/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.1.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/operator/finally';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined) : Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }
}

@Injectable()
export class AppointmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getForm(body: GetMedicalAppointmentPreProcedureFormRequest | undefined) : Observable<GetMedicalAppointmentPreProcedureFormResponse> {
        let url_ = this.baseUrl + "/api/services/app/health/Appointment/GetForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForm(<any>response_);
                } catch (e) {
                    return <Observable<GetMedicalAppointmentPreProcedureFormResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMedicalAppointmentPreProcedureFormResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetForm(response: HttpResponseBase): Observable<GetMedicalAppointmentPreProcedureFormResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicalAppointmentPreProcedureFormResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMedicalAppointmentPreProcedureFormResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    collect(body: CollectMedicalAppointmentPreProcedureFormRequest | undefined) : Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/health/Appointment/Collect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollect(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCollect(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAnswer(body: GetMedicalAppointmentPreProcedureFormAnswerRequest | undefined) : Observable<GetMedicalAppointmentPreProcedureFormAnswerResponse> {
        let url_ = this.baseUrl + "/api/services/app/health/Appointment/GetAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnswer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnswer(<any>response_);
                } catch (e) {
                    return <Observable<GetMedicalAppointmentPreProcedureFormAnswerResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMedicalAppointmentPreProcedureFormAnswerResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnswer(response: HttpResponseBase): Observable<GetMedicalAppointmentPreProcedureFormAnswerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicalAppointmentPreProcedureFormAnswerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMedicalAppointmentPreProcedureFormAnswerResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getPaymentOptions() : Observable<GetPaymentOptionsResult> {
        let url_ = this.baseUrl + "/api/services/app/health/Appointment/GetPaymentOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentOptions(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentOptionsResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentOptionsResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentOptions(response: HttpResponseBase): Observable<GetPaymentOptionsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentOptionsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentOptionsResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAsPayed(body: MarkMedicalAppointmentAsPayedRequest | undefined) : Observable<MedicalAppointmentDetails> {
        let url_ = this.baseUrl + "/api/services/app/health/Appointment/MarkAsPayed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsPayed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsPayed(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDetails>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsPayed(response: HttpResponseBase): Observable<MedicalAppointmentDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDetails>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePrice(body: UpdateMedicalAppointmentPrice | undefined) : Observable<MedicalAppointmentDetails> {
        let url_ = this.baseUrl + "/api/services/app/health/Appointment/UpdatePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrice(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDetails>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePrice(response: HttpResponseBase): Observable<MedicalAppointmentDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDetails>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    collectStats(body: ProcessDailyStatsRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/health/Appointment/CollectStats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollectStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollectStats(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCollectStats(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    isPaymentCompleted(id: string | undefined) : Observable<IsPaymentCompletedQueryResult> {
        let url_ = this.baseUrl + "/api/services/app/health/Appointment/IsPaymentCompleted?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPaymentCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPaymentCompleted(<any>response_);
                } catch (e) {
                    return <Observable<IsPaymentCompletedQueryResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsPaymentCompletedQueryResult>><any>_observableThrow(response_);
        }));
    }

    protected processIsPaymentCompleted(response: HttpResponseBase): Observable<IsPaymentCompletedQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsPaymentCompletedQueryResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsPaymentCompletedQueryResult>(<any>null);
    }

    /**
     * @param appointmentId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadAppointmentFile(appointmentId: string | undefined, file: FileParameter | null | undefined) : Observable<UploadFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/health/Appointment/UploadAppointmentFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (appointmentId === null || appointmentId === undefined)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else
            content_.append("AppointmentId", appointmentId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAppointmentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAppointmentFile(<any>response_);
                } catch (e) {
                    return <Observable<UploadFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUploadAppointmentFile(response: HttpResponseBase): Observable<UploadFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadFileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadFileResponse>(<any>null);
    }
}

@Injectable()
export class BirdIdServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    configuration() : Observable<GetBirdIdConfigurationResponse> {
        let url_ = this.baseUrl + "/api/services/app/BirdId/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<GetBirdIdConfigurationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBirdIdConfigurationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processConfiguration(response: HttpResponseBase): Observable<GetBirdIdConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBirdIdConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBirdIdConfigurationResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    connect(body: ConnectBirdIdRequest | undefined) : Observable<BirdIdCertificate[]> {
        let url_ = this.baseUrl + "/api/services/app/BirdId/Connect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnect(<any>response_);
                } catch (e) {
                    return <Observable<BirdIdCertificate[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BirdIdCertificate[]>><any>_observableThrow(response_);
        }));
    }

    protected processConnect(response: HttpResponseBase): Observable<BirdIdCertificate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BirdIdCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BirdIdCertificate[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reconnect(body: ConnectBirdIdRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BirdId/Reconnect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReconnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReconnect(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReconnect(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    certificates() : Observable<BirdIdCertificate[]> {
        let url_ = this.baseUrl + "/api/services/app/BirdId/Certificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCertificates(<any>response_);
                } catch (e) {
                    return <Observable<BirdIdCertificate[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BirdIdCertificate[]>><any>_observableThrow(response_);
        }));
    }

    protected processCertificates(response: HttpResponseBase): Observable<BirdIdCertificate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BirdIdCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BirdIdCertificate[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    selectCertificate(body: SelectBirdIdCertificateRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BirdId/SelectCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSelectCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    disconnect() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BirdId/Disconnect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnect(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisconnect(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    sign(file: FileParameter | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BirdId/Sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSign(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class BuyerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getBuyerInfo() : Observable<GetBuyerInfoResponse> {
        let url_ = this.baseUrl + "/api/services/app/BuyerService/GetBuyerInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuyerInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuyerInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetBuyerInfoResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBuyerInfoResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetBuyerInfo(response: HttpResponseBase): Observable<GetBuyerInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBuyerInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBuyerInfoResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBuyerIfNotExists(body: CreateBuyerIfNotExistsRequest | undefined) : Observable<BuyerDto> {
        let url_ = this.baseUrl + "/api/services/app/BuyerService/CreateBuyerIfNotExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBuyerIfNotExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBuyerIfNotExists(<any>response_);
                } catch (e) {
                    return <Observable<BuyerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BuyerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateBuyerIfNotExists(response: HttpResponseBase): Observable<BuyerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BuyerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BuyerDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isAbleToMakePayment(body: IsAbleToMakePaymentRequest | undefined) : Observable<IsAbleToMakePaymentResponse> {
        let url_ = this.baseUrl + "/api/services/app/BuyerService/IsAbleToMakePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAbleToMakePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAbleToMakePayment(<any>response_);
                } catch (e) {
                    return <Observable<IsAbleToMakePaymentResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsAbleToMakePaymentResponse>><any>_observableThrow(response_);
        }));
    }

    protected processIsAbleToMakePayment(response: HttpResponseBase): Observable<IsAbleToMakePaymentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsAbleToMakePaymentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsAbleToMakePaymentResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCard(body: AddCardRequest | undefined) : Observable<BuyerDto> {
        let url_ = this.baseUrl + "/api/services/app/BuyerService/AddCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCard(<any>response_);
                } catch (e) {
                    return <Observable<BuyerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BuyerDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddCard(response: HttpResponseBase): Observable<BuyerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BuyerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BuyerDto>(<any>null);
    }
}

@Injectable()
export class CertificateServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param password (optional) 
     * @param file (optional) 
     * @return Success
     */
    upload(password: string | null | undefined, file: FileParameter | null | undefined) : Observable<CertificateInfo> {
        let url_ = this.baseUrl + "/api/services/app/CertificateService/Upload?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<CertificateInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateInfo>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<CertificateInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificateInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateInfo>(<any>null);
    }

    /**
     * @return Success
     */
    getInfo() : Observable<CertificateInfo> {
        let url_ = this.baseUrl + "/api/services/app/CertificateService/GetInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(<any>response_);
                } catch (e) {
                    return <Observable<CertificateInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<CertificateInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificateInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateInfo>(<any>null);
    }

    /**
     * @return Success
     */
    delete() : Observable<CertificateInfo> {
        let url_ = this.baseUrl + "/api/services/app/CertificateService/Delete";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<CertificateInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateInfo>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CertificateInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificateInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateInfo>(<any>null);
    }
}

@Injectable()
export class ChildGrowthCurveConfigurationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    configuration() : Observable<ChildGrowthCurveConfiguration> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthCurveConfigurationService/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<ChildGrowthCurveConfiguration>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChildGrowthCurveConfiguration>><any>_observableThrow(response_);
        }));
    }

    protected processConfiguration(response: HttpResponseBase): Observable<ChildGrowthCurveConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildGrowthCurveConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChildGrowthCurveConfiguration>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ChildGrowthCurveConfiguration | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthCurveConfigurationService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class ChildGrowthServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateChildGrowthRequest | undefined) : Observable<ChildGrowthEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ChildGrowthEntryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChildGrowthEntryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ChildGrowthEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildGrowthEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChildGrowthEntryDto>(<any>null);
    }

    /**
     * @param patient (optional) 
     * @return Success
     */
    get(patient: string | undefined) : Observable<ChildGrowthChartSeries> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthService/Get?";
        if (patient === null)
            throw new Error("The parameter 'patient' cannot be null.");
        else if (patient !== undefined)
            url_ += "patient=" + encodeURIComponent("" + patient) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ChildGrowthChartSeries>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChildGrowthChartSeries>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ChildGrowthChartSeries> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildGrowthChartSeries.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChildGrowthChartSeries>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateChildGrowthRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getWeightChartData(patientId: string | undefined) : Observable<ChartDto> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthService/GetWeightChartData?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeightChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeightChartData(<any>response_);
                } catch (e) {
                    return <Observable<ChartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChartDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWeightChartData(response: HttpResponseBase): Observable<ChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChartDto>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getHeightChartData(patientId: string | undefined) : Observable<ChartDto> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthService/GetHeightChartData?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeightChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeightChartData(<any>response_);
                } catch (e) {
                    return <Observable<ChartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChartDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHeightChartData(response: HttpResponseBase): Observable<ChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChartDto>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getHeadCircumferenceChartData(patientId: string | undefined) : Observable<ChartDto> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthService/GetHeadCircumferenceChartData?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeadCircumferenceChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeadCircumferenceChartData(<any>response_);
                } catch (e) {
                    return <Observable<ChartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChartDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHeadCircumferenceChartData(response: HttpResponseBase): Observable<ChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChartDto>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getImcChartData(patientId: string | undefined) : Observable<ChartDto> {
        let url_ = this.baseUrl + "/api/services/app/ChildGrowthService/GetImcChartData?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImcChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImcChartData(<any>response_);
                } catch (e) {
                    return <Observable<ChartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChartDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetImcChartData(response: HttpResponseBase): Observable<ChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChartDto>(<any>null);
    }
}

@Injectable()
export class ConfigServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getConfig() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/Config/GetConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getSiteConfig() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/Config/GetSiteConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiteConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiteConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetSiteConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getSite() : Observable<SiteDefinition> {
        let url_ = this.baseUrl + "/api/services/Config/GetSite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSite(<any>response_);
                } catch (e) {
                    return <Observable<SiteDefinition>><any>_observableThrow(e);
                }
            } else
                return <Observable<SiteDefinition>><any>_observableThrow(response_);
        }));
    }

    protected processGetSite(response: HttpResponseBase): Observable<SiteDefinition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteDefinition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SiteDefinition>(<any>null);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLeftMenuVisibility(body: ChangeLeftMenuVisibilityInput | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeLeftMenuVisibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLeftMenuVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLeftMenuVisibility(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLeftMenuVisibility(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param project (optional) 
     * @param lastModificationTime (optional) 
     * @return Success
     */
    getContent(project: string | undefined, lastModificationTime: moment.Moment | undefined) : Observable<Contact> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetContent?";
        if (project === null)
            throw new Error("The parameter 'project' cannot be null.");
        else if (project !== undefined)
            url_ += "Project=" + encodeURIComponent("" + project) + "&";
        if (lastModificationTime === null)
            throw new Error("The parameter 'lastModificationTime' cannot be null.");
        else if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContent(<any>response_);
                } catch (e) {
                    return <Observable<Contact>><any>_observableThrow(e);
                }
            } else
                return <Observable<Contact>><any>_observableThrow(response_);
        }));
    }

    protected processGetContent(response: HttpResponseBase): Observable<Contact> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Contact.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Contact>(<any>null);
    }

    /**
     * @param project (optional) 
     * @param lastModificationTime (optional) 
     * @return Success
     */
    getUnits(project: string | undefined, lastModificationTime: moment.Moment | undefined) : Observable<Contact[]> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetUnits?";
        if (project === null)
            throw new Error("The parameter 'project' cannot be null.");
        else if (project !== undefined)
            url_ += "Project=" + encodeURIComponent("" + project) + "&";
        if (lastModificationTime === null)
            throw new Error("The parameter 'lastModificationTime' cannot be null.");
        else if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnits(<any>response_);
                } catch (e) {
                    return <Observable<Contact[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Contact[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnits(response: HttpResponseBase): Observable<Contact[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Contact.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Contact[]>(<any>null);
    }
}

@Injectable()
export class DigitalSignatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    activeEngineName() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignature/ActiveEngineName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveEngineName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveEngineName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processActiveEngineName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class DoctorServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    convertDoctorSpecialty() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/ConvertDoctorSpecialty";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertDoctorSpecialty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertDoctorSpecialty(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processConvertDoctorSpecialty(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSpecialties(id: string | null | undefined) : Observable<DoctorSpecialty[]> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/GetSpecialties?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialties(<any>response_);
                } catch (e) {
                    return <Observable<DoctorSpecialty[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorSpecialty[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpecialties(response: HttpResponseBase): Observable<DoctorSpecialty[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DoctorSpecialty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorSpecialty[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPreferredSpecialties(id: string | null | undefined) : Observable<DoctorSpecialty[]> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/GetPreferredSpecialties?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreferredSpecialties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreferredSpecialties(<any>response_);
                } catch (e) {
                    return <Observable<DoctorSpecialty[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorSpecialty[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPreferredSpecialties(response: HttpResponseBase): Observable<DoctorSpecialty[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DoctorSpecialty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorSpecialty[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: DoctorDto | undefined) : Observable<DoctorDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DoctorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DoctorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterDoctorDto | undefined) : Observable<DoctorDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<DoctorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorDto>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<DoctorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDoctorDto | undefined) : Observable<DoctorDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DoctorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DoctorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getByUser(id: number | null | undefined) : Observable<DoctorDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/GetByUser?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUser(<any>response_);
                } catch (e) {
                    return <Observable<DoctorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByUser(response: HttpResponseBase): Observable<DoctorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorDto>(<any>null);
    }

    /**
     * @param specialty (optional) 
     * @return Success
     */
    getBySpecialty(specialty: number | undefined) : Observable<DoctorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/GetBySpecialty?";
        if (specialty === null)
            throw new Error("The parameter 'specialty' cannot be null.");
        else if (specialty !== undefined)
            url_ += "specialty=" + encodeURIComponent("" + specialty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySpecialty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySpecialty(<any>response_);
                } catch (e) {
                    return <Observable<DoctorDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBySpecialty(response: HttpResponseBase): Observable<DoctorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DoctorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorDto[]>(<any>null);
    }

    /**
     * Just for DTO proxy generation
     * @return Success
     */
    getDoctorInvitationCompletionModel() : Observable<DoctorInvitationCompletionModel> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/GetDoctorInvitationCompletionModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorInvitationCompletionModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorInvitationCompletionModel(<any>response_);
                } catch (e) {
                    return <Observable<DoctorInvitationCompletionModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorInvitationCompletionModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetDoctorInvitationCompletionModel(response: HttpResponseBase): Observable<DoctorInvitationCompletionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorInvitationCompletionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorInvitationCompletionModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeRegistrationByInvitation(body: DoctorInvitationCompletionModel | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/CompleteRegistrationByInvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteRegistrationByInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteRegistrationByInvitation(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteRegistrationByInvitation(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<DoctorDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DoctorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DoctorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<DoctorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorService/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DoctorDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DoctorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class DocumentsServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @param logo (optional) 
     * @return Success
     */
    uploadLogo(tenantId: number | undefined, logo: FileParameter | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/DocumentsService/UploadLogo?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logo !== null && logo !== undefined)
            content_.append("logo", logo.data, logo.fileName ? logo.fileName : "logo");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    removeLogo(tenantId: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/DocumentsService/RemoveLogo?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLogo(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveLogo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    verifyContent(file: FileParameter | null | undefined) : Observable<DocumentVerificationResult> {
        let url_ = this.baseUrl + "/api/services/app/DocumentsService/VerifyContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyContent(<any>response_);
                } catch (e) {
                    return <Observable<DocumentVerificationResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentVerificationResult>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyContent(response: HttpResponseBase): Observable<DocumentVerificationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentVerificationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentVerificationResult>(<any>null);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    verify(fileId: string | null | undefined) : Observable<DocumentVerificationResult> {
        let url_ = this.baseUrl + "/api/services/app/DocumentsService/Verify?";
        if (fileId !== undefined && fileId !== null)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerify(<any>response_);
                } catch (e) {
                    return <Observable<DocumentVerificationResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentVerificationResult>><any>_observableThrow(response_);
        }));
    }

    protected processVerify(response: HttpResponseBase): Observable<DocumentVerificationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentVerificationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentVerificationResult>(<any>null);
    }

    /**
     * @param type (optional) 
     * @param id (optional) 
     * @param _format (optional) 
     * @param _secretCode (optional) 
     * @return Success
     */
    getDownloadUrl(type: string | null | undefined, id: string | null | undefined, _format: string | null | undefined, _secretCode: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentsService/GetDownloadUrl?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (_format !== undefined && _format !== null)
            url_ += "_format=" + encodeURIComponent("" + _format) + "&";
        if (_secretCode !== undefined && _secretCode !== null)
            url_ += "_secretCode=" + encodeURIComponent("" + _secretCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadUrl(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetDownloadUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    download(code: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentsService/Download?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param name (optional) 
     * @return Success
     */
    export(id: string | undefined, name: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentsService/Export?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    downloadFile(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentsService/DownloadFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    exportPrintableVersion(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentsService/ExportPrintableVersion?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPrintableVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPrintableVersion(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportPrintableVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DocumentTemplateCategoryServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentTemplateCategoryInput | undefined) : Observable<DocumentTemplateCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateCategoryService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentTemplateCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateCategoryDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDocumentTemplateCategoryInput | undefined) : Observable<DocumentTemplateCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateCategoryService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentTemplateCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateCategoryDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<DocumentTemplateCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateCategoryService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentTemplateCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateCategoryDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateCategoryService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllWithoutPaging() : Observable<DocumentTemplateCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateCategoryService/GetAllWithoutPaging";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithoutPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithoutPaging(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateCategoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateCategoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWithoutPaging(response: HttpResponseBase): Observable<DocumentTemplateCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DocumentTemplateCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateCategoryDto[]>(<any>null);
    }

    /**
     * @param name (optional) 
     * @param templateName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, templateName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<DocumentTemplateCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateCategoryService/GetAll?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (templateName !== undefined && templateName !== null)
            url_ += "TemplateName=" + encodeURIComponent("" + templateName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateCategoryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateCategoryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentTemplateCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateCategoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateCategoryDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class DocumentTemplateServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentTemplateRequest | undefined) : Observable<DocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDocumentTemplateRequest | undefined) : Observable<DocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<DocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBasicData() : Observable<DocumentTemplateBasicData[]> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateService/GetAllBasicData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBasicData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBasicData(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateBasicData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateBasicData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBasicData(response: HttpResponseBase): Observable<DocumentTemplateBasicData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DocumentTemplateBasicData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateBasicData[]>(<any>null);
    }

    /**
     * @param name (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<DocumentTemplateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateService/GetAll?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTemplateDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTemplateDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentTemplateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTemplateDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentTemplateService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EditionServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getTenantFeatures(tenantId: number | undefined) : Observable<TenantFeatureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EditionService/GetTenantFeatures?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeatures(<any>response_);
                } catch (e) {
                    return <Observable<TenantFeatureDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantFeatureDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantFeatures(response: HttpResponseBase): Observable<TenantFeatureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantFeatureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantFeatureDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleTenantFeatures(body: ToggleTenantFeaturesRequest | undefined) : Observable<TenantFeatureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EditionService/ToggleTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleTenantFeatures(<any>response_);
                } catch (e) {
                    return <Observable<TenantFeatureDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantFeatureDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processToggleTenantFeatures(response: HttpResponseBase): Observable<TenantFeatureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantFeatureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantFeatureDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getEditions() : Observable<EditionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EditionService/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(<any>response_);
                } catch (e) {
                    return <Observable<EditionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<EditionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionDto[]>(<any>null);
    }
}

@Injectable()
export class EmailAppointmentNotificationNotifierServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    execute(body: AppointmentNotificationData | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailAppointmentNotificationNotifier/Execute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecute(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExecute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EmailTemplateServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param settingPrefix (optional) 
     * @param tenantId (optional) 
     * @param user (optional) 
     * @return Success
     */
    getEmailTemplate(settingPrefix: string | null | undefined, tenantId: number | null | undefined, user: number | null | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplateService/GetEmailTemplate?";
        if (settingPrefix !== undefined && settingPrefix !== null)
            url_ += "settingPrefix=" + encodeURIComponent("" + settingPrefix) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param settingPrefix (optional) 
     * @return Success
     */
    getLocalEmailTemplate(settingPrefix: string | null | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplateService/GetLocalEmailTemplate?";
        if (settingPrefix !== undefined && settingPrefix !== null)
            url_ += "settingPrefix=" + encodeURIComponent("" + settingPrefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalEmailTemplate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocalEmailTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class ExaminationModelServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllGet() : Observable<ExaminationModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationModelService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGet(<any>response_);
                } catch (e) {
                    return <Observable<ExaminationModelDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExaminationModelDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGet(response: HttpResponseBase): Observable<ExaminationModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExaminationModelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExaminationModelDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllPost(body: GetExaminationModelsQuery | undefined) : Observable<ExaminationModelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationModelService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPost(<any>response_);
                } catch (e) {
                    return <Observable<ExaminationModelDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExaminationModelDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPost(response: HttpResponseBase): Observable<ExaminationModelDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExaminationModelDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExaminationModelDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<ExaminationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationModelService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ExaminationModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExaminationModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ExaminationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExaminationModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExaminationModelDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateExaminationModelRequest | undefined) : Observable<ExaminationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationModelService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ExaminationModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExaminationModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ExaminationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExaminationModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExaminationModelDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateExaminationModelRequest | undefined) : Observable<ExaminationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationModelService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ExaminationModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExaminationModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ExaminationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExaminationModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExaminationModelDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationModelService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ExaminationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    download(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationService/Download?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param examId (optional) 
     * @return Success
     */
    sendExamByEmail(examId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationService/SendExamByEmail?";
        if (examId === null)
            throw new Error("The parameter 'examId' cannot be null.");
        else if (examId !== undefined)
            url_ += "examId=" + encodeURIComponent("" + examId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendExamByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendExamByEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendExamByEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getExaminations(patientId: string | undefined) : Observable<ExaminationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationService/GetExaminations?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExaminations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExaminations(<any>response_);
                } catch (e) {
                    return <Observable<ExaminationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExaminationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExaminations(response: HttpResponseBase): Observable<ExaminationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExaminationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExaminationDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateExaminationDto | undefined) : Observable<ExaminationDto> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ExaminationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExaminationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ExaminationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExaminationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExaminationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateExaminationRequest | undefined) : Observable<ExaminationDto> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ExaminationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExaminationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ExaminationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExaminationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExaminationDto>(<any>null);
    }

    /**
     * @return Success
     */
    isReadyToRequestExams() : Observable<IsReadyToRequestExamsDto> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationService/IsReadyToRequestExams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsReadyToRequestExams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsReadyToRequestExams(<any>response_);
                } catch (e) {
                    return <Observable<IsReadyToRequestExamsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsReadyToRequestExamsDto>><any>_observableThrow(response_);
        }));
    }

    protected processIsReadyToRequestExams(response: HttpResponseBase): Observable<IsReadyToRequestExamsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsReadyToRequestExamsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsReadyToRequestExamsDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExaminationService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FeatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param mobileProjectId (optional) 
     * @param featureName (optional) 
     * @param lastModificationTime (optional) 
     * @return Success
     */
    getFeature(mobileProjectId: string | undefined, featureName: string | null | undefined, lastModificationTime: moment.Moment | undefined) : Observable<FeatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Feature/GetFeature?";
        if (mobileProjectId === null)
            throw new Error("The parameter 'mobileProjectId' cannot be null.");
        else if (mobileProjectId !== undefined)
            url_ += "MobileProjectId=" + encodeURIComponent("" + mobileProjectId) + "&";
        if (featureName !== undefined && featureName !== null)
            url_ += "FeatureName=" + encodeURIComponent("" + featureName) + "&";
        if (lastModificationTime === null)
            throw new Error("The parameter 'lastModificationTime' cannot be null.");
        else if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeature(<any>response_);
                } catch (e) {
                    return <Observable<FeatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFeature(response: HttpResponseBase): Observable<FeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureDto>(<any>null);
    }

    /**
     * @param lastModificationTime (optional) 
     * @return Success
     */
    getFeatures(lastModificationTime: moment.Moment | undefined) : Observable<FeatureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Feature/GetFeatures?";
        if (lastModificationTime === null)
            throw new Error("The parameter 'lastModificationTime' cannot be null.");
        else if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatures(<any>response_);
                } catch (e) {
                    return <Observable<FeatureDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeatureDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFeatures(response: HttpResponseBase): Observable<FeatureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FeatureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FeatureDto | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Feature/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FileDraftServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) When id is an <b>empty Guid</b>, it will perform a create operation, otherwise update.
     * @return Success
     */
    upsert(body: FileItemDraft | undefined) : Observable<FileItemDraft> {
        let url_ = this.baseUrl + "/api/services/app/FileDraftService/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<FileItemDraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileItemDraft>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<FileItemDraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileItemDraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileItemDraft>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    get(patientId: string | undefined) : Observable<FileItemDraft> {
        let url_ = this.baseUrl + "/api/services/app/FileDraftService/Get?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FileItemDraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileItemDraft>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileItemDraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileItemDraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileItemDraft>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    remove(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileDraftService/Remove?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FileManagerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gerar novo documento
     * @param body (optional) 
     * @return Success
     */
    createFile(body: CreateFileRequest | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FileManagerService/CreateFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFile(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFile(body: UpdateFileRequest | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FileManagerService/UpdateFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFile(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rename(body: RenameFileRequest | undefined) : Observable<RenameFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/FileManagerService/Rename";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRename(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRename(<any>response_);
                } catch (e) {
                    return <Observable<RenameFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RenameFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRename(response: HttpResponseBase): Observable<RenameFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RenameFileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RenameFileResponse>(<any>null);
    }
}

@Injectable()
export class FilesServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param parent (optional) 
     * @param ownerUser (optional) 
     * @param ownerPatient (optional) 
     * @param files (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadMultiple(parent: string | undefined, ownerUser: number | null | undefined, ownerPatient: string | undefined, files: FileParameter[] | null | undefined, file: FileParameter | null | undefined) : Observable<UploadMultipleResponse> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/UploadMultiple?";
        if (parent === null)
            throw new Error("The parameter 'parent' cannot be null.");
        else if (parent !== undefined)
            url_ += "parent=" + encodeURIComponent("" + parent) + "&";
        if (ownerUser !== undefined && ownerUser !== null)
            url_ += "ownerUser=" + encodeURIComponent("" + ownerUser) + "&";
        if (ownerPatient === null)
            throw new Error("The parameter 'ownerPatient' cannot be null.");
        else if (ownerPatient !== undefined)
            url_ += "ownerPatient=" + encodeURIComponent("" + ownerPatient) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMultiple(<any>response_);
                } catch (e) {
                    return <Observable<UploadMultipleResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadMultipleResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUploadMultiple(response: HttpResponseBase): Observable<UploadMultipleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadMultipleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadMultipleResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveAndSignDocuments(body: MoveAndSignDocumentsRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/MoveAndSignDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveAndSignDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveAndSignDocuments(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processMoveAndSignDocuments(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    streamUpload() : Observable<UploadMultipleResponse> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/StreamUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStreamUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStreamUpload(<any>response_);
                } catch (e) {
                    return <Observable<UploadMultipleResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadMultipleResponse>><any>_observableThrow(response_);
        }));
    }

    protected processStreamUpload(response: HttpResponseBase): Observable<UploadMultipleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadMultipleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadMultipleResponse>(<any>null);
    }

    /**
     * Upload de arquivo
     * @param parent (optional) Id da pasta onde o arquivo será armazenado. Utilize "00000000-0000-0000-0000-000000000000" para salvar na pasta raíz do paciente
     * @param ownerUser (optional) 
     * @param ownerPatient (optional) Id do paciente que receberá o arquivo
     * @param fileName (optional) Nome do arquivo com formato, ex.: Laudo.pdf
     * @param file (optional) 
     * @return Success
     */
    upload(parent: string | undefined, ownerUser: number | null | undefined, ownerPatient: string | undefined, fileName: string | null | undefined, file: FileParameter | null | undefined) : Observable<FileSystemItem> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/Upload?";
        if (parent === null)
            throw new Error("The parameter 'parent' cannot be null.");
        else if (parent !== undefined)
            url_ += "parent=" + encodeURIComponent("" + parent) + "&";
        if (ownerUser !== undefined && ownerUser !== null)
            url_ += "ownerUser=" + encodeURIComponent("" + ownerUser) + "&";
        if (ownerPatient === null)
            throw new Error("The parameter 'ownerPatient' cannot be null.");
        else if (ownerPatient !== undefined)
            url_ += "ownerPatient=" + encodeURIComponent("" + ownerPatient) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<FileSystemItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileSystemItem>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<FileSystemItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileSystemItem>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    download(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/Download?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param files (optional) 
     * @return Success
     */
    sendFilesByEmail(files: string[] | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/SendFilesByEmail?";
        if (files !== undefined && files !== null)
            files && files.forEach(item => { url_ += "files=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFilesByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFilesByEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendFilesByEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param hash (optional) 
     * @return Success
     */
    downloadSharedFile(hash: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/DownloadSharedFile?";
        if (hash !== undefined && hash !== null)
            url_ += "hash=" + encodeURIComponent("" + hash) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSharedFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSharedFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadSharedFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    renderHtml(path: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/RenderHtml?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenderHtml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenderHtml(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRenderHtml(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFolder(id: string | undefined) : Observable<FileSystemFolder> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/GetFolder?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolder(<any>response_);
                } catch (e) {
                    return <Observable<FileSystemFolder>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileSystemFolder>><any>_observableThrow(response_);
        }));
    }

    protected processGetFolder(response: HttpResponseBase): Observable<FileSystemFolder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemFolder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileSystemFolder>(<any>null);
    }

    /**
     * Listar arquivos do paciente
     * @param body (optional) 
     * @return Success
     */
    listFolder(body: GetFolderRequest | undefined) : Observable<FileSystemFolder> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/ListFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListFolder(<any>response_);
                } catch (e) {
                    return <Observable<FileSystemFolder>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileSystemFolder>><any>_observableThrow(response_);
        }));
    }

    protected processListFolder(response: HttpResponseBase): Observable<FileSystemFolder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemFolder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileSystemFolder>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFolder(body: CreateFolder | undefined) : Observable<FileSystemFolder> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/CreateFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFolder(<any>response_);
                } catch (e) {
                    return <Observable<FileSystemFolder>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileSystemFolder>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFolder(response: HttpResponseBase): Observable<FileSystemFolder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemFolder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileSystemFolder>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFile(id: string | undefined) : Observable<FileSystemFile> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/GetFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(<any>response_);
                } catch (e) {
                    return <Observable<FileSystemFile>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileSystemFile>><any>_observableThrow(response_);
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileSystemFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileSystemFile>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveFile(body: MoveFile | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/MoveFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMoveFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param parent (optional) 
     * @param patient (optional) 
     * @param tenantId (optional) 
     * @param projectId (optional) 
     * @return Success
     */
    getFolderPath(parent: string | undefined, patient: string | undefined, tenantId: number | undefined, projectId: string | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/GetFolderPath?";
        if (parent === null)
            throw new Error("The parameter 'parent' cannot be null.");
        else if (parent !== undefined)
            url_ += "parent=" + encodeURIComponent("" + parent) + "&";
        if (patient === null)
            throw new Error("The parameter 'patient' cannot be null.");
        else if (patient !== undefined)
            url_ += "patient=" + encodeURIComponent("" + patient) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFolderPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolderPath(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetFolderPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rename(body: RenameFileSystemItemRequest | undefined) : Observable<FileSystemFolder> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/Rename";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRename(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRename(<any>response_);
                } catch (e) {
                    return <Observable<FileSystemFolder>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileSystemFolder>><any>_observableThrow(response_);
        }));
    }

    protected processRename(response: HttpResponseBase): Observable<FileSystemFolder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemFolder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileSystemFolder>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateParentModificationTime(body: FileItem | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/UpdateParentModificationTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParentModificationTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParentModificationTime(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateParentModificationTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDownloadLink(id: string | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/GetDownloadLink?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadLink(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetDownloadLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    exists(id: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/Exists?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<FileSystemFolder> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<FileSystemFolder>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileSystemFolder>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileSystemFolder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemFolder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileSystemFolder>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    restore(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/Restore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestore(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRestore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param patient (optional) 
     * @return Success
     */
    getPinnedFolders(patient: string | undefined) : Observable<PinnedFolderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/GetPinnedFolders?";
        if (patient === null)
            throw new Error("The parameter 'patient' cannot be null.");
        else if (patient !== undefined)
            url_ += "Patient=" + encodeURIComponent("" + patient) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPinnedFolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPinnedFolders(<any>response_);
                } catch (e) {
                    return <Observable<PinnedFolderDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PinnedFolderDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPinnedFolders(response: HttpResponseBase): Observable<PinnedFolderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PinnedFolderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PinnedFolderDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removePinnedFolder(body: RemovePinnedFolderInput | undefined) : Observable<PinnedFolderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/RemovePinnedFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePinnedFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePinnedFolder(<any>response_);
                } catch (e) {
                    return <Observable<PinnedFolderDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PinnedFolderDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processRemovePinnedFolder(response: HttpResponseBase): Observable<PinnedFolderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PinnedFolderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PinnedFolderDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renamePinnedFolder(body: RenamePinnedFolderInput | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FilesService/RenamePinnedFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenamePinnedFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenamePinnedFolder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRenamePinnedFolder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FolderTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    list() : Observable<FolderTemplateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FolderTemplate/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(<any>response_);
                } catch (e) {
                    return <Observable<FolderTemplateDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FolderTemplateDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processList(response: HttpResponseBase): Observable<FolderTemplateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FolderTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FolderTemplateDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFolderTemplateRequest | undefined) : Observable<FolderTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/FolderTemplate/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FolderTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FolderTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FolderTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FolderTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FolderTemplateDto>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FolderTemplate/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(id: number, body: UpdateFolderTemplateRequest | undefined) : Observable<FolderTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/FolderTemplate/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FolderTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FolderTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FolderTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FolderTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FolderTemplateDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    order(body: number[] | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FolderTemplate/order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GoogleCalendarAppointmentSourceServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    disableIntegration(tenantId: number | undefined, userId: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarAppointmentSourceService/DisableIntegration?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableIntegration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableIntegration(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableIntegration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GoogleCalendarConnectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    connect() : Observable<GoogleCalendarConnectResult> {
        let url_ = this.baseUrl + "/api/services/GoogleCalendarConnect/Connect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnect(<any>response_);
                } catch (e) {
                    return <Observable<GoogleCalendarConnectResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoogleCalendarConnectResult>><any>_observableThrow(response_);
        }));
    }

    protected processConnect(response: HttpResponseBase): Observable<GoogleCalendarConnectResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoogleCalendarConnectResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoogleCalendarConnectResult>(<any>null);
    }

    /**
     * @return Success
     */
    callback() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/GoogleCalendarConnect/Callback";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallback(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    notifications() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/GoogleCalendarConnect/Notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifications(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GoogleCalendarServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAuthorizeUrl() : Observable<GoogleCalendarConnectResult> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarService/GetAuthorizeUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizeUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizeUrl(<any>response_);
                } catch (e) {
                    return <Observable<GoogleCalendarConnectResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoogleCalendarConnectResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuthorizeUrl(response: HttpResponseBase): Observable<GoogleCalendarConnectResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoogleCalendarConnectResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoogleCalendarConnectResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    complete(body: CompleteGoogleCalendarIntegrationInput | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarService/Complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComplete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processComplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getConfig() : Observable<GoogleCalendarConfigResult> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarService/GetConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(<any>response_);
                } catch (e) {
                    return <Observable<GoogleCalendarConfigResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoogleCalendarConfigResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<GoogleCalendarConfigResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoogleCalendarConfigResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoogleCalendarConfigResult>(<any>null);
    }

    /**
     * @param code (optional) 
     * @param scope (optional) 
     * @param state (optional) 
     * @return Success
     */
    processAuthData(code: string | null | undefined, scope: string | null | undefined, state: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarService/ProcessAuthData?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (scope !== undefined && scope !== null)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessAuthData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessAuthData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProcessAuthData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    disable() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarService/Disable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCalendars() : Observable<GoogleCalendarEntry[]> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarService/GetCalendars";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendars(<any>response_);
                } catch (e) {
                    return <Observable<GoogleCalendarEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GoogleCalendarEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendars(response: HttpResponseBase): Observable<GoogleCalendarEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GoogleCalendarEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoogleCalendarEntry[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processNotification(body: GoogleNotificationData | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarService/ProcessNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProcessNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getEventPreviewSettings() : Observable<EventPreviewType> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarService/GetEventPreviewSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventPreviewSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventPreviewSettings(<any>response_);
                } catch (e) {
                    return <Observable<EventPreviewType>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventPreviewType>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventPreviewSettings(response: HttpResponseBase): Observable<EventPreviewType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventPreviewType>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEventPreviewSettings(body: EventPreviewType | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GoogleCalendarService/UpdateEventPreviewSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEventPreviewSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEventPreviewSettings(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateEventPreviewSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class HealthCareUnitServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Listar unidades de atendimento
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetHealthCareUnitsInput | undefined) : Observable<HealthCareUnitDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthCareUnitService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<HealthCareUnitDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthCareUnitDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HealthCareUnitDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCareUnitDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthCareUnitDtoPagedResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBasicData() : Observable<HealthCareUnitBasicData[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthCareUnitService/GetBasicData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicData(<any>response_);
                } catch (e) {
                    return <Observable<HealthCareUnitBasicData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthCareUnitBasicData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBasicData(response: HttpResponseBase): Observable<HealthCareUnitBasicData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HealthCareUnitBasicData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthCareUnitBasicData[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHealthCareUnitInput | undefined) : Observable<HealthCareUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthCareUnitService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<HealthCareUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthCareUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HealthCareUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCareUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthCareUnitDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHealthCareUnitInput | undefined) : Observable<HealthCareUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthCareUnitService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<HealthCareUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthCareUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HealthCareUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCareUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthCareUnitDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthCareUnitService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<HealthCareUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthCareUnitService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<HealthCareUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthCareUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HealthCareUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCareUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthCareUnitDto>(<any>null);
    }
}

@Injectable()
export class HealthProfessionalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    restoreHealthProfessional(userId: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessional/RestoreHealthProfessional?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreHealthProfessional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreHealthProfessional(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRestoreHealthProfessional(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class HealthProfessionalMedicalProcedureServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param professionalId (optional) 
     * @return Success
     */
    getCurrentProcedures(professionalId: string | null | undefined) : Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalMedicalProcedureService/GetCurrentProcedures?";
        if (professionalId !== undefined && professionalId !== null)
            url_ += "professionalId=" + encodeURIComponent("" + professionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentProcedures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentProcedures(<any>response_);
                } catch (e) {
                    return <Observable<number[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<number[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentProcedures(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetHealthProfessionalMedicalProceduresInput | undefined) : Observable<HealthProfessionalMedicalProcedureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalMedicalProcedureService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalMedicalProcedureDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalMedicalProcedureDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HealthProfessionalMedicalProcedureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalMedicalProcedureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalMedicalProcedureDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<HealthProfessionalMedicalProcedureDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalMedicalProcedureService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalMedicalProcedureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalMedicalProcedureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HealthProfessionalMedicalProcedureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalMedicalProcedureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalMedicalProcedureDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insuranceOptions(body: HealthProfessionalInsuranceOptionsInput | undefined) : Observable<HealthProfessionalMedicalProcedureInsuranceOptions> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalMedicalProcedureService/InsuranceOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsuranceOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsuranceOptions(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalMedicalProcedureInsuranceOptions>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalMedicalProcedureInsuranceOptions>><any>_observableThrow(response_);
        }));
    }

    protected processInsuranceOptions(response: HttpResponseBase): Observable<HealthProfessionalMedicalProcedureInsuranceOptions> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalMedicalProcedureInsuranceOptions.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalMedicalProcedureInsuranceOptions>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    careUnitOptions(body: HealthProfessionalProcedureCareUnitOptionsInput | undefined) : Observable<ProfessionalCareUnitBasicInputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalMedicalProcedureService/CareUnitOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCareUnitOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCareUnitOptions(<any>response_);
                } catch (e) {
                    return <Observable<ProfessionalCareUnitBasicInputDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfessionalCareUnitBasicInputDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCareUnitOptions(response: HttpResponseBase): Observable<ProfessionalCareUnitBasicInputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProfessionalCareUnitBasicInputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessionalCareUnitBasicInputDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHealthProfessionalMedicalProcedureInput | undefined) : Observable<HealthProfessionalMedicalProcedureDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalMedicalProcedureService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalMedicalProcedureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalMedicalProcedureDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HealthProfessionalMedicalProcedureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalMedicalProcedureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalMedicalProcedureDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHealthProfessionalMedicalProcedureInput | undefined) : Observable<HealthProfessionalMedicalProcedureDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalMedicalProcedureService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalMedicalProcedureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalMedicalProcedureDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HealthProfessionalMedicalProcedureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalMedicalProcedureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalMedicalProcedureDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toogleActive(body: ToggleHealthProfessionalMedicalProcedureActiveDto[] | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalMedicalProcedureService/ToogleActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToogleActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToogleActive(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processToogleActive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalMedicalProcedureService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class HealthProfessionalServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAppointmentEmailNotificationSettings(body: UpdateAppointmentEmailNotificationSettingsRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/UpdateAppointmentEmailNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAppointmentEmailNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAppointmentEmailNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAppointmentEmailNotificationSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getAppointmentEmailNotificationSettings() : Observable<AppointmentEmailNotificationSettingsResponse> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/GetAppointmentEmailNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentEmailNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentEmailNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentEmailNotificationSettingsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentEmailNotificationSettingsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppointmentEmailNotificationSettings(response: HttpResponseBase): Observable<AppointmentEmailNotificationSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentEmailNotificationSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentEmailNotificationSettingsResponse>(<any>null);
    }

    /**
     * Autenticar profissional
     * @param body (optional) 
     * @return Success
     */
    authenticateHealthProfessional(body: AuthenticateHealthProfessionalRequest | undefined) : Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/AuthenticateHealthProfessional";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateHealthProfessional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateHealthProfessional(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateHealthProfessional(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * Listar profissionais de saúde
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetHealthProfessionalsInput | undefined) : Observable<HealthProfessionalDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HealthProfessionalDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHealthProfessionalInput | undefined) : Observable<HealthProfessionalDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HealthProfessionalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<HealthProfessionalDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HealthProfessionalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getHealthProfessionals() : Observable<HealthProfessionalBasicData[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/GetHealthProfessionals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthProfessionals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthProfessionals(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalBasicData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalBasicData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHealthProfessionals(response: HttpResponseBase): Observable<HealthProfessionalBasicData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HealthProfessionalBasicData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalBasicData[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWorkJourney(id: string | undefined) : Observable<AvailableDateWindow[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/GetWorkJourney?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkJourney(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkJourney(<any>response_);
                } catch (e) {
                    return <Observable<AvailableDateWindow[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailableDateWindow[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkJourney(response: HttpResponseBase): Observable<AvailableDateWindow[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AvailableDateWindow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailableDateWindow[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkJourney(body: UpdateHealthProfessionalWorkJourneyInput | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/UpdateWorkJourney";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkJourney(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkJourney(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateWorkJourney(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAvailability(body: GetProfessionalAvailabilityInput | undefined) : Observable<ProfessionalAvailabilityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/GetAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailability(<any>response_);
                } catch (e) {
                    return <Observable<ProfessionalAvailabilityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfessionalAvailabilityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailability(response: HttpResponseBase): Observable<ProfessionalAvailabilityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProfessionalAvailabilityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessionalAvailabilityDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    isReady() : Observable<IsReadyDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/IsReady";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsReady(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsReady(<any>response_);
                } catch (e) {
                    return <Observable<IsReadyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsReadyDto>><any>_observableThrow(response_);
        }));
    }

    protected processIsReady(response: HttpResponseBase): Observable<IsReadyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsReadyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsReadyDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHealthProfessionalInput | undefined) : Observable<HealthProfessionalDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthProfessionalService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HealthProfessionalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalDto>(<any>null);
    }
}

@Injectable()
export class HealthTenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDefaultTenantCreationModel() : Observable<CreateHealthTenantRequest> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/GetDefaultTenantCreationModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultTenantCreationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultTenantCreationModel(<any>response_);
                } catch (e) {
                    return <Observable<CreateHealthTenantRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateHealthTenantRequest>><any>_observableThrow(response_);
        }));
    }

    protected processGetDefaultTenantCreationModel(response: HttpResponseBase): Observable<CreateHealthTenantRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateHealthTenantRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateHealthTenantRequest>(<any>null);
    }

    /**
     * @return Success
     */
    getDoctor() : Observable<DoctorDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/GetDoctor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctor(<any>response_);
                } catch (e) {
                    return <Observable<DoctorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDoctor(response: HttpResponseBase): Observable<DoctorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorDto>(<any>null);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getCompleteTenantRegistrationModel(token: string | null | undefined) : Observable<CompleteHealthTenantRegistrationRequest> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/GetCompleteTenantRegistrationModel?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompleteTenantRegistrationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompleteTenantRegistrationModel(<any>response_);
                } catch (e) {
                    return <Observable<CompleteHealthTenantRegistrationRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompleteHealthTenantRegistrationRequest>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompleteTenantRegistrationModel(response: HttpResponseBase): Observable<CompleteHealthTenantRegistrationRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompleteHealthTenantRegistrationRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompleteHealthTenantRegistrationRequest>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeTenantRegistration(body: CompleteHealthTenantRegistrationRequest | undefined) : Observable<HealthTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/CompleteTenantRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteTenantRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteTenantRegistration(<any>response_);
                } catch (e) {
                    return <Observable<HealthTenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthTenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteTenantRegistration(response: HttpResponseBase): Observable<HealthTenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthTenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthTenantDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSpecialties() : Observable<MedicalProfessionSpecialty[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/GetSpecialties";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialties(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProfessionSpecialty[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProfessionSpecialty[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpecialties(response: HttpResponseBase): Observable<MedicalProfessionSpecialty[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalProfessionSpecialty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProfessionSpecialty[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHealthTenantRequest | undefined) : Observable<HealthTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<HealthTenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthTenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HealthTenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthTenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthTenantDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEdition(id: number | null | undefined) : Observable<EditionDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/GetEdition?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(<any>response_);
                } catch (e) {
                    return <Observable<EditionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionDto>(<any>null);
    }

    /**
     * @param billingPeriod (optional) 
     * @return Success
     */
    getBillingPeriodDiscount(billingPeriod: string | null | undefined) : Observable<Discount> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/GetBillingPeriodDiscount?";
        if (billingPeriod !== undefined && billingPeriod !== null)
            url_ += "billingPeriod=" + encodeURIComponent("" + billingPeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingPeriodDiscount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingPeriodDiscount(<any>response_);
                } catch (e) {
                    return <Observable<Discount>><any>_observableThrow(e);
                }
            } else
                return <Observable<Discount>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillingPeriodDiscount(response: HttpResponseBase): Observable<Discount> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Discount.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Discount>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateVoucher(body: ValidateVoucherInput | undefined) : Observable<ValidateVoucherResult> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/ValidateVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateVoucher(<any>response_);
                } catch (e) {
                    return <Observable<ValidateVoucherResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidateVoucherResult>><any>_observableThrow(response_);
        }));
    }

    protected processValidateVoucher(response: HttpResponseBase): Observable<ValidateVoucherResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateVoucherResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateVoucherResult>(<any>null);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getEditionByName(name: string | null | undefined) : Observable<EditionDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/GetEditionByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionByName(<any>response_);
                } catch (e) {
                    return <Observable<EditionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionByName(response: HttpResponseBase): Observable<EditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBasicInfo(body: UpdateBasicInfoRequest | undefined) : Observable<TenantInfo> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/UpdateBasicInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBasicInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBasicInfo(<any>response_);
                } catch (e) {
                    return <Observable<TenantInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantInfo>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBasicInfo(response: HttpResponseBase): Observable<TenantInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFiscalInfo(body: UpdateFiscalInfoRequest | undefined) : Observable<TenantInfo> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/UpdateFiscalInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFiscalInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFiscalInfo(<any>response_);
                } catch (e) {
                    return <Observable<TenantInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantInfo>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateFiscalInfo(response: HttpResponseBase): Observable<TenantInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePaymentProfile(body: UpdatePaymentProfileRequest | undefined) : Observable<TenantInfo> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/UpdatePaymentProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaymentProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentProfile(<any>response_);
                } catch (e) {
                    return <Observable<TenantInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantInfo>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePaymentProfile(response: HttpResponseBase): Observable<TenantInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantInfo>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantInfo() : Observable<TenantInfo> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/GetTenantInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantInfo(<any>response_);
                } catch (e) {
                    return <Observable<TenantInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantInfo(response: HttpResponseBase): Observable<TenantInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantInfo>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<HealthTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<HealthTenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthTenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HealthTenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthTenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthTenantDto>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined) : Observable<HealthTenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<HealthTenantDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthTenantDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HealthTenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthTenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthTenantDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: HealthTenantDto | undefined) : Observable<HealthTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<HealthTenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthTenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HealthTenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthTenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthTenantDto>(<any>null);
    }
}

@Injectable()
export class HealthTenantServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    exportAllData() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenantService/ExportAllData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAllData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAllData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportAllData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: CreateHealthTenantRequest | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/services/app/HealthTenantService/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }
}

@Injectable()
export class HomeScreenServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param project (optional) 
     * @param lastModificationTime (optional) 
     * @return Success
     */
    getContent(project: string | undefined, lastModificationTime: moment.Moment | undefined) : Observable<HomeScreen> {
        let url_ = this.baseUrl + "/api/services/app/HomeScreen/GetContent?";
        if (project === null)
            throw new Error("The parameter 'project' cannot be null.");
        else if (project !== undefined)
            url_ += "Project=" + encodeURIComponent("" + project) + "&";
        if (lastModificationTime === null)
            throw new Error("The parameter 'lastModificationTime' cannot be null.");
        else if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContent(<any>response_);
                } catch (e) {
                    return <Observable<HomeScreen>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomeScreen>><any>_observableThrow(response_);
        }));
    }

    protected processGetContent(response: HttpResponseBase): Observable<HomeScreen> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HomeScreen.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeScreen>(<any>null);
    }
}

@Injectable()
export class IconServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getFeatureIcons() : Observable<Icon[]> {
        let url_ = this.baseUrl + "/api/services/app/IconService/GetFeatureIcons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatureIcons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatureIcons(<any>response_);
                } catch (e) {
                    return <Observable<Icon[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Icon[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFeatureIcons(response: HttpResponseBase): Observable<Icon[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Icon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Icon[]>(<any>null);
    }

    /**
     * @param text (optional) 
     * @return Success
     */
    getIcons(text: string | null | undefined) : Observable<Icon[]> {
        let url_ = this.baseUrl + "/api/services/app/IconService/GetIcons?";
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIcons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIcons(<any>response_);
                } catch (e) {
                    return <Observable<Icon[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Icon[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetIcons(response: HttpResponseBase): Observable<Icon[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Icon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Icon[]>(<any>null);
    }
}

@Injectable()
export class ImpersonateServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonate(body: ImpersonateInput | undefined) : Observable<TenantUserAbpLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/ImpersonateService/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(<any>response_);
                } catch (e) {
                    return <Observable<TenantUserAbpLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantUserAbpLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<TenantUserAbpLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantUserAbpLoginResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantUserAbpLoginResult>(<any>null);
    }
}

@Injectable()
export class InsuranceCompanyServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateInsuranceCompanyInput | undefined) : Observable<InsuranceCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/InsuranceCompanyService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<InsuranceCompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsuranceCompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InsuranceCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsuranceCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsuranceCompanyDto>(<any>null);
    }

    /**
     * Listar convênios
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetInsuranceCompaniesInput | undefined) : Observable<InsuranceCompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InsuranceCompanyService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<InsuranceCompanyDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsuranceCompanyDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InsuranceCompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsuranceCompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsuranceCompanyDtoPagedResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getInsuranceCompanies() : Observable<InsuranceCompanyBasicData[]> {
        let url_ = this.baseUrl + "/api/services/app/InsuranceCompanyService/GetInsuranceCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuranceCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuranceCompanies(<any>response_);
                } catch (e) {
                    return <Observable<InsuranceCompanyBasicData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsuranceCompanyBasicData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetInsuranceCompanies(response: HttpResponseBase): Observable<InsuranceCompanyBasicData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InsuranceCompanyBasicData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsuranceCompanyBasicData[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InsuranceCompanyService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateInsuranceCompanyInput | undefined) : Observable<InsuranceCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/InsuranceCompanyService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<InsuranceCompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsuranceCompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InsuranceCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsuranceCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsuranceCompanyDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<InsuranceCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/InsuranceCompanyService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<InsuranceCompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsuranceCompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InsuranceCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsuranceCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsuranceCompanyDto>(<any>null);
    }
}

@Injectable()
export class InsurancePlanServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Listar planos de convênios
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetInsurancePlansInput | undefined) : Observable<InsurancePlanDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InsurancePlanService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<InsurancePlanDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsurancePlanDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InsurancePlanDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsurancePlanDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsurancePlanDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<InsurancePlanDto> {
        let url_ = this.baseUrl + "/api/services/app/InsurancePlanService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<InsurancePlanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsurancePlanDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InsurancePlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsurancePlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsurancePlanDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateInsurancePlanInput | undefined) : Observable<InsurancePlanDto> {
        let url_ = this.baseUrl + "/api/services/app/InsurancePlanService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<InsurancePlanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsurancePlanDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InsurancePlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsurancePlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsurancePlanDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateInsurancePlanInput | undefined) : Observable<InsurancePlanDto> {
        let url_ = this.baseUrl + "/api/services/app/InsurancePlanService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<InsurancePlanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InsurancePlanDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InsurancePlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsurancePlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsurancePlanDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InsurancePlanService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class InvitationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateInvitation | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvitationService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    getFirstActiveInvitation(email: string | null | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/InvitationService/GetFirstActiveInvitation?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirstActiveInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstActiveInvitation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetFirstActiveInvitation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param email (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getActiveInvitation(email: string | null | undefined, tenantId: number | undefined) : Observable<InvitationDto> {
        let url_ = this.baseUrl + "/api/services/app/InvitationService/GetActiveInvitation?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveInvitation(<any>response_);
                } catch (e) {
                    return <Observable<InvitationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvitationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveInvitation(response: HttpResponseBase): Observable<InvitationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvitationDto>(<any>null);
    }

    /**
     * @param invitationId (optional) 
     * @return Success
     */
    get(invitationId: string | undefined) : Observable<InvitationDto> {
        let url_ = this.baseUrl + "/api/services/app/InvitationService/Get?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<InvitationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvitationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InvitationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvitationDto>(<any>null);
    }

    /**
     * @param invitationId (optional) 
     * @return Success
     */
    getCompletionModel(invitationId: string | undefined) : Observable<InvitationCompletionModel> {
        let url_ = this.baseUrl + "/api/services/app/InvitationService/GetCompletionModel?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompletionModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompletionModel(<any>response_);
                } catch (e) {
                    return <Observable<InvitationCompletionModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvitationCompletionModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompletionModel(response: HttpResponseBase): Observable<InvitationCompletionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitationCompletionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvitationCompletionModel>(<any>null);
    }

    /**
     * @param invitationId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getCompletionModelForUser(invitationId: string | undefined, userId: number | null | undefined) : Observable<InvitationCompletionModel> {
        let url_ = this.baseUrl + "/api/services/app/InvitationService/GetCompletionModelForUser?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompletionModelForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompletionModelForUser(<any>response_);
                } catch (e) {
                    return <Observable<InvitationCompletionModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvitationCompletionModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompletionModelForUser(response: HttpResponseBase): Observable<InvitationCompletionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitationCompletionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvitationCompletionModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    complete(body: InvitationCompletionModel | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/services/app/InvitationService/Complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComplete(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processComplete(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param invitationId (optional) 
     * @return Success
     */
    getOwner(invitationId: string | undefined) : Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InvitationService/GetOwner?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwner(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetOwner(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    delete(email: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvitationService/Delete?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LoginServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param forceTenantCheck (optional) 
     * @param updateLastTenantLogin (optional) 
     * @return Success
     */
    loginUserInTenant(userId: number | undefined, tenantId: number | null | undefined, forceTenantCheck: boolean | undefined, updateLastTenantLogin: boolean | undefined) : Observable<TenantUserAbpLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/LoginService/LoginUserInTenant?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (forceTenantCheck === null)
            throw new Error("The parameter 'forceTenantCheck' cannot be null.");
        else if (forceTenantCheck !== undefined)
            url_ += "forceTenantCheck=" + encodeURIComponent("" + forceTenantCheck) + "&";
        if (updateLastTenantLogin === null)
            throw new Error("The parameter 'updateLastTenantLogin' cannot be null.");
        else if (updateLastTenantLogin !== undefined)
            url_ += "updateLastTenantLogin=" + encodeURIComponent("" + updateLastTenantLogin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginUserInTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginUserInTenant(<any>response_);
                } catch (e) {
                    return <Observable<TenantUserAbpLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantUserAbpLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processLoginUserInTenant(response: HttpResponseBase): Observable<TenantUserAbpLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantUserAbpLoginResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantUserAbpLoginResult>(<any>null);
    }
}

@Injectable()
export class MedicalAgreementServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param doctorId (optional) 
     * @return Success
     */
    getAllByDoctor(doctorId: string | undefined) : Observable<MedicalAgreementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAgreementService/GetAllByDoctor?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByDoctor(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAgreementDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAgreementDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByDoctor(response: HttpResponseBase): Observable<MedicalAgreementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalAgreementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAgreementDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<MedicalAgreementDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAgreementService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAgreementDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAgreementDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAgreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAgreementDto>(<any>null);
    }

    /**
     * @param doctorId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(doctorId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<MedicalAgreementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAgreementService/GetAll?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAgreementDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAgreementDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicalAgreementDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAgreementDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAgreementDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicalAgreement | undefined) : Observable<MedicalAgreementDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAgreementService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAgreementDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAgreementDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAgreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAgreementDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicalAgreementDto | undefined) : Observable<MedicalAgreementDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAgreementService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAgreementDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAgreementDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicalAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAgreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAgreementDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAgreementService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MedicalAppointmentDurationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param doctorId (optional) 
     * @param specialty (optional) 
     * @return Success
     */
    getFromCache(doctorId: string | undefined, specialty: number | undefined) : Observable<MedicalAppointmentDurationDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentDurationService/GetFromCache?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (specialty === null)
            throw new Error("The parameter 'specialty' cannot be null.");
        else if (specialty !== undefined)
            url_ += "specialty=" + encodeURIComponent("" + specialty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromCache(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFromCache(response: HttpResponseBase): Observable<MedicalAppointmentDurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDurationDto>(<any>null);
    }

    /**
     * @param doctorId (optional) 
     * @return Success
     */
    getAppointment(doctorId: string | undefined) : Observable<MedicalAppointmentDurationDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentDurationService/GetAppointment?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointment(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppointment(response: HttpResponseBase): Observable<MedicalAppointmentDurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDurationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: MedicalAppointmentDurationDto | undefined) : Observable<MedicalAppointmentDurationDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentDurationService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalAppointmentDurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDurationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: MedicalAppointmentDurationDto | undefined) : Observable<MedicalAppointmentDurationDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentDurationService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicalAppointmentDurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDurationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentDurationService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<MedicalAppointmentDurationDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentDurationService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalAppointmentDurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDurationDto>(<any>null);
    }

    /**
     * @param doctorId (optional) 
     * @return Success
     */
    getAll(doctorId: string | undefined) : Observable<MedicalAppointmentDurationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentDurationService/GetAll?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDurationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDurationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicalAppointmentDurationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDurationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDurationDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class MedicalAppointmentServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAvailability(body: GetAvailableMedicalAppointmentTimesRequest | undefined) : Observable<GetAvailableAppointmentTimesResponse> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailability(<any>response_);
                } catch (e) {
                    return <Observable<GetAvailableAppointmentTimesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAvailableAppointmentTimesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailability(response: HttpResponseBase): Observable<GetAvailableAppointmentTimesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableAppointmentTimesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAvailableAppointmentTimesResponse>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param file (optional) 
     * @return Success
     */
    download(id: string | undefined, file: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Download?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (file === null)
            throw new Error("The parameter 'file' cannot be null.");
        else if (file !== undefined)
            url_ += "file=" + encodeURIComponent("" + file) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelByToken(body: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/CancelByToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelByToken(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCancelByToken(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmByChannel(body: ConfirmByChannelRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/ConfirmByChannel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmByChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmByChannel(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmByChannel(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param doctorId (optional) 
     * @param professionals (optional) ID's dos profissionais dos quais você quer visualizar a agenda
     * @param procedures (optional) ID's dos procedimentos dos quais você quer visualizar a agenda
     * @param patientId (optional) Caso você queira obter a lista de agendamentos de um paciente específico
     * @param excludeExternalAppointments (optional) 
     * @param from (optional) Inicio da janela de tempo que você quer listar os agendamentos, exemplo: 19/10/2022 e passando Range = 2 (Weekly) você vai receber a lista de agendamentos da semana do dia 19/10
     * @param range (optional) Tamanho da janela de tempo: Daily = 1, Weekly = 2, Monthly = 3, NowOn = 4
     * @param showCanceledAppointments (optional) 
     * @param careUnits (optional) ID's das Unidades das quais você quer visualizar a agenda
     * @param appointmentStatus (optional) ID's dos status de agendamento a serem visualizados
     * @param includeForDeletedPatients (optional) 
     * @return Success
     */
    getAll(doctorId: string | undefined, professionals: string[] | null | undefined, procedures: number[] | null | undefined, patientId: string | undefined, excludeExternalAppointments: boolean | undefined, from: moment.Moment | null | undefined, range: AppointmentsQueryRange | undefined, showCanceledAppointments: boolean | undefined, careUnits: number[] | null | undefined, appointmentStatus: AppointmentStatus[] | null | undefined, includeForDeletedPatients: boolean | undefined) : Observable<MedicalAppointmentEntry[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetAll?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (professionals !== undefined && professionals !== null)
            professionals && professionals.forEach(item => { url_ += "Professionals=" + encodeURIComponent("" + item) + "&"; });
        if (procedures !== undefined && procedures !== null)
            procedures && procedures.forEach(item => { url_ += "Procedures=" + encodeURIComponent("" + item) + "&"; });
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (excludeExternalAppointments === null)
            throw new Error("The parameter 'excludeExternalAppointments' cannot be null.");
        else if (excludeExternalAppointments !== undefined)
            url_ += "ExcludeExternalAppointments=" + encodeURIComponent("" + excludeExternalAppointments) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (range === null)
            throw new Error("The parameter 'range' cannot be null.");
        else if (range !== undefined)
            url_ += "Range=" + encodeURIComponent("" + range) + "&";
        if (showCanceledAppointments === null)
            throw new Error("The parameter 'showCanceledAppointments' cannot be null.");
        else if (showCanceledAppointments !== undefined)
            url_ += "ShowCanceledAppointments=" + encodeURIComponent("" + showCanceledAppointments) + "&";
        if (careUnits !== undefined && careUnits !== null)
            careUnits && careUnits.forEach(item => { url_ += "CareUnits=" + encodeURIComponent("" + item) + "&"; });
        if (appointmentStatus !== undefined && appointmentStatus !== null)
            appointmentStatus && appointmentStatus.forEach(item => { url_ += "AppointmentStatus=" + encodeURIComponent("" + item) + "&"; });
        if (includeForDeletedPatients === null)
            throw new Error("The parameter 'includeForDeletedPatients' cannot be null.");
        else if (includeForDeletedPatients !== undefined)
            url_ += "IncludeForDeletedPatients=" + encodeURIComponent("" + includeForDeletedPatients) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicalAppointmentEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalAppointmentEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentEntry[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyFileUploaded(body: NotifyAppointmentFileUploadedRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/NotifyFileUploaded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyFileUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyFileUploaded(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNotifyFileUploaded(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param appointmentId (optional) 
     * @return Success
     */
    getOwner(appointmentId: string | undefined) : Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetOwner?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "appointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwner(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetOwner(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCall(body: CreateMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/CreateCall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCall(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCall(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAppointmentForCall(id: string | undefined) : Observable<GetAppointmentForCallResult> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetAppointmentForCall?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentForCall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentForCall(<any>response_);
                } catch (e) {
                    return <Observable<GetAppointmentForCallResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAppointmentForCallResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppointmentForCall(response: HttpResponseBase): Observable<GetAppointmentForCallResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppointmentForCallResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAppointmentForCallResult>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAppointment(id: string | undefined) : Observable<MedicalAppointmentDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetAppointment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointment(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppointment(response: HttpResponseBase): Observable<MedicalAppointmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param deleteAllRecurrences (optional) 
     * @return Success
     */
    delete(id: string | undefined, deleteAllRecurrences: boolean | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deleteAllRecurrences === null)
            throw new Error("The parameter 'deleteAllRecurrences' cannot be null.");
        else if (deleteAllRecurrences !== undefined)
            url_ += "DeleteAllRecurrences=" + encodeURIComponent("" + deleteAllRecurrences) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    hasAlreadyConfiguredWorkSchedule(userId: number | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/HasAlreadyConfiguredWorkSchedule?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAlreadyConfiguredWorkSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAlreadyConfiguredWorkSchedule(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHasAlreadyConfiguredWorkSchedule(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    isReadyToTakeAppointments(userId: number | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/IsReadyToTakeAppointments?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsReadyToTakeAppointments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsReadyToTakeAppointments(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsReadyToTakeAppointments(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getWorkSchedule(userId: number | null | undefined) : Observable<WorkSchedule> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetWorkSchedule?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkSchedule(<any>response_);
                } catch (e) {
                    return <Observable<WorkSchedule>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkSchedule>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkSchedule(response: HttpResponseBase): Observable<WorkSchedule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkSchedule.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkSchedule>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkSchedule(body: UpdateWorkScheduleRequest | undefined) : Observable<WorkSchedule> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/UpdateWorkSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkSchedule(<any>response_);
                } catch (e) {
                    return <Observable<WorkSchedule>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkSchedule>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateWorkSchedule(response: HttpResponseBase): Observable<WorkSchedule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkSchedule.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkSchedule>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCalendarView(body: AppointmentsQueryRange | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/UpdateCalendarView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCalendarView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCalendarView(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCalendarView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCalendarView() : Observable<AppointmentsQueryRange> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetCalendarView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarView(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentsQueryRange>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentsQueryRange>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendarView(response: HttpResponseBase): Observable<AppointmentsQueryRange> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentsQueryRange>(<any>null);
    }

    /**
     * @return Success
     */
    notificationsFeatureEnabled() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/NotificationsFeatureEnabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsFeatureEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsFeatureEnabled(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processNotificationsFeatureEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param allow (optional) 
     * @return Success
     */
    updateAllowScheduleNotifications(allow: boolean | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/UpdateAllowScheduleNotifications?";
        if (allow === null)
            throw new Error("The parameter 'allow' cannot be null.");
        else if (allow !== undefined)
            url_ += "allow=" + encodeURIComponent("" + allow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllowScheduleNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllowScheduleNotifications(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllowScheduleNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    allowScheduleNotifications() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/AllowScheduleNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllowScheduleNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllowScheduleNotifications(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAllowScheduleNotifications(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param text (optional) 
     * @return Success
     */
    search(text: string | null | undefined) : Observable<AppointmentSearchResultGroup[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Search?";
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<AppointmentSearchResultGroup[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppointmentSearchResultGroup[]>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<AppointmentSearchResultGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AppointmentSearchResultGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppointmentSearchResultGroup[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSpecialties() : Observable<MedicalProfessionSpecialty[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetSpecialties";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialties(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProfessionSpecialty[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProfessionSpecialty[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpecialties(response: HttpResponseBase): Observable<MedicalProfessionSpecialty[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalProfessionSpecialty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProfessionSpecialty[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSpecialty(id: number | undefined) : Observable<MedicalProfessionSpecialty> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetSpecialty?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialty(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProfessionSpecialty>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProfessionSpecialty>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpecialty(response: HttpResponseBase): Observable<MedicalProfessionSpecialty> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalProfessionSpecialty.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProfessionSpecialty>(<any>null);
    }

    /**
     * @param specialty (optional) 
     * @return Success
     */
    getDoctors(specialty: number | undefined) : Observable<DoctorInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetDoctors?";
        if (specialty === null)
            throw new Error("The parameter 'specialty' cannot be null.");
        else if (specialty !== undefined)
            url_ += "specialty=" + encodeURIComponent("" + specialty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctors(<any>response_);
                } catch (e) {
                    return <Observable<DoctorInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDoctors(response: HttpResponseBase): Observable<DoctorInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DoctorInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorInfo[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDoctor(id: string | undefined) : Observable<DoctorInfo> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetDoctor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctor(<any>response_);
                } catch (e) {
                    return <Observable<DoctorInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetDoctor(response: HttpResponseBase): Observable<DoctorInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorInfo>(<any>null);
    }

    /**
     * @param doctorId (optional) 
     * @param procedureId (optional) 
     * @return Success
     */
    getMedicalAgreements(doctorId: string | undefined, procedureId: number | undefined) : Observable<MedicalAgreementInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/GetMedicalAgreements?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (procedureId === null)
            throw new Error("The parameter 'procedureId' cannot be null.");
        else if (procedureId !== undefined)
            url_ += "procedureId=" + encodeURIComponent("" + procedureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalAgreements(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAgreementInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAgreementInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMedicalAgreements(response: HttpResponseBase): Observable<MedicalAgreementInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalAgreementInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAgreementInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    parseMedicalAppointmentModel(body: GetMedicalAppointmentModelInput | undefined) : Observable<CreateMedicalAppointmentModel> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/ParseMedicalAppointmentModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParseMedicalAppointmentModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParseMedicalAppointmentModel(<any>response_);
                } catch (e) {
                    return <Observable<CreateMedicalAppointmentModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateMedicalAppointmentModel>><any>_observableThrow(response_);
        }));
    }

    protected processParseMedicalAppointmentModel(response: HttpResponseBase): Observable<CreateMedicalAppointmentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMedicalAppointmentModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateMedicalAppointmentModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    accept(body: AcceptMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccept(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reject(body: RejectMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancel(body: CancelMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    requestCancel(id: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/RequestCancel?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestCancel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRequestCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    counterPartDidNotShowUp(body: CounterPartDidNotShowUpDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/CounterPartDidNotShowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCounterPartDidNotShowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCounterPartDidNotShowUp(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processCounterPartDidNotShowUp(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reschedule(body: RescheduleMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Reschedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReschedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReschedule(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processReschedule(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finalize(body: FinalizeMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/Finalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalize(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processFinalize(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleRemotely(body: ToggleMedicalAppointmentRemotelyDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/MedicalAppointmentService/ToggleRemotely";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleRemotely(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleRemotely(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processToggleRemotely(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }
}

@Injectable()
export class PreServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param procedureId (optional) 
     * @return Success
     */
    getAll(procedureId: number | undefined) : Observable<PreProcedureFormInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/health/procedure/form/pre/GetAll?";
        if (procedureId === null)
            throw new Error("The parameter 'procedureId' cannot be null.");
        else if (procedureId !== undefined)
            url_ += "procedureId=" + encodeURIComponent("" + procedureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PreProcedureFormInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreProcedureFormInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PreProcedureFormInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PreProcedureFormInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreProcedureFormInfo[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<GetProcedurePreFormDetailsResponse> {
        let url_ = this.baseUrl + "/api/services/app/health/procedure/form/pre/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GetProcedurePreFormDetailsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProcedurePreFormDetailsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetProcedurePreFormDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProcedurePreFormDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProcedurePreFormDetailsResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProcedurePreFormRequest | undefined) : Observable<PreProcedureFormInfo> {
        let url_ = this.baseUrl + "/api/services/app/health/procedure/form/pre/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PreProcedureFormInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreProcedureFormInfo>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PreProcedureFormInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreProcedureFormInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreProcedureFormInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateProcedurePreFormRequest | undefined) : Observable<PreProcedureFormInfo> {
        let url_ = this.baseUrl + "/api/services/app/health/procedure/form/pre/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PreProcedureFormInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreProcedureFormInfo>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PreProcedureFormInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreProcedureFormInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreProcedureFormInfo>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/health/procedure/form/pre/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MedicalProcedureServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPublicDescription(id: number | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProcedureService/GetPublicDescription?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicDescription(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublicDescription(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Listar procedimentos
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetMedicalProceduresInput | undefined) : Observable<MedicalProcedureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProcedureService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProcedureDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProcedureDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicalProcedureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalProcedureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProcedureDtoPagedResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBasicData() : Observable<MedicalProcedureBasicData[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProcedureService/GetBasicData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicData(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProcedureBasicData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProcedureBasicData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBasicData(response: HttpResponseBase): Observable<MedicalProcedureBasicData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalProcedureBasicData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProcedureBasicData[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<MedicalProcedureDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProcedureService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProcedureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProcedureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalProcedureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalProcedureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProcedureDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicalProcedureInput | undefined) : Observable<MedicalProcedureDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProcedureService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProcedureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProcedureDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalProcedureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalProcedureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProcedureDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicalProcedureInput | undefined) : Observable<MedicalProcedureDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProcedureService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProcedureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProcedureDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicalProcedureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalProcedureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProcedureDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProcedureService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRootProcedures() : Observable<MedicalProcedureBasicData[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProcedureService/GetRootProcedures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRootProcedures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRootProcedures(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProcedureBasicData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProcedureBasicData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRootProcedures(response: HttpResponseBase): Observable<MedicalProcedureBasicData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalProcedureBasicData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProcedureBasicData[]>(<any>null);
    }

    /**
     * @return Success
     */
    allowTerms() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProcedureService/AllowTerms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllowTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllowTerms(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAllowTerms(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class MedicalProfessionServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMedicalProfessionData() : Observable<GetMedicalProfessionDataResponse> {
        let url_ = this.baseUrl + "/api/services/app/MedicalProfessionService/GetMedicalProfessionData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalProfessionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalProfessionData(<any>response_);
                } catch (e) {
                    return <Observable<GetMedicalProfessionDataResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMedicalProfessionDataResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMedicalProfessionData(response: HttpResponseBase): Observable<GetMedicalProfessionDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicalProfessionDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMedicalProfessionDataResponse>(<any>null);
    }
}

@Injectable()
export class MedicalRecordConfigurationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    configuration() : Observable<MedicalRecordConfigurationModel> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordConfigurationService/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordConfigurationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordConfigurationModel>><any>_observableThrow(response_);
        }));
    }

    protected processConfiguration(response: HttpResponseBase): Observable<MedicalRecordConfigurationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalRecordConfigurationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordConfigurationModel>(<any>null);
    }

    /**
     * @param sharedMedicalRecord (optional) 
     * @param allowRecordEdition (optional) 
     * @param recordEditionPeriod (optional) 
     * @param sharedExaminationModel (optional) 
     * @param sharedPrescriptionModel (optional) 
     * @param sharedDocumentModel (optional) 
     * @param sendExaminationToPatientByEmail (optional) 
     * @param sendPrescriptionToPatientByEmail (optional) 
     * @param sendFileToPatientByEmail (optional) 
     * @return Success
     */
    update(sharedMedicalRecord: boolean | undefined, allowRecordEdition: boolean | undefined, recordEditionPeriod: number | undefined, sharedExaminationModel: boolean | undefined, sharedPrescriptionModel: boolean | undefined, sharedDocumentModel: boolean | undefined, sendExaminationToPatientByEmail: boolean | undefined, sendPrescriptionToPatientByEmail: boolean | undefined, sendFileToPatientByEmail: boolean | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordConfigurationService/Update?";
        if (sharedMedicalRecord === null)
            throw new Error("The parameter 'sharedMedicalRecord' cannot be null.");
        else if (sharedMedicalRecord !== undefined)
            url_ += "SharedMedicalRecord=" + encodeURIComponent("" + sharedMedicalRecord) + "&";
        if (allowRecordEdition === null)
            throw new Error("The parameter 'allowRecordEdition' cannot be null.");
        else if (allowRecordEdition !== undefined)
            url_ += "AllowRecordEdition=" + encodeURIComponent("" + allowRecordEdition) + "&";
        if (recordEditionPeriod === null)
            throw new Error("The parameter 'recordEditionPeriod' cannot be null.");
        else if (recordEditionPeriod !== undefined)
            url_ += "RecordEditionPeriod=" + encodeURIComponent("" + recordEditionPeriod) + "&";
        if (sharedExaminationModel === null)
            throw new Error("The parameter 'sharedExaminationModel' cannot be null.");
        else if (sharedExaminationModel !== undefined)
            url_ += "SharedExaminationModel=" + encodeURIComponent("" + sharedExaminationModel) + "&";
        if (sharedPrescriptionModel === null)
            throw new Error("The parameter 'sharedPrescriptionModel' cannot be null.");
        else if (sharedPrescriptionModel !== undefined)
            url_ += "SharedPrescriptionModel=" + encodeURIComponent("" + sharedPrescriptionModel) + "&";
        if (sharedDocumentModel === null)
            throw new Error("The parameter 'sharedDocumentModel' cannot be null.");
        else if (sharedDocumentModel !== undefined)
            url_ += "SharedDocumentModel=" + encodeURIComponent("" + sharedDocumentModel) + "&";
        if (sendExaminationToPatientByEmail === null)
            throw new Error("The parameter 'sendExaminationToPatientByEmail' cannot be null.");
        else if (sendExaminationToPatientByEmail !== undefined)
            url_ += "SendExaminationToPatientByEmail=" + encodeURIComponent("" + sendExaminationToPatientByEmail) + "&";
        if (sendPrescriptionToPatientByEmail === null)
            throw new Error("The parameter 'sendPrescriptionToPatientByEmail' cannot be null.");
        else if (sendPrescriptionToPatientByEmail !== undefined)
            url_ += "SendPrescriptionToPatientByEmail=" + encodeURIComponent("" + sendPrescriptionToPatientByEmail) + "&";
        if (sendFileToPatientByEmail === null)
            throw new Error("The parameter 'sendFileToPatientByEmail' cannot be null.");
        else if (sendFileToPatientByEmail !== undefined)
            url_ += "SendFileToPatientByEmail=" + encodeURIComponent("" + sendFileToPatientByEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class MedicalRecordEntryServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: AddMedicalRecordEntryCommand | undefined) : Observable<MedicalRecordEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordEntryService/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordEntryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordEntryDto>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<MedicalRecordEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalRecordEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordEntryDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(body: GetMedicalRecordQuery | undefined) : Observable<GetMedicalRecordResult> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordEntryService/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GetMedicalRecordResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMedicalRecordResult>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetMedicalRecordResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicalRecordResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMedicalRecordResult>(<any>null);
    }
}

@Injectable()
export class MedicalRecordFormDefinitionServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetMedicalRecordFormsDefinitionQuery | undefined) : Observable<GetMedicalRecordFormsDefinitionResult> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordFormDefinitionService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<GetMedicalRecordFormsDefinitionResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMedicalRecordFormsDefinitionResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetMedicalRecordFormsDefinitionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicalRecordFormsDefinitionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMedicalRecordFormsDefinitionResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicalRecordFormDefinitionCommand | undefined) : Observable<MedicalRecordFormDefinition> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordFormDefinitionService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordFormDefinition>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordFormDefinition>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalRecordFormDefinition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalRecordFormDefinition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordFormDefinition>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicalRecordFormDefinitionCommand | undefined) : Observable<MedicalRecordFormDefinition> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordFormDefinitionService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordFormDefinition>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordFormDefinition>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicalRecordFormDefinition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalRecordFormDefinition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordFormDefinition>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<MedicalRecordFormDefinition> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordFormDefinitionService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordFormDefinition>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordFormDefinition>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalRecordFormDefinition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalRecordFormDefinition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordFormDefinition>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordFormDefinitionService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getSearchable(input: GetSearchableMedicalRecordFormsQuery | undefined) : Observable<MedicalRecordFormDefinition[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordFormDefinitionService/GetSearchable?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchable(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordFormDefinition[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordFormDefinition[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchable(response: HttpResponseBase): Observable<MedicalRecordFormDefinition[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalRecordFormDefinition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordFormDefinition[]>(<any>null);
    }
}

@Injectable()
export class MedicalRecordFormServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    collect(body: CollectMedicalRecordFormCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordFormService/Collect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollect(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCollect(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicalRecordFormResponseRequest | undefined) : Observable<MedicalRecordFormResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordFormService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordFormResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordFormResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicalRecordFormResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalRecordFormResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordFormResponseDto>(<any>null);
    }
}

@Injectable()
export class MedicalRecordLegacyFormServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetMedicalRecordFormsQuery | undefined) : Observable<GetMedicalRecordFormsResult> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordLegacyFormService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<GetMedicalRecordFormsResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMedicalRecordFormsResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetMedicalRecordFormsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicalRecordFormsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMedicalRecordFormsResult>(<any>null);
    }

    /**
     * @return Success
     */
    getTags() : Observable<MedicalRecordFormTagDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordLegacyFormService/GetTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordFormTagDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordFormTagDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<MedicalRecordFormTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalRecordFormTagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordFormTagDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicalRecordFormCommand | undefined) : Observable<MedicalRecordFormDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordLegacyFormService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordFormDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordFormDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalRecordFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalRecordFormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordFormDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicalRecordFormCommand | undefined) : Observable<MedicalRecordFormDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordLegacyFormService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordFormDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordFormDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicalRecordFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalRecordFormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordFormDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<MedicalRecordFormDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordLegacyFormService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalRecordFormDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalRecordFormDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalRecordFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalRecordFormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalRecordFormDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedicalRecordLegacyFormService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class MedicalSpecialtyServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: MedicalSpecialtyDto | undefined) : Observable<MedicalSpecialtyDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalSpecialtyService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalSpecialtyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalSpecialtyDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicalSpecialtyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalSpecialtyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalSpecialtyDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    find(body: FindSpecialtiesRequest | undefined) : Observable<SimpleMedicalSpecialty[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicalSpecialtyService/Find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFind(<any>response_);
                } catch (e) {
                    return <Observable<SimpleMedicalSpecialty[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SimpleMedicalSpecialty[]>><any>_observableThrow(response_);
        }));
    }

    protected processFind(response: HttpResponseBase): Observable<SimpleMedicalSpecialty[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SimpleMedicalSpecialty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SimpleMedicalSpecialty[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<MedicalSpecialtyDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalSpecialtyService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalSpecialtyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalSpecialtyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalSpecialtyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalSpecialtyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalSpecialtyDto>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined) : Observable<MedicalSpecialtyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalSpecialtyService/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicalSpecialtyDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalSpecialtyDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicalSpecialtyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalSpecialtyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalSpecialtyDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicalSpecialtyDto | undefined) : Observable<MedicalSpecialtyDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalSpecialtyService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalSpecialtyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalSpecialtyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalSpecialtyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalSpecialtyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalSpecialtyDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalSpecialtyService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MedicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMedicationDoseConfiguration() : Observable<GetMedicationDoseConfiguration> {
        let url_ = this.baseUrl + "/api/services/app/health/Medication/GetMedicationDoseConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationDoseConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationDoseConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<GetMedicationDoseConfiguration>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMedicationDoseConfiguration>><any>_observableThrow(response_);
        }));
    }

    protected processGetMedicationDoseConfiguration(response: HttpResponseBase): Observable<GetMedicationDoseConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicationDoseConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMedicationDoseConfiguration>(<any>null);
    }

    /**
     * @param title (optional) 
     * @param message (optional) 
     * @return Success
     */
    updateMedicationDoseConfiguration(title: string | null | undefined, message: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/health/Medication/UpdateMedicationDoseConfiguration?";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (message !== undefined && message !== null)
            url_ += "Message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicationDoseConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicationDoseConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMedicationDoseConfiguration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    restoreDefaultMedicationDoseConfiguration() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/health/Medication/RestoreDefaultMedicationDoseConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreDefaultMedicationDoseConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreDefaultMedicationDoseConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRestoreDefaultMedicationDoseConfiguration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    createMedicationRecurrence() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/health/Medication/CreateMedicationRecurrence";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMedicationRecurrence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMedicationRecurrence(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMedicationRecurrence(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class MedicationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMedicationInfo() : Observable<MedicationInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationService/GetMedicationInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationInfo(<any>response_);
                } catch (e) {
                    return <Observable<MedicationInfoDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationInfoDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMedicationInfo(response: HttpResponseBase): Observable<MedicationInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicationInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicationInfoDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPatientMedicationInfo() : Observable<MedicationInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationService/GetPatientMedicationInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMedicationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMedicationInfo(<any>response_);
                } catch (e) {
                    return <Observable<MedicationInfoDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationInfoDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPatientMedicationInfo(response: HttpResponseBase): Observable<MedicationInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicationInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicationInfoDto[]>(<any>null);
    }

    /**
     * @param prescriptionModelId (optional) 
     * @return Success
     */
    handlePrescriptionModelCreatedEvent(prescriptionModelId: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicationService/HandlePrescriptionModelCreatedEvent?";
        if (prescriptionModelId === null)
            throw new Error("The parameter 'prescriptionModelId' cannot be null.");
        else if (prescriptionModelId !== undefined)
            url_ += "prescriptionModelId=" + encodeURIComponent("" + prescriptionModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandlePrescriptionModelCreatedEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandlePrescriptionModelCreatedEvent(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHandlePrescriptionModelCreatedEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    removePatientMedicationNode(patientId: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicationService/RemovePatientMedicationNode?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePatientMedicationNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePatientMedicationNode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemovePatientMedicationNode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class NoteServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    hasDrafts(patientId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/HasDrafts?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasDrafts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasDrafts(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHasDrafts(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getDraft(patientId: string | undefined) : Observable<NoteDraft> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/GetDraft?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraft(<any>response_);
                } catch (e) {
                    return <Observable<NoteDraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoteDraft>><any>_observableThrow(response_);
        }));
    }

    protected processGetDraft(response: HttpResponseBase): Observable<NoteDraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteDraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoteDraft>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    createDraft(patientId: string | undefined) : Observable<NoteDraft> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/CreateDraft?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDraft(<any>response_);
                } catch (e) {
                    return <Observable<NoteDraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoteDraft>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDraft(response: HttpResponseBase): Observable<NoteDraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteDraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoteDraft>(<any>null);
    }

    /**
     * @param draftId (optional) 
     * @param text (optional) 
     * @return Success
     */
    updateDraft(draftId: string | undefined, text: string | null | undefined) : Observable<NoteDraft> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/UpdateDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (draftId === null || draftId === undefined)
            throw new Error("The parameter 'draftId' cannot be null.");
        else
            content_.append("draftId", draftId.toString());
        if (text !== null && text !== undefined)
            content_.append("text", text.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDraft(<any>response_);
                } catch (e) {
                    return <Observable<NoteDraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoteDraft>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDraft(response: HttpResponseBase): Observable<NoteDraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteDraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoteDraft>(<any>null);
    }

    /**
     * @param noteId (optional) 
     * @return Success
     */
    createUpdateDraft(noteId: string | undefined) : Observable<NoteDraft> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/CreateUpdateDraft?";
        if (noteId === null)
            throw new Error("The parameter 'noteId' cannot be null.");
        else if (noteId !== undefined)
            url_ += "noteId=" + encodeURIComponent("" + noteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateDraft(<any>response_);
                } catch (e) {
                    return <Observable<NoteDraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoteDraft>><any>_observableThrow(response_);
        }));
    }

    protected processCreateUpdateDraft(response: HttpResponseBase): Observable<NoteDraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteDraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoteDraft>(<any>null);
    }

    /**
     * @param draftId (optional) 
     * @return Success
     */
    deleteDraft(draftId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/DeleteDraft?";
        if (draftId === null)
            throw new Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDraft(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDraft(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param draftId (optional) 
     * @param text (optional) 
     * @param files (optional) 
     * @return Success
     */
    publish(draftId: string | undefined, text: string | null | undefined, files: FileParameter[] | null | undefined) : Observable<NoteDto> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/Publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (draftId === null || draftId === undefined)
            throw new Error("The parameter 'draftId' cannot be null.");
        else
            content_.append("draftId", draftId.toString());
        if (text !== null && text !== undefined)
            content_.append("text", text.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(<any>response_);
                } catch (e) {
                    return <Observable<NoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<NoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoteDto>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    publishAllDrafts(patientId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/PublishAllDrafts?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishAllDrafts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishAllDrafts(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPublishAllDrafts(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    discardAllDrafts(patientId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/DiscardAllDrafts?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiscardAllDrafts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscardAllDrafts(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDiscardAllDrafts(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param noteId (optional) 
     * @return Success
     */
    delete(noteId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/Delete?";
        if (noteId === null)
            throw new Error("The parameter 'noteId' cannot be null.");
        else if (noteId !== undefined)
            url_ += "noteId=" + encodeURIComponent("" + noteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param noteId (optional) 
     * @param files (optional) 
     * @return Success
     */
    attachDocuments(noteId: string | undefined, files: FileParameter[] | null | undefined) : Observable<NoteDto> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/AttachDocuments?";
        if (noteId === null)
            throw new Error("The parameter 'noteId' cannot be null.");
        else if (noteId !== undefined)
            url_ += "noteId=" + encodeURIComponent("" + noteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachDocuments(<any>response_);
                } catch (e) {
                    return <Observable<NoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processAttachDocuments(response: HttpResponseBase): Observable<NoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoteDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDocument(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/DeleteDocument?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    downloadDocument(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/DownloadDocument?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: ExportNotesRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getIcd(keyword: string | null | undefined) : Observable<Icd[]> {
        let url_ = this.baseUrl + "/api/services/app/NoteService/GetIcd?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIcd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIcd(<any>response_);
                } catch (e) {
                    return <Observable<Icd[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Icd[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetIcd(response: HttpResponseBase): Observable<Icd[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Icd.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Icd[]>(<any>null);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getNotificationSettings() : Observable<NotificationSettingsResponse> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<NotificationSettingsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationSettingsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<NotificationSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationSettingsResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotificationSettings(body: NotificationSettingsRequest | undefined) : Observable<NotificationSettingsResponse> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<NotificationSettingsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationSettingsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<NotificationSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationSettingsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getUnreadNotificationCount() : Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUnreadNotificationCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadNotificationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadNotificationCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnreadNotificationCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentNotifications() : Observable<GetRecentNotificationsResult> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetRecentNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentNotifications(<any>response_);
                } catch (e) {
                    return <Observable<GetRecentNotificationsResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRecentNotificationsResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentNotifications(response: HttpResponseBase): Observable<GetRecentNotificationsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentNotificationsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRecentNotificationsResult>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getNotifications(skipCount: number | undefined, maxResultCount: number | undefined) : Observable<ResponseNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotifications?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifications(<any>response_);
                } catch (e) {
                    return <Observable<ResponseNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotifications(response: HttpResponseBase): Observable<ResponseNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseNotificationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    setRead(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetRead?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    setReadAll() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetReadAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetReadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetReadAll(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetReadAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteAll() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filters (optional) Filters are formatted as: filter1:filter2:filter3
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filters: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<ObjectPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAll?";
        if (filters !== undefined && filters !== null)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ObjectPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ObjectPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotification(id: string | undefined) : Observable<UserNotification> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotification(<any>response_);
                } catch (e) {
                    return <Observable<UserNotification>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserNotification>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotification(response: HttpResponseBase): Observable<UserNotification> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotification.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotification>(<any>null);
    }
}

@Injectable()
export class PatientRegistrationConfigurationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get() : Observable<PatientRegistrationSettings> {
        let url_ = this.baseUrl + "/api/services/app/PatientRegistrationConfigurationService/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientRegistrationSettings>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientRegistrationSettings>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientRegistrationSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientRegistrationSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientRegistrationSettings>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PatientRegistrationSettings | undefined) : Observable<PatientRegistrationSettings> {
        let url_ = this.baseUrl + "/api/services/app/PatientRegistrationConfigurationService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientRegistrationSettings>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientRegistrationSettings>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientRegistrationSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientRegistrationSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientRegistrationSettings>(<any>null);
    }
}

@Injectable()
export class PatientServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDeletedPatients(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<GetDeletedPatientsQueryResult> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/GetDeletedPatients?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeletedPatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeletedPatients(<any>response_);
                } catch (e) {
                    return <Observable<GetDeletedPatientsQueryResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeletedPatientsQueryResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeletedPatients(response: HttpResponseBase): Observable<GetDeletedPatientsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeletedPatientsQueryResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeletedPatientsQueryResult>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    restorePatient(patientId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/RestorePatient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestorePatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestorePatient(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRestorePatient(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePhoto(body: UpdatePatientPhotoRequest | undefined) : Observable<PatientDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/UpdatePhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePhoto(<any>response_);
                } catch (e) {
                    return <Observable<PatientDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePhoto(response: HttpResponseBase): Observable<PatientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientDto>(<any>null);
    }

    /**
     * @param personalIdentifier (optional) 
     * @return Success
     */
    find(personalIdentifier: string | null | undefined) : Observable<PatientDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/Find?";
        if (personalIdentifier !== undefined && personalIdentifier !== null)
            url_ += "PersonalIdentifier=" + encodeURIComponent("" + personalIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFind(<any>response_);
                } catch (e) {
                    return <Observable<PatientDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processFind(response: HttpResponseBase): Observable<PatientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PatientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    listBirthdays(body: GetBirthdaysRequest | undefined) : Observable<GetBirthdaysDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/list-birthdays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListBirthdays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListBirthdays(<any>response_);
                } catch (e) {
                    return <Observable<GetBirthdaysDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBirthdaysDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processListBirthdays(response: HttpResponseBase): Observable<GetBirthdaysDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetBirthdaysDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBirthdaysDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportListBirthdays(body: ExportBirthdaysRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/export-list-birthdays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportListBirthdays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportListBirthdays(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportListBirthdays(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    toggleSidebarSequentialNumber() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/ToggleSidebarSequentialNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleSidebarSequentialNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleSidebarSequentialNumber(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processToggleSidebarSequentialNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getSidebarSettings() : Observable<GetSidebarSettingsResponse> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/GetSidebarSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSidebarSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSidebarSettings(<any>response_);
                } catch (e) {
                    return <Observable<GetSidebarSettingsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSidebarSettingsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSidebarSettings(response: HttpResponseBase): Observable<GetSidebarSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSidebarSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSidebarSettingsResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTag(body: AddTagRequest | undefined) : Observable<TagDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/AddTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTag(<any>response_);
                } catch (e) {
                    return <Observable<TagDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TagDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddTag(response: HttpResponseBase): Observable<TagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TagDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTags() : Observable<TagDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/GetTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(<any>response_);
                } catch (e) {
                    return <Observable<TagDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TagDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<TagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TagDto[]>(<any>null);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    createTag(name: string | null | undefined) : Observable<TagDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/CreateTag?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTag(<any>response_);
                } catch (e) {
                    return <Observable<TagDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TagDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTag(response: HttpResponseBase): Observable<TagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TagDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameTag(body: RenameTagRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/RenameTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameTag(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRenameTag(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTag(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/DeleteTag?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTag(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTag(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(body: ExportInput | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getExcelTemplate() : Observable<GetImportPatientExcelTemplateResult> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/GetExcelTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcelTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcelTemplate(<any>response_);
                } catch (e) {
                    return <Observable<GetImportPatientExcelTemplateResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetImportPatientExcelTemplateResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetExcelTemplate(response: HttpResponseBase): Observable<GetImportPatientExcelTemplateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetImportPatientExcelTemplateResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetImportPatientExcelTemplateResult>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importFromExcelTemplate(file: FileParameter | null | undefined) : Observable<ImportPatientsFromExcelTemplateResult> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/ImportFromExcelTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportFromExcelTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFromExcelTemplate(<any>response_);
                } catch (e) {
                    return <Observable<ImportPatientsFromExcelTemplateResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportPatientsFromExcelTemplateResult>><any>_observableThrow(response_);
        }));
    }

    protected processImportFromExcelTemplate(response: HttpResponseBase): Observable<ImportPatientsFromExcelTemplateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportPatientsFromExcelTemplateResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportPatientsFromExcelTemplateResult>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    exportBirthdays(filter: PeriodFilter | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/ExportBirthdays?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBirthdays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBirthdays(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportBirthdays(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getBirthdays(filter: PeriodFilter | undefined) : Observable<GetBirthdaysDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/GetBirthdays?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBirthdays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBirthdays(<any>response_);
                } catch (e) {
                    return <Observable<GetBirthdaysDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBirthdaysDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBirthdays(response: HttpResponseBase): Observable<GetBirthdaysDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetBirthdaysDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBirthdaysDto[]>(<any>null);
    }

    /**
     * Buscar paciente
     * @param keyword (optional) Termo usado para pesquisar pelo nome ou Email. Se formatado, pode ser data de nascimento (no formato 'dd/MM/yyyy'), CPF, RG ou código do paciente.
     * @return Success
     */
    search(keyword: string | null | undefined) : Observable<PatientSearchResult[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/Search?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PatientSearchResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientSearchResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PatientSearchResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PatientSearchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientSearchResult[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetPatientsRequest | undefined) : Observable<PatientDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientDtoPagedResultDto>(<any>null);
    }

    /**
     * Cadastrar
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientRequest | undefined) : Observable<PatientDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientDto>(<any>null);
    }

    /**
     * Atualizar
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientRequest | undefined) : Observable<PatientDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBasicData(body: UpdatePatientBasicDataInput | undefined) : Observable<PatientNameInfo> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/UpdateBasicData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBasicData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBasicData(<any>response_);
                } catch (e) {
                    return <Observable<PatientNameInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientNameInfo>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBasicData(response: HttpResponseBase): Observable<PatientNameInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientNameInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientNameInfo>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param invitationId (optional) 
     * @return Success
     */
    getPatientInvitationCompletionModel(invitationId: string | undefined) : Observable<PatientInvitationCompletionModel> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/GetPatientInvitationCompletionModel?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientInvitationCompletionModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientInvitationCompletionModel(<any>response_);
                } catch (e) {
                    return <Observable<PatientInvitationCompletionModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientInvitationCompletionModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetPatientInvitationCompletionModel(response: HttpResponseBase): Observable<PatientInvitationCompletionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientInvitationCompletionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientInvitationCompletionModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeRegistrationByInvitation(body: PatientInvitationCompletionModel | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/CompleteRegistrationByInvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteRegistrationByInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteRegistrationByInvitation(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteRegistrationByInvitation(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param text (optional) 
     * @return Success
     */
    getPatientsInfo(text: string | null | undefined) : Observable<PatientNameInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/GetPatientsInfo?";
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientsInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientsInfo(<any>response_);
                } catch (e) {
                    return <Observable<PatientNameInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientNameInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPatientsInfo(response: HttpResponseBase): Observable<PatientNameInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PatientNameInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientNameInfo[]>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getPatientInfo(patientId: string | undefined) : Observable<PatientNameInfo> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/GetPatientInfo?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientInfo(<any>response_);
                } catch (e) {
                    return <Observable<PatientNameInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientNameInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetPatientInfo(response: HttpResponseBase): Observable<PatientNameInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientNameInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientNameInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    merge(body: MergePatientInput | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/Merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerge(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMerge(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeTag(body: RemoveTagModel | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/RemoveTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveTag(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveTag(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<PatientDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientDto>(<any>null);
    }

    /**
     * @return Success
     */
    togglePatientProfessionalRelationshipRule() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PatientService/TogglePatientProfessionalRelationshipRule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTogglePatientProfessionalRelationshipRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTogglePatientProfessionalRelationshipRule(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processTogglePatientProfessionalRelationshipRule(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class PostalCodeServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param postalCode (optional) 
     * @return Success
     */
    validatePostalCode(postalCode: string | null | undefined) : Observable<GetExternalPostalCodeResult> {
        let url_ = this.baseUrl + "/api/services/app/PostalCodeService/ValidatePostalCode?";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePostalCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePostalCode(<any>response_);
                } catch (e) {
                    return <Observable<GetExternalPostalCodeResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetExternalPostalCodeResult>><any>_observableThrow(response_);
        }));
    }

    protected processValidatePostalCode(response: HttpResponseBase): Observable<GetExternalPostalCodeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExternalPostalCodeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExternalPostalCodeResult>(<any>null);
    }
}

@Injectable()
export class PregnancyCardServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    download(body: DownloadPregnancyCardRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PregnancyCardService/Download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getConfiguration() : Observable<PregnancyModuleConfigurationModel> {
        let url_ = this.baseUrl + "/api/services/app/PregnancyCardService/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<PregnancyModuleConfigurationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PregnancyModuleConfigurationModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<PregnancyModuleConfigurationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PregnancyModuleConfigurationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PregnancyModuleConfigurationModel>(<any>null);
    }

    /**
     * @param enabled (optional) 
     * @param sendByEmail (optional) 
     * @return Success
     */
    updateConfiguration(enabled: boolean | undefined, sendByEmail: boolean | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PregnancyCardService/UpdateConfiguration?";
        if (enabled === null)
            throw new Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "Enabled=" + encodeURIComponent("" + enabled) + "&";
        if (sendByEmail === null)
            throw new Error("The parameter 'sendByEmail' cannot be null.");
        else if (sendByEmail !== undefined)
            url_ += "SendByEmail=" + encodeURIComponent("" + sendByEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateConfiguration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    updatePregnancyCardFiles() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PregnancyCardService/UpdatePregnancyCardFiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePregnancyCardFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePregnancyCardFiles(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePregnancyCardFiles(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finalize(body: FinalizePregnancyCardRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PregnancyCardService/Finalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalize(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processFinalize(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    get(patientId: string | undefined) : Observable<GetPregnancyCardResponse> {
        let url_ = this.baseUrl + "/api/services/app/PregnancyCardService/Get?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GetPregnancyCardResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPregnancyCardResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPregnancyCardResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPregnancyCardResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPregnancyCardResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePregnancyCardRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PregnancyCardService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class PregnancyFormDefinitionServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePregnancyFormDefinitionRequest | undefined) : Observable<CreatePregnancyFormDefinitionResponse> {
        let url_ = this.baseUrl + "/api/services/app/PregnancyFormDefinitionService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CreatePregnancyFormDefinitionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreatePregnancyFormDefinitionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatePregnancyFormDefinitionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePregnancyFormDefinitionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePregnancyFormDefinitionResponse>(<any>null);
    }

    /**
     * @return Success
     */
    get() : Observable<GetPregnancyFormDefinitionResponse> {
        let url_ = this.baseUrl + "/api/services/app/PregnancyFormDefinitionService/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GetPregnancyFormDefinitionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPregnancyFormDefinitionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPregnancyFormDefinitionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPregnancyFormDefinitionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPregnancyFormDefinitionResponse>(<any>null);
    }
}

@Injectable()
export class PrescriptionModelServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetPrescriptionModelsQuery | undefined) : Observable<PrescriptionModelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionModelService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionModelDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionModelDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PrescriptionModelDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionModelDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionModelDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<PrescriptionModelDto> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionModelService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PrescriptionModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionModelDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionModelService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PrescriptionServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Update prescription comments order on front-end and prescription documents.
     * @param body (optional) 
     * @return Success
     */
    updatePrescriptionCommentsOrder(body: UpdatePrescriptionCommentsOrderRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/UpdatePrescriptionCommentsOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrescriptionCommentsOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrescriptionCommentsOrder(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePrescriptionCommentsOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param from (optional) 
     * @param range (optional) 
     * @param lastSyncDate (optional) 
     * @return Success
     */
    getMedicationDoses(from: moment.Moment | null | undefined, range: MedicationDosesQueryRange | undefined, lastSyncDate: moment.Moment | undefined) : Observable<MedicationDoseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/GetMedicationDoses?";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (range === null)
            throw new Error("The parameter 'range' cannot be null.");
        else if (range !== undefined)
            url_ += "Range=" + encodeURIComponent("" + range) + "&";
        if (lastSyncDate === null)
            throw new Error("The parameter 'lastSyncDate' cannot be null.");
        else if (lastSyncDate !== undefined)
            url_ += "LastSyncDate=" + encodeURIComponent(lastSyncDate ? "" + lastSyncDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationDoses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationDoses(<any>response_);
                } catch (e) {
                    return <Observable<MedicationDoseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationDoseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMedicationDoses(response: HttpResponseBase): Observable<MedicationDoseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicationDoseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicationDoseDto[]>(<any>null);
    }

    /**
     * @param doseId (optional) 
     * @return Success
     */
    takeDose(doseId: string | undefined) : Observable<MedicationDoseDto> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/TakeDose?";
        if (doseId === null)
            throw new Error("The parameter 'doseId' cannot be null.");
        else if (doseId !== undefined)
            url_ += "doseId=" + encodeURIComponent("" + doseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTakeDose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTakeDose(<any>response_);
                } catch (e) {
                    return <Observable<MedicationDoseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationDoseDto>><any>_observableThrow(response_);
        }));
    }

    protected processTakeDose(response: HttpResponseBase): Observable<MedicationDoseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationDoseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicationDoseDto>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getDraft(patientId: string | undefined) : Observable<PrescriptionDraft> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/GetDraft?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraft(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionDraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionDraft>><any>_observableThrow(response_);
        }));
    }

    protected processGetDraft(response: HttpResponseBase): Observable<PrescriptionDraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionDraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionDraft>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDraft(body: CreateDraftRequest | undefined) : Observable<PrescriptionDraft> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/CreateDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDraft(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionDraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionDraft>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDraft(response: HttpResponseBase): Observable<PrescriptionDraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionDraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionDraft>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDraft(body: UpdateDraftRequest | undefined) : Observable<PrescriptionDraft> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/UpdateDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDraft(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionDraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionDraft>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDraft(response: HttpResponseBase): Observable<PrescriptionDraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionDraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionDraft>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDraft(body: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/DeleteDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDraft(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDraft(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    publishDraft(body: PublishDraftRequest | undefined) : Observable<PrescriptionDto> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/PublishDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishDraft(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processPublishDraft(response: HttpResponseBase): Observable<PrescriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param name (optional) 
     * @return Success
     */
    download(id: string | undefined, name: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/Download?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    archivedPrescription(id: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/ArchivedPrescription?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchivedPrescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchivedPrescription(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processArchivedPrescription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    restorePrescription(id: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/RestorePrescription?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestorePrescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestorePrescription(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRestorePrescription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param prescriptionId (optional) 
     * @return Success
     */
    sendPrescriptionByEmail(prescriptionId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/SendPrescriptionByEmail?";
        if (prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' cannot be null.");
        else if (prescriptionId !== undefined)
            url_ += "prescriptionId=" + encodeURIComponent("" + prescriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPrescriptionByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPrescriptionByEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendPrescriptionByEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param hash (optional) 
     * @return Success
     */
    validate(hash: string | null | undefined) : Observable<PrescriptionInfo> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/Validate?";
        if (hash !== undefined && hash !== null)
            url_ += "hash=" + encodeURIComponent("" + hash) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidate(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionInfo>><any>_observableThrow(response_);
        }));
    }

    protected processValidate(response: HttpResponseBase): Observable<PrescriptionInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionInfo>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    validateByCode(code: string | null | undefined) : Observable<PrescriptionInfo> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/ValidateByCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateByCode(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionInfo>><any>_observableThrow(response_);
        }));
    }

    protected processValidateByCode(response: HttpResponseBase): Observable<PrescriptionInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionInfo>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getPrescriptionsByPatientId(patientId: string | undefined) : Observable<PrescriptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/GetPrescriptionsByPatientId?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionsByPatientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionsByPatientId(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPrescriptionsByPatientId(response: HttpResponseBase): Observable<PrescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PrescriptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    notificationsFeatureEnabled() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/NotificationsFeatureEnabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsFeatureEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsFeatureEnabled(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processNotificationsFeatureEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param allow (optional) 
     * @return Success
     */
    updateAllowMedicationDoseNotifications(allow: boolean | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/UpdateAllowMedicationDoseNotifications?";
        if (allow === null)
            throw new Error("The parameter 'allow' cannot be null.");
        else if (allow !== undefined)
            url_ += "allow=" + encodeURIComponent("" + allow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllowMedicationDoseNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllowMedicationDoseNotifications(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllowMedicationDoseNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    allowMedicationDoseNotifications() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/AllowMedicationDoseNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllowMedicationDoseNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllowMedicationDoseNotifications(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAllowMedicationDoseNotifications(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    isReadyToMakePrescription() : Observable<IsReadyToMakePrescriptionDto> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/IsReadyToMakePrescription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsReadyToMakePrescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsReadyToMakePrescription(<any>response_);
                } catch (e) {
                    return <Observable<IsReadyToMakePrescriptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsReadyToMakePrescriptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processIsReadyToMakePrescription(response: HttpResponseBase): Observable<IsReadyToMakePrescriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsReadyToMakePrescriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsReadyToMakePrescriptionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    generate(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/Generate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGenerate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<PrescriptionDto> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PrescriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionDto>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined) : Observable<PrescriptionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PrescriptionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePrescriptionRequest | undefined) : Observable<PrescriptionDto> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PrescriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePrescriptionRequest | undefined) : Observable<PrescriptionDto> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PrescriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrescriptionService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PublishServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAvailability(body: GetAvailableAppointmentTimesRequest | undefined) : Observable<GetAvailableAppointmentTimesResponse> {
        let url_ = this.baseUrl + "/api/services/app/PublishService/GetAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailability(<any>response_);
                } catch (e) {
                    return <Observable<GetAvailableAppointmentTimesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAvailableAppointmentTimesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailability(response: HttpResponseBase): Observable<GetAvailableAppointmentTimesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableAppointmentTimesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAvailableAppointmentTimesResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getWorkSchedule() : Observable<WorkSchedule> {
        let url_ = this.baseUrl + "/api/services/app/PublishService/GetWorkSchedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkSchedule(<any>response_);
                } catch (e) {
                    return <Observable<WorkSchedule>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkSchedule>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkSchedule(response: HttpResponseBase): Observable<WorkSchedule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkSchedule.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkSchedule>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePublishAppointmentDto | undefined) : Observable<PublishAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/PublishService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PublishAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublishAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PublishAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublishAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PublishAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reschedule(body: RescheduleAppointmentDto | undefined) : Observable<PublishAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/PublishService/Reschedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReschedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReschedule(<any>response_);
                } catch (e) {
                    return <Observable<PublishAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublishAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processReschedule(response: HttpResponseBase): Observable<PublishAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublishAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PublishAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancel(body: AppointmentStatusUpdateDto | undefined) : Observable<PublishAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/PublishService/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(<any>response_);
                } catch (e) {
                    return <Observable<PublishAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublishAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<PublishAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublishAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PublishAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finalize(body: AppointmentStatusUpdateDto | undefined) : Observable<PublishAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/PublishService/Finalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalize(<any>response_);
                } catch (e) {
                    return <Observable<PublishAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublishAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processFinalize(response: HttpResponseBase): Observable<PublishAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublishAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PublishAppointmentPreview>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAppointment(id: string | undefined) : Observable<PublishAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/PublishService/GetAppointment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointment(<any>response_);
                } catch (e) {
                    return <Observable<PublishAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublishAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppointment(response: HttpResponseBase): Observable<PublishAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublishAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PublishAppointmentPreview>(<any>null);
    }
}

@Injectable()
export class QrCodeLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    read(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/QrCodeLink/Read?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class QrCodeLinkServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    read(id: string | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/QrCodeLinkService/Read?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRead(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processRead(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class RemoteNotificationsServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateNotificationDto | undefined) : Observable<RemoteNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RemoteNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemoteNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RemoteNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoteNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoteNotificationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerDevice(body: RegisterDeviceDto | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/RegisterDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDevice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unregisterDevice(body: RegisterDeviceDto | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/UnregisterDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnregisterDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnregisterDevice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnregisterDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param notificationId (optional) 
     * @return Success
     */
    received(notificationId: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/Received?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceived(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReceived(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param notificationId (optional) 
     * @return Success
     */
    opened(notificationId: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/Opened?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpened(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpened(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processOpened(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param notificationId (optional) 
     * @return Success
     */
    deleted(notificationId: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/Deleted?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleted(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<RemoteNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RemoteNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemoteNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RemoteNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoteNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoteNotificationDto>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<RemoteNotificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/GetAll?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RemoteNotificationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemoteNotificationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RemoteNotificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoteNotificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoteNotificationDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RemoteNotificationDto | undefined) : Observable<RemoteNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RemoteNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemoteNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RemoteNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoteNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoteNotificationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RemoteNotificationsService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ReportServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Agendamentos/Atendimentos
     * @param body (optional) 
     * @return Success
     */
    getAttendance(body: GetAttendanceReportRequest | undefined) : Observable<GetAttendanceReportResponse> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/GetAttendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendance(<any>response_);
                } catch (e) {
                    return <Observable<GetAttendanceReportResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAttendanceReportResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttendance(response: HttpResponseBase): Observable<GetAttendanceReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceReportResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAttendance(body: GetAttendanceReportRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/ExportAttendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAttendance(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param role (optional) 
     * @return Success
     */
    getRolePermissions(role: string | null | undefined) : Observable<PermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRolePermissions?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolePermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRolePermissions(response: HttpResponseBase): Observable<PermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRolePermissions(body: UpdateRolePermissionsRequest | undefined) : Observable<PermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Role/UpdateRolePermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRolePermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRolePermissions(response: HttpResponseBase): Observable<PermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetRolePermissions(body: ResetRolePermissionsRequest | undefined) : Observable<PermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Role/ResetRolePermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetRolePermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processResetRolePermissions(response: HttpResponseBase): Observable<PermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined) : Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined) : Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined) : Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class ScheduleConfigurationServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    configuration() : Observable<ScheduleConfiguration> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleConfigurationService/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleConfiguration>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleConfiguration>><any>_observableThrow(response_);
        }));
    }

    protected processConfiguration(response: HttpResponseBase): Observable<ScheduleConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleConfiguration>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ScheduleConfiguration | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleConfigurationService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class ScheduleServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    makePayment(body: MakePaymentRequest | undefined) : Observable<MakePaymentResponse> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/MakePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakePayment(<any>response_);
                } catch (e) {
                    return <Observable<MakePaymentResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<MakePaymentResponse>><any>_observableThrow(response_);
        }));
    }

    protected processMakePayment(response: HttpResponseBase): Observable<MakePaymentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MakePaymentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MakePaymentResponse>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    download(id: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Download?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmailNotificationEnable(body: UpdateScheduleEmailNotificationEnableRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/UpdateEmailNotificationEnable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmailNotificationEnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmailNotificationEnable(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateEmailNotificationEnable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    isScheduleEmailNotificationEnable() : Observable<IsScheduleEmailNotificationEnableResponse> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/IsScheduleEmailNotificationEnable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsScheduleEmailNotificationEnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsScheduleEmailNotificationEnable(<any>response_);
                } catch (e) {
                    return <Observable<IsScheduleEmailNotificationEnableResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsScheduleEmailNotificationEnableResponse>><any>_observableThrow(response_);
        }));
    }

    protected processIsScheduleEmailNotificationEnable(response: HttpResponseBase): Observable<IsScheduleEmailNotificationEnableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsScheduleEmailNotificationEnableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsScheduleEmailNotificationEnableResponse>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    notify(id: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Notify?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotify(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processNotify(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    notifyAll(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/NotifyAll?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyAll(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processNotifyAll(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    start(body: StartAppointmentRequest | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStart(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processStart(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * Just for testing purpose
     * @param doctorId (optional) 
     * @param professionals (optional) ID's dos profissionais dos quais você quer visualizar a agenda
     * @param procedures (optional) ID's dos procedimentos dos quais você quer visualizar a agenda
     * @param patientId (optional) Caso você queira obter a lista de agendamentos de um paciente específico
     * @param excludeExternalAppointments (optional) 
     * @param from (optional) Inicio da janela de tempo que você quer listar os agendamentos, exemplo: 19/10/2022 e passando Range = 2 (Weekly) você vai receber a lista de agendamentos da semana do dia 19/10
     * @param range (optional) Tamanho da janela de tempo: Daily = 1, Weekly = 2, Monthly = 3, NowOn = 4
     * @param showCanceledAppointments (optional) 
     * @param careUnits (optional) ID's das Unidades das quais você quer visualizar a agenda
     * @param appointmentStatus (optional) ID's dos status de agendamento a serem visualizados
     * @return Success
     */
    getAllLegacy(doctorId: string | undefined, professionals: string[] | null | undefined, procedures: number[] | null | undefined, patientId: string | undefined, excludeExternalAppointments: boolean | undefined, from: moment.Moment | null | undefined, range: AppointmentsQueryRange | undefined, showCanceledAppointments: boolean | undefined, careUnits: number[] | null | undefined, appointmentStatus: AppointmentStatus[] | null | undefined) : Observable<MedicalAppointmentPreview[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/GetAllLegacy?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (professionals !== undefined && professionals !== null)
            professionals && professionals.forEach(item => { url_ += "Professionals=" + encodeURIComponent("" + item) + "&"; });
        if (procedures !== undefined && procedures !== null)
            procedures && procedures.forEach(item => { url_ += "Procedures=" + encodeURIComponent("" + item) + "&"; });
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (excludeExternalAppointments === null)
            throw new Error("The parameter 'excludeExternalAppointments' cannot be null.");
        else if (excludeExternalAppointments !== undefined)
            url_ += "ExcludeExternalAppointments=" + encodeURIComponent("" + excludeExternalAppointments) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (range === null)
            throw new Error("The parameter 'range' cannot be null.");
        else if (range !== undefined)
            url_ += "Range=" + encodeURIComponent("" + range) + "&";
        if (showCanceledAppointments === null)
            throw new Error("The parameter 'showCanceledAppointments' cannot be null.");
        else if (showCanceledAppointments !== undefined)
            url_ += "ShowCanceledAppointments=" + encodeURIComponent("" + showCanceledAppointments) + "&";
        if (careUnits !== undefined && careUnits !== null)
            careUnits && careUnits.forEach(item => { url_ += "CareUnits=" + encodeURIComponent("" + item) + "&"; });
        if (appointmentStatus !== undefined && appointmentStatus !== null)
            appointmentStatus && appointmentStatus.forEach(item => { url_ += "AppointmentStatus=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLegacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLegacy(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllLegacy(response: HttpResponseBase): Observable<MedicalAppointmentPreview[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalAppointmentPreview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview[]>(<any>null);
    }

    /**
     * Listar agendamentos
     * @param body (optional) 
     * @return Product retrieved
     */
    getAll(body: GetMedicalAppointmentsQuery | undefined) : Observable<MedicalAppointmentEntry[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicalAppointmentEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalAppointmentEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentEntry[]>(<any>null);
    }

    /**
     * Informações do agendamento
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined) : Observable<MedicalAppointmentDetails> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalAppointmentDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentDetails>(<any>null);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getByToken(token: string | null | undefined) : Observable<GetAppointmentByTokenResult> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/GetByToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByToken(<any>response_);
                } catch (e) {
                    return <Observable<GetAppointmentByTokenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAppointmentByTokenResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetByToken(response: HttpResponseBase): Observable<GetAppointmentByTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppointmentByTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAppointmentByTokenResult>(<any>null);
    }

    /**
     * Snapshot
     * @param body (optional) Teste
     * @return Success
     */
    snapshot(body: GetMedicalAppointmentSnapshotInput | undefined) : Observable<MedicalAppointmentSnapshot> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Snapshot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSnapshot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSnapshot(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentSnapshot>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentSnapshot>><any>_observableThrow(response_);
        }));
    }

    protected processSnapshot(response: HttpResponseBase): Observable<MedicalAppointmentSnapshot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentSnapshot.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentSnapshot>(<any>null);
    }

    /**
     * Agendar
     * @param body (optional) 
     * @return Success
     */
    create(body: ScheduleMedicalAppointmentInput | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * Remarcar
     * @param body (optional) 
     * @return Success
     */
    reSchedule(body: ReScheduleAppointmentInput | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/ReSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processReSchedule(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateScheduleAppointmentInput | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * Aceitar um agendamento
     * @param body (optional) 
     * @return Success
     */
    accept(body: AcceptMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccept(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * Rejeitar um agendamento
     * @param body (optional) 
     * @return Success
     */
    reject(body: RejectMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * Cancelar um agendamento
     * @param body (optional) 
     * @return Success
     */
    cancel(body: CancelMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * Não compareceu
     * @param body (optional) 
     * @return Success
     */
    counterPartDidNotShowUp(body: CounterPartDidNotShowUpDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/CounterPartDidNotShowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCounterPartDidNotShowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCounterPartDidNotShowUp(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processCounterPartDidNotShowUp(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * Finalizar
     * @param body (optional) 
     * @return Success
     */
    finalize(body: FinalizeMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Finalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalize(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processFinalize(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * O paciente está aguardando
     * @param body (optional) 
     * @return Success
     */
    waiting(body: WaitingMedicalAppointmentDto | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Waiting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWaiting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWaiting(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processWaiting(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param deleteAllRecurrences (optional) 
     * @return Success
     */
    delete(id: string | undefined, deleteAllRecurrences: boolean | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deleteAllRecurrences === null)
            throw new Error("The parameter 'deleteAllRecurrences' cannot be null.");
        else if (deleteAllRecurrences !== undefined)
            url_ += "DeleteAllRecurrences=" + encodeURIComponent("" + deleteAllRecurrences) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    end(input: string | undefined) : Observable<MedicalAppointmentPreview> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/End?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnd(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview>><any>_observableThrow(response_);
        }));
    }

    protected processEnd(response: HttpResponseBase): Observable<MedicalAppointmentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalAppointmentPreview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activeMedicalAppointmentForPatient(body: GetActiveMedicalAppointmentForPatientInput | undefined) : Observable<MedicalAppointmentPreview[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/ActiveMedicalAppointmentForPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveMedicalAppointmentForPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveMedicalAppointmentForPatient(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview[]>><any>_observableThrow(response_);
        }));
    }

    protected processActiveMedicalAppointmentForPatient(response: HttpResponseBase): Observable<MedicalAppointmentPreview[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalAppointmentPreview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview[]>(<any>null);
    }

    /**
     * Obter horários disponíveis
     * @param body (optional) 
     * @return Success
     */
    getAvailability(body: GetAvailableMedicalAppointmentTimesRequest | undefined) : Observable<GetAvailableAppointmentTimesResponse> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/GetAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailability(<any>response_);
                } catch (e) {
                    return <Observable<GetAvailableAppointmentTimesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAvailableAppointmentTimesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailability(response: HttpResponseBase): Observable<GetAvailableAppointmentTimesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableAppointmentTimesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAvailableAppointmentTimesResponse>(<any>null);
    }

    /**
     * Obter janela de horários
     * @param body (optional) 
     * @return Success
     */
    getAvailabilityWindow(body: GetAvailabilityWindowRequest | undefined) : Observable<ScheduleDateAvailability[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/GetAvailabilityWindow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailabilityWindow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailabilityWindow(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleDateAvailability[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleDateAvailability[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailabilityWindow(response: HttpResponseBase): Observable<ScheduleDateAvailability[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ScheduleDateAvailability.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleDateAvailability[]>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    lock(patientId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Lock?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLock(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processLock(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    unlock(patientId: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/Unlock?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlock(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUnlock(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getLocked() : Observable<PatientSearchResult[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/GetLocked";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocked(<any>response_);
                } catch (e) {
                    return <Observable<PatientSearchResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientSearchResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocked(response: HttpResponseBase): Observable<PatientSearchResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PatientSearchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientSearchResult[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addComplementaryProcedure(body: AddComplementaryProcedureCommand | undefined) : Observable<ComplementaryProcedureDto> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/AddComplementaryProcedure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddComplementaryProcedure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddComplementaryProcedure(<any>response_);
                } catch (e) {
                    return <Observable<ComplementaryProcedureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComplementaryProcedureDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddComplementaryProcedure(response: HttpResponseBase): Observable<ComplementaryProcedureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComplementaryProcedureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComplementaryProcedureDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteComplementaryProcedure(body: RemoveComplementaryProcedureCommand | undefined) : Observable<ComplementaryProcedureDto> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/DeleteComplementaryProcedure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComplementaryProcedure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComplementaryProcedure(<any>response_);
                } catch (e) {
                    return <Observable<ComplementaryProcedureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComplementaryProcedureDto>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteComplementaryProcedure(response: HttpResponseBase): Observable<ComplementaryProcedureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComplementaryProcedureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComplementaryProcedureDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPossibleComplementaryProcedures(body: GetPossibleComplementaryProceduresModel | undefined) : Observable<MedicalProcedureBasicData[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/GetPossibleComplementaryProcedures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleComplementaryProcedures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleComplementaryProcedures(<any>response_);
                } catch (e) {
                    return <Observable<MedicalProcedureBasicData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalProcedureBasicData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPossibleComplementaryProcedures(response: HttpResponseBase): Observable<MedicalProcedureBasicData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalProcedureBasicData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalProcedureBasicData[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signTerm(body: SignAppointmentResponsibilityTermCommand | undefined) : Observable<MedicalAppointmentProcedureResponsibilityTerm[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/SignTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignTerm(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentProcedureResponsibilityTerm[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentProcedureResponsibilityTerm[]>><any>_observableThrow(response_);
        }));
    }

    protected processSignTerm(response: HttpResponseBase): Observable<MedicalAppointmentProcedureResponsibilityTerm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalAppointmentProcedureResponsibilityTerm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentProcedureResponsibilityTerm[]>(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getPatientHistory(patientId: string | undefined) : Observable<MedicalAppointmentPreview[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduleService/GetPatientHistory?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientHistory(<any>response_);
                } catch (e) {
                    return <Observable<MedicalAppointmentPreview[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalAppointmentPreview[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPatientHistory(response: HttpResponseBase): Observable<MedicalAppointmentPreview[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicalAppointmentPreview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicalAppointmentPreview[]>(<any>null);
    }
}

@Injectable()
export class SellerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMatrixSeller(body: CreateMatrixSellerRequest | undefined) : Observable<MatrixSellerDto> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/CreateMatrixSeller";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMatrixSeller(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMatrixSeller(<any>response_);
                } catch (e) {
                    return <Observable<MatrixSellerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MatrixSellerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMatrixSeller(response: HttpResponseBase): Observable<MatrixSellerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatrixSellerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MatrixSellerDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createHealthProfessionalSeller(body: CreateHealthProfessionalSellerRequest | undefined) : Observable<HealthProfessionalSellerDto> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/CreateHealthProfessionalSeller";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHealthProfessionalSeller(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHealthProfessionalSeller(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalSellerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalSellerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateHealthProfessionalSeller(response: HttpResponseBase): Observable<HealthProfessionalSellerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalSellerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalSellerDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMatrixSellerState() : Observable<SellerAccountStatus> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/GetMatrixSellerState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatrixSellerState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatrixSellerState(<any>response_);
                } catch (e) {
                    return <Observable<SellerAccountStatus>><any>_observableThrow(e);
                }
            } else
                return <Observable<SellerAccountStatus>><any>_observableThrow(response_);
        }));
    }

    protected processGetMatrixSellerState(response: HttpResponseBase): Observable<SellerAccountStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellerAccountStatus>(<any>null);
    }

    /**
     * @param healthProfessionalId (optional) 
     * @return Success
     */
    getHealthProfessionalSellerState(healthProfessionalId: string | null | undefined) : Observable<SellerAccountStatus> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/GetHealthProfessionalSellerState?";
        if (healthProfessionalId !== undefined && healthProfessionalId !== null)
            url_ += "HealthProfessionalId=" + encodeURIComponent("" + healthProfessionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthProfessionalSellerState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthProfessionalSellerState(<any>response_);
                } catch (e) {
                    return <Observable<SellerAccountStatus>><any>_observableThrow(e);
                }
            } else
                return <Observable<SellerAccountStatus>><any>_observableThrow(response_);
        }));
    }

    protected processGetHealthProfessionalSellerState(response: HttpResponseBase): Observable<SellerAccountStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellerAccountStatus>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getMatrixSeller(tenantId: number | null | undefined) : Observable<MatrixSeller> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/GetMatrixSeller?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatrixSeller(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatrixSeller(<any>response_);
                } catch (e) {
                    return <Observable<MatrixSeller>><any>_observableThrow(e);
                }
            } else
                return <Observable<MatrixSeller>><any>_observableThrow(response_);
        }));
    }

    protected processGetMatrixSeller(response: HttpResponseBase): Observable<MatrixSeller> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatrixSeller.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MatrixSeller>(<any>null);
    }

    /**
     * @param healthProfessionalId (optional) 
     * @return Success
     */
    getHealthProfessionalSeller(healthProfessionalId: string | null | undefined) : Observable<HealthProfessionalSeller> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/GetHealthProfessionalSeller?";
        if (healthProfessionalId !== undefined && healthProfessionalId !== null)
            url_ += "HealthProfessionalId=" + encodeURIComponent("" + healthProfessionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthProfessionalSeller(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthProfessionalSeller(<any>response_);
                } catch (e) {
                    return <Observable<HealthProfessionalSeller>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthProfessionalSeller>><any>_observableThrow(response_);
        }));
    }

    protected processGetHealthProfessionalSeller(response: HttpResponseBase): Observable<HealthProfessionalSeller> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthProfessionalSeller.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthProfessionalSeller>(<any>null);
    }

    /**
     * @return Success
     */
    deactivateSeller() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/DeactivateSeller";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateSeller(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateSeller(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeactivateSeller(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    reactivateSeller() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/ReactivateSeller";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateSeller(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateSeller(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processReactivateSeller(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getSellerRegistrationModel() : Observable<SellerRegistrationModel> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/GetSellerRegistrationModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSellerRegistrationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellerRegistrationModel(<any>response_);
                } catch (e) {
                    return <Observable<SellerRegistrationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SellerRegistrationModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetSellerRegistrationModel(response: HttpResponseBase): Observable<SellerRegistrationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellerRegistrationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellerRegistrationModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isAllowedToAcceptPayments(body: IsAllowedToAcceptPaymentsQuery | undefined) : Observable<IsAllowedToAcceptPaymentsResult> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/IsAllowedToAcceptPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAllowedToAcceptPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAllowedToAcceptPayments(<any>response_);
                } catch (e) {
                    return <Observable<IsAllowedToAcceptPaymentsResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsAllowedToAcceptPaymentsResult>><any>_observableThrow(response_);
        }));
    }

    protected processIsAllowedToAcceptPayments(response: HttpResponseBase): Observable<IsAllowedToAcceptPaymentsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsAllowedToAcceptPaymentsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsAllowedToAcceptPaymentsResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSellerMaxProcedureNumberOfInstallments(body: UpdateSellerMaxProcedureNumberOfInstallmentsCommand | undefined) : Observable<MatrixSellerDto> {
        let url_ = this.baseUrl + "/api/services/app/SellerService/UpdateSellerMaxProcedureNumberOfInstallments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSellerMaxProcedureNumberOfInstallments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSellerMaxProcedureNumberOfInstallments(<any>response_);
                } catch (e) {
                    return <Observable<MatrixSellerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MatrixSellerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSellerMaxProcedureNumberOfInstallments(response: HttpResponseBase): Observable<MatrixSellerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatrixSellerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MatrixSellerDto>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations() : Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeTenant(body: TenantLoginInfoDto | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/services/app/Session/ChangeTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeTenant(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processChangeTenant(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param role (optional) 
     * @return Success
     */
    checkCurrentUserInRole(role: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Session/CheckCurrentUserInRole?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserInRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserInRole(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCurrentUserInRole(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class SessionCacheServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    handleEvent(body: DoctorEntityUpdatedEventData | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SessionCacheService/HandleEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleEvent(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHandleEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param user (optional) 
     * @return Success
     */
    removeUserSessionInfo(user: number | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SessionCacheService/RemoveUserSessionInfo?";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserSessionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserSessionInfo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUserSessionInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    get() : Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SessionCacheService/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @param user (optional) 
     * @param body (optional) 
     * @return Success
     */
    set(user: number | null | undefined, body: GetCurrentLoginInformationsOutput | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SessionCacheService/Set?";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SignatureServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param temporalFilePath (optional) 
     * @return Success
     */
    uploadImage(temporalFilePath: string | null | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SignatureService/UploadImage?";
        if (temporalFilePath !== undefined && temporalFilePath !== null)
            url_ += "temporalFilePath=" + encodeURIComponent("" + temporalFilePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getProcessedImage() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SignatureService/GetProcessedImage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessedImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessedImage(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetProcessedImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getProcessedImageBase64() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SignatureService/GetProcessedImageBase64";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessedImageBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessedImageBase64(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetProcessedImageBase64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getProcessedImageStream(tenantId: number | null | undefined, userId: number | undefined) : Observable<Stream> {
        let url_ = this.baseUrl + "/api/services/app/SignatureService/GetProcessedImageStream?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessedImageStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessedImageStream(<any>response_);
                } catch (e) {
                    return <Observable<Stream>><any>_observableThrow(e);
                }
            } else
                return <Observable<Stream>><any>_observableThrow(response_);
        }));
    }

    protected processGetProcessedImageStream(response: HttpResponseBase): Observable<Stream> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Stream.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Stream>(<any>null);
    }

    /**
     * @return Success
     */
    getOriginalImage() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SignatureService/GetOriginalImage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOriginalImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOriginalImage(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetOriginalImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    removeSignatureImage() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SignatureService/RemoveSignatureImage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSignatureImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSignatureImage(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveSignatureImage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class SiteServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @param file (optional) 
     * @return Success
     */
    upload(tenantId: number | undefined, file: FileParameter | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/Upload?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    updateDefault(tenantId: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/UpdateDefault?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefault(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDefault(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getDomainSettings(tenantId: number | undefined) : Observable<DomainSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/GetDomainSettings?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDomainSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomainSettings(<any>response_);
                } catch (e) {
                    return <Observable<DomainSettingsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DomainSettingsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDomainSettings(response: HttpResponseBase): Observable<DomainSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DomainSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DomainSettingsDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInternalDomain(body: UpdateInternalDomainCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/UpdateInternalDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInternalDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInternalDomain(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateInternalDomain(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setExternalDomain(body: UpdateExternalDomainCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/SetExternalDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetExternalDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetExternalDomain(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetExternalDomain(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeExternalDomain(body: DeleteExternalDomainCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/RemoveExternalDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveExternalDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveExternalDomain(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveExternalDomain(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomDomainToRedirect(body: AddCustomDomainToRedirectAppServiceCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/AddCustomDomainToRedirect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomDomainToRedirect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomDomainToRedirect(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomDomainToRedirect(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getAll() : Observable<SiteTemplate[]> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<SiteTemplate[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SiteTemplate[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SiteTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SiteTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SiteTemplate[]>(<any>null);
    }

    /**
     * @return Success
     */
    get() : Observable<SiteTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<SiteTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SiteTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SiteTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SiteTemplateDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSite() : Observable<SiteDefinition> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/GetSite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSite(<any>response_);
                } catch (e) {
                    return <Observable<SiteDefinition>><any>_observableThrow(e);
                }
            } else
                return <Observable<SiteDefinition>><any>_observableThrow(response_);
        }));
    }

    protected processGetSite(response: HttpResponseBase): Observable<SiteDefinition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteDefinition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SiteDefinition>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    removeFromCache(tenantId: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/RemoveFromCache?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFromCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFromCache(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveFromCache(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param templateId (optional) 
     * @return Success
     */
    getPages(templateId: number | undefined) : Observable<SiteTemplatePage[]> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/GetPages?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPages(<any>response_);
                } catch (e) {
                    return <Observable<SiteTemplatePage[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SiteTemplatePage[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPages(response: HttpResponseBase): Observable<SiteTemplatePage[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SiteTemplatePage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SiteTemplatePage[]>(<any>null);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getPage(name: string | null | undefined) : Observable<SiteTemplatePage> {
        let url_ = this.baseUrl + "/api/services/app/SiteService/GetPage?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPage(<any>response_);
                } catch (e) {
                    return <Observable<SiteTemplatePage>><any>_observableThrow(e);
                }
            } else
                return <Observable<SiteTemplatePage>><any>_observableThrow(response_);
        }));
    }

    protected processGetPage(response: HttpResponseBase): Observable<SiteTemplatePage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteTemplatePage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SiteTemplatePage>(<any>null);
    }
}

@Injectable()
export class SupportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getIdentifier() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Support/GetIdentifier";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdentifier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdentifier(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetIdentifier(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class TemporalFileManagerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param originalFile (optional) 
     * @param file (optional) 
     * @return Success
     */
    upload(originalFile: string | null | undefined, file: FileParameter | null | undefined) : Observable<UploadTemporalFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/TemporalFileManagerService/Upload?";
        if (originalFile !== undefined && originalFile !== null)
            url_ += "originalFile=" + encodeURIComponent("" + originalFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<UploadTemporalFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadTemporalFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<UploadTemporalFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadTemporalFileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadTemporalFileResponse>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    send(file: FileParameter | null | undefined) : Observable<UploadTemporalFileResult> {
        let url_ = this.baseUrl + "/api/services/app/TemporalFileManagerService/Send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSend(<any>response_);
                } catch (e) {
                    return <Observable<UploadTemporalFileResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadTemporalFileResult>><any>_observableThrow(response_);
        }));
    }

    protected processSend(response: HttpResponseBase): Observable<UploadTemporalFileResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadTemporalFileResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadTemporalFileResult>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    toggleIsActive(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ToggleIsActive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleIsActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleIsActive(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processToggleIsActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    updateActiveStatusOnStats() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateActiveStatusOnStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActiveStatusOnStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActiveStatusOnStats(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateActiveStatusOnStats(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param searchTerm (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(searchTerm: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<TenantDetailsPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TenantDetailsPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDetailsPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDetailsPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetailsPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDetailsPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined) : Observable<TenantDetails> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDetails>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDetails>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    hasAlreadyConfiguredWorkJourney(userId: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/HasAlreadyConfiguredWorkJourney?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAlreadyConfiguredWorkJourney(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAlreadyConfiguredWorkJourney(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHasAlreadyConfiguredWorkJourney(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getWorkJourney(userId: number | undefined) : Observable<WorkJourney> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetWorkJourney?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkJourney(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkJourney(<any>response_);
                } catch (e) {
                    return <Observable<WorkJourney>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkJourney>><any>_observableThrow(response_);
        }));
    }

    protected processGetWorkJourney(response: HttpResponseBase): Observable<WorkJourney> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkJourney.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkJourney>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkJourney(body: WorkJourneyDto | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateWorkJourney";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkJourney(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkJourney(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateWorkJourney(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    validateEmail(email: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ValidateEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidateEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getDoctorsCalendar() : Observable<DoctorCalendarSettings> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetDoctorsCalendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorsCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorsCalendar(<any>response_);
                } catch (e) {
                    return <Observable<DoctorCalendarSettings>><any>_observableThrow(e);
                }
            } else
                return <Observable<DoctorCalendarSettings>><any>_observableThrow(response_);
        }));
    }

    protected processGetDoctorsCalendar(response: HttpResponseBase): Observable<DoctorCalendarSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorCalendarSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DoctorCalendarSettings>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlock(body: UnlockTenantCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Unlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlock(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUnlock(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeEmail(body: ChangeTenantEmailCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ChangeEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangeEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setTenantDefaultPatientEmail(body: SetTenantDefaultPatientEmailCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/SetTenantDefaultPatientEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTenantDefaultPatientEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTenantDefaultPatientEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetTenantDefaultPatientEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateApiKey(body: SetApiKeyCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GenerateApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateApiKey(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateApiKey(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    toggleFinancialModuleEnabled(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ToggleFinancialModuleEnabled?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleFinancialModuleEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleFinancialModuleEnabled(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processToggleFinancialModuleEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activateFinancialModule(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ActivateFinancialModule?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateFinancialModule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateFinancialModule(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processActivateFinancialModule(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<TenantDetails> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TenantDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDetails>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined) : Observable<TenantDetails> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDetails>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDetails>(<any>null);
    }
}

@Injectable()
export class TenantDataImportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeImport(body: DataImportCompletedCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantDataImport/CompleteImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteImport(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteImport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Generates patient-professional relation for data imported patients
     * @param body (optional) 
     * @return Success
     */
    generatePatientProfessionalRelationship(body: GeneratePatientProfessionalRelationshipRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantDataImport/GeneratePatientProfessionalRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePatientProfessionalRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePatientProfessionalRelationship(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGeneratePatientProfessionalRelationship(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processDataImport(body: ProcessDataImportCommand | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantDataImport/ProcessDataImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessDataImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessDataImport(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processProcessDataImport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class TermsOfServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get() : Observable<PendingTermsOfService> {
        let url_ = this.baseUrl + "/api/services/app/TermsOfService/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PendingTermsOfService>><any>_observableThrow(e);
                }
            } else
                return <Observable<PendingTermsOfService>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PendingTermsOfService> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingTermsOfService.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PendingTermsOfService>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    sign(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TermsOfService/Sign?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSign(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSign(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class TestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    test1(path: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/Test1?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest1(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTest1(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMobileProjectId() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Test/GetMobileProjectId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMobileProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileProjectId(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetMobileProjectId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class ThemeServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getThemes() : Observable<ColorThemeCategory[]> {
        let url_ = this.baseUrl + "/api/services/app/ThemeService/GetThemes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThemes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThemes(<any>response_);
                } catch (e) {
                    return <Observable<ColorThemeCategory[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ColorThemeCategory[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetThemes(response: HttpResponseBase): Observable<ColorThemeCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ColorThemeCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ColorThemeCategory[]>(<any>null);
    }

    /**
     * @param tag (optional) 
     * @return Success
     */
    getByTag(tag: string | null | undefined) : Observable<ColorTheme> {
        let url_ = this.baseUrl + "/api/services/app/ThemeService/GetByTag?";
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTag(<any>response_);
                } catch (e) {
                    return <Observable<ColorTheme>><any>_observableThrow(e);
                }
            } else
                return <Observable<ColorTheme>><any>_observableThrow(response_);
        }));
    }

    protected processGetByTag(response: HttpResponseBase): Observable<ColorTheme> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ColorTheme.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ColorTheme>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultColorTheme() : Observable<ColorTheme> {
        let url_ = this.baseUrl + "/api/services/app/ThemeService/GetDefaultColorTheme";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultColorTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultColorTheme(<any>response_);
                } catch (e) {
                    return <Observable<ColorTheme>><any>_observableThrow(e);
                }
            } else
                return <Observable<ColorTheme>><any>_observableThrow(response_);
        }));
    }

    protected processGetDefaultColorTheme(response: HttpResponseBase): Observable<ColorTheme> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ColorTheme.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ColorTheme>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonate(body: ImpersonateInput | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticateMobileUser(body: AuthenticateMobileUserModel | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateMobileUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateMobileUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateMobileUser(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateMobileUser(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticateMobileUserInTenant(body: AuthenticateMobileUserModel | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateMobileUserInTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateMobileUserInTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateMobileUserInTenant(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateMobileUserInTenant(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders() : Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined) : Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }
}

@Injectable()
export class TransactionServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    get(paymentId: number | undefined) : Observable<TransactionDetails> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/Get?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TransactionDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TransactionDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDetails>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    getReceipt(paymentId: number | undefined) : Observable<ReceiptDetails> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/GetReceipt?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceipt(<any>response_);
                } catch (e) {
                    return <Observable<ReceiptDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiptDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetReceipt(response: HttpResponseBase): Observable<ReceiptDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDetails>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param roleName (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDeletedUsers(roleName: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<GetDeletedUsersQueryResult> {
        let url_ = this.baseUrl + "/api/services/app/User/GetDeletedUsers?";
        if (roleName !== undefined && roleName !== null)
            url_ += "RoleName=" + encodeURIComponent("" + roleName) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeletedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeletedUsers(<any>response_);
                } catch (e) {
                    return <Observable<GetDeletedUsersQueryResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeletedUsersQueryResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeletedUsers(response: HttpResponseBase): Observable<GetDeletedUsersQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeletedUsersQueryResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeletedUsersQueryResult>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    restoreUser(id: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/RestoreUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreUser(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRestoreUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    addAdminRole(userId: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/AddAdminRole?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAdminRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAdminRole(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddAdminRole(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    removeAdminRole(userId: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/RemoveAdminRole?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAdminRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAdminRole(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveAdminRole(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserRoles(userId: number | undefined) : Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserRoles?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    upload(path: string | null | undefined) : Observable<UploadResponse> {
        let url_ = this.baseUrl + "/api/services/app/User/Upload?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<UploadResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<UploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadResponse>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    isUserLoginAllowed(email: string | null | undefined) : Observable<AvailableTenant[]> {
        let url_ = this.baseUrl + "/api/services/app/User/IsUserLoginAllowed?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserLoginAllowed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserLoginAllowed(<any>response_);
                } catch (e) {
                    return <Observable<AvailableTenant[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailableTenant[]>><any>_observableThrow(response_);
        }));
    }

    protected processIsUserLoginAllowed(response: HttpResponseBase): Observable<AvailableTenant[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AvailableTenant.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailableTenant[]>(<any>null);
    }

    /**
     * @return Success
     */
    getChangelogLastDisplayedVersion() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/GetChangelogLastDisplayedVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangelogLastDisplayedVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangelogLastDisplayedVersion(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetChangelogLastDisplayedVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param version (optional) 
     * @return Success
     */
    updateChangelogLastDisplayedVersion(version: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateChangelogLastDisplayedVersion?";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateChangelogLastDisplayedVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChangelogLastDisplayedVersion(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateChangelogLastDisplayedVersion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    isTourVisualized(name: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/IsTourVisualized?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTourVisualized(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTourVisualized(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsTourVisualized(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    markTourAsVisualized(name: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/MarkTourAsVisualized?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkTourAsVisualized(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkTourAsVisualized(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processMarkTourAsVisualized(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserPermissions(userId: number | undefined) : Observable<PermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissions?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPermissions(response: HttpResponseBase): Observable<PermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsRequest | undefined) : Observable<PermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<PermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetUserPermissions(body: ResetUserPermissionsRequest | undefined) : Observable<PermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserPermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processResetUserPermissions(response: HttpResponseBase): Observable<PermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined) : Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * Will reach for invitation of Doctor, Employee, Patient or when an user try to access a shared link
     * @param body (optional) 
     * @return Success
     */
    register(body: CreateUserDto | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/services/app/User/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMobileUser(body: CreateMobileUserDto | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateMobileUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMobileUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMobileUser(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMobileUser(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param amount (optional) 
     * @return Success
     */
    checkOverLimit(amount: number | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/CheckOverLimit?";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOverLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOverLimit(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckOverLimit(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param cPF (optional) 
     * @return Success
     */
    getUserByCPF(cPF: string | null | undefined) : Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserByCPF?";
        if (cPF !== undefined && cPF !== null)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByCPF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByCPF(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserByCPF(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserById(id: number | undefined) : Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined) : Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserDto | undefined) : Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRoles() : Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<RoleDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getUsersChat() : Observable<UserChat[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersChat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersChat(<any>response_);
                } catch (e) {
                    return <Observable<UserChat[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserChat[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersChat(response: HttpResponseBase): Observable<UserChat[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserChat.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserChat[]>(<any>null);
    }

    /**
     * @return Success
     */
    getToken() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/GetToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    completeWelcomeWizard() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CompleteWelcomeWizard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteWelcomeWizard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteWelcomeWizard(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteWelcomeWizard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    completeWizardOnboarding() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CompleteWizardOnboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteWizardOnboarding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteWizardOnboarding(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteWizardOnboarding(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getChatConnectionInfo() : Observable<ChatConnectionInfo> {
        let url_ = this.baseUrl + "/api/services/app/User/GetChatConnectionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatConnectionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatConnectionInfo(<any>response_);
                } catch (e) {
                    return <Observable<ChatConnectionInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChatConnectionInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetChatConnectionInfo(response: HttpResponseBase): Observable<ChatConnectionInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatConnectionInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatConnectionInfo>(<any>null);
    }

    /**
     * @return Success
     */
    getInfo() : Observable<UserInfo> {
        let url_ = this.baseUrl + "/api/services/app/User/GetInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(<any>response_);
                } catch (e) {
                    return <Observable<UserInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<UserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInfo(body: UpdateUserInfoRequest | undefined) : Observable<UpdateUserInfoResponse> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInfo(<any>response_);
                } catch (e) {
                    return <Observable<UpdateUserInfoResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateUserInfoResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateInfo(response: HttpResponseBase): Observable<UpdateUserInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserInfoResponse>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    confirmEmail(code: string | null | undefined) : Observable<UserInfo> {
        let url_ = this.baseUrl + "/api/services/app/User/ConfirmEmail?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(<any>response_);
                } catch (e) {
                    return <Observable<UserInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfo>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<UserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfo>(<any>null);
    }

    /**
     * @param code (optional) 
     * @param phone (optional) 
     * @return Success
     */
    confirmPhoneNumber(code: string | null | undefined, phone: string | null | undefined) : Observable<UserInfo> {
        let url_ = this.baseUrl + "/api/services/app/User/ConfirmPhoneNumber?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<UserInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfo>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmPhoneNumber(response: HttpResponseBase): Observable<UserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startResetPassword(body: StartResetPasswordRequest | undefined) : Observable<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/api/services/app/User/StartResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordResponse>><any>_observableThrow(response_);
        }));
    }

    protected processStartResetPassword(response: HttpResponseBase): Observable<ResetPasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateResetPasswordCode(body: ValidateResetPasswordCodeInput | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ValidateResetPasswordCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateResetPasswordCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateResetPasswordCode(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidateResetPasswordCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeResetPassword(body: CompleteResetPasswordRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CompleteResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getForgotPasswordConfirm(token: string | null | undefined) : Observable<ForgotPasswordConfirm> {
        let url_ = this.baseUrl + "/api/services/app/User/GetForgotPasswordConfirm?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForgotPasswordConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForgotPasswordConfirm(<any>response_);
                } catch (e) {
                    return <Observable<ForgotPasswordConfirm>><any>_observableThrow(e);
                }
            } else
                return <Observable<ForgotPasswordConfirm>><any>_observableThrow(response_);
        }));
    }

    protected processGetForgotPasswordConfirm(response: HttpResponseBase): Observable<ForgotPasswordConfirm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForgotPasswordConfirm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForgotPasswordConfirm>(<any>null);
    }

    /**
     * @param password (optional) 
     * @return Success
     */
    validatePassword(password: string | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ValidatePassword?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processValidatePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeEmail(body: ChangeEmailRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param user (optional) 
     * @return Success
     */
    getAvatar(user: string | null | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAvatar?";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvatar(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvatar(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param userNameOrEmailAddress (optional) 
     * @param password (optional) 
     * @return Success
     */
    loginUser(userNameOrEmailAddress: string | null | undefined, password: string | null | undefined) : Observable<TenantUserAbpLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/User/LoginUser?";
        if (userNameOrEmailAddress !== undefined && userNameOrEmailAddress !== null)
            url_ += "userNameOrEmailAddress=" + encodeURIComponent("" + userNameOrEmailAddress) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginUser(<any>response_);
                } catch (e) {
                    return <Observable<TenantUserAbpLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantUserAbpLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processLoginUser(response: HttpResponseBase): Observable<TenantUserAbpLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantUserAbpLoginResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantUserAbpLoginResult>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param forceTenantCheck (optional) 
     * @param updateLastTenantLogin (optional) 
     * @return Success
     */
    loginUserInTenant(userId: number | undefined, tenantId: number | null | undefined, forceTenantCheck: boolean | undefined, updateLastTenantLogin: boolean | undefined) : Observable<TenantUserAbpLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/User/LoginUserInTenant?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (forceTenantCheck === null)
            throw new Error("The parameter 'forceTenantCheck' cannot be null.");
        else if (forceTenantCheck !== undefined)
            url_ += "forceTenantCheck=" + encodeURIComponent("" + forceTenantCheck) + "&";
        if (updateLastTenantLogin === null)
            throw new Error("The parameter 'updateLastTenantLogin' cannot be null.");
        else if (updateLastTenantLogin !== undefined)
            url_ += "updateLastTenantLogin=" + encodeURIComponent("" + updateLastTenantLogin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginUserInTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginUserInTenant(<any>response_);
                } catch (e) {
                    return <Observable<TenantUserAbpLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantUserAbpLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processLoginUserInTenant(response: HttpResponseBase): Observable<TenantUserAbpLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantUserAbpLoginResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantUserAbpLoginResult>(<any>null);
    }

    /**
     * Autenticar paciente
     * @param userNameOrEmailAddress (optional) E-mail usado na hora de cadastrar o paciente
     * @param password (optional) Senha utilizada na hora de cadastrar o paciente
     * @return Success
     */
    authenticateMobileUser(userNameOrEmailAddress: string | null | undefined, password: string | null | undefined) : Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/services/app/User/AuthenticateMobileUser?";
        if (userNameOrEmailAddress !== undefined && userNameOrEmailAddress !== null)
            url_ += "userNameOrEmailAddress=" + encodeURIComponent("" + userNameOrEmailAddress) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateMobileUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateMobileUser(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateMobileUser(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * Validate if the email address is available
     * @param email (optional) 
     * @return Success
     */
    validateEmail(email: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ValidateEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidateEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param email (optional) 
     * @param code (optional) 
     * @return Success
     */
    validateCode(email: string | null | undefined, code: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ValidateCode?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCode(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidateCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    loginEnabledForEmail(email: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/LoginEnabledForEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginEnabledForEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginEnabledForEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processLoginEnabledForEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Validate if the email address is already registered, if it's but have no access to tenant, then set it
     * @param email (optional) 
     * @param mobileProjectId (optional) 
     * @return Success
     */
    validateEmailForMobileProject(email: string | null | undefined, mobileProjectId: string | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ValidateEmailForMobileProject?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (mobileProjectId === null)
            throw new Error("The parameter 'mobileProjectId' cannot be null.");
        else if (mobileProjectId !== undefined)
            url_ += "mobileProjectId=" + encodeURIComponent("" + mobileProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateEmailForMobileProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEmailForMobileProject(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processValidateEmailForMobileProject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    validateEmailForTenant(email: string | null | undefined, tenantId: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ValidateEmailForTenant?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateEmailForTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEmailForTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processValidateEmailForTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param phone (optional) 
     * @param mobileProject (optional) 
     * @return Success
     */
    validatePhone(phone: string | null | undefined, mobileProject: string | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ValidatePhone?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (mobileProject === null)
            throw new Error("The parameter 'mobileProject' cannot be null.");
        else if (mobileProject !== undefined)
            url_ += "mobileProject=" + encodeURIComponent("" + mobileProject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePhone(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidatePhone(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param phone (optional) 
     * @param code (optional) 
     * @return Success
     */
    validatePhoneCode(phone: string | null | undefined, code: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ValidatePhoneCode?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePhoneCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePhoneCode(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidatePhoneCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Validate if the Id (Email address or Personal ID) is available
     * @param body (optional) 
     * @return Success
     */
    isAvailable(body: IsUserIdAvailableQuery | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/IsAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAvailable(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    deleteAccount() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param role (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(role: string | null | undefined, keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined) : Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(<any>null);
    }
}

@Injectable()
export class UserAvatarServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param path (optional) 
     * @param userId (optional) 
     * @return Success
     */
    update(path: string | null | undefined, userId: number | undefined) : Observable<UpdateUserAvatarResponse> {
        let url_ = this.baseUrl + "/api/services/app/UserAvatar/Update?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UpdateUserAvatarResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateUserAvatarResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateUserAvatarResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserAvatarResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserAvatarResponse>(<any>null);
    }

    /**
     * @param user (optional) 
     * @return Success
     */
    get(user: string | null | undefined) : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UserAvatar/Get?";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class VidaasSignatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    confirmQrCodeAuthorization(code: string | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/VidaasSignature/ConfirmQrCodeAuthorization?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmQrCodeAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmQrCodeAuthorization(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmQrCodeAuthorization(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getQrCodeUrl() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/VidaasSignature/GetQrCodeUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQrCodeUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQrCodeUrl(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetQrCodeUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getSessionInfo() : Observable<GetSessionInfoResponse> {
        let url_ = this.baseUrl + "/api/services/app/VidaasSignature/GetSessionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetSessionInfoResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSessionInfoResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSessionInfo(response: HttpResponseBase): Observable<GetSessionInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSessionInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSessionInfoResponse>(<any>null);
    }

    /**
     * @return Success
     */
    disconnect() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/VidaasSignature/Disconnect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnect(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDisconnect(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class WizardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getApplicationLogo() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/GetApplicationLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetApplicationLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getSiteConfig() : Observable<MobileProjectStructureDto> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/GetSiteConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiteConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiteConfig(<any>response_);
                } catch (e) {
                    return <Observable<MobileProjectStructureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MobileProjectStructureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSiteConfig(response: HttpResponseBase): Observable<MobileProjectStructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileProjectStructureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileProjectStructureDto>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    downloadQrCodeLinks(tenantId: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/DownloadQrCodeLinks?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadQrCodeLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadQrCodeLinks(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadQrCodeLinks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    mobileProjectStructureGet(projectId: string | undefined) : Observable<GetMobileProjectStructureResult> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/MobileProjectStructure?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileProjectStructureGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileProjectStructureGet(<any>response_);
                } catch (e) {
                    return <Observable<GetMobileProjectStructureResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMobileProjectStructureResult>><any>_observableThrow(response_);
        }));
    }

    protected processMobileProjectStructureGet(response: HttpResponseBase): Observable<GetMobileProjectStructureResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMobileProjectStructureResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMobileProjectStructureResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mobileProjectStructurePatch(body: UpdateMobileProjectStructureCommand | undefined) : Observable<GetMobileProjectStructureResult> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/MobileProjectStructure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileProjectStructurePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileProjectStructurePatch(<any>response_);
                } catch (e) {
                    return <Observable<GetMobileProjectStructureResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMobileProjectStructureResult>><any>_observableThrow(response_);
        }));
    }

    protected processMobileProjectStructurePatch(response: HttpResponseBase): Observable<GetMobileProjectStructureResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMobileProjectStructureResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMobileProjectStructureResult>(<any>null);
    }

    /**
     * @return Success
     */
    getAccountModule() : Observable<AccountAppModule> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/GetAccountModule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountModule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountModule(<any>response_);
                } catch (e) {
                    return <Observable<AccountAppModule>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountAppModule>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountModule(response: HttpResponseBase): Observable<AccountAppModule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountAppModule.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountAppModule>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAccountModule(body: UpdateAccountModuleCommand | undefined) : Observable<AccountAppModule> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/UpdateAccountModule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccountModule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountModule(<any>response_);
                } catch (e) {
                    return <Observable<AccountAppModule>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountAppModule>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAccountModule(response: HttpResponseBase): Observable<AccountAppModule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountAppModule.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountAppModule>(<any>null);
    }

    /**
     * @return Success
     */
    mobileProjectId() : Observable<PwaDefinition> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/MobileProjectId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileProjectId(<any>response_);
                } catch (e) {
                    return <Observable<PwaDefinition>><any>_observableThrow(e);
                }
            } else
                return <Observable<PwaDefinition>><any>_observableThrow(response_);
        }));
    }

    protected processMobileProjectId(response: HttpResponseBase): Observable<PwaDefinition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PwaDefinition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PwaDefinition>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param bundleId (optional) 
     * @param teamId (optional) 
     * @param keyId (optional) 
     * @param token (optional) 
     * @param fcmServiceAccountFile (optional) 
     * @return Success
     */
    updateRemoteNotificationSettings(tenantId: number | undefined, bundleId: string | null | undefined, teamId: string | null | undefined, keyId: string | null | undefined, token: string | null | undefined, fcmServiceAccountFile: FileParameter | null | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/UpdateRemoteNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (tenantId === null || tenantId === undefined)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else
            content_.append("tenantId", tenantId.toString());
        if (bundleId !== null && bundleId !== undefined)
            content_.append("BundleId", bundleId.toString());
        if (teamId !== null && teamId !== undefined)
            content_.append("TeamId", teamId.toString());
        if (keyId !== null && keyId !== undefined)
            content_.append("KeyId", keyId.toString());
        if (token !== null && token !== undefined)
            content_.append("Token", token.toString());
        if (fcmServiceAccountFile !== null && fcmServiceAccountFile !== undefined)
            content_.append("fcmServiceAccountFile", fcmServiceAccountFile.data, fcmServiceAccountFile.fileName ? fcmServiceAccountFile.fileName : "fcmServiceAccountFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRemoteNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRemoteNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRemoteNotificationSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    mobileProjectBuildConfig(tenantId: number | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/MobileProjectBuildConfig?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileProjectBuildConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileProjectBuildConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMobileProjectBuildConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateMobileProjectBuildConfig(tenantId: number | undefined, body: any | null | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/UpdateMobileProjectBuildConfig?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMobileProjectBuildConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMobileProjectBuildConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMobileProjectBuildConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    hasApplication() : Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/HasApplication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasApplication(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHasApplication(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    get() : Observable<WizardDto> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<WizardDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WizardDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WizardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WizardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WizardDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBase64ApplicationLogo() : Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/GetBase64ApplicationLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBase64ApplicationLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBase64ApplicationLogo(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetBase64ApplicationLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getMobileProjectStructure(projectId: string | undefined) : Observable<MobileProjectStructureDto> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/GetMobileProjectStructure?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMobileProjectStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileProjectStructure(<any>response_);
                } catch (e) {
                    return <Observable<MobileProjectStructureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MobileProjectStructureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMobileProjectStructure(response: HttpResponseBase): Observable<MobileProjectStructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileProjectStructureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileProjectStructureDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMobileAppInfo() : Observable<CacheMobileAppInfo> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/GetMobileAppInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMobileAppInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileAppInfo(<any>response_);
                } catch (e) {
                    return <Observable<CacheMobileAppInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<CacheMobileAppInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetMobileAppInfo(response: HttpResponseBase): Observable<CacheMobileAppInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CacheMobileAppInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CacheMobileAppInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDefaultApp(body: Tenant | undefined) : Observable<MobileProject> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/CreateDefaultApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDefaultApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDefaultApp(<any>response_);
                } catch (e) {
                    return <Observable<MobileProject>><any>_observableThrow(e);
                }
            } else
                return <Observable<MobileProject>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDefaultApp(response: HttpResponseBase): Observable<MobileProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileProject.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileProject>(<any>null);
    }

    /**
     * @return Success
     */
    getFeatures() : Observable<FeatureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/GetFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatures(<any>response_);
                } catch (e) {
                    return <Observable<FeatureDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeatureDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFeatures(response: HttpResponseBase): Observable<FeatureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FeatureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FeatureDto | undefined) : Observable<FeatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FeatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureDto>(<any>null);
    }

    /**
     * @return Success
     */
    getStoreInfoNomenclators() : Observable<StoreInfoNomenclators> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/GetStoreInfoNomenclators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreInfoNomenclators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreInfoNomenclators(<any>response_);
                } catch (e) {
                    return <Observable<StoreInfoNomenclators>><any>_observableThrow(e);
                }
            } else
                return <Observable<StoreInfoNomenclators>><any>_observableThrow(response_);
        }));
    }

    protected processGetStoreInfoNomenclators(response: HttpResponseBase): Observable<StoreInfoNomenclators> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreInfoNomenclators.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreInfoNomenclators>(<any>null);
    }

    /**
     * @return Success
     */
    completeWizard() : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/CompleteWizard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteWizard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteWizard(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteWizard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStoreLinks(body: UpdateStoreLinkCommand | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/UpdateStoreLinks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStoreLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStoreLinks(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStoreLinks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateQrCodeLinks(body: GenerateQrCodeLinkCommand | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wizard/GenerateQrCodeLinks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQrCodeLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQrCodeLinks(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateQrCodeLinks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class GetMedicalAppointmentPreProcedureFormRequest implements IGetMedicalAppointmentPreProcedureFormRequest {
    id: string;
    code: string | undefined;

    constructor(data?: IGetMedicalAppointmentPreProcedureFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): GetMedicalAppointmentPreProcedureFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalAppointmentPreProcedureFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        return data; 
    }

    clone(): GetMedicalAppointmentPreProcedureFormRequest {
        const json = this.toJSON();
        let result = new GetMedicalAppointmentPreProcedureFormRequest();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalAppointmentPreProcedureFormRequest {
    id: string;
    code: string | undefined;
}

export class GetMedicalAppointmentPreProcedureFormResponse implements IGetMedicalAppointmentPreProcedureFormResponse {
    id: number;
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    allowAnswer: boolean;

    constructor(data?: IGetMedicalAppointmentPreProcedureFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            this.allowAnswer = _data["allowAnswer"];
        }
    }

    static fromJS(data: any): GetMedicalAppointmentPreProcedureFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalAppointmentPreProcedureFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        data["allowAnswer"] = this.allowAnswer;
        return data; 
    }

    clone(): GetMedicalAppointmentPreProcedureFormResponse {
        const json = this.toJSON();
        let result = new GetMedicalAppointmentPreProcedureFormResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalAppointmentPreProcedureFormResponse {
    id: number;
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    allowAnswer: boolean;
}

export class CollectMedicalAppointmentPreProcedureFormRequest implements ICollectMedicalAppointmentPreProcedureFormRequest {
    id: string;
    formId: number;
    response: string;

    constructor(data?: ICollectMedicalAppointmentPreProcedureFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formId = _data["formId"];
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): CollectMedicalAppointmentPreProcedureFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CollectMedicalAppointmentPreProcedureFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formId"] = this.formId;
        data["response"] = this.response;
        return data; 
    }

    clone(): CollectMedicalAppointmentPreProcedureFormRequest {
        const json = this.toJSON();
        let result = new CollectMedicalAppointmentPreProcedureFormRequest();
        result.init(json);
        return result;
    }
}

export interface ICollectMedicalAppointmentPreProcedureFormRequest {
    id: string;
    formId: number;
    response: string;
}

export class GetMedicalAppointmentPreProcedureFormAnswerRequest implements IGetMedicalAppointmentPreProcedureFormAnswerRequest {
    responseId: number;

    constructor(data?: IGetMedicalAppointmentPreProcedureFormAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseId = _data["responseId"];
        }
    }

    static fromJS(data: any): GetMedicalAppointmentPreProcedureFormAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalAppointmentPreProcedureFormAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseId"] = this.responseId;
        return data; 
    }

    clone(): GetMedicalAppointmentPreProcedureFormAnswerRequest {
        const json = this.toJSON();
        let result = new GetMedicalAppointmentPreProcedureFormAnswerRequest();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalAppointmentPreProcedureFormAnswerRequest {
    responseId: number;
}

export class FormAnswer implements IFormAnswer {
    fieldId: string | undefined;
    fieldType: string | undefined;
    label: string | undefined;
    required: boolean;
    answer: string | undefined;
    answerValue: any | undefined;
    creationTime: moment.Moment;

    constructor(data?: IFormAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.fieldType = _data["fieldType"];
            this.label = _data["label"];
            this.required = _data["required"];
            this.answer = _data["answer"];
            this.answerValue = _data["answerValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FormAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new FormAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["fieldType"] = this.fieldType;
        data["label"] = this.label;
        data["required"] = this.required;
        data["answer"] = this.answer;
        data["answerValue"] = this.answerValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): FormAnswer {
        const json = this.toJSON();
        let result = new FormAnswer();
        result.init(json);
        return result;
    }
}

export interface IFormAnswer {
    fieldId: string | undefined;
    fieldType: string | undefined;
    label: string | undefined;
    required: boolean;
    answer: string | undefined;
    answerValue: any | undefined;
    creationTime: moment.Moment;
}

export class Address implements IAddress {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    latitude: number;
    longitude: number;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postalCode = _data["postalCode"];
            this.formattedAddress = _data["formattedAddress"];
            this.reference = _data["reference"];
            this.complement = _data["complement"];
            this.number = _data["number"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postalCode"] = this.postalCode;
        data["formattedAddress"] = this.formattedAddress;
        data["reference"] = this.reference;
        data["complement"] = this.complement;
        data["number"] = this.number;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    latitude: number;
    longitude: number;
}

export class PatientInsurance implements IPatientInsurance {
    id: number | undefined;
    isCompany: boolean | undefined;
    number: string | undefined;

    constructor(data?: IPatientInsurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCompany = _data["isCompany"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): PatientInsurance {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInsurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCompany"] = this.isCompany;
        data["number"] = this.number;
        return data; 
    }

    clone(): PatientInsurance {
        const json = this.toJSON();
        let result = new PatientInsurance();
        result.init(json);
        return result;
    }
}

export interface IPatientInsurance {
    id: number | undefined;
    isCompany: boolean | undefined;
    number: string | undefined;
}

export class PatientNameInfo implements IPatientNameInfo {
    id: string;
    userId: number | undefined;
    name: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    gender: number;
    address: Address;
    birthday: moment.Moment | undefined;
    insurance: PatientInsurance;
    profession: string | undefined;
    sequentialNumber: number;
    billingAddress: Address;

    constructor(data?: IPatientNameInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.dni = _data["dni"];
            this.gender = _data["gender"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.insurance = _data["insurance"] ? PatientInsurance.fromJS(_data["insurance"]) : <any>undefined;
            this.profession = _data["profession"];
            this.sequentialNumber = _data["sequentialNumber"];
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientNameInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PatientNameInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["personalIdentifier"] = this.personalIdentifier;
        data["dni"] = this.dni;
        data["gender"] = this.gender;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>undefined;
        data["profession"] = this.profession;
        data["sequentialNumber"] = this.sequentialNumber;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        return data; 
    }

    clone(): PatientNameInfo {
        const json = this.toJSON();
        let result = new PatientNameInfo();
        result.init(json);
        return result;
    }
}

export interface IPatientNameInfo {
    id: string;
    userId: number | undefined;
    name: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    gender: number;
    address: Address;
    birthday: moment.Moment | undefined;
    insurance: PatientInsurance;
    profession: string | undefined;
    sequentialNumber: number;
    billingAddress: Address;
}

export class GetMedicalAppointmentPreProcedureFormAnswerResponse implements IGetMedicalAppointmentPreProcedureFormAnswerResponse {
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    answers: FormAnswer[] | undefined;
    allowViewOnMedicalRecord: boolean;
    patient: PatientNameInfo;

    constructor(data?: IGetMedicalAppointmentPreProcedureFormAnswerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers.push(FormAnswer.fromJS(item));
            }
            this.allowViewOnMedicalRecord = _data["allowViewOnMedicalRecord"];
            this.patient = _data["patient"] ? PatientNameInfo.fromJS(_data["patient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMedicalAppointmentPreProcedureFormAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalAppointmentPreProcedureFormAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["allowViewOnMedicalRecord"] = this.allowViewOnMedicalRecord;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetMedicalAppointmentPreProcedureFormAnswerResponse {
        const json = this.toJSON();
        let result = new GetMedicalAppointmentPreProcedureFormAnswerResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalAppointmentPreProcedureFormAnswerResponse {
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    answers: FormAnswer[] | undefined;
    allowViewOnMedicalRecord: boolean;
    patient: PatientNameInfo;
}

export class FinancialAccountDto implements IFinancialAccountDto {
    id: number;
    name: string | undefined;

    constructor(data?: IFinancialAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FinancialAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): FinancialAccountDto {
        const json = this.toJSON();
        let result = new FinancialAccountDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialAccountDto {
    id: number;
    name: string | undefined;
}

export class FinancialIncomingChannelDto implements IFinancialIncomingChannelDto {
    id: number;
    type: number;

    constructor(data?: IFinancialIncomingChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): FinancialIncomingChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialIncomingChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data; 
    }

    clone(): FinancialIncomingChannelDto {
        const json = this.toJSON();
        let result = new FinancialIncomingChannelDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialIncomingChannelDto {
    id: number;
    type: number;
}

export class GetPaymentOptionsResult implements IGetPaymentOptionsResult {
    accounts: FinancialAccountDto[] | undefined;
    incomingChannels: FinancialIncomingChannelDto[] | undefined;

    constructor(data?: IGetPaymentOptionsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts.push(FinancialAccountDto.fromJS(item));
            }
            if (Array.isArray(_data["incomingChannels"])) {
                this.incomingChannels = [] as any;
                for (let item of _data["incomingChannels"])
                    this.incomingChannels.push(FinancialIncomingChannelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPaymentOptionsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentOptionsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        if (Array.isArray(this.incomingChannels)) {
            data["incomingChannels"] = [];
            for (let item of this.incomingChannels)
                data["incomingChannels"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetPaymentOptionsResult {
        const json = this.toJSON();
        let result = new GetPaymentOptionsResult();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentOptionsResult {
    accounts: FinancialAccountDto[] | undefined;
    incomingChannels: FinancialIncomingChannelDto[] | undefined;
}

export class MarkMedicalAppointmentAsPayedRequest implements IMarkMedicalAppointmentAsPayedRequest {
    id: string;
    channelId: number;
    accountId: number;
    date: moment.Moment;

    constructor(data?: IMarkMedicalAppointmentAsPayedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channelId = _data["channelId"];
            this.accountId = _data["accountId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarkMedicalAppointmentAsPayedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkMedicalAppointmentAsPayedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channelId"] = this.channelId;
        data["accountId"] = this.accountId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }

    clone(): MarkMedicalAppointmentAsPayedRequest {
        const json = this.toJSON();
        let result = new MarkMedicalAppointmentAsPayedRequest();
        result.init(json);
        return result;
    }
}

export interface IMarkMedicalAppointmentAsPayedRequest {
    id: string;
    channelId: number;
    accountId: number;
    date: moment.Moment;
}

export class MedicalAppointmentProcedureResponsibilityTerm implements IMedicalAppointmentProcedureResponsibilityTerm {
    medicalProcedureResponsibilityTermId: number;
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    signedDocumentId: string | undefined;
    id: number;

    constructor(data?: IMedicalAppointmentProcedureResponsibilityTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalProcedureResponsibilityTermId = _data["medicalProcedureResponsibilityTermId"];
            this.title = _data["title"];
            this.documentUrl = _data["documentUrl"];
            this.signatureRequiredOnlyOnce = _data["signatureRequiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
            this.signedDocumentId = _data["signedDocumentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalAppointmentProcedureResponsibilityTerm {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentProcedureResponsibilityTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalProcedureResponsibilityTermId"] = this.medicalProcedureResponsibilityTermId;
        data["title"] = this.title;
        data["documentUrl"] = this.documentUrl;
        data["signatureRequiredOnlyOnce"] = this.signatureRequiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        data["signedDocumentId"] = this.signedDocumentId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalAppointmentProcedureResponsibilityTerm {
        const json = this.toJSON();
        let result = new MedicalAppointmentProcedureResponsibilityTerm();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentProcedureResponsibilityTerm {
    medicalProcedureResponsibilityTermId: number;
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    signedDocumentId: string | undefined;
    id: number;
}

export class MedicalAppointmentProcedurePreForm implements IMedicalAppointmentProcedurePreForm {
    title: string | undefined;
    link: string | undefined;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    responseId: number | undefined;
    id: number;

    constructor(data?: IMedicalAppointmentProcedurePreForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.link = _data["link"];
            this.requiredOnlyOnce = _data["requiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
            this.responseId = _data["responseId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalAppointmentProcedurePreForm {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentProcedurePreForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["link"] = this.link;
        data["requiredOnlyOnce"] = this.requiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        data["responseId"] = this.responseId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalAppointmentProcedurePreForm {
        const json = this.toJSON();
        let result = new MedicalAppointmentProcedurePreForm();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentProcedurePreForm {
    title: string | undefined;
    link: string | undefined;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    responseId: number | undefined;
    id: number;
}

export class CreatorUser implements ICreatorUser {
    id: number;
    fullName: string | undefined;

    constructor(data?: ICreatorUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): CreatorUser {
        data = typeof data === 'object' ? data : {};
        let result = new CreatorUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        return data; 
    }

    clone(): CreatorUser {
        const json = this.toJSON();
        let result = new CreatorUser();
        result.init(json);
        return result;
    }
}

export interface ICreatorUser {
    id: number;
    fullName: string | undefined;
}

export enum PaymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ConfirmationChannel {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class PatientConfirmation implements IPatientConfirmation {
    confirmed: boolean | undefined;
    channel: ConfirmationChannel;

    constructor(data?: IPatientConfirmation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmed = _data["confirmed"];
            this.channel = _data["channel"];
        }
    }

    static fromJS(data: any): PatientConfirmation {
        data = typeof data === 'object' ? data : {};
        let result = new PatientConfirmation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmed"] = this.confirmed;
        data["channel"] = this.channel;
        return data; 
    }

    clone(): PatientConfirmation {
        const json = this.toJSON();
        let result = new PatientConfirmation();
        result.init(json);
        return result;
    }
}

export interface IPatientConfirmation {
    confirmed: boolean | undefined;
    channel: ConfirmationChannel;
}

export class LicenceNumber implements ILicenceNumber {
    number: string | undefined;
    agency: string | undefined;
    state: string | undefined;

    constructor(data?: ILicenceNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.agency = _data["agency"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): LicenceNumber {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["agency"] = this.agency;
        data["state"] = this.state;
        return data; 
    }

    clone(): LicenceNumber {
        const json = this.toJSON();
        let result = new LicenceNumber();
        result.init(json);
        return result;
    }
}

export interface ILicenceNumber {
    number: string | undefined;
    agency: string | undefined;
    state: string | undefined;
}

export class DoctorSpecialtyCacheItem implements IDoctorSpecialtyCacheItem {
    specialty: number;
    duration: number | undefined;
    price: number | undefined;
    title: string | undefined;

    constructor(data?: IDoctorSpecialtyCacheItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialty = _data["specialty"];
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): DoctorSpecialtyCacheItem {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorSpecialtyCacheItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialty"] = this.specialty;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["title"] = this.title;
        return data; 
    }

    clone(): DoctorSpecialtyCacheItem {
        const json = this.toJSON();
        let result = new DoctorSpecialtyCacheItem();
        result.init(json);
        return result;
    }
}

export interface IDoctorSpecialtyCacheItem {
    specialty: number;
    duration: number | undefined;
    price: number | undefined;
    title: string | undefined;
}

export class DoctorInfo implements IDoctorInfo {
    id: string;
    userId: number;
    name: string | undefined;
    licenceNumber: LicenceNumber;
    specialty: DoctorSpecialtyCacheItem;
    avatar: string | undefined;

    constructor(data?: IDoctorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.licenceNumber = _data["licenceNumber"] ? LicenceNumber.fromJS(_data["licenceNumber"]) : <any>undefined;
            this.specialty = _data["specialty"] ? DoctorSpecialtyCacheItem.fromJS(_data["specialty"]) : <any>undefined;
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): DoctorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["licenceNumber"] = this.licenceNumber ? this.licenceNumber.toJSON() : <any>undefined;
        data["specialty"] = this.specialty ? this.specialty.toJSON() : <any>undefined;
        data["avatar"] = this.avatar;
        return data; 
    }

    clone(): DoctorInfo {
        const json = this.toJSON();
        let result = new DoctorInfo();
        result.init(json);
        return result;
    }
}

export interface IDoctorInfo {
    id: string;
    userId: number;
    name: string | undefined;
    licenceNumber: LicenceNumber;
    specialty: DoctorSpecialtyCacheItem;
    avatar: string | undefined;
}

export class LocalizedAddress implements ILocalizedAddress {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    latitude: number;
    longitude: number;

    constructor(data?: ILocalizedAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postalCode = _data["postalCode"];
            this.formattedAddress = _data["formattedAddress"];
            this.reference = _data["reference"];
            this.complement = _data["complement"];
            this.number = _data["number"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): LocalizedAddress {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postalCode"] = this.postalCode;
        data["formattedAddress"] = this.formattedAddress;
        data["reference"] = this.reference;
        data["complement"] = this.complement;
        data["number"] = this.number;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }

    clone(): LocalizedAddress {
        const json = this.toJSON();
        let result = new LocalizedAddress();
        result.init(json);
        return result;
    }
}

export interface ILocalizedAddress {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    latitude: number;
    longitude: number;
}

export class HealthCareUnitBasicData implements IHealthCareUnitBasicData {
    id: number;
    name: string | undefined;
    isDeleted: boolean;
    address: LocalizedAddress;

    constructor(data?: IHealthCareUnitBasicData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.address = _data["address"] ? LocalizedAddress.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthCareUnitBasicData {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCareUnitBasicData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): HealthCareUnitBasicData {
        const json = this.toJSON();
        let result = new HealthCareUnitBasicData();
        result.init(json);
        return result;
    }
}

export interface IHealthCareUnitBasicData {
    id: number;
    name: string | undefined;
    isDeleted: boolean;
    address: LocalizedAddress;
}

export class ComplementaryProcedureDto implements IComplementaryProcedureDto {
    procedureName: string | undefined;
    appointmentId: string;
    procedureId: number;
    price: number;

    constructor(data?: IComplementaryProcedureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procedureName = _data["procedureName"];
            this.appointmentId = _data["appointmentId"];
            this.procedureId = _data["procedureId"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ComplementaryProcedureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComplementaryProcedureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["procedureName"] = this.procedureName;
        data["appointmentId"] = this.appointmentId;
        data["procedureId"] = this.procedureId;
        data["price"] = this.price;
        return data; 
    }

    clone(): ComplementaryProcedureDto {
        const json = this.toJSON();
        let result = new ComplementaryProcedureDto();
        result.init(json);
        return result;
    }
}

export interface IComplementaryProcedureDto {
    procedureName: string | undefined;
    appointmentId: string;
    procedureId: number;
    price: number;
}

export class DoctorSpecialty implements IDoctorSpecialty {
    code: number;
    name: string | undefined;
    registry: string | undefined;

    constructor(data?: IDoctorSpecialty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.registry = _data["registry"];
        }
    }

    static fromJS(data: any): DoctorSpecialty {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorSpecialty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["registry"] = this.registry;
        return data; 
    }

    clone(): DoctorSpecialty {
        const json = this.toJSON();
        let result = new DoctorSpecialty();
        result.init(json);
        return result;
    }
}

export interface IDoctorSpecialty {
    code: number;
    name: string | undefined;
    registry: string | undefined;
}

export class MedicalProfessionSpecialty implements IMedicalProfessionSpecialty {
    id: number;
    title: string | undefined;
    agency: string | undefined;
    specialtyRegistry: DoctorSpecialty[] | undefined;

    constructor(data?: IMedicalProfessionSpecialty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.agency = _data["agency"];
            if (Array.isArray(_data["specialtyRegistry"])) {
                this.specialtyRegistry = [] as any;
                for (let item of _data["specialtyRegistry"])
                    this.specialtyRegistry.push(DoctorSpecialty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicalProfessionSpecialty {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProfessionSpecialty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["agency"] = this.agency;
        if (Array.isArray(this.specialtyRegistry)) {
            data["specialtyRegistry"] = [];
            for (let item of this.specialtyRegistry)
                data["specialtyRegistry"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MedicalProfessionSpecialty {
        const json = this.toJSON();
        let result = new MedicalProfessionSpecialty();
        result.init(json);
        return result;
    }
}

export interface IMedicalProfessionSpecialty {
    id: number;
    title: string | undefined;
    agency: string | undefined;
    specialtyRegistry: DoctorSpecialty[] | undefined;
}

export enum ProcedurePeriodUnit {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class AvailableDateWindow implements IAvailableDateWindow {
    id: string | undefined;
    daysOfWeek: string | undefined;
    rRule: string | undefined;
    startDate: moment.Moment | undefined;
    startTime: string | undefined;
    endDate: moment.Moment | undefined;
    endTime: string | undefined;
    available: boolean;
    comments: string | undefined;
    version: number;

    constructor(data?: IAvailableDateWindow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.daysOfWeek = _data["daysOfWeek"];
            this.rRule = _data["rRule"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.endTime = _data["endTime"];
            this.available = _data["available"];
            this.comments = _data["comments"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): AvailableDateWindow {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableDateWindow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["daysOfWeek"] = this.daysOfWeek;
        data["rRule"] = this.rRule;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endTime"] = this.endTime;
        data["available"] = this.available;
        data["comments"] = this.comments;
        data["version"] = this.version;
        return data; 
    }

    clone(): AvailableDateWindow {
        const json = this.toJSON();
        let result = new AvailableDateWindow();
        result.init(json);
        return result;
    }
}

export interface IAvailableDateWindow {
    id: string | undefined;
    daysOfWeek: string | undefined;
    rRule: string | undefined;
    startDate: moment.Moment | undefined;
    startTime: string | undefined;
    endDate: moment.Moment | undefined;
    endTime: string | undefined;
    available: boolean;
    comments: string | undefined;
    version: number;
}

export class ProfessionalCareUnitBasicInputDto implements IProfessionalCareUnitBasicInputDto {
    id: number;
    name: string | undefined;
    isActive: boolean;
    workJourney: AvailableDateWindow[] | undefined;

    constructor(data?: IProfessionalCareUnitBasicInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["workJourney"])) {
                this.workJourney = [] as any;
                for (let item of _data["workJourney"])
                    this.workJourney.push(AvailableDateWindow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfessionalCareUnitBasicInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalCareUnitBasicInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.workJourney)) {
            data["workJourney"] = [];
            for (let item of this.workJourney)
                data["workJourney"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ProfessionalCareUnitBasicInputDto {
        const json = this.toJSON();
        let result = new ProfessionalCareUnitBasicInputDto();
        result.init(json);
        return result;
    }
}

export interface IProfessionalCareUnitBasicInputDto {
    id: number;
    name: string | undefined;
    isActive: boolean;
    workJourney: AvailableDateWindow[] | undefined;
}

export enum MedicalProcedureOnlinePaymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class MedicalProcedureBasicData implements IMedicalProcedureBasicData {
    name: string | undefined;
    duration: number | undefined;
    price: number;
    allowOnlineSchedule: boolean;
    professionalRequired: boolean;
    periodUnit: ProcedurePeriodUnit;
    derivedProcedures: MedicalProcedureBasicData[] | undefined;
    careUnits: ProfessionalCareUnitBasicInputDto[] | undefined;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    splitPercentage: number | undefined;
    maxNumberOfInstallments: number;
    id: number;

    constructor(data?: IMedicalProcedureBasicData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.allowOnlineSchedule = _data["allowOnlineSchedule"];
            this.professionalRequired = _data["professionalRequired"];
            this.periodUnit = _data["periodUnit"];
            if (Array.isArray(_data["derivedProcedures"])) {
                this.derivedProcedures = [] as any;
                for (let item of _data["derivedProcedures"])
                    this.derivedProcedures.push(MedicalProcedureBasicData.fromJS(item));
            }
            if (Array.isArray(_data["careUnits"])) {
                this.careUnits = [] as any;
                for (let item of _data["careUnits"])
                    this.careUnits.push(ProfessionalCareUnitBasicInputDto.fromJS(item));
            }
            this.onlinePaymentType = _data["onlinePaymentType"];
            this.splitPercentage = _data["splitPercentage"];
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureBasicData {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureBasicData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["allowOnlineSchedule"] = this.allowOnlineSchedule;
        data["professionalRequired"] = this.professionalRequired;
        data["periodUnit"] = this.periodUnit;
        if (Array.isArray(this.derivedProcedures)) {
            data["derivedProcedures"] = [];
            for (let item of this.derivedProcedures)
                data["derivedProcedures"].push(item.toJSON());
        }
        if (Array.isArray(this.careUnits)) {
            data["careUnits"] = [];
            for (let item of this.careUnits)
                data["careUnits"].push(item.toJSON());
        }
        data["onlinePaymentType"] = this.onlinePaymentType;
        data["splitPercentage"] = this.splitPercentage;
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureBasicData {
        const json = this.toJSON();
        let result = new MedicalProcedureBasicData();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureBasicData {
    name: string | undefined;
    duration: number | undefined;
    price: number;
    allowOnlineSchedule: boolean;
    professionalRequired: boolean;
    periodUnit: ProcedurePeriodUnit;
    derivedProcedures: MedicalProcedureBasicData[] | undefined;
    careUnits: ProfessionalCareUnitBasicInputDto[] | undefined;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    splitPercentage: number | undefined;
    maxNumberOfInstallments: number;
    id: number;
}

export class MedicalAgreementInfo implements IMedicalAgreementInfo {
    id: string;
    name: string | undefined;

    constructor(data?: IMedicalAgreementInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MedicalAgreementInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAgreementInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): MedicalAgreementInfo {
        const json = this.toJSON();
        let result = new MedicalAgreementInfo();
        result.init(json);
        return result;
    }
}

export interface IMedicalAgreementInfo {
    id: string;
    name: string | undefined;
}

export class InsurancePlanBasicData implements IInsurancePlanBasicData {
    name: string | undefined;
    price: number | undefined;
    /** Will be used only when generating reports */
    number: string | undefined;
    id: number;

    constructor(data?: IInsurancePlanBasicData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.number = _data["number"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsurancePlanBasicData {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePlanBasicData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["number"] = this.number;
        data["id"] = this.id;
        return data; 
    }

    clone(): InsurancePlanBasicData {
        const json = this.toJSON();
        let result = new InsurancePlanBasicData();
        result.init(json);
        return result;
    }
}

export interface IInsurancePlanBasicData {
    name: string | undefined;
    price: number | undefined;
    /** Will be used only when generating reports */
    number: string | undefined;
    id: number;
}

export class InsuranceCompanyBasicData implements IInsuranceCompanyBasicData {
    name: string | undefined;
    code: string | undefined;
    /** Will be used only when generating reports */
    number: string | undefined;
    insurancePlans: InsurancePlanBasicData[] | undefined;
    id: number;

    constructor(data?: IInsuranceCompanyBasicData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.number = _data["number"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans.push(InsurancePlanBasicData.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsuranceCompanyBasicData {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyBasicData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["number"] = this.number;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): InsuranceCompanyBasicData {
        const json = this.toJSON();
        let result = new InsuranceCompanyBasicData();
        result.init(json);
        return result;
    }
}

export interface IInsuranceCompanyBasicData {
    name: string | undefined;
    code: string | undefined;
    /** Will be used only when generating reports */
    number: string | undefined;
    insurancePlans: InsurancePlanBasicData[] | undefined;
    id: number;
}

export enum AppointmentStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _20 = 20,
    _21 = 21,
    _30 = 30,
    _31 = 31,
    _40 = 40,
    _41 = 41,
    _50 = 50,
    _51 = 51,
    _81 = 81,
    _82 = 82,
    _90 = 90,
    _100 = 100,
    _110 = 110,
}

export class UserIdentifier implements IUserIdentifier {
    tenantId: number | undefined;
    userId: number;

    constructor(data?: IUserIdentifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserIdentifier {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): UserIdentifier {
        const json = this.toJSON();
        let result = new UserIdentifier();
        result.init(json);
        return result;
    }
}

export interface IUserIdentifier {
    tenantId: number | undefined;
    userId: number;
}

export class MedicalAppointmentDetails implements IMedicalAppointmentDetails {
    /** Lista de termos a serem assinados */
    responsibilityTerms: MedicalAppointmentProcedureResponsibilityTerm[] | undefined;
    /** Formulários pré-procedimento a serem preenchidos */
    preForms: MedicalAppointmentProcedurePreForm[] | undefined;
    creationTime: moment.Moment;
    creatorUser: CreatorUser;
    paymentOptions: GetPaymentOptionsResult;
    price: number;
    splitPercentage: number | undefined;
    numberOfInstallments: number;
    maxNumberOfInstallments: number;
    /** Tipos de pagamento aceitos via link de pagamento: 1 = Cartão de crédito, 2 = Boleto bancário e 3 = PIX */
    allowedPaymentType: PaymentType[] | undefined;
    allowCancelByPatient: boolean;
    patientConfirmation: PatientConfirmation;
    dataOnlyEnabled: boolean;
    tenantId: number;
    patient: PatientNameInfo;
    doctor: DoctorInfo;
    remotely: boolean;
    allowStartMedicalCare: boolean;
    allowStartMedicalCareCall: boolean;
    /** Will be true when not paid */
    paymentRequired: boolean;
    careUnit: HealthCareUnitBasicData;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    /** VPay order */
    paymentId: number;
    /** Via VPay */
    paymentCompleted: boolean;
    /** Internal, manually marked as paid */
    transactionId: number | undefined;
    readonly payed: boolean;
    readonly allowUpdatePrice: boolean;
    isPrivateInsurance: boolean;
    allowMarkAsPayed: boolean;
    medicalAppointmentComplementaryProcedures: ComplementaryProcedureDto[] | undefined;
    specialty: MedicalProfessionSpecialty;
    procedure: MedicalProcedureBasicData;
    agreement: MedicalAgreementInfo;
    insuranceCompany: InsuranceCompanyBasicData;
    insurancePlan: InsurancePlanBasicData;
    paymentLink: string | undefined;
    pixCode: string | undefined;
    pixExpiringDate: moment.Moment | undefined;
    pixQrCode: string | undefined;
    id: string | undefined;
    discriminator: string | undefined;
    date: moment.Moment;
    duration: number;
    title: string | undefined;
    comments: string | undefined;
    status: AppointmentStatus;
    ownerUser: UserIdentifier;
    recurringEventId: string | undefined;
    readonly isRecurringEvent: boolean;
    recurrence: string | undefined;

    constructor(data?: IMedicalAppointmentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responsibilityTerms"])) {
                this.responsibilityTerms = [] as any;
                for (let item of _data["responsibilityTerms"])
                    this.responsibilityTerms.push(MedicalAppointmentProcedureResponsibilityTerm.fromJS(item));
            }
            if (Array.isArray(_data["preForms"])) {
                this.preForms = [] as any;
                for (let item of _data["preForms"])
                    this.preForms.push(MedicalAppointmentProcedurePreForm.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? CreatorUser.fromJS(_data["creatorUser"]) : <any>undefined;
            this.paymentOptions = _data["paymentOptions"] ? GetPaymentOptionsResult.fromJS(_data["paymentOptions"]) : <any>undefined;
            this.price = _data["price"];
            this.splitPercentage = _data["splitPercentage"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
            if (Array.isArray(_data["allowedPaymentType"])) {
                this.allowedPaymentType = [] as any;
                for (let item of _data["allowedPaymentType"])
                    this.allowedPaymentType.push(item);
            }
            this.allowCancelByPatient = _data["allowCancelByPatient"];
            this.patientConfirmation = _data["patientConfirmation"] ? PatientConfirmation.fromJS(_data["patientConfirmation"]) : <any>undefined;
            this.dataOnlyEnabled = _data["dataOnlyEnabled"];
            this.tenantId = _data["tenantId"];
            this.patient = _data["patient"] ? PatientNameInfo.fromJS(_data["patient"]) : <any>undefined;
            this.doctor = _data["doctor"] ? DoctorInfo.fromJS(_data["doctor"]) : <any>undefined;
            this.remotely = _data["remotely"];
            this.allowStartMedicalCare = _data["allowStartMedicalCare"];
            this.allowStartMedicalCareCall = _data["allowStartMedicalCareCall"];
            this.paymentRequired = _data["paymentRequired"];
            this.careUnit = _data["careUnit"] ? HealthCareUnitBasicData.fromJS(_data["careUnit"]) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.paymentCompleted = _data["paymentCompleted"];
            this.transactionId = _data["transactionId"];
            (<any>this).payed = _data["payed"];
            (<any>this).allowUpdatePrice = _data["allowUpdatePrice"];
            this.isPrivateInsurance = _data["isPrivateInsurance"];
            this.allowMarkAsPayed = _data["allowMarkAsPayed"];
            if (Array.isArray(_data["medicalAppointmentComplementaryProcedures"])) {
                this.medicalAppointmentComplementaryProcedures = [] as any;
                for (let item of _data["medicalAppointmentComplementaryProcedures"])
                    this.medicalAppointmentComplementaryProcedures.push(ComplementaryProcedureDto.fromJS(item));
            }
            this.specialty = _data["specialty"] ? MedicalProfessionSpecialty.fromJS(_data["specialty"]) : <any>undefined;
            this.procedure = _data["procedure"] ? MedicalProcedureBasicData.fromJS(_data["procedure"]) : <any>undefined;
            this.agreement = _data["agreement"] ? MedicalAgreementInfo.fromJS(_data["agreement"]) : <any>undefined;
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyBasicData.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insurancePlan = _data["insurancePlan"] ? InsurancePlanBasicData.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.paymentLink = _data["paymentLink"];
            this.pixCode = _data["pixCode"];
            this.pixExpiringDate = _data["pixExpiringDate"] ? moment(_data["pixExpiringDate"].toString()) : <any>undefined;
            this.pixQrCode = _data["pixQrCode"];
            this.id = _data["id"];
            this.discriminator = _data["discriminator"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.title = _data["title"];
            this.comments = _data["comments"];
            this.status = _data["status"];
            this.ownerUser = _data["ownerUser"] ? UserIdentifier.fromJS(_data["ownerUser"]) : <any>undefined;
            this.recurringEventId = _data["recurringEventId"];
            (<any>this).isRecurringEvent = _data["isRecurringEvent"];
            this.recurrence = _data["recurrence"];
        }
    }

    static fromJS(data: any): MedicalAppointmentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responsibilityTerms)) {
            data["responsibilityTerms"] = [];
            for (let item of this.responsibilityTerms)
                data["responsibilityTerms"].push(item.toJSON());
        }
        if (Array.isArray(this.preForms)) {
            data["preForms"] = [];
            for (let item of this.preForms)
                data["preForms"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["paymentOptions"] = this.paymentOptions ? this.paymentOptions.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["splitPercentage"] = this.splitPercentage;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        if (Array.isArray(this.allowedPaymentType)) {
            data["allowedPaymentType"] = [];
            for (let item of this.allowedPaymentType)
                data["allowedPaymentType"].push(item);
        }
        data["allowCancelByPatient"] = this.allowCancelByPatient;
        data["patientConfirmation"] = this.patientConfirmation ? this.patientConfirmation.toJSON() : <any>undefined;
        data["dataOnlyEnabled"] = this.dataOnlyEnabled;
        data["tenantId"] = this.tenantId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["remotely"] = this.remotely;
        data["allowStartMedicalCare"] = this.allowStartMedicalCare;
        data["allowStartMedicalCareCall"] = this.allowStartMedicalCareCall;
        data["paymentRequired"] = this.paymentRequired;
        data["careUnit"] = this.careUnit ? this.careUnit.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["paymentCompleted"] = this.paymentCompleted;
        data["transactionId"] = this.transactionId;
        data["payed"] = this.payed;
        data["allowUpdatePrice"] = this.allowUpdatePrice;
        data["isPrivateInsurance"] = this.isPrivateInsurance;
        data["allowMarkAsPayed"] = this.allowMarkAsPayed;
        if (Array.isArray(this.medicalAppointmentComplementaryProcedures)) {
            data["medicalAppointmentComplementaryProcedures"] = [];
            for (let item of this.medicalAppointmentComplementaryProcedures)
                data["medicalAppointmentComplementaryProcedures"].push(item.toJSON());
        }
        data["specialty"] = this.specialty ? this.specialty.toJSON() : <any>undefined;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data["agreement"] = this.agreement ? this.agreement.toJSON() : <any>undefined;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["paymentLink"] = this.paymentLink;
        data["pixCode"] = this.pixCode;
        data["pixExpiringDate"] = this.pixExpiringDate ? this.pixExpiringDate.toISOString() : <any>undefined;
        data["pixQrCode"] = this.pixQrCode;
        data["id"] = this.id;
        data["discriminator"] = this.discriminator;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["title"] = this.title;
        data["comments"] = this.comments;
        data["status"] = this.status;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : <any>undefined;
        data["recurringEventId"] = this.recurringEventId;
        data["isRecurringEvent"] = this.isRecurringEvent;
        data["recurrence"] = this.recurrence;
        return data; 
    }

    clone(): MedicalAppointmentDetails {
        const json = this.toJSON();
        let result = new MedicalAppointmentDetails();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentDetails {
    /** Lista de termos a serem assinados */
    responsibilityTerms: MedicalAppointmentProcedureResponsibilityTerm[] | undefined;
    /** Formulários pré-procedimento a serem preenchidos */
    preForms: MedicalAppointmentProcedurePreForm[] | undefined;
    creationTime: moment.Moment;
    creatorUser: CreatorUser;
    paymentOptions: GetPaymentOptionsResult;
    price: number;
    splitPercentage: number | undefined;
    numberOfInstallments: number;
    maxNumberOfInstallments: number;
    /** Tipos de pagamento aceitos via link de pagamento: 1 = Cartão de crédito, 2 = Boleto bancário e 3 = PIX */
    allowedPaymentType: PaymentType[] | undefined;
    allowCancelByPatient: boolean;
    patientConfirmation: PatientConfirmation;
    dataOnlyEnabled: boolean;
    tenantId: number;
    patient: PatientNameInfo;
    doctor: DoctorInfo;
    remotely: boolean;
    allowStartMedicalCare: boolean;
    allowStartMedicalCareCall: boolean;
    /** Will be true when not paid */
    paymentRequired: boolean;
    careUnit: HealthCareUnitBasicData;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    /** VPay order */
    paymentId: number;
    /** Via VPay */
    paymentCompleted: boolean;
    /** Internal, manually marked as paid */
    transactionId: number | undefined;
    payed: boolean;
    allowUpdatePrice: boolean;
    isPrivateInsurance: boolean;
    allowMarkAsPayed: boolean;
    medicalAppointmentComplementaryProcedures: ComplementaryProcedureDto[] | undefined;
    specialty: MedicalProfessionSpecialty;
    procedure: MedicalProcedureBasicData;
    agreement: MedicalAgreementInfo;
    insuranceCompany: InsuranceCompanyBasicData;
    insurancePlan: InsurancePlanBasicData;
    paymentLink: string | undefined;
    pixCode: string | undefined;
    pixExpiringDate: moment.Moment | undefined;
    pixQrCode: string | undefined;
    id: string | undefined;
    discriminator: string | undefined;
    date: moment.Moment;
    duration: number;
    title: string | undefined;
    comments: string | undefined;
    status: AppointmentStatus;
    ownerUser: UserIdentifier;
    recurringEventId: string | undefined;
    isRecurringEvent: boolean;
    recurrence: string | undefined;
}

export class UpdateMedicalAppointmentPrice implements IUpdateMedicalAppointmentPrice {
    id: string;
    price: number;

    constructor(data?: IUpdateMedicalAppointmentPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): UpdateMedicalAppointmentPrice {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicalAppointmentPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        return data; 
    }

    clone(): UpdateMedicalAppointmentPrice {
        const json = this.toJSON();
        let result = new UpdateMedicalAppointmentPrice();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicalAppointmentPrice {
    id: string;
    price: number;
}

export class ProcessDailyStatsRequest implements IProcessDailyStatsRequest {
    tenantId: number;
    date: moment.Moment;

    constructor(data?: IProcessDailyStatsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessDailyStatsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDailyStatsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }

    clone(): ProcessDailyStatsRequest {
        const json = this.toJSON();
        let result = new ProcessDailyStatsRequest();
        result.init(json);
        return result;
    }
}

export interface IProcessDailyStatsRequest {
    tenantId: number;
    date: moment.Moment;
}

export class IsPaymentCompletedQueryResult implements IIsPaymentCompletedQueryResult {
    isCompleted: boolean;
    isExpired: boolean;

    constructor(data?: IIsPaymentCompletedQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCompleted = _data["isCompleted"];
            this.isExpired = _data["isExpired"];
        }
    }

    static fromJS(data: any): IsPaymentCompletedQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsPaymentCompletedQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCompleted"] = this.isCompleted;
        data["isExpired"] = this.isExpired;
        return data; 
    }

    clone(): IsPaymentCompletedQueryResult {
        const json = this.toJSON();
        let result = new IsPaymentCompletedQueryResult();
        result.init(json);
        return result;
    }
}

export interface IIsPaymentCompletedQueryResult {
    isCompleted: boolean;
    isExpired: boolean;
}

export class UploadFileResponse implements IUploadFileResponse {
    id: string;
    path: string | undefined;
    name: string | undefined;
    appointmentId: string;

    constructor(data?: IUploadFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.path = _data["path"];
            this.name = _data["name"];
            this.appointmentId = _data["appointmentId"];
        }
    }

    static fromJS(data: any): UploadFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["path"] = this.path;
        data["name"] = this.name;
        data["appointmentId"] = this.appointmentId;
        return data; 
    }

    clone(): UploadFileResponse {
        const json = this.toJSON();
        let result = new UploadFileResponse();
        result.init(json);
        return result;
    }
}

export interface IUploadFileResponse {
    id: string;
    path: string | undefined;
    name: string | undefined;
    appointmentId: string;
}

export class GetBirdIdConfigurationResponse implements IGetBirdIdConfigurationResponse {
    username: string | undefined;
    alias: string | undefined;
    tokenExpirationDate: moment.Moment | undefined;

    constructor(data?: IGetBirdIdConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.alias = _data["alias"];
            this.tokenExpirationDate = _data["tokenExpirationDate"] ? moment(_data["tokenExpirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBirdIdConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBirdIdConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["alias"] = this.alias;
        data["tokenExpirationDate"] = this.tokenExpirationDate ? this.tokenExpirationDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): GetBirdIdConfigurationResponse {
        const json = this.toJSON();
        let result = new GetBirdIdConfigurationResponse();
        result.init(json);
        return result;
    }
}

export interface IGetBirdIdConfigurationResponse {
    username: string | undefined;
    alias: string | undefined;
    tokenExpirationDate: moment.Moment | undefined;
}

export class ConnectBirdIdRequest implements IConnectBirdIdRequest {
    username: string;
    password: string;

    constructor(data?: IConnectBirdIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ConnectBirdIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectBirdIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }

    clone(): ConnectBirdIdRequest {
        const json = this.toJSON();
        let result = new ConnectBirdIdRequest();
        result.init(json);
        return result;
    }
}

export interface IConnectBirdIdRequest {
    username: string;
    password: string;
}

export class BirdIdCertificate implements IBirdIdCertificate {
    alias: string | undefined;
    cn: string | undefined;

    constructor(data?: IBirdIdCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
            this.cn = _data["cn"];
        }
    }

    static fromJS(data: any): BirdIdCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new BirdIdCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        data["cn"] = this.cn;
        return data; 
    }

    clone(): BirdIdCertificate {
        const json = this.toJSON();
        let result = new BirdIdCertificate();
        result.init(json);
        return result;
    }
}

export interface IBirdIdCertificate {
    alias: string | undefined;
    cn: string | undefined;
}

export class SelectBirdIdCertificateRequest implements ISelectBirdIdCertificateRequest {
    alias: string;

    constructor(data?: ISelectBirdIdCertificateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
        }
    }

    static fromJS(data: any): SelectBirdIdCertificateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SelectBirdIdCertificateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        return data; 
    }

    clone(): SelectBirdIdCertificateRequest {
        const json = this.toJSON();
        let result = new SelectBirdIdCertificateRequest();
        result.init(json);
        return result;
    }
}

export interface ISelectBirdIdCertificateRequest {
    alias: string;
}

export class GetBuyerInfoResponse implements IGetBuyerInfoResponse {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    /** CPF */
    taxPayerId: string | undefined;
    billingAddress: Address;
    birthday: moment.Moment;
    tenantId: number;

    constructor(data?: IGetBuyerInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): GetBuyerInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuyerInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): GetBuyerInfoResponse {
        const json = this.toJSON();
        let result = new GetBuyerInfoResponse();
        result.init(json);
        return result;
    }
}

export interface IGetBuyerInfoResponse {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    /** CPF */
    taxPayerId: string | undefined;
    billingAddress: Address;
    birthday: moment.Moment;
    tenantId: number;
}

export class CreateBuyerIfNotExistsRequest implements ICreateBuyerIfNotExistsRequest {
    patientId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment | undefined;

    constructor(data?: ICreateBuyerIfNotExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateBuyerIfNotExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBuyerIfNotExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        return data; 
    }

    clone(): CreateBuyerIfNotExistsRequest {
        const json = this.toJSON();
        let result = new CreateBuyerIfNotExistsRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateBuyerIfNotExistsRequest {
    patientId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment | undefined;
}

export class BuyerDto implements IBuyerDto {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBuyerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BuyerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): BuyerDto {
        const json = this.toJSON();
        let result = new BuyerDto();
        result.init(json);
        return result;
    }
}

export interface IBuyerDto {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class IsAbleToMakePaymentRequest implements IIsAbleToMakePaymentRequest {
    patientId: string | undefined;

    constructor(data?: IIsAbleToMakePaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): IsAbleToMakePaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsAbleToMakePaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        return data; 
    }

    clone(): IsAbleToMakePaymentRequest {
        const json = this.toJSON();
        let result = new IsAbleToMakePaymentRequest();
        result.init(json);
        return result;
    }
}

export interface IIsAbleToMakePaymentRequest {
    patientId: string | undefined;
}

export class IsAbleToMakePaymentResponse implements IIsAbleToMakePaymentResponse {
    isAble: boolean;

    constructor(data?: IIsAbleToMakePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAble = _data["isAble"];
        }
    }

    static fromJS(data: any): IsAbleToMakePaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsAbleToMakePaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAble"] = this.isAble;
        return data; 
    }

    clone(): IsAbleToMakePaymentResponse {
        const json = this.toJSON();
        let result = new IsAbleToMakePaymentResponse();
        result.init(json);
        return result;
    }
}

export interface IIsAbleToMakePaymentResponse {
    isAble: boolean;
}

export class AddCardRequest implements IAddCardRequest {
    token: string | undefined;

    constructor(data?: IAddCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AddCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data; 
    }

    clone(): AddCardRequest {
        const json = this.toJSON();
        let result = new AddCardRequest();
        result.init(json);
        return result;
    }
}

export interface IAddCardRequest {
    token: string | undefined;
}

export class CertificateInfo implements ICertificateInfo {
    active: boolean;
    expirationDate: moment.Moment;
    incomplete: boolean;

    constructor(data?: ICertificateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.incomplete = _data["incomplete"];
        }
    }

    static fromJS(data: any): CertificateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["incomplete"] = this.incomplete;
        return data; 
    }

    clone(): CertificateInfo {
        const json = this.toJSON();
        let result = new CertificateInfo();
        result.init(json);
        return result;
    }
}

export interface ICertificateInfo {
    active: boolean;
    expirationDate: moment.Moment;
    incomplete: boolean;
}

export class ChildGrowthCurveConfiguration implements IChildGrowthCurveConfiguration {
    allowChildGrowthCurve: boolean;
    referenceByPercentile: boolean;
    weightUnit: string | undefined;

    constructor(data?: IChildGrowthCurveConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowChildGrowthCurve = _data["allowChildGrowthCurve"];
            this.referenceByPercentile = _data["referenceByPercentile"];
            this.weightUnit = _data["weightUnit"];
        }
    }

    static fromJS(data: any): ChildGrowthCurveConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ChildGrowthCurveConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowChildGrowthCurve"] = this.allowChildGrowthCurve;
        data["referenceByPercentile"] = this.referenceByPercentile;
        data["weightUnit"] = this.weightUnit;
        return data; 
    }

    clone(): ChildGrowthCurveConfiguration {
        const json = this.toJSON();
        let result = new ChildGrowthCurveConfiguration();
        result.init(json);
        return result;
    }
}

export interface IChildGrowthCurveConfiguration {
    allowChildGrowthCurve: boolean;
    referenceByPercentile: boolean;
    weightUnit: string | undefined;
}

export class CreateChildGrowthRequest implements ICreateChildGrowthRequest {
    patientId: string;
    weight: number;
    height: number;
    headCircumference: number | undefined;
    creationTime: moment.Moment | undefined;

    constructor(data?: ICreateChildGrowthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.headCircumference = _data["headCircumference"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateChildGrowthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildGrowthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["headCircumference"] = this.headCircumference;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): CreateChildGrowthRequest {
        const json = this.toJSON();
        let result = new CreateChildGrowthRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateChildGrowthRequest {
    patientId: string;
    weight: number;
    height: number;
    headCircumference: number | undefined;
    creationTime: moment.Moment | undefined;
}

export class ChildGrowthEntryDto implements IChildGrowthEntryDto {
    weight: number;
    height: number;
    headCircumference: number;
    imc: number;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IChildGrowthEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.headCircumference = _data["headCircumference"];
            this.imc = _data["imc"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChildGrowthEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChildGrowthEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["headCircumference"] = this.headCircumference;
        data["imc"] = this.imc;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): ChildGrowthEntryDto {
        const json = this.toJSON();
        let result = new ChildGrowthEntryDto();
        result.init(json);
        return result;
    }
}

export interface IChildGrowthEntryDto {
    weight: number;
    height: number;
    headCircumference: number;
    imc: number;
    creationTime: moment.Moment;
    id: number;
}

export class SeriesPoint implements ISeriesPoint {
    x: number;
    y: number;

    constructor(data?: ISeriesPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): SeriesPoint {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        return data; 
    }

    clone(): SeriesPoint {
        const json = this.toJSON();
        let result = new SeriesPoint();
        result.init(json);
        return result;
    }
}

export interface ISeriesPoint {
    x: number;
    y: number;
}

export class SeriesReference implements ISeriesReference {
    name: string | undefined;
    values: SeriesPoint[] | undefined;
    color: string | undefined;

    constructor(data?: ISeriesReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(SeriesPoint.fromJS(item));
            }
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): SeriesReference {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["color"] = this.color;
        return data; 
    }

    clone(): SeriesReference {
        const json = this.toJSON();
        let result = new SeriesReference();
        result.init(json);
        return result;
    }
}

export interface ISeriesReference {
    name: string | undefined;
    values: SeriesPoint[] | undefined;
    color: string | undefined;
}

export class SeriesData implements ISeriesData {
    name: string | undefined;
    color: string | undefined;
    values: SeriesPoint[] | undefined;
    references: SeriesReference[] | undefined;
    minY: number;
    maxY: number;

    constructor(data?: ISeriesData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.color = _data["color"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(SeriesPoint.fromJS(item));
            }
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references.push(SeriesReference.fromJS(item));
            }
            this.minY = _data["minY"];
            this.maxY = _data["maxY"];
        }
    }

    static fromJS(data: any): SeriesData {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["color"] = this.color;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        data["minY"] = this.minY;
        data["maxY"] = this.maxY;
        return data; 
    }

    clone(): SeriesData {
        const json = this.toJSON();
        let result = new SeriesData();
        result.init(json);
        return result;
    }
}

export interface ISeriesData {
    name: string | undefined;
    color: string | undefined;
    values: SeriesPoint[] | undefined;
    references: SeriesReference[] | undefined;
    minY: number;
    maxY: number;
}

export class ChildGrowthChartSeries implements IChildGrowthChartSeries {
    gender: number;
    age: number;
    type: string | undefined;
    weight: SeriesData;
    height: SeriesData;
    headCircumference: SeriesData;
    imc: SeriesData;

    constructor(data?: IChildGrowthChartSeries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gender = _data["gender"];
            this.age = _data["age"];
            this.type = _data["type"];
            this.weight = _data["weight"] ? SeriesData.fromJS(_data["weight"]) : <any>undefined;
            this.height = _data["height"] ? SeriesData.fromJS(_data["height"]) : <any>undefined;
            this.headCircumference = _data["headCircumference"] ? SeriesData.fromJS(_data["headCircumference"]) : <any>undefined;
            this.imc = _data["imc"] ? SeriesData.fromJS(_data["imc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChildGrowthChartSeries {
        data = typeof data === 'object' ? data : {};
        let result = new ChildGrowthChartSeries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gender"] = this.gender;
        data["age"] = this.age;
        data["type"] = this.type;
        data["weight"] = this.weight ? this.weight.toJSON() : <any>undefined;
        data["height"] = this.height ? this.height.toJSON() : <any>undefined;
        data["headCircumference"] = this.headCircumference ? this.headCircumference.toJSON() : <any>undefined;
        data["imc"] = this.imc ? this.imc.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ChildGrowthChartSeries {
        const json = this.toJSON();
        let result = new ChildGrowthChartSeries();
        result.init(json);
        return result;
    }
}

export interface IChildGrowthChartSeries {
    gender: number;
    age: number;
    type: string | undefined;
    weight: SeriesData;
    height: SeriesData;
    headCircumference: SeriesData;
    imc: SeriesData;
}

export class UpdateChildGrowthRequest implements IUpdateChildGrowthRequest {
    id: number;
    weight: number;
    height: number;
    headCircumference: number | undefined;
    imc: number;

    constructor(data?: IUpdateChildGrowthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.headCircumference = _data["headCircumference"];
            this.imc = _data["imc"];
        }
    }

    static fromJS(data: any): UpdateChildGrowthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChildGrowthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["headCircumference"] = this.headCircumference;
        data["imc"] = this.imc;
        return data; 
    }

    clone(): UpdateChildGrowthRequest {
        const json = this.toJSON();
        let result = new UpdateChildGrowthRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateChildGrowthRequest {
    id: number;
    weight: number;
    height: number;
    headCircumference: number | undefined;
    imc: number;
}

export class ChartData implements IChartData {
    name: string | undefined;
    value: number | undefined;
    week: number;

    constructor(data?: IChartData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.week = _data["week"];
        }
    }

    static fromJS(data: any): ChartData {
        data = typeof data === 'object' ? data : {};
        let result = new ChartData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["week"] = this.week;
        return data; 
    }

    clone(): ChartData {
        const json = this.toJSON();
        let result = new ChartData();
        result.init(json);
        return result;
    }
}

export interface IChartData {
    name: string | undefined;
    value: number | undefined;
    week: number;
}

export class ChartDto implements IChartDto {
    chartData: ChartData[] | undefined;
    gender: number;

    constructor(data?: IChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["chartData"])) {
                this.chartData = [] as any;
                for (let item of _data["chartData"])
                    this.chartData.push(ChartData.fromJS(item));
            }
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): ChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chartData)) {
            data["chartData"] = [];
            for (let item of this.chartData)
                data["chartData"].push(item.toJSON());
        }
        data["gender"] = this.gender;
        return data; 
    }

    clone(): ChartDto {
        const json = this.toJSON();
        let result = new ChartDto();
        result.init(json);
        return result;
    }
}

export interface IChartDto {
    chartData: ChartData[] | undefined;
    gender: number;
}

export class ColorScheme implements IColorScheme {
    primary: string | undefined;
    onPrimary: string | undefined;
    onPrimaryActive: string | undefined;
    darkPrimary: string | undefined;
    lightPrimary: string | undefined;
    text: string | undefined;
    accent: string | undefined;
    onAccent: string | undefined;
    lightAccent: string | undefined;
    primaryText: string | undefined;
    secondaryText: string | undefined;
    divider: string | undefined;
    background: string | undefined;
    backgroundImageUrl: string | undefined;
    backgroundPosition: string | undefined;
    backgroundSize: string | undefined;

    constructor(data?: IColorScheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primary = _data["primary"];
            this.onPrimary = _data["onPrimary"];
            this.onPrimaryActive = _data["onPrimaryActive"];
            this.darkPrimary = _data["darkPrimary"];
            this.lightPrimary = _data["lightPrimary"];
            this.text = _data["text"];
            this.accent = _data["accent"];
            this.onAccent = _data["onAccent"];
            this.lightAccent = _data["lightAccent"];
            this.primaryText = _data["primaryText"];
            this.secondaryText = _data["secondaryText"];
            this.divider = _data["divider"];
            this.background = _data["background"];
            this.backgroundImageUrl = _data["backgroundImageUrl"];
            this.backgroundPosition = _data["backgroundPosition"];
            this.backgroundSize = _data["backgroundSize"];
        }
    }

    static fromJS(data: any): ColorScheme {
        data = typeof data === 'object' ? data : {};
        let result = new ColorScheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primary"] = this.primary;
        data["onPrimary"] = this.onPrimary;
        data["onPrimaryActive"] = this.onPrimaryActive;
        data["darkPrimary"] = this.darkPrimary;
        data["lightPrimary"] = this.lightPrimary;
        data["text"] = this.text;
        data["accent"] = this.accent;
        data["onAccent"] = this.onAccent;
        data["lightAccent"] = this.lightAccent;
        data["primaryText"] = this.primaryText;
        data["secondaryText"] = this.secondaryText;
        data["divider"] = this.divider;
        data["background"] = this.background;
        data["backgroundImageUrl"] = this.backgroundImageUrl;
        data["backgroundPosition"] = this.backgroundPosition;
        data["backgroundSize"] = this.backgroundSize;
        return data; 
    }

    clone(): ColorScheme {
        const json = this.toJSON();
        let result = new ColorScheme();
        result.init(json);
        return result;
    }
}

export interface IColorScheme {
    primary: string | undefined;
    onPrimary: string | undefined;
    onPrimaryActive: string | undefined;
    darkPrimary: string | undefined;
    lightPrimary: string | undefined;
    text: string | undefined;
    accent: string | undefined;
    onAccent: string | undefined;
    lightAccent: string | undefined;
    primaryText: string | undefined;
    secondaryText: string | undefined;
    divider: string | undefined;
    background: string | undefined;
    backgroundImageUrl: string | undefined;
    backgroundPosition: string | undefined;
    backgroundSize: string | undefined;
}

export class Margin implements IMargin {
    top: number;
    right: number;
    bottom: number;
    left: number;

    constructor(data?: IMargin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.top = _data["top"];
            this.right = _data["right"];
            this.bottom = _data["bottom"];
            this.left = _data["left"];
        }
    }

    static fromJS(data: any): Margin {
        data = typeof data === 'object' ? data : {};
        let result = new Margin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["top"] = this.top;
        data["right"] = this.right;
        data["bottom"] = this.bottom;
        data["left"] = this.left;
        return data; 
    }

    clone(): Margin {
        const json = this.toJSON();
        let result = new Margin();
        result.init(json);
        return result;
    }
}

export interface IMargin {
    top: number;
    right: number;
    bottom: number;
    left: number;
}

export class MarginScreenSupport implements IMarginScreenSupport {
    xs: Margin;
    sm: Margin;
    md: Margin;
    lg: Margin;
    xl: Margin;

    constructor(data?: IMarginScreenSupport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xs = _data["xs"] ? Margin.fromJS(_data["xs"]) : <any>undefined;
            this.sm = _data["sm"] ? Margin.fromJS(_data["sm"]) : <any>undefined;
            this.md = _data["md"] ? Margin.fromJS(_data["md"]) : <any>undefined;
            this.lg = _data["lg"] ? Margin.fromJS(_data["lg"]) : <any>undefined;
            this.xl = _data["xl"] ? Margin.fromJS(_data["xl"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarginScreenSupport {
        data = typeof data === 'object' ? data : {};
        let result = new MarginScreenSupport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xs"] = this.xs ? this.xs.toJSON() : <any>undefined;
        data["sm"] = this.sm ? this.sm.toJSON() : <any>undefined;
        data["md"] = this.md ? this.md.toJSON() : <any>undefined;
        data["lg"] = this.lg ? this.lg.toJSON() : <any>undefined;
        data["xl"] = this.xl ? this.xl.toJSON() : <any>undefined;
        return data; 
    }

    clone(): MarginScreenSupport {
        const json = this.toJSON();
        let result = new MarginScreenSupport();
        result.init(json);
        return result;
    }
}

export interface IMarginScreenSupport {
    xs: Margin;
    sm: Margin;
    md: Margin;
    lg: Margin;
    xl: Margin;
}

export class StringScreenSupport implements IStringScreenSupport {
    xs: string | undefined;
    sm: string | undefined;
    md: string | undefined;
    lg: string | undefined;
    xl: string | undefined;

    constructor(data?: IStringScreenSupport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xs = _data["xs"];
            this.sm = _data["sm"];
            this.md = _data["md"];
            this.lg = _data["lg"];
            this.xl = _data["xl"];
        }
    }

    static fromJS(data: any): StringScreenSupport {
        data = typeof data === 'object' ? data : {};
        let result = new StringScreenSupport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xs"] = this.xs;
        data["sm"] = this.sm;
        data["md"] = this.md;
        data["lg"] = this.lg;
        data["xl"] = this.xl;
        return data; 
    }

    clone(): StringScreenSupport {
        const json = this.toJSON();
        let result = new StringScreenSupport();
        result.init(json);
        return result;
    }
}

export interface IStringScreenSupport {
    xs: string | undefined;
    sm: string | undefined;
    md: string | undefined;
    lg: string | undefined;
    xl: string | undefined;
}

export class Image implements IImage {
    source: string | undefined;
    id: string | undefined;
    theme: ColorScheme;
    shadow: string | undefined;
    margin: MarginScreenSupport;
    padding: MarginScreenSupport;
    width: StringScreenSupport;
    height: StringScreenSupport;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.id = _data["id"];
            this.theme = _data["theme"] ? ColorScheme.fromJS(_data["theme"]) : <any>undefined;
            this.shadow = _data["shadow"];
            this.margin = _data["margin"] ? MarginScreenSupport.fromJS(_data["margin"]) : <any>undefined;
            this.padding = _data["padding"] ? MarginScreenSupport.fromJS(_data["padding"]) : <any>undefined;
            this.width = _data["width"] ? StringScreenSupport.fromJS(_data["width"]) : <any>undefined;
            this.height = _data["height"] ? StringScreenSupport.fromJS(_data["height"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["id"] = this.id;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        data["shadow"] = this.shadow;
        data["margin"] = this.margin ? this.margin.toJSON() : <any>undefined;
        data["padding"] = this.padding ? this.padding.toJSON() : <any>undefined;
        data["width"] = this.width ? this.width.toJSON() : <any>undefined;
        data["height"] = this.height ? this.height.toJSON() : <any>undefined;
        return data; 
    }

    clone(): Image {
        const json = this.toJSON();
        let result = new Image();
        result.init(json);
        return result;
    }
}

export interface IImage {
    source: string | undefined;
    id: string | undefined;
    theme: ColorScheme;
    shadow: string | undefined;
    margin: MarginScreenSupport;
    padding: MarginScreenSupport;
    width: StringScreenSupport;
    height: StringScreenSupport;
}

export class FontDefinition implements IFontDefinition {
    name: string | undefined;
    size: string | undefined;

    constructor(data?: IFontDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): FontDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new FontDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["size"] = this.size;
        return data; 
    }

    clone(): FontDefinition {
        const json = this.toJSON();
        let result = new FontDefinition();
        result.init(json);
        return result;
    }
}

export interface IFontDefinition {
    name: string | undefined;
    size: string | undefined;
}

export class TextControl implements ITextControl {
    font: FontDefinition;
    text: string | undefined;
    alignment: string | undefined;
    id: string | undefined;
    theme: ColorScheme;
    shadow: string | undefined;
    margin: MarginScreenSupport;
    padding: MarginScreenSupport;
    width: StringScreenSupport;
    height: StringScreenSupport;

    constructor(data?: ITextControl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.font = _data["font"] ? FontDefinition.fromJS(_data["font"]) : <any>undefined;
            this.text = _data["text"];
            this.alignment = _data["alignment"];
            this.id = _data["id"];
            this.theme = _data["theme"] ? ColorScheme.fromJS(_data["theme"]) : <any>undefined;
            this.shadow = _data["shadow"];
            this.margin = _data["margin"] ? MarginScreenSupport.fromJS(_data["margin"]) : <any>undefined;
            this.padding = _data["padding"] ? MarginScreenSupport.fromJS(_data["padding"]) : <any>undefined;
            this.width = _data["width"] ? StringScreenSupport.fromJS(_data["width"]) : <any>undefined;
            this.height = _data["height"] ? StringScreenSupport.fromJS(_data["height"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TextControl {
        data = typeof data === 'object' ? data : {};
        let result = new TextControl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["font"] = this.font ? this.font.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["alignment"] = this.alignment;
        data["id"] = this.id;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        data["shadow"] = this.shadow;
        data["margin"] = this.margin ? this.margin.toJSON() : <any>undefined;
        data["padding"] = this.padding ? this.padding.toJSON() : <any>undefined;
        data["width"] = this.width ? this.width.toJSON() : <any>undefined;
        data["height"] = this.height ? this.height.toJSON() : <any>undefined;
        return data; 
    }

    clone(): TextControl {
        const json = this.toJSON();
        let result = new TextControl();
        result.init(json);
        return result;
    }
}

export interface ITextControl {
    font: FontDefinition;
    text: string | undefined;
    alignment: string | undefined;
    id: string | undefined;
    theme: ColorScheme;
    shadow: string | undefined;
    margin: MarginScreenSupport;
    padding: MarginScreenSupport;
    width: StringScreenSupport;
    height: StringScreenSupport;
}

export class Page implements IPage {
    icon: Image;
    title: TextControl;
    subtitle: TextControl;
    order: number;
    name: string | undefined;
    friendlyUrl: string | undefined;
    layout: string | undefined;
    id: string | undefined;
    theme: ColorScheme;
    shadow: string | undefined;
    margin: MarginScreenSupport;
    padding: MarginScreenSupport;
    width: StringScreenSupport;
    height: StringScreenSupport;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icon = _data["icon"] ? Image.fromJS(_data["icon"]) : <any>undefined;
            this.title = _data["title"] ? TextControl.fromJS(_data["title"]) : <any>undefined;
            this.subtitle = _data["subtitle"] ? TextControl.fromJS(_data["subtitle"]) : <any>undefined;
            this.order = _data["order"];
            this.name = _data["name"];
            this.friendlyUrl = _data["friendlyUrl"];
            this.layout = _data["layout"];
            this.id = _data["id"];
            this.theme = _data["theme"] ? ColorScheme.fromJS(_data["theme"]) : <any>undefined;
            this.shadow = _data["shadow"];
            this.margin = _data["margin"] ? MarginScreenSupport.fromJS(_data["margin"]) : <any>undefined;
            this.padding = _data["padding"] ? MarginScreenSupport.fromJS(_data["padding"]) : <any>undefined;
            this.width = _data["width"] ? StringScreenSupport.fromJS(_data["width"]) : <any>undefined;
            this.height = _data["height"] ? StringScreenSupport.fromJS(_data["height"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["subtitle"] = this.subtitle ? this.subtitle.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["name"] = this.name;
        data["friendlyUrl"] = this.friendlyUrl;
        data["layout"] = this.layout;
        data["id"] = this.id;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        data["shadow"] = this.shadow;
        data["margin"] = this.margin ? this.margin.toJSON() : <any>undefined;
        data["padding"] = this.padding ? this.padding.toJSON() : <any>undefined;
        data["width"] = this.width ? this.width.toJSON() : <any>undefined;
        data["height"] = this.height ? this.height.toJSON() : <any>undefined;
        return data; 
    }

    clone(): Page {
        const json = this.toJSON();
        let result = new Page();
        result.init(json);
        return result;
    }
}

export interface IPage {
    icon: Image;
    title: TextControl;
    subtitle: TextControl;
    order: number;
    name: string | undefined;
    friendlyUrl: string | undefined;
    layout: string | undefined;
    id: string | undefined;
    theme: ColorScheme;
    shadow: string | undefined;
    margin: MarginScreenSupport;
    padding: MarginScreenSupport;
    width: StringScreenSupport;
    height: StringScreenSupport;
}

export class Module implements IModule {
    name: string | undefined;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }

    clone(): Module {
        const json = this.toJSON();
        let result = new Module();
        result.init(json);
        return result;
    }
}

export interface IModule {
    name: string | undefined;
}

export class LegalInfo implements ILegalInfo {
    appName: string | undefined;
    companyName: string | undefined;
    commercialIdentifier: string | undefined;
    companyAddress: string | undefined;
    companyDpoName: string | undefined;
    companyDpoAddress: string | undefined;
    companyDpoEmail: string | undefined;

    constructor(data?: ILegalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appName = _data["appName"];
            this.companyName = _data["companyName"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.companyAddress = _data["companyAddress"];
            this.companyDpoName = _data["companyDpoName"];
            this.companyDpoAddress = _data["companyDpoAddress"];
            this.companyDpoEmail = _data["companyDpoEmail"];
        }
    }

    static fromJS(data: any): LegalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LegalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appName"] = this.appName;
        data["companyName"] = this.companyName;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["companyAddress"] = this.companyAddress;
        data["companyDpoName"] = this.companyDpoName;
        data["companyDpoAddress"] = this.companyDpoAddress;
        data["companyDpoEmail"] = this.companyDpoEmail;
        return data; 
    }

    clone(): LegalInfo {
        const json = this.toJSON();
        let result = new LegalInfo();
        result.init(json);
        return result;
    }
}

export interface ILegalInfo {
    appName: string | undefined;
    companyName: string | undefined;
    commercialIdentifier: string | undefined;
    companyAddress: string | undefined;
    companyDpoName: string | undefined;
    companyDpoAddress: string | undefined;
    companyDpoEmail: string | undefined;
}

export class SiteDefinition implements ISiteDefinition {
    title: string | undefined;
    faviconUrl: string | undefined;
    theme: ColorScheme;
    pages: Page[] | undefined;
    modules: Module[] | undefined;
    layout: string | undefined;
    logoUrl: string | undefined;
    homeUrl: string | undefined;
    facebookPixel: string | undefined;
    googleTag: string | undefined;
    metaTags: { [key: string]: string; } | undefined;
    headScripts: string[] | undefined;
    bodyScripts: string[] | undefined;
    legalInfo: LegalInfo;

    constructor(data?: ISiteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.faviconUrl = _data["faviconUrl"];
            this.theme = _data["theme"] ? ColorScheme.fromJS(_data["theme"]) : <any>undefined;
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages.push(Page.fromJS(item));
            }
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules.push(Module.fromJS(item));
            }
            this.layout = _data["layout"];
            this.logoUrl = _data["logoUrl"];
            this.homeUrl = _data["homeUrl"];
            this.facebookPixel = _data["facebookPixel"];
            this.googleTag = _data["googleTag"];
            if (_data["metaTags"]) {
                this.metaTags = {} as any;
                for (let key in _data["metaTags"]) {
                    if (_data["metaTags"].hasOwnProperty(key))
                        (<any>this.metaTags)[key] = _data["metaTags"][key];
                }
            }
            if (Array.isArray(_data["headScripts"])) {
                this.headScripts = [] as any;
                for (let item of _data["headScripts"])
                    this.headScripts.push(item);
            }
            if (Array.isArray(_data["bodyScripts"])) {
                this.bodyScripts = [] as any;
                for (let item of _data["bodyScripts"])
                    this.bodyScripts.push(item);
            }
            this.legalInfo = _data["legalInfo"] ? LegalInfo.fromJS(_data["legalInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SiteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new SiteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["faviconUrl"] = this.faviconUrl;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["layout"] = this.layout;
        data["logoUrl"] = this.logoUrl;
        data["homeUrl"] = this.homeUrl;
        data["facebookPixel"] = this.facebookPixel;
        data["googleTag"] = this.googleTag;
        if (this.metaTags) {
            data["metaTags"] = {};
            for (let key in this.metaTags) {
                if (this.metaTags.hasOwnProperty(key))
                    (<any>data["metaTags"])[key] = this.metaTags[key];
            }
        }
        if (Array.isArray(this.headScripts)) {
            data["headScripts"] = [];
            for (let item of this.headScripts)
                data["headScripts"].push(item);
        }
        if (Array.isArray(this.bodyScripts)) {
            data["bodyScripts"] = [];
            for (let item of this.bodyScripts)
                data["bodyScripts"].push(item);
        }
        data["legalInfo"] = this.legalInfo ? this.legalInfo.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SiteDefinition {
        const json = this.toJSON();
        let result = new SiteDefinition();
        result.init(json);
        return result;
    }
}

export interface ISiteDefinition {
    title: string | undefined;
    faviconUrl: string | undefined;
    theme: ColorScheme;
    pages: Page[] | undefined;
    modules: Module[] | undefined;
    layout: string | undefined;
    logoUrl: string | undefined;
    homeUrl: string | undefined;
    facebookPixel: string | undefined;
    googleTag: string | undefined;
    metaTags: { [key: string]: string; } | undefined;
    headScripts: string[] | undefined;
    bodyScripts: string[] | undefined;
    legalInfo: LegalInfo;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data; 
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeLeftMenuVisibilityInput implements IChangeLeftMenuVisibilityInput {
    collapsed: boolean;

    constructor(data?: IChangeLeftMenuVisibilityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collapsed = _data["collapsed"];
        }
    }

    static fromJS(data: any): ChangeLeftMenuVisibilityInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLeftMenuVisibilityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collapsed"] = this.collapsed;
        return data; 
    }

    clone(): ChangeLeftMenuVisibilityInput {
        const json = this.toJSON();
        let result = new ChangeLeftMenuVisibilityInput();
        result.init(json);
        return result;
    }
}

export interface IChangeLeftMenuVisibilityInput {
    collapsed: boolean;
}

export class ContactTitleTranslation implements IContactTitleTranslation {
    language: string | undefined;
    title: string | undefined;

    constructor(data?: IContactTitleTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ContactTitleTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ContactTitleTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["title"] = this.title;
        return data; 
    }

    clone(): ContactTitleTranslation {
        const json = this.toJSON();
        let result = new ContactTitleTranslation();
        result.init(json);
        return result;
    }
}

export interface IContactTitleTranslation {
    language: string | undefined;
    title: string | undefined;
}

export class ContactAddress implements IContactAddress {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    latitude: number;
    longitude: number;

    constructor(data?: IContactAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postalCode = _data["postalCode"];
            this.formattedAddress = _data["formattedAddress"];
            this.reference = _data["reference"];
            this.complement = _data["complement"];
            this.number = _data["number"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): ContactAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postalCode"] = this.postalCode;
        data["formattedAddress"] = this.formattedAddress;
        data["reference"] = this.reference;
        data["complement"] = this.complement;
        data["number"] = this.number;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }

    clone(): ContactAddress {
        const json = this.toJSON();
        let result = new ContactAddress();
        result.init(json);
        return result;
    }
}

export interface IContactAddress {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    latitude: number;
    longitude: number;
}

export class Social implements ISocial {
    website: string | undefined;
    facebook: string | undefined;
    twitter: string | undefined;
    linkedin: string | undefined;
    instagram: string | undefined;
    youtube: string | undefined;

    constructor(data?: ISocial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.website = _data["website"];
            this.facebook = _data["facebook"];
            this.twitter = _data["twitter"];
            this.linkedin = _data["linkedin"];
            this.instagram = _data["instagram"];
            this.youtube = _data["youtube"];
        }
    }

    static fromJS(data: any): Social {
        data = typeof data === 'object' ? data : {};
        let result = new Social();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["website"] = this.website;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["linkedin"] = this.linkedin;
        data["instagram"] = this.instagram;
        data["youtube"] = this.youtube;
        return data; 
    }

    clone(): Social {
        const json = this.toJSON();
        let result = new Social();
        result.init(json);
        return result;
    }
}

export interface ISocial {
    website: string | undefined;
    facebook: string | undefined;
    twitter: string | undefined;
    linkedin: string | undefined;
    instagram: string | undefined;
    youtube: string | undefined;
}

export class PhoneTitleTranslation implements IPhoneTitleTranslation {
    language: string | undefined;
    title: string | undefined;

    constructor(data?: IPhoneTitleTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PhoneTitleTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneTitleTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["title"] = this.title;
        return data; 
    }

    clone(): PhoneTitleTranslation {
        const json = this.toJSON();
        let result = new PhoneTitleTranslation();
        result.init(json);
        return result;
    }
}

export interface IPhoneTitleTranslation {
    language: string | undefined;
    title: string | undefined;
}

export class ContactPhone implements IContactPhone {
    translations: PhoneTitleTranslation[] | undefined;
    number: string | undefined;
    isWhatsApp: boolean;

    constructor(data?: IContactPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations.push(PhoneTitleTranslation.fromJS(item));
            }
            this.number = _data["number"];
            this.isWhatsApp = _data["isWhatsApp"];
        }
    }

    static fromJS(data: any): ContactPhone {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["number"] = this.number;
        data["isWhatsApp"] = this.isWhatsApp;
        return data; 
    }

    clone(): ContactPhone {
        const json = this.toJSON();
        let result = new ContactPhone();
        result.init(json);
        return result;
    }
}

export interface IContactPhone {
    translations: PhoneTitleTranslation[] | undefined;
    number: string | undefined;
    isWhatsApp: boolean;
}

export class Contact implements IContact {
    id: number;
    translations: ContactTitleTranslation[] | undefined;
    address: ContactAddress;
    website: string | undefined;
    email: string | undefined;
    emails: string[] | undefined;
    social: Social;
    phones: ContactPhone[] | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations.push(ContactTitleTranslation.fromJS(item));
            }
            this.address = _data["address"] ? ContactAddress.fromJS(_data["address"]) : <any>undefined;
            this.website = _data["website"];
            this.email = _data["email"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(item);
            }
            this.social = _data["social"] ? Social.fromJS(_data["social"]) : <any>undefined;
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones.push(ContactPhone.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["website"] = this.website;
        data["email"] = this.email;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["social"] = this.social ? this.social.toJSON() : <any>undefined;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact {
    id: number;
    translations: ContactTitleTranslation[] | undefined;
    address: ContactAddress;
    website: string | undefined;
    email: string | undefined;
    emails: string[] | undefined;
    social: Social;
    phones: ContactPhone[] | undefined;
}

export class UserDto implements IUserDto {
    tenantId: number | undefined;
    readonly userName: string | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    birthday: moment.Moment;
    isActive: boolean;
    fullName: string | undefined;
    avatar: string | undefined;
    gender: number | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    allowEdit: boolean;
    id: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            (<any>this).userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.gender = _data["gender"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.allowEdit = _data["allowEdit"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["personalIdentifier"] = this.personalIdentifier;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["gender"] = this.gender;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["allowEdit"] = this.allowEdit;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    tenantId: number | undefined;
    userName: string | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    birthday: moment.Moment;
    isActive: boolean;
    fullName: string | undefined;
    avatar: string | undefined;
    gender: number | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    allowEdit: boolean;
    id: number;
}

export class ProfessionData implements IProfessionData {
    code: number;
    details: string | undefined;
    speciality: number | undefined;
    specialtyRegistry: DoctorSpecialty[] | undefined;
    professionName: string | undefined;

    constructor(data?: IProfessionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.details = _data["details"];
            this.speciality = _data["speciality"];
            if (Array.isArray(_data["specialtyRegistry"])) {
                this.specialtyRegistry = [] as any;
                for (let item of _data["specialtyRegistry"])
                    this.specialtyRegistry.push(DoctorSpecialty.fromJS(item));
            }
            this.professionName = _data["professionName"];
        }
    }

    static fromJS(data: any): ProfessionData {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["details"] = this.details;
        data["speciality"] = this.speciality;
        if (Array.isArray(this.specialtyRegistry)) {
            data["specialtyRegistry"] = [];
            for (let item of this.specialtyRegistry)
                data["specialtyRegistry"].push(item.toJSON());
        }
        data["professionName"] = this.professionName;
        return data; 
    }

    clone(): ProfessionData {
        const json = this.toJSON();
        let result = new ProfessionData();
        result.init(json);
        return result;
    }
}

export interface IProfessionData {
    code: number;
    details: string | undefined;
    speciality: number | undefined;
    specialtyRegistry: DoctorSpecialty[] | undefined;
    professionName: string | undefined;
}

export class DoctorDto implements IDoctorDto {
    user: UserDto;
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;
    profession: ProfessionData;
    tenantId: number | undefined;
    allowEdit: boolean;
    readonly isExample: boolean;
    id: string;

    constructor(data?: IDoctorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.licenceNumber = _data["licenceNumber"] ? LicenceNumber.fromJS(_data["licenceNumber"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.commercialPhone = _data["commercialPhone"];
            this.profession = _data["profession"] ? ProfessionData.fromJS(_data["profession"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.allowEdit = _data["allowEdit"];
            (<any>this).isExample = _data["isExample"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DoctorDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["licenceNumber"] = this.licenceNumber ? this.licenceNumber.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["commercialPhone"] = this.commercialPhone;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["allowEdit"] = this.allowEdit;
        data["isExample"] = this.isExample;
        data["id"] = this.id;
        return data; 
    }

    clone(): DoctorDto {
        const json = this.toJSON();
        let result = new DoctorDto();
        result.init(json);
        return result;
    }
}

export interface IDoctorDto {
    user: UserDto;
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;
    profession: ProfessionData;
    tenantId: number | undefined;
    allowEdit: boolean;
    isExample: boolean;
    id: string;
}

export class RegisterDoctorDto implements IRegisterDoctorDto {
    password: string | undefined;
    user: UserDto;
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;
    profession: ProfessionData;
    tenantId: number | undefined;
    allowEdit: boolean;
    readonly isExample: boolean;
    id: string;

    constructor(data?: IRegisterDoctorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.licenceNumber = _data["licenceNumber"] ? LicenceNumber.fromJS(_data["licenceNumber"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.commercialPhone = _data["commercialPhone"];
            this.profession = _data["profession"] ? ProfessionData.fromJS(_data["profession"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.allowEdit = _data["allowEdit"];
            (<any>this).isExample = _data["isExample"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegisterDoctorDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDoctorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["licenceNumber"] = this.licenceNumber ? this.licenceNumber.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["commercialPhone"] = this.commercialPhone;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["allowEdit"] = this.allowEdit;
        data["isExample"] = this.isExample;
        data["id"] = this.id;
        return data; 
    }

    clone(): RegisterDoctorDto {
        const json = this.toJSON();
        let result = new RegisterDoctorDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterDoctorDto {
    password: string | undefined;
    user: UserDto;
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;
    profession: ProfessionData;
    tenantId: number | undefined;
    allowEdit: boolean;
    isExample: boolean;
    id: string;
}

export class UpdateDoctorUserDto implements IUpdateDoctorUserDto {
    name: string;
    surname: string;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    birthday: moment.Moment;
    gender: number | undefined;
    id: number;

    constructor(data?: IUpdateDoctorUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateDoctorUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDoctorUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["personalIdentifier"] = this.personalIdentifier;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateDoctorUserDto {
        const json = this.toJSON();
        let result = new UpdateDoctorUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDoctorUserDto {
    name: string;
    surname: string;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    birthday: moment.Moment;
    gender: number | undefined;
    id: number;
}

export class UpdateDoctorDto implements IUpdateDoctorDto {
    user: UpdateDoctorUserDto;
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;
    profession: ProfessionData;
    id: string;

    constructor(data?: IUpdateDoctorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UpdateDoctorUserDto.fromJS(_data["user"]) : <any>undefined;
            this.licenceNumber = _data["licenceNumber"] ? LicenceNumber.fromJS(_data["licenceNumber"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.commercialPhone = _data["commercialPhone"];
            this.profession = _data["profession"] ? ProfessionData.fromJS(_data["profession"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateDoctorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDoctorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["licenceNumber"] = this.licenceNumber ? this.licenceNumber.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["commercialPhone"] = this.commercialPhone;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateDoctorDto {
        const json = this.toJSON();
        let result = new UpdateDoctorDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDoctorDto {
    user: UpdateDoctorUserDto;
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;
    profession: ProfessionData;
    id: string;
}

export class DoctorInvitationCompletionModel implements IDoctorInvitationCompletionModel {
    readonly componentName: string | undefined;
    licenceNumber: string | undefined;
    licenceAgency: string | undefined;
    licenceState: string | undefined;
    commercialPhone: string | undefined;
    contactEmail: string | undefined;
    professionCode: number;
    professionDetails: string | undefined;
    professionSpeciality: number | undefined;
    readonly autoLogin: boolean;
    invitationId: string;
    tenantId: number;
    userId: number | undefined;
    invitedUserEmail: string | undefined;
    invitedUserPhone: string | undefined;
    invitedUserName: string | undefined;
    ownerName: string | undefined;
    metadata: string | undefined;
    redirectToLogin: boolean;

    constructor(data?: IDoctorInvitationCompletionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).componentName = _data["componentName"];
            this.licenceNumber = _data["licenceNumber"];
            this.licenceAgency = _data["licenceAgency"];
            this.licenceState = _data["licenceState"];
            this.commercialPhone = _data["commercialPhone"];
            this.contactEmail = _data["contactEmail"];
            this.professionCode = _data["professionCode"];
            this.professionDetails = _data["professionDetails"];
            this.professionSpeciality = _data["professionSpeciality"];
            (<any>this).autoLogin = _data["autoLogin"];
            this.invitationId = _data["invitationId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.invitedUserEmail = _data["invitedUserEmail"];
            this.invitedUserPhone = _data["invitedUserPhone"];
            this.invitedUserName = _data["invitedUserName"];
            this.ownerName = _data["ownerName"];
            this.metadata = _data["metadata"];
            this.redirectToLogin = _data["redirectToLogin"];
        }
    }

    static fromJS(data: any): DoctorInvitationCompletionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorInvitationCompletionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentName"] = this.componentName;
        data["licenceNumber"] = this.licenceNumber;
        data["licenceAgency"] = this.licenceAgency;
        data["licenceState"] = this.licenceState;
        data["commercialPhone"] = this.commercialPhone;
        data["contactEmail"] = this.contactEmail;
        data["professionCode"] = this.professionCode;
        data["professionDetails"] = this.professionDetails;
        data["professionSpeciality"] = this.professionSpeciality;
        data["autoLogin"] = this.autoLogin;
        data["invitationId"] = this.invitationId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["invitedUserEmail"] = this.invitedUserEmail;
        data["invitedUserPhone"] = this.invitedUserPhone;
        data["invitedUserName"] = this.invitedUserName;
        data["ownerName"] = this.ownerName;
        data["metadata"] = this.metadata;
        data["redirectToLogin"] = this.redirectToLogin;
        return data; 
    }

    clone(): DoctorInvitationCompletionModel {
        const json = this.toJSON();
        let result = new DoctorInvitationCompletionModel();
        result.init(json);
        return result;
    }
}

export interface IDoctorInvitationCompletionModel {
    componentName: string | undefined;
    licenceNumber: string | undefined;
    licenceAgency: string | undefined;
    licenceState: string | undefined;
    commercialPhone: string | undefined;
    contactEmail: string | undefined;
    professionCode: number;
    professionDetails: string | undefined;
    professionSpeciality: number | undefined;
    autoLogin: boolean;
    invitationId: string;
    tenantId: number;
    userId: number | undefined;
    invitedUserEmail: string | undefined;
    invitedUserPhone: string | undefined;
    invitedUserName: string | undefined;
    ownerName: string | undefined;
    metadata: string | undefined;
    redirectToLogin: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    errorCode: number;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    tenantId: number | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    errorCode: number;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    tenantId: number | undefined;
}

export class DoctorDtoPagedResultDto implements IDoctorDtoPagedResultDto {
    totalCount: number;
    items: DoctorDto[] | undefined;

    constructor(data?: IDoctorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DoctorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DoctorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DoctorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DoctorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDoctorDtoPagedResultDto {
    totalCount: number;
    items: DoctorDto[] | undefined;
}

export class DocumentVerificationResult implements IDocumentVerificationResult {
    valid: boolean;

    constructor(data?: IDocumentVerificationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
        }
    }

    static fromJS(data: any): DocumentVerificationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVerificationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        return data; 
    }

    clone(): DocumentVerificationResult {
        const json = this.toJSON();
        let result = new DocumentVerificationResult();
        result.init(json);
        return result;
    }
}

export interface IDocumentVerificationResult {
    valid: boolean;
}

export class CreateDocumentTemplateCategoryInput implements ICreateDocumentTemplateCategoryInput {
    name: string | undefined;
    content: string | undefined;
    isPrivate: boolean;

    constructor(data?: ICreateDocumentTemplateCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): CreateDocumentTemplateCategoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentTemplateCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        data["isPrivate"] = this.isPrivate;
        return data; 
    }

    clone(): CreateDocumentTemplateCategoryInput {
        const json = this.toJSON();
        let result = new CreateDocumentTemplateCategoryInput();
        result.init(json);
        return result;
    }
}

export interface ICreateDocumentTemplateCategoryInput {
    name: string | undefined;
    content: string | undefined;
    isPrivate: boolean;
}

export class DocumentTemplateDto implements IDocumentTemplateDto {
    name: string | undefined;
    content: string | undefined;
    categoryId: number;
    isPrivate: boolean;
    healthProfessionalId: string | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IDocumentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
            this.categoryId = _data["categoryId"];
            this.isPrivate = _data["isPrivate"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        data["categoryId"] = this.categoryId;
        data["isPrivate"] = this.isPrivate;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): DocumentTemplateDto {
        const json = this.toJSON();
        let result = new DocumentTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTemplateDto {
    name: string | undefined;
    content: string | undefined;
    categoryId: number;
    isPrivate: boolean;
    healthProfessionalId: string | undefined;
    tenantId: number;
    id: number;
}

export class DocumentTemplateCategoryDto implements IDocumentTemplateCategoryDto {
    name: string | undefined;
    content: string | undefined;
    templates: DocumentTemplateDto[] | undefined;
    isPrivate: boolean;
    healthProfessionalId: string | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IDocumentTemplateCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates.push(DocumentTemplateDto.fromJS(item));
            }
            this.isPrivate = _data["isPrivate"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentTemplateCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        data["isPrivate"] = this.isPrivate;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): DocumentTemplateCategoryDto {
        const json = this.toJSON();
        let result = new DocumentTemplateCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTemplateCategoryDto {
    name: string | undefined;
    content: string | undefined;
    templates: DocumentTemplateDto[] | undefined;
    isPrivate: boolean;
    healthProfessionalId: string | undefined;
    tenantId: number;
    id: number;
}

export class UpdateDocumentTemplateCategoryInput implements IUpdateDocumentTemplateCategoryInput {
    name: string | undefined;
    content: string | undefined;
    isPrivate: boolean;
    id: number;

    constructor(data?: IUpdateDocumentTemplateCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
            this.isPrivate = _data["isPrivate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateDocumentTemplateCategoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentTemplateCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        data["isPrivate"] = this.isPrivate;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateDocumentTemplateCategoryInput {
        const json = this.toJSON();
        let result = new UpdateDocumentTemplateCategoryInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateDocumentTemplateCategoryInput {
    name: string | undefined;
    content: string | undefined;
    isPrivate: boolean;
    id: number;
}

export class DocumentTemplateCategoryDtoPagedResultDto implements IDocumentTemplateCategoryDtoPagedResultDto {
    totalCount: number;
    items: DocumentTemplateCategoryDto[] | undefined;

    constructor(data?: IDocumentTemplateCategoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DocumentTemplateCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentTemplateCategoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateCategoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DocumentTemplateCategoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentTemplateCategoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTemplateCategoryDtoPagedResultDto {
    totalCount: number;
    items: DocumentTemplateCategoryDto[] | undefined;
}

export class CreateDocumentTemplateRequest implements ICreateDocumentTemplateRequest {
    name: string | undefined;
    content: string | undefined;
    categoryId: number;
    isPrivate: boolean;

    constructor(data?: ICreateDocumentTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
            this.categoryId = _data["categoryId"];
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): CreateDocumentTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        data["categoryId"] = this.categoryId;
        data["isPrivate"] = this.isPrivate;
        return data; 
    }

    clone(): CreateDocumentTemplateRequest {
        const json = this.toJSON();
        let result = new CreateDocumentTemplateRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateDocumentTemplateRequest {
    name: string | undefined;
    content: string | undefined;
    categoryId: number;
    isPrivate: boolean;
}

export class UpdateDocumentTemplateRequest implements IUpdateDocumentTemplateRequest {
    id: number;
    name: string | undefined;
    content: string | undefined;
    categoryId: number;
    isPrivate: boolean;

    constructor(data?: IUpdateDocumentTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.categoryId = _data["categoryId"];
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): UpdateDocumentTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["categoryId"] = this.categoryId;
        data["isPrivate"] = this.isPrivate;
        return data; 
    }

    clone(): UpdateDocumentTemplateRequest {
        const json = this.toJSON();
        let result = new UpdateDocumentTemplateRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateDocumentTemplateRequest {
    id: number;
    name: string | undefined;
    content: string | undefined;
    categoryId: number;
    isPrivate: boolean;
}

export class DocumentTemplateBasicData implements IDocumentTemplateBasicData {
    name: string | undefined;
    isPrivate: boolean;
    healthProfessionalId: string | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IDocumentTemplateBasicData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPrivate = _data["isPrivate"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentTemplateBasicData {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateBasicData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPrivate"] = this.isPrivate;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): DocumentTemplateBasicData {
        const json = this.toJSON();
        let result = new DocumentTemplateBasicData();
        result.init(json);
        return result;
    }
}

export interface IDocumentTemplateBasicData {
    name: string | undefined;
    isPrivate: boolean;
    healthProfessionalId: string | undefined;
    tenantId: number;
    id: number;
}

export class DocumentTemplateDtoPagedResultDto implements IDocumentTemplateDtoPagedResultDto {
    totalCount: number;
    items: DocumentTemplateDto[] | undefined;

    constructor(data?: IDocumentTemplateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DocumentTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentTemplateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DocumentTemplateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentTemplateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTemplateDtoPagedResultDto {
    totalCount: number;
    items: DocumentTemplateDto[] | undefined;
}

export class TenantFeatureDto implements ITenantFeatureDto {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: ITenantFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }

    clone(): TenantFeatureDto {
        const json = this.toJSON();
        let result = new TenantFeatureDto();
        result.init(json);
        return result;
    }
}

export interface ITenantFeatureDto {
    name: string | undefined;
    value: string | undefined;
}

export class ToggleTenantFeaturesRequest implements IToggleTenantFeaturesRequest {
    tenantId: number;
    features: TenantFeatureDto[] | undefined;

    constructor(data?: IToggleTenantFeaturesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(TenantFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ToggleTenantFeaturesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleTenantFeaturesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ToggleTenantFeaturesRequest {
        const json = this.toJSON();
        let result = new ToggleTenantFeaturesRequest();
        result.init(json);
        return result;
    }
}

export interface IToggleTenantFeaturesRequest {
    tenantId: number;
    features: TenantFeatureDto[] | undefined;
}

export class EditionFeatureDto implements IEditionFeatureDto {
    name: string | undefined;
    text: string | undefined;
    enabled: boolean;

    constructor(data?: IEditionFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.text = _data["text"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): EditionFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["text"] = this.text;
        data["enabled"] = this.enabled;
        return data; 
    }

    clone(): EditionFeatureDto {
        const json = this.toJSON();
        let result = new EditionFeatureDto();
        result.init(json);
        return result;
    }
}

export interface IEditionFeatureDto {
    name: string | undefined;
    text: string | undefined;
    enabled: boolean;
}

export class EditionFeatureGroup implements IEditionFeatureGroup {
    name: string | undefined;
    text: string | undefined;
    features: EditionFeatureDto[] | undefined;

    constructor(data?: IEditionFeatureGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.text = _data["text"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(EditionFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionFeatureGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EditionFeatureGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["text"] = this.text;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }

    clone(): EditionFeatureGroup {
        const json = this.toJSON();
        let result = new EditionFeatureGroup();
        result.init(json);
        return result;
    }
}

export interface IEditionFeatureGroup {
    name: string | undefined;
    text: string | undefined;
    features: EditionFeatureDto[] | undefined;
}

export class EditionDto implements IEditionDto {
    name: string | undefined;
    displayName: string | undefined;
    featureGroups: EditionFeatureGroup[] | undefined;
    features: EditionFeatureDto[] | undefined;
    price: string | undefined;
    selected: boolean;
    id: number;

    constructor(data?: IEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["featureGroups"])) {
                this.featureGroups = [] as any;
                for (let item of _data["featureGroups"])
                    this.featureGroups.push(EditionFeatureGroup.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(EditionFeatureDto.fromJS(item));
            }
            this.price = _data["price"];
            this.selected = _data["selected"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.featureGroups)) {
            data["featureGroups"] = [];
            for (let item of this.featureGroups)
                data["featureGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        data["price"] = this.price;
        data["selected"] = this.selected;
        data["id"] = this.id;
        return data; 
    }

    clone(): EditionDto {
        const json = this.toJSON();
        let result = new EditionDto();
        result.init(json);
        return result;
    }
}

export interface IEditionDto {
    name: string | undefined;
    displayName: string | undefined;
    featureGroups: EditionFeatureGroup[] | undefined;
    features: EditionFeatureDto[] | undefined;
    price: string | undefined;
    selected: boolean;
    id: number;
}

export class AppointmentNotificationData implements IAppointmentNotificationData {
    id: string;
    date: moment.Moment;
    status: AppointmentStatus;
    readonly type: string | undefined;
    properties: { [key: string]: any; } | undefined;

    constructor(data?: IAppointmentNotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.status = _data["status"];
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)[key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): AppointmentNotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentNotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key];
            }
        }
        return data; 
    }

    clone(): AppointmentNotificationData {
        const json = this.toJSON();
        let result = new AppointmentNotificationData();
        result.init(json);
        return result;
    }
}

export interface IAppointmentNotificationData {
    id: string;
    date: moment.Moment;
    status: AppointmentStatus;
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export class ExaminationModelDto implements IExaminationModelDto {
    examinationDescription: string | undefined;
    description: string | undefined;
    id: string;

    constructor(data?: IExaminationModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examinationDescription = _data["examinationDescription"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExaminationModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExaminationModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examinationDescription"] = this.examinationDescription;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }

    clone(): ExaminationModelDto {
        const json = this.toJSON();
        let result = new ExaminationModelDto();
        result.init(json);
        return result;
    }
}

export interface IExaminationModelDto {
    examinationDescription: string | undefined;
    description: string | undefined;
    id: string;
}

export class GetExaminationModelsQuery implements IGetExaminationModelsQuery {
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetExaminationModelsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetExaminationModelsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetExaminationModelsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetExaminationModelsQuery {
        const json = this.toJSON();
        let result = new GetExaminationModelsQuery();
        result.init(json);
        return result;
    }
}

export interface IGetExaminationModelsQuery {
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class ExaminationModelDtoPagedResultDto implements IExaminationModelDtoPagedResultDto {
    totalCount: number;
    items: ExaminationModelDto[] | undefined;

    constructor(data?: IExaminationModelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ExaminationModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExaminationModelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExaminationModelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ExaminationModelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ExaminationModelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IExaminationModelDtoPagedResultDto {
    totalCount: number;
    items: ExaminationModelDto[] | undefined;
}

export class CreateExaminationModelRequest implements ICreateExaminationModelRequest {
    examinationDescription: string | undefined;
    description: string | undefined;

    constructor(data?: ICreateExaminationModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examinationDescription = _data["examinationDescription"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateExaminationModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExaminationModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examinationDescription"] = this.examinationDescription;
        data["description"] = this.description;
        return data; 
    }

    clone(): CreateExaminationModelRequest {
        const json = this.toJSON();
        let result = new CreateExaminationModelRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateExaminationModelRequest {
    examinationDescription: string | undefined;
    description: string | undefined;
}

export class UpdateExaminationModelRequest implements IUpdateExaminationModelRequest {
    id: string;
    examinationDescription: string | undefined;
    description: string | undefined;

    constructor(data?: IUpdateExaminationModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.examinationDescription = _data["examinationDescription"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateExaminationModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExaminationModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["examinationDescription"] = this.examinationDescription;
        data["description"] = this.description;
        return data; 
    }

    clone(): UpdateExaminationModelRequest {
        const json = this.toJSON();
        let result = new UpdateExaminationModelRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateExaminationModelRequest {
    id: string;
    examinationDescription: string | undefined;
    description: string | undefined;
}

export class BirthInfoData implements IBirthInfoData {
    gestationalAge: number | undefined;
    nextYoungerSiblingBirth: moment.Moment | undefined;
    /** In milligrams */
    weight: number | undefined;
    /** In cm */
    height: number | undefined;
    imc: number | undefined;
    /** In cm */
    headCircumference: number | undefined;
    rank: number | undefined;
    readonly isValid: boolean;

    constructor(data?: IBirthInfoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gestationalAge = _data["gestationalAge"];
            this.nextYoungerSiblingBirth = _data["nextYoungerSiblingBirth"] ? moment(_data["nextYoungerSiblingBirth"].toString()) : <any>undefined;
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.imc = _data["imc"];
            this.headCircumference = _data["headCircumference"];
            this.rank = _data["rank"];
            (<any>this).isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): BirthInfoData {
        data = typeof data === 'object' ? data : {};
        let result = new BirthInfoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gestationalAge"] = this.gestationalAge;
        data["nextYoungerSiblingBirth"] = this.nextYoungerSiblingBirth ? this.nextYoungerSiblingBirth.toISOString() : <any>undefined;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["imc"] = this.imc;
        data["headCircumference"] = this.headCircumference;
        data["rank"] = this.rank;
        data["isValid"] = this.isValid;
        return data; 
    }

    clone(): BirthInfoData {
        const json = this.toJSON();
        let result = new BirthInfoData();
        result.init(json);
        return result;
    }
}

export interface IBirthInfoData {
    gestationalAge: number | undefined;
    nextYoungerSiblingBirth: moment.Moment | undefined;
    /** In milligrams */
    weight: number | undefined;
    /** In cm */
    height: number | undefined;
    imc: number | undefined;
    /** In cm */
    headCircumference: number | undefined;
    rank: number | undefined;
    isValid: boolean;
}

export class PatientInsuranceInfo implements IPatientInsuranceInfo {
    id: number | undefined;
    name: string | undefined;
    number: string | undefined;
    isCompany: boolean | undefined;

    constructor(data?: IPatientInsuranceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.isCompany = _data["isCompany"];
        }
    }

    static fromJS(data: any): PatientInsuranceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInsuranceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        data["isCompany"] = this.isCompany;
        return data; 
    }

    clone(): PatientInsuranceInfo {
        const json = this.toJSON();
        let result = new PatientInsuranceInfo();
        result.init(json);
        return result;
    }
}

export interface IPatientInsuranceInfo {
    id: number | undefined;
    name: string | undefined;
    number: string | undefined;
    isCompany: boolean | undefined;
}

export class PersonData implements IPersonData {
    name: string | undefined;
    phoneNumber: string | undefined;

    constructor(data?: IPersonData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): PersonData {
        data = typeof data === 'object' ? data : {};
        let result = new PersonData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }

    clone(): PersonData {
        const json = this.toJSON();
        let result = new PersonData();
        result.init(json);
        return result;
    }
}

export interface IPersonData {
    name: string | undefined;
    phoneNumber: string | undefined;
}

export enum PatientStatus {
    _1 = 1,
    _2 = 2,
}

export class PatientDto implements IPatientDto {
    tenantId: number;
    userId: number;
    user: UserDto;
    address: Address;
    bloodType: string | undefined;
    weight: string | undefined;
    height: string | undefined;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    comments: string | undefined;
    name: string | undefined;
    gender: number;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    phone: string | undefined;
    readonly alreadyIsPatient: boolean;
    readonly isExample: boolean;
    birthInfo: BirthInfoData;
    insurance: PatientInsuranceInfo;
    mother: PersonData;
    father: PersonData;
    partner: PersonData;
    sponsor: PersonData;
    tags: number[] | undefined;
    externalId: string | undefined;
    status: PatientStatus;
    sequentialNumber: number;
    profession: string | undefined;
    photo: string | undefined;
    id: string;

    constructor(data?: IPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.bloodType = _data["bloodType"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.dni = _data["dni"];
            this.comments = _data["comments"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.phone = _data["phone"];
            (<any>this).alreadyIsPatient = _data["alreadyIsPatient"];
            (<any>this).isExample = _data["isExample"];
            this.birthInfo = _data["birthInfo"] ? BirthInfoData.fromJS(_data["birthInfo"]) : <any>undefined;
            this.insurance = _data["insurance"] ? PatientInsuranceInfo.fromJS(_data["insurance"]) : <any>undefined;
            this.mother = _data["mother"] ? PersonData.fromJS(_data["mother"]) : <any>undefined;
            this.father = _data["father"] ? PersonData.fromJS(_data["father"]) : <any>undefined;
            this.partner = _data["partner"] ? PersonData.fromJS(_data["partner"]) : <any>undefined;
            this.sponsor = _data["sponsor"] ? PersonData.fromJS(_data["sponsor"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.externalId = _data["externalId"];
            this.status = _data["status"];
            this.sequentialNumber = _data["sequentialNumber"];
            this.profession = _data["profession"];
            this.photo = _data["photo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["bloodType"] = this.bloodType;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["personalIdentifier"] = this.personalIdentifier;
        data["dni"] = this.dni;
        data["comments"] = this.comments;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["alreadyIsPatient"] = this.alreadyIsPatient;
        data["isExample"] = this.isExample;
        data["birthInfo"] = this.birthInfo ? this.birthInfo.toJSON() : <any>undefined;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>undefined;
        data["mother"] = this.mother ? this.mother.toJSON() : <any>undefined;
        data["father"] = this.father ? this.father.toJSON() : <any>undefined;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        data["sponsor"] = this.sponsor ? this.sponsor.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["externalId"] = this.externalId;
        data["status"] = this.status;
        data["sequentialNumber"] = this.sequentialNumber;
        data["profession"] = this.profession;
        data["photo"] = this.photo;
        data["id"] = this.id;
        return data; 
    }

    clone(): PatientDto {
        const json = this.toJSON();
        let result = new PatientDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDto {
    tenantId: number;
    userId: number;
    user: UserDto;
    address: Address;
    bloodType: string | undefined;
    weight: string | undefined;
    height: string | undefined;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    comments: string | undefined;
    name: string | undefined;
    gender: number;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    phone: string | undefined;
    alreadyIsPatient: boolean;
    isExample: boolean;
    birthInfo: BirthInfoData;
    insurance: PatientInsuranceInfo;
    mother: PersonData;
    father: PersonData;
    partner: PersonData;
    sponsor: PersonData;
    tags: number[] | undefined;
    externalId: string | undefined;
    status: PatientStatus;
    sequentialNumber: number;
    profession: string | undefined;
    photo: string | undefined;
    id: string;
}

export class ExaminationDto implements IExaminationDto {
    creator: DoctorDto;
    doctorId: string;
    patient: PatientDto;
    examinationDescription: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IExaminationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creator = _data["creator"] ? DoctorDto.fromJS(_data["creator"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.examinationDescription = _data["examinationDescription"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExaminationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExaminationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["examinationDescription"] = this.examinationDescription;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ExaminationDto {
        const json = this.toJSON();
        let result = new ExaminationDto();
        result.init(json);
        return result;
    }
}

export interface IExaminationDto {
    creator: DoctorDto;
    doctorId: string;
    patient: PatientDto;
    examinationDescription: string | undefined;
    description: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreateExaminationDto implements ICreateExaminationDto {
    examinationDescription: string | undefined;
    patientId: string;
    description: string | undefined;
    modelId: string;
    saveModel: boolean;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICreateExaminationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examinationDescription = _data["examinationDescription"];
            this.patientId = _data["patientId"];
            this.description = _data["description"];
            this.modelId = _data["modelId"];
            this.saveModel = _data["saveModel"];
            this.signDigitally = _data["signDigitally"];
            if (Array.isArray(_data["selectedSpecialties"])) {
                this.selectedSpecialties = [] as any;
                for (let item of _data["selectedSpecialties"])
                    this.selectedSpecialties.push(DoctorSpecialty.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateExaminationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExaminationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examinationDescription"] = this.examinationDescription;
        data["patientId"] = this.patientId;
        data["description"] = this.description;
        data["modelId"] = this.modelId;
        data["saveModel"] = this.saveModel;
        data["signDigitally"] = this.signDigitally;
        if (Array.isArray(this.selectedSpecialties)) {
            data["selectedSpecialties"] = [];
            for (let item of this.selectedSpecialties)
                data["selectedSpecialties"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateExaminationDto {
        const json = this.toJSON();
        let result = new CreateExaminationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateExaminationDto {
    examinationDescription: string | undefined;
    patientId: string;
    description: string | undefined;
    modelId: string;
    saveModel: boolean;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class UpdateExaminationRequest implements IUpdateExaminationRequest {
    examinationDescription: string | undefined;
    description: string | undefined;
    id: string;

    constructor(data?: IUpdateExaminationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examinationDescription = _data["examinationDescription"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateExaminationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExaminationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examinationDescription"] = this.examinationDescription;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateExaminationRequest {
        const json = this.toJSON();
        let result = new UpdateExaminationRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateExaminationRequest {
    examinationDescription: string | undefined;
    description: string | undefined;
    id: string;
}

export class IsReadyToRequestExamsDto implements IIsReadyToRequestExamsDto {
    isReady: boolean;
    notAllowed: boolean;
    missingConfiguration: boolean;
    info: DoctorDto;

    constructor(data?: IIsReadyToRequestExamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isReady = _data["isReady"];
            this.notAllowed = _data["notAllowed"];
            this.missingConfiguration = _data["missingConfiguration"];
            this.info = _data["info"] ? DoctorDto.fromJS(_data["info"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IsReadyToRequestExamsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsReadyToRequestExamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReady"] = this.isReady;
        data["notAllowed"] = this.notAllowed;
        data["missingConfiguration"] = this.missingConfiguration;
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        return data; 
    }

    clone(): IsReadyToRequestExamsDto {
        const json = this.toJSON();
        let result = new IsReadyToRequestExamsDto();
        result.init(json);
        return result;
    }
}

export interface IIsReadyToRequestExamsDto {
    isReady: boolean;
    notAllowed: boolean;
    missingConfiguration: boolean;
    info: DoctorDto;
}

export class FeatureDto implements IFeatureDto {
    name: string | undefined;
    definition: string | undefined;
    title: string | undefined;
    icon: string | undefined;
    id: string;

    constructor(data?: IFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.definition = _data["definition"];
            this.title = _data["title"];
            this.icon = _data["icon"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["definition"] = this.definition;
        data["title"] = this.title;
        data["icon"] = this.icon;
        data["id"] = this.id;
        return data; 
    }

    clone(): FeatureDto {
        const json = this.toJSON();
        let result = new FeatureDto();
        result.init(json);
        return result;
    }
}

export interface IFeatureDto {
    name: string | undefined;
    definition: string | undefined;
    title: string | undefined;
    icon: string | undefined;
    id: string;
}

export enum BusinessType {
    _1 = 1,
}

export class FiscalInfo implements IFiscalInfo {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    paymentKey: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;

    constructor(data?: IFiscalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.paymentKey = _data["paymentKey"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberExtension = _data["phoneNumberExtension"];
            this.email = _data["email"];
            this.postalCode = _data["postalCode"];
            this.formattedAddress = _data["formattedAddress"];
            this.reference = _data["reference"];
            this.complement = _data["complement"];
            this.number = _data["number"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): FiscalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FiscalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["paymentKey"] = this.paymentKey;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberExtension"] = this.phoneNumberExtension;
        data["email"] = this.email;
        data["postalCode"] = this.postalCode;
        data["formattedAddress"] = this.formattedAddress;
        data["reference"] = this.reference;
        data["complement"] = this.complement;
        data["number"] = this.number;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        return data; 
    }

    clone(): FiscalInfo {
        const json = this.toJSON();
        let result = new FiscalInfo();
        result.init(json);
        return result;
    }
}

export interface IFiscalInfo {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    paymentKey: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
}

export class PaymentInfo implements IPaymentInfo {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;

    constructor(data?: IPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberExtension = _data["phoneNumberExtension"];
            this.email = _data["email"];
            this.postalCode = _data["postalCode"];
            this.formattedAddress = _data["formattedAddress"];
            this.reference = _data["reference"];
            this.complement = _data["complement"];
            this.number = _data["number"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): PaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberExtension"] = this.phoneNumberExtension;
        data["email"] = this.email;
        data["postalCode"] = this.postalCode;
        data["formattedAddress"] = this.formattedAddress;
        data["reference"] = this.reference;
        data["complement"] = this.complement;
        data["number"] = this.number;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        return data; 
    }

    clone(): PaymentInfo {
        const json = this.toJSON();
        let result = new PaymentInfo();
        result.init(json);
        return result;
    }
}

export interface IPaymentInfo {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
}

export enum BillingCycle {
    _0 = 0,
    _1 = 1,
    _12 = 12,
}

export enum CreatorProfile {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
}

export class Feature implements IFeature {
    project: MobileProject;
    name: string | undefined;
    definition: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? MobileProject.fromJS(_data["project"]) : <any>undefined;
            this.name = _data["name"];
            this.definition = _data["definition"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): Feature {
        data = typeof data === 'object' ? data : {};
        let result = new Feature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["definition"] = this.definition;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): Feature {
        const json = this.toJSON();
        let result = new Feature();
        result.init(json);
        return result;
    }
}

export interface IFeature {
    project: MobileProject;
    name: string | undefined;
    definition: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class Apns implements IApns {
    bundleId: string | undefined;
    teamId: string | undefined;
    keyId: string | undefined;
    token: string | undefined;

    constructor(data?: IApns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bundleId = _data["bundleId"];
            this.teamId = _data["teamId"];
            this.keyId = _data["keyId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): Apns {
        data = typeof data === 'object' ? data : {};
        let result = new Apns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bundleId"] = this.bundleId;
        data["teamId"] = this.teamId;
        data["keyId"] = this.keyId;
        data["token"] = this.token;
        return data; 
    }

    clone(): Apns {
        const json = this.toJSON();
        let result = new Apns();
        result.init(json);
        return result;
    }
}

export interface IApns {
    bundleId: string | undefined;
    teamId: string | undefined;
    keyId: string | undefined;
    token: string | undefined;
}

export class Fcm implements IFcm {
    apiKey: string | undefined;

    constructor(data?: IFcm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): Fcm {
        data = typeof data === 'object' ? data : {};
        let result = new Fcm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        return data; 
    }

    clone(): Fcm {
        const json = this.toJSON();
        let result = new Fcm();
        result.init(json);
        return result;
    }
}

export interface IFcm {
    apiKey: string | undefined;
}

export class MobileProject implements IMobileProject {
    tenant: Tenant;
    name: string | undefined;
    iconImage: string | undefined;
    requestIconImage: boolean;
    brandImage: string | undefined;
    requestBrandImage: boolean;
    definition: string | undefined;
    storesInfo: string | undefined;
    appKey: string | undefined;
    features: Feature[] | undefined;
    completed: boolean;
    appStoreQrCodeLinkId: string | undefined;
    appStoreLink: string | undefined;
    googlePlayQrCodeLinkId: string | undefined;
    googlePlayLink: string | undefined;
    apns: Apns;
    fcm: Fcm;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IMobileProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.name = _data["name"];
            this.iconImage = _data["iconImage"];
            this.requestIconImage = _data["requestIconImage"];
            this.brandImage = _data["brandImage"];
            this.requestBrandImage = _data["requestBrandImage"];
            this.definition = _data["definition"];
            this.storesInfo = _data["storesInfo"];
            this.appKey = _data["appKey"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(Feature.fromJS(item));
            }
            this.completed = _data["completed"];
            this.appStoreQrCodeLinkId = _data["appStoreQrCodeLinkId"];
            this.appStoreLink = _data["appStoreLink"];
            this.googlePlayQrCodeLinkId = _data["googlePlayQrCodeLinkId"];
            this.googlePlayLink = _data["googlePlayLink"];
            this.apns = _data["apns"] ? Apns.fromJS(_data["apns"]) : <any>undefined;
            this.fcm = _data["fcm"] ? Fcm.fromJS(_data["fcm"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): MobileProject {
        data = typeof data === 'object' ? data : {};
        let result = new MobileProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["iconImage"] = this.iconImage;
        data["requestIconImage"] = this.requestIconImage;
        data["brandImage"] = this.brandImage;
        data["requestBrandImage"] = this.requestBrandImage;
        data["definition"] = this.definition;
        data["storesInfo"] = this.storesInfo;
        data["appKey"] = this.appKey;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        data["completed"] = this.completed;
        data["appStoreQrCodeLinkId"] = this.appStoreQrCodeLinkId;
        data["appStoreLink"] = this.appStoreLink;
        data["googlePlayQrCodeLinkId"] = this.googlePlayQrCodeLinkId;
        data["googlePlayLink"] = this.googlePlayLink;
        data["apns"] = this.apns ? this.apns.toJSON() : <any>undefined;
        data["fcm"] = this.fcm ? this.fcm.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): MobileProject {
        const json = this.toJSON();
        let result = new MobileProject();
        result.init(json);
        return result;
    }
}

export interface IMobileProject {
    tenant: Tenant;
    name: string | undefined;
    iconImage: string | undefined;
    requestIconImage: boolean;
    brandImage: string | undefined;
    requestBrandImage: boolean;
    definition: string | undefined;
    storesInfo: string | undefined;
    appKey: string | undefined;
    features: Feature[] | undefined;
    completed: boolean;
    appStoreQrCodeLinkId: string | undefined;
    appStoreLink: string | undefined;
    googlePlayQrCodeLinkId: string | undefined;
    googlePlayLink: string | undefined;
    apns: Apns;
    fcm: Fcm;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class Edition implements IEdition {
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Edition {
        data = typeof data === 'object' ? data : {};
        let result = new Edition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Edition {
        const json = this.toJSON();
        let result = new Edition();
        result.init(json);
        return result;
    }
}

export interface IEdition {
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Tenant implements ITenant {
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: FiscalInfo;
    paymentInfo: PaymentInfo;
    billingCycle: BillingCycle;
    externalId: number;
    activePaymentProfile: number;
    activeSubscription: number;
    pickedPlan: boolean;
    activationTime: moment.Moment | undefined;
    domain: string | undefined;
    systemDomain: string | undefined;
    apiKey: string | undefined;
    creatorProfile: CreatorProfile;
    mobileProject: MobileProject;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.fixedPhone = _data["fixedPhone"];
            this.email = _data["email"];
            this.businessType = _data["businessType"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.fiscalInfo = _data["fiscalInfo"] ? FiscalInfo.fromJS(_data["fiscalInfo"]) : <any>undefined;
            this.paymentInfo = _data["paymentInfo"] ? PaymentInfo.fromJS(_data["paymentInfo"]) : <any>undefined;
            this.billingCycle = _data["billingCycle"];
            this.externalId = _data["externalId"];
            this.activePaymentProfile = _data["activePaymentProfile"];
            this.activeSubscription = _data["activeSubscription"];
            this.pickedPlan = _data["pickedPlan"];
            this.activationTime = _data["activationTime"] ? moment(_data["activationTime"].toString()) : <any>undefined;
            this.domain = _data["domain"];
            this.systemDomain = _data["systemDomain"];
            this.apiKey = _data["apiKey"];
            this.creatorProfile = _data["creatorProfile"];
            this.mobileProject = _data["mobileProject"] ? MobileProject.fromJS(_data["mobileProject"]) : <any>undefined;
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"]) : <any>undefined;
            this.editionId = _data["editionId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["phoneNumber"] = this.phoneNumber;
        data["fixedPhone"] = this.fixedPhone;
        data["email"] = this.email;
        data["businessType"] = this.businessType;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fiscalInfo"] = this.fiscalInfo ? this.fiscalInfo.toJSON() : <any>undefined;
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        data["billingCycle"] = this.billingCycle;
        data["externalId"] = this.externalId;
        data["activePaymentProfile"] = this.activePaymentProfile;
        data["activeSubscription"] = this.activeSubscription;
        data["pickedPlan"] = this.pickedPlan;
        data["activationTime"] = this.activationTime ? this.activationTime.toISOString() : <any>undefined;
        data["domain"] = this.domain;
        data["systemDomain"] = this.systemDomain;
        data["apiKey"] = this.apiKey;
        data["creatorProfile"] = this.creatorProfile;
        data["mobileProject"] = this.mobileProject ? this.mobileProject.toJSON() : <any>undefined;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["editionId"] = this.editionId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Tenant {
        const json = this.toJSON();
        let result = new Tenant();
        result.init(json);
        return result;
    }
}

export interface ITenant {
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: FiscalInfo;
    paymentInfo: PaymentInfo;
    billingCycle: BillingCycle;
    externalId: number;
    activePaymentProfile: number;
    activeSubscription: number;
    pickedPlan: boolean;
    activationTime: moment.Moment | undefined;
    domain: string | undefined;
    systemDomain: string | undefined;
    apiKey: string | undefined;
    creatorProfile: CreatorProfile;
    mobileProject: MobileProject;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TenantAccess implements ITenantAccess {
    user: User;
    userId: number;
    tenant: Tenant;
    lock: boolean;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: ITenantAccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.lock = _data["lock"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): TenantAccess {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["lock"] = this.lock;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): TenantAccess {
        const json = this.toJSON();
        let result = new TenantAccess();
        result.init(json);
        return result;
    }
}

export interface ITenantAccess {
    user: User;
    userId: number;
    tenant: Tenant;
    lock: boolean;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class UserToken implements IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class User implements IUser {
    personalIdentifier: string | undefined;
    birthday: moment.Moment;
    avatar: string | undefined;
    genderOld: boolean | undefined;
    gender: number | undefined;
    tenantAccesses: TenantAccess[] | undefined;
    phoneNumberConfirmationCode: string | undefined;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalIdentifier = _data["personalIdentifier"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.avatar = _data["avatar"];
            this.genderOld = _data["genderOld"];
            this.gender = _data["gender"];
            if (Array.isArray(_data["tenantAccesses"])) {
                this.tenantAccesses = [] as any;
                for (let item of _data["tenantAccesses"])
                    this.tenantAccesses.push(TenantAccess.fromJS(item));
            }
            this.phoneNumberConfirmationCode = _data["phoneNumberConfirmationCode"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalIdentifier"] = this.personalIdentifier;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["avatar"] = this.avatar;
        data["genderOld"] = this.genderOld;
        data["gender"] = this.gender;
        if (Array.isArray(this.tenantAccesses)) {
            data["tenantAccesses"] = [];
            for (let item of this.tenantAccesses)
                data["tenantAccesses"].push(item.toJSON());
        }
        data["phoneNumberConfirmationCode"] = this.phoneNumberConfirmationCode;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    personalIdentifier: string | undefined;
    birthday: moment.Moment;
    avatar: string | undefined;
    genderOld: boolean | undefined;
    gender: number | undefined;
    tenantAccesses: TenantAccess[] | undefined;
    phoneNumberConfirmationCode: string | undefined;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class FileItemDraft implements IFileItemDraft {
    tenantId: number;
    ownerPatient: string;
    name: string | undefined;
    content: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IFileItemDraft) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.ownerPatient = _data["ownerPatient"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): FileItemDraft {
        data = typeof data === 'object' ? data : {};
        let result = new FileItemDraft();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["ownerPatient"] = this.ownerPatient;
        data["name"] = this.name;
        data["content"] = this.content;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): FileItemDraft {
        const json = this.toJSON();
        let result = new FileItemDraft();
        result.init(json);
        return result;
    }
}

export interface IFileItemDraft {
    tenantId: number;
    ownerPatient: string;
    name: string | undefined;
    content: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class CreateFileRequest implements ICreateFileRequest {
    parent: string;
    title: string | undefined;
    fileContent: string | undefined;
    ownerPatient: string;
    ownerUser: number | undefined;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICreateFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent = _data["parent"];
            this.title = _data["title"];
            this.fileContent = _data["fileContent"];
            this.ownerPatient = _data["ownerPatient"];
            this.ownerUser = _data["ownerUser"];
            this.signDigitally = _data["signDigitally"];
            if (Array.isArray(_data["selectedSpecialties"])) {
                this.selectedSpecialties = [] as any;
                for (let item of _data["selectedSpecialties"])
                    this.selectedSpecialties.push(DoctorSpecialty.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent"] = this.parent;
        data["title"] = this.title;
        data["fileContent"] = this.fileContent;
        data["ownerPatient"] = this.ownerPatient;
        data["ownerUser"] = this.ownerUser;
        data["signDigitally"] = this.signDigitally;
        if (Array.isArray(this.selectedSpecialties)) {
            data["selectedSpecialties"] = [];
            for (let item of this.selectedSpecialties)
                data["selectedSpecialties"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateFileRequest {
        const json = this.toJSON();
        let result = new CreateFileRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateFileRequest {
    parent: string;
    title: string | undefined;
    fileContent: string | undefined;
    ownerPatient: string;
    ownerUser: number | undefined;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class UpdateFileRequest implements IUpdateFileRequest {
    title: string | undefined;
    content: string | undefined;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdateFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
            this.signDigitally = _data["signDigitally"];
            if (Array.isArray(_data["selectedSpecialties"])) {
                this.selectedSpecialties = [] as any;
                for (let item of _data["selectedSpecialties"])
                    this.selectedSpecialties.push(DoctorSpecialty.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["signDigitally"] = this.signDigitally;
        if (Array.isArray(this.selectedSpecialties)) {
            data["selectedSpecialties"] = [];
            for (let item of this.selectedSpecialties)
                data["selectedSpecialties"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateFileRequest {
        const json = this.toJSON();
        let result = new UpdateFileRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateFileRequest {
    title: string | undefined;
    content: string | undefined;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class RenameFileRequest implements IRenameFileRequest {
    id: string;
    name: string | undefined;
    ownerUser: number | undefined;
    ownerPatient: string;

    constructor(data?: IRenameFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ownerUser = _data["ownerUser"];
            this.ownerPatient = _data["ownerPatient"];
        }
    }

    static fromJS(data: any): RenameFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ownerUser"] = this.ownerUser;
        data["ownerPatient"] = this.ownerPatient;
        return data; 
    }

    clone(): RenameFileRequest {
        const json = this.toJSON();
        let result = new RenameFileRequest();
        result.init(json);
        return result;
    }
}

export interface IRenameFileRequest {
    id: string;
    name: string | undefined;
    ownerUser: number | undefined;
    ownerPatient: string;
}

export class RenameFileResponse implements IRenameFileResponse {
    tenantId: number;
    projectId: string;
    name: string | undefined;
    parent: string;
    path: string | undefined;
    system: boolean;
    isReadOnly: boolean;
    size: number;
    isHidden: boolean;
    key: string | undefined;
    isOwner: boolean;
    readonly allowDelete: boolean;
    isDirectory: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    readonly allowMove: boolean;

    constructor(data?: IRenameFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.parent = _data["parent"];
            this.path = _data["path"];
            this.system = _data["system"];
            this.isReadOnly = _data["isReadOnly"];
            this.size = _data["size"];
            this.isHidden = _data["isHidden"];
            this.key = _data["key"];
            this.isOwner = _data["isOwner"];
            (<any>this).allowDelete = _data["allowDelete"];
            this.isDirectory = _data["isDirectory"];
            this.ownerUser = _data["ownerUser"];
            this.ownerPatient = _data["ownerPatient"];
            (<any>this).allowMove = _data["allowMove"];
        }
    }

    static fromJS(data: any): RenameFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenameFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["parent"] = this.parent;
        data["path"] = this.path;
        data["system"] = this.system;
        data["isReadOnly"] = this.isReadOnly;
        data["size"] = this.size;
        data["isHidden"] = this.isHidden;
        data["key"] = this.key;
        data["isOwner"] = this.isOwner;
        data["allowDelete"] = this.allowDelete;
        data["isDirectory"] = this.isDirectory;
        data["ownerUser"] = this.ownerUser;
        data["ownerPatient"] = this.ownerPatient;
        data["allowMove"] = this.allowMove;
        return data; 
    }

    clone(): RenameFileResponse {
        const json = this.toJSON();
        let result = new RenameFileResponse();
        result.init(json);
        return result;
    }
}

export interface IRenameFileResponse {
    tenantId: number;
    projectId: string;
    name: string | undefined;
    parent: string;
    path: string | undefined;
    system: boolean;
    isReadOnly: boolean;
    size: number;
    isHidden: boolean;
    key: string | undefined;
    isOwner: boolean;
    allowDelete: boolean;
    isDirectory: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    allowMove: boolean;
}

export class TemporalFileDto implements ITemporalFileDto {
    name: string | undefined;
    url: string | undefined;
    fileSize: number;

    constructor(data?: ITemporalFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): TemporalFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemporalFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["fileSize"] = this.fileSize;
        return data; 
    }

    clone(): TemporalFileDto {
        const json = this.toJSON();
        let result = new TemporalFileDto();
        result.init(json);
        return result;
    }
}

export interface ITemporalFileDto {
    name: string | undefined;
    url: string | undefined;
    fileSize: number;
}

export class TemporalDocumentFileDto implements ITemporalDocumentFileDto {
    document: TemporalFileDto;
    pdf: TemporalFileDto;

    constructor(data?: ITemporalDocumentFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? TemporalFileDto.fromJS(_data["document"]) : <any>undefined;
            this.pdf = _data["pdf"] ? TemporalFileDto.fromJS(_data["pdf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TemporalDocumentFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemporalDocumentFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["pdf"] = this.pdf ? this.pdf.toJSON() : <any>undefined;
        return data; 
    }

    clone(): TemporalDocumentFileDto {
        const json = this.toJSON();
        let result = new TemporalDocumentFileDto();
        result.init(json);
        return result;
    }
}

export interface ITemporalDocumentFileDto {
    document: TemporalFileDto;
    pdf: TemporalFileDto;
}

export class FileSystemFile implements IFileSystemFile {
    /** Path of the thumb file */
    thumb: string | undefined;
    /** If it's a file, mimetype of the content */
    mimeType: string | undefined;
    content: string | undefined;
    contentEditable: boolean;
    /** Related to */
    tenantId: number;
    /** Related to project */
    projectId: string;
    /** Name */
    name: string | undefined;
    /** Parent's container */
    parent: string;
    /** Path of the folder or file on the FileSystem */
    path: string | undefined;
    /** System's folders, or files */
    system: boolean;
    /** Can the file be edited/deleted */
    isReadOnly: boolean;
    /** File's size */
    size: number;
    isHidden: boolean;
    key: string | undefined;
    isOwner: boolean;
    readonly allowDelete: boolean;
    isDirectory: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    readonly allowMove: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IFileSystemFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thumb = _data["thumb"];
            this.mimeType = _data["mimeType"];
            this.content = _data["content"];
            this.contentEditable = _data["contentEditable"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.parent = _data["parent"];
            this.path = _data["path"];
            this.system = _data["system"];
            this.isReadOnly = _data["isReadOnly"];
            this.size = _data["size"];
            this.isHidden = _data["isHidden"];
            this.key = _data["key"];
            this.isOwner = _data["isOwner"];
            (<any>this).allowDelete = _data["allowDelete"];
            this.isDirectory = _data["isDirectory"];
            this.ownerUser = _data["ownerUser"];
            this.ownerPatient = _data["ownerPatient"];
            (<any>this).allowMove = _data["allowMove"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FileSystemFile {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thumb"] = this.thumb;
        data["mimeType"] = this.mimeType;
        data["content"] = this.content;
        data["contentEditable"] = this.contentEditable;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["parent"] = this.parent;
        data["path"] = this.path;
        data["system"] = this.system;
        data["isReadOnly"] = this.isReadOnly;
        data["size"] = this.size;
        data["isHidden"] = this.isHidden;
        data["key"] = this.key;
        data["isOwner"] = this.isOwner;
        data["allowDelete"] = this.allowDelete;
        data["isDirectory"] = this.isDirectory;
        data["ownerUser"] = this.ownerUser;
        data["ownerPatient"] = this.ownerPatient;
        data["allowMove"] = this.allowMove;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): FileSystemFile {
        const json = this.toJSON();
        let result = new FileSystemFile();
        result.init(json);
        return result;
    }
}

export interface IFileSystemFile {
    /** Path of the thumb file */
    thumb: string | undefined;
    /** If it's a file, mimetype of the content */
    mimeType: string | undefined;
    content: string | undefined;
    contentEditable: boolean;
    /** Related to */
    tenantId: number;
    /** Related to project */
    projectId: string;
    /** Name */
    name: string | undefined;
    /** Parent's container */
    parent: string;
    /** Path of the folder or file on the FileSystem */
    path: string | undefined;
    /** System's folders, or files */
    system: boolean;
    /** Can the file be edited/deleted */
    isReadOnly: boolean;
    /** File's size */
    size: number;
    isHidden: boolean;
    key: string | undefined;
    isOwner: boolean;
    allowDelete: boolean;
    isDirectory: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    allowMove: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class FileSystemFolder implements IFileSystemFolder {
    folders: FileSystemFolder[] | undefined;
    files: FileSystemFile[] | undefined;
    uploadedFile: string;
    uploadedFileName: string | undefined;
    uploadedFilePath: string | undefined;
    highlighted: boolean;
    icon: string | undefined;
    order: number;
    /** Related to */
    tenantId: number;
    /** Related to project */
    projectId: string;
    /** Name */
    name: string | undefined;
    /** Parent's container */
    parent: string;
    /** Path of the folder or file on the FileSystem */
    path: string | undefined;
    /** System's folders, or files */
    system: boolean;
    /** Can the file be edited/deleted */
    isReadOnly: boolean;
    /** File's size */
    size: number;
    isHidden: boolean;
    key: string | undefined;
    isOwner: boolean;
    readonly allowDelete: boolean;
    isDirectory: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    readonly allowMove: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IFileSystemFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders.push(FileSystemFolder.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(FileSystemFile.fromJS(item));
            }
            this.uploadedFile = _data["uploadedFile"];
            this.uploadedFileName = _data["uploadedFileName"];
            this.uploadedFilePath = _data["uploadedFilePath"];
            this.highlighted = _data["highlighted"];
            this.icon = _data["icon"];
            this.order = _data["order"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.parent = _data["parent"];
            this.path = _data["path"];
            this.system = _data["system"];
            this.isReadOnly = _data["isReadOnly"];
            this.size = _data["size"];
            this.isHidden = _data["isHidden"];
            this.key = _data["key"];
            this.isOwner = _data["isOwner"];
            (<any>this).allowDelete = _data["allowDelete"];
            this.isDirectory = _data["isDirectory"];
            this.ownerUser = _data["ownerUser"];
            this.ownerPatient = _data["ownerPatient"];
            (<any>this).allowMove = _data["allowMove"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FileSystemFolder {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemFolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["uploadedFile"] = this.uploadedFile;
        data["uploadedFileName"] = this.uploadedFileName;
        data["uploadedFilePath"] = this.uploadedFilePath;
        data["highlighted"] = this.highlighted;
        data["icon"] = this.icon;
        data["order"] = this.order;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["parent"] = this.parent;
        data["path"] = this.path;
        data["system"] = this.system;
        data["isReadOnly"] = this.isReadOnly;
        data["size"] = this.size;
        data["isHidden"] = this.isHidden;
        data["key"] = this.key;
        data["isOwner"] = this.isOwner;
        data["allowDelete"] = this.allowDelete;
        data["isDirectory"] = this.isDirectory;
        data["ownerUser"] = this.ownerUser;
        data["ownerPatient"] = this.ownerPatient;
        data["allowMove"] = this.allowMove;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): FileSystemFolder {
        const json = this.toJSON();
        let result = new FileSystemFolder();
        result.init(json);
        return result;
    }
}

export interface IFileSystemFolder {
    folders: FileSystemFolder[] | undefined;
    files: FileSystemFile[] | undefined;
    uploadedFile: string;
    uploadedFileName: string | undefined;
    uploadedFilePath: string | undefined;
    highlighted: boolean;
    icon: string | undefined;
    order: number;
    /** Related to */
    tenantId: number;
    /** Related to project */
    projectId: string;
    /** Name */
    name: string | undefined;
    /** Parent's container */
    parent: string;
    /** Path of the folder or file on the FileSystem */
    path: string | undefined;
    /** System's folders, or files */
    system: boolean;
    /** Can the file be edited/deleted */
    isReadOnly: boolean;
    /** File's size */
    size: number;
    isHidden: boolean;
    key: string | undefined;
    isOwner: boolean;
    allowDelete: boolean;
    isDirectory: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    allowMove: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class UploadMultipleResponse implements IUploadMultipleResponse {
    filesUploaded: boolean;
    temporaryDocumentFiles: TemporalDocumentFileDto[] | undefined;
    parentFolder: FileSystemFolder;

    constructor(data?: IUploadMultipleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filesUploaded = _data["filesUploaded"];
            if (Array.isArray(_data["temporaryDocumentFiles"])) {
                this.temporaryDocumentFiles = [] as any;
                for (let item of _data["temporaryDocumentFiles"])
                    this.temporaryDocumentFiles.push(TemporalDocumentFileDto.fromJS(item));
            }
            this.parentFolder = _data["parentFolder"] ? FileSystemFolder.fromJS(_data["parentFolder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadMultipleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadMultipleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filesUploaded"] = this.filesUploaded;
        if (Array.isArray(this.temporaryDocumentFiles)) {
            data["temporaryDocumentFiles"] = [];
            for (let item of this.temporaryDocumentFiles)
                data["temporaryDocumentFiles"].push(item.toJSON());
        }
        data["parentFolder"] = this.parentFolder ? this.parentFolder.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UploadMultipleResponse {
        const json = this.toJSON();
        let result = new UploadMultipleResponse();
        result.init(json);
        return result;
    }
}

export interface IUploadMultipleResponse {
    filesUploaded: boolean;
    temporaryDocumentFiles: TemporalDocumentFileDto[] | undefined;
    parentFolder: FileSystemFolder;
}

export class MoveAndSignDocumentsDto implements IMoveAndSignDocumentsDto {
    signDigitally: boolean;
    document: TemporalFileDto;
    pdf: TemporalFileDto;

    constructor(data?: IMoveAndSignDocumentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signDigitally = _data["signDigitally"];
            this.document = _data["document"] ? TemporalFileDto.fromJS(_data["document"]) : <any>undefined;
            this.pdf = _data["pdf"] ? TemporalFileDto.fromJS(_data["pdf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MoveAndSignDocumentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveAndSignDocumentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signDigitally"] = this.signDigitally;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["pdf"] = this.pdf ? this.pdf.toJSON() : <any>undefined;
        return data; 
    }

    clone(): MoveAndSignDocumentsDto {
        const json = this.toJSON();
        let result = new MoveAndSignDocumentsDto();
        result.init(json);
        return result;
    }
}

export interface IMoveAndSignDocumentsDto {
    signDigitally: boolean;
    document: TemporalFileDto;
    pdf: TemporalFileDto;
}

export class MoveAndSignDocumentsRequest implements IMoveAndSignDocumentsRequest {
    documents: MoveAndSignDocumentsDto[] | undefined;
    parentFolder: string;
    ownerPatient: string;
    selectedSpecialties: DoctorSpecialty[] | undefined;

    constructor(data?: IMoveAndSignDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents.push(MoveAndSignDocumentsDto.fromJS(item));
            }
            this.parentFolder = _data["parentFolder"];
            this.ownerPatient = _data["ownerPatient"];
            if (Array.isArray(_data["selectedSpecialties"])) {
                this.selectedSpecialties = [] as any;
                for (let item of _data["selectedSpecialties"])
                    this.selectedSpecialties.push(DoctorSpecialty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveAndSignDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveAndSignDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["parentFolder"] = this.parentFolder;
        data["ownerPatient"] = this.ownerPatient;
        if (Array.isArray(this.selectedSpecialties)) {
            data["selectedSpecialties"] = [];
            for (let item of this.selectedSpecialties)
                data["selectedSpecialties"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MoveAndSignDocumentsRequest {
        const json = this.toJSON();
        let result = new MoveAndSignDocumentsRequest();
        result.init(json);
        return result;
    }
}

export interface IMoveAndSignDocumentsRequest {
    documents: MoveAndSignDocumentsDto[] | undefined;
    parentFolder: string;
    ownerPatient: string;
    selectedSpecialties: DoctorSpecialty[] | undefined;
}

export class FileSystemItem implements IFileSystemItem {
    /** Related to */
    tenantId: number;
    /** Related to project */
    projectId: string;
    /** Name */
    name: string | undefined;
    /** Parent's container */
    parent: string;
    /** Path of the folder or file on the FileSystem */
    path: string | undefined;
    /** System's folders, or files */
    system: boolean;
    /** Can the file be edited/deleted */
    isReadOnly: boolean;
    /** File's size */
    size: number;
    isHidden: boolean;
    key: string | undefined;
    isOwner: boolean;
    readonly allowDelete: boolean;
    isDirectory: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    readonly allowMove: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IFileSystemItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.parent = _data["parent"];
            this.path = _data["path"];
            this.system = _data["system"];
            this.isReadOnly = _data["isReadOnly"];
            this.size = _data["size"];
            this.isHidden = _data["isHidden"];
            this.key = _data["key"];
            this.isOwner = _data["isOwner"];
            (<any>this).allowDelete = _data["allowDelete"];
            this.isDirectory = _data["isDirectory"];
            this.ownerUser = _data["ownerUser"];
            this.ownerPatient = _data["ownerPatient"];
            (<any>this).allowMove = _data["allowMove"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FileSystemItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["parent"] = this.parent;
        data["path"] = this.path;
        data["system"] = this.system;
        data["isReadOnly"] = this.isReadOnly;
        data["size"] = this.size;
        data["isHidden"] = this.isHidden;
        data["key"] = this.key;
        data["isOwner"] = this.isOwner;
        data["allowDelete"] = this.allowDelete;
        data["isDirectory"] = this.isDirectory;
        data["ownerUser"] = this.ownerUser;
        data["ownerPatient"] = this.ownerPatient;
        data["allowMove"] = this.allowMove;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): FileSystemItem {
        const json = this.toJSON();
        let result = new FileSystemItem();
        result.init(json);
        return result;
    }
}

export interface IFileSystemItem {
    /** Related to */
    tenantId: number;
    /** Related to project */
    projectId: string;
    /** Name */
    name: string | undefined;
    /** Parent's container */
    parent: string;
    /** Path of the folder or file on the FileSystem */
    path: string | undefined;
    /** System's folders, or files */
    system: boolean;
    /** Can the file be edited/deleted */
    isReadOnly: boolean;
    /** File's size */
    size: number;
    isHidden: boolean;
    key: string | undefined;
    isOwner: boolean;
    allowDelete: boolean;
    isDirectory: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    allowMove: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class GetFolderRequest implements IGetFolderRequest {
    patient: string;
    user: number | undefined;
    id: string;
    sorting: string | undefined;
    deletedOnly: boolean;

    constructor(data?: IGetFolderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"];
            this.user = _data["user"];
            this.id = _data["id"];
            this.sorting = _data["sorting"];
            this.deletedOnly = _data["deletedOnly"];
        }
    }

    static fromJS(data: any): GetFolderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFolderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        data["user"] = this.user;
        data["id"] = this.id;
        data["sorting"] = this.sorting;
        data["deletedOnly"] = this.deletedOnly;
        return data; 
    }

    clone(): GetFolderRequest {
        const json = this.toJSON();
        let result = new GetFolderRequest();
        result.init(json);
        return result;
    }
}

export interface IGetFolderRequest {
    patient: string;
    user: number | undefined;
    id: string;
    sorting: string | undefined;
    deletedOnly: boolean;
}

export class CreateFolder implements ICreateFolder {
    tenantId: number | undefined;
    projectId: string | undefined;
    createdByUser: number | undefined;
    parent: string;
    name: string | undefined;
    renameIfExists: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    isHidden: boolean;
    isReadOnly: boolean;
    isTemplate: boolean;
    pinned: boolean;
    pinnedOrder: number;
    key: string | undefined;
    isSystemFolder: boolean;
    highlighted: boolean;
    icon: string | undefined;
    parentKey: string | undefined;

    constructor(data?: ICreateFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.createdByUser = _data["createdByUser"];
            this.parent = _data["parent"];
            this.name = _data["name"];
            this.renameIfExists = _data["renameIfExists"];
            this.ownerUser = _data["ownerUser"];
            this.ownerPatient = _data["ownerPatient"];
            this.isHidden = _data["isHidden"];
            this.isReadOnly = _data["isReadOnly"];
            this.isTemplate = _data["isTemplate"];
            this.pinned = _data["pinned"];
            this.pinnedOrder = _data["pinnedOrder"];
            this.key = _data["key"];
            this.isSystemFolder = _data["isSystemFolder"];
            this.highlighted = _data["highlighted"];
            this.icon = _data["icon"];
            this.parentKey = _data["parentKey"];
        }
    }

    static fromJS(data: any): CreateFolder {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["createdByUser"] = this.createdByUser;
        data["parent"] = this.parent;
        data["name"] = this.name;
        data["renameIfExists"] = this.renameIfExists;
        data["ownerUser"] = this.ownerUser;
        data["ownerPatient"] = this.ownerPatient;
        data["isHidden"] = this.isHidden;
        data["isReadOnly"] = this.isReadOnly;
        data["isTemplate"] = this.isTemplate;
        data["pinned"] = this.pinned;
        data["pinnedOrder"] = this.pinnedOrder;
        data["key"] = this.key;
        data["isSystemFolder"] = this.isSystemFolder;
        data["highlighted"] = this.highlighted;
        data["icon"] = this.icon;
        data["parentKey"] = this.parentKey;
        return data; 
    }

    clone(): CreateFolder {
        const json = this.toJSON();
        let result = new CreateFolder();
        result.init(json);
        return result;
    }
}

export interface ICreateFolder {
    tenantId: number | undefined;
    projectId: string | undefined;
    createdByUser: number | undefined;
    parent: string;
    name: string | undefined;
    renameIfExists: boolean;
    ownerUser: number | undefined;
    ownerPatient: string;
    isHidden: boolean;
    isReadOnly: boolean;
    isTemplate: boolean;
    pinned: boolean;
    pinnedOrder: number;
    key: string | undefined;
    isSystemFolder: boolean;
    highlighted: boolean;
    icon: string | undefined;
    parentKey: string | undefined;
}

export class MoveFile implements IMoveFile {
    itemId: string;
    folderDestinationId: string;

    constructor(data?: IMoveFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.folderDestinationId = _data["folderDestinationId"];
        }
    }

    static fromJS(data: any): MoveFile {
        data = typeof data === 'object' ? data : {};
        let result = new MoveFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["folderDestinationId"] = this.folderDestinationId;
        return data; 
    }

    clone(): MoveFile {
        const json = this.toJSON();
        let result = new MoveFile();
        result.init(json);
        return result;
    }
}

export interface IMoveFile {
    itemId: string;
    folderDestinationId: string;
}

export class RenameFileSystemItemRequest implements IRenameFileSystemItemRequest {
    id: string;
    name: string | undefined;
    ownerUser: number | undefined;
    ownerPatient: string;

    constructor(data?: IRenameFileSystemItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ownerUser = _data["ownerUser"];
            this.ownerPatient = _data["ownerPatient"];
        }
    }

    static fromJS(data: any): RenameFileSystemItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameFileSystemItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ownerUser"] = this.ownerUser;
        data["ownerPatient"] = this.ownerPatient;
        return data; 
    }

    clone(): RenameFileSystemItemRequest {
        const json = this.toJSON();
        let result = new RenameFileSystemItemRequest();
        result.init(json);
        return result;
    }
}

export interface IRenameFileSystemItemRequest {
    id: string;
    name: string | undefined;
    ownerUser: number | undefined;
    ownerPatient: string;
}

export class FileItem implements IFileItem {
    projectId: string;
    ownerUser: number | undefined;
    ownerPatient: string;
    name: string | undefined;
    parent: string;
    path: string | undefined;
    thumb: string | undefined;
    remoteDeletionCompleted: boolean;
    size: number;
    thumbSize: number;
    isDirectory: boolean;
    mimeType: string | undefined;
    system: boolean;
    isReadOnly: boolean;
    isHidden: boolean;
    key: string | undefined;
    externalId: string | undefined;
    tenantId: number;
    contentEditable: boolean;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IFileItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.ownerUser = _data["ownerUser"];
            this.ownerPatient = _data["ownerPatient"];
            this.name = _data["name"];
            this.parent = _data["parent"];
            this.path = _data["path"];
            this.thumb = _data["thumb"];
            this.remoteDeletionCompleted = _data["remoteDeletionCompleted"];
            this.size = _data["size"];
            this.thumbSize = _data["thumbSize"];
            this.isDirectory = _data["isDirectory"];
            this.mimeType = _data["mimeType"];
            this.system = _data["system"];
            this.isReadOnly = _data["isReadOnly"];
            this.isHidden = _data["isHidden"];
            this.key = _data["key"];
            this.externalId = _data["externalId"];
            this.tenantId = _data["tenantId"];
            this.contentEditable = _data["contentEditable"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): FileItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["ownerUser"] = this.ownerUser;
        data["ownerPatient"] = this.ownerPatient;
        data["name"] = this.name;
        data["parent"] = this.parent;
        data["path"] = this.path;
        data["thumb"] = this.thumb;
        data["remoteDeletionCompleted"] = this.remoteDeletionCompleted;
        data["size"] = this.size;
        data["thumbSize"] = this.thumbSize;
        data["isDirectory"] = this.isDirectory;
        data["mimeType"] = this.mimeType;
        data["system"] = this.system;
        data["isReadOnly"] = this.isReadOnly;
        data["isHidden"] = this.isHidden;
        data["key"] = this.key;
        data["externalId"] = this.externalId;
        data["tenantId"] = this.tenantId;
        data["contentEditable"] = this.contentEditable;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): FileItem {
        const json = this.toJSON();
        let result = new FileItem();
        result.init(json);
        return result;
    }
}

export interface IFileItem {
    projectId: string;
    ownerUser: number | undefined;
    ownerPatient: string;
    name: string | undefined;
    parent: string;
    path: string | undefined;
    thumb: string | undefined;
    remoteDeletionCompleted: boolean;
    size: number;
    thumbSize: number;
    isDirectory: boolean;
    mimeType: string | undefined;
    system: boolean;
    isReadOnly: boolean;
    isHidden: boolean;
    key: string | undefined;
    externalId: string | undefined;
    tenantId: number;
    contentEditable: boolean;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class PinnedFolderDto implements IPinnedFolderDto {
    id: string;
    name: string | undefined;
    key: string | undefined;
    pinnedOrder: number;

    constructor(data?: IPinnedFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.key = _data["key"];
            this.pinnedOrder = _data["pinnedOrder"];
        }
    }

    static fromJS(data: any): PinnedFolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PinnedFolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        data["pinnedOrder"] = this.pinnedOrder;
        return data; 
    }

    clone(): PinnedFolderDto {
        const json = this.toJSON();
        let result = new PinnedFolderDto();
        result.init(json);
        return result;
    }
}

export interface IPinnedFolderDto {
    id: string;
    name: string | undefined;
    key: string | undefined;
    pinnedOrder: number;
}

export class RemovePinnedFolderInput implements IRemovePinnedFolderInput {
    id: string;
    key: string | undefined;
    onlyForPatient: boolean;
    permanent: boolean;

    constructor(data?: IRemovePinnedFolderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.onlyForPatient = _data["onlyForPatient"];
            this.permanent = _data["permanent"];
        }
    }

    static fromJS(data: any): RemovePinnedFolderInput {
        data = typeof data === 'object' ? data : {};
        let result = new RemovePinnedFolderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["onlyForPatient"] = this.onlyForPatient;
        data["permanent"] = this.permanent;
        return data; 
    }

    clone(): RemovePinnedFolderInput {
        const json = this.toJSON();
        let result = new RemovePinnedFolderInput();
        result.init(json);
        return result;
    }
}

export interface IRemovePinnedFolderInput {
    id: string;
    key: string | undefined;
    onlyForPatient: boolean;
    permanent: boolean;
}

export class RenamePinnedFolderInput implements IRenamePinnedFolderInput {
    id: string;
    key: string | undefined;
    name: string | undefined;

    constructor(data?: IRenamePinnedFolderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenamePinnedFolderInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePinnedFolderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["name"] = this.name;
        return data; 
    }

    clone(): RenamePinnedFolderInput {
        const json = this.toJSON();
        let result = new RenamePinnedFolderInput();
        result.init(json);
        return result;
    }
}

export interface IRenamePinnedFolderInput {
    id: string;
    key: string | undefined;
    name: string | undefined;
}

export class FolderTemplateDto implements IFolderTemplateDto {
    id: number;
    name: string | undefined;
    /** Can the folder be edited/deleted by the patient */
    isReadOnly: boolean;
    /** Show or not to the patient */
    isHidden: boolean;
    key: string | undefined;
    pinned: boolean;
    pinnedOrder: number;
    /** Prescriptions, Exams, Terms, etc. */
    isSystemFolder: boolean;
    highlighted: boolean;
    icon: string | undefined;
    order: number;

    constructor(data?: IFolderTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isReadOnly = _data["isReadOnly"];
            this.isHidden = _data["isHidden"];
            this.key = _data["key"];
            this.pinned = _data["pinned"];
            this.pinnedOrder = _data["pinnedOrder"];
            this.isSystemFolder = _data["isSystemFolder"];
            this.highlighted = _data["highlighted"];
            this.icon = _data["icon"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): FolderTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isReadOnly"] = this.isReadOnly;
        data["isHidden"] = this.isHidden;
        data["key"] = this.key;
        data["pinned"] = this.pinned;
        data["pinnedOrder"] = this.pinnedOrder;
        data["isSystemFolder"] = this.isSystemFolder;
        data["highlighted"] = this.highlighted;
        data["icon"] = this.icon;
        data["order"] = this.order;
        return data; 
    }

    clone(): FolderTemplateDto {
        const json = this.toJSON();
        let result = new FolderTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IFolderTemplateDto {
    id: number;
    name: string | undefined;
    /** Can the folder be edited/deleted by the patient */
    isReadOnly: boolean;
    /** Show or not to the patient */
    isHidden: boolean;
    key: string | undefined;
    pinned: boolean;
    pinnedOrder: number;
    /** Prescriptions, Exams, Terms, etc. */
    isSystemFolder: boolean;
    highlighted: boolean;
    icon: string | undefined;
    order: number;
}

export class CreateFolderTemplateRequest implements ICreateFolderTemplateRequest {
    name: string | undefined;
    isReadOnly: boolean;
    isHidden: boolean;
    pinned: boolean;
    highlighted: boolean;
    icon: string | undefined;

    constructor(data?: ICreateFolderTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isReadOnly = _data["isReadOnly"];
            this.isHidden = _data["isHidden"];
            this.pinned = _data["pinned"];
            this.highlighted = _data["highlighted"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): CreateFolderTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFolderTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isReadOnly"] = this.isReadOnly;
        data["isHidden"] = this.isHidden;
        data["pinned"] = this.pinned;
        data["highlighted"] = this.highlighted;
        data["icon"] = this.icon;
        return data; 
    }

    clone(): CreateFolderTemplateRequest {
        const json = this.toJSON();
        let result = new CreateFolderTemplateRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateFolderTemplateRequest {
    name: string | undefined;
    isReadOnly: boolean;
    isHidden: boolean;
    pinned: boolean;
    highlighted: boolean;
    icon: string | undefined;
}

export class UpdateFolderTemplateRequest implements IUpdateFolderTemplateRequest {
    name: string | undefined;
    isReadOnly: boolean;
    isHidden: boolean;
    pinned: boolean;
    highlighted: boolean;
    icon: string | undefined;

    constructor(data?: IUpdateFolderTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isReadOnly = _data["isReadOnly"];
            this.isHidden = _data["isHidden"];
            this.pinned = _data["pinned"];
            this.highlighted = _data["highlighted"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): UpdateFolderTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFolderTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isReadOnly"] = this.isReadOnly;
        data["isHidden"] = this.isHidden;
        data["pinned"] = this.pinned;
        data["highlighted"] = this.highlighted;
        data["icon"] = this.icon;
        return data; 
    }

    clone(): UpdateFolderTemplateRequest {
        const json = this.toJSON();
        let result = new UpdateFolderTemplateRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateFolderTemplateRequest {
    name: string | undefined;
    isReadOnly: boolean;
    isHidden: boolean;
    pinned: boolean;
    highlighted: boolean;
    icon: string | undefined;
}

export class GoogleCalendarConnectResult implements IGoogleCalendarConnectResult {
    url: string | undefined;

    constructor(data?: IGoogleCalendarConnectResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GoogleCalendarConnectResult {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleCalendarConnectResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data; 
    }

    clone(): GoogleCalendarConnectResult {
        const json = this.toJSON();
        let result = new GoogleCalendarConnectResult();
        result.init(json);
        return result;
    }
}

export interface IGoogleCalendarConnectResult {
    url: string | undefined;
}

export class CompleteGoogleCalendarIntegrationInput implements ICompleteGoogleCalendarIntegrationInput {
    calendarId: string | undefined;

    constructor(data?: ICompleteGoogleCalendarIntegrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarId = _data["calendarId"];
        }
    }

    static fromJS(data: any): CompleteGoogleCalendarIntegrationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteGoogleCalendarIntegrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarId"] = this.calendarId;
        return data; 
    }

    clone(): CompleteGoogleCalendarIntegrationInput {
        const json = this.toJSON();
        let result = new CompleteGoogleCalendarIntegrationInput();
        result.init(json);
        return result;
    }
}

export interface ICompleteGoogleCalendarIntegrationInput {
    calendarId: string | undefined;
}

export class GoogleCalendarConfigResult implements IGoogleCalendarConfigResult {
    enabled: boolean;
    calendar: string | undefined;

    constructor(data?: IGoogleCalendarConfigResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.calendar = _data["calendar"];
        }
    }

    static fromJS(data: any): GoogleCalendarConfigResult {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleCalendarConfigResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["calendar"] = this.calendar;
        return data; 
    }

    clone(): GoogleCalendarConfigResult {
        const json = this.toJSON();
        let result = new GoogleCalendarConfigResult();
        result.init(json);
        return result;
    }
}

export interface IGoogleCalendarConfigResult {
    enabled: boolean;
    calendar: string | undefined;
}

export class GoogleCalendarEntry implements IGoogleCalendarEntry {
    id: string | undefined;
    name: string | undefined;

    constructor(data?: IGoogleCalendarEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GoogleCalendarEntry {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleCalendarEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): GoogleCalendarEntry {
        const json = this.toJSON();
        let result = new GoogleCalendarEntry();
        result.init(json);
        return result;
    }
}

export interface IGoogleCalendarEntry {
    id: string | undefined;
    name: string | undefined;
}

export class GoogleNotificationData implements IGoogleNotificationData {
    channelId: string | undefined;
    channelToken: string | undefined;
    channelState: string | undefined;
    channelExpiration: string | undefined;

    constructor(data?: IGoogleNotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.channelToken = _data["channelToken"];
            this.channelState = _data["channelState"];
            this.channelExpiration = _data["channelExpiration"];
        }
    }

    static fromJS(data: any): GoogleNotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleNotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["channelToken"] = this.channelToken;
        data["channelState"] = this.channelState;
        data["channelExpiration"] = this.channelExpiration;
        return data; 
    }

    clone(): GoogleNotificationData {
        const json = this.toJSON();
        let result = new GoogleNotificationData();
        result.init(json);
        return result;
    }
}

export interface IGoogleNotificationData {
    channelId: string | undefined;
    channelToken: string | undefined;
    channelState: string | undefined;
    channelExpiration: string | undefined;
}

export enum EventPreviewType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetHealthCareUnitsInput implements IGetHealthCareUnitsInput {
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetHealthCareUnitsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetHealthCareUnitsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthCareUnitsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetHealthCareUnitsInput {
        const json = this.toJSON();
        let result = new GetHealthCareUnitsInput();
        result.init(json);
        return result;
    }
}

export interface IGetHealthCareUnitsInput {
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export enum ContactEmailDiscriminator {
    _1 = 1,
}

export class HealthCareUnitContactEmailDto implements IHealthCareUnitContactEmailDto {
    discriminator: ContactEmailDiscriminator;
    email: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IHealthCareUnitContactEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthCareUnitContactEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCareUnitContactEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthCareUnitContactEmailDto {
        const json = this.toJSON();
        let result = new HealthCareUnitContactEmailDto();
        result.init(json);
        return result;
    }
}

export interface IHealthCareUnitContactEmailDto {
    discriminator: ContactEmailDiscriminator;
    email: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum PhoneNumberDiscriminator {
    _1 = 1,
}

export class HealthCareUnitPhoneDto implements IHealthCareUnitPhoneDto {
    discriminator: PhoneNumberDiscriminator;
    number: string | undefined;
    isLandline: boolean;
    isWhatsApp: boolean;
    readonly clearedNumber: string | undefined;
    readonly brazilianFormat: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IHealthCareUnitPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.number = _data["number"];
            this.isLandline = _data["isLandline"];
            this.isWhatsApp = _data["isWhatsApp"];
            (<any>this).clearedNumber = _data["clearedNumber"];
            (<any>this).brazilianFormat = _data["brazilianFormat"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthCareUnitPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCareUnitPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["number"] = this.number;
        data["isLandline"] = this.isLandline;
        data["isWhatsApp"] = this.isWhatsApp;
        data["clearedNumber"] = this.clearedNumber;
        data["brazilianFormat"] = this.brazilianFormat;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthCareUnitPhoneDto {
        const json = this.toJSON();
        let result = new HealthCareUnitPhoneDto();
        result.init(json);
        return result;
    }
}

export interface IHealthCareUnitPhoneDto {
    discriminator: PhoneNumberDiscriminator;
    number: string | undefined;
    isLandline: boolean;
    isWhatsApp: boolean;
    clearedNumber: string | undefined;
    brazilianFormat: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MedicalProcedureCoveredInHealthCareUnitDto implements IMedicalProcedureCoveredInHealthCareUnitDto {
    medicalProcedure: MedicalProcedureBasicData;
    medicalProcedureId: number;
    id: number;

    constructor(data?: IMedicalProcedureCoveredInHealthCareUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedureBasicData.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredInHealthCareUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredInHealthCareUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredInHealthCareUnitDto {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredInHealthCareUnitDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredInHealthCareUnitDto {
    medicalProcedure: MedicalProcedureBasicData;
    medicalProcedureId: number;
    id: number;
}

export class HealthCareUnitDto implements IHealthCareUnitDto {
    name: string | undefined;
    address: LocalizedAddress;
    contactEmails: HealthCareUnitContactEmailDto[] | undefined;
    social: Social;
    phoneNumbers: HealthCareUnitPhoneDto[] | undefined;
    coveredProcedures: MedicalProcedureCoveredInHealthCareUnitDto[] | undefined;
    workJourney: AvailableDateWindow[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IHealthCareUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? LocalizedAddress.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["contactEmails"])) {
                this.contactEmails = [] as any;
                for (let item of _data["contactEmails"])
                    this.contactEmails.push(HealthCareUnitContactEmailDto.fromJS(item));
            }
            this.social = _data["social"] ? Social.fromJS(_data["social"]) : <any>undefined;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(HealthCareUnitPhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["coveredProcedures"])) {
                this.coveredProcedures = [] as any;
                for (let item of _data["coveredProcedures"])
                    this.coveredProcedures.push(MedicalProcedureCoveredInHealthCareUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["workJourney"])) {
                this.workJourney = [] as any;
                for (let item of _data["workJourney"])
                    this.workJourney.push(AvailableDateWindow.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthCareUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCareUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.contactEmails)) {
            data["contactEmails"] = [];
            for (let item of this.contactEmails)
                data["contactEmails"].push(item.toJSON());
        }
        data["social"] = this.social ? this.social.toJSON() : <any>undefined;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredProcedures)) {
            data["coveredProcedures"] = [];
            for (let item of this.coveredProcedures)
                data["coveredProcedures"].push(item.toJSON());
        }
        if (Array.isArray(this.workJourney)) {
            data["workJourney"] = [];
            for (let item of this.workJourney)
                data["workJourney"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthCareUnitDto {
        const json = this.toJSON();
        let result = new HealthCareUnitDto();
        result.init(json);
        return result;
    }
}

export interface IHealthCareUnitDto {
    name: string | undefined;
    address: LocalizedAddress;
    contactEmails: HealthCareUnitContactEmailDto[] | undefined;
    social: Social;
    phoneNumbers: HealthCareUnitPhoneDto[] | undefined;
    coveredProcedures: MedicalProcedureCoveredInHealthCareUnitDto[] | undefined;
    workJourney: AvailableDateWindow[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class HealthCareUnitDtoPagedResultDto implements IHealthCareUnitDtoPagedResultDto {
    totalCount: number;
    items: HealthCareUnitDto[] | undefined;

    constructor(data?: IHealthCareUnitDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HealthCareUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthCareUnitDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCareUnitDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HealthCareUnitDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HealthCareUnitDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHealthCareUnitDtoPagedResultDto {
    totalCount: number;
    items: HealthCareUnitDto[] | undefined;
}

export class ProcedureItemSelection implements IProcedureItemSelection {
    medicalProcedureId: number;

    constructor(data?: IProcedureItemSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalProcedureId = _data["medicalProcedureId"];
        }
    }

    static fromJS(data: any): ProcedureItemSelection {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureItemSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalProcedureId"] = this.medicalProcedureId;
        return data; 
    }

    clone(): ProcedureItemSelection {
        const json = this.toJSON();
        let result = new ProcedureItemSelection();
        result.init(json);
        return result;
    }
}

export interface IProcedureItemSelection {
    medicalProcedureId: number;
}

export class CreateHealthCareUnitInput implements ICreateHealthCareUnitInput {
    name: string | undefined;
    address: LocalizedAddress;
    contactEmails: HealthCareUnitContactEmailDto[] | undefined;
    social: Social;
    phoneNumbers: HealthCareUnitPhoneDto[] | undefined;
    coveredProcedures: ProcedureItemSelection[] | undefined;
    workJourney: AvailableDateWindow[] | undefined;

    constructor(data?: ICreateHealthCareUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? LocalizedAddress.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["contactEmails"])) {
                this.contactEmails = [] as any;
                for (let item of _data["contactEmails"])
                    this.contactEmails.push(HealthCareUnitContactEmailDto.fromJS(item));
            }
            this.social = _data["social"] ? Social.fromJS(_data["social"]) : <any>undefined;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(HealthCareUnitPhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["coveredProcedures"])) {
                this.coveredProcedures = [] as any;
                for (let item of _data["coveredProcedures"])
                    this.coveredProcedures.push(ProcedureItemSelection.fromJS(item));
            }
            if (Array.isArray(_data["workJourney"])) {
                this.workJourney = [] as any;
                for (let item of _data["workJourney"])
                    this.workJourney.push(AvailableDateWindow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateHealthCareUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthCareUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.contactEmails)) {
            data["contactEmails"] = [];
            for (let item of this.contactEmails)
                data["contactEmails"].push(item.toJSON());
        }
        data["social"] = this.social ? this.social.toJSON() : <any>undefined;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredProcedures)) {
            data["coveredProcedures"] = [];
            for (let item of this.coveredProcedures)
                data["coveredProcedures"].push(item.toJSON());
        }
        if (Array.isArray(this.workJourney)) {
            data["workJourney"] = [];
            for (let item of this.workJourney)
                data["workJourney"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateHealthCareUnitInput {
        const json = this.toJSON();
        let result = new CreateHealthCareUnitInput();
        result.init(json);
        return result;
    }
}

export interface ICreateHealthCareUnitInput {
    name: string | undefined;
    address: LocalizedAddress;
    contactEmails: HealthCareUnitContactEmailDto[] | undefined;
    social: Social;
    phoneNumbers: HealthCareUnitPhoneDto[] | undefined;
    coveredProcedures: ProcedureItemSelection[] | undefined;
    workJourney: AvailableDateWindow[] | undefined;
}

export class UpdateHealthCareUnitInput implements IUpdateHealthCareUnitInput {
    name: string | undefined;
    address: LocalizedAddress;
    contactEmails: HealthCareUnitContactEmailDto[] | undefined;
    social: Social;
    phoneNumbers: HealthCareUnitPhoneDto[] | undefined;
    workJourney: AvailableDateWindow[] | undefined;
    id: number;

    constructor(data?: IUpdateHealthCareUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? LocalizedAddress.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["contactEmails"])) {
                this.contactEmails = [] as any;
                for (let item of _data["contactEmails"])
                    this.contactEmails.push(HealthCareUnitContactEmailDto.fromJS(item));
            }
            this.social = _data["social"] ? Social.fromJS(_data["social"]) : <any>undefined;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(HealthCareUnitPhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["workJourney"])) {
                this.workJourney = [] as any;
                for (let item of _data["workJourney"])
                    this.workJourney.push(AvailableDateWindow.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateHealthCareUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHealthCareUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.contactEmails)) {
            data["contactEmails"] = [];
            for (let item of this.contactEmails)
                data["contactEmails"].push(item.toJSON());
        }
        data["social"] = this.social ? this.social.toJSON() : <any>undefined;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.workJourney)) {
            data["workJourney"] = [];
            for (let item of this.workJourney)
                data["workJourney"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateHealthCareUnitInput {
        const json = this.toJSON();
        let result = new UpdateHealthCareUnitInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateHealthCareUnitInput {
    name: string | undefined;
    address: LocalizedAddress;
    contactEmails: HealthCareUnitContactEmailDto[] | undefined;
    social: Social;
    phoneNumbers: HealthCareUnitPhoneDto[] | undefined;
    workJourney: AvailableDateWindow[] | undefined;
    id: number;
}

export class GetHealthProfessionalMedicalProceduresInput implements IGetHealthProfessionalMedicalProceduresInput {
    professionalId: string;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetHealthProfessionalMedicalProceduresInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionalId = _data["professionalId"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetHealthProfessionalMedicalProceduresInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthProfessionalMedicalProceduresInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionalId"] = this.professionalId;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetHealthProfessionalMedicalProceduresInput {
        const json = this.toJSON();
        let result = new GetHealthProfessionalMedicalProceduresInput();
        result.init(json);
        return result;
    }
}

export interface IGetHealthProfessionalMedicalProceduresInput {
    professionalId: string;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class HealthProfessionalBasicDto implements IHealthProfessionalBasicDto {
    name: string | undefined;

    constructor(data?: IHealthProfessionalBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HealthProfessionalBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }

    clone(): HealthProfessionalBasicDto {
        const json = this.toJSON();
        let result = new HealthProfessionalBasicDto();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalBasicDto {
    name: string | undefined;
}

export class MedicalProcedureBasicDto implements IMedicalProcedureBasicDto {
    name: string | undefined;
    price: number;
    description: string | undefined;
    duration: number;
    periodUnit: ProcedurePeriodUnit;

    constructor(data?: IMedicalProcedureBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.description = _data["description"];
            this.duration = _data["duration"];
            this.periodUnit = _data["periodUnit"];
        }
    }

    static fromJS(data: any): MedicalProcedureBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["description"] = this.description;
        data["duration"] = this.duration;
        data["periodUnit"] = this.periodUnit;
        return data; 
    }

    clone(): MedicalProcedureBasicDto {
        const json = this.toJSON();
        let result = new MedicalProcedureBasicDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureBasicDto {
    name: string | undefined;
    price: number;
    description: string | undefined;
    duration: number;
    periodUnit: ProcedurePeriodUnit;
}

export class ProfessionalCompanyBasicInputDto implements IProfessionalCompanyBasicInputDto {
    id: number;
    checked: boolean;
    price: number | undefined;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: IProfessionalCompanyBasicInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.checked = _data["checked"];
            this.price = _data["price"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ProfessionalCompanyBasicInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalCompanyBasicInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checked"] = this.checked;
        data["price"] = this.price;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }

    clone(): ProfessionalCompanyBasicInputDto {
        const json = this.toJSON();
        let result = new ProfessionalCompanyBasicInputDto();
        result.init(json);
        return result;
    }
}

export interface IProfessionalCompanyBasicInputDto {
    id: number;
    checked: boolean;
    price: number | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class ProfessionalPlanBasicInputDto implements IProfessionalPlanBasicInputDto {
    id: number;
    checked: boolean;
    price: number | undefined;
    name: string | undefined;
    companyId: number;

    constructor(data?: IProfessionalPlanBasicInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.checked = _data["checked"];
            this.price = _data["price"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ProfessionalPlanBasicInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalPlanBasicInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checked"] = this.checked;
        data["price"] = this.price;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        return data; 
    }

    clone(): ProfessionalPlanBasicInputDto {
        const json = this.toJSON();
        let result = new ProfessionalPlanBasicInputDto();
        result.init(json);
        return result;
    }
}

export interface IProfessionalPlanBasicInputDto {
    id: number;
    checked: boolean;
    price: number | undefined;
    name: string | undefined;
    companyId: number;
}

export class HealthProfessionalMedicalProcedureDto implements IHealthProfessionalMedicalProcedureDto {
    professionalId: string;
    professional: HealthProfessionalBasicDto;
    medicalProcedureId: number;
    medicalProcedure: MedicalProcedureBasicDto;
    duration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    isActive: boolean;
    comments: string | undefined;
    allowOnlineSchedule: boolean;
    price: number;
    splitPercentage: number | undefined;
    insuranceCompanies: ProfessionalCompanyBasicInputDto[] | undefined;
    insurancePlans: ProfessionalPlanBasicInputDto[] | undefined;
    careUnits: ProfessionalCareUnitBasicInputDto[] | undefined;
    id: number;

    constructor(data?: IHealthProfessionalMedicalProcedureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionalId = _data["professionalId"];
            this.professional = _data["professional"] ? HealthProfessionalBasicDto.fromJS(_data["professional"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedureBasicDto.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.duration = _data["duration"];
            this.periodUnit = _data["periodUnit"];
            this.isActive = _data["isActive"];
            this.comments = _data["comments"];
            this.allowOnlineSchedule = _data["allowOnlineSchedule"];
            this.price = _data["price"];
            this.splitPercentage = _data["splitPercentage"];
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies.push(ProfessionalCompanyBasicInputDto.fromJS(item));
            }
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans.push(ProfessionalPlanBasicInputDto.fromJS(item));
            }
            if (Array.isArray(_data["careUnits"])) {
                this.careUnits = [] as any;
                for (let item of _data["careUnits"])
                    this.careUnits.push(ProfessionalCareUnitBasicInputDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthProfessionalMedicalProcedureDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalMedicalProcedureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionalId"] = this.professionalId;
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["duration"] = this.duration;
        data["periodUnit"] = this.periodUnit;
        data["isActive"] = this.isActive;
        data["comments"] = this.comments;
        data["allowOnlineSchedule"] = this.allowOnlineSchedule;
        data["price"] = this.price;
        data["splitPercentage"] = this.splitPercentage;
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.careUnits)) {
            data["careUnits"] = [];
            for (let item of this.careUnits)
                data["careUnits"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthProfessionalMedicalProcedureDto {
        const json = this.toJSON();
        let result = new HealthProfessionalMedicalProcedureDto();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalMedicalProcedureDto {
    professionalId: string;
    professional: HealthProfessionalBasicDto;
    medicalProcedureId: number;
    medicalProcedure: MedicalProcedureBasicDto;
    duration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    isActive: boolean;
    comments: string | undefined;
    allowOnlineSchedule: boolean;
    price: number;
    splitPercentage: number | undefined;
    insuranceCompanies: ProfessionalCompanyBasicInputDto[] | undefined;
    insurancePlans: ProfessionalPlanBasicInputDto[] | undefined;
    careUnits: ProfessionalCareUnitBasicInputDto[] | undefined;
    id: number;
}

export class HealthProfessionalMedicalProcedureDtoPagedResultDto implements IHealthProfessionalMedicalProcedureDtoPagedResultDto {
    totalCount: number;
    items: HealthProfessionalMedicalProcedureDto[] | undefined;

    constructor(data?: IHealthProfessionalMedicalProcedureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HealthProfessionalMedicalProcedureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthProfessionalMedicalProcedureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalMedicalProcedureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HealthProfessionalMedicalProcedureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HealthProfessionalMedicalProcedureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalMedicalProcedureDtoPagedResultDto {
    totalCount: number;
    items: HealthProfessionalMedicalProcedureDto[] | undefined;
}

export class HealthProfessionalInsuranceOptionsInput implements IHealthProfessionalInsuranceOptionsInput {
    professionalId: string | undefined;
    procedureId: number;

    constructor(data?: IHealthProfessionalInsuranceOptionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionalId = _data["professionalId"];
            this.procedureId = _data["procedureId"];
        }
    }

    static fromJS(data: any): HealthProfessionalInsuranceOptionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalInsuranceOptionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionalId"] = this.professionalId;
        data["procedureId"] = this.procedureId;
        return data; 
    }

    clone(): HealthProfessionalInsuranceOptionsInput {
        const json = this.toJSON();
        let result = new HealthProfessionalInsuranceOptionsInput();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalInsuranceOptionsInput {
    professionalId: string | undefined;
    procedureId: number;
}

export class HealthProfessionalMedicalProcedureInsuranceOptions implements IHealthProfessionalMedicalProcedureInsuranceOptions {
    insuranceCompanies: ProfessionalCompanyBasicInputDto[] | undefined;
    insurancePlans: ProfessionalPlanBasicInputDto[] | undefined;

    constructor(data?: IHealthProfessionalMedicalProcedureInsuranceOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies.push(ProfessionalCompanyBasicInputDto.fromJS(item));
            }
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans.push(ProfessionalPlanBasicInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthProfessionalMedicalProcedureInsuranceOptions {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalMedicalProcedureInsuranceOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HealthProfessionalMedicalProcedureInsuranceOptions {
        const json = this.toJSON();
        let result = new HealthProfessionalMedicalProcedureInsuranceOptions();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalMedicalProcedureInsuranceOptions {
    insuranceCompanies: ProfessionalCompanyBasicInputDto[] | undefined;
    insurancePlans: ProfessionalPlanBasicInputDto[] | undefined;
}

export class HealthProfessionalProcedureCareUnitOptionsInput implements IHealthProfessionalProcedureCareUnitOptionsInput {
    professionalId: string | undefined;
    procedureId: number;

    constructor(data?: IHealthProfessionalProcedureCareUnitOptionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionalId = _data["professionalId"];
            this.procedureId = _data["procedureId"];
        }
    }

    static fromJS(data: any): HealthProfessionalProcedureCareUnitOptionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalProcedureCareUnitOptionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionalId"] = this.professionalId;
        data["procedureId"] = this.procedureId;
        return data; 
    }

    clone(): HealthProfessionalProcedureCareUnitOptionsInput {
        const json = this.toJSON();
        let result = new HealthProfessionalProcedureCareUnitOptionsInput();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalProcedureCareUnitOptionsInput {
    professionalId: string | undefined;
    procedureId: number;
}

export class UpdateHealthProfessionalMedicalProcedureInput implements IUpdateHealthProfessionalMedicalProcedureInput {
    professionalId: string;
    medicalProcedureId: number;
    duration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    isActive: boolean;
    comments: string | undefined;
    allowOnlineSchedule: boolean;
    splitPercentage: number | undefined;
    insuranceCompanies: ProfessionalCompanyBasicInputDto[] | undefined;
    insurancePlans: ProfessionalPlanBasicInputDto[] | undefined;
    careUnits: ProfessionalCareUnitBasicInputDto[] | undefined;
    id: number;

    constructor(data?: IUpdateHealthProfessionalMedicalProcedureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionalId = _data["professionalId"];
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.duration = _data["duration"];
            this.periodUnit = _data["periodUnit"];
            this.isActive = _data["isActive"];
            this.comments = _data["comments"];
            this.allowOnlineSchedule = _data["allowOnlineSchedule"];
            this.splitPercentage = _data["splitPercentage"];
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies.push(ProfessionalCompanyBasicInputDto.fromJS(item));
            }
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans.push(ProfessionalPlanBasicInputDto.fromJS(item));
            }
            if (Array.isArray(_data["careUnits"])) {
                this.careUnits = [] as any;
                for (let item of _data["careUnits"])
                    this.careUnits.push(ProfessionalCareUnitBasicInputDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateHealthProfessionalMedicalProcedureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHealthProfessionalMedicalProcedureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionalId"] = this.professionalId;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["duration"] = this.duration;
        data["periodUnit"] = this.periodUnit;
        data["isActive"] = this.isActive;
        data["comments"] = this.comments;
        data["allowOnlineSchedule"] = this.allowOnlineSchedule;
        data["splitPercentage"] = this.splitPercentage;
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.careUnits)) {
            data["careUnits"] = [];
            for (let item of this.careUnits)
                data["careUnits"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateHealthProfessionalMedicalProcedureInput {
        const json = this.toJSON();
        let result = new UpdateHealthProfessionalMedicalProcedureInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateHealthProfessionalMedicalProcedureInput {
    professionalId: string;
    medicalProcedureId: number;
    duration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    isActive: boolean;
    comments: string | undefined;
    allowOnlineSchedule: boolean;
    splitPercentage: number | undefined;
    insuranceCompanies: ProfessionalCompanyBasicInputDto[] | undefined;
    insurancePlans: ProfessionalPlanBasicInputDto[] | undefined;
    careUnits: ProfessionalCareUnitBasicInputDto[] | undefined;
    id: number;
}

export class CreateHealthProfessionalMedicalProcedureInput implements ICreateHealthProfessionalMedicalProcedureInput {
    professionalId: string;
    medicalProcedureId: number;
    duration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    isActive: boolean;
    comments: string | undefined;
    allowOnlineSchedule: boolean;
    splitPercentage: number | undefined;
    insuranceCompanies: ProfessionalCompanyBasicInputDto[] | undefined;
    insurancePlans: ProfessionalPlanBasicInputDto[] | undefined;
    careUnits: ProfessionalCareUnitBasicInputDto[] | undefined;

    constructor(data?: ICreateHealthProfessionalMedicalProcedureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionalId = _data["professionalId"];
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.duration = _data["duration"];
            this.periodUnit = _data["periodUnit"];
            this.isActive = _data["isActive"];
            this.comments = _data["comments"];
            this.allowOnlineSchedule = _data["allowOnlineSchedule"];
            this.splitPercentage = _data["splitPercentage"];
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies.push(ProfessionalCompanyBasicInputDto.fromJS(item));
            }
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans.push(ProfessionalPlanBasicInputDto.fromJS(item));
            }
            if (Array.isArray(_data["careUnits"])) {
                this.careUnits = [] as any;
                for (let item of _data["careUnits"])
                    this.careUnits.push(ProfessionalCareUnitBasicInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateHealthProfessionalMedicalProcedureInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthProfessionalMedicalProcedureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionalId"] = this.professionalId;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["duration"] = this.duration;
        data["periodUnit"] = this.periodUnit;
        data["isActive"] = this.isActive;
        data["comments"] = this.comments;
        data["allowOnlineSchedule"] = this.allowOnlineSchedule;
        data["splitPercentage"] = this.splitPercentage;
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.careUnits)) {
            data["careUnits"] = [];
            for (let item of this.careUnits)
                data["careUnits"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateHealthProfessionalMedicalProcedureInput {
        const json = this.toJSON();
        let result = new CreateHealthProfessionalMedicalProcedureInput();
        result.init(json);
        return result;
    }
}

export interface ICreateHealthProfessionalMedicalProcedureInput {
    professionalId: string;
    medicalProcedureId: number;
    duration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    isActive: boolean;
    comments: string | undefined;
    allowOnlineSchedule: boolean;
    splitPercentage: number | undefined;
    insuranceCompanies: ProfessionalCompanyBasicInputDto[] | undefined;
    insurancePlans: ProfessionalPlanBasicInputDto[] | undefined;
    careUnits: ProfessionalCareUnitBasicInputDto[] | undefined;
}

export class ToggleHealthProfessionalMedicalProcedureActiveDto implements IToggleHealthProfessionalMedicalProcedureActiveDto {
    id: number;
    isActive: boolean;

    constructor(data?: IToggleHealthProfessionalMedicalProcedureActiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ToggleHealthProfessionalMedicalProcedureActiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleHealthProfessionalMedicalProcedureActiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): ToggleHealthProfessionalMedicalProcedureActiveDto {
        const json = this.toJSON();
        let result = new ToggleHealthProfessionalMedicalProcedureActiveDto();
        result.init(json);
        return result;
    }
}

export interface IToggleHealthProfessionalMedicalProcedureActiveDto {
    id: number;
    isActive: boolean;
}

export class UpdateAppointmentEmailNotificationSettingsRequest implements IUpdateAppointmentEmailNotificationSettingsRequest {
    enabled: boolean;
    inbox: string | undefined;

    constructor(data?: IUpdateAppointmentEmailNotificationSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.inbox = _data["inbox"];
        }
    }

    static fromJS(data: any): UpdateAppointmentEmailNotificationSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppointmentEmailNotificationSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["inbox"] = this.inbox;
        return data; 
    }

    clone(): UpdateAppointmentEmailNotificationSettingsRequest {
        const json = this.toJSON();
        let result = new UpdateAppointmentEmailNotificationSettingsRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateAppointmentEmailNotificationSettingsRequest {
    enabled: boolean;
    inbox: string | undefined;
}

export class AppointmentEmailNotificationSettingsResponse implements IAppointmentEmailNotificationSettingsResponse {
    enabled: boolean;
    inbox: string | undefined;

    constructor(data?: IAppointmentEmailNotificationSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.inbox = _data["inbox"];
        }
    }

    static fromJS(data: any): AppointmentEmailNotificationSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentEmailNotificationSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["inbox"] = this.inbox;
        return data; 
    }

    clone(): AppointmentEmailNotificationSettingsResponse {
        const json = this.toJSON();
        let result = new AppointmentEmailNotificationSettingsResponse();
        result.init(json);
        return result;
    }
}

export interface IAppointmentEmailNotificationSettingsResponse {
    enabled: boolean;
    inbox: string | undefined;
}

export class AuthenticateHealthProfessionalRequest implements IAuthenticateHealthProfessionalRequest {
    email: string | undefined;
    name: string | undefined;

    constructor(data?: IAuthenticateHealthProfessionalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AuthenticateHealthProfessionalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateHealthProfessionalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        return data; 
    }

    clone(): AuthenticateHealthProfessionalRequest {
        const json = this.toJSON();
        let result = new AuthenticateHealthProfessionalRequest();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateHealthProfessionalRequest {
    email: string | undefined;
    name: string | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data; 
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class GetHealthProfessionalsInput implements IGetHealthProfessionalsInput {
    /** Nome do profissional (opcional) */
    text: string | undefined;
    /** Id do profissional (opcional) */
    professional: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetHealthProfessionalsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.professional = _data["professional"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetHealthProfessionalsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthProfessionalsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["professional"] = this.professional;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetHealthProfessionalsInput {
        const json = this.toJSON();
        let result = new GetHealthProfessionalsInput();
        result.init(json);
        return result;
    }
}

export interface IGetHealthProfessionalsInput {
    /** Nome do profissional (opcional) */
    text: string | undefined;
    /** Id do profissional (opcional) */
    professional: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class HealthProfessionalDto implements IHealthProfessionalDto {
    name: string | undefined;
    address: Address;
    user: UserDto;
    discriminator: string | undefined;
    id: string;

    constructor(data?: IHealthProfessionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.discriminator = _data["discriminator"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthProfessionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["discriminator"] = this.discriminator;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthProfessionalDto {
        const json = this.toJSON();
        let result = new HealthProfessionalDto();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalDto {
    name: string | undefined;
    address: Address;
    user: UserDto;
    discriminator: string | undefined;
    id: string;
}

export class HealthProfessionalDtoPagedResultDto implements IHealthProfessionalDtoPagedResultDto {
    totalCount: number;
    items: HealthProfessionalDto[] | undefined;

    constructor(data?: IHealthProfessionalDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HealthProfessionalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthProfessionalDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HealthProfessionalDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HealthProfessionalDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalDtoPagedResultDto {
    totalCount: number;
    items: HealthProfessionalDto[] | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    tenantId: number | undefined;
    readonly userName: string | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string | undefined;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    gender: number | undefined;
    birthday: moment.Moment;
    invitation: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            (<any>this).userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.gender = _data["gender"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.invitation = _data["invitation"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        data["personalIdentifier"] = this.personalIdentifier;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["invitation"] = this.invitation;
        return data; 
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    tenantId: number | undefined;
    userName: string | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string | undefined;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    gender: number | undefined;
    birthday: moment.Moment;
    invitation: string;
}

export class CreateHealthProfessionalInput implements ICreateHealthProfessionalInput {
    user: CreateUserDto;
    isDoctor: boolean;
    profession: ProfessionData;
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;

    constructor(data?: ICreateHealthProfessionalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? CreateUserDto.fromJS(_data["user"]) : <any>undefined;
            this.isDoctor = _data["isDoctor"];
            this.profession = _data["profession"] ? ProfessionData.fromJS(_data["profession"]) : <any>undefined;
            this.licenceNumber = _data["licenceNumber"] ? LicenceNumber.fromJS(_data["licenceNumber"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.commercialPhone = _data["commercialPhone"];
        }
    }

    static fromJS(data: any): CreateHealthProfessionalInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthProfessionalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["isDoctor"] = this.isDoctor;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["licenceNumber"] = this.licenceNumber ? this.licenceNumber.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["commercialPhone"] = this.commercialPhone;
        return data; 
    }

    clone(): CreateHealthProfessionalInput {
        const json = this.toJSON();
        let result = new CreateHealthProfessionalInput();
        result.init(json);
        return result;
    }
}

export interface ICreateHealthProfessionalInput {
    user: CreateUserDto;
    isDoctor: boolean;
    profession: ProfessionData;
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;
}

export class HealthProfessionalBasicData implements IHealthProfessionalBasicData {
    name: string | undefined;
    id: string;

    constructor(data?: IHealthProfessionalBasicData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthProfessionalBasicData {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalBasicData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthProfessionalBasicData {
        const json = this.toJSON();
        let result = new HealthProfessionalBasicData();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalBasicData {
    name: string | undefined;
    id: string;
}

export class UpdateHealthProfessionalWorkJourneyInput implements IUpdateHealthProfessionalWorkJourneyInput {
    professional: string;
    workJourney: AvailableDateWindow[] | undefined;

    constructor(data?: IUpdateHealthProfessionalWorkJourneyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professional = _data["professional"];
            if (Array.isArray(_data["workJourney"])) {
                this.workJourney = [] as any;
                for (let item of _data["workJourney"])
                    this.workJourney.push(AvailableDateWindow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateHealthProfessionalWorkJourneyInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHealthProfessionalWorkJourneyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professional"] = this.professional;
        if (Array.isArray(this.workJourney)) {
            data["workJourney"] = [];
            for (let item of this.workJourney)
                data["workJourney"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpdateHealthProfessionalWorkJourneyInput {
        const json = this.toJSON();
        let result = new UpdateHealthProfessionalWorkJourneyInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateHealthProfessionalWorkJourneyInput {
    professional: string;
    workJourney: AvailableDateWindow[] | undefined;
}

export class GetProfessionalAvailabilityInput implements IGetProfessionalAvailabilityInput {
    /** Ids of the professionals */
    ids: string[] | undefined;

    constructor(data?: IGetProfessionalAvailabilityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids.push(item);
            }
        }
    }

    static fromJS(data: any): GetProfessionalAvailabilityInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfessionalAvailabilityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): GetProfessionalAvailabilityInput {
        const json = this.toJSON();
        let result = new GetProfessionalAvailabilityInput();
        result.init(json);
        return result;
    }
}

export interface IGetProfessionalAvailabilityInput {
    /** Ids of the professionals */
    ids: string[] | undefined;
}

export class ProfessionalAvailabilityDto implements IProfessionalAvailabilityDto {
    id: string;
    availability: AvailableDateWindow[] | undefined;

    constructor(data?: IProfessionalAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["availability"])) {
                this.availability = [] as any;
                for (let item of _data["availability"])
                    this.availability.push(AvailableDateWindow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfessionalAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.availability)) {
            data["availability"] = [];
            for (let item of this.availability)
                data["availability"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ProfessionalAvailabilityDto {
        const json = this.toJSON();
        let result = new ProfessionalAvailabilityDto();
        result.init(json);
        return result;
    }
}

export interface IProfessionalAvailabilityDto {
    id: string;
    availability: AvailableDateWindow[] | undefined;
}

export class IsReadyDto implements IIsReadyDto {
    isReady: boolean;
    /** Pending config (professional data, procedures, work journey, etc.) */
    pending: string | undefined;

    constructor(data?: IIsReadyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isReady = _data["isReady"];
            this.pending = _data["pending"];
        }
    }

    static fromJS(data: any): IsReadyDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsReadyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReady"] = this.isReady;
        data["pending"] = this.pending;
        return data; 
    }

    clone(): IsReadyDto {
        const json = this.toJSON();
        let result = new IsReadyDto();
        result.init(json);
        return result;
    }
}

export interface IIsReadyDto {
    isReady: boolean;
    /** Pending config (professional data, procedures, work journey, etc.) */
    pending: string | undefined;
}

export class UpdateHealthProfessionalInput implements IUpdateHealthProfessionalInput {
    name: string | undefined;
    address: Address;
    id: string;

    constructor(data?: IUpdateHealthProfessionalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateHealthProfessionalInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHealthProfessionalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateHealthProfessionalInput {
        const json = this.toJSON();
        let result = new UpdateHealthProfessionalInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateHealthProfessionalInput {
    name: string | undefined;
    address: Address;
    id: string;
}

export class CreateHealthTenantRequest implements ICreateHealthTenantRequest {
    creatorProfile: CreatorProfile;
    isProfessional: boolean;
    readonly tenancyName: string | undefined;
    businessType: BusinessType;
    editionId: number | undefined;
    editionName: string | undefined;
    possibleEditions: EditionDto[] | undefined;
    edition: EditionDto;
    name: string | undefined;
    commercialIdentifier: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    gatewayPaymentToken: string | undefined;
    pickedPlan: boolean;
    fiscalInfo: FiscalInfo;
    externalId: number;
    utm_source: string | undefined;
    utm_medium: string | undefined;
    utm_campaign: string | undefined;
    utm_content: string | undefined;

    constructor(data?: ICreateHealthTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorProfile = _data["creatorProfile"];
            this.isProfessional = _data["isProfessional"];
            (<any>this).tenancyName = _data["tenancyName"];
            this.businessType = _data["businessType"];
            this.editionId = _data["editionId"];
            this.editionName = _data["editionName"];
            if (Array.isArray(_data["possibleEditions"])) {
                this.possibleEditions = [] as any;
                for (let item of _data["possibleEditions"])
                    this.possibleEditions.push(EditionDto.fromJS(item));
            }
            this.edition = _data["edition"] ? EditionDto.fromJS(_data["edition"]) : <any>undefined;
            this.name = _data["name"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.gatewayPaymentToken = _data["gatewayPaymentToken"];
            this.pickedPlan = _data["pickedPlan"];
            this.fiscalInfo = _data["fiscalInfo"] ? FiscalInfo.fromJS(_data["fiscalInfo"]) : <any>undefined;
            this.externalId = _data["externalId"];
            this.utm_source = _data["utm_source"];
            this.utm_medium = _data["utm_medium"];
            this.utm_campaign = _data["utm_campaign"];
            this.utm_content = _data["utm_content"];
        }
    }

    static fromJS(data: any): CreateHealthTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorProfile"] = this.creatorProfile;
        data["isProfessional"] = this.isProfessional;
        data["tenancyName"] = this.tenancyName;
        data["businessType"] = this.businessType;
        data["editionId"] = this.editionId;
        data["editionName"] = this.editionName;
        if (Array.isArray(this.possibleEditions)) {
            data["possibleEditions"] = [];
            for (let item of this.possibleEditions)
                data["possibleEditions"].push(item.toJSON());
        }
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["gatewayPaymentToken"] = this.gatewayPaymentToken;
        data["pickedPlan"] = this.pickedPlan;
        data["fiscalInfo"] = this.fiscalInfo ? this.fiscalInfo.toJSON() : <any>undefined;
        data["externalId"] = this.externalId;
        data["utm_source"] = this.utm_source;
        data["utm_medium"] = this.utm_medium;
        data["utm_campaign"] = this.utm_campaign;
        data["utm_content"] = this.utm_content;
        return data; 
    }

    clone(): CreateHealthTenantRequest {
        const json = this.toJSON();
        let result = new CreateHealthTenantRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateHealthTenantRequest {
    creatorProfile: CreatorProfile;
    isProfessional: boolean;
    tenancyName: string | undefined;
    businessType: BusinessType;
    editionId: number | undefined;
    editionName: string | undefined;
    possibleEditions: EditionDto[] | undefined;
    edition: EditionDto;
    name: string | undefined;
    commercialIdentifier: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    gatewayPaymentToken: string | undefined;
    pickedPlan: boolean;
    fiscalInfo: FiscalInfo;
    externalId: number;
    utm_source: string | undefined;
    utm_medium: string | undefined;
    utm_campaign: string | undefined;
    utm_content: string | undefined;
}

export class DoctorPersonalData implements IDoctorPersonalData {
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;
    professionData: ProfessionData;
    name: string | undefined;
    emailAddress: string | undefined;
    personalIdentifier: string | undefined;
    birthday: moment.Moment | undefined;
    gender: number | undefined;
    phoneNumber: string | undefined;

    constructor(data?: IDoctorPersonalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceNumber = _data["licenceNumber"] ? LicenceNumber.fromJS(_data["licenceNumber"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.commercialPhone = _data["commercialPhone"];
            this.professionData = _data["professionData"] ? ProfessionData.fromJS(_data["professionData"]) : <any>undefined;
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): DoctorPersonalData {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorPersonalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceNumber"] = this.licenceNumber ? this.licenceNumber.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["commercialPhone"] = this.commercialPhone;
        data["professionData"] = this.professionData ? this.professionData.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["personalIdentifier"] = this.personalIdentifier;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }

    clone(): DoctorPersonalData {
        const json = this.toJSON();
        let result = new DoctorPersonalData();
        result.init(json);
        return result;
    }
}

export interface IDoctorPersonalData {
    licenceNumber: LicenceNumber;
    address: Address;
    commercialPhone: string | undefined;
    professionData: ProfessionData;
    name: string | undefined;
    emailAddress: string | undefined;
    personalIdentifier: string | undefined;
    birthday: moment.Moment | undefined;
    gender: number | undefined;
    phoneNumber: string | undefined;
}

export class ClinicData implements IClinicData {
    name: string | undefined;
    address: Address;
    fixedPhone: string | undefined;
    phone: string | undefined;
    commercialIdentifier: string | undefined;

    constructor(data?: IClinicData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.fixedPhone = _data["fixedPhone"];
            this.phone = _data["phone"];
            this.commercialIdentifier = _data["commercialIdentifier"];
        }
    }

    static fromJS(data: any): ClinicData {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fixedPhone"] = this.fixedPhone;
        data["phone"] = this.phone;
        data["commercialIdentifier"] = this.commercialIdentifier;
        return data; 
    }

    clone(): ClinicData {
        const json = this.toJSON();
        let result = new ClinicData();
        result.init(json);
        return result;
    }
}

export interface IClinicData {
    name: string | undefined;
    address: Address;
    fixedPhone: string | undefined;
    phone: string | undefined;
    commercialIdentifier: string | undefined;
}

export class MedicalProfession implements IMedicalProfession {
    id: number;
    title: string | undefined;
    agency: string | undefined;

    constructor(data?: IMedicalProfession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.agency = _data["agency"];
        }
    }

    static fromJS(data: any): MedicalProfession {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProfession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["agency"] = this.agency;
        return data; 
    }

    clone(): MedicalProfession {
        const json = this.toJSON();
        let result = new MedicalProfession();
        result.init(json);
        return result;
    }
}

export interface IMedicalProfession {
    id: number;
    title: string | undefined;
    agency: string | undefined;
}

export class MedicalProfessionAgency implements IMedicalProfessionAgency {
    id: string | undefined;
    title: string | undefined;

    constructor(data?: IMedicalProfessionAgency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MedicalProfessionAgency {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProfessionAgency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data; 
    }

    clone(): MedicalProfessionAgency {
        const json = this.toJSON();
        let result = new MedicalProfessionAgency();
        result.init(json);
        return result;
    }
}

export interface IMedicalProfessionAgency {
    id: string | undefined;
    title: string | undefined;
}

export class GetMedicalProfessionDataResponse implements IGetMedicalProfessionDataResponse {
    professions: MedicalProfession[] | undefined;
    specialties: MedicalProfessionSpecialty[] | undefined;
    agencies: MedicalProfessionAgency[] | undefined;

    constructor(data?: IGetMedicalProfessionDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions.push(MedicalProfession.fromJS(item));
            }
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties.push(MedicalProfessionSpecialty.fromJS(item));
            }
            if (Array.isArray(_data["agencies"])) {
                this.agencies = [] as any;
                for (let item of _data["agencies"])
                    this.agencies.push(MedicalProfessionAgency.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMedicalProfessionDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalProfessionDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item.toJSON());
        }
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item.toJSON());
        }
        if (Array.isArray(this.agencies)) {
            data["agencies"] = [];
            for (let item of this.agencies)
                data["agencies"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetMedicalProfessionDataResponse {
        const json = this.toJSON();
        let result = new GetMedicalProfessionDataResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalProfessionDataResponse {
    professions: MedicalProfession[] | undefined;
    specialties: MedicalProfessionSpecialty[] | undefined;
    agencies: MedicalProfessionAgency[] | undefined;
}

export class CompleteHealthTenantRegistrationRequest implements ICompleteHealthTenantRegistrationRequest {
    tenantId: number;
    userId: number;
    token: string | undefined;
    passwordResetCode: string | undefined;
    password: string | undefined;
    personalData: DoctorPersonalData;
    isClinicOwner: boolean;
    clinic: ClinicData;
    medicalProfessions: GetMedicalProfessionDataResponse;

    constructor(data?: ICompleteHealthTenantRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.token = _data["token"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.password = _data["password"];
            this.personalData = _data["personalData"] ? DoctorPersonalData.fromJS(_data["personalData"]) : <any>undefined;
            this.isClinicOwner = _data["isClinicOwner"];
            this.clinic = _data["clinic"] ? ClinicData.fromJS(_data["clinic"]) : <any>undefined;
            this.medicalProfessions = _data["medicalProfessions"] ? GetMedicalProfessionDataResponse.fromJS(_data["medicalProfessions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompleteHealthTenantRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteHealthTenantRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["token"] = this.token;
        data["passwordResetCode"] = this.passwordResetCode;
        data["password"] = this.password;
        data["personalData"] = this.personalData ? this.personalData.toJSON() : <any>undefined;
        data["isClinicOwner"] = this.isClinicOwner;
        data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>undefined;
        data["medicalProfessions"] = this.medicalProfessions ? this.medicalProfessions.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CompleteHealthTenantRegistrationRequest {
        const json = this.toJSON();
        let result = new CompleteHealthTenantRegistrationRequest();
        result.init(json);
        return result;
    }
}

export interface ICompleteHealthTenantRegistrationRequest {
    tenantId: number;
    userId: number;
    token: string | undefined;
    passwordResetCode: string | undefined;
    password: string | undefined;
    personalData: DoctorPersonalData;
    isClinicOwner: boolean;
    clinic: ClinicData;
    medicalProfessions: GetMedicalProfessionDataResponse;
}

export class MobileProjectDto implements IMobileProjectDto {
    name: string | undefined;
    definition: string | undefined;
    id: string;

    constructor(data?: IMobileProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.definition = _data["definition"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MobileProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobileProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["definition"] = this.definition;
        data["id"] = this.id;
        return data; 
    }

    clone(): MobileProjectDto {
        const json = this.toJSON();
        let result = new MobileProjectDto();
        result.init(json);
        return result;
    }
}

export interface IMobileProjectDto {
    name: string | undefined;
    definition: string | undefined;
    id: string;
}

export class HealthTenantDto implements IHealthTenantDto {
    token: string | undefined;
    tenancyName: string;
    name: string;
    isActive: boolean;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: FiscalInfo;
    paymentInfo: PaymentInfo;
    billingCycle: BillingCycle;
    /** External Id, Vindi external customer id */
    externalId: number;
    activePaymentProfile: number;
    activeSubscription: number;
    pickedPlan: boolean;
    /** Date when the payment was made */
    activationTime: moment.Moment | undefined;
    /** Domain for the template site, for now: xxxx.vsaude.com.br */
    domain: string | undefined;
    mobileProject: MobileProjectDto;
    id: number;

    constructor(data?: IHealthTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.fixedPhone = _data["fixedPhone"];
            this.email = _data["email"];
            this.businessType = _data["businessType"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.fiscalInfo = _data["fiscalInfo"] ? FiscalInfo.fromJS(_data["fiscalInfo"]) : <any>undefined;
            this.paymentInfo = _data["paymentInfo"] ? PaymentInfo.fromJS(_data["paymentInfo"]) : <any>undefined;
            this.billingCycle = _data["billingCycle"];
            this.externalId = _data["externalId"];
            this.activePaymentProfile = _data["activePaymentProfile"];
            this.activeSubscription = _data["activeSubscription"];
            this.pickedPlan = _data["pickedPlan"];
            this.activationTime = _data["activationTime"] ? moment(_data["activationTime"].toString()) : <any>undefined;
            this.domain = _data["domain"];
            this.mobileProject = _data["mobileProject"] ? MobileProjectDto.fromJS(_data["mobileProject"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["phoneNumber"] = this.phoneNumber;
        data["fixedPhone"] = this.fixedPhone;
        data["email"] = this.email;
        data["businessType"] = this.businessType;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fiscalInfo"] = this.fiscalInfo ? this.fiscalInfo.toJSON() : <any>undefined;
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        data["billingCycle"] = this.billingCycle;
        data["externalId"] = this.externalId;
        data["activePaymentProfile"] = this.activePaymentProfile;
        data["activeSubscription"] = this.activeSubscription;
        data["pickedPlan"] = this.pickedPlan;
        data["activationTime"] = this.activationTime ? this.activationTime.toISOString() : <any>undefined;
        data["domain"] = this.domain;
        data["mobileProject"] = this.mobileProject ? this.mobileProject.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthTenantDto {
        const json = this.toJSON();
        let result = new HealthTenantDto();
        result.init(json);
        return result;
    }
}

export interface IHealthTenantDto {
    token: string | undefined;
    tenancyName: string;
    name: string;
    isActive: boolean;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: FiscalInfo;
    paymentInfo: PaymentInfo;
    billingCycle: BillingCycle;
    /** External Id, Vindi external customer id */
    externalId: number;
    activePaymentProfile: number;
    activeSubscription: number;
    pickedPlan: boolean;
    /** Date when the payment was made */
    activationTime: moment.Moment | undefined;
    /** Domain for the template site, for now: xxxx.vsaude.com.br */
    domain: string | undefined;
    mobileProject: MobileProjectDto;
    id: number;
}

export enum DiscountType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class Discount implements IDiscount {
    type: DiscountType;
    amountOff: number | undefined;
    amountLimit: number | undefined;
    percentOff: number | undefined;
    unitOff: number | undefined;
    cycles: number | undefined;
    id: number;

    constructor(data?: IDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.amountOff = _data["amountOff"];
            this.amountLimit = _data["amountLimit"];
            this.percentOff = _data["percentOff"];
            this.unitOff = _data["unitOff"];
            this.cycles = _data["cycles"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Discount {
        data = typeof data === 'object' ? data : {};
        let result = new Discount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["amountOff"] = this.amountOff;
        data["amountLimit"] = this.amountLimit;
        data["percentOff"] = this.percentOff;
        data["unitOff"] = this.unitOff;
        data["cycles"] = this.cycles;
        data["id"] = this.id;
        return data; 
    }

    clone(): Discount {
        const json = this.toJSON();
        let result = new Discount();
        result.init(json);
        return result;
    }
}

export interface IDiscount {
    type: DiscountType;
    amountOff: number | undefined;
    amountLimit: number | undefined;
    percentOff: number | undefined;
    unitOff: number | undefined;
    cycles: number | undefined;
    id: number;
}

export class ValidateVoucherInput implements IValidateVoucherInput {
    code: string | undefined;
    isInternal: boolean;
    billingCycle: BillingCycle;
    customerId: string | undefined;
    customerEmail: string | undefined;

    constructor(data?: IValidateVoucherInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.isInternal = _data["isInternal"];
            this.billingCycle = _data["billingCycle"];
            this.customerId = _data["customerId"];
            this.customerEmail = _data["customerEmail"];
        }
    }

    static fromJS(data: any): ValidateVoucherInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateVoucherInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isInternal"] = this.isInternal;
        data["billingCycle"] = this.billingCycle;
        data["customerId"] = this.customerId;
        data["customerEmail"] = this.customerEmail;
        return data; 
    }

    clone(): ValidateVoucherInput {
        const json = this.toJSON();
        let result = new ValidateVoucherInput();
        result.init(json);
        return result;
    }
}

export interface IValidateVoucherInput {
    code: string | undefined;
    isInternal: boolean;
    billingCycle: BillingCycle;
    customerId: string | undefined;
    customerEmail: string | undefined;
}

export class ValidateVoucherResult implements IValidateVoucherResult {
    valid: boolean;
    discount: Discount;
    errorMessage: string | undefined;

    constructor(data?: IValidateVoucherResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
            this.discount = _data["discount"] ? Discount.fromJS(_data["discount"]) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ValidateVoucherResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateVoucherResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }

    clone(): ValidateVoucherResult {
        const json = this.toJSON();
        let result = new ValidateVoucherResult();
        result.init(json);
        return result;
    }
}

export interface IValidateVoucherResult {
    valid: boolean;
    discount: Discount;
    errorMessage: string | undefined;
}

export class UpdateBasicInfoRequest implements IUpdateBasicInfoRequest {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    address: Address;

    constructor(data?: IUpdateBasicInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.fixedPhone = _data["fixedPhone"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateBasicInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBasicInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["phoneNumber"] = this.phoneNumber;
        data["fixedPhone"] = this.fixedPhone;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdateBasicInfoRequest {
        const json = this.toJSON();
        let result = new UpdateBasicInfoRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateBasicInfoRequest {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    address: Address;
}

export class TenantFiscalInfo implements ITenantFiscalInfo {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    address: Address;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;

    constructor(data?: ITenantFiscalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberExtension = _data["phoneNumberExtension"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): TenantFiscalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFiscalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberExtension"] = this.phoneNumberExtension;
        data["email"] = this.email;
        return data; 
    }

    clone(): TenantFiscalInfo {
        const json = this.toJSON();
        let result = new TenantFiscalInfo();
        result.init(json);
        return result;
    }
}

export interface ITenantFiscalInfo {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    address: Address;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;
}

export class PaymentCompany implements IPaymentCompany {
    id: number;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: IPaymentCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): PaymentCompany {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }

    clone(): PaymentCompany {
        const json = this.toJSON();
        let result = new PaymentCompany();
        result.init(json);
        return result;
    }
}

export interface IPaymentCompany {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class PaymentMethod implements IPaymentMethod {
    id: number;
    public_name: string | undefined;
    code: string | undefined;
    type: string | undefined;

    constructor(data?: IPaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.public_name = _data["public_name"];
            this.code = _data["code"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["public_name"] = this.public_name;
        data["code"] = this.code;
        data["type"] = this.type;
        return data; 
    }

    clone(): PaymentMethod {
        const json = this.toJSON();
        let result = new PaymentMethod();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethod {
    id: number;
    public_name: string | undefined;
    code: string | undefined;
    type: string | undefined;
}

export class PaymentProfile implements IPaymentProfile {
    id: number;
    status: string | undefined;
    holder_name: string | undefined;
    card_expiration: moment.Moment;
    card_number_first_six: string | undefined;
    card_number_last_four: string | undefined;
    payment_company: PaymentCompany;
    payment_method: PaymentMethod;

    constructor(data?: IPaymentProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.holder_name = _data["holder_name"];
            this.card_expiration = _data["card_expiration"] ? moment(_data["card_expiration"].toString()) : <any>undefined;
            this.card_number_first_six = _data["card_number_first_six"];
            this.card_number_last_four = _data["card_number_last_four"];
            this.payment_company = _data["payment_company"] ? PaymentCompany.fromJS(_data["payment_company"]) : <any>undefined;
            this.payment_method = _data["payment_method"] ? PaymentMethod.fromJS(_data["payment_method"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentProfile {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["holder_name"] = this.holder_name;
        data["card_expiration"] = this.card_expiration ? this.card_expiration.toISOString() : <any>undefined;
        data["card_number_first_six"] = this.card_number_first_six;
        data["card_number_last_four"] = this.card_number_last_four;
        data["payment_company"] = this.payment_company ? this.payment_company.toJSON() : <any>undefined;
        data["payment_method"] = this.payment_method ? this.payment_method.toJSON() : <any>undefined;
        return data; 
    }

    clone(): PaymentProfile {
        const json = this.toJSON();
        let result = new PaymentProfile();
        result.init(json);
        return result;
    }
}

export interface IPaymentProfile {
    id: number;
    status: string | undefined;
    holder_name: string | undefined;
    card_expiration: moment.Moment;
    card_number_first_six: string | undefined;
    card_number_last_four: string | undefined;
    payment_company: PaymentCompany;
    payment_method: PaymentMethod;
}

export enum SubscriptionPaymentMethod {
    _0 = 0,
    _3 = 3,
}

export class SubscriptionCreditCardInfo implements ISubscriptionCreditCardInfo {
    flag: string | undefined;
    ownerName: string | undefined;
    digits: string | undefined;
    expirationMonth: string | undefined;
    expirationYear: string | undefined;

    constructor(data?: ISubscriptionCreditCardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flag = _data["flag"];
            this.ownerName = _data["ownerName"];
            this.digits = _data["digits"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
        }
    }

    static fromJS(data: any): SubscriptionCreditCardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCreditCardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flag"] = this.flag;
        data["ownerName"] = this.ownerName;
        data["digits"] = this.digits;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        return data; 
    }

    clone(): SubscriptionCreditCardInfo {
        const json = this.toJSON();
        let result = new SubscriptionCreditCardInfo();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionCreditCardInfo {
    flag: string | undefined;
    ownerName: string | undefined;
    digits: string | undefined;
    expirationMonth: string | undefined;
    expirationYear: string | undefined;
}

export class SubscriptionCustomer implements ISubscriptionCustomer {
    id: number;
    fiscalIdentifier: string | undefined;
    address: Address;
    paymentMethod: SubscriptionPaymentMethod;
    creditCard: SubscriptionCreditCardInfo;

    constructor(data?: ISubscriptionCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fiscalIdentifier = _data["fiscalIdentifier"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.paymentMethod = _data["paymentMethod"];
            this.creditCard = _data["creditCard"] ? SubscriptionCreditCardInfo.fromJS(_data["creditCard"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fiscalIdentifier"] = this.fiscalIdentifier;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["paymentMethod"] = this.paymentMethod;
        data["creditCard"] = this.creditCard ? this.creditCard.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SubscriptionCustomer {
        const json = this.toJSON();
        let result = new SubscriptionCustomer();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionCustomer {
    id: number;
    fiscalIdentifier: string | undefined;
    address: Address;
    paymentMethod: SubscriptionPaymentMethod;
    creditCard: SubscriptionCreditCardInfo;
}

export enum SubscriptionStatusCode {
    _0 = 0,
    _1 = 1,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _71 = 71,
    _254 = 254,
}

export class SubscriptionItem implements ISubscriptionItem {
    name: string | undefined;
    value: string | undefined;
    /** True if not included on default Edition's items */
    extra: boolean;
    /** True if one time purchase */
    oneTime: boolean;
    /** Price when Extra = True or OneTime = True */
    price: number | undefined;
    status: SubscriptionStatusCode;

    constructor(data?: ISubscriptionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.extra = _data["extra"];
            this.oneTime = _data["oneTime"];
            this.price = _data["price"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SubscriptionItem {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["extra"] = this.extra;
        data["oneTime"] = this.oneTime;
        data["price"] = this.price;
        data["status"] = this.status;
        return data; 
    }

    clone(): SubscriptionItem {
        const json = this.toJSON();
        let result = new SubscriptionItem();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionItem {
    name: string | undefined;
    value: string | undefined;
    /** True if not included on default Edition's items */
    extra: boolean;
    /** True if one time purchase */
    oneTime: boolean;
    /** Price when Extra = True or OneTime = True */
    price: number | undefined;
    status: SubscriptionStatusCode;
}

export class SubscriptionStatus implements ISubscriptionStatus {
    code: SubscriptionStatusCode;
    date: moment.Moment | undefined;

    constructor(data?: ISubscriptionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }

    clone(): SubscriptionStatus {
        const json = this.toJSON();
        let result = new SubscriptionStatus();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionStatus {
    code: SubscriptionStatusCode;
    date: moment.Moment | undefined;
}

export class SubscriptionInfo implements ISubscriptionInfo {
    customer: SubscriptionCustomer;
    editionId: string | undefined;
    editionName: string | undefined;
    price: number;
    currentPrice: number;
    billingCycle: BillingCycle;
    startDate: moment.Moment;
    items: SubscriptionItem[] | undefined;
    status: SubscriptionStatus;
    activeBilling: { [key: string]: moment.Moment; } | undefined;

    constructor(data?: ISubscriptionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? SubscriptionCustomer.fromJS(_data["customer"]) : <any>undefined;
            this.editionId = _data["editionId"];
            this.editionName = _data["editionName"];
            this.price = _data["price"];
            this.currentPrice = _data["currentPrice"];
            this.billingCycle = _data["billingCycle"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SubscriptionItem.fromJS(item));
            }
            this.status = _data["status"] ? SubscriptionStatus.fromJS(_data["status"]) : <any>undefined;
            if (_data["activeBilling"]) {
                this.activeBilling = {} as any;
                for (let key in _data["activeBilling"]) {
                    if (_data["activeBilling"].hasOwnProperty(key))
                        (<any>this.activeBilling)[key] = _data["activeBilling"][key] ? moment(_data["activeBilling"][key].toString()) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): SubscriptionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["editionId"] = this.editionId;
        data["editionName"] = this.editionName;
        data["price"] = this.price;
        data["currentPrice"] = this.currentPrice;
        data["billingCycle"] = this.billingCycle;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (this.activeBilling) {
            data["activeBilling"] = {};
            for (let key in this.activeBilling) {
                if (this.activeBilling.hasOwnProperty(key))
                    (<any>data["activeBilling"])[key] = this.activeBilling[key] ? this.activeBilling[key].toISOString() : <any>undefined;
            }
        }
        return data; 
    }

    clone(): SubscriptionInfo {
        const json = this.toJSON();
        let result = new SubscriptionInfo();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionInfo {
    customer: SubscriptionCustomer;
    editionId: string | undefined;
    editionName: string | undefined;
    price: number;
    currentPrice: number;
    billingCycle: BillingCycle;
    startDate: moment.Moment;
    items: SubscriptionItem[] | undefined;
    status: SubscriptionStatus;
    activeBilling: { [key: string]: moment.Moment; } | undefined;
}

export class TenantInfo implements ITenantInfo {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: TenantFiscalInfo;
    paymentProfile: PaymentProfile;
    edition: EditionDto;
    subscriptionInfo: SubscriptionInfo;
    /** For now will be used the mobile app logo */
    logoUrl: string | undefined;
    isAllowToAcceptPayment: boolean;
    id: number;

    constructor(data?: ITenantInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.fixedPhone = _data["fixedPhone"];
            this.email = _data["email"];
            this.businessType = _data["businessType"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.fiscalInfo = _data["fiscalInfo"] ? TenantFiscalInfo.fromJS(_data["fiscalInfo"]) : <any>undefined;
            this.paymentProfile = _data["paymentProfile"] ? PaymentProfile.fromJS(_data["paymentProfile"]) : <any>undefined;
            this.edition = _data["edition"] ? EditionDto.fromJS(_data["edition"]) : <any>undefined;
            this.subscriptionInfo = _data["subscriptionInfo"] ? SubscriptionInfo.fromJS(_data["subscriptionInfo"]) : <any>undefined;
            this.logoUrl = _data["logoUrl"];
            this.isAllowToAcceptPayment = _data["isAllowToAcceptPayment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["phoneNumber"] = this.phoneNumber;
        data["fixedPhone"] = this.fixedPhone;
        data["email"] = this.email;
        data["businessType"] = this.businessType;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fiscalInfo"] = this.fiscalInfo ? this.fiscalInfo.toJSON() : <any>undefined;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["subscriptionInfo"] = this.subscriptionInfo ? this.subscriptionInfo.toJSON() : <any>undefined;
        data["logoUrl"] = this.logoUrl;
        data["isAllowToAcceptPayment"] = this.isAllowToAcceptPayment;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantInfo {
        const json = this.toJSON();
        let result = new TenantInfo();
        result.init(json);
        return result;
    }
}

export interface ITenantInfo {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: TenantFiscalInfo;
    paymentProfile: PaymentProfile;
    edition: EditionDto;
    subscriptionInfo: SubscriptionInfo;
    /** For now will be used the mobile app logo */
    logoUrl: string | undefined;
    isAllowToAcceptPayment: boolean;
    id: number;
}

export class UpdateFiscalInfoRequest implements IUpdateFiscalInfoRequest {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    address: Address;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;

    constructor(data?: IUpdateFiscalInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberExtension = _data["phoneNumberExtension"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateFiscalInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFiscalInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberExtension"] = this.phoneNumberExtension;
        data["email"] = this.email;
        return data; 
    }

    clone(): UpdateFiscalInfoRequest {
        const json = this.toJSON();
        let result = new UpdateFiscalInfoRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateFiscalInfoRequest {
    name: string | undefined;
    commercialIdentifier: string | undefined;
    address: Address;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;
}

export class UpdatePaymentProfileRequest implements IUpdatePaymentProfileRequest {
    editionName: string | undefined;
    token: string | undefined;
    name: string | undefined;
    identifier: string | undefined;
    address: Address;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;
    isYearlyBillingPeriod: boolean;
    vouchers: string[] | undefined;
    fiscalInfo: FiscalInfo;

    constructor(data?: IUpdatePaymentProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionName = _data["editionName"];
            this.token = _data["token"];
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberExtension = _data["phoneNumberExtension"];
            this.email = _data["email"];
            this.isYearlyBillingPeriod = _data["isYearlyBillingPeriod"];
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers.push(item);
            }
            this.fiscalInfo = _data["fiscalInfo"] ? FiscalInfo.fromJS(_data["fiscalInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePaymentProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionName"] = this.editionName;
        data["token"] = this.token;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberExtension"] = this.phoneNumberExtension;
        data["email"] = this.email;
        data["isYearlyBillingPeriod"] = this.isYearlyBillingPeriod;
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item);
        }
        data["fiscalInfo"] = this.fiscalInfo ? this.fiscalInfo.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdatePaymentProfileRequest {
        const json = this.toJSON();
        let result = new UpdatePaymentProfileRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePaymentProfileRequest {
    editionName: string | undefined;
    token: string | undefined;
    name: string | undefined;
    identifier: string | undefined;
    address: Address;
    phoneNumber: string | undefined;
    phoneNumberExtension: string | undefined;
    email: string | undefined;
    isYearlyBillingPeriod: boolean;
    vouchers: string[] | undefined;
    fiscalInfo: FiscalInfo;
}

export class HealthTenantDtoPagedResultDto implements IHealthTenantDtoPagedResultDto {
    totalCount: number;
    items: HealthTenantDto[] | undefined;

    constructor(data?: IHealthTenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HealthTenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthTenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HealthTenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HealthTenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHealthTenantDtoPagedResultDto {
    totalCount: number;
    items: HealthTenantDto[] | undefined;
}

export class HomeScreenMenuItemTranslation implements IHomeScreenMenuItemTranslation {
    language: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    html: string | undefined;

    constructor(data?: IHomeScreenMenuItemTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.html = _data["html"];
        }
    }

    static fromJS(data: any): HomeScreenMenuItemTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new HomeScreenMenuItemTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["html"] = this.html;
        return data; 
    }

    clone(): HomeScreenMenuItemTranslation {
        const json = this.toJSON();
        let result = new HomeScreenMenuItemTranslation();
        result.init(json);
        return result;
    }
}

export interface IHomeScreenMenuItemTranslation {
    language: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    html: string | undefined;
}

export class HomeScreenMenuItem implements IHomeScreenMenuItem {
    id: string | undefined;
    order: number;
    icon: string | undefined;
    translations: HomeScreenMenuItemTranslation[] | undefined;

    constructor(data?: IHomeScreenMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations.push(HomeScreenMenuItemTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HomeScreenMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new HomeScreenMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["icon"] = this.icon;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HomeScreenMenuItem {
        const json = this.toJSON();
        let result = new HomeScreenMenuItem();
        result.init(json);
        return result;
    }
}

export interface IHomeScreenMenuItem {
    id: string | undefined;
    order: number;
    icon: string | undefined;
    translations: HomeScreenMenuItemTranslation[] | undefined;
}

export class HomeScreenTranslation implements IHomeScreenTranslation {
    language: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;

    constructor(data?: IHomeScreenTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
        }
    }

    static fromJS(data: any): HomeScreenTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new HomeScreenTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        return data; 
    }

    clone(): HomeScreenTranslation {
        const json = this.toJSON();
        let result = new HomeScreenTranslation();
        result.init(json);
        return result;
    }
}

export interface IHomeScreenTranslation {
    language: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
}

export class HomeScreen implements IHomeScreen {
    headerImage: string | undefined;
    items: HomeScreenMenuItem[] | undefined;
    translations: HomeScreenTranslation[] | undefined;

    constructor(data?: IHomeScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headerImage = _data["headerImage"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HomeScreenMenuItem.fromJS(item));
            }
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations.push(HomeScreenTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HomeScreen {
        data = typeof data === 'object' ? data : {};
        let result = new HomeScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerImage"] = this.headerImage;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HomeScreen {
        const json = this.toJSON();
        let result = new HomeScreen();
        result.init(json);
        return result;
    }
}

export interface IHomeScreen {
    headerImage: string | undefined;
    items: HomeScreenMenuItem[] | undefined;
    translations: HomeScreenTranslation[] | undefined;
}

export class Icon implements IIcon {
    name: string | undefined;
    ligature: string | undefined;
    tags: string[] | undefined;

    constructor(data?: IIcon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ligature = _data["ligature"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
        }
    }

    static fromJS(data: any): Icon {
        data = typeof data === 'object' ? data : {};
        let result = new Icon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ligature"] = this.ligature;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data; 
    }

    clone(): Icon {
        const json = this.toJSON();
        let result = new Icon();
        result.init(json);
        return result;
    }
}

export interface IIcon {
    name: string | undefined;
    ligature: string | undefined;
    tags: string[] | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId: number | undefined;
    userId: number | undefined;
    impersonatingPatient: boolean;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.impersonatingPatient = _data["impersonatingPatient"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["impersonatingPatient"] = this.impersonatingPatient;
        return data; 
    }

    clone(): ImpersonateInput {
        const json = this.toJSON();
        let result = new ImpersonateInput();
        result.init(json);
        return result;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number | undefined;
    impersonatingPatient: boolean;
}

export enum AbpLoginResultType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
}

export class Claim implements IClaim {
    issuer: string | undefined;
    originalIssuer: string | undefined;
    readonly properties: { [key: string]: string; } | undefined;
    subject: ClaimsIdentity;
    type: string | undefined;
    value: string | undefined;
    valueType: string | undefined;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.originalIssuer = _data["originalIssuer"];
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)[key] = _data["properties"][key];
                }
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"]) : <any>undefined;
            this.type = _data["type"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["originalIssuer"] = this.originalIssuer;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key];
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data; 
    }

    clone(): Claim {
        const json = this.toJSON();
        let result = new Claim();
        result.init(json);
        return result;
    }
}

export interface IClaim {
    issuer: string | undefined;
    originalIssuer: string | undefined;
    properties: { [key: string]: string; } | undefined;
    subject: ClaimsIdentity;
    type: string | undefined;
    value: string | undefined;
    valueType: string | undefined;
}

export class ClaimsIdentity implements IClaimsIdentity {
    authenticationType: string | undefined;
    readonly isAuthenticated: boolean;
    actor: ClaimsIdentity;
    bootstrapContext: any | undefined;
    claims: Claim[] | undefined;
    label: string | undefined;
    readonly name: string | undefined;
    readonly nameClaimType: string | undefined;
    readonly roleClaimType: string | undefined;

    constructor(data?: IClaimsIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationType = _data["authenticationType"];
            (<any>this).isAuthenticated = _data["isAuthenticated"];
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"]) : <any>undefined;
            this.bootstrapContext = _data["bootstrapContext"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(Claim.fromJS(item));
            }
            this.label = _data["label"];
            (<any>this).name = _data["name"];
            (<any>this).nameClaimType = _data["nameClaimType"];
            (<any>this).roleClaimType = _data["roleClaimType"];
        }
    }

    static fromJS(data: any): ClaimsIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType;
        data["isAuthenticated"] = this.isAuthenticated;
        data["actor"] = this.actor ? this.actor.toJSON() : <any>undefined;
        data["bootstrapContext"] = this.bootstrapContext;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["label"] = this.label;
        data["name"] = this.name;
        data["nameClaimType"] = this.nameClaimType;
        data["roleClaimType"] = this.roleClaimType;
        return data; 
    }

    clone(): ClaimsIdentity {
        const json = this.toJSON();
        let result = new ClaimsIdentity();
        result.init(json);
        return result;
    }
}

export interface IClaimsIdentity {
    authenticationType: string | undefined;
    isAuthenticated: boolean;
    actor: ClaimsIdentity;
    bootstrapContext: any | undefined;
    claims: Claim[] | undefined;
    label: string | undefined;
    name: string | undefined;
    nameClaimType: string | undefined;
    roleClaimType: string | undefined;
}

export class TenantUserAbpLoginResult implements ITenantUserAbpLoginResult {
    result: AbpLoginResultType;
    tenant: Tenant;
    user: User;
    identity: ClaimsIdentity;

    constructor(data?: ITenantUserAbpLoginResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.identity = _data["identity"] ? ClaimsIdentity.fromJS(_data["identity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantUserAbpLoginResult {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserAbpLoginResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["identity"] = this.identity ? this.identity.toJSON() : <any>undefined;
        return data; 
    }

    clone(): TenantUserAbpLoginResult {
        const json = this.toJSON();
        let result = new TenantUserAbpLoginResult();
        result.init(json);
        return result;
    }
}

export interface ITenantUserAbpLoginResult {
    result: AbpLoginResultType;
    tenant: Tenant;
    user: User;
    identity: ClaimsIdentity;
}

export class CreateInsuranceCompanyInput implements ICreateInsuranceCompanyInput {
    name: string | undefined;
    code: string | undefined;
    dailyLimit: number | undefined;
    returnDaysLimit: number | undefined;
    locked: boolean;

    constructor(data?: ICreateInsuranceCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.dailyLimit = _data["dailyLimit"];
            this.returnDaysLimit = _data["returnDaysLimit"];
            this.locked = _data["locked"];
        }
    }

    static fromJS(data: any): CreateInsuranceCompanyInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInsuranceCompanyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["dailyLimit"] = this.dailyLimit;
        data["returnDaysLimit"] = this.returnDaysLimit;
        data["locked"] = this.locked;
        return data; 
    }

    clone(): CreateInsuranceCompanyInput {
        const json = this.toJSON();
        let result = new CreateInsuranceCompanyInput();
        result.init(json);
        return result;
    }
}

export interface ICreateInsuranceCompanyInput {
    name: string | undefined;
    code: string | undefined;
    dailyLimit: number | undefined;
    returnDaysLimit: number | undefined;
    locked: boolean;
}

export enum InsurancePlanStatus {
    _0 = 0,
    _1 = 1,
}

export class MedicalProcedureCoveredByInsurancePlanDto implements IMedicalProcedureCoveredByInsurancePlanDto {
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalProcedureCoveredByInsurancePlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByInsurancePlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByInsurancePlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByInsurancePlanDto {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByInsurancePlanDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByInsurancePlanDto {
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MedicalAgreementDto implements IMedicalAgreementDto {
    name: string | undefined;
    doctor: DoctorDto;
    allowEdit: boolean;
    id: string;

    constructor(data?: IMedicalAgreementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.doctor = _data["doctor"] ? DoctorDto.fromJS(_data["doctor"]) : <any>undefined;
            this.allowEdit = _data["allowEdit"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["allowEdit"] = this.allowEdit;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalAgreementDto {
        const json = this.toJSON();
        let result = new MedicalAgreementDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalAgreementDto {
    name: string | undefined;
    doctor: DoctorDto;
    allowEdit: boolean;
    id: string;
}

export class MedicalProcedureCoveredByInsuranceCompanyData implements IMedicalProcedureCoveredByInsuranceCompanyData {
    price: number | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: IMedicalProcedureCoveredByInsuranceCompanyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByInsuranceCompanyData {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByInsuranceCompanyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByInsuranceCompanyData {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByInsuranceCompanyData();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByInsuranceCompanyData {
    price: number | undefined;
    name: string | undefined;
    id: number;
}

export class MedicalProcedureCoveredByInsurancePlanData implements IMedicalProcedureCoveredByInsurancePlanData {
    price: number | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: IMedicalProcedureCoveredByInsurancePlanData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByInsurancePlanData {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByInsurancePlanData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByInsurancePlanData {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByInsurancePlanData();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByInsurancePlanData {
    price: number | undefined;
    name: string | undefined;
    id: number;
}

export class MedicalProcedureCoveredByProfessionalData implements IMedicalProcedureCoveredByProfessionalData {
    duration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    minutesDuration: number | undefined;
    name: string | undefined;
    splitPercentage: number | undefined;
    id: string;

    constructor(data?: IMedicalProcedureCoveredByProfessionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.periodUnit = _data["periodUnit"];
            this.minutesDuration = _data["minutesDuration"];
            this.name = _data["name"];
            this.splitPercentage = _data["splitPercentage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByProfessionalData {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByProfessionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["periodUnit"] = this.periodUnit;
        data["minutesDuration"] = this.minutesDuration;
        data["name"] = this.name;
        data["splitPercentage"] = this.splitPercentage;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByProfessionalData {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByProfessionalData();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByProfessionalData {
    duration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    minutesDuration: number | undefined;
    name: string | undefined;
    splitPercentage: number | undefined;
    id: string;
}

export class MedicalProcedureCoveredCareUnitsData implements IMedicalProcedureCoveredCareUnitsData {
    name: string | undefined;
    isActive: boolean;
    workJourney: AvailableDateWindow[] | undefined;
    id: number;

    constructor(data?: IMedicalProcedureCoveredCareUnitsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["workJourney"])) {
                this.workJourney = [] as any;
                for (let item of _data["workJourney"])
                    this.workJourney.push(AvailableDateWindow.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredCareUnitsData {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredCareUnitsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.workJourney)) {
            data["workJourney"] = [];
            for (let item of this.workJourney)
                data["workJourney"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredCareUnitsData {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredCareUnitsData();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredCareUnitsData {
    name: string | undefined;
    isActive: boolean;
    workJourney: AvailableDateWindow[] | undefined;
    id: number;
}

export class MedicalProcedureResponsibilityTermDto implements IMedicalProcedureResponsibilityTermDto {
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    /** Will be mandatory to accept it when scheduling */
    requiredOnScheduling: boolean;
    allowEdit: boolean;
    id: number;

    constructor(data?: IMedicalProcedureResponsibilityTermDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.documentUrl = _data["documentUrl"];
            this.signatureRequiredOnlyOnce = _data["signatureRequiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
            this.allowEdit = _data["allowEdit"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureResponsibilityTermDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureResponsibilityTermDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["documentUrl"] = this.documentUrl;
        data["signatureRequiredOnlyOnce"] = this.signatureRequiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        data["allowEdit"] = this.allowEdit;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureResponsibilityTermDto {
        const json = this.toJSON();
        let result = new MedicalProcedureResponsibilityTermDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureResponsibilityTermDto {
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    /** Will be mandatory to accept it when scheduling */
    requiredOnScheduling: boolean;
    allowEdit: boolean;
    id: number;
}

export class MedicalProcedureDto implements IMedicalProcedureDto {
    name: string | undefined;
    description: string | undefined;
    publicDescription: string | undefined;
    duration: number;
    periodUnit: ProcedurePeriodUnit;
    price: number;
    scheduleColor: string | undefined;
    parentId: number | undefined;
    coveredInsuranceCompanies: MedicalProcedureCoveredByInsuranceCompanyData[] | undefined;
    coveredInsurancePlans: MedicalProcedureCoveredByInsurancePlanData[] | undefined;
    coveredByProfessionals: MedicalProcedureCoveredByProfessionalData[] | undefined;
    coveredCareUnits: MedicalProcedureCoveredCareUnitsData[] | undefined;
    allowOnlineSchedule: boolean;
    remotely: boolean;
    isReturn: boolean;
    returnParentId: number[] | undefined;
    hasDerivedProcedures: boolean;
    isProfessionalRequired: boolean | undefined;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    splitPercentage: number | undefined;
    responsibilityTerms: MedicalProcedureResponsibilityTermDto[] | undefined;
    maxNumberOfInstallments: number;
    minutesDuration: number;
    id: number;

    constructor(data?: IMedicalProcedureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.publicDescription = _data["publicDescription"];
            this.duration = _data["duration"];
            this.periodUnit = _data["periodUnit"];
            this.price = _data["price"];
            this.scheduleColor = _data["scheduleColor"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["coveredInsuranceCompanies"])) {
                this.coveredInsuranceCompanies = [] as any;
                for (let item of _data["coveredInsuranceCompanies"])
                    this.coveredInsuranceCompanies.push(MedicalProcedureCoveredByInsuranceCompanyData.fromJS(item));
            }
            if (Array.isArray(_data["coveredInsurancePlans"])) {
                this.coveredInsurancePlans = [] as any;
                for (let item of _data["coveredInsurancePlans"])
                    this.coveredInsurancePlans.push(MedicalProcedureCoveredByInsurancePlanData.fromJS(item));
            }
            if (Array.isArray(_data["coveredByProfessionals"])) {
                this.coveredByProfessionals = [] as any;
                for (let item of _data["coveredByProfessionals"])
                    this.coveredByProfessionals.push(MedicalProcedureCoveredByProfessionalData.fromJS(item));
            }
            if (Array.isArray(_data["coveredCareUnits"])) {
                this.coveredCareUnits = [] as any;
                for (let item of _data["coveredCareUnits"])
                    this.coveredCareUnits.push(MedicalProcedureCoveredCareUnitsData.fromJS(item));
            }
            this.allowOnlineSchedule = _data["allowOnlineSchedule"];
            this.remotely = _data["remotely"];
            this.isReturn = _data["isReturn"];
            if (Array.isArray(_data["returnParentId"])) {
                this.returnParentId = [] as any;
                for (let item of _data["returnParentId"])
                    this.returnParentId.push(item);
            }
            this.hasDerivedProcedures = _data["hasDerivedProcedures"];
            this.isProfessionalRequired = _data["isProfessionalRequired"];
            this.onlinePaymentType = _data["onlinePaymentType"];
            this.splitPercentage = _data["splitPercentage"];
            if (Array.isArray(_data["responsibilityTerms"])) {
                this.responsibilityTerms = [] as any;
                for (let item of _data["responsibilityTerms"])
                    this.responsibilityTerms.push(MedicalProcedureResponsibilityTermDto.fromJS(item));
            }
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
            this.minutesDuration = _data["minutesDuration"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["publicDescription"] = this.publicDescription;
        data["duration"] = this.duration;
        data["periodUnit"] = this.periodUnit;
        data["price"] = this.price;
        data["scheduleColor"] = this.scheduleColor;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.coveredInsuranceCompanies)) {
            data["coveredInsuranceCompanies"] = [];
            for (let item of this.coveredInsuranceCompanies)
                data["coveredInsuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredInsurancePlans)) {
            data["coveredInsurancePlans"] = [];
            for (let item of this.coveredInsurancePlans)
                data["coveredInsurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredByProfessionals)) {
            data["coveredByProfessionals"] = [];
            for (let item of this.coveredByProfessionals)
                data["coveredByProfessionals"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredCareUnits)) {
            data["coveredCareUnits"] = [];
            for (let item of this.coveredCareUnits)
                data["coveredCareUnits"].push(item.toJSON());
        }
        data["allowOnlineSchedule"] = this.allowOnlineSchedule;
        data["remotely"] = this.remotely;
        data["isReturn"] = this.isReturn;
        if (Array.isArray(this.returnParentId)) {
            data["returnParentId"] = [];
            for (let item of this.returnParentId)
                data["returnParentId"].push(item);
        }
        data["hasDerivedProcedures"] = this.hasDerivedProcedures;
        data["isProfessionalRequired"] = this.isProfessionalRequired;
        data["onlinePaymentType"] = this.onlinePaymentType;
        data["splitPercentage"] = this.splitPercentage;
        if (Array.isArray(this.responsibilityTerms)) {
            data["responsibilityTerms"] = [];
            for (let item of this.responsibilityTerms)
                data["responsibilityTerms"].push(item.toJSON());
        }
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        data["minutesDuration"] = this.minutesDuration;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureDto {
        const json = this.toJSON();
        let result = new MedicalProcedureDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureDto {
    name: string | undefined;
    description: string | undefined;
    publicDescription: string | undefined;
    duration: number;
    periodUnit: ProcedurePeriodUnit;
    price: number;
    scheduleColor: string | undefined;
    parentId: number | undefined;
    coveredInsuranceCompanies: MedicalProcedureCoveredByInsuranceCompanyData[] | undefined;
    coveredInsurancePlans: MedicalProcedureCoveredByInsurancePlanData[] | undefined;
    coveredByProfessionals: MedicalProcedureCoveredByProfessionalData[] | undefined;
    coveredCareUnits: MedicalProcedureCoveredCareUnitsData[] | undefined;
    allowOnlineSchedule: boolean;
    remotely: boolean;
    isReturn: boolean;
    returnParentId: number[] | undefined;
    hasDerivedProcedures: boolean;
    isProfessionalRequired: boolean | undefined;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    splitPercentage: number | undefined;
    responsibilityTerms: MedicalProcedureResponsibilityTermDto[] | undefined;
    maxNumberOfInstallments: number;
    minutesDuration: number;
    id: number;
}

export class AppointmentStatusChangeDto implements IAppointmentStatusChangeDto {
    status: AppointmentStatus;
    id: string;

    constructor(data?: IAppointmentStatusChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppointmentStatusChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentStatusChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }

    clone(): AppointmentStatusChangeDto {
        const json = this.toJSON();
        let result = new AppointmentStatusChangeDto();
        result.init(json);
        return result;
    }
}

export interface IAppointmentStatusChangeDto {
    status: AppointmentStatus;
    id: string;
}

export class AppointmentRatingItemDto implements IAppointmentRatingItemDto {
    item: string | undefined;
    value: string | undefined;
    id: string;

    constructor(data?: IAppointmentRatingItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppointmentRatingItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentRatingItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }

    clone(): AppointmentRatingItemDto {
        const json = this.toJSON();
        let result = new AppointmentRatingItemDto();
        result.init(json);
        return result;
    }
}

export interface IAppointmentRatingItemDto {
    item: string | undefined;
    value: string | undefined;
    id: string;
}

export class AppointmentRatingDto implements IAppointmentRatingDto {
    appointment: string;
    ratingForm: string;
    items: AppointmentRatingItemDto[] | undefined;
    id: string;

    constructor(data?: IAppointmentRatingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointment = _data["appointment"];
            this.ratingForm = _data["ratingForm"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppointmentRatingItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppointmentRatingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentRatingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointment"] = this.appointment;
        data["ratingForm"] = this.ratingForm;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): AppointmentRatingDto {
        const json = this.toJSON();
        let result = new AppointmentRatingDto();
        result.init(json);
        return result;
    }
}

export interface IAppointmentRatingDto {
    appointment: string;
    ratingForm: string;
    items: AppointmentRatingItemDto[] | undefined;
    id: string;
}

export class MedicalAppointmentDto implements IMedicalAppointmentDto {
    medicalSpecialty: MedicalProfessionSpecialty;
    medicalAgreement: MedicalAgreementDto;
    parent: MedicalAppointmentDto;
    comments: string | undefined;
    title: string | undefined;
    /** Will be equal to MedicalSpecialty Appointment 's duration, just for quick access */
    duration: number;
    procedure: MedicalProcedureDto;
    termSignatures: MedicalAppointmentProcedureResponsibilityTerm[] | undefined;
    complementaryProcedures: ComplementaryProcedureDto[] | undefined;
    preProcedureForms: MedicalAppointmentProcedurePreForm[] | undefined;
    date: moment.Moment;
    status: AppointmentStatus;
    patient: PatientDto;
    doctor: DoctorDto;
    statusChanges: AppointmentStatusChangeDto[] | undefined;
    ratings: AppointmentRatingDto[] | undefined;
    id: string;

    constructor(data?: IMedicalAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalSpecialty = _data["medicalSpecialty"] ? MedicalProfessionSpecialty.fromJS(_data["medicalSpecialty"]) : <any>undefined;
            this.medicalAgreement = _data["medicalAgreement"] ? MedicalAgreementDto.fromJS(_data["medicalAgreement"]) : <any>undefined;
            this.parent = _data["parent"] ? MedicalAppointmentDto.fromJS(_data["parent"]) : <any>undefined;
            this.comments = _data["comments"];
            this.title = _data["title"];
            this.duration = _data["duration"];
            this.procedure = _data["procedure"] ? MedicalProcedureDto.fromJS(_data["procedure"]) : <any>undefined;
            if (Array.isArray(_data["termSignatures"])) {
                this.termSignatures = [] as any;
                for (let item of _data["termSignatures"])
                    this.termSignatures.push(MedicalAppointmentProcedureResponsibilityTerm.fromJS(item));
            }
            if (Array.isArray(_data["complementaryProcedures"])) {
                this.complementaryProcedures = [] as any;
                for (let item of _data["complementaryProcedures"])
                    this.complementaryProcedures.push(ComplementaryProcedureDto.fromJS(item));
            }
            if (Array.isArray(_data["preProcedureForms"])) {
                this.preProcedureForms = [] as any;
                for (let item of _data["preProcedureForms"])
                    this.preProcedureForms.push(MedicalAppointmentProcedurePreForm.fromJS(item));
            }
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.doctor = _data["doctor"] ? DoctorDto.fromJS(_data["doctor"]) : <any>undefined;
            if (Array.isArray(_data["statusChanges"])) {
                this.statusChanges = [] as any;
                for (let item of _data["statusChanges"])
                    this.statusChanges.push(AppointmentStatusChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["ratings"])) {
                this.ratings = [] as any;
                for (let item of _data["ratings"])
                    this.ratings.push(AppointmentRatingDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalSpecialty"] = this.medicalSpecialty ? this.medicalSpecialty.toJSON() : <any>undefined;
        data["medicalAgreement"] = this.medicalAgreement ? this.medicalAgreement.toJSON() : <any>undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        data["title"] = this.title;
        data["duration"] = this.duration;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        if (Array.isArray(this.termSignatures)) {
            data["termSignatures"] = [];
            for (let item of this.termSignatures)
                data["termSignatures"].push(item.toJSON());
        }
        if (Array.isArray(this.complementaryProcedures)) {
            data["complementaryProcedures"] = [];
            for (let item of this.complementaryProcedures)
                data["complementaryProcedures"].push(item.toJSON());
        }
        if (Array.isArray(this.preProcedureForms)) {
            data["preProcedureForms"] = [];
            for (let item of this.preProcedureForms)
                data["preProcedureForms"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        if (Array.isArray(this.statusChanges)) {
            data["statusChanges"] = [];
            for (let item of this.statusChanges)
                data["statusChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.ratings)) {
            data["ratings"] = [];
            for (let item of this.ratings)
                data["ratings"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalAppointmentDto {
        const json = this.toJSON();
        let result = new MedicalAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentDto {
    medicalSpecialty: MedicalProfessionSpecialty;
    medicalAgreement: MedicalAgreementDto;
    parent: MedicalAppointmentDto;
    comments: string | undefined;
    title: string | undefined;
    /** Will be equal to MedicalSpecialty Appointment 's duration, just for quick access */
    duration: number;
    procedure: MedicalProcedureDto;
    termSignatures: MedicalAppointmentProcedureResponsibilityTerm[] | undefined;
    complementaryProcedures: ComplementaryProcedureDto[] | undefined;
    preProcedureForms: MedicalAppointmentProcedurePreForm[] | undefined;
    date: moment.Moment;
    status: AppointmentStatus;
    patient: PatientDto;
    doctor: DoctorDto;
    statusChanges: AppointmentStatusChangeDto[] | undefined;
    ratings: AppointmentRatingDto[] | undefined;
    id: string;
}

export class InsurancePlanDto implements IInsurancePlanDto {
    company: InsuranceCompanyDto;
    companyId: number;
    name: string | undefined;
    returnDaysLimit: number | undefined;
    price: number | undefined;
    status: InsurancePlanStatus;
    coveredProcedures: MedicalProcedureCoveredByInsurancePlanDto[] | undefined;
    appointments: MedicalAppointmentDto[] | undefined;
    id: number;

    constructor(data?: IInsurancePlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? InsuranceCompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.returnDaysLimit = _data["returnDaysLimit"];
            this.price = _data["price"];
            this.status = _data["status"];
            if (Array.isArray(_data["coveredProcedures"])) {
                this.coveredProcedures = [] as any;
                for (let item of _data["coveredProcedures"])
                    this.coveredProcedures.push(MedicalProcedureCoveredByInsurancePlanDto.fromJS(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments.push(MedicalAppointmentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsurancePlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["returnDaysLimit"] = this.returnDaysLimit;
        data["price"] = this.price;
        data["status"] = this.status;
        if (Array.isArray(this.coveredProcedures)) {
            data["coveredProcedures"] = [];
            for (let item of this.coveredProcedures)
                data["coveredProcedures"].push(item.toJSON());
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): InsurancePlanDto {
        const json = this.toJSON();
        let result = new InsurancePlanDto();
        result.init(json);
        return result;
    }
}

export interface IInsurancePlanDto {
    company: InsuranceCompanyDto;
    companyId: number;
    name: string | undefined;
    returnDaysLimit: number | undefined;
    price: number | undefined;
    status: InsurancePlanStatus;
    coveredProcedures: MedicalProcedureCoveredByInsurancePlanDto[] | undefined;
    appointments: MedicalAppointmentDto[] | undefined;
    id: number;
}

export class MedicalProcedureCoveredByInsuranceCompanyDto implements IMedicalProcedureCoveredByInsuranceCompanyDto {
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalProcedureCoveredByInsuranceCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByInsuranceCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByInsuranceCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByInsuranceCompanyDto {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByInsuranceCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByInsuranceCompanyDto {
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class InsuranceCompanyDto implements IInsuranceCompanyDto {
    name: string | undefined;
    code: string | undefined;
    dailyLimit: number | undefined;
    returnDaysLimit: number | undefined;
    locked: boolean;
    insurancePlans: InsurancePlanDto[] | undefined;
    coveredProcedures: MedicalProcedureCoveredByInsuranceCompanyDto[] | undefined;
    id: number;

    constructor(data?: IInsuranceCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.dailyLimit = _data["dailyLimit"];
            this.returnDaysLimit = _data["returnDaysLimit"];
            this.locked = _data["locked"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans.push(InsurancePlanDto.fromJS(item));
            }
            if (Array.isArray(_data["coveredProcedures"])) {
                this.coveredProcedures = [] as any;
                for (let item of _data["coveredProcedures"])
                    this.coveredProcedures.push(MedicalProcedureCoveredByInsuranceCompanyDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsuranceCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["dailyLimit"] = this.dailyLimit;
        data["returnDaysLimit"] = this.returnDaysLimit;
        data["locked"] = this.locked;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredProcedures)) {
            data["coveredProcedures"] = [];
            for (let item of this.coveredProcedures)
                data["coveredProcedures"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): InsuranceCompanyDto {
        const json = this.toJSON();
        let result = new InsuranceCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IInsuranceCompanyDto {
    name: string | undefined;
    code: string | undefined;
    dailyLimit: number | undefined;
    returnDaysLimit: number | undefined;
    locked: boolean;
    insurancePlans: InsurancePlanDto[] | undefined;
    coveredProcedures: MedicalProcedureCoveredByInsuranceCompanyDto[] | undefined;
    id: number;
}

export class GetInsuranceCompaniesInput implements IGetInsuranceCompaniesInput {
    name: string | undefined;
    procedure: number | undefined;
    includeInsurancePlans: boolean;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetInsuranceCompaniesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.procedure = _data["procedure"];
            this.includeInsurancePlans = _data["includeInsurancePlans"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetInsuranceCompaniesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInsuranceCompaniesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["procedure"] = this.procedure;
        data["includeInsurancePlans"] = this.includeInsurancePlans;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetInsuranceCompaniesInput {
        const json = this.toJSON();
        let result = new GetInsuranceCompaniesInput();
        result.init(json);
        return result;
    }
}

export interface IGetInsuranceCompaniesInput {
    name: string | undefined;
    procedure: number | undefined;
    includeInsurancePlans: boolean;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class InsuranceCompanyDtoPagedResultDto implements IInsuranceCompanyDtoPagedResultDto {
    totalCount: number;
    items: InsuranceCompanyDto[] | undefined;

    constructor(data?: IInsuranceCompanyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InsuranceCompanyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsuranceCompanyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): InsuranceCompanyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InsuranceCompanyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInsuranceCompanyDtoPagedResultDto {
    totalCount: number;
    items: InsuranceCompanyDto[] | undefined;
}

export class UpdateInsuranceCompanyInput implements IUpdateInsuranceCompanyInput {
    name: string | undefined;
    code: string | undefined;
    dailyLimit: number | undefined;
    returnDaysLimit: number | undefined;
    locked: boolean;
    id: number;

    constructor(data?: IUpdateInsuranceCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.dailyLimit = _data["dailyLimit"];
            this.returnDaysLimit = _data["returnDaysLimit"];
            this.locked = _data["locked"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateInsuranceCompanyInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInsuranceCompanyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["dailyLimit"] = this.dailyLimit;
        data["returnDaysLimit"] = this.returnDaysLimit;
        data["locked"] = this.locked;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateInsuranceCompanyInput {
        const json = this.toJSON();
        let result = new UpdateInsuranceCompanyInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateInsuranceCompanyInput {
    name: string | undefined;
    code: string | undefined;
    dailyLimit: number | undefined;
    returnDaysLimit: number | undefined;
    locked: boolean;
    id: number;
}

export class GetInsurancePlansInput implements IGetInsurancePlansInput {
    name: string | undefined;
    company: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetInsurancePlansInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.company = _data["company"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetInsurancePlansInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInsurancePlansInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["company"] = this.company;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetInsurancePlansInput {
        const json = this.toJSON();
        let result = new GetInsurancePlansInput();
        result.init(json);
        return result;
    }
}

export interface IGetInsurancePlansInput {
    name: string | undefined;
    company: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class InsurancePlanDtoPagedResultDto implements IInsurancePlanDtoPagedResultDto {
    totalCount: number;
    items: InsurancePlanDto[] | undefined;

    constructor(data?: IInsurancePlanDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InsurancePlanDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsurancePlanDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePlanDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): InsurancePlanDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InsurancePlanDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInsurancePlanDtoPagedResultDto {
    totalCount: number;
    items: InsurancePlanDto[] | undefined;
}

export class CreateInsurancePlanInput implements ICreateInsurancePlanInput {
    companyId: number;
    name: string | undefined;
    returnDaysLimit: number | undefined;
    price: number | undefined;
    status: InsurancePlanStatus;

    constructor(data?: ICreateInsurancePlanInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.returnDaysLimit = _data["returnDaysLimit"];
            this.price = _data["price"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateInsurancePlanInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInsurancePlanInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["returnDaysLimit"] = this.returnDaysLimit;
        data["price"] = this.price;
        data["status"] = this.status;
        return data; 
    }

    clone(): CreateInsurancePlanInput {
        const json = this.toJSON();
        let result = new CreateInsurancePlanInput();
        result.init(json);
        return result;
    }
}

export interface ICreateInsurancePlanInput {
    companyId: number;
    name: string | undefined;
    returnDaysLimit: number | undefined;
    price: number | undefined;
    status: InsurancePlanStatus;
}

export class UpdateInsurancePlanInput implements IUpdateInsurancePlanInput {
    companyId: number;
    name: string | undefined;
    returnDaysLimit: number | undefined;
    price: number | undefined;
    status: InsurancePlanStatus;
    id: number;

    constructor(data?: IUpdateInsurancePlanInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.returnDaysLimit = _data["returnDaysLimit"];
            this.price = _data["price"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateInsurancePlanInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInsurancePlanInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["returnDaysLimit"] = this.returnDaysLimit;
        data["price"] = this.price;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateInsurancePlanInput {
        const json = this.toJSON();
        let result = new UpdateInsurancePlanInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateInsurancePlanInput {
    companyId: number;
    name: string | undefined;
    returnDaysLimit: number | undefined;
    price: number | undefined;
    status: InsurancePlanStatus;
    id: number;
}

export class CreateInvitation implements ICreateInvitation {
    invitedUserEmail: string | undefined;
    invitedUserName: string | undefined;
    roles: string[] | undefined;
    message: string | undefined;
    metadata: any | undefined;
    sendEmail: boolean;

    constructor(data?: ICreateInvitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitedUserEmail = _data["invitedUserEmail"];
            this.invitedUserName = _data["invitedUserName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
            this.message = _data["message"];
            this.metadata = _data["metadata"];
            this.sendEmail = _data["sendEmail"];
        }
    }

    static fromJS(data: any): CreateInvitation {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitedUserEmail"] = this.invitedUserEmail;
        data["invitedUserName"] = this.invitedUserName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["message"] = this.message;
        data["metadata"] = this.metadata;
        data["sendEmail"] = this.sendEmail;
        return data; 
    }

    clone(): CreateInvitation {
        const json = this.toJSON();
        let result = new CreateInvitation();
        result.init(json);
        return result;
    }
}

export interface ICreateInvitation {
    invitedUserEmail: string | undefined;
    invitedUserName: string | undefined;
    roles: string[] | undefined;
    message: string | undefined;
    metadata: any | undefined;
    sendEmail: boolean;
}

export class InvitationDto implements IInvitationDto {
    tenantId: number;
    invitedUserEmail: string | undefined;
    userAlreadyRegistered: boolean;
    roleNames: string[] | undefined;
    message: string | undefined;
    metadata: string | undefined;
    id: string;

    constructor(data?: IInvitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.invitedUserEmail = _data["invitedUserEmail"];
            this.userAlreadyRegistered = _data["userAlreadyRegistered"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.message = _data["message"];
            this.metadata = _data["metadata"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InvitationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["invitedUserEmail"] = this.invitedUserEmail;
        data["userAlreadyRegistered"] = this.userAlreadyRegistered;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["message"] = this.message;
        data["metadata"] = this.metadata;
        data["id"] = this.id;
        return data; 
    }

    clone(): InvitationDto {
        const json = this.toJSON();
        let result = new InvitationDto();
        result.init(json);
        return result;
    }
}

export interface IInvitationDto {
    tenantId: number;
    invitedUserEmail: string | undefined;
    userAlreadyRegistered: boolean;
    roleNames: string[] | undefined;
    message: string | undefined;
    metadata: string | undefined;
    id: string;
}

export class InvitationCompletionModel implements IInvitationCompletionModel {
    readonly componentName: string | undefined;
    readonly autoLogin: boolean;
    invitationId: string;
    tenantId: number;
    userId: number | undefined;
    invitedUserEmail: string | undefined;
    invitedUserPhone: string | undefined;
    invitedUserName: string | undefined;
    ownerName: string | undefined;
    metadata: string | undefined;
    redirectToLogin: boolean;

    constructor(data?: IInvitationCompletionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).componentName = _data["componentName"];
            (<any>this).autoLogin = _data["autoLogin"];
            this.invitationId = _data["invitationId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.invitedUserEmail = _data["invitedUserEmail"];
            this.invitedUserPhone = _data["invitedUserPhone"];
            this.invitedUserName = _data["invitedUserName"];
            this.ownerName = _data["ownerName"];
            this.metadata = _data["metadata"];
            this.redirectToLogin = _data["redirectToLogin"];
        }
    }

    static fromJS(data: any): InvitationCompletionModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationCompletionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentName"] = this.componentName;
        data["autoLogin"] = this.autoLogin;
        data["invitationId"] = this.invitationId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["invitedUserEmail"] = this.invitedUserEmail;
        data["invitedUserPhone"] = this.invitedUserPhone;
        data["invitedUserName"] = this.invitedUserName;
        data["ownerName"] = this.ownerName;
        data["metadata"] = this.metadata;
        data["redirectToLogin"] = this.redirectToLogin;
        return data; 
    }

    clone(): InvitationCompletionModel {
        const json = this.toJSON();
        let result = new InvitationCompletionModel();
        result.init(json);
        return result;
    }
}

export interface IInvitationCompletionModel {
    componentName: string | undefined;
    autoLogin: boolean;
    invitationId: string;
    tenantId: number;
    userId: number | undefined;
    invitedUserEmail: string | undefined;
    invitedUserPhone: string | undefined;
    invitedUserName: string | undefined;
    ownerName: string | undefined;
    metadata: string | undefined;
    redirectToLogin: boolean;
}

export class MedicalAgreementDtoPagedResultDto implements IMedicalAgreementDtoPagedResultDto {
    totalCount: number;
    items: MedicalAgreementDto[] | undefined;

    constructor(data?: IMedicalAgreementDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MedicalAgreementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicalAgreementDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAgreementDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MedicalAgreementDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicalAgreementDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalAgreementDtoPagedResultDto {
    totalCount: number;
    items: MedicalAgreementDto[] | undefined;
}

export class CreateMedicalAgreement implements ICreateMedicalAgreement {
    name: string | undefined;
    doctorId: string;

    constructor(data?: ICreateMedicalAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.doctorId = _data["doctorId"];
        }
    }

    static fromJS(data: any): CreateMedicalAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["doctorId"] = this.doctorId;
        return data; 
    }

    clone(): CreateMedicalAgreement {
        const json = this.toJSON();
        let result = new CreateMedicalAgreement();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalAgreement {
    name: string | undefined;
    doctorId: string;
}

export class UpdateMedicalAgreementDto implements IUpdateMedicalAgreementDto {
    name: string | undefined;
    doctorId: string;
    id: string;

    constructor(data?: IUpdateMedicalAgreementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.doctorId = _data["doctorId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMedicalAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicalAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["doctorId"] = this.doctorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateMedicalAgreementDto {
        const json = this.toJSON();
        let result = new UpdateMedicalAgreementDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicalAgreementDto {
    name: string | undefined;
    doctorId: string;
    id: string;
}

export class MedicalAppointmentDurationDto implements IMedicalAppointmentDurationDto {
    medicalProfession: number;
    medicalSpecialty: number | undefined;
    duration: number;
    price: number;
    doctorId: string;
    id: string;

    constructor(data?: IMedicalAppointmentDurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalProfession = _data["medicalProfession"];
            this.medicalSpecialty = _data["medicalSpecialty"];
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.doctorId = _data["doctorId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalAppointmentDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentDurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalProfession"] = this.medicalProfession;
        data["medicalSpecialty"] = this.medicalSpecialty;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["doctorId"] = this.doctorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalAppointmentDurationDto {
        const json = this.toJSON();
        let result = new MedicalAppointmentDurationDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentDurationDto {
    medicalProfession: number;
    medicalSpecialty: number | undefined;
    duration: number;
    price: number;
    doctorId: string;
    id: string;
}

export class MedicalAppointmentDurationDtoPagedResultDto implements IMedicalAppointmentDurationDtoPagedResultDto {
    totalCount: number;
    items: MedicalAppointmentDurationDto[] | undefined;

    constructor(data?: IMedicalAppointmentDurationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MedicalAppointmentDurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicalAppointmentDurationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentDurationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MedicalAppointmentDurationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicalAppointmentDurationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentDurationDtoPagedResultDto {
    totalCount: number;
    items: MedicalAppointmentDurationDto[] | undefined;
}

export class GetAvailableMedicalAppointmentTimesRequest implements IGetAvailableMedicalAppointmentTimesRequest {
    medicalSpecialty: number;
    proposedDuration: number | undefined;
    doctor: string | undefined;
    doctorUserId: number;
    procedureId: number | undefined;
    careUnitId: number | undefined;
    isProfessionalRequired: boolean | undefined;
    patient: string;
    /** Caso você esteja "remarcando" um agendamento, dessa forma será excluída a data do agendamento */
    appointmentId: string | undefined;
    date: moment.Moment;
    client: number | undefined;
    host: number | undefined;

    constructor(data?: IGetAvailableMedicalAppointmentTimesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalSpecialty = _data["medicalSpecialty"];
            this.proposedDuration = _data["proposedDuration"];
            this.doctor = _data["doctor"];
            this.doctorUserId = _data["doctorUserId"];
            this.procedureId = _data["procedureId"];
            this.careUnitId = _data["careUnitId"];
            this.isProfessionalRequired = _data["isProfessionalRequired"];
            this.patient = _data["patient"];
            this.appointmentId = _data["appointmentId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.client = _data["client"];
            this.host = _data["host"];
        }
    }

    static fromJS(data: any): GetAvailableMedicalAppointmentTimesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableMedicalAppointmentTimesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalSpecialty"] = this.medicalSpecialty;
        data["proposedDuration"] = this.proposedDuration;
        data["doctor"] = this.doctor;
        data["doctorUserId"] = this.doctorUserId;
        data["procedureId"] = this.procedureId;
        data["careUnitId"] = this.careUnitId;
        data["isProfessionalRequired"] = this.isProfessionalRequired;
        data["patient"] = this.patient;
        data["appointmentId"] = this.appointmentId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["client"] = this.client;
        data["host"] = this.host;
        return data; 
    }

    clone(): GetAvailableMedicalAppointmentTimesRequest {
        const json = this.toJSON();
        let result = new GetAvailableMedicalAppointmentTimesRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAvailableMedicalAppointmentTimesRequest {
    medicalSpecialty: number;
    proposedDuration: number | undefined;
    doctor: string | undefined;
    doctorUserId: number;
    procedureId: number | undefined;
    careUnitId: number | undefined;
    isProfessionalRequired: boolean | undefined;
    patient: string;
    /** Caso você esteja "remarcando" um agendamento, dessa forma será excluída a data do agendamento */
    appointmentId: string | undefined;
    date: moment.Moment;
    client: number | undefined;
    host: number | undefined;
}

export class GetAvailableAppointmentTimesResponse implements IGetAvailableAppointmentTimesResponse {
    proposedDateHasAvailability: boolean;
    date: moment.Moment;
    times: moment.Moment[] | undefined;

    constructor(data?: IGetAvailableAppointmentTimesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposedDateHasAvailability = _data["proposedDateHasAvailability"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["times"])) {
                this.times = [] as any;
                for (let item of _data["times"])
                    this.times.push(moment(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableAppointmentTimesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableAppointmentTimesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposedDateHasAvailability"] = this.proposedDateHasAvailability;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.times)) {
            data["times"] = [];
            for (let item of this.times)
                data["times"].push(item.toISOString());
        }
        return data; 
    }

    clone(): GetAvailableAppointmentTimesResponse {
        const json = this.toJSON();
        let result = new GetAvailableAppointmentTimesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAvailableAppointmentTimesResponse {
    proposedDateHasAvailability: boolean;
    date: moment.Moment;
    times: moment.Moment[] | undefined;
}

export class ConfirmByChannelRequest implements IConfirmByChannelRequest {
    token: string | undefined;
    channel: ConfirmationChannel;

    constructor(data?: IConfirmByChannelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.channel = _data["channel"];
        }
    }

    static fromJS(data: any): ConfirmByChannelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmByChannelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["channel"] = this.channel;
        return data; 
    }

    clone(): ConfirmByChannelRequest {
        const json = this.toJSON();
        let result = new ConfirmByChannelRequest();
        result.init(json);
        return result;
    }
}

export interface IConfirmByChannelRequest {
    token: string | undefined;
    channel: ConfirmationChannel;
}

/** Tamanho da janela de tempo: Daily = 1, Weekly = 2, Monthly = 3, NowOn = 4 */
export enum AppointmentsQueryRange {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _10 = 10,
    _20 = 20,
}

export class MedicalAppointmentEntryPatient implements IMedicalAppointmentEntryPatient {
    id: string;
    name: string | undefined;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    gender: number;

    constructor(data?: IMedicalAppointmentEntryPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.dni = _data["dni"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): MedicalAppointmentEntryPatient {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentEntryPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["personalIdentifier"] = this.personalIdentifier;
        data["dni"] = this.dni;
        data["gender"] = this.gender;
        return data; 
    }

    clone(): MedicalAppointmentEntryPatient {
        const json = this.toJSON();
        let result = new MedicalAppointmentEntryPatient();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentEntryPatient {
    id: string;
    name: string | undefined;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    gender: number;
}

export class MedicalAppointmentEntryProfessional implements IMedicalAppointmentEntryProfessional {
    id: string;
    userId: number;
    name: string | undefined;
    licenceNumber: LicenceNumber;

    constructor(data?: IMedicalAppointmentEntryProfessional) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.licenceNumber = _data["licenceNumber"] ? LicenceNumber.fromJS(_data["licenceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicalAppointmentEntryProfessional {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentEntryProfessional();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["licenceNumber"] = this.licenceNumber ? this.licenceNumber.toJSON() : <any>undefined;
        return data; 
    }

    clone(): MedicalAppointmentEntryProfessional {
        const json = this.toJSON();
        let result = new MedicalAppointmentEntryProfessional();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentEntryProfessional {
    id: string;
    userId: number;
    name: string | undefined;
    licenceNumber: LicenceNumber;
}

export class MedicalAppointmentEntryUnit implements IMedicalAppointmentEntryUnit {
    id: number;
    name: string | undefined;

    constructor(data?: IMedicalAppointmentEntryUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MedicalAppointmentEntryUnit {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentEntryUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): MedicalAppointmentEntryUnit {
        const json = this.toJSON();
        let result = new MedicalAppointmentEntryUnit();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentEntryUnit {
    id: number;
    name: string | undefined;
}

export class MedicalAppointmentEntrySpecialty implements IMedicalAppointmentEntrySpecialty {
    id: number;
    title: string | undefined;

    constructor(data?: IMedicalAppointmentEntrySpecialty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MedicalAppointmentEntrySpecialty {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentEntrySpecialty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data; 
    }

    clone(): MedicalAppointmentEntrySpecialty {
        const json = this.toJSON();
        let result = new MedicalAppointmentEntrySpecialty();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentEntrySpecialty {
    id: number;
    title: string | undefined;
}

export class MedicalAppointmentEntryProcedure implements IMedicalAppointmentEntryProcedure {
    id: number;
    name: string | undefined;

    constructor(data?: IMedicalAppointmentEntryProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MedicalAppointmentEntryProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentEntryProcedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): MedicalAppointmentEntryProcedure {
        const json = this.toJSON();
        let result = new MedicalAppointmentEntryProcedure();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentEntryProcedure {
    id: number;
    name: string | undefined;
}

export class MedicalAppointmentEntryAgreement implements IMedicalAppointmentEntryAgreement {
    id: string;
    name: string | undefined;

    constructor(data?: IMedicalAppointmentEntryAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MedicalAppointmentEntryAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentEntryAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): MedicalAppointmentEntryAgreement {
        const json = this.toJSON();
        let result = new MedicalAppointmentEntryAgreement();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentEntryAgreement {
    id: string;
    name: string | undefined;
}

export class MedicalAppointmentEntryInsuranceCompany implements IMedicalAppointmentEntryInsuranceCompany {
    id: number;
    name: string | undefined;

    constructor(data?: IMedicalAppointmentEntryInsuranceCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MedicalAppointmentEntryInsuranceCompany {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentEntryInsuranceCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): MedicalAppointmentEntryInsuranceCompany {
        const json = this.toJSON();
        let result = new MedicalAppointmentEntryInsuranceCompany();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentEntryInsuranceCompany {
    id: number;
    name: string | undefined;
}

export class MedicalAppointmentEntryInsurancePlan implements IMedicalAppointmentEntryInsurancePlan {
    id: number;
    name: string | undefined;

    constructor(data?: IMedicalAppointmentEntryInsurancePlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MedicalAppointmentEntryInsurancePlan {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentEntryInsurancePlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): MedicalAppointmentEntryInsurancePlan {
        const json = this.toJSON();
        let result = new MedicalAppointmentEntryInsurancePlan();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentEntryInsurancePlan {
    id: number;
    name: string | undefined;
}

export class MedicalAppointmentEntry implements IMedicalAppointmentEntry {
    id: string | undefined;
    discriminator: string | undefined;
    date: moment.Moment;
    duration: number;
    title: string | undefined;
    status: AppointmentStatus;
    ownerUser: UserIdentifier;
    patient: MedicalAppointmentEntryPatient;
    doctor: MedicalAppointmentEntryProfessional;
    remotely: boolean;
    paymentRequired: boolean;
    careUnit: MedicalAppointmentEntryUnit;
    paymentCompleted: boolean;
    isPrivateInsurance: boolean;
    specialty: MedicalAppointmentEntrySpecialty;
    procedure: MedicalAppointmentEntryProcedure;
    agreement: MedicalAppointmentEntryAgreement;
    insuranceCompany: MedicalAppointmentEntryInsuranceCompany;
    insurancePlan: MedicalAppointmentEntryInsurancePlan;

    constructor(data?: IMedicalAppointmentEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discriminator = _data["discriminator"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.ownerUser = _data["ownerUser"] ? UserIdentifier.fromJS(_data["ownerUser"]) : <any>undefined;
            this.patient = _data["patient"] ? MedicalAppointmentEntryPatient.fromJS(_data["patient"]) : <any>undefined;
            this.doctor = _data["doctor"] ? MedicalAppointmentEntryProfessional.fromJS(_data["doctor"]) : <any>undefined;
            this.remotely = _data["remotely"];
            this.paymentRequired = _data["paymentRequired"];
            this.careUnit = _data["careUnit"] ? MedicalAppointmentEntryUnit.fromJS(_data["careUnit"]) : <any>undefined;
            this.paymentCompleted = _data["paymentCompleted"];
            this.isPrivateInsurance = _data["isPrivateInsurance"];
            this.specialty = _data["specialty"] ? MedicalAppointmentEntrySpecialty.fromJS(_data["specialty"]) : <any>undefined;
            this.procedure = _data["procedure"] ? MedicalAppointmentEntryProcedure.fromJS(_data["procedure"]) : <any>undefined;
            this.agreement = _data["agreement"] ? MedicalAppointmentEntryAgreement.fromJS(_data["agreement"]) : <any>undefined;
            this.insuranceCompany = _data["insuranceCompany"] ? MedicalAppointmentEntryInsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insurancePlan = _data["insurancePlan"] ? MedicalAppointmentEntryInsurancePlan.fromJS(_data["insurancePlan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicalAppointmentEntry {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discriminator"] = this.discriminator;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["title"] = this.title;
        data["status"] = this.status;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["remotely"] = this.remotely;
        data["paymentRequired"] = this.paymentRequired;
        data["careUnit"] = this.careUnit ? this.careUnit.toJSON() : <any>undefined;
        data["paymentCompleted"] = this.paymentCompleted;
        data["isPrivateInsurance"] = this.isPrivateInsurance;
        data["specialty"] = this.specialty ? this.specialty.toJSON() : <any>undefined;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data["agreement"] = this.agreement ? this.agreement.toJSON() : <any>undefined;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        return data; 
    }

    clone(): MedicalAppointmentEntry {
        const json = this.toJSON();
        let result = new MedicalAppointmentEntry();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentEntry {
    id: string | undefined;
    discriminator: string | undefined;
    date: moment.Moment;
    duration: number;
    title: string | undefined;
    status: AppointmentStatus;
    ownerUser: UserIdentifier;
    patient: MedicalAppointmentEntryPatient;
    doctor: MedicalAppointmentEntryProfessional;
    remotely: boolean;
    paymentRequired: boolean;
    careUnit: MedicalAppointmentEntryUnit;
    paymentCompleted: boolean;
    isPrivateInsurance: boolean;
    specialty: MedicalAppointmentEntrySpecialty;
    procedure: MedicalAppointmentEntryProcedure;
    agreement: MedicalAppointmentEntryAgreement;
    insuranceCompany: MedicalAppointmentEntryInsuranceCompany;
    insurancePlan: MedicalAppointmentEntryInsurancePlan;
}

export class NotifyAppointmentFileUploadedRequest implements INotifyAppointmentFileUploadedRequest {
    file: string;
    fileName: string | undefined;
    appointment: string;

    constructor(data?: INotifyAppointmentFileUploadedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.fileName = _data["fileName"];
            this.appointment = _data["appointment"];
        }
    }

    static fromJS(data: any): NotifyAppointmentFileUploadedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyAppointmentFileUploadedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["fileName"] = this.fileName;
        data["appointment"] = this.appointment;
        return data; 
    }

    clone(): NotifyAppointmentFileUploadedRequest {
        const json = this.toJSON();
        let result = new NotifyAppointmentFileUploadedRequest();
        result.init(json);
        return result;
    }
}

export interface INotifyAppointmentFileUploadedRequest {
    file: string;
    fileName: string | undefined;
    appointment: string;
}

export class CreateMedicalAppointmentDto implements ICreateMedicalAppointmentDto {
    medicalSpecialty: number;
    medicalAgreement: string;
    healthPlan: string;
    isReturn: boolean;
    comments: string | undefined;
    date: moment.Moment;
    patient: string;
    doctor: string | undefined;
    remotely: boolean;
    duration: number | undefined;
    recurrence: string | undefined;

    constructor(data?: ICreateMedicalAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalSpecialty = _data["medicalSpecialty"];
            this.medicalAgreement = _data["medicalAgreement"];
            this.healthPlan = _data["healthPlan"];
            this.isReturn = _data["isReturn"];
            this.comments = _data["comments"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.patient = _data["patient"];
            this.doctor = _data["doctor"];
            this.remotely = _data["remotely"];
            this.duration = _data["duration"];
            this.recurrence = _data["recurrence"];
        }
    }

    static fromJS(data: any): CreateMedicalAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalSpecialty"] = this.medicalSpecialty;
        data["medicalAgreement"] = this.medicalAgreement;
        data["healthPlan"] = this.healthPlan;
        data["isReturn"] = this.isReturn;
        data["comments"] = this.comments;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["patient"] = this.patient;
        data["doctor"] = this.doctor;
        data["remotely"] = this.remotely;
        data["duration"] = this.duration;
        data["recurrence"] = this.recurrence;
        return data; 
    }

    clone(): CreateMedicalAppointmentDto {
        const json = this.toJSON();
        let result = new CreateMedicalAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalAppointmentDto {
    medicalSpecialty: number;
    medicalAgreement: string;
    healthPlan: string;
    isReturn: boolean;
    comments: string | undefined;
    date: moment.Moment;
    patient: string;
    doctor: string | undefined;
    remotely: boolean;
    duration: number | undefined;
    recurrence: string | undefined;
}

export class MedicalAppointmentPreview implements IMedicalAppointmentPreview {
    tenantId: number;
    patient: PatientNameInfo;
    doctor: DoctorInfo;
    remotely: boolean;
    allowStartMedicalCare: boolean;
    allowStartMedicalCareCall: boolean;
    /** Will be true when not paid */
    paymentRequired: boolean;
    careUnit: HealthCareUnitBasicData;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    /** VPay order */
    paymentId: number;
    /** Via VPay */
    paymentCompleted: boolean;
    /** Internal, manually marked as paid */
    transactionId: number | undefined;
    readonly payed: boolean;
    readonly allowUpdatePrice: boolean;
    isPrivateInsurance: boolean;
    allowMarkAsPayed: boolean;
    medicalAppointmentComplementaryProcedures: ComplementaryProcedureDto[] | undefined;
    specialty: MedicalProfessionSpecialty;
    procedure: MedicalProcedureBasicData;
    agreement: MedicalAgreementInfo;
    insuranceCompany: InsuranceCompanyBasicData;
    insurancePlan: InsurancePlanBasicData;
    paymentLink: string | undefined;
    pixCode: string | undefined;
    pixExpiringDate: moment.Moment | undefined;
    pixQrCode: string | undefined;
    id: string | undefined;
    discriminator: string | undefined;
    date: moment.Moment;
    duration: number;
    title: string | undefined;
    comments: string | undefined;
    status: AppointmentStatus;
    ownerUser: UserIdentifier;
    recurringEventId: string | undefined;
    readonly isRecurringEvent: boolean;
    recurrence: string | undefined;

    constructor(data?: IMedicalAppointmentPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.patient = _data["patient"] ? PatientNameInfo.fromJS(_data["patient"]) : <any>undefined;
            this.doctor = _data["doctor"] ? DoctorInfo.fromJS(_data["doctor"]) : <any>undefined;
            this.remotely = _data["remotely"];
            this.allowStartMedicalCare = _data["allowStartMedicalCare"];
            this.allowStartMedicalCareCall = _data["allowStartMedicalCareCall"];
            this.paymentRequired = _data["paymentRequired"];
            this.careUnit = _data["careUnit"] ? HealthCareUnitBasicData.fromJS(_data["careUnit"]) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.paymentCompleted = _data["paymentCompleted"];
            this.transactionId = _data["transactionId"];
            (<any>this).payed = _data["payed"];
            (<any>this).allowUpdatePrice = _data["allowUpdatePrice"];
            this.isPrivateInsurance = _data["isPrivateInsurance"];
            this.allowMarkAsPayed = _data["allowMarkAsPayed"];
            if (Array.isArray(_data["medicalAppointmentComplementaryProcedures"])) {
                this.medicalAppointmentComplementaryProcedures = [] as any;
                for (let item of _data["medicalAppointmentComplementaryProcedures"])
                    this.medicalAppointmentComplementaryProcedures.push(ComplementaryProcedureDto.fromJS(item));
            }
            this.specialty = _data["specialty"] ? MedicalProfessionSpecialty.fromJS(_data["specialty"]) : <any>undefined;
            this.procedure = _data["procedure"] ? MedicalProcedureBasicData.fromJS(_data["procedure"]) : <any>undefined;
            this.agreement = _data["agreement"] ? MedicalAgreementInfo.fromJS(_data["agreement"]) : <any>undefined;
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyBasicData.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insurancePlan = _data["insurancePlan"] ? InsurancePlanBasicData.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.paymentLink = _data["paymentLink"];
            this.pixCode = _data["pixCode"];
            this.pixExpiringDate = _data["pixExpiringDate"] ? moment(_data["pixExpiringDate"].toString()) : <any>undefined;
            this.pixQrCode = _data["pixQrCode"];
            this.id = _data["id"];
            this.discriminator = _data["discriminator"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.title = _data["title"];
            this.comments = _data["comments"];
            this.status = _data["status"];
            this.ownerUser = _data["ownerUser"] ? UserIdentifier.fromJS(_data["ownerUser"]) : <any>undefined;
            this.recurringEventId = _data["recurringEventId"];
            (<any>this).isRecurringEvent = _data["isRecurringEvent"];
            this.recurrence = _data["recurrence"];
        }
    }

    static fromJS(data: any): MedicalAppointmentPreview {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["remotely"] = this.remotely;
        data["allowStartMedicalCare"] = this.allowStartMedicalCare;
        data["allowStartMedicalCareCall"] = this.allowStartMedicalCareCall;
        data["paymentRequired"] = this.paymentRequired;
        data["careUnit"] = this.careUnit ? this.careUnit.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["paymentCompleted"] = this.paymentCompleted;
        data["transactionId"] = this.transactionId;
        data["payed"] = this.payed;
        data["allowUpdatePrice"] = this.allowUpdatePrice;
        data["isPrivateInsurance"] = this.isPrivateInsurance;
        data["allowMarkAsPayed"] = this.allowMarkAsPayed;
        if (Array.isArray(this.medicalAppointmentComplementaryProcedures)) {
            data["medicalAppointmentComplementaryProcedures"] = [];
            for (let item of this.medicalAppointmentComplementaryProcedures)
                data["medicalAppointmentComplementaryProcedures"].push(item.toJSON());
        }
        data["specialty"] = this.specialty ? this.specialty.toJSON() : <any>undefined;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data["agreement"] = this.agreement ? this.agreement.toJSON() : <any>undefined;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["paymentLink"] = this.paymentLink;
        data["pixCode"] = this.pixCode;
        data["pixExpiringDate"] = this.pixExpiringDate ? this.pixExpiringDate.toISOString() : <any>undefined;
        data["pixQrCode"] = this.pixQrCode;
        data["id"] = this.id;
        data["discriminator"] = this.discriminator;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["title"] = this.title;
        data["comments"] = this.comments;
        data["status"] = this.status;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : <any>undefined;
        data["recurringEventId"] = this.recurringEventId;
        data["isRecurringEvent"] = this.isRecurringEvent;
        data["recurrence"] = this.recurrence;
        return data; 
    }

    clone(): MedicalAppointmentPreview {
        const json = this.toJSON();
        let result = new MedicalAppointmentPreview();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentPreview {
    tenantId: number;
    patient: PatientNameInfo;
    doctor: DoctorInfo;
    remotely: boolean;
    allowStartMedicalCare: boolean;
    allowStartMedicalCareCall: boolean;
    /** Will be true when not paid */
    paymentRequired: boolean;
    careUnit: HealthCareUnitBasicData;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    /** VPay order */
    paymentId: number;
    /** Via VPay */
    paymentCompleted: boolean;
    /** Internal, manually marked as paid */
    transactionId: number | undefined;
    payed: boolean;
    allowUpdatePrice: boolean;
    isPrivateInsurance: boolean;
    allowMarkAsPayed: boolean;
    medicalAppointmentComplementaryProcedures: ComplementaryProcedureDto[] | undefined;
    specialty: MedicalProfessionSpecialty;
    procedure: MedicalProcedureBasicData;
    agreement: MedicalAgreementInfo;
    insuranceCompany: InsuranceCompanyBasicData;
    insurancePlan: InsurancePlanBasicData;
    paymentLink: string | undefined;
    pixCode: string | undefined;
    pixExpiringDate: moment.Moment | undefined;
    pixQrCode: string | undefined;
    id: string | undefined;
    discriminator: string | undefined;
    date: moment.Moment;
    duration: number;
    title: string | undefined;
    comments: string | undefined;
    status: AppointmentStatus;
    ownerUser: UserIdentifier;
    recurringEventId: string | undefined;
    isRecurringEvent: boolean;
    recurrence: string | undefined;
}

export class GetAppointmentForCallResult implements IGetAppointmentForCallResult {
    logoUrl: string | undefined;
    meetToken: string | undefined;
    meetDomain: string | undefined;
    tenantId: number;
    patient: PatientNameInfo;
    doctor: DoctorInfo;
    remotely: boolean;
    allowStartMedicalCare: boolean;
    allowStartMedicalCareCall: boolean;
    /** Will be true when not paid */
    paymentRequired: boolean;
    careUnit: HealthCareUnitBasicData;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    /** VPay order */
    paymentId: number;
    /** Via VPay */
    paymentCompleted: boolean;
    /** Internal, manually marked as paid */
    transactionId: number | undefined;
    readonly payed: boolean;
    readonly allowUpdatePrice: boolean;
    isPrivateInsurance: boolean;
    allowMarkAsPayed: boolean;
    medicalAppointmentComplementaryProcedures: ComplementaryProcedureDto[] | undefined;
    specialty: MedicalProfessionSpecialty;
    procedure: MedicalProcedureBasicData;
    agreement: MedicalAgreementInfo;
    insuranceCompany: InsuranceCompanyBasicData;
    insurancePlan: InsurancePlanBasicData;
    paymentLink: string | undefined;
    pixCode: string | undefined;
    pixExpiringDate: moment.Moment | undefined;
    pixQrCode: string | undefined;
    id: string | undefined;
    discriminator: string | undefined;
    date: moment.Moment;
    duration: number;
    title: string | undefined;
    comments: string | undefined;
    status: AppointmentStatus;
    ownerUser: UserIdentifier;
    recurringEventId: string | undefined;
    readonly isRecurringEvent: boolean;
    recurrence: string | undefined;

    constructor(data?: IGetAppointmentForCallResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoUrl = _data["logoUrl"];
            this.meetToken = _data["meetToken"];
            this.meetDomain = _data["meetDomain"];
            this.tenantId = _data["tenantId"];
            this.patient = _data["patient"] ? PatientNameInfo.fromJS(_data["patient"]) : <any>undefined;
            this.doctor = _data["doctor"] ? DoctorInfo.fromJS(_data["doctor"]) : <any>undefined;
            this.remotely = _data["remotely"];
            this.allowStartMedicalCare = _data["allowStartMedicalCare"];
            this.allowStartMedicalCareCall = _data["allowStartMedicalCareCall"];
            this.paymentRequired = _data["paymentRequired"];
            this.careUnit = _data["careUnit"] ? HealthCareUnitBasicData.fromJS(_data["careUnit"]) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.paymentCompleted = _data["paymentCompleted"];
            this.transactionId = _data["transactionId"];
            (<any>this).payed = _data["payed"];
            (<any>this).allowUpdatePrice = _data["allowUpdatePrice"];
            this.isPrivateInsurance = _data["isPrivateInsurance"];
            this.allowMarkAsPayed = _data["allowMarkAsPayed"];
            if (Array.isArray(_data["medicalAppointmentComplementaryProcedures"])) {
                this.medicalAppointmentComplementaryProcedures = [] as any;
                for (let item of _data["medicalAppointmentComplementaryProcedures"])
                    this.medicalAppointmentComplementaryProcedures.push(ComplementaryProcedureDto.fromJS(item));
            }
            this.specialty = _data["specialty"] ? MedicalProfessionSpecialty.fromJS(_data["specialty"]) : <any>undefined;
            this.procedure = _data["procedure"] ? MedicalProcedureBasicData.fromJS(_data["procedure"]) : <any>undefined;
            this.agreement = _data["agreement"] ? MedicalAgreementInfo.fromJS(_data["agreement"]) : <any>undefined;
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyBasicData.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insurancePlan = _data["insurancePlan"] ? InsurancePlanBasicData.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.paymentLink = _data["paymentLink"];
            this.pixCode = _data["pixCode"];
            this.pixExpiringDate = _data["pixExpiringDate"] ? moment(_data["pixExpiringDate"].toString()) : <any>undefined;
            this.pixQrCode = _data["pixQrCode"];
            this.id = _data["id"];
            this.discriminator = _data["discriminator"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.title = _data["title"];
            this.comments = _data["comments"];
            this.status = _data["status"];
            this.ownerUser = _data["ownerUser"] ? UserIdentifier.fromJS(_data["ownerUser"]) : <any>undefined;
            this.recurringEventId = _data["recurringEventId"];
            (<any>this).isRecurringEvent = _data["isRecurringEvent"];
            this.recurrence = _data["recurrence"];
        }
    }

    static fromJS(data: any): GetAppointmentForCallResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentForCallResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoUrl"] = this.logoUrl;
        data["meetToken"] = this.meetToken;
        data["meetDomain"] = this.meetDomain;
        data["tenantId"] = this.tenantId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["remotely"] = this.remotely;
        data["allowStartMedicalCare"] = this.allowStartMedicalCare;
        data["allowStartMedicalCareCall"] = this.allowStartMedicalCareCall;
        data["paymentRequired"] = this.paymentRequired;
        data["careUnit"] = this.careUnit ? this.careUnit.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["paymentCompleted"] = this.paymentCompleted;
        data["transactionId"] = this.transactionId;
        data["payed"] = this.payed;
        data["allowUpdatePrice"] = this.allowUpdatePrice;
        data["isPrivateInsurance"] = this.isPrivateInsurance;
        data["allowMarkAsPayed"] = this.allowMarkAsPayed;
        if (Array.isArray(this.medicalAppointmentComplementaryProcedures)) {
            data["medicalAppointmentComplementaryProcedures"] = [];
            for (let item of this.medicalAppointmentComplementaryProcedures)
                data["medicalAppointmentComplementaryProcedures"].push(item.toJSON());
        }
        data["specialty"] = this.specialty ? this.specialty.toJSON() : <any>undefined;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data["agreement"] = this.agreement ? this.agreement.toJSON() : <any>undefined;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["paymentLink"] = this.paymentLink;
        data["pixCode"] = this.pixCode;
        data["pixExpiringDate"] = this.pixExpiringDate ? this.pixExpiringDate.toISOString() : <any>undefined;
        data["pixQrCode"] = this.pixQrCode;
        data["id"] = this.id;
        data["discriminator"] = this.discriminator;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["title"] = this.title;
        data["comments"] = this.comments;
        data["status"] = this.status;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : <any>undefined;
        data["recurringEventId"] = this.recurringEventId;
        data["isRecurringEvent"] = this.isRecurringEvent;
        data["recurrence"] = this.recurrence;
        return data; 
    }

    clone(): GetAppointmentForCallResult {
        const json = this.toJSON();
        let result = new GetAppointmentForCallResult();
        result.init(json);
        return result;
    }
}

export interface IGetAppointmentForCallResult {
    logoUrl: string | undefined;
    meetToken: string | undefined;
    meetDomain: string | undefined;
    tenantId: number;
    patient: PatientNameInfo;
    doctor: DoctorInfo;
    remotely: boolean;
    allowStartMedicalCare: boolean;
    allowStartMedicalCareCall: boolean;
    /** Will be true when not paid */
    paymentRequired: boolean;
    careUnit: HealthCareUnitBasicData;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    /** VPay order */
    paymentId: number;
    /** Via VPay */
    paymentCompleted: boolean;
    /** Internal, manually marked as paid */
    transactionId: number | undefined;
    payed: boolean;
    allowUpdatePrice: boolean;
    isPrivateInsurance: boolean;
    allowMarkAsPayed: boolean;
    medicalAppointmentComplementaryProcedures: ComplementaryProcedureDto[] | undefined;
    specialty: MedicalProfessionSpecialty;
    procedure: MedicalProcedureBasicData;
    agreement: MedicalAgreementInfo;
    insuranceCompany: InsuranceCompanyBasicData;
    insurancePlan: InsurancePlanBasicData;
    paymentLink: string | undefined;
    pixCode: string | undefined;
    pixExpiringDate: moment.Moment | undefined;
    pixQrCode: string | undefined;
    id: string | undefined;
    discriminator: string | undefined;
    date: moment.Moment;
    duration: number;
    title: string | undefined;
    comments: string | undefined;
    status: AppointmentStatus;
    ownerUser: UserIdentifier;
    recurringEventId: string | undefined;
    isRecurringEvent: boolean;
    recurrence: string | undefined;
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class AvailableDate implements IAvailableDate {
    dayOfWeek: DayOfWeek;
    from: string;
    to: string;
    comments: string | undefined;

    constructor(data?: IAvailableDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): AvailableDate {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["from"] = this.from;
        data["to"] = this.to;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): AvailableDate {
        const json = this.toJSON();
        let result = new AvailableDate();
        result.init(json);
        return result;
    }
}

export interface IAvailableDate {
    dayOfWeek: DayOfWeek;
    from: string;
    to: string;
    comments: string | undefined;
}

export class UnavailableDate implements IUnavailableDate {
    date: moment.Moment;
    from: moment.Moment;
    to: moment.Moment;
    comments: string | undefined;

    constructor(data?: IUnavailableDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): UnavailableDate {
        data = typeof data === 'object' ? data : {};
        let result = new UnavailableDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): UnavailableDate {
        const json = this.toJSON();
        let result = new UnavailableDate();
        result.init(json);
        return result;
    }
}

export interface IUnavailableDate {
    date: moment.Moment;
    from: moment.Moment;
    to: moment.Moment;
    comments: string | undefined;
}

export class WorkSchedule implements IWorkSchedule {
    availableDates: AvailableDate[] | undefined;
    unavailableDates: UnavailableDate[] | undefined;

    constructor(data?: IWorkSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableDates"])) {
                this.availableDates = [] as any;
                for (let item of _data["availableDates"])
                    this.availableDates.push(AvailableDate.fromJS(item));
            }
            if (Array.isArray(_data["unavailableDates"])) {
                this.unavailableDates = [] as any;
                for (let item of _data["unavailableDates"])
                    this.unavailableDates.push(UnavailableDate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new WorkSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableDates)) {
            data["availableDates"] = [];
            for (let item of this.availableDates)
                data["availableDates"].push(item.toJSON());
        }
        if (Array.isArray(this.unavailableDates)) {
            data["unavailableDates"] = [];
            for (let item of this.unavailableDates)
                data["unavailableDates"].push(item.toJSON());
        }
        return data; 
    }

    clone(): WorkSchedule {
        const json = this.toJSON();
        let result = new WorkSchedule();
        result.init(json);
        return result;
    }
}

export interface IWorkSchedule {
    availableDates: AvailableDate[] | undefined;
    unavailableDates: UnavailableDate[] | undefined;
}

export class UpdateWorkScheduleRequest implements IUpdateWorkScheduleRequest {
    workSchedule: WorkSchedule;
    userId: number | undefined;

    constructor(data?: IUpdateWorkScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workSchedule = _data["workSchedule"] ? WorkSchedule.fromJS(_data["workSchedule"]) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateWorkScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workSchedule"] = this.workSchedule ? this.workSchedule.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): UpdateWorkScheduleRequest {
        const json = this.toJSON();
        let result = new UpdateWorkScheduleRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkScheduleRequest {
    workSchedule: WorkSchedule;
    userId: number | undefined;
}

export class AppointmentSearchResultItem implements IAppointmentSearchResultItem {
    type: number;
    metadata: { [key: string]: any; } | undefined;
    text: string | undefined;

    constructor(data?: IAppointmentSearchResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)[key] = _data["metadata"][key];
                }
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AppointmentSearchResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentSearchResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = this.metadata[key];
            }
        }
        data["text"] = this.text;
        return data; 
    }

    clone(): AppointmentSearchResultItem {
        const json = this.toJSON();
        let result = new AppointmentSearchResultItem();
        result.init(json);
        return result;
    }
}

export interface IAppointmentSearchResultItem {
    type: number;
    metadata: { [key: string]: any; } | undefined;
    text: string | undefined;
}

export class AppointmentSearchResultGroup implements IAppointmentSearchResultGroup {
    text: string | undefined;
    items: AppointmentSearchResultItem[] | undefined;

    constructor(data?: IAppointmentSearchResultGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppointmentSearchResultItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppointmentSearchResultGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentSearchResultGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AppointmentSearchResultGroup {
        const json = this.toJSON();
        let result = new AppointmentSearchResultGroup();
        result.init(json);
        return result;
    }
}

export interface IAppointmentSearchResultGroup {
    text: string | undefined;
    items: AppointmentSearchResultItem[] | undefined;
}

export class GetMedicalAppointmentModelInput implements IGetMedicalAppointmentModelInput {
    medicalSpecialty: number | undefined;
    /** Selected doctor */
    doctor: string;
    /** Selected insurance */
    medicalAgreement: string;

    constructor(data?: IGetMedicalAppointmentModelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalSpecialty = _data["medicalSpecialty"];
            this.doctor = _data["doctor"];
            this.medicalAgreement = _data["medicalAgreement"];
        }
    }

    static fromJS(data: any): GetMedicalAppointmentModelInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalAppointmentModelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalSpecialty"] = this.medicalSpecialty;
        data["doctor"] = this.doctor;
        data["medicalAgreement"] = this.medicalAgreement;
        return data; 
    }

    clone(): GetMedicalAppointmentModelInput {
        const json = this.toJSON();
        let result = new GetMedicalAppointmentModelInput();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalAppointmentModelInput {
    medicalSpecialty: number | undefined;
    /** Selected doctor */
    doctor: string;
    /** Selected insurance */
    medicalAgreement: string;
}

export class CreateMedicalAppointmentModel implements ICreateMedicalAppointmentModel {
    medicalSpecialty: number | undefined;
    /** List of possible Specialties */
    specialties: MedicalProfessionSpecialty[] | undefined;
    /** Selected doctor */
    doctor: string | undefined;
    /** List of doctors thar are able to take specialty */
    doctors: DoctorInfo[] | undefined;
    /** Selected insurance */
    medicalAgreement: string | undefined;
    /** List of accepted insurances by the selected doctor */
    insurances: MedicalAgreementInfo[] | undefined;

    constructor(data?: ICreateMedicalAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalSpecialty = _data["medicalSpecialty"];
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties.push(MedicalProfessionSpecialty.fromJS(item));
            }
            this.doctor = _data["doctor"];
            if (Array.isArray(_data["doctors"])) {
                this.doctors = [] as any;
                for (let item of _data["doctors"])
                    this.doctors.push(DoctorInfo.fromJS(item));
            }
            this.medicalAgreement = _data["medicalAgreement"];
            if (Array.isArray(_data["insurances"])) {
                this.insurances = [] as any;
                for (let item of _data["insurances"])
                    this.insurances.push(MedicalAgreementInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMedicalAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalSpecialty"] = this.medicalSpecialty;
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item.toJSON());
        }
        data["doctor"] = this.doctor;
        if (Array.isArray(this.doctors)) {
            data["doctors"] = [];
            for (let item of this.doctors)
                data["doctors"].push(item.toJSON());
        }
        data["medicalAgreement"] = this.medicalAgreement;
        if (Array.isArray(this.insurances)) {
            data["insurances"] = [];
            for (let item of this.insurances)
                data["insurances"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateMedicalAppointmentModel {
        const json = this.toJSON();
        let result = new CreateMedicalAppointmentModel();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalAppointmentModel {
    medicalSpecialty: number | undefined;
    /** List of possible Specialties */
    specialties: MedicalProfessionSpecialty[] | undefined;
    /** Selected doctor */
    doctor: string | undefined;
    /** List of doctors thar are able to take specialty */
    doctors: DoctorInfo[] | undefined;
    /** Selected insurance */
    medicalAgreement: string | undefined;
    /** List of accepted insurances by the selected doctor */
    insurances: MedicalAgreementInfo[] | undefined;
}

export class AcceptMedicalAppointmentDto implements IAcceptMedicalAppointmentDto {
    id: string;
    comments: string | undefined;

    constructor(data?: IAcceptMedicalAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): AcceptMedicalAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptMedicalAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): AcceptMedicalAppointmentDto {
        const json = this.toJSON();
        let result = new AcceptMedicalAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface IAcceptMedicalAppointmentDto {
    id: string;
    comments: string | undefined;
}

export class RejectMedicalAppointmentDto implements IRejectMedicalAppointmentDto {
    id: string;
    comments: string | undefined;
    patient: string | undefined;
    doctor: string | undefined;

    constructor(data?: IRejectMedicalAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comments = _data["comments"];
            this.patient = _data["patient"];
            this.doctor = _data["doctor"];
        }
    }

    static fromJS(data: any): RejectMedicalAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectMedicalAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comments"] = this.comments;
        data["patient"] = this.patient;
        data["doctor"] = this.doctor;
        return data; 
    }

    clone(): RejectMedicalAppointmentDto {
        const json = this.toJSON();
        let result = new RejectMedicalAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface IRejectMedicalAppointmentDto {
    id: string;
    comments: string | undefined;
    patient: string | undefined;
    doctor: string | undefined;
}

export class CancelMedicalAppointmentDto implements ICancelMedicalAppointmentDto {
    id: string;
    comments: string | undefined;

    constructor(data?: ICancelMedicalAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CancelMedicalAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelMedicalAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): CancelMedicalAppointmentDto {
        const json = this.toJSON();
        let result = new CancelMedicalAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface ICancelMedicalAppointmentDto {
    id: string;
    comments: string | undefined;
}

export class CounterPartDidNotShowUpDto implements ICounterPartDidNotShowUpDto {
    id: string;
    comments: string | undefined;
    patient: string | undefined;
    doctor: string | undefined;

    constructor(data?: ICounterPartDidNotShowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comments = _data["comments"];
            this.patient = _data["patient"];
            this.doctor = _data["doctor"];
        }
    }

    static fromJS(data: any): CounterPartDidNotShowUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new CounterPartDidNotShowUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comments"] = this.comments;
        data["patient"] = this.patient;
        data["doctor"] = this.doctor;
        return data; 
    }

    clone(): CounterPartDidNotShowUpDto {
        const json = this.toJSON();
        let result = new CounterPartDidNotShowUpDto();
        result.init(json);
        return result;
    }
}

export interface ICounterPartDidNotShowUpDto {
    id: string;
    comments: string | undefined;
    patient: string | undefined;
    doctor: string | undefined;
}

export class RescheduleMedicalAppointmentDto implements IRescheduleMedicalAppointmentDto {
    id: string;
    date: moment.Moment;
    comments: string | undefined;
    confirmed: boolean;

    constructor(data?: IRescheduleMedicalAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.confirmed = _data["confirmed"];
        }
    }

    static fromJS(data: any): RescheduleMedicalAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RescheduleMedicalAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["confirmed"] = this.confirmed;
        return data; 
    }

    clone(): RescheduleMedicalAppointmentDto {
        const json = this.toJSON();
        let result = new RescheduleMedicalAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface IRescheduleMedicalAppointmentDto {
    id: string;
    date: moment.Moment;
    comments: string | undefined;
    confirmed: boolean;
}

export class FinalizeMedicalAppointmentDto implements IFinalizeMedicalAppointmentDto {
    id: string;
    comments: string | undefined;

    constructor(data?: IFinalizeMedicalAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): FinalizeMedicalAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinalizeMedicalAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): FinalizeMedicalAppointmentDto {
        const json = this.toJSON();
        let result = new FinalizeMedicalAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface IFinalizeMedicalAppointmentDto {
    id: string;
    comments: string | undefined;
}

export class ToggleMedicalAppointmentRemotelyDto implements IToggleMedicalAppointmentRemotelyDto {
    id: string;
    confirmed: boolean;

    constructor(data?: IToggleMedicalAppointmentRemotelyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.confirmed = _data["confirmed"];
        }
    }

    static fromJS(data: any): ToggleMedicalAppointmentRemotelyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleMedicalAppointmentRemotelyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["confirmed"] = this.confirmed;
        return data; 
    }

    clone(): ToggleMedicalAppointmentRemotelyDto {
        const json = this.toJSON();
        let result = new ToggleMedicalAppointmentRemotelyDto();
        result.init(json);
        return result;
    }
}

export interface IToggleMedicalAppointmentRemotelyDto {
    id: string;
    confirmed: boolean;
}

export class PreProcedureFormInfo implements IPreProcedureFormInfo {
    id: number;
    title: string | undefined;
    description: string | undefined;
    version: number;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    creationTime: moment.Moment;
    isDeleted: boolean;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;

    constructor(data?: IPreProcedureFormInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.version = _data["version"];
            this.requiredOnlyOnce = _data["requiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.sendResponseNotification = _data["sendResponseNotification"];
            this.showOnMedicalRecords = _data["showOnMedicalRecords"];
        }
    }

    static fromJS(data: any): PreProcedureFormInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PreProcedureFormInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["version"] = this.version;
        data["requiredOnlyOnce"] = this.requiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["sendResponseNotification"] = this.sendResponseNotification;
        data["showOnMedicalRecords"] = this.showOnMedicalRecords;
        return data; 
    }

    clone(): PreProcedureFormInfo {
        const json = this.toJSON();
        let result = new PreProcedureFormInfo();
        result.init(json);
        return result;
    }
}

export interface IPreProcedureFormInfo {
    id: number;
    title: string | undefined;
    description: string | undefined;
    version: number;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    creationTime: moment.Moment;
    isDeleted: boolean;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;
}

export class GetProcedurePreFormDetailsResponse implements IGetProcedurePreFormDetailsResponse {
    id: number;
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    version: number;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    creationTime: moment.Moment;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;

    constructor(data?: IGetProcedurePreFormDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            this.version = _data["version"];
            this.requiredOnlyOnce = _data["requiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.sendResponseNotification = _data["sendResponseNotification"];
            this.showOnMedicalRecords = _data["showOnMedicalRecords"];
        }
    }

    static fromJS(data: any): GetProcedurePreFormDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProcedurePreFormDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        data["version"] = this.version;
        data["requiredOnlyOnce"] = this.requiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sendResponseNotification"] = this.sendResponseNotification;
        data["showOnMedicalRecords"] = this.showOnMedicalRecords;
        return data; 
    }

    clone(): GetProcedurePreFormDetailsResponse {
        const json = this.toJSON();
        let result = new GetProcedurePreFormDetailsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProcedurePreFormDetailsResponse {
    id: number;
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    version: number;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    creationTime: moment.Moment;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;
}

export class CreateProcedurePreFormRequest implements ICreateProcedurePreFormRequest {
    title: string;
    description: string;
    definition: string;
    allowResponseEdition: boolean;
    medicalProcedureId: number;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;

    constructor(data?: ICreateProcedurePreFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            this.allowResponseEdition = _data["allowResponseEdition"];
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.sendResponseNotification = _data["sendResponseNotification"];
            this.showOnMedicalRecords = _data["showOnMedicalRecords"];
        }
    }

    static fromJS(data: any): CreateProcedurePreFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcedurePreFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        data["allowResponseEdition"] = this.allowResponseEdition;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["sendResponseNotification"] = this.sendResponseNotification;
        data["showOnMedicalRecords"] = this.showOnMedicalRecords;
        return data; 
    }

    clone(): CreateProcedurePreFormRequest {
        const json = this.toJSON();
        let result = new CreateProcedurePreFormRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateProcedurePreFormRequest {
    title: string;
    description: string;
    definition: string;
    allowResponseEdition: boolean;
    medicalProcedureId: number;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;
}

export class UpdateProcedurePreFormRequest implements IUpdateProcedurePreFormRequest {
    id: number;
    title: string;
    description: string;
    definition: string;
    allowResponseEdition: boolean;
    medicalProcedureId: number;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;

    constructor(data?: IUpdateProcedurePreFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            this.allowResponseEdition = _data["allowResponseEdition"];
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.requiredOnlyOnce = _data["requiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
            this.sendResponseNotification = _data["sendResponseNotification"];
            this.showOnMedicalRecords = _data["showOnMedicalRecords"];
        }
    }

    static fromJS(data: any): UpdateProcedurePreFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcedurePreFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        data["allowResponseEdition"] = this.allowResponseEdition;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["requiredOnlyOnce"] = this.requiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        data["sendResponseNotification"] = this.sendResponseNotification;
        data["showOnMedicalRecords"] = this.showOnMedicalRecords;
        return data; 
    }

    clone(): UpdateProcedurePreFormRequest {
        const json = this.toJSON();
        let result = new UpdateProcedurePreFormRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateProcedurePreFormRequest {
    id: number;
    title: string;
    description: string;
    definition: string;
    allowResponseEdition: boolean;
    medicalProcedureId: number;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;
}

export class GetMedicalProceduresInput implements IGetMedicalProceduresInput {
    insuranceCompany: string | undefined;
    parent: number | undefined;
    exclude: number[] | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetMedicalProceduresInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuranceCompany = _data["insuranceCompany"];
            this.parent = _data["parent"];
            if (Array.isArray(_data["exclude"])) {
                this.exclude = [] as any;
                for (let item of _data["exclude"])
                    this.exclude.push(item);
            }
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetMedicalProceduresInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalProceduresInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceCompany"] = this.insuranceCompany;
        data["parent"] = this.parent;
        if (Array.isArray(this.exclude)) {
            data["exclude"] = [];
            for (let item of this.exclude)
                data["exclude"].push(item);
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetMedicalProceduresInput {
        const json = this.toJSON();
        let result = new GetMedicalProceduresInput();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalProceduresInput {
    insuranceCompany: string | undefined;
    parent: number | undefined;
    exclude: number[] | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class MedicalProcedureDtoPagedResultDto implements IMedicalProcedureDtoPagedResultDto {
    totalCount: number;
    items: MedicalProcedureDto[] | undefined;

    constructor(data?: IMedicalProcedureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MedicalProcedureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicalProcedureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MedicalProcedureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicalProcedureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureDtoPagedResultDto {
    totalCount: number;
    items: MedicalProcedureDto[] | undefined;
}

export class MedicalProcedureCoveredByInsuranceCompanyInput implements IMedicalProcedureCoveredByInsuranceCompanyInput {
    checked: boolean;
    price: number | undefined;
    id: number;

    constructor(data?: IMedicalProcedureCoveredByInsuranceCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checked = _data["checked"];
            this.price = _data["price"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByInsuranceCompanyInput {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByInsuranceCompanyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checked"] = this.checked;
        data["price"] = this.price;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByInsuranceCompanyInput {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByInsuranceCompanyInput();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByInsuranceCompanyInput {
    checked: boolean;
    price: number | undefined;
    id: number;
}

export class MedicalProcedureCoveredByInsurancePlanInput implements IMedicalProcedureCoveredByInsurancePlanInput {
    checked: boolean;
    price: number | undefined;
    id: number;

    constructor(data?: IMedicalProcedureCoveredByInsurancePlanInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checked = _data["checked"];
            this.price = _data["price"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByInsurancePlanInput {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByInsurancePlanInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checked"] = this.checked;
        data["price"] = this.price;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByInsurancePlanInput {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByInsurancePlanInput();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByInsurancePlanInput {
    checked: boolean;
    price: number | undefined;
    id: number;
}

export class MedicalProcedureCoveredByProfessional implements IMedicalProcedureCoveredByProfessional {
    checked: boolean;
    minutesDuration: number | undefined;
    splitPercentage: number | undefined;
    id: string;

    constructor(data?: IMedicalProcedureCoveredByProfessional) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checked = _data["checked"];
            this.minutesDuration = _data["minutesDuration"];
            this.splitPercentage = _data["splitPercentage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByProfessional {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByProfessional();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checked"] = this.checked;
        data["minutesDuration"] = this.minutesDuration;
        data["splitPercentage"] = this.splitPercentage;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByProfessional {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByProfessional();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByProfessional {
    checked: boolean;
    minutesDuration: number | undefined;
    splitPercentage: number | undefined;
    id: string;
}

export class MedicalProcedureCareUnitBasicInputDto implements IMedicalProcedureCareUnitBasicInputDto {
    /** Care Unit's Id */
    id: number;
    isActive: boolean;
    workJourney: AvailableDateWindow[] | undefined;

    constructor(data?: IMedicalProcedureCareUnitBasicInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["workJourney"])) {
                this.workJourney = [] as any;
                for (let item of _data["workJourney"])
                    this.workJourney.push(AvailableDateWindow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicalProcedureCareUnitBasicInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCareUnitBasicInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.workJourney)) {
            data["workJourney"] = [];
            for (let item of this.workJourney)
                data["workJourney"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MedicalProcedureCareUnitBasicInputDto {
        const json = this.toJSON();
        let result = new MedicalProcedureCareUnitBasicInputDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCareUnitBasicInputDto {
    /** Care Unit's Id */
    id: number;
    isActive: boolean;
    workJourney: AvailableDateWindow[] | undefined;
}

export class MedicalProcedureResponsibilityTermAttachment implements IMedicalProcedureResponsibilityTermAttachment {
    id: number | undefined;
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;

    constructor(data?: IMedicalProcedureResponsibilityTermAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.documentUrl = _data["documentUrl"];
            this.signatureRequiredOnlyOnce = _data["signatureRequiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
        }
    }

    static fromJS(data: any): MedicalProcedureResponsibilityTermAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureResponsibilityTermAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["documentUrl"] = this.documentUrl;
        data["signatureRequiredOnlyOnce"] = this.signatureRequiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        return data; 
    }

    clone(): MedicalProcedureResponsibilityTermAttachment {
        const json = this.toJSON();
        let result = new MedicalProcedureResponsibilityTermAttachment();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureResponsibilityTermAttachment {
    id: number | undefined;
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
}

export class CreateMedicalProcedureInput implements ICreateMedicalProcedureInput {
    name: string | undefined;
    description: string | undefined;
    publicDescription: string | undefined;
    duration: number;
    price: number;
    scheduleColor: string | undefined;
    parentId: number | undefined;
    splitPercentage: number | undefined;
    coveredInsuranceCompanies: MedicalProcedureCoveredByInsuranceCompanyInput[] | undefined;
    coveredInsurancePlans: MedicalProcedureCoveredByInsurancePlanInput[] | undefined;
    coveredByProfessionals: MedicalProcedureCoveredByProfessional[] | undefined;
    coveredCareUnits: MedicalProcedureCareUnitBasicInputDto[] | undefined;
    allowOnlinePayment: boolean;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    allowOnlineSchedule: boolean;
    remotely: boolean;
    isReturn: boolean;
    returnParentId: number[] | undefined;
    isProfessionalRequired: boolean;
    responsibilityTerms: MedicalProcedureResponsibilityTermAttachment[] | undefined;
    periodUnit: ProcedurePeriodUnit;
    /** Max allowed number of installments */
    maxNumberOfInstallments: number;

    constructor(data?: ICreateMedicalProcedureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.publicDescription = _data["publicDescription"];
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.scheduleColor = _data["scheduleColor"];
            this.parentId = _data["parentId"];
            this.splitPercentage = _data["splitPercentage"];
            if (Array.isArray(_data["coveredInsuranceCompanies"])) {
                this.coveredInsuranceCompanies = [] as any;
                for (let item of _data["coveredInsuranceCompanies"])
                    this.coveredInsuranceCompanies.push(MedicalProcedureCoveredByInsuranceCompanyInput.fromJS(item));
            }
            if (Array.isArray(_data["coveredInsurancePlans"])) {
                this.coveredInsurancePlans = [] as any;
                for (let item of _data["coveredInsurancePlans"])
                    this.coveredInsurancePlans.push(MedicalProcedureCoveredByInsurancePlanInput.fromJS(item));
            }
            if (Array.isArray(_data["coveredByProfessionals"])) {
                this.coveredByProfessionals = [] as any;
                for (let item of _data["coveredByProfessionals"])
                    this.coveredByProfessionals.push(MedicalProcedureCoveredByProfessional.fromJS(item));
            }
            if (Array.isArray(_data["coveredCareUnits"])) {
                this.coveredCareUnits = [] as any;
                for (let item of _data["coveredCareUnits"])
                    this.coveredCareUnits.push(MedicalProcedureCareUnitBasicInputDto.fromJS(item));
            }
            this.allowOnlinePayment = _data["allowOnlinePayment"];
            this.onlinePaymentType = _data["onlinePaymentType"];
            this.allowOnlineSchedule = _data["allowOnlineSchedule"];
            this.remotely = _data["remotely"];
            this.isReturn = _data["isReturn"];
            if (Array.isArray(_data["returnParentId"])) {
                this.returnParentId = [] as any;
                for (let item of _data["returnParentId"])
                    this.returnParentId.push(item);
            }
            this.isProfessionalRequired = _data["isProfessionalRequired"];
            if (Array.isArray(_data["responsibilityTerms"])) {
                this.responsibilityTerms = [] as any;
                for (let item of _data["responsibilityTerms"])
                    this.responsibilityTerms.push(MedicalProcedureResponsibilityTermAttachment.fromJS(item));
            }
            this.periodUnit = _data["periodUnit"];
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
        }
    }

    static fromJS(data: any): CreateMedicalProcedureInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalProcedureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["publicDescription"] = this.publicDescription;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["scheduleColor"] = this.scheduleColor;
        data["parentId"] = this.parentId;
        data["splitPercentage"] = this.splitPercentage;
        if (Array.isArray(this.coveredInsuranceCompanies)) {
            data["coveredInsuranceCompanies"] = [];
            for (let item of this.coveredInsuranceCompanies)
                data["coveredInsuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredInsurancePlans)) {
            data["coveredInsurancePlans"] = [];
            for (let item of this.coveredInsurancePlans)
                data["coveredInsurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredByProfessionals)) {
            data["coveredByProfessionals"] = [];
            for (let item of this.coveredByProfessionals)
                data["coveredByProfessionals"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredCareUnits)) {
            data["coveredCareUnits"] = [];
            for (let item of this.coveredCareUnits)
                data["coveredCareUnits"].push(item.toJSON());
        }
        data["allowOnlinePayment"] = this.allowOnlinePayment;
        data["onlinePaymentType"] = this.onlinePaymentType;
        data["allowOnlineSchedule"] = this.allowOnlineSchedule;
        data["remotely"] = this.remotely;
        data["isReturn"] = this.isReturn;
        if (Array.isArray(this.returnParentId)) {
            data["returnParentId"] = [];
            for (let item of this.returnParentId)
                data["returnParentId"].push(item);
        }
        data["isProfessionalRequired"] = this.isProfessionalRequired;
        if (Array.isArray(this.responsibilityTerms)) {
            data["responsibilityTerms"] = [];
            for (let item of this.responsibilityTerms)
                data["responsibilityTerms"].push(item.toJSON());
        }
        data["periodUnit"] = this.periodUnit;
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        return data; 
    }

    clone(): CreateMedicalProcedureInput {
        const json = this.toJSON();
        let result = new CreateMedicalProcedureInput();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalProcedureInput {
    name: string | undefined;
    description: string | undefined;
    publicDescription: string | undefined;
    duration: number;
    price: number;
    scheduleColor: string | undefined;
    parentId: number | undefined;
    splitPercentage: number | undefined;
    coveredInsuranceCompanies: MedicalProcedureCoveredByInsuranceCompanyInput[] | undefined;
    coveredInsurancePlans: MedicalProcedureCoveredByInsurancePlanInput[] | undefined;
    coveredByProfessionals: MedicalProcedureCoveredByProfessional[] | undefined;
    coveredCareUnits: MedicalProcedureCareUnitBasicInputDto[] | undefined;
    allowOnlinePayment: boolean;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    allowOnlineSchedule: boolean;
    remotely: boolean;
    isReturn: boolean;
    returnParentId: number[] | undefined;
    isProfessionalRequired: boolean;
    responsibilityTerms: MedicalProcedureResponsibilityTermAttachment[] | undefined;
    periodUnit: ProcedurePeriodUnit;
    /** Max allowed number of installments */
    maxNumberOfInstallments: number;
}

export class UpdateMedicalProcedureInput implements IUpdateMedicalProcedureInput {
    name: string | undefined;
    description: string | undefined;
    publicDescription: string | undefined;
    duration: number;
    price: number;
    scheduleColor: string | undefined;
    parentId: number | undefined;
    coveredInsuranceCompanies: MedicalProcedureCoveredByInsuranceCompanyInput[] | undefined;
    coveredInsurancePlans: MedicalProcedureCoveredByInsurancePlanInput[] | undefined;
    coveredByProfessionals: MedicalProcedureCoveredByProfessional[] | undefined;
    coveredCareUnits: MedicalProcedureCareUnitBasicInputDto[] | undefined;
    allowOnlineSchedule: boolean;
    remotely: boolean;
    isReturn: boolean;
    returnParentId: number[] | undefined;
    isProfessionalRequired: boolean;
    allowOnlinePayment: boolean;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    responsibilityTerms: MedicalProcedureResponsibilityTermAttachment[] | undefined;
    periodUnit: ProcedurePeriodUnit;
    splitPercentage: number | undefined;
    /** Max allowed number of installments */
    maxNumberOfInstallments: number;
    id: number;

    constructor(data?: IUpdateMedicalProcedureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.publicDescription = _data["publicDescription"];
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.scheduleColor = _data["scheduleColor"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["coveredInsuranceCompanies"])) {
                this.coveredInsuranceCompanies = [] as any;
                for (let item of _data["coveredInsuranceCompanies"])
                    this.coveredInsuranceCompanies.push(MedicalProcedureCoveredByInsuranceCompanyInput.fromJS(item));
            }
            if (Array.isArray(_data["coveredInsurancePlans"])) {
                this.coveredInsurancePlans = [] as any;
                for (let item of _data["coveredInsurancePlans"])
                    this.coveredInsurancePlans.push(MedicalProcedureCoveredByInsurancePlanInput.fromJS(item));
            }
            if (Array.isArray(_data["coveredByProfessionals"])) {
                this.coveredByProfessionals = [] as any;
                for (let item of _data["coveredByProfessionals"])
                    this.coveredByProfessionals.push(MedicalProcedureCoveredByProfessional.fromJS(item));
            }
            if (Array.isArray(_data["coveredCareUnits"])) {
                this.coveredCareUnits = [] as any;
                for (let item of _data["coveredCareUnits"])
                    this.coveredCareUnits.push(MedicalProcedureCareUnitBasicInputDto.fromJS(item));
            }
            this.allowOnlineSchedule = _data["allowOnlineSchedule"];
            this.remotely = _data["remotely"];
            this.isReturn = _data["isReturn"];
            if (Array.isArray(_data["returnParentId"])) {
                this.returnParentId = [] as any;
                for (let item of _data["returnParentId"])
                    this.returnParentId.push(item);
            }
            this.isProfessionalRequired = _data["isProfessionalRequired"];
            this.allowOnlinePayment = _data["allowOnlinePayment"];
            this.onlinePaymentType = _data["onlinePaymentType"];
            if (Array.isArray(_data["responsibilityTerms"])) {
                this.responsibilityTerms = [] as any;
                for (let item of _data["responsibilityTerms"])
                    this.responsibilityTerms.push(MedicalProcedureResponsibilityTermAttachment.fromJS(item));
            }
            this.periodUnit = _data["periodUnit"];
            this.splitPercentage = _data["splitPercentage"];
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMedicalProcedureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicalProcedureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["publicDescription"] = this.publicDescription;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["scheduleColor"] = this.scheduleColor;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.coveredInsuranceCompanies)) {
            data["coveredInsuranceCompanies"] = [];
            for (let item of this.coveredInsuranceCompanies)
                data["coveredInsuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredInsurancePlans)) {
            data["coveredInsurancePlans"] = [];
            for (let item of this.coveredInsurancePlans)
                data["coveredInsurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredByProfessionals)) {
            data["coveredByProfessionals"] = [];
            for (let item of this.coveredByProfessionals)
                data["coveredByProfessionals"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredCareUnits)) {
            data["coveredCareUnits"] = [];
            for (let item of this.coveredCareUnits)
                data["coveredCareUnits"].push(item.toJSON());
        }
        data["allowOnlineSchedule"] = this.allowOnlineSchedule;
        data["remotely"] = this.remotely;
        data["isReturn"] = this.isReturn;
        if (Array.isArray(this.returnParentId)) {
            data["returnParentId"] = [];
            for (let item of this.returnParentId)
                data["returnParentId"].push(item);
        }
        data["isProfessionalRequired"] = this.isProfessionalRequired;
        data["allowOnlinePayment"] = this.allowOnlinePayment;
        data["onlinePaymentType"] = this.onlinePaymentType;
        if (Array.isArray(this.responsibilityTerms)) {
            data["responsibilityTerms"] = [];
            for (let item of this.responsibilityTerms)
                data["responsibilityTerms"].push(item.toJSON());
        }
        data["periodUnit"] = this.periodUnit;
        data["splitPercentage"] = this.splitPercentage;
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateMedicalProcedureInput {
        const json = this.toJSON();
        let result = new UpdateMedicalProcedureInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicalProcedureInput {
    name: string | undefined;
    description: string | undefined;
    publicDescription: string | undefined;
    duration: number;
    price: number;
    scheduleColor: string | undefined;
    parentId: number | undefined;
    coveredInsuranceCompanies: MedicalProcedureCoveredByInsuranceCompanyInput[] | undefined;
    coveredInsurancePlans: MedicalProcedureCoveredByInsurancePlanInput[] | undefined;
    coveredByProfessionals: MedicalProcedureCoveredByProfessional[] | undefined;
    coveredCareUnits: MedicalProcedureCareUnitBasicInputDto[] | undefined;
    allowOnlineSchedule: boolean;
    remotely: boolean;
    isReturn: boolean;
    returnParentId: number[] | undefined;
    isProfessionalRequired: boolean;
    allowOnlinePayment: boolean;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    responsibilityTerms: MedicalProcedureResponsibilityTermAttachment[] | undefined;
    periodUnit: ProcedurePeriodUnit;
    splitPercentage: number | undefined;
    /** Max allowed number of installments */
    maxNumberOfInstallments: number;
    id: number;
}

export class MedicalRecordConfigurationModel implements IMedicalRecordConfigurationModel {
    sharedMedicalRecord: boolean;
    allowRecordEdition: boolean;
    recordEditionPeriod: number;
    sharedExaminationModel: boolean;
    sharedPrescriptionModel: boolean;
    sharedDocumentModel: boolean;
    sendExaminationToPatientByEmail: boolean;
    sendPrescriptionToPatientByEmail: boolean;
    sendFileToPatientByEmail: boolean;

    constructor(data?: IMedicalRecordConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharedMedicalRecord = _data["sharedMedicalRecord"];
            this.allowRecordEdition = _data["allowRecordEdition"];
            this.recordEditionPeriod = _data["recordEditionPeriod"];
            this.sharedExaminationModel = _data["sharedExaminationModel"];
            this.sharedPrescriptionModel = _data["sharedPrescriptionModel"];
            this.sharedDocumentModel = _data["sharedDocumentModel"];
            this.sendExaminationToPatientByEmail = _data["sendExaminationToPatientByEmail"];
            this.sendPrescriptionToPatientByEmail = _data["sendPrescriptionToPatientByEmail"];
            this.sendFileToPatientByEmail = _data["sendFileToPatientByEmail"];
        }
    }

    static fromJS(data: any): MedicalRecordConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecordConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharedMedicalRecord"] = this.sharedMedicalRecord;
        data["allowRecordEdition"] = this.allowRecordEdition;
        data["recordEditionPeriod"] = this.recordEditionPeriod;
        data["sharedExaminationModel"] = this.sharedExaminationModel;
        data["sharedPrescriptionModel"] = this.sharedPrescriptionModel;
        data["sharedDocumentModel"] = this.sharedDocumentModel;
        data["sendExaminationToPatientByEmail"] = this.sendExaminationToPatientByEmail;
        data["sendPrescriptionToPatientByEmail"] = this.sendPrescriptionToPatientByEmail;
        data["sendFileToPatientByEmail"] = this.sendFileToPatientByEmail;
        return data; 
    }

    clone(): MedicalRecordConfigurationModel {
        const json = this.toJSON();
        let result = new MedicalRecordConfigurationModel();
        result.init(json);
        return result;
    }
}

export interface IMedicalRecordConfigurationModel {
    sharedMedicalRecord: boolean;
    allowRecordEdition: boolean;
    recordEditionPeriod: number;
    sharedExaminationModel: boolean;
    sharedPrescriptionModel: boolean;
    sharedDocumentModel: boolean;
    sendExaminationToPatientByEmail: boolean;
    sendPrescriptionToPatientByEmail: boolean;
    sendFileToPatientByEmail: boolean;
}

export class AddMedicalRecordEntryCommand implements IAddMedicalRecordEntryCommand {
    healthProfessionalId: string | undefined;
    patientId: string;
    formId: string;
    value: string | undefined;

    constructor(data?: IAddMedicalRecordEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.patientId = _data["patientId"];
            this.formId = _data["formId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AddMedicalRecordEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddMedicalRecordEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["patientId"] = this.patientId;
        data["formId"] = this.formId;
        data["value"] = this.value;
        return data; 
    }

    clone(): AddMedicalRecordEntryCommand {
        const json = this.toJSON();
        let result = new AddMedicalRecordEntryCommand();
        result.init(json);
        return result;
    }
}

export interface IAddMedicalRecordEntryCommand {
    healthProfessionalId: string | undefined;
    patientId: string;
    formId: string;
    value: string | undefined;
}

export class MedicalRecordEntryDto implements IMedicalRecordEntryDto {
    creator: DoctorDto;
    healthProfessionalId: string | undefined;
    patientId: string;
    formId: string;
    value: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IMedicalRecordEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creator = _data["creator"] ? DoctorDto.fromJS(_data["creator"]) : <any>undefined;
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.patientId = _data["patientId"];
            this.formId = _data["formId"];
            this.value = _data["value"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalRecordEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecordEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["patientId"] = this.patientId;
        data["formId"] = this.formId;
        data["value"] = this.value;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalRecordEntryDto {
        const json = this.toJSON();
        let result = new MedicalRecordEntryDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalRecordEntryDto {
    creator: DoctorDto;
    healthProfessionalId: string | undefined;
    patientId: string;
    formId: string;
    value: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class GetMedicalRecordQuery implements IGetMedicalRecordQuery {
    patientId: string;
    dates: number[] | undefined;
    pageSize: number | undefined;

    constructor(data?: IGetMedicalRecordQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates.push(item);
            }
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetMedicalRecordQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalRecordQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        data["pageSize"] = this.pageSize;
        return data; 
    }

    clone(): GetMedicalRecordQuery {
        const json = this.toJSON();
        let result = new GetMedicalRecordQuery();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalRecordQuery {
    patientId: string;
    dates: number[] | undefined;
    pageSize: number | undefined;
}

export class MedicalRecordFormDto implements IMedicalRecordFormDto {
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    /** Autoincrement, starting in 1 */
    version: number;
    tags: number;
    horizontalEvolution: boolean;
    creator: DoctorDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IMedicalRecordFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            this.version = _data["version"];
            this.tags = _data["tags"];
            this.horizontalEvolution = _data["horizontalEvolution"];
            this.creator = _data["creator"] ? DoctorDto.fromJS(_data["creator"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalRecordFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecordFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        data["version"] = this.version;
        data["tags"] = this.tags;
        data["horizontalEvolution"] = this.horizontalEvolution;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalRecordFormDto {
        const json = this.toJSON();
        let result = new MedicalRecordFormDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalRecordFormDto {
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    /** Autoincrement, starting in 1 */
    version: number;
    tags: number;
    horizontalEvolution: boolean;
    creator: DoctorDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class LegacyHorizontalMedicalRecord implements ILegacyHorizontalMedicalRecord {
    formId: string;
    creatorUserId: number | undefined;
    creator: DoctorDto;
    entries: MedicalRecordEntryDto[] | undefined;

    constructor(data?: ILegacyHorizontalMedicalRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creator = _data["creator"] ? DoctorDto.fromJS(_data["creator"]) : <any>undefined;
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries.push(MedicalRecordEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LegacyHorizontalMedicalRecord {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyHorizontalMedicalRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["creatorUserId"] = this.creatorUserId;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data; 
    }

    clone(): LegacyHorizontalMedicalRecord {
        const json = this.toJSON();
        let result = new LegacyHorizontalMedicalRecord();
        result.init(json);
        return result;
    }
}

export interface ILegacyHorizontalMedicalRecord {
    formId: string;
    creatorUserId: number | undefined;
    creator: DoctorDto;
    entries: MedicalRecordEntryDto[] | undefined;
}

export class MedicalRecordFormAnswerDto implements IMedicalRecordFormAnswerDto {
    fieldId: string | undefined;
    fieldType: string | undefined;
    label: string | undefined;
    required: boolean;
    answer: string | undefined;
    answerValue: any | undefined;
    creationTime: moment.Moment;

    constructor(data?: IMedicalRecordFormAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.fieldType = _data["fieldType"];
            this.label = _data["label"];
            this.required = _data["required"];
            this.answer = _data["answer"];
            this.answerValue = _data["answerValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicalRecordFormAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecordFormAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["fieldType"] = this.fieldType;
        data["label"] = this.label;
        data["required"] = this.required;
        data["answer"] = this.answer;
        data["answerValue"] = this.answerValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): MedicalRecordFormAnswerDto {
        const json = this.toJSON();
        let result = new MedicalRecordFormAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalRecordFormAnswerDto {
    fieldId: string | undefined;
    fieldType: string | undefined;
    label: string | undefined;
    required: boolean;
    answer: string | undefined;
    answerValue: any | undefined;
    creationTime: moment.Moment;
}

export class MedicalRecordFormResponseDto implements IMedicalRecordFormResponseDto {
    formId: number;
    horizontalEvolution: boolean;
    title: string | undefined;
    description: string | undefined;
    answers: MedicalRecordFormAnswerDto[] | undefined;
    patientId: string;
    healthProfessionalId: string | undefined;
    creator: DoctorDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalRecordFormResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.horizontalEvolution = _data["horizontalEvolution"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers.push(MedicalRecordFormAnswerDto.fromJS(item));
            }
            this.patientId = _data["patientId"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.creator = _data["creator"] ? DoctorDto.fromJS(_data["creator"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalRecordFormResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecordFormResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["horizontalEvolution"] = this.horizontalEvolution;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["patientId"] = this.patientId;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalRecordFormResponseDto {
        const json = this.toJSON();
        let result = new MedicalRecordFormResponseDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalRecordFormResponseDto {
    formId: number;
    horizontalEvolution: boolean;
    title: string | undefined;
    description: string | undefined;
    answers: MedicalRecordFormAnswerDto[] | undefined;
    patientId: string;
    healthProfessionalId: string | undefined;
    creator: DoctorDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class HorizontalMedicalRecord implements IHorizontalMedicalRecord {
    formId: number;
    title: string | undefined;
    description: string | undefined;
    healthProfessionalId: string | undefined;
    creatorUserId: number | undefined;
    responses: MedicalRecordFormResponseDto[] | undefined;

    constructor(data?: IHorizontalMedicalRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.creatorUserId = _data["creatorUserId"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses.push(MedicalRecordFormResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HorizontalMedicalRecord {
        data = typeof data === 'object' ? data : {};
        let result = new HorizontalMedicalRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["creatorUserId"] = this.creatorUserId;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HorizontalMedicalRecord {
        const json = this.toJSON();
        let result = new HorizontalMedicalRecord();
        result.init(json);
        return result;
    }
}

export interface IHorizontalMedicalRecord {
    formId: number;
    title: string | undefined;
    description: string | undefined;
    healthProfessionalId: string | undefined;
    creatorUserId: number | undefined;
    responses: MedicalRecordFormResponseDto[] | undefined;
}

export class UserNameInfo implements IUserNameInfo {
    id: number;
    name: string | undefined;

    constructor(data?: IUserNameInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserNameInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserNameInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): UserNameInfo {
        const json = this.toJSON();
        let result = new UserNameInfo();
        result.init(json);
        return result;
    }
}

export interface IUserNameInfo {
    id: number;
    name: string | undefined;
}

export class MedicalRecord implements IMedicalRecord {
    date: moment.Moment;
    creator: UserNameInfo;
    readonly discriminator: string | undefined;

    constructor(data?: IMedicalRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.creator = _data["creator"] ? UserNameInfo.fromJS(_data["creator"]) : <any>undefined;
            (<any>this).discriminator = _data["discriminator"];
        }
    }

    static fromJS(data: any): MedicalRecord {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["discriminator"] = this.discriminator;
        return data; 
    }

    clone(): MedicalRecord {
        const json = this.toJSON();
        let result = new MedicalRecord();
        result.init(json);
        return result;
    }
}

export interface IMedicalRecord {
    date: moment.Moment;
    creator: UserNameInfo;
    discriminator: string | undefined;
}

export class MedicalRecordGroup implements IMedicalRecordGroup {
    date: moment.Moment;
    items: MedicalRecord[] | undefined;

    constructor(data?: IMedicalRecordGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MedicalRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicalRecordGroup {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecordGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MedicalRecordGroup {
        const json = this.toJSON();
        let result = new MedicalRecordGroup();
        result.init(json);
        return result;
    }
}

export interface IMedicalRecordGroup {
    date: moment.Moment;
    items: MedicalRecord[] | undefined;
}

export class GetMedicalRecordResult implements IGetMedicalRecordResult {
    dates: number[] | undefined;
    pageSize: number;
    forms: MedicalRecordFormDto[] | undefined;
    legacyHorizontalRecords: LegacyHorizontalMedicalRecord[] | undefined;
    horizontalRecords: HorizontalMedicalRecord[] | undefined;
    childGrowth: ChildGrowthEntryDto[] | undefined;
    records: MedicalRecordGroup[] | undefined;

    constructor(data?: IGetMedicalRecordResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates.push(item);
            }
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms.push(MedicalRecordFormDto.fromJS(item));
            }
            if (Array.isArray(_data["legacyHorizontalRecords"])) {
                this.legacyHorizontalRecords = [] as any;
                for (let item of _data["legacyHorizontalRecords"])
                    this.legacyHorizontalRecords.push(LegacyHorizontalMedicalRecord.fromJS(item));
            }
            if (Array.isArray(_data["horizontalRecords"])) {
                this.horizontalRecords = [] as any;
                for (let item of _data["horizontalRecords"])
                    this.horizontalRecords.push(HorizontalMedicalRecord.fromJS(item));
            }
            if (Array.isArray(_data["childGrowth"])) {
                this.childGrowth = [] as any;
                for (let item of _data["childGrowth"])
                    this.childGrowth.push(ChildGrowthEntryDto.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records.push(MedicalRecordGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMedicalRecordResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalRecordResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        if (Array.isArray(this.legacyHorizontalRecords)) {
            data["legacyHorizontalRecords"] = [];
            for (let item of this.legacyHorizontalRecords)
                data["legacyHorizontalRecords"].push(item.toJSON());
        }
        if (Array.isArray(this.horizontalRecords)) {
            data["horizontalRecords"] = [];
            for (let item of this.horizontalRecords)
                data["horizontalRecords"].push(item.toJSON());
        }
        if (Array.isArray(this.childGrowth)) {
            data["childGrowth"] = [];
            for (let item of this.childGrowth)
                data["childGrowth"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetMedicalRecordResult {
        const json = this.toJSON();
        let result = new GetMedicalRecordResult();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalRecordResult {
    dates: number[] | undefined;
    pageSize: number;
    forms: MedicalRecordFormDto[] | undefined;
    legacyHorizontalRecords: LegacyHorizontalMedicalRecord[] | undefined;
    horizontalRecords: HorizontalMedicalRecord[] | undefined;
    childGrowth: ChildGrowthEntryDto[] | undefined;
    records: MedicalRecordGroup[] | undefined;
}

export class GetMedicalRecordFormsDefinitionQuery implements IGetMedicalRecordFormsDefinitionQuery {
    includeDefinition: boolean;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetMedicalRecordFormsDefinitionQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeDefinition = _data["includeDefinition"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetMedicalRecordFormsDefinitionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalRecordFormsDefinitionQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeDefinition"] = this.includeDefinition;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetMedicalRecordFormsDefinitionQuery {
        const json = this.toJSON();
        let result = new GetMedicalRecordFormsDefinitionQuery();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalRecordFormsDefinitionQuery {
    includeDefinition: boolean;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export enum Status {
    _0 = 0,
    _1 = 1,
}

export class MedicalRecordFormDefinition implements IMedicalRecordFormDefinition {
    parentId: number | undefined;
    status: Status;
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    tags: number;
    /** Allow to search using the fields on the form */
    searchable: boolean;
    version: number;
    /** Will the form be available to all professionals, or not */
    private: boolean;
    /** Form's field will be displayed as Table columns */
    horizontalEvolution: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalRecordFormDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.status = _data["status"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            this.tags = _data["tags"];
            this.searchable = _data["searchable"];
            this.version = _data["version"];
            this.private = _data["private"];
            this.horizontalEvolution = _data["horizontalEvolution"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalRecordFormDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecordFormDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["status"] = this.status;
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        data["tags"] = this.tags;
        data["searchable"] = this.searchable;
        data["version"] = this.version;
        data["private"] = this.private;
        data["horizontalEvolution"] = this.horizontalEvolution;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalRecordFormDefinition {
        const json = this.toJSON();
        let result = new MedicalRecordFormDefinition();
        result.init(json);
        return result;
    }
}

export interface IMedicalRecordFormDefinition {
    parentId: number | undefined;
    status: Status;
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    tags: number;
    /** Allow to search using the fields on the form */
    searchable: boolean;
    version: number;
    /** Will the form be available to all professionals, or not */
    private: boolean;
    /** Form's field will be displayed as Table columns */
    horizontalEvolution: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class GetMedicalRecordFormsDefinitionResult implements IGetMedicalRecordFormsDefinitionResult {
    totalCount: number;
    items: MedicalRecordFormDefinition[] | undefined;

    constructor(data?: IGetMedicalRecordFormsDefinitionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MedicalRecordFormDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMedicalRecordFormsDefinitionResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalRecordFormsDefinitionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetMedicalRecordFormsDefinitionResult {
        const json = this.toJSON();
        let result = new GetMedicalRecordFormsDefinitionResult();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalRecordFormsDefinitionResult {
    totalCount: number;
    items: MedicalRecordFormDefinition[] | undefined;
}

export class CreateMedicalRecordFormDefinitionCommand implements ICreateMedicalRecordFormDefinitionCommand {
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    tags: number[] | undefined;
    searchable: boolean;
    private: boolean;
    horizontalEvolution: boolean;

    constructor(data?: ICreateMedicalRecordFormDefinitionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.searchable = _data["searchable"];
            this.private = _data["private"];
            this.horizontalEvolution = _data["horizontalEvolution"];
        }
    }

    static fromJS(data: any): CreateMedicalRecordFormDefinitionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalRecordFormDefinitionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["searchable"] = this.searchable;
        data["private"] = this.private;
        data["horizontalEvolution"] = this.horizontalEvolution;
        return data; 
    }

    clone(): CreateMedicalRecordFormDefinitionCommand {
        const json = this.toJSON();
        let result = new CreateMedicalRecordFormDefinitionCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalRecordFormDefinitionCommand {
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    tags: number[] | undefined;
    searchable: boolean;
    private: boolean;
    horizontalEvolution: boolean;
}

export class UpdateMedicalRecordFormDefinitionCommand implements IUpdateMedicalRecordFormDefinitionCommand {
    id: number;
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    tags: number[] | undefined;
    searchable: boolean;
    private: boolean;
    horizontalEvolution: boolean;

    constructor(data?: IUpdateMedicalRecordFormDefinitionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.searchable = _data["searchable"];
            this.private = _data["private"];
            this.horizontalEvolution = _data["horizontalEvolution"];
        }
    }

    static fromJS(data: any): UpdateMedicalRecordFormDefinitionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicalRecordFormDefinitionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["searchable"] = this.searchable;
        data["private"] = this.private;
        data["horizontalEvolution"] = this.horizontalEvolution;
        return data; 
    }

    clone(): UpdateMedicalRecordFormDefinitionCommand {
        const json = this.toJSON();
        let result = new UpdateMedicalRecordFormDefinitionCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicalRecordFormDefinitionCommand {
    id: number;
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    tags: number[] | undefined;
    searchable: boolean;
    private: boolean;
    horizontalEvolution: boolean;
}

export class GetSearchableMedicalRecordFormsQuery implements IGetSearchableMedicalRecordFormsQuery {

    constructor(data?: IGetSearchableMedicalRecordFormsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSearchableMedicalRecordFormsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchableMedicalRecordFormsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetSearchableMedicalRecordFormsQuery {
        const json = this.toJSON();
        let result = new GetSearchableMedicalRecordFormsQuery();
        result.init(json);
        return result;
    }
}

export interface IGetSearchableMedicalRecordFormsQuery {
}

export class CollectMedicalRecordFormCommand implements ICollectMedicalRecordFormCommand {
    tenantId: number | undefined;
    collectionTime: moment.Moment | undefined;
    medicalRecordFormId: number;
    patientId: string;
    response: string | undefined;
    saveNonAnsweredQuestion: boolean;
    professionalId: string | undefined;
    externalId: string | undefined;

    constructor(data?: ICollectMedicalRecordFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.collectionTime = _data["collectionTime"] ? moment(_data["collectionTime"].toString()) : <any>undefined;
            this.medicalRecordFormId = _data["medicalRecordFormId"];
            this.patientId = _data["patientId"];
            this.response = _data["response"];
            this.saveNonAnsweredQuestion = _data["saveNonAnsweredQuestion"];
            this.professionalId = _data["professionalId"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): CollectMedicalRecordFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CollectMedicalRecordFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["collectionTime"] = this.collectionTime ? this.collectionTime.toISOString() : <any>undefined;
        data["medicalRecordFormId"] = this.medicalRecordFormId;
        data["patientId"] = this.patientId;
        data["response"] = this.response;
        data["saveNonAnsweredQuestion"] = this.saveNonAnsweredQuestion;
        data["professionalId"] = this.professionalId;
        data["externalId"] = this.externalId;
        return data; 
    }

    clone(): CollectMedicalRecordFormCommand {
        const json = this.toJSON();
        let result = new CollectMedicalRecordFormCommand();
        result.init(json);
        return result;
    }
}

export interface ICollectMedicalRecordFormCommand {
    tenantId: number | undefined;
    collectionTime: moment.Moment | undefined;
    medicalRecordFormId: number;
    patientId: string;
    response: string | undefined;
    saveNonAnsweredQuestion: boolean;
    professionalId: string | undefined;
    externalId: string | undefined;
}

export class UpdateMedicalRecordFormResponseRequest implements IUpdateMedicalRecordFormResponseRequest {
    medicalRecordFormResponseId: number;
    response: string | undefined;
    saveNonAnsweredQuestion: boolean;

    constructor(data?: IUpdateMedicalRecordFormResponseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalRecordFormResponseId = _data["medicalRecordFormResponseId"];
            this.response = _data["response"];
            this.saveNonAnsweredQuestion = _data["saveNonAnsweredQuestion"];
        }
    }

    static fromJS(data: any): UpdateMedicalRecordFormResponseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicalRecordFormResponseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalRecordFormResponseId"] = this.medicalRecordFormResponseId;
        data["response"] = this.response;
        data["saveNonAnsweredQuestion"] = this.saveNonAnsweredQuestion;
        return data; 
    }

    clone(): UpdateMedicalRecordFormResponseRequest {
        const json = this.toJSON();
        let result = new UpdateMedicalRecordFormResponseRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicalRecordFormResponseRequest {
    medicalRecordFormResponseId: number;
    response: string | undefined;
    saveNonAnsweredQuestion: boolean;
}

export class GetMedicalRecordFormsQuery implements IGetMedicalRecordFormsQuery {
    includeDefinition: boolean;
    ids: string[] | undefined;
    filterByIds: boolean;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetMedicalRecordFormsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeDefinition = _data["includeDefinition"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids.push(item);
            }
            this.filterByIds = _data["filterByIds"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetMedicalRecordFormsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalRecordFormsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeDefinition"] = this.includeDefinition;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["filterByIds"] = this.filterByIds;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetMedicalRecordFormsQuery {
        const json = this.toJSON();
        let result = new GetMedicalRecordFormsQuery();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalRecordFormsQuery {
    includeDefinition: boolean;
    ids: string[] | undefined;
    filterByIds: boolean;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class GetMedicalRecordFormsResult implements IGetMedicalRecordFormsResult {
    totalCount: number;
    items: MedicalRecordFormDto[] | undefined;

    constructor(data?: IGetMedicalRecordFormsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MedicalRecordFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMedicalRecordFormsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalRecordFormsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetMedicalRecordFormsResult {
        const json = this.toJSON();
        let result = new GetMedicalRecordFormsResult();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalRecordFormsResult {
    totalCount: number;
    items: MedicalRecordFormDto[] | undefined;
}

export class MedicalRecordFormTagDto implements IMedicalRecordFormTagDto {
    name: string | undefined;
    identifier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalRecordFormTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalRecordFormTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecordFormTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalRecordFormTagDto {
        const json = this.toJSON();
        let result = new MedicalRecordFormTagDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalRecordFormTagDto {
    name: string | undefined;
    identifier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateMedicalRecordFormCommand implements ICreateMedicalRecordFormCommand {
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    tags: number[] | undefined;
    horizontalEvolution: boolean;

    constructor(data?: ICreateMedicalRecordFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.horizontalEvolution = _data["horizontalEvolution"];
        }
    }

    static fromJS(data: any): CreateMedicalRecordFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalRecordFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["horizontalEvolution"] = this.horizontalEvolution;
        return data; 
    }

    clone(): CreateMedicalRecordFormCommand {
        const json = this.toJSON();
        let result = new CreateMedicalRecordFormCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalRecordFormCommand {
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    tags: number[] | undefined;
    horizontalEvolution: boolean;
}

export class UpdateMedicalRecordFormCommand implements IUpdateMedicalRecordFormCommand {
    id: string;
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    tags: number[] | undefined;
    horizontalEvolution: boolean;

    constructor(data?: IUpdateMedicalRecordFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.horizontalEvolution = _data["horizontalEvolution"];
        }
    }

    static fromJS(data: any): UpdateMedicalRecordFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicalRecordFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["horizontalEvolution"] = this.horizontalEvolution;
        return data; 
    }

    clone(): UpdateMedicalRecordFormCommand {
        const json = this.toJSON();
        let result = new UpdateMedicalRecordFormCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicalRecordFormCommand {
    id: string;
    title: string | undefined;
    description: string | undefined;
    /** Form json definition */
    definition: string | undefined;
    tags: number[] | undefined;
    horizontalEvolution: boolean;
}

export class MedicalSpecialtyTranslationDto implements IMedicalSpecialtyTranslationDto {
    name: string | undefined;
    language: string | undefined;
    id: string;

    constructor(data?: IMedicalSpecialtyTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.language = _data["language"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalSpecialtyTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalSpecialtyTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["language"] = this.language;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalSpecialtyTranslationDto {
        const json = this.toJSON();
        let result = new MedicalSpecialtyTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalSpecialtyTranslationDto {
    name: string | undefined;
    language: string | undefined;
    id: string;
}

export class MedicalSpecialtyDto implements IMedicalSpecialtyDto {
    translations: MedicalSpecialtyTranslationDto[] | undefined;
    appointmentDuration: MedicalAppointmentDurationDto;
    id: string;

    constructor(data?: IMedicalSpecialtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations.push(MedicalSpecialtyTranslationDto.fromJS(item));
            }
            this.appointmentDuration = _data["appointmentDuration"] ? MedicalAppointmentDurationDto.fromJS(_data["appointmentDuration"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalSpecialtyDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalSpecialtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["appointmentDuration"] = this.appointmentDuration ? this.appointmentDuration.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalSpecialtyDto {
        const json = this.toJSON();
        let result = new MedicalSpecialtyDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalSpecialtyDto {
    translations: MedicalSpecialtyTranslationDto[] | undefined;
    appointmentDuration: MedicalAppointmentDurationDto;
    id: string;
}

export class FindSpecialtiesRequest implements IFindSpecialtiesRequest {
    sorting: string | undefined;

    constructor(data?: IFindSpecialtiesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): FindSpecialtiesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FindSpecialtiesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        return data; 
    }

    clone(): FindSpecialtiesRequest {
        const json = this.toJSON();
        let result = new FindSpecialtiesRequest();
        result.init(json);
        return result;
    }
}

export interface IFindSpecialtiesRequest {
    sorting: string | undefined;
}

export class SimpleMedicalAppointmentDuration implements ISimpleMedicalAppointmentDuration {
    duration: number;
    price: number;
    id: string;

    constructor(data?: ISimpleMedicalAppointmentDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SimpleMedicalAppointmentDuration {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleMedicalAppointmentDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["id"] = this.id;
        return data; 
    }

    clone(): SimpleMedicalAppointmentDuration {
        const json = this.toJSON();
        let result = new SimpleMedicalAppointmentDuration();
        result.init(json);
        return result;
    }
}

export interface ISimpleMedicalAppointmentDuration {
    duration: number;
    price: number;
    id: string;
}

export class SimpleMedicalSpecialty implements ISimpleMedicalSpecialty {
    name: string | undefined;
    appointmentDuration: SimpleMedicalAppointmentDuration;
    id: string;

    constructor(data?: ISimpleMedicalSpecialty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.appointmentDuration = _data["appointmentDuration"] ? SimpleMedicalAppointmentDuration.fromJS(_data["appointmentDuration"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SimpleMedicalSpecialty {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleMedicalSpecialty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["appointmentDuration"] = this.appointmentDuration ? this.appointmentDuration.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): SimpleMedicalSpecialty {
        const json = this.toJSON();
        let result = new SimpleMedicalSpecialty();
        result.init(json);
        return result;
    }
}

export interface ISimpleMedicalSpecialty {
    name: string | undefined;
    appointmentDuration: SimpleMedicalAppointmentDuration;
    id: string;
}

export class MedicalSpecialtyDtoPagedResultDto implements IMedicalSpecialtyDtoPagedResultDto {
    totalCount: number;
    items: MedicalSpecialtyDto[] | undefined;

    constructor(data?: IMedicalSpecialtyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MedicalSpecialtyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicalSpecialtyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalSpecialtyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MedicalSpecialtyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicalSpecialtyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalSpecialtyDtoPagedResultDto {
    totalCount: number;
    items: MedicalSpecialtyDto[] | undefined;
}

export class CreateMedicalSpecialtyTranslationDto implements ICreateMedicalSpecialtyTranslationDto {
    name: string | undefined;
    language: string | undefined;

    constructor(data?: ICreateMedicalSpecialtyTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): CreateMedicalSpecialtyTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalSpecialtyTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["language"] = this.language;
        return data; 
    }

    clone(): CreateMedicalSpecialtyTranslationDto {
        const json = this.toJSON();
        let result = new CreateMedicalSpecialtyTranslationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalSpecialtyTranslationDto {
    name: string | undefined;
    language: string | undefined;
}

export class CreateMedicalAppointmentDurationDto implements ICreateMedicalAppointmentDurationDto {
    medicalSpecialty: number;
    duration: number;
    price: number;

    constructor(data?: ICreateMedicalAppointmentDurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalSpecialty = _data["medicalSpecialty"];
            this.duration = _data["duration"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CreateMedicalAppointmentDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalAppointmentDurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalSpecialty"] = this.medicalSpecialty;
        data["duration"] = this.duration;
        data["price"] = this.price;
        return data; 
    }

    clone(): CreateMedicalAppointmentDurationDto {
        const json = this.toJSON();
        let result = new CreateMedicalAppointmentDurationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalAppointmentDurationDto {
    medicalSpecialty: number;
    duration: number;
    price: number;
}

export class CreateMedicalSpecialtyDto implements ICreateMedicalSpecialtyDto {
    translations: CreateMedicalSpecialtyTranslationDto[] | undefined;
    appointmentDuration: CreateMedicalAppointmentDurationDto;

    constructor(data?: ICreateMedicalSpecialtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations.push(CreateMedicalSpecialtyTranslationDto.fromJS(item));
            }
            this.appointmentDuration = _data["appointmentDuration"] ? CreateMedicalAppointmentDurationDto.fromJS(_data["appointmentDuration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMedicalSpecialtyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalSpecialtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["appointmentDuration"] = this.appointmentDuration ? this.appointmentDuration.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CreateMedicalSpecialtyDto {
        const json = this.toJSON();
        let result = new CreateMedicalSpecialtyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalSpecialtyDto {
    translations: CreateMedicalSpecialtyTranslationDto[] | undefined;
    appointmentDuration: CreateMedicalAppointmentDurationDto;
}

export class GetMedicationDoseConfiguration implements IGetMedicationDoseConfiguration {
    title: string | undefined;
    message: string | undefined;

    constructor(data?: IGetMedicationDoseConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): GetMedicationDoseConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicationDoseConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["message"] = this.message;
        return data; 
    }

    clone(): GetMedicationDoseConfiguration {
        const json = this.toJSON();
        let result = new GetMedicationDoseConfiguration();
        result.init(json);
        return result;
    }
}

export interface IGetMedicationDoseConfiguration {
    title: string | undefined;
    message: string | undefined;
}

export enum PeriodUnit {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _10 = 10,
}

export class Period implements IPeriod {
    value: number | undefined;
    unit: PeriodUnit;

    constructor(data?: IPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Period {
        data = typeof data === 'object' ? data : {};
        let result = new Period();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data; 
    }

    clone(): Period {
        const json = this.toJSON();
        let result = new Period();
        result.init(json);
        return result;
    }
}

export interface IPeriod {
    value: number | undefined;
    unit: PeriodUnit;
}

export class MedicationInfoDto implements IMedicationInfoDto {
    drugDescriptionAndDosage: string | undefined;
    period: Period;
    frequency: Period;
    needsSpecialPrescription: boolean;
    continuousUsage: boolean;
    usageInstruction: string | undefined;
    startDate: moment.Moment;
    id: string;

    constructor(data?: IMedicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.drugDescriptionAndDosage = _data["drugDescriptionAndDosage"];
            this.period = _data["period"] ? Period.fromJS(_data["period"]) : <any>undefined;
            this.frequency = _data["frequency"] ? Period.fromJS(_data["frequency"]) : <any>undefined;
            this.needsSpecialPrescription = _data["needsSpecialPrescription"];
            this.continuousUsage = _data["continuousUsage"];
            this.usageInstruction = _data["usageInstruction"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["drugDescriptionAndDosage"] = this.drugDescriptionAndDosage;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["needsSpecialPrescription"] = this.needsSpecialPrescription;
        data["continuousUsage"] = this.continuousUsage;
        data["usageInstruction"] = this.usageInstruction;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicationInfoDto {
        const json = this.toJSON();
        let result = new MedicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationInfoDto {
    drugDescriptionAndDosage: string | undefined;
    period: Period;
    frequency: Period;
    needsSpecialPrescription: boolean;
    continuousUsage: boolean;
    usageInstruction: string | undefined;
    startDate: moment.Moment;
    id: string;
}

export class NoteDocumentDto implements INoteDocumentDto {
    fileId: string;
    name: string | undefined;
    link: string | undefined;
    id: number;

    constructor(data?: INoteDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.link = _data["link"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NoteDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["link"] = this.link;
        data["id"] = this.id;
        return data; 
    }

    clone(): NoteDocumentDto {
        const json = this.toJSON();
        let result = new NoteDocumentDto();
        result.init(json);
        return result;
    }
}

export interface INoteDocumentDto {
    fileId: string;
    name: string | undefined;
    link: string | undefined;
    id: number;
}

export class NoteDraft implements INoteDraft {
    text: string | undefined;
    date: moment.Moment;
    documents: NoteDocumentDto[] | undefined;
    parentId: string | undefined;
    id: string;

    constructor(data?: INoteDraft) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents.push(NoteDocumentDto.fromJS(item));
            }
            this.parentId = _data["parentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NoteDraft {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDraft();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        return data; 
    }

    clone(): NoteDraft {
        const json = this.toJSON();
        let result = new NoteDraft();
        result.init(json);
        return result;
    }
}

export interface INoteDraft {
    text: string | undefined;
    date: moment.Moment;
    documents: NoteDocumentDto[] | undefined;
    parentId: string | undefined;
    id: string;
}

export class NoteDto implements INoteDto {
    text: string | undefined;
    creator: DoctorDto;
    doctorId: string;
    patientId: string;
    patient: PatientDto;
    date: moment.Moment;
    documents: NoteDocumentDto[] | undefined;
    draftId: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.creator = _data["creator"] ? DoctorDto.fromJS(_data["creator"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.patientId = _data["patientId"];
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents.push(NoteDocumentDto.fromJS(item));
            }
            this.draftId = _data["draftId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["patientId"] = this.patientId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["draftId"] = this.draftId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): NoteDto {
        const json = this.toJSON();
        let result = new NoteDto();
        result.init(json);
        return result;
    }
}

export interface INoteDto {
    text: string | undefined;
    creator: DoctorDto;
    doctorId: string;
    patientId: string;
    patient: PatientDto;
    date: moment.Moment;
    documents: NoteDocumentDto[] | undefined;
    draftId: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ExportNotesRequest implements IExportNotesRequest {
    patientId: string;

    constructor(data?: IExportNotesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): ExportNotesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportNotesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        return data; 
    }

    clone(): ExportNotesRequest {
        const json = this.toJSON();
        let result = new ExportNotesRequest();
        result.init(json);
        return result;
    }
}

export interface IExportNotesRequest {
    patientId: string;
}

export class Icd implements IIcd {
    subCategoryId: string | undefined;
    title: string | undefined;
    classification: string | undefined;
    genderRestriction: string | undefined;
    causeDeath: string | undefined;
    reference: string | undefined;
    excluded: string | undefined;

    constructor(data?: IIcd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategoryId = _data["subCategoryId"];
            this.title = _data["title"];
            this.classification = _data["classification"];
            this.genderRestriction = _data["genderRestriction"];
            this.causeDeath = _data["causeDeath"];
            this.reference = _data["reference"];
            this.excluded = _data["excluded"];
        }
    }

    static fromJS(data: any): Icd {
        data = typeof data === 'object' ? data : {};
        let result = new Icd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategoryId"] = this.subCategoryId;
        data["title"] = this.title;
        data["classification"] = this.classification;
        data["genderRestriction"] = this.genderRestriction;
        data["causeDeath"] = this.causeDeath;
        data["reference"] = this.reference;
        data["excluded"] = this.excluded;
        return data; 
    }

    clone(): Icd {
        const json = this.toJSON();
        let result = new Icd();
        result.init(json);
        return result;
    }
}

export interface IIcd {
    subCategoryId: string | undefined;
    title: string | undefined;
    classification: string | undefined;
    genderRestriction: string | undefined;
    causeDeath: string | undefined;
    reference: string | undefined;
    excluded: string | undefined;
}

export class NotificationSettingsResponse implements INotificationSettingsResponse {
    allowScheduleNotifications: boolean;
    allowPreFormResponseNotifications: boolean;

    constructor(data?: INotificationSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowScheduleNotifications = _data["allowScheduleNotifications"];
            this.allowPreFormResponseNotifications = _data["allowPreFormResponseNotifications"];
        }
    }

    static fromJS(data: any): NotificationSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowScheduleNotifications"] = this.allowScheduleNotifications;
        data["allowPreFormResponseNotifications"] = this.allowPreFormResponseNotifications;
        return data; 
    }

    clone(): NotificationSettingsResponse {
        const json = this.toJSON();
        let result = new NotificationSettingsResponse();
        result.init(json);
        return result;
    }
}

export interface INotificationSettingsResponse {
    allowScheduleNotifications: boolean;
    allowPreFormResponseNotifications: boolean;
}

export class NotificationSettingsRequest implements INotificationSettingsRequest {
    allowScheduleNotifications: boolean;
    allowPreFormResponseNotifications: boolean;

    constructor(data?: INotificationSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowScheduleNotifications = _data["allowScheduleNotifications"];
            this.allowPreFormResponseNotifications = _data["allowPreFormResponseNotifications"];
        }
    }

    static fromJS(data: any): NotificationSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowScheduleNotifications"] = this.allowScheduleNotifications;
        data["allowPreFormResponseNotifications"] = this.allowPreFormResponseNotifications;
        return data; 
    }

    clone(): NotificationSettingsRequest {
        const json = this.toJSON();
        let result = new NotificationSettingsRequest();
        result.init(json);
        return result;
    }
}

export interface INotificationSettingsRequest {
    allowScheduleNotifications: boolean;
    allowPreFormResponseNotifications: boolean;
}

export class GetRecentNotificationsResult implements IGetRecentNotificationsResult {
    unread: number;
    maxNumberOfRecentNotifications: number;
    notifications: any[] | undefined;

    constructor(data?: IGetRecentNotificationsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unread = _data["unread"];
            this.maxNumberOfRecentNotifications = _data["maxNumberOfRecentNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications.push(item);
            }
        }
    }

    static fromJS(data: any): GetRecentNotificationsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentNotificationsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unread"] = this.unread;
        data["maxNumberOfRecentNotifications"] = this.maxNumberOfRecentNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item);
        }
        return data; 
    }

    clone(): GetRecentNotificationsResult {
        const json = this.toJSON();
        let result = new GetRecentNotificationsResult();
        result.init(json);
        return result;
    }
}

export interface IGetRecentNotificationsResult {
    unread: number;
    maxNumberOfRecentNotifications: number;
    notifications: any[] | undefined;
}

export class ResponseNotificationDto implements IResponseNotificationDto {
    notifications: any[] | undefined;
    countUnread: number;

    constructor(data?: IResponseNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications.push(item);
            }
            this.countUnread = _data["countUnread"];
        }
    }

    static fromJS(data: any): ResponseNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item);
        }
        data["countUnread"] = this.countUnread;
        return data; 
    }

    clone(): ResponseNotificationDto {
        const json = this.toJSON();
        let result = new ResponseNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IResponseNotificationDto {
    notifications: any[] | undefined;
    countUnread: number;
}

export class ObjectPagedResultDto implements IObjectPagedResultDto {
    totalCount: number;
    items: any[] | undefined;

    constructor(data?: IObjectPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(item);
            }
        }
    }

    static fromJS(data: any): ObjectPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data; 
    }

    clone(): ObjectPagedResultDto {
        const json = this.toJSON();
        let result = new ObjectPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IObjectPagedResultDto {
    totalCount: number;
    items: any[] | undefined;
}

export enum UserNotificationState {
    _0 = 0,
    _1 = 1,
}

export class NotificationData implements INotificationData {
    readonly type: string | undefined;
    properties: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)[key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key];
            }
        }
        return data; 
    }

    clone(): NotificationData {
        const json = this.toJSON();
        let result = new NotificationData();
        result.init(json);
        return result;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class TenantNotification implements ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantNotification {
        const json = this.toJSON();
        let result = new TenantNotification();
        result.init(json);
        return result;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class UserNotification implements IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserNotification {
        const json = this.toJSON();
        let result = new UserNotification();
        result.init(json);
        return result;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class PatientRegistrationSettings implements IPatientRegistrationSettings {
    agreementTitle: string | undefined;
    agreementDocumentUrl: string | undefined;
    standardAgreementTitle: string | undefined;
    standardAgreementDocumentUrl: string | undefined;
    readonly configured: boolean;
    patientProfessionalRelationshipRuleEnabled: boolean;
    allowEnabledSequentialNumber: boolean;
    sequentialNumberEnabled: boolean;
    sequentialNumberInitialValue: number;
    restrictUniquenessByPersonalIdentifier: boolean;

    constructor(data?: IPatientRegistrationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreementTitle = _data["agreementTitle"];
            this.agreementDocumentUrl = _data["agreementDocumentUrl"];
            this.standardAgreementTitle = _data["standardAgreementTitle"];
            this.standardAgreementDocumentUrl = _data["standardAgreementDocumentUrl"];
            (<any>this).configured = _data["configured"];
            this.patientProfessionalRelationshipRuleEnabled = _data["patientProfessionalRelationshipRuleEnabled"];
            this.allowEnabledSequentialNumber = _data["allowEnabledSequentialNumber"];
            this.sequentialNumberEnabled = _data["sequentialNumberEnabled"];
            this.sequentialNumberInitialValue = _data["sequentialNumberInitialValue"];
            this.restrictUniquenessByPersonalIdentifier = _data["restrictUniquenessByPersonalIdentifier"];
        }
    }

    static fromJS(data: any): PatientRegistrationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PatientRegistrationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementTitle"] = this.agreementTitle;
        data["agreementDocumentUrl"] = this.agreementDocumentUrl;
        data["standardAgreementTitle"] = this.standardAgreementTitle;
        data["standardAgreementDocumentUrl"] = this.standardAgreementDocumentUrl;
        data["configured"] = this.configured;
        data["patientProfessionalRelationshipRuleEnabled"] = this.patientProfessionalRelationshipRuleEnabled;
        data["allowEnabledSequentialNumber"] = this.allowEnabledSequentialNumber;
        data["sequentialNumberEnabled"] = this.sequentialNumberEnabled;
        data["sequentialNumberInitialValue"] = this.sequentialNumberInitialValue;
        data["restrictUniquenessByPersonalIdentifier"] = this.restrictUniquenessByPersonalIdentifier;
        return data; 
    }

    clone(): PatientRegistrationSettings {
        const json = this.toJSON();
        let result = new PatientRegistrationSettings();
        result.init(json);
        return result;
    }
}

export interface IPatientRegistrationSettings {
    agreementTitle: string | undefined;
    agreementDocumentUrl: string | undefined;
    standardAgreementTitle: string | undefined;
    standardAgreementDocumentUrl: string | undefined;
    configured: boolean;
    patientProfessionalRelationshipRuleEnabled: boolean;
    allowEnabledSequentialNumber: boolean;
    sequentialNumberEnabled: boolean;
    sequentialNumberInitialValue: number;
    restrictUniquenessByPersonalIdentifier: boolean;
}

export class DeletedPatient implements IDeletedPatient {
    id: string;
    name: string | undefined;
    personalIdentifier: string | undefined;
    email: string | undefined;
    birthday: moment.Moment | undefined;

    constructor(data?: IDeletedPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.email = _data["email"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeletedPatient {
        data = typeof data === 'object' ? data : {};
        let result = new DeletedPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["personalIdentifier"] = this.personalIdentifier;
        data["email"] = this.email;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        return data; 
    }

    clone(): DeletedPatient {
        const json = this.toJSON();
        let result = new DeletedPatient();
        result.init(json);
        return result;
    }
}

export interface IDeletedPatient {
    id: string;
    name: string | undefined;
    personalIdentifier: string | undefined;
    email: string | undefined;
    birthday: moment.Moment | undefined;
}

export class GetDeletedPatientsQueryResult implements IGetDeletedPatientsQueryResult {
    totalCount: number;
    items: DeletedPatient[] | undefined;

    constructor(data?: IGetDeletedPatientsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DeletedPatient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeletedPatientsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeletedPatientsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetDeletedPatientsQueryResult {
        const json = this.toJSON();
        let result = new GetDeletedPatientsQueryResult();
        result.init(json);
        return result;
    }
}

export interface IGetDeletedPatientsQueryResult {
    totalCount: number;
    items: DeletedPatient[] | undefined;
}

export class UpdatePatientPhotoRequest implements IUpdatePatientPhotoRequest {
    id: string;
    path: string | undefined;

    constructor(data?: IUpdatePatientPhotoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): UpdatePatientPhotoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientPhotoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["path"] = this.path;
        return data; 
    }

    clone(): UpdatePatientPhotoRequest {
        const json = this.toJSON();
        let result = new UpdatePatientPhotoRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientPhotoRequest {
    id: string;
    path: string | undefined;
}

export enum PeriodFilter {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetBirthdaysRequest implements IGetBirthdaysRequest {
    reference: moment.Moment;
    filter: PeriodFilter;

    constructor(data?: IGetBirthdaysRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"] ? moment(_data["reference"].toString()) : <any>undefined;
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): GetBirthdaysRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetBirthdaysRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference ? this.reference.toISOString() : <any>undefined;
        data["filter"] = this.filter;
        return data; 
    }

    clone(): GetBirthdaysRequest {
        const json = this.toJSON();
        let result = new GetBirthdaysRequest();
        result.init(json);
        return result;
    }
}

export interface IGetBirthdaysRequest {
    reference: moment.Moment;
    filter: PeriodFilter;
}

export class GetBirthdaysDto implements IGetBirthdaysDto {
    id: string;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    name: string | undefined;
    phone: string | undefined;

    constructor(data?: IGetBirthdaysDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GetBirthdaysDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBirthdaysDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        return data; 
    }

    clone(): GetBirthdaysDto {
        const json = this.toJSON();
        let result = new GetBirthdaysDto();
        result.init(json);
        return result;
    }
}

export interface IGetBirthdaysDto {
    id: string;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    name: string | undefined;
    phone: string | undefined;
}

export class ExportBirthdaysRequest implements IExportBirthdaysRequest {
    reference: moment.Moment;
    filter: PeriodFilter;

    constructor(data?: IExportBirthdaysRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"] ? moment(_data["reference"].toString()) : <any>undefined;
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): ExportBirthdaysRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportBirthdaysRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference ? this.reference.toISOString() : <any>undefined;
        data["filter"] = this.filter;
        return data; 
    }

    clone(): ExportBirthdaysRequest {
        const json = this.toJSON();
        let result = new ExportBirthdaysRequest();
        result.init(json);
        return result;
    }
}

export interface IExportBirthdaysRequest {
    reference: moment.Moment;
    filter: PeriodFilter;
}

export class GetSidebarSettingsResponse implements IGetSidebarSettingsResponse {
    sequentialNumberEnabled: boolean;
    sorting: string | undefined;
    showSequentialNumber: boolean;

    constructor(data?: IGetSidebarSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequentialNumberEnabled = _data["sequentialNumberEnabled"];
            this.sorting = _data["sorting"];
            this.showSequentialNumber = _data["showSequentialNumber"];
        }
    }

    static fromJS(data: any): GetSidebarSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSidebarSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequentialNumberEnabled"] = this.sequentialNumberEnabled;
        data["sorting"] = this.sorting;
        data["showSequentialNumber"] = this.showSequentialNumber;
        return data; 
    }

    clone(): GetSidebarSettingsResponse {
        const json = this.toJSON();
        let result = new GetSidebarSettingsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSidebarSettingsResponse {
    sequentialNumberEnabled: boolean;
    sorting: string | undefined;
    showSequentialNumber: boolean;
}

export class AddTagRequest implements IAddTagRequest {
    patientId: string;
    tag: string | undefined;

    constructor(data?: IAddTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): AddTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["tag"] = this.tag;
        return data; 
    }

    clone(): AddTagRequest {
        const json = this.toJSON();
        let result = new AddTagRequest();
        result.init(json);
        return result;
    }
}

export interface IAddTagRequest {
    patientId: string;
    tag: string | undefined;
}

export class TagDto implements ITagDto {
    name: string | undefined;
    identifier: number;
    id: number;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["id"] = this.id;
        return data; 
    }

    clone(): TagDto {
        const json = this.toJSON();
        let result = new TagDto();
        result.init(json);
        return result;
    }
}

export interface ITagDto {
    name: string | undefined;
    identifier: number;
    id: number;
}

export class RenameTagRequest implements IRenameTagRequest {
    id: number;
    name: string | undefined;

    constructor(data?: IRenameTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): RenameTagRequest {
        const json = this.toJSON();
        let result = new RenameTagRequest();
        result.init(json);
        return result;
    }
}

export interface IRenameTagRequest {
    id: number;
    name: string | undefined;
}

export class ExportInput implements IExportInput {
    format: string | undefined;
    keyword: string | undefined;

    constructor(data?: IExportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.format = _data["format"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): ExportInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        data["keyword"] = this.keyword;
        return data; 
    }

    clone(): ExportInput {
        const json = this.toJSON();
        let result = new ExportInput();
        result.init(json);
        return result;
    }
}

export interface IExportInput {
    format: string | undefined;
    keyword: string | undefined;
}

export class GetImportPatientExcelTemplateResult implements IGetImportPatientExcelTemplateResult {
    url: string | undefined;

    constructor(data?: IGetImportPatientExcelTemplateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetImportPatientExcelTemplateResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetImportPatientExcelTemplateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data; 
    }

    clone(): GetImportPatientExcelTemplateResult {
        const json = this.toJSON();
        let result = new GetImportPatientExcelTemplateResult();
        result.init(json);
        return result;
    }
}

export interface IGetImportPatientExcelTemplateResult {
    url: string | undefined;
}

export class ImportPatientsFromExcelTemplateResult implements IImportPatientsFromExcelTemplateResult {

    constructor(data?: IImportPatientsFromExcelTemplateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ImportPatientsFromExcelTemplateResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportPatientsFromExcelTemplateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): ImportPatientsFromExcelTemplateResult {
        const json = this.toJSON();
        let result = new ImportPatientsFromExcelTemplateResult();
        result.init(json);
        return result;
    }
}

export interface IImportPatientsFromExcelTemplateResult {
}

export class PatientSearchResult implements IPatientSearchResult {
    id: string;
    name: string | undefined;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    gender: number;
    insurance: PatientInsurance;
    sequentialNumber: number;

    constructor(data?: IPatientSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.dni = _data["dni"];
            this.gender = _data["gender"];
            this.insurance = _data["insurance"] ? PatientInsurance.fromJS(_data["insurance"]) : <any>undefined;
            this.sequentialNumber = _data["sequentialNumber"];
        }
    }

    static fromJS(data: any): PatientSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["personalIdentifier"] = this.personalIdentifier;
        data["dni"] = this.dni;
        data["gender"] = this.gender;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>undefined;
        data["sequentialNumber"] = this.sequentialNumber;
        return data; 
    }

    clone(): PatientSearchResult {
        const json = this.toJSON();
        let result = new PatientSearchResult();
        result.init(json);
        return result;
    }
}

export interface IPatientSearchResult {
    id: string;
    name: string | undefined;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    gender: number;
    insurance: PatientInsurance;
    sequentialNumber: number;
}

export class FormFieldFilter implements IFormFieldFilter {
    id: string | undefined;
    operator: string | undefined;
    value: string | undefined;

    constructor(data?: IFormFieldFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operator = _data["operator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FormFieldFilter {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operator"] = this.operator;
        data["value"] = this.value;
        return data; 
    }

    clone(): FormFieldFilter {
        const json = this.toJSON();
        let result = new FormFieldFilter();
        result.init(json);
        return result;
    }
}

export interface IFormFieldFilter {
    id: string | undefined;
    operator: string | undefined;
    value: string | undefined;
}

export class FormFilter implements IFormFilter {
    id: number;
    operator: string | undefined;
    fields: FormFieldFilter[] | undefined;

    constructor(data?: IFormFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operator = _data["operator"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields.push(FormFieldFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormFilter {
        data = typeof data === 'object' ? data : {};
        let result = new FormFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operator"] = this.operator;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormFilter {
        const json = this.toJSON();
        let result = new FormFilter();
        result.init(json);
        return result;
    }
}

export interface IFormFilter {
    id: number;
    operator: string | undefined;
    fields: FormFieldFilter[] | undefined;
}

export enum PatientStatusFilter {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetPatientsRequest implements IGetPatientsRequest {
    keyword: string | undefined;
    formFilter: FormFilter;
    status: PatientStatusFilter;
    insurancePlans: number[] | undefined;
    insuranceCompanies: number[] | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetPatientsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.formFilter = _data["formFilter"] ? FormFilter.fromJS(_data["formFilter"]) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans.push(item);
            }
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies.push(item);
            }
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetPatientsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["formFilter"] = this.formFilter ? this.formFilter.toJSON() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item);
        }
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item);
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetPatientsRequest {
        const json = this.toJSON();
        let result = new GetPatientsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPatientsRequest {
    keyword: string | undefined;
    formFilter: FormFilter;
    status: PatientStatusFilter;
    insurancePlans: number[] | undefined;
    insuranceCompanies: number[] | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class PatientDtoPagedResultDto implements IPatientDtoPagedResultDto {
    totalCount: number;
    items: PatientDto[] | undefined;

    constructor(data?: IPatientDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PatientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PatientDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDtoPagedResultDto {
    totalCount: number;
    items: PatientDto[] | undefined;
}

export class CreatePatientRequest implements ICreatePatientRequest {
    id: string;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    name: string | undefined;
    gender: number;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    password: string | undefined;
    phone: string | undefined;
    bloodType: string | undefined;
    weight: string | undefined;
    height: string | undefined;
    address: Address;
    comments: string | undefined;
    birthInfo: BirthInfoData;
    mother: PersonData;
    father: PersonData;
    partner: PersonData;
    sponsor: PersonData;
    tags: number[] | undefined;
    insurance: PatientInsurance;
    profession: string | undefined;
    photo: string | undefined;

    constructor(data?: ICreatePatientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.dni = _data["dni"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.password = _data["password"];
            this.phone = _data["phone"];
            this.bloodType = _data["bloodType"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.comments = _data["comments"];
            this.birthInfo = _data["birthInfo"] ? BirthInfoData.fromJS(_data["birthInfo"]) : <any>undefined;
            this.mother = _data["mother"] ? PersonData.fromJS(_data["mother"]) : <any>undefined;
            this.father = _data["father"] ? PersonData.fromJS(_data["father"]) : <any>undefined;
            this.partner = _data["partner"] ? PersonData.fromJS(_data["partner"]) : <any>undefined;
            this.sponsor = _data["sponsor"] ? PersonData.fromJS(_data["sponsor"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.insurance = _data["insurance"] ? PatientInsurance.fromJS(_data["insurance"]) : <any>undefined;
            this.profession = _data["profession"];
            this.photo = _data["photo"];
        }
    }

    static fromJS(data: any): CreatePatientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personalIdentifier"] = this.personalIdentifier;
        data["dni"] = this.dni;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["password"] = this.password;
        data["phone"] = this.phone;
        data["bloodType"] = this.bloodType;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        data["birthInfo"] = this.birthInfo ? this.birthInfo.toJSON() : <any>undefined;
        data["mother"] = this.mother ? this.mother.toJSON() : <any>undefined;
        data["father"] = this.father ? this.father.toJSON() : <any>undefined;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        data["sponsor"] = this.sponsor ? this.sponsor.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>undefined;
        data["profession"] = this.profession;
        data["photo"] = this.photo;
        return data; 
    }

    clone(): CreatePatientRequest {
        const json = this.toJSON();
        let result = new CreatePatientRequest();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientRequest {
    id: string;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    name: string | undefined;
    gender: number;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    password: string | undefined;
    phone: string | undefined;
    bloodType: string | undefined;
    weight: string | undefined;
    height: string | undefined;
    address: Address;
    comments: string | undefined;
    birthInfo: BirthInfoData;
    mother: PersonData;
    father: PersonData;
    partner: PersonData;
    sponsor: PersonData;
    tags: number[] | undefined;
    insurance: PatientInsurance;
    profession: string | undefined;
    photo: string | undefined;
}

export class UpdatePatientRequest implements IUpdatePatientRequest {
    personalIdentifier: string | undefined;
    dni: string | undefined;
    name: string | undefined;
    gender: number;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    phone: string | undefined;
    bloodType: string | undefined;
    weight: string | undefined;
    height: string | undefined;
    address: Address;
    comments: string | undefined;
    birthInfo: BirthInfoData;
    mother: PersonData;
    father: PersonData;
    partner: PersonData;
    sponsor: PersonData;
    status: PatientStatus;
    insurance: PatientInsurance;
    profession: string | undefined;
    id: string;

    constructor(data?: IUpdatePatientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalIdentifier = _data["personalIdentifier"];
            this.dni = _data["dni"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.bloodType = _data["bloodType"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.comments = _data["comments"];
            this.birthInfo = _data["birthInfo"] ? BirthInfoData.fromJS(_data["birthInfo"]) : <any>undefined;
            this.mother = _data["mother"] ? PersonData.fromJS(_data["mother"]) : <any>undefined;
            this.father = _data["father"] ? PersonData.fromJS(_data["father"]) : <any>undefined;
            this.partner = _data["partner"] ? PersonData.fromJS(_data["partner"]) : <any>undefined;
            this.sponsor = _data["sponsor"] ? PersonData.fromJS(_data["sponsor"]) : <any>undefined;
            this.status = _data["status"];
            this.insurance = _data["insurance"] ? PatientInsurance.fromJS(_data["insurance"]) : <any>undefined;
            this.profession = _data["profession"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePatientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalIdentifier"] = this.personalIdentifier;
        data["dni"] = this.dni;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["bloodType"] = this.bloodType;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        data["birthInfo"] = this.birthInfo ? this.birthInfo.toJSON() : <any>undefined;
        data["mother"] = this.mother ? this.mother.toJSON() : <any>undefined;
        data["father"] = this.father ? this.father.toJSON() : <any>undefined;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        data["sponsor"] = this.sponsor ? this.sponsor.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>undefined;
        data["profession"] = this.profession;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdatePatientRequest {
        const json = this.toJSON();
        let result = new UpdatePatientRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientRequest {
    personalIdentifier: string | undefined;
    dni: string | undefined;
    name: string | undefined;
    gender: number;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    phone: string | undefined;
    bloodType: string | undefined;
    weight: string | undefined;
    height: string | undefined;
    address: Address;
    comments: string | undefined;
    birthInfo: BirthInfoData;
    mother: PersonData;
    father: PersonData;
    partner: PersonData;
    sponsor: PersonData;
    status: PatientStatus;
    insurance: PatientInsurance;
    profession: string | undefined;
    id: string;
}

export class UpdatePatientBasicDataInput implements IUpdatePatientBasicDataInput {
    personalIdentifier: string | undefined;
    dni: string | undefined;
    address: Address;
    birthday: moment.Moment | undefined;

    constructor(data?: IUpdatePatientBasicDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalIdentifier = _data["personalIdentifier"];
            this.dni = _data["dni"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePatientBasicDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientBasicDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalIdentifier"] = this.personalIdentifier;
        data["dni"] = this.dni;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        return data; 
    }

    clone(): UpdatePatientBasicDataInput {
        const json = this.toJSON();
        let result = new UpdatePatientBasicDataInput();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientBasicDataInput {
    personalIdentifier: string | undefined;
    dni: string | undefined;
    address: Address;
    birthday: moment.Moment | undefined;
}

export class PatientInvitationCompletionModel implements IPatientInvitationCompletionModel {
    readonly componentName: string | undefined;
    readonly autoLogin: boolean;
    patientId: string;
    metadata: string | undefined;
    updatePatientRequest: UpdatePatientRequest;
    invitationId: string;
    tenantId: number;
    userId: number | undefined;
    invitedUserEmail: string | undefined;
    invitedUserPhone: string | undefined;
    invitedUserName: string | undefined;
    ownerName: string | undefined;
    redirectToLogin: boolean;

    constructor(data?: IPatientInvitationCompletionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).componentName = _data["componentName"];
            (<any>this).autoLogin = _data["autoLogin"];
            this.patientId = _data["patientId"];
            this.metadata = _data["metadata"];
            this.updatePatientRequest = _data["updatePatientRequest"] ? UpdatePatientRequest.fromJS(_data["updatePatientRequest"]) : <any>undefined;
            this.invitationId = _data["invitationId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.invitedUserEmail = _data["invitedUserEmail"];
            this.invitedUserPhone = _data["invitedUserPhone"];
            this.invitedUserName = _data["invitedUserName"];
            this.ownerName = _data["ownerName"];
            this.redirectToLogin = _data["redirectToLogin"];
        }
    }

    static fromJS(data: any): PatientInvitationCompletionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInvitationCompletionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentName"] = this.componentName;
        data["autoLogin"] = this.autoLogin;
        data["patientId"] = this.patientId;
        data["metadata"] = this.metadata;
        data["updatePatientRequest"] = this.updatePatientRequest ? this.updatePatientRequest.toJSON() : <any>undefined;
        data["invitationId"] = this.invitationId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["invitedUserEmail"] = this.invitedUserEmail;
        data["invitedUserPhone"] = this.invitedUserPhone;
        data["invitedUserName"] = this.invitedUserName;
        data["ownerName"] = this.ownerName;
        data["redirectToLogin"] = this.redirectToLogin;
        return data; 
    }

    clone(): PatientInvitationCompletionModel {
        const json = this.toJSON();
        let result = new PatientInvitationCompletionModel();
        result.init(json);
        return result;
    }
}

export interface IPatientInvitationCompletionModel {
    componentName: string | undefined;
    autoLogin: boolean;
    patientId: string;
    metadata: string | undefined;
    updatePatientRequest: UpdatePatientRequest;
    invitationId: string;
    tenantId: number;
    userId: number | undefined;
    invitedUserEmail: string | undefined;
    invitedUserPhone: string | undefined;
    invitedUserName: string | undefined;
    ownerName: string | undefined;
    redirectToLogin: boolean;
}

export class MergePatientInput implements IMergePatientInput {
    tenantId: number;
    patients: string[] | undefined;
    into: string;

    constructor(data?: IMergePatientInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients.push(item);
            }
            this.into = _data["into"];
        }
    }

    static fromJS(data: any): MergePatientInput {
        data = typeof data === 'object' ? data : {};
        let result = new MergePatientInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item);
        }
        data["into"] = this.into;
        return data; 
    }

    clone(): MergePatientInput {
        const json = this.toJSON();
        let result = new MergePatientInput();
        result.init(json);
        return result;
    }
}

export interface IMergePatientInput {
    tenantId: number;
    patients: string[] | undefined;
    into: string;
}

export class RemoveTagModel implements IRemoveTagModel {
    patientId: string;
    identifier: number;

    constructor(data?: IRemoveTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): RemoveTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["identifier"] = this.identifier;
        return data; 
    }

    clone(): RemoveTagModel {
        const json = this.toJSON();
        let result = new RemoveTagModel();
        result.init(json);
        return result;
    }
}

export interface IRemoveTagModel {
    patientId: string;
    identifier: number;
}

export class GetExternalPostalCodeResult implements IGetExternalPostalCodeResult {
    code: string | undefined;
    address: string | undefined;
    reference: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    number: string | undefined;

    constructor(data?: IGetExternalPostalCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.address = _data["address"];
            this.reference = _data["reference"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): GetExternalPostalCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetExternalPostalCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["address"] = this.address;
        data["reference"] = this.reference;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["number"] = this.number;
        return data; 
    }

    clone(): GetExternalPostalCodeResult {
        const json = this.toJSON();
        let result = new GetExternalPostalCodeResult();
        result.init(json);
        return result;
    }
}

export interface IGetExternalPostalCodeResult {
    code: string | undefined;
    address: string | undefined;
    reference: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    number: string | undefined;
}

export class DownloadPregnancyCardRequest implements IDownloadPregnancyCardRequest {
    id: string;
    data: string | undefined;

    constructor(data?: IDownloadPregnancyCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DownloadPregnancyCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPregnancyCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        return data; 
    }

    clone(): DownloadPregnancyCardRequest {
        const json = this.toJSON();
        let result = new DownloadPregnancyCardRequest();
        result.init(json);
        return result;
    }
}

export interface IDownloadPregnancyCardRequest {
    id: string;
    data: string | undefined;
}

export class PregnancyModuleConfigurationModel implements IPregnancyModuleConfigurationModel {
    enabled: boolean;
    sendByEmail: boolean;

    constructor(data?: IPregnancyModuleConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.sendByEmail = _data["sendByEmail"];
        }
    }

    static fromJS(data: any): PregnancyModuleConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PregnancyModuleConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["sendByEmail"] = this.sendByEmail;
        return data; 
    }

    clone(): PregnancyModuleConfigurationModel {
        const json = this.toJSON();
        let result = new PregnancyModuleConfigurationModel();
        result.init(json);
        return result;
    }
}

export interface IPregnancyModuleConfigurationModel {
    enabled: boolean;
    sendByEmail: boolean;
}

export class FinalizePregnancyCardRequest implements IFinalizePregnancyCardRequest {
    id: string;
    data: string | undefined;

    constructor(data?: IFinalizePregnancyCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): FinalizePregnancyCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FinalizePregnancyCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        return data; 
    }

    clone(): FinalizePregnancyCardRequest {
        const json = this.toJSON();
        let result = new FinalizePregnancyCardRequest();
        result.init(json);
        return result;
    }
}

export interface IFinalizePregnancyCardRequest {
    id: string;
    data: string | undefined;
}

export class GetPregnancyCardResponse implements IGetPregnancyCardResponse {
    id: string | undefined;
    formId: number;
    definition: string | undefined;
    data: string | undefined;

    constructor(data?: IGetPregnancyCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formId = _data["formId"];
            this.definition = _data["definition"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GetPregnancyCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPregnancyCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formId"] = this.formId;
        data["definition"] = this.definition;
        data["data"] = this.data;
        return data; 
    }

    clone(): GetPregnancyCardResponse {
        const json = this.toJSON();
        let result = new GetPregnancyCardResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPregnancyCardResponse {
    id: string | undefined;
    formId: number;
    definition: string | undefined;
    data: string | undefined;
}

export class UpdatePregnancyCardRequest implements IUpdatePregnancyCardRequest {
    id: string;
    /** Json data */
    data: string | undefined;

    constructor(data?: IUpdatePregnancyCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UpdatePregnancyCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePregnancyCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        return data; 
    }

    clone(): UpdatePregnancyCardRequest {
        const json = this.toJSON();
        let result = new UpdatePregnancyCardRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePregnancyCardRequest {
    id: string;
    /** Json data */
    data: string | undefined;
}

export class CreatePregnancyFormDefinitionRequest implements ICreatePregnancyFormDefinitionRequest {
    tenantId: number | undefined;
    professionalId: string | undefined;
    definition: string | undefined;

    constructor(data?: ICreatePregnancyFormDefinitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.professionalId = _data["professionalId"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): CreatePregnancyFormDefinitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePregnancyFormDefinitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["professionalId"] = this.professionalId;
        data["definition"] = this.definition;
        return data; 
    }

    clone(): CreatePregnancyFormDefinitionRequest {
        const json = this.toJSON();
        let result = new CreatePregnancyFormDefinitionRequest();
        result.init(json);
        return result;
    }
}

export interface ICreatePregnancyFormDefinitionRequest {
    tenantId: number | undefined;
    professionalId: string | undefined;
    definition: string | undefined;
}

export class CreatePregnancyFormDefinitionResponse implements ICreatePregnancyFormDefinitionResponse {
    id: number;
    definition: string | undefined;
    htmlTemplate: string | undefined;

    constructor(data?: ICreatePregnancyFormDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.definition = _data["definition"];
            this.htmlTemplate = _data["htmlTemplate"];
        }
    }

    static fromJS(data: any): CreatePregnancyFormDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePregnancyFormDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["definition"] = this.definition;
        data["htmlTemplate"] = this.htmlTemplate;
        return data; 
    }

    clone(): CreatePregnancyFormDefinitionResponse {
        const json = this.toJSON();
        let result = new CreatePregnancyFormDefinitionResponse();
        result.init(json);
        return result;
    }
}

export interface ICreatePregnancyFormDefinitionResponse {
    id: number;
    definition: string | undefined;
    htmlTemplate: string | undefined;
}

export class GetPregnancyFormDefinitionResponse implements IGetPregnancyFormDefinitionResponse {
    id: number;
    definition: string | undefined;
    htmlTemplate: string | undefined;

    constructor(data?: IGetPregnancyFormDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.definition = _data["definition"];
            this.htmlTemplate = _data["htmlTemplate"];
        }
    }

    static fromJS(data: any): GetPregnancyFormDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPregnancyFormDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["definition"] = this.definition;
        data["htmlTemplate"] = this.htmlTemplate;
        return data; 
    }

    clone(): GetPregnancyFormDefinitionResponse {
        const json = this.toJSON();
        let result = new GetPregnancyFormDefinitionResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPregnancyFormDefinitionResponse {
    id: number;
    definition: string | undefined;
    htmlTemplate: string | undefined;
}

export class GetPrescriptionModelsQuery implements IGetPrescriptionModelsQuery {
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetPrescriptionModelsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetPrescriptionModelsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrescriptionModelsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetPrescriptionModelsQuery {
        const json = this.toJSON();
        let result = new GetPrescriptionModelsQuery();
        result.init(json);
        return result;
    }
}

export interface IGetPrescriptionModelsQuery {
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class MedicationModelDto implements IMedicationModelDto {
    prescriptionModelId: string;
    drugDescriptionAndDosage: string;
    period: Period;
    frequency: Period;
    usageInstruction: string | undefined;
    continuousUsage: boolean;
    needsSpecialPrescription: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IMedicationModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionModelId = _data["prescriptionModelId"];
            this.drugDescriptionAndDosage = _data["drugDescriptionAndDosage"];
            this.period = _data["period"] ? Period.fromJS(_data["period"]) : <any>undefined;
            this.frequency = _data["frequency"] ? Period.fromJS(_data["frequency"]) : <any>undefined;
            this.usageInstruction = _data["usageInstruction"];
            this.continuousUsage = _data["continuousUsage"];
            this.needsSpecialPrescription = _data["needsSpecialPrescription"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicationModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionModelId"] = this.prescriptionModelId;
        data["drugDescriptionAndDosage"] = this.drugDescriptionAndDosage;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["usageInstruction"] = this.usageInstruction;
        data["continuousUsage"] = this.continuousUsage;
        data["needsSpecialPrescription"] = this.needsSpecialPrescription;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicationModelDto {
        const json = this.toJSON();
        let result = new MedicationModelDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationModelDto {
    prescriptionModelId: string;
    drugDescriptionAndDosage: string;
    period: Period;
    frequency: Period;
    usageInstruction: string | undefined;
    continuousUsage: boolean;
    needsSpecialPrescription: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PrescriptionModelDto implements IPrescriptionModelDto {
    name: string | undefined;
    hint: string | undefined;
    medications: MedicationModelDto[] | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    allowDelete: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPrescriptionModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.hint = _data["hint"];
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications.push(MedicationModelDto.fromJS(item));
            }
            this.smart = _data["smart"];
            this.content = _data["content"];
            this.specialPrescription = _data["specialPrescription"];
            this.allowDelete = _data["allowDelete"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrescriptionModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["hint"] = this.hint;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item.toJSON());
        }
        data["smart"] = this.smart;
        data["content"] = this.content;
        data["specialPrescription"] = this.specialPrescription;
        data["allowDelete"] = this.allowDelete;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PrescriptionModelDto {
        const json = this.toJSON();
        let result = new PrescriptionModelDto();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionModelDto {
    name: string | undefined;
    hint: string | undefined;
    medications: MedicationModelDto[] | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    allowDelete: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PrescriptionModelDtoPagedResultDto implements IPrescriptionModelDtoPagedResultDto {
    totalCount: number;
    items: PrescriptionModelDto[] | undefined;

    constructor(data?: IPrescriptionModelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PrescriptionModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrescriptionModelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionModelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PrescriptionModelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PrescriptionModelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionModelDtoPagedResultDto {
    totalCount: number;
    items: PrescriptionModelDto[] | undefined;
}

export class UpdatePrescriptionCommentsOrderRequest implements IUpdatePrescriptionCommentsOrderRequest {
    tenantId: number | undefined;
    userId: number | undefined;
    prescriptionCommentsOrder: boolean;

    constructor(data?: IUpdatePrescriptionCommentsOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.prescriptionCommentsOrder = _data["prescriptionCommentsOrder"];
        }
    }

    static fromJS(data: any): UpdatePrescriptionCommentsOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePrescriptionCommentsOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["prescriptionCommentsOrder"] = this.prescriptionCommentsOrder;
        return data; 
    }

    clone(): UpdatePrescriptionCommentsOrderRequest {
        const json = this.toJSON();
        let result = new UpdatePrescriptionCommentsOrderRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePrescriptionCommentsOrderRequest {
    tenantId: number | undefined;
    userId: number | undefined;
    prescriptionCommentsOrder: boolean;
}

export enum MedicationDosesQueryRange {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class MedicationDoseDto implements IMedicationDoseDto {
    id: string;
    medicationId: string;
    dateTime: moment.Moment;
    taken: boolean;
    takenAt: moment.Moment;
    comments: string | undefined;
    drugDescriptionAndDosage: string | undefined;
    usageInstruction: string | undefined;
    isDeleted: boolean;

    constructor(data?: IMedicationDoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medicationId = _data["medicationId"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
            this.taken = _data["taken"];
            this.takenAt = _data["takenAt"] ? moment(_data["takenAt"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.drugDescriptionAndDosage = _data["drugDescriptionAndDosage"];
            this.usageInstruction = _data["usageInstruction"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): MedicationDoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medicationId"] = this.medicationId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["taken"] = this.taken;
        data["takenAt"] = this.takenAt ? this.takenAt.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["drugDescriptionAndDosage"] = this.drugDescriptionAndDosage;
        data["usageInstruction"] = this.usageInstruction;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }

    clone(): MedicationDoseDto {
        const json = this.toJSON();
        let result = new MedicationDoseDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationDoseDto {
    id: string;
    medicationId: string;
    dateTime: moment.Moment;
    taken: boolean;
    takenAt: moment.Moment;
    comments: string | undefined;
    drugDescriptionAndDosage: string | undefined;
    usageInstruction: string | undefined;
    isDeleted: boolean;
}

export class MedicationDto implements IMedicationDto {
    drugDescriptionAndDosage: string;
    period: Period;
    frequency: Period;
    usageInstruction: string | undefined;
    continuousUsage: boolean;
    startDate: moment.Moment | undefined;
    needsSpecialPrescription: boolean;
    patientId: string | undefined;
    id: string;

    constructor(data?: IMedicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.drugDescriptionAndDosage = _data["drugDescriptionAndDosage"];
            this.period = _data["period"] ? Period.fromJS(_data["period"]) : <any>undefined;
            this.frequency = _data["frequency"] ? Period.fromJS(_data["frequency"]) : <any>undefined;
            this.usageInstruction = _data["usageInstruction"];
            this.continuousUsage = _data["continuousUsage"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.needsSpecialPrescription = _data["needsSpecialPrescription"];
            this.patientId = _data["patientId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["drugDescriptionAndDosage"] = this.drugDescriptionAndDosage;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["usageInstruction"] = this.usageInstruction;
        data["continuousUsage"] = this.continuousUsage;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["needsSpecialPrescription"] = this.needsSpecialPrescription;
        data["patientId"] = this.patientId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicationDto {
        const json = this.toJSON();
        let result = new MedicationDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationDto {
    drugDescriptionAndDosage: string;
    period: Period;
    frequency: Period;
    usageInstruction: string | undefined;
    continuousUsage: boolean;
    startDate: moment.Moment | undefined;
    needsSpecialPrescription: boolean;
    patientId: string | undefined;
    id: string;
}

export class PrescriptionDraft implements IPrescriptionDraft {
    id: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    content: string | undefined;
    medications: MedicationDto[] | undefined;
    specialPrescription: boolean;
    smart: boolean;

    constructor(data?: IPrescriptionDraft) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.content = _data["content"];
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications.push(MedicationDto.fromJS(item));
            }
            this.specialPrescription = _data["specialPrescription"];
            this.smart = _data["smart"];
        }
    }

    static fromJS(data: any): PrescriptionDraft {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionDraft();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["content"] = this.content;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item.toJSON());
        }
        data["specialPrescription"] = this.specialPrescription;
        data["smart"] = this.smart;
        return data; 
    }

    clone(): PrescriptionDraft {
        const json = this.toJSON();
        let result = new PrescriptionDraft();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionDraft {
    id: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    content: string | undefined;
    medications: MedicationDto[] | undefined;
    specialPrescription: boolean;
    smart: boolean;
}

export class CreateDraftRequest implements ICreateDraftRequest {
    patientId: string;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    medications: MedicationDto[] | undefined;

    constructor(data?: ICreateDraftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.smart = _data["smart"];
            this.content = _data["content"];
            this.specialPrescription = _data["specialPrescription"];
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications.push(MedicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDraftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDraftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["smart"] = this.smart;
        data["content"] = this.content;
        data["specialPrescription"] = this.specialPrescription;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateDraftRequest {
        const json = this.toJSON();
        let result = new CreateDraftRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateDraftRequest {
    patientId: string;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    medications: MedicationDto[] | undefined;
}

export class UpdateDraftRequest implements IUpdateDraftRequest {
    draftId: string;
    patientId: string;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    medications: MedicationDto[] | undefined;

    constructor(data?: IUpdateDraftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftId = _data["draftId"];
            this.patientId = _data["patientId"];
            this.smart = _data["smart"];
            this.content = _data["content"];
            this.specialPrescription = _data["specialPrescription"];
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications.push(MedicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDraftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDraftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftId"] = this.draftId;
        data["patientId"] = this.patientId;
        data["smart"] = this.smart;
        data["content"] = this.content;
        data["specialPrescription"] = this.specialPrescription;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpdateDraftRequest {
        const json = this.toJSON();
        let result = new UpdateDraftRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateDraftRequest {
    draftId: string;
    patientId: string;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    medications: MedicationDto[] | undefined;
}

export class PublishDraftRequest implements IPublishDraftRequest {
    draftId: string | undefined;
    patientId: string;
    medications: MedicationDto[] | undefined;
    completed: boolean;
    hint: string | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    modelId: string;
    saveModel: boolean;
    modelName: string | undefined;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    stampDate: boolean;
    stampProfessionalFiscalIdentifier: boolean;

    constructor(data?: IPublishDraftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draftId = _data["draftId"];
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications.push(MedicationDto.fromJS(item));
            }
            this.completed = _data["completed"];
            this.hint = _data["hint"];
            this.smart = _data["smart"];
            this.content = _data["content"];
            this.specialPrescription = _data["specialPrescription"];
            this.modelId = _data["modelId"];
            this.saveModel = _data["saveModel"];
            this.modelName = _data["modelName"];
            this.signDigitally = _data["signDigitally"];
            if (Array.isArray(_data["selectedSpecialties"])) {
                this.selectedSpecialties = [] as any;
                for (let item of _data["selectedSpecialties"])
                    this.selectedSpecialties.push(DoctorSpecialty.fromJS(item));
            }
            this.stampDate = _data["stampDate"];
            this.stampProfessionalFiscalIdentifier = _data["stampProfessionalFiscalIdentifier"];
        }
    }

    static fromJS(data: any): PublishDraftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PublishDraftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draftId"] = this.draftId;
        data["patientId"] = this.patientId;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item.toJSON());
        }
        data["completed"] = this.completed;
        data["hint"] = this.hint;
        data["smart"] = this.smart;
        data["content"] = this.content;
        data["specialPrescription"] = this.specialPrescription;
        data["modelId"] = this.modelId;
        data["saveModel"] = this.saveModel;
        data["modelName"] = this.modelName;
        data["signDigitally"] = this.signDigitally;
        if (Array.isArray(this.selectedSpecialties)) {
            data["selectedSpecialties"] = [];
            for (let item of this.selectedSpecialties)
                data["selectedSpecialties"].push(item.toJSON());
        }
        data["stampDate"] = this.stampDate;
        data["stampProfessionalFiscalIdentifier"] = this.stampProfessionalFiscalIdentifier;
        return data; 
    }

    clone(): PublishDraftRequest {
        const json = this.toJSON();
        let result = new PublishDraftRequest();
        result.init(json);
        return result;
    }
}

export interface IPublishDraftRequest {
    draftId: string | undefined;
    patientId: string;
    medications: MedicationDto[] | undefined;
    completed: boolean;
    hint: string | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    modelId: string;
    saveModel: boolean;
    modelName: string | undefined;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    stampDate: boolean;
    stampProfessionalFiscalIdentifier: boolean;
}

export enum PublishStatus {
    _1 = 1,
    _2 = 2,
    _10 = 10,
}

export class PrescriptionDto implements IPrescriptionDto {
    patientId: string;
    medications: MedicationDto[] | undefined;
    completed: boolean;
    hint: string | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    creator: DoctorDto;
    doctorId: string;
    status: PublishStatus;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPrescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications.push(MedicationDto.fromJS(item));
            }
            this.completed = _data["completed"];
            this.hint = _data["hint"];
            this.smart = _data["smart"];
            this.content = _data["content"];
            this.specialPrescription = _data["specialPrescription"];
            this.creator = _data["creator"] ? DoctorDto.fromJS(_data["creator"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item.toJSON());
        }
        data["completed"] = this.completed;
        data["hint"] = this.hint;
        data["smart"] = this.smart;
        data["content"] = this.content;
        data["specialPrescription"] = this.specialPrescription;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PrescriptionDto {
        const json = this.toJSON();
        let result = new PrescriptionDto();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionDto {
    patientId: string;
    medications: MedicationDto[] | undefined;
    completed: boolean;
    hint: string | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    creator: DoctorDto;
    doctorId: string;
    status: PublishStatus;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PatientInfo implements IPatientInfo {
    name: string | undefined;
    personalIdentifier: string | undefined;

    constructor(data?: IPatientInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.personalIdentifier = _data["personalIdentifier"];
        }
    }

    static fromJS(data: any): PatientInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["personalIdentifier"] = this.personalIdentifier;
        return data; 
    }

    clone(): PatientInfo {
        const json = this.toJSON();
        let result = new PatientInfo();
        result.init(json);
        return result;
    }
}

export interface IPatientInfo {
    name: string | undefined;
    personalIdentifier: string | undefined;
}

export class PrescriptionDoctorInfo implements IPrescriptionDoctorInfo {
    name: string | undefined;
    license: string | undefined;

    constructor(data?: IPrescriptionDoctorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.license = _data["license"];
        }
    }

    static fromJS(data: any): PrescriptionDoctorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionDoctorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["license"] = this.license;
        return data; 
    }

    clone(): PrescriptionDoctorInfo {
        const json = this.toJSON();
        let result = new PrescriptionDoctorInfo();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionDoctorInfo {
    name: string | undefined;
    license: string | undefined;
}

export class MedicationInfo implements IMedicationInfo {
    id: string;
    drugDescriptionAndDosage: string | undefined;
    period: Period;
    frequency: Period;
    usageInstruction: string | undefined;
    continuousUsage: boolean;
    startDate: moment.Moment | undefined;
    needsSpecialPrescription: boolean;

    constructor(data?: IMedicationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drugDescriptionAndDosage = _data["drugDescriptionAndDosage"];
            this.period = _data["period"] ? Period.fromJS(_data["period"]) : <any>undefined;
            this.frequency = _data["frequency"] ? Period.fromJS(_data["frequency"]) : <any>undefined;
            this.usageInstruction = _data["usageInstruction"];
            this.continuousUsage = _data["continuousUsage"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.needsSpecialPrescription = _data["needsSpecialPrescription"];
        }
    }

    static fromJS(data: any): MedicationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drugDescriptionAndDosage"] = this.drugDescriptionAndDosage;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["frequency"] = this.frequency ? this.frequency.toJSON() : <any>undefined;
        data["usageInstruction"] = this.usageInstruction;
        data["continuousUsage"] = this.continuousUsage;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["needsSpecialPrescription"] = this.needsSpecialPrescription;
        return data; 
    }

    clone(): MedicationInfo {
        const json = this.toJSON();
        let result = new MedicationInfo();
        result.init(json);
        return result;
    }
}

export interface IMedicationInfo {
    id: string;
    drugDescriptionAndDosage: string | undefined;
    period: Period;
    frequency: Period;
    usageInstruction: string | undefined;
    continuousUsage: boolean;
    startDate: moment.Moment | undefined;
    needsSpecialPrescription: boolean;
}

export class PrescriptionInfo implements IPrescriptionInfo {
    id: string;
    patient: PatientInfo;
    smart: boolean;
    content: string | undefined;
    isSpecial: boolean;
    doctor: PrescriptionDoctorInfo;
    medications: MedicationInfo[] | undefined;
    creationTime: moment.Moment;
    hash: string | undefined;

    constructor(data?: IPrescriptionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"] ? PatientInfo.fromJS(_data["patient"]) : <any>undefined;
            this.smart = _data["smart"];
            this.content = _data["content"];
            this.isSpecial = _data["isSpecial"];
            this.doctor = _data["doctor"] ? PrescriptionDoctorInfo.fromJS(_data["doctor"]) : <any>undefined;
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications.push(MedicationInfo.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any): PrescriptionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["smart"] = this.smart;
        data["content"] = this.content;
        data["isSpecial"] = this.isSpecial;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["hash"] = this.hash;
        return data; 
    }

    clone(): PrescriptionInfo {
        const json = this.toJSON();
        let result = new PrescriptionInfo();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionInfo {
    id: string;
    patient: PatientInfo;
    smart: boolean;
    content: string | undefined;
    isSpecial: boolean;
    doctor: PrescriptionDoctorInfo;
    medications: MedicationInfo[] | undefined;
    creationTime: moment.Moment;
    hash: string | undefined;
}

export class IsReadyToMakePrescriptionDto implements IIsReadyToMakePrescriptionDto {
    isReady: boolean;
    notAllowed: boolean;
    missingConfiguration: boolean;
    info: DoctorDto;

    constructor(data?: IIsReadyToMakePrescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isReady = _data["isReady"];
            this.notAllowed = _data["notAllowed"];
            this.missingConfiguration = _data["missingConfiguration"];
            this.info = _data["info"] ? DoctorDto.fromJS(_data["info"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IsReadyToMakePrescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsReadyToMakePrescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReady"] = this.isReady;
        data["notAllowed"] = this.notAllowed;
        data["missingConfiguration"] = this.missingConfiguration;
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        return data; 
    }

    clone(): IsReadyToMakePrescriptionDto {
        const json = this.toJSON();
        let result = new IsReadyToMakePrescriptionDto();
        result.init(json);
        return result;
    }
}

export interface IIsReadyToMakePrescriptionDto {
    isReady: boolean;
    notAllowed: boolean;
    missingConfiguration: boolean;
    info: DoctorDto;
}

export class PrescriptionDtoPagedResultDto implements IPrescriptionDtoPagedResultDto {
    totalCount: number;
    items: PrescriptionDto[] | undefined;

    constructor(data?: IPrescriptionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PrescriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrescriptionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PrescriptionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PrescriptionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionDtoPagedResultDto {
    totalCount: number;
    items: PrescriptionDto[] | undefined;
}

export class CreatePrescriptionRequest implements ICreatePrescriptionRequest {
    patientId: string;
    medications: MedicationDto[] | undefined;
    completed: boolean;
    hint: string | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    modelId: string;
    saveModel: boolean;
    modelName: string | undefined;
    stampDate: boolean;
    stampProfessionalFiscalIdentifier: boolean;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICreatePrescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications.push(MedicationDto.fromJS(item));
            }
            this.completed = _data["completed"];
            this.hint = _data["hint"];
            this.smart = _data["smart"];
            this.content = _data["content"];
            this.specialPrescription = _data["specialPrescription"];
            this.modelId = _data["modelId"];
            this.saveModel = _data["saveModel"];
            this.modelName = _data["modelName"];
            this.stampDate = _data["stampDate"];
            this.stampProfessionalFiscalIdentifier = _data["stampProfessionalFiscalIdentifier"];
            this.signDigitally = _data["signDigitally"];
            if (Array.isArray(_data["selectedSpecialties"])) {
                this.selectedSpecialties = [] as any;
                for (let item of _data["selectedSpecialties"])
                    this.selectedSpecialties.push(DoctorSpecialty.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePrescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePrescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item.toJSON());
        }
        data["completed"] = this.completed;
        data["hint"] = this.hint;
        data["smart"] = this.smart;
        data["content"] = this.content;
        data["specialPrescription"] = this.specialPrescription;
        data["modelId"] = this.modelId;
        data["saveModel"] = this.saveModel;
        data["modelName"] = this.modelName;
        data["stampDate"] = this.stampDate;
        data["stampProfessionalFiscalIdentifier"] = this.stampProfessionalFiscalIdentifier;
        data["signDigitally"] = this.signDigitally;
        if (Array.isArray(this.selectedSpecialties)) {
            data["selectedSpecialties"] = [];
            for (let item of this.selectedSpecialties)
                data["selectedSpecialties"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreatePrescriptionRequest {
        const json = this.toJSON();
        let result = new CreatePrescriptionRequest();
        result.init(json);
        return result;
    }
}

export interface ICreatePrescriptionRequest {
    patientId: string;
    medications: MedicationDto[] | undefined;
    completed: boolean;
    hint: string | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    modelId: string;
    saveModel: boolean;
    modelName: string | undefined;
    stampDate: boolean;
    stampProfessionalFiscalIdentifier: boolean;
    signDigitally: boolean;
    selectedSpecialties: DoctorSpecialty[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class UpdatePrescriptionRequest implements IUpdatePrescriptionRequest {
    patientId: string;
    medications: MedicationDto[] | undefined;
    completed: boolean;
    hint: string | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    creator: DoctorDto;
    doctorId: string;
    status: PublishStatus;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdatePrescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["medications"])) {
                this.medications = [] as any;
                for (let item of _data["medications"])
                    this.medications.push(MedicationDto.fromJS(item));
            }
            this.completed = _data["completed"];
            this.hint = _data["hint"];
            this.smart = _data["smart"];
            this.content = _data["content"];
            this.specialPrescription = _data["specialPrescription"];
            this.creator = _data["creator"] ? DoctorDto.fromJS(_data["creator"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePrescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePrescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        if (Array.isArray(this.medications)) {
            data["medications"] = [];
            for (let item of this.medications)
                data["medications"].push(item.toJSON());
        }
        data["completed"] = this.completed;
        data["hint"] = this.hint;
        data["smart"] = this.smart;
        data["content"] = this.content;
        data["specialPrescription"] = this.specialPrescription;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdatePrescriptionRequest {
        const json = this.toJSON();
        let result = new UpdatePrescriptionRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePrescriptionRequest {
    patientId: string;
    medications: MedicationDto[] | undefined;
    completed: boolean;
    hint: string | undefined;
    smart: boolean;
    content: string | undefined;
    specialPrescription: boolean;
    creator: DoctorDto;
    doctorId: string;
    status: PublishStatus;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class GetAvailableAppointmentTimesRequest implements IGetAvailableAppointmentTimesRequest {
    date: moment.Moment;
    client: number | undefined;
    host: number | undefined;

    constructor(data?: IGetAvailableAppointmentTimesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.client = _data["client"];
            this.host = _data["host"];
        }
    }

    static fromJS(data: any): GetAvailableAppointmentTimesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableAppointmentTimesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["client"] = this.client;
        data["host"] = this.host;
        return data; 
    }

    clone(): GetAvailableAppointmentTimesRequest {
        const json = this.toJSON();
        let result = new GetAvailableAppointmentTimesRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAvailableAppointmentTimesRequest {
    date: moment.Moment;
    client: number | undefined;
    host: number | undefined;
}

export class CreatePublishAppointmentDto implements ICreatePublishAppointmentDto {
    date: moment.Moment;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    comments: string | undefined;

    constructor(data?: ICreatePublishAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreatePublishAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePublishAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): CreatePublishAppointmentDto {
        const json = this.toJSON();
        let result = new CreatePublishAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePublishAppointmentDto {
    date: moment.Moment;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    comments: string | undefined;
}

export class PublishAppointmentPreview implements IPublishAppointmentPreview {
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    comments: string | undefined;
    duration: number;
    date: moment.Moment;
    status: AppointmentStatus;
    id: string;

    constructor(data?: IPublishAppointmentPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.comments = _data["comments"];
            this.duration = _data["duration"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PublishAppointmentPreview {
        data = typeof data === 'object' ? data : {};
        let result = new PublishAppointmentPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["comments"] = this.comments;
        data["duration"] = this.duration;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }

    clone(): PublishAppointmentPreview {
        const json = this.toJSON();
        let result = new PublishAppointmentPreview();
        result.init(json);
        return result;
    }
}

export interface IPublishAppointmentPreview {
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    comments: string | undefined;
    duration: number;
    date: moment.Moment;
    status: AppointmentStatus;
    id: string;
}

export class RescheduleAppointmentDto implements IRescheduleAppointmentDto {
    id: string;
    date: moment.Moment;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    comments: string | undefined;

    constructor(data?: IRescheduleAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): RescheduleAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RescheduleAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): RescheduleAppointmentDto {
        const json = this.toJSON();
        let result = new RescheduleAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface IRescheduleAppointmentDto {
    id: string;
    date: moment.Moment;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    comments: string | undefined;
}

export class AppointmentStatusUpdateDto implements IAppointmentStatusUpdateDto {
    id: string;
    comments: string | undefined;

    constructor(data?: IAppointmentStatusUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): AppointmentStatusUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentStatusUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): AppointmentStatusUpdateDto {
        const json = this.toJSON();
        let result = new AppointmentStatusUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IAppointmentStatusUpdateDto {
    id: string;
    comments: string | undefined;
}

export enum NotificationPlatform {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum NotificationMessageType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class C360NotificationData implements IC360NotificationData {
    i: number;
    route: string | undefined;
    args: string | undefined;

    constructor(data?: IC360NotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.i = _data["i"];
            this.route = _data["route"];
            this.args = _data["args"];
        }
    }

    static fromJS(data: any): C360NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new C360NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["i"] = this.i;
        data["route"] = this.route;
        data["args"] = this.args;
        return data; 
    }

    clone(): C360NotificationData {
        const json = this.toJSON();
        let result = new C360NotificationData();
        result.init(json);
        return result;
    }
}

export interface IC360NotificationData {
    i: number;
    route: string | undefined;
    args: string | undefined;
}

export class PushMessageData implements IPushMessageData {
    title: string | undefined;
    message: string | undefined;
    imageUrl: string | undefined;
    openedAction: string | undefined;
    customData: C360NotificationData;

    constructor(data?: IPushMessageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.message = _data["message"];
            this.imageUrl = _data["imageUrl"];
            this.openedAction = _data["openedAction"];
            this.customData = _data["customData"] ? C360NotificationData.fromJS(_data["customData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new PushMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["message"] = this.message;
        data["imageUrl"] = this.imageUrl;
        data["openedAction"] = this.openedAction;
        data["customData"] = this.customData ? this.customData.toJSON() : <any>undefined;
        return data; 
    }

    clone(): PushMessageData {
        const json = this.toJSON();
        let result = new PushMessageData();
        result.init(json);
        return result;
    }
}

export interface IPushMessageData {
    title: string | undefined;
    message: string | undefined;
    imageUrl: string | undefined;
    openedAction: string | undefined;
    customData: C360NotificationData;
}

export class CreateNotificationDto implements ICreateNotificationDto {
    targetPlatform: NotificationPlatform;
    targetUsers: string | undefined;
    data: string | undefined;
    messageType: NotificationMessageType;
    sendDate: moment.Moment | undefined;
    pushMessageData: PushMessageData;
    tags: number[] | undefined;
    tagOperator: string | undefined;

    constructor(data?: ICreateNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetPlatform = _data["targetPlatform"];
            this.targetUsers = _data["targetUsers"];
            this.data = _data["data"];
            this.messageType = _data["messageType"];
            this.sendDate = _data["sendDate"] ? moment(_data["sendDate"].toString()) : <any>undefined;
            this.pushMessageData = _data["pushMessageData"] ? PushMessageData.fromJS(_data["pushMessageData"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.tagOperator = _data["tagOperator"];
        }
    }

    static fromJS(data: any): CreateNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetPlatform"] = this.targetPlatform;
        data["targetUsers"] = this.targetUsers;
        data["data"] = this.data;
        data["messageType"] = this.messageType;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["pushMessageData"] = this.pushMessageData ? this.pushMessageData.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["tagOperator"] = this.tagOperator;
        return data; 
    }

    clone(): CreateNotificationDto {
        const json = this.toJSON();
        let result = new CreateNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNotificationDto {
    targetPlatform: NotificationPlatform;
    targetUsers: string | undefined;
    data: string | undefined;
    messageType: NotificationMessageType;
    sendDate: moment.Moment | undefined;
    pushMessageData: PushMessageData;
    tags: number[] | undefined;
    tagOperator: string | undefined;
}

export class MessageData implements IMessageData {
    title: string | undefined;
    message: string | undefined;
    imageUrl: string | undefined;
    openedAction: string | undefined;
    customData: C360NotificationData;

    constructor(data?: IMessageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.message = _data["message"];
            this.imageUrl = _data["imageUrl"];
            this.openedAction = _data["openedAction"];
            this.customData = _data["customData"] ? C360NotificationData.fromJS(_data["customData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MessageData {
        data = typeof data === 'object' ? data : {};
        let result = new MessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["message"] = this.message;
        data["imageUrl"] = this.imageUrl;
        data["openedAction"] = this.openedAction;
        data["customData"] = this.customData ? this.customData.toJSON() : <any>undefined;
        return data; 
    }

    clone(): MessageData {
        const json = this.toJSON();
        let result = new MessageData();
        result.init(json);
        return result;
    }
}

export interface IMessageData {
    title: string | undefined;
    message: string | undefined;
    imageUrl: string | undefined;
    openedAction: string | undefined;
    customData: C360NotificationData;
}

export enum NotificationStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RemoteNotificationDto implements IRemoteNotificationDto {
    tenantId: number;
    targetPlatform: NotificationPlatform;
    targetUsers: string | undefined;
    data: MessageData;
    messageType: NotificationMessageType;
    sendDate: moment.Moment | undefined;
    status: NotificationStatus;
    statusUpdatedAt: moment.Moment;
    deliveredCount: number;
    openedCount: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IRemoteNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.targetPlatform = _data["targetPlatform"];
            this.targetUsers = _data["targetUsers"];
            this.data = _data["data"] ? MessageData.fromJS(_data["data"]) : <any>undefined;
            this.messageType = _data["messageType"];
            this.sendDate = _data["sendDate"] ? moment(_data["sendDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusUpdatedAt = _data["statusUpdatedAt"] ? moment(_data["statusUpdatedAt"].toString()) : <any>undefined;
            this.deliveredCount = _data["deliveredCount"];
            this.openedCount = _data["openedCount"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RemoteNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["targetPlatform"] = this.targetPlatform;
        data["targetUsers"] = this.targetUsers;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["messageType"] = this.messageType;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusUpdatedAt"] = this.statusUpdatedAt ? this.statusUpdatedAt.toISOString() : <any>undefined;
        data["deliveredCount"] = this.deliveredCount;
        data["openedCount"] = this.openedCount;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): RemoteNotificationDto {
        const json = this.toJSON();
        let result = new RemoteNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IRemoteNotificationDto {
    tenantId: number;
    targetPlatform: NotificationPlatform;
    targetUsers: string | undefined;
    data: MessageData;
    messageType: NotificationMessageType;
    sendDate: moment.Moment | undefined;
    status: NotificationStatus;
    statusUpdatedAt: moment.Moment;
    deliveredCount: number;
    openedCount: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum DevicePlatform {
    _0 = 0,
    _1 = 1,
}

export class RegisterDeviceDto implements IRegisterDeviceDto {
    token: string | undefined;
    platform: DevicePlatform;

    constructor(data?: IRegisterDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): RegisterDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["platform"] = this.platform;
        return data; 
    }

    clone(): RegisterDeviceDto {
        const json = this.toJSON();
        let result = new RegisterDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterDeviceDto {
    token: string | undefined;
    platform: DevicePlatform;
}

export class RemoteNotificationDtoPagedResultDto implements IRemoteNotificationDtoPagedResultDto {
    totalCount: number;
    items: RemoteNotificationDto[] | undefined;

    constructor(data?: IRemoteNotificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RemoteNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemoteNotificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteNotificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RemoteNotificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RemoteNotificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRemoteNotificationDtoPagedResultDto {
    totalCount: number;
    items: RemoteNotificationDto[] | undefined;
}

export class GetAttendanceReportRequest implements IGetAttendanceReportRequest {
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    proceduresId: number[] | undefined;
    insuranceCompaniesId: number[] | undefined;
    insurancePlansId: number[] | undefined;
    careUnitsId: number[] | undefined;
    patientId: string | undefined;
    patientGender: number | undefined;
    statuses: AppointmentStatus[] | undefined;
    professionals: string[] | undefined;
    fromAge: number | undefined;
    toAge: number | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetAttendanceReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["proceduresId"])) {
                this.proceduresId = [] as any;
                for (let item of _data["proceduresId"])
                    this.proceduresId.push(item);
            }
            if (Array.isArray(_data["insuranceCompaniesId"])) {
                this.insuranceCompaniesId = [] as any;
                for (let item of _data["insuranceCompaniesId"])
                    this.insuranceCompaniesId.push(item);
            }
            if (Array.isArray(_data["insurancePlansId"])) {
                this.insurancePlansId = [] as any;
                for (let item of _data["insurancePlansId"])
                    this.insurancePlansId.push(item);
            }
            if (Array.isArray(_data["careUnitsId"])) {
                this.careUnitsId = [] as any;
                for (let item of _data["careUnitsId"])
                    this.careUnitsId.push(item);
            }
            this.patientId = _data["patientId"];
            this.patientGender = _data["patientGender"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses.push(item);
            }
            if (Array.isArray(_data["professionals"])) {
                this.professionals = [] as any;
                for (let item of _data["professionals"])
                    this.professionals.push(item);
            }
            this.fromAge = _data["fromAge"];
            this.toAge = _data["toAge"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAttendanceReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.proceduresId)) {
            data["proceduresId"] = [];
            for (let item of this.proceduresId)
                data["proceduresId"].push(item);
        }
        if (Array.isArray(this.insuranceCompaniesId)) {
            data["insuranceCompaniesId"] = [];
            for (let item of this.insuranceCompaniesId)
                data["insuranceCompaniesId"].push(item);
        }
        if (Array.isArray(this.insurancePlansId)) {
            data["insurancePlansId"] = [];
            for (let item of this.insurancePlansId)
                data["insurancePlansId"].push(item);
        }
        if (Array.isArray(this.careUnitsId)) {
            data["careUnitsId"] = [];
            for (let item of this.careUnitsId)
                data["careUnitsId"].push(item);
        }
        data["patientId"] = this.patientId;
        data["patientGender"] = this.patientGender;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        if (Array.isArray(this.professionals)) {
            data["professionals"] = [];
            for (let item of this.professionals)
                data["professionals"].push(item);
        }
        data["fromAge"] = this.fromAge;
        data["toAge"] = this.toAge;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetAttendanceReportRequest {
        const json = this.toJSON();
        let result = new GetAttendanceReportRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAttendanceReportRequest {
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    proceduresId: number[] | undefined;
    insuranceCompaniesId: number[] | undefined;
    insurancePlansId: number[] | undefined;
    careUnitsId: number[] | undefined;
    patientId: string | undefined;
    patientGender: number | undefined;
    statuses: AppointmentStatus[] | undefined;
    professionals: string[] | undefined;
    fromAge: number | undefined;
    toAge: number | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class DoctorNameInfo implements IDoctorNameInfo {
    id: string;
    userId: number;
    name: string | undefined;
    gender: number | undefined;

    constructor(data?: IDoctorNameInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): DoctorNameInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorNameInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["gender"] = this.gender;
        return data; 
    }

    clone(): DoctorNameInfo {
        const json = this.toJSON();
        let result = new DoctorNameInfo();
        result.init(json);
        return result;
    }
}

export interface IDoctorNameInfo {
    id: string;
    userId: number;
    name: string | undefined;
    gender: number | undefined;
}

export class AttendanceReportDto implements IAttendanceReportDto {
    date: moment.Moment;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    patient: PatientNameInfo;
    healthProfessional: DoctorNameInfo;
    remotely: boolean;
    price: number;
    procedure: MedicalProcedureBasicData;
    careUnit: HealthCareUnitBasicData;
    status: AppointmentStatus;
    plannedDuration: number;
    duration: number;
    splitPortion: string | undefined;
    clinicPricePart: number;
    otherPricePart: number;
    insuranceCompany: InsuranceCompanyBasicData;
    insurancePlan: InsurancePlanBasicData;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IAttendanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.patient = _data["patient"] ? PatientNameInfo.fromJS(_data["patient"]) : <any>undefined;
            this.healthProfessional = _data["healthProfessional"] ? DoctorNameInfo.fromJS(_data["healthProfessional"]) : <any>undefined;
            this.remotely = _data["remotely"];
            this.price = _data["price"];
            this.procedure = _data["procedure"] ? MedicalProcedureBasicData.fromJS(_data["procedure"]) : <any>undefined;
            this.careUnit = _data["careUnit"] ? HealthCareUnitBasicData.fromJS(_data["careUnit"]) : <any>undefined;
            this.status = _data["status"];
            this.plannedDuration = _data["plannedDuration"];
            this.duration = _data["duration"];
            this.splitPortion = _data["splitPortion"];
            this.clinicPricePart = _data["clinicPricePart"];
            this.otherPricePart = _data["otherPricePart"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompanyBasicData.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insurancePlan = _data["insurancePlan"] ? InsurancePlanBasicData.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttendanceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["healthProfessional"] = this.healthProfessional ? this.healthProfessional.toJSON() : <any>undefined;
        data["remotely"] = this.remotely;
        data["price"] = this.price;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data["careUnit"] = this.careUnit ? this.careUnit.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["plannedDuration"] = this.plannedDuration;
        data["duration"] = this.duration;
        data["splitPortion"] = this.splitPortion;
        data["clinicPricePart"] = this.clinicPricePart;
        data["otherPricePart"] = this.otherPricePart;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): AttendanceReportDto {
        const json = this.toJSON();
        let result = new AttendanceReportDto();
        result.init(json);
        return result;
    }
}

export interface IAttendanceReportDto {
    date: moment.Moment;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    patient: PatientNameInfo;
    healthProfessional: DoctorNameInfo;
    remotely: boolean;
    price: number;
    procedure: MedicalProcedureBasicData;
    careUnit: HealthCareUnitBasicData;
    status: AppointmentStatus;
    plannedDuration: number;
    duration: number;
    splitPortion: string | undefined;
    clinicPricePart: number;
    otherPricePart: number;
    insuranceCompany: InsuranceCompanyBasicData;
    insurancePlan: InsurancePlanBasicData;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class GetAttendanceReportResponse implements IGetAttendanceReportResponse {
    totalCount: number;
    totalPrice: number;
    totalDuration: number;
    items: AttendanceReportDto[] | undefined;

    constructor(data?: IGetAttendanceReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.totalPrice = _data["totalPrice"];
            this.totalDuration = _data["totalDuration"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AttendanceReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAttendanceReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["totalPrice"] = this.totalPrice;
        data["totalDuration"] = this.totalDuration;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAttendanceReportResponse {
        const json = this.toJSON();
        let result = new GetAttendanceReportResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAttendanceReportResponse {
    totalCount: number;
    totalPrice: number;
    totalDuration: number;
    items: AttendanceReportDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    isGranted: boolean;
    children: PermissionDto[] | undefined;
    parentName: string | undefined;
    showDescription: boolean;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(PermissionDto.fromJS(item));
            }
            this.parentName = _data["parentName"];
            this.showDescription = _data["showDescription"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["parentName"] = this.parentName;
        data["showDescription"] = this.showDescription;
        return data; 
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    isGranted: boolean;
    children: PermissionDto[] | undefined;
    parentName: string | undefined;
    showDescription: boolean;
}

export class UpdateRolePermissionsRequest implements IUpdateRolePermissionsRequest {
    role: string | undefined;
    permissions: PermissionDto[] | undefined;

    constructor(data?: IUpdateRolePermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateRolePermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRolePermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpdateRolePermissionsRequest {
        const json = this.toJSON();
        let result = new UpdateRolePermissionsRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateRolePermissionsRequest {
    role: string | undefined;
    permissions: PermissionDto[] | undefined;
}

export class ResetRolePermissionsRequest implements IResetRolePermissionsRequest {
    role: string | undefined;

    constructor(data?: IResetRolePermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ResetRolePermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetRolePermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        return data; 
    }

    clone(): ResetRolePermissionsRequest {
        const json = this.toJSON();
        let result = new ResetRolePermissionsRequest();
        result.init(json);
        return result;
    }
}

export interface IResetRolePermissionsRequest {
    role: string | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isStatic: boolean;
    permissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data; 
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isStatic: boolean;
    permissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isStatic: boolean;
    permissions: string[] | undefined;
    id: number;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isStatic: boolean;
    permissions: string[] | undefined;
    id: number;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;
}

export enum ScheduleBehaviour {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum RescheduleStatusBehaviour {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ScheduleConfiguration implements IScheduleConfiguration {
    allowMultipleAppointmentAtSameTime: boolean;
    confirmAppointmentAutomatically: boolean;
    allowPickStartAndEndTime: boolean;
    shared: boolean;
    behaviour: ScheduleBehaviour;
    /** How many minutes before the patient will need to schedule an appointment (1 day = 24 hours * 60 minutes = 1440 minutes) */
    scheduleWithMinutesInAdvance: number;
    /** Will the professional be able to manage their own Calendar? default = true */
    allowProfessionalsManageTheirsCalendar: boolean;
    sendEmailNotificationToPatientWhenScheduledByHost: boolean;
    calendarViewWindowStartTime: string | undefined;
    calendarViewWindowEndTime: string | undefined;
    calendarViewTimeSlotDuration: number;
    inboxEmailAddress: string | undefined;
    inboxDisplayName: string | undefined;
    showAppointmentStartTime: boolean;
    showAppointmentEndTime: boolean;
    /** Comma separated */
    appointmentTitleFields: string | undefined;
    emailNotificationEnabled: boolean;
    failedPaymentEmailNotificationEnabled: boolean;
    patientEmailNotificationEnabled: boolean;
    sendCancelLinkByEmail: boolean;
    allowAppointmentWithComplementaryProcedures: boolean;
    rescheduleStatusBehaviour: RescheduleStatusBehaviour;
    askBehaviourOnReschedule: boolean;

    constructor(data?: IScheduleConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowMultipleAppointmentAtSameTime = _data["allowMultipleAppointmentAtSameTime"];
            this.confirmAppointmentAutomatically = _data["confirmAppointmentAutomatically"];
            this.allowPickStartAndEndTime = _data["allowPickStartAndEndTime"];
            this.shared = _data["shared"];
            this.behaviour = _data["behaviour"];
            this.scheduleWithMinutesInAdvance = _data["scheduleWithMinutesInAdvance"];
            this.allowProfessionalsManageTheirsCalendar = _data["allowProfessionalsManageTheirsCalendar"];
            this.sendEmailNotificationToPatientWhenScheduledByHost = _data["sendEmailNotificationToPatientWhenScheduledByHost"];
            this.calendarViewWindowStartTime = _data["calendarViewWindowStartTime"];
            this.calendarViewWindowEndTime = _data["calendarViewWindowEndTime"];
            this.calendarViewTimeSlotDuration = _data["calendarViewTimeSlotDuration"];
            this.inboxEmailAddress = _data["inboxEmailAddress"];
            this.inboxDisplayName = _data["inboxDisplayName"];
            this.showAppointmentStartTime = _data["showAppointmentStartTime"];
            this.showAppointmentEndTime = _data["showAppointmentEndTime"];
            this.appointmentTitleFields = _data["appointmentTitleFields"];
            this.emailNotificationEnabled = _data["emailNotificationEnabled"];
            this.failedPaymentEmailNotificationEnabled = _data["failedPaymentEmailNotificationEnabled"];
            this.patientEmailNotificationEnabled = _data["patientEmailNotificationEnabled"];
            this.sendCancelLinkByEmail = _data["sendCancelLinkByEmail"];
            this.allowAppointmentWithComplementaryProcedures = _data["allowAppointmentWithComplementaryProcedures"];
            this.rescheduleStatusBehaviour = _data["rescheduleStatusBehaviour"];
            this.askBehaviourOnReschedule = _data["askBehaviourOnReschedule"];
        }
    }

    static fromJS(data: any): ScheduleConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowMultipleAppointmentAtSameTime"] = this.allowMultipleAppointmentAtSameTime;
        data["confirmAppointmentAutomatically"] = this.confirmAppointmentAutomatically;
        data["allowPickStartAndEndTime"] = this.allowPickStartAndEndTime;
        data["shared"] = this.shared;
        data["behaviour"] = this.behaviour;
        data["scheduleWithMinutesInAdvance"] = this.scheduleWithMinutesInAdvance;
        data["allowProfessionalsManageTheirsCalendar"] = this.allowProfessionalsManageTheirsCalendar;
        data["sendEmailNotificationToPatientWhenScheduledByHost"] = this.sendEmailNotificationToPatientWhenScheduledByHost;
        data["calendarViewWindowStartTime"] = this.calendarViewWindowStartTime;
        data["calendarViewWindowEndTime"] = this.calendarViewWindowEndTime;
        data["calendarViewTimeSlotDuration"] = this.calendarViewTimeSlotDuration;
        data["inboxEmailAddress"] = this.inboxEmailAddress;
        data["inboxDisplayName"] = this.inboxDisplayName;
        data["showAppointmentStartTime"] = this.showAppointmentStartTime;
        data["showAppointmentEndTime"] = this.showAppointmentEndTime;
        data["appointmentTitleFields"] = this.appointmentTitleFields;
        data["emailNotificationEnabled"] = this.emailNotificationEnabled;
        data["failedPaymentEmailNotificationEnabled"] = this.failedPaymentEmailNotificationEnabled;
        data["patientEmailNotificationEnabled"] = this.patientEmailNotificationEnabled;
        data["sendCancelLinkByEmail"] = this.sendCancelLinkByEmail;
        data["allowAppointmentWithComplementaryProcedures"] = this.allowAppointmentWithComplementaryProcedures;
        data["rescheduleStatusBehaviour"] = this.rescheduleStatusBehaviour;
        data["askBehaviourOnReschedule"] = this.askBehaviourOnReschedule;
        return data; 
    }

    clone(): ScheduleConfiguration {
        const json = this.toJSON();
        let result = new ScheduleConfiguration();
        result.init(json);
        return result;
    }
}

export interface IScheduleConfiguration {
    allowMultipleAppointmentAtSameTime: boolean;
    confirmAppointmentAutomatically: boolean;
    allowPickStartAndEndTime: boolean;
    shared: boolean;
    behaviour: ScheduleBehaviour;
    /** How many minutes before the patient will need to schedule an appointment (1 day = 24 hours * 60 minutes = 1440 minutes) */
    scheduleWithMinutesInAdvance: number;
    /** Will the professional be able to manage their own Calendar? default = true */
    allowProfessionalsManageTheirsCalendar: boolean;
    sendEmailNotificationToPatientWhenScheduledByHost: boolean;
    calendarViewWindowStartTime: string | undefined;
    calendarViewWindowEndTime: string | undefined;
    calendarViewTimeSlotDuration: number;
    inboxEmailAddress: string | undefined;
    inboxDisplayName: string | undefined;
    showAppointmentStartTime: boolean;
    showAppointmentEndTime: boolean;
    /** Comma separated */
    appointmentTitleFields: string | undefined;
    emailNotificationEnabled: boolean;
    failedPaymentEmailNotificationEnabled: boolean;
    patientEmailNotificationEnabled: boolean;
    sendCancelLinkByEmail: boolean;
    allowAppointmentWithComplementaryProcedures: boolean;
    rescheduleStatusBehaviour: RescheduleStatusBehaviour;
    askBehaviourOnReschedule: boolean;
}

export enum DeviceType {
    _0 = 0,
    _1 = 1,
}

export class DeviceData implements IDeviceData {
    colorDepth: number;
    deviceType: DeviceType;
    screenHeight: number;
    screenWidth: number;
    timezoneOffset: number;

    constructor(data?: IDeviceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorDepth = _data["colorDepth"];
            this.deviceType = _data["deviceType"];
            this.screenHeight = _data["screenHeight"];
            this.screenWidth = _data["screenWidth"];
            this.timezoneOffset = _data["timezoneOffset"];
        }
    }

    static fromJS(data: any): DeviceData {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorDepth"] = this.colorDepth;
        data["deviceType"] = this.deviceType;
        data["screenHeight"] = this.screenHeight;
        data["screenWidth"] = this.screenWidth;
        data["timezoneOffset"] = this.timezoneOffset;
        return data; 
    }

    clone(): DeviceData {
        const json = this.toJSON();
        let result = new DeviceData();
        result.init(json);
        return result;
    }
}

export interface IDeviceData {
    colorDepth: number;
    deviceType: DeviceType;
    screenHeight: number;
    screenWidth: number;
    timezoneOffset: number;
}

export class MakePaymentRequest implements IMakePaymentRequest {
    token: string | undefined;
    paymentType: PaymentType;
    cardToken: string | undefined;
    numberOfInstallments: number;
    deviceInfo: DeviceData;
    billingAddress: Address;

    constructor(data?: IMakePaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.paymentType = _data["paymentType"];
            this.cardToken = _data["cardToken"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.deviceInfo = _data["deviceInfo"] ? DeviceData.fromJS(_data["deviceInfo"]) : <any>undefined;
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MakePaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MakePaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["paymentType"] = this.paymentType;
        data["cardToken"] = this.cardToken;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["deviceInfo"] = this.deviceInfo ? this.deviceInfo.toJSON() : <any>undefined;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        return data; 
    }

    clone(): MakePaymentRequest {
        const json = this.toJSON();
        let result = new MakePaymentRequest();
        result.init(json);
        return result;
    }
}

export interface IMakePaymentRequest {
    token: string | undefined;
    paymentType: PaymentType;
    cardToken: string | undefined;
    numberOfInstallments: number;
    deviceInfo: DeviceData;
    billingAddress: Address;
}

export class MakePaymentResponse implements IMakePaymentResponse {
    pixCode: string | undefined;
    pixExpiringDate: moment.Moment | undefined;
    pixQrCode: string | undefined;

    constructor(data?: IMakePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pixCode = _data["pixCode"];
            this.pixExpiringDate = _data["pixExpiringDate"] ? moment(_data["pixExpiringDate"].toString()) : <any>undefined;
            this.pixQrCode = _data["pixQrCode"];
        }
    }

    static fromJS(data: any): MakePaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MakePaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pixCode"] = this.pixCode;
        data["pixExpiringDate"] = this.pixExpiringDate ? this.pixExpiringDate.toISOString() : <any>undefined;
        data["pixQrCode"] = this.pixQrCode;
        return data; 
    }

    clone(): MakePaymentResponse {
        const json = this.toJSON();
        let result = new MakePaymentResponse();
        result.init(json);
        return result;
    }
}

export interface IMakePaymentResponse {
    pixCode: string | undefined;
    pixExpiringDate: moment.Moment | undefined;
    pixQrCode: string | undefined;
}

export class UpdateScheduleEmailNotificationEnableRequest implements IUpdateScheduleEmailNotificationEnableRequest {
    readonly enabled: boolean;

    constructor(data?: IUpdateScheduleEmailNotificationEnableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): UpdateScheduleEmailNotificationEnableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleEmailNotificationEnableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        return data; 
    }

    clone(): UpdateScheduleEmailNotificationEnableRequest {
        const json = this.toJSON();
        let result = new UpdateScheduleEmailNotificationEnableRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateScheduleEmailNotificationEnableRequest {
    enabled: boolean;
}

export class IsScheduleEmailNotificationEnableResponse implements IIsScheduleEmailNotificationEnableResponse {
    enabled: boolean;

    constructor(data?: IIsScheduleEmailNotificationEnableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): IsScheduleEmailNotificationEnableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsScheduleEmailNotificationEnableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        return data; 
    }

    clone(): IsScheduleEmailNotificationEnableResponse {
        const json = this.toJSON();
        let result = new IsScheduleEmailNotificationEnableResponse();
        result.init(json);
        return result;
    }
}

export interface IIsScheduleEmailNotificationEnableResponse {
    enabled: boolean;
}

export class StartAppointmentRequest implements IStartAppointmentRequest {
    id: string;
    startWithoutPaymentConfirmation: boolean | undefined;

    constructor(data?: IStartAppointmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startWithoutPaymentConfirmation = _data["startWithoutPaymentConfirmation"];
        }
    }

    static fromJS(data: any): StartAppointmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartAppointmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startWithoutPaymentConfirmation"] = this.startWithoutPaymentConfirmation;
        return data; 
    }

    clone(): StartAppointmentRequest {
        const json = this.toJSON();
        let result = new StartAppointmentRequest();
        result.init(json);
        return result;
    }
}

export interface IStartAppointmentRequest {
    id: string;
    startWithoutPaymentConfirmation: boolean | undefined;
}

export class GetMedicalAppointmentsQuery implements IGetMedicalAppointmentsQuery {
    doctorId: string;
    /** ID's dos profissionais dos quais você quer visualizar a agenda */
    professionals: string[] | undefined;
    /** ID's dos procedimentos dos quais você quer visualizar a agenda */
    procedures: number[] | undefined;
    /** Caso você queira obter a lista de agendamentos de um paciente específico */
    patientId: string;
    excludeExternalAppointments: boolean;
    /** Inicio da janela de tempo que você quer listar os agendamentos, exemplo: 19/10/2022 e passando Range = 2 (Weekly) você vai receber a lista de agendamentos da semana do dia 19/10 */
    from: moment.Moment | undefined;
    range: AppointmentsQueryRange;
    showCanceledAppointments: boolean;
    /** ID's das Unidades das quais você quer visualizar a agenda */
    careUnits: number[] | undefined;
    /** ID's dos status de agendamento a serem visualizados */
    appointmentStatus: AppointmentStatus[] | undefined;
    includeForDeletedPatients: boolean;

    constructor(data?: IGetMedicalAppointmentsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            if (Array.isArray(_data["professionals"])) {
                this.professionals = [] as any;
                for (let item of _data["professionals"])
                    this.professionals.push(item);
            }
            if (Array.isArray(_data["procedures"])) {
                this.procedures = [] as any;
                for (let item of _data["procedures"])
                    this.procedures.push(item);
            }
            this.patientId = _data["patientId"];
            this.excludeExternalAppointments = _data["excludeExternalAppointments"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.range = _data["range"];
            this.showCanceledAppointments = _data["showCanceledAppointments"];
            if (Array.isArray(_data["careUnits"])) {
                this.careUnits = [] as any;
                for (let item of _data["careUnits"])
                    this.careUnits.push(item);
            }
            if (Array.isArray(_data["appointmentStatus"])) {
                this.appointmentStatus = [] as any;
                for (let item of _data["appointmentStatus"])
                    this.appointmentStatus.push(item);
            }
            this.includeForDeletedPatients = _data["includeForDeletedPatients"];
        }
    }

    static fromJS(data: any): GetMedicalAppointmentsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalAppointmentsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        if (Array.isArray(this.professionals)) {
            data["professionals"] = [];
            for (let item of this.professionals)
                data["professionals"].push(item);
        }
        if (Array.isArray(this.procedures)) {
            data["procedures"] = [];
            for (let item of this.procedures)
                data["procedures"].push(item);
        }
        data["patientId"] = this.patientId;
        data["excludeExternalAppointments"] = this.excludeExternalAppointments;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["range"] = this.range;
        data["showCanceledAppointments"] = this.showCanceledAppointments;
        if (Array.isArray(this.careUnits)) {
            data["careUnits"] = [];
            for (let item of this.careUnits)
                data["careUnits"].push(item);
        }
        if (Array.isArray(this.appointmentStatus)) {
            data["appointmentStatus"] = [];
            for (let item of this.appointmentStatus)
                data["appointmentStatus"].push(item);
        }
        data["includeForDeletedPatients"] = this.includeForDeletedPatients;
        return data; 
    }

    clone(): GetMedicalAppointmentsQuery {
        const json = this.toJSON();
        let result = new GetMedicalAppointmentsQuery();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalAppointmentsQuery {
    doctorId: string;
    /** ID's dos profissionais dos quais você quer visualizar a agenda */
    professionals: string[] | undefined;
    /** ID's dos procedimentos dos quais você quer visualizar a agenda */
    procedures: number[] | undefined;
    /** Caso você queira obter a lista de agendamentos de um paciente específico */
    patientId: string;
    excludeExternalAppointments: boolean;
    /** Inicio da janela de tempo que você quer listar os agendamentos, exemplo: 19/10/2022 e passando Range = 2 (Weekly) você vai receber a lista de agendamentos da semana do dia 19/10 */
    from: moment.Moment | undefined;
    range: AppointmentsQueryRange;
    showCanceledAppointments: boolean;
    /** ID's das Unidades das quais você quer visualizar a agenda */
    careUnits: number[] | undefined;
    /** ID's dos status de agendamento a serem visualizados */
    appointmentStatus: AppointmentStatus[] | undefined;
    includeForDeletedPatients: boolean;
}

export class GetAppointmentByTokenResult implements IGetAppointmentByTokenResult {
    name: string | undefined;
    logoUrl: string | undefined;
    details: MedicalAppointmentDetails;

    constructor(data?: IGetAppointmentByTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
            this.details = _data["details"] ? MedicalAppointmentDetails.fromJS(_data["details"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppointmentByTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentByTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetAppointmentByTokenResult {
        const json = this.toJSON();
        let result = new GetAppointmentByTokenResult();
        result.init(json);
        return result;
    }
}

export interface IGetAppointmentByTokenResult {
    name: string | undefined;
    logoUrl: string | undefined;
    details: MedicalAppointmentDetails;
}

export class GetMedicalAppointmentSnapshotInput implements IGetMedicalAppointmentSnapshotInput {
    professionalId: string | undefined;
    procedureId: number | undefined;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitId: number | undefined;
    order: string | undefined;
    patientId: string | undefined;
    doesNotSetPatientInsuranceAutomatically: boolean;

    constructor(data?: IGetMedicalAppointmentSnapshotInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionalId = _data["professionalId"];
            this.procedureId = _data["procedureId"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insurancePlanId = _data["insurancePlanId"];
            this.careUnitId = _data["careUnitId"];
            this.order = _data["order"];
            this.patientId = _data["patientId"];
            this.doesNotSetPatientInsuranceAutomatically = _data["doesNotSetPatientInsuranceAutomatically"];
        }
    }

    static fromJS(data: any): GetMedicalAppointmentSnapshotInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalAppointmentSnapshotInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionalId"] = this.professionalId;
        data["procedureId"] = this.procedureId;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insurancePlanId"] = this.insurancePlanId;
        data["careUnitId"] = this.careUnitId;
        data["order"] = this.order;
        data["patientId"] = this.patientId;
        data["doesNotSetPatientInsuranceAutomatically"] = this.doesNotSetPatientInsuranceAutomatically;
        return data; 
    }

    clone(): GetMedicalAppointmentSnapshotInput {
        const json = this.toJSON();
        let result = new GetMedicalAppointmentSnapshotInput();
        result.init(json);
        return result;
    }
}

export interface IGetMedicalAppointmentSnapshotInput {
    professionalId: string | undefined;
    procedureId: number | undefined;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitId: number | undefined;
    order: string | undefined;
    patientId: string | undefined;
    doesNotSetPatientInsuranceAutomatically: boolean;
}

export class SchedulingMedicalProcedure implements ISchedulingMedicalProcedure {
    id: number;
    name: string | undefined;
    duration: number | undefined;
    price: number;
    professionalRequired: boolean;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    maxNumberOfInstallments: number;

    constructor(data?: ISchedulingMedicalProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.professionalRequired = _data["professionalRequired"];
            this.onlinePaymentType = _data["onlinePaymentType"];
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
        }
    }

    static fromJS(data: any): SchedulingMedicalProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulingMedicalProcedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["professionalRequired"] = this.professionalRequired;
        data["onlinePaymentType"] = this.onlinePaymentType;
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        return data; 
    }

    clone(): SchedulingMedicalProcedure {
        const json = this.toJSON();
        let result = new SchedulingMedicalProcedure();
        result.init(json);
        return result;
    }
}

export interface ISchedulingMedicalProcedure {
    id: number;
    name: string | undefined;
    duration: number | undefined;
    price: number;
    professionalRequired: boolean;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    maxNumberOfInstallments: number;
}

export class SchedulingHealthProfessional implements ISchedulingHealthProfessional {
    id: string;
    name: string | undefined;

    constructor(data?: ISchedulingHealthProfessional) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SchedulingHealthProfessional {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulingHealthProfessional();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): SchedulingHealthProfessional {
        const json = this.toJSON();
        let result = new SchedulingHealthProfessional();
        result.init(json);
        return result;
    }
}

export interface ISchedulingHealthProfessional {
    id: string;
    name: string | undefined;
}

export class SchedulingInsuranceCompany implements ISchedulingInsuranceCompany {
    id: number;
    price: number | undefined;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: ISchedulingInsuranceCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): SchedulingInsuranceCompany {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulingInsuranceCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }

    clone(): SchedulingInsuranceCompany {
        const json = this.toJSON();
        let result = new SchedulingInsuranceCompany();
        result.init(json);
        return result;
    }
}

export interface ISchedulingInsuranceCompany {
    id: number;
    price: number | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class SchedulingInsurancePlan implements ISchedulingInsurancePlan {
    id: number;
    price: number | undefined;
    name: string | undefined;

    constructor(data?: ISchedulingInsurancePlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SchedulingInsurancePlan {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulingInsurancePlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["name"] = this.name;
        return data; 
    }

    clone(): SchedulingInsurancePlan {
        const json = this.toJSON();
        let result = new SchedulingInsurancePlan();
        result.init(json);
        return result;
    }
}

export interface ISchedulingInsurancePlan {
    id: number;
    price: number | undefined;
    name: string | undefined;
}

export class SchedulingInsuranceOptions implements ISchedulingInsuranceOptions {
    insuranceCompanies: SchedulingInsuranceCompany[] | undefined;
    insurancePlans: SchedulingInsurancePlan[] | undefined;

    constructor(data?: ISchedulingInsuranceOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insuranceCompanies"])) {
                this.insuranceCompanies = [] as any;
                for (let item of _data["insuranceCompanies"])
                    this.insuranceCompanies.push(SchedulingInsuranceCompany.fromJS(item));
            }
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans.push(SchedulingInsurancePlan.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchedulingInsuranceOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulingInsuranceOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insuranceCompanies)) {
            data["insuranceCompanies"] = [];
            for (let item of this.insuranceCompanies)
                data["insuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SchedulingInsuranceOptions {
        const json = this.toJSON();
        let result = new SchedulingInsuranceOptions();
        result.init(json);
        return result;
    }
}

export interface ISchedulingInsuranceOptions {
    insuranceCompanies: SchedulingInsuranceCompany[] | undefined;
    insurancePlans: SchedulingInsurancePlan[] | undefined;
}

export class SchedulingCareUnit implements ISchedulingCareUnit {
    id: number;
    name: string | undefined;

    constructor(data?: ISchedulingCareUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SchedulingCareUnit {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulingCareUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): SchedulingCareUnit {
        const json = this.toJSON();
        let result = new SchedulingCareUnit();
        result.init(json);
        return result;
    }
}

export interface ISchedulingCareUnit {
    id: number;
    name: string | undefined;
}

export class SchedulingMedicalProcedureResponsibilityTerm implements ISchedulingMedicalProcedureResponsibilityTerm {
    id: number;
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;

    constructor(data?: ISchedulingMedicalProcedureResponsibilityTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.documentUrl = _data["documentUrl"];
            this.signatureRequiredOnlyOnce = _data["signatureRequiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
        }
    }

    static fromJS(data: any): SchedulingMedicalProcedureResponsibilityTerm {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulingMedicalProcedureResponsibilityTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["documentUrl"] = this.documentUrl;
        data["signatureRequiredOnlyOnce"] = this.signatureRequiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        return data; 
    }

    clone(): SchedulingMedicalProcedureResponsibilityTerm {
        const json = this.toJSON();
        let result = new SchedulingMedicalProcedureResponsibilityTerm();
        result.init(json);
        return result;
    }
}

export interface ISchedulingMedicalProcedureResponsibilityTerm {
    id: number;
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
}

export class MedicalAppointmentSnapshot implements IMedicalAppointmentSnapshot {
    procedures: SchedulingMedicalProcedure[] | undefined;
    procedureId: number;
    professionals: SchedulingHealthProfessional[] | undefined;
    professionalId: string | undefined;
    lockedProfessional: boolean;
    insuranceOptions: SchedulingInsuranceOptions;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitOptions: SchedulingCareUnit[] | undefined;
    careUnitId: number | undefined;
    allowOnlinePayment: boolean;
    isPaymentMandatory: boolean;
    responsibilityTerms: SchedulingMedicalProcedureResponsibilityTerm[] | undefined;
    allowedPaymentType: PaymentType[] | undefined;
    dataOnlyEnabled: boolean;

    constructor(data?: IMedicalAppointmentSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["procedures"])) {
                this.procedures = [] as any;
                for (let item of _data["procedures"])
                    this.procedures.push(SchedulingMedicalProcedure.fromJS(item));
            }
            this.procedureId = _data["procedureId"];
            if (Array.isArray(_data["professionals"])) {
                this.professionals = [] as any;
                for (let item of _data["professionals"])
                    this.professionals.push(SchedulingHealthProfessional.fromJS(item));
            }
            this.professionalId = _data["professionalId"];
            this.lockedProfessional = _data["lockedProfessional"];
            this.insuranceOptions = _data["insuranceOptions"] ? SchedulingInsuranceOptions.fromJS(_data["insuranceOptions"]) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insurancePlanId = _data["insurancePlanId"];
            if (Array.isArray(_data["careUnitOptions"])) {
                this.careUnitOptions = [] as any;
                for (let item of _data["careUnitOptions"])
                    this.careUnitOptions.push(SchedulingCareUnit.fromJS(item));
            }
            this.careUnitId = _data["careUnitId"];
            this.allowOnlinePayment = _data["allowOnlinePayment"];
            this.isPaymentMandatory = _data["isPaymentMandatory"];
            if (Array.isArray(_data["responsibilityTerms"])) {
                this.responsibilityTerms = [] as any;
                for (let item of _data["responsibilityTerms"])
                    this.responsibilityTerms.push(SchedulingMedicalProcedureResponsibilityTerm.fromJS(item));
            }
            if (Array.isArray(_data["allowedPaymentType"])) {
                this.allowedPaymentType = [] as any;
                for (let item of _data["allowedPaymentType"])
                    this.allowedPaymentType.push(item);
            }
            this.dataOnlyEnabled = _data["dataOnlyEnabled"];
        }
    }

    static fromJS(data: any): MedicalAppointmentSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.procedures)) {
            data["procedures"] = [];
            for (let item of this.procedures)
                data["procedures"].push(item.toJSON());
        }
        data["procedureId"] = this.procedureId;
        if (Array.isArray(this.professionals)) {
            data["professionals"] = [];
            for (let item of this.professionals)
                data["professionals"].push(item.toJSON());
        }
        data["professionalId"] = this.professionalId;
        data["lockedProfessional"] = this.lockedProfessional;
        data["insuranceOptions"] = this.insuranceOptions ? this.insuranceOptions.toJSON() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insurancePlanId"] = this.insurancePlanId;
        if (Array.isArray(this.careUnitOptions)) {
            data["careUnitOptions"] = [];
            for (let item of this.careUnitOptions)
                data["careUnitOptions"].push(item.toJSON());
        }
        data["careUnitId"] = this.careUnitId;
        data["allowOnlinePayment"] = this.allowOnlinePayment;
        data["isPaymentMandatory"] = this.isPaymentMandatory;
        if (Array.isArray(this.responsibilityTerms)) {
            data["responsibilityTerms"] = [];
            for (let item of this.responsibilityTerms)
                data["responsibilityTerms"].push(item.toJSON());
        }
        if (Array.isArray(this.allowedPaymentType)) {
            data["allowedPaymentType"] = [];
            for (let item of this.allowedPaymentType)
                data["allowedPaymentType"].push(item);
        }
        data["dataOnlyEnabled"] = this.dataOnlyEnabled;
        return data; 
    }

    clone(): MedicalAppointmentSnapshot {
        const json = this.toJSON();
        let result = new MedicalAppointmentSnapshot();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentSnapshot {
    procedures: SchedulingMedicalProcedure[] | undefined;
    procedureId: number;
    professionals: SchedulingHealthProfessional[] | undefined;
    professionalId: string | undefined;
    lockedProfessional: boolean;
    insuranceOptions: SchedulingInsuranceOptions;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitOptions: SchedulingCareUnit[] | undefined;
    careUnitId: number | undefined;
    allowOnlinePayment: boolean;
    isPaymentMandatory: boolean;
    responsibilityTerms: SchedulingMedicalProcedureResponsibilityTerm[] | undefined;
    allowedPaymentType: PaymentType[] | undefined;
    dataOnlyEnabled: boolean;
}

export class ScheduleComplementaryProcedureModel implements IScheduleComplementaryProcedureModel {
    id: number;
    price: number | undefined;

    constructor(data?: IScheduleComplementaryProcedureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ScheduleComplementaryProcedureModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleComplementaryProcedureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        return data; 
    }

    clone(): ScheduleComplementaryProcedureModel {
        const json = this.toJSON();
        let result = new ScheduleComplementaryProcedureModel();
        result.init(json);
        return result;
    }
}

export interface IScheduleComplementaryProcedureModel {
    id: number;
    price: number | undefined;
}

export enum OriginPlatform {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ScheduleMedicalAppointmentInput implements IScheduleMedicalAppointmentInput {
    patientId: string;
    professionalId: string | undefined;
    procedureId: number;
    price: number | undefined;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitId: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    comments: string | undefined;
    cardToken: string | undefined;
    numberOfInstallments: number | undefined;
    recurrence: string | undefined;
    signedTerms: number[] | undefined;
    complementaryProcedures: ScheduleComplementaryProcedureModel[] | undefined;
    paymentType: PaymentType;
    originPlatform: OriginPlatform;
    deviceData: DeviceData;
    billingAddress: Address;

    constructor(data?: IScheduleMedicalAppointmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.professionalId = _data["professionalId"];
            this.procedureId = _data["procedureId"];
            this.price = _data["price"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insurancePlanId = _data["insurancePlanId"];
            this.careUnitId = _data["careUnitId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.cardToken = _data["cardToken"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.recurrence = _data["recurrence"];
            if (Array.isArray(_data["signedTerms"])) {
                this.signedTerms = [] as any;
                for (let item of _data["signedTerms"])
                    this.signedTerms.push(item);
            }
            if (Array.isArray(_data["complementaryProcedures"])) {
                this.complementaryProcedures = [] as any;
                for (let item of _data["complementaryProcedures"])
                    this.complementaryProcedures.push(ScheduleComplementaryProcedureModel.fromJS(item));
            }
            this.paymentType = _data["paymentType"];
            this.originPlatform = _data["originPlatform"];
            this.deviceData = _data["deviceData"] ? DeviceData.fromJS(_data["deviceData"]) : <any>undefined;
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleMedicalAppointmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleMedicalAppointmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["professionalId"] = this.professionalId;
        data["procedureId"] = this.procedureId;
        data["price"] = this.price;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insurancePlanId"] = this.insurancePlanId;
        data["careUnitId"] = this.careUnitId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["cardToken"] = this.cardToken;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["recurrence"] = this.recurrence;
        if (Array.isArray(this.signedTerms)) {
            data["signedTerms"] = [];
            for (let item of this.signedTerms)
                data["signedTerms"].push(item);
        }
        if (Array.isArray(this.complementaryProcedures)) {
            data["complementaryProcedures"] = [];
            for (let item of this.complementaryProcedures)
                data["complementaryProcedures"].push(item.toJSON());
        }
        data["paymentType"] = this.paymentType;
        data["originPlatform"] = this.originPlatform;
        data["deviceData"] = this.deviceData ? this.deviceData.toJSON() : <any>undefined;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ScheduleMedicalAppointmentInput {
        const json = this.toJSON();
        let result = new ScheduleMedicalAppointmentInput();
        result.init(json);
        return result;
    }
}

export interface IScheduleMedicalAppointmentInput {
    patientId: string;
    professionalId: string | undefined;
    procedureId: number;
    price: number | undefined;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitId: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    comments: string | undefined;
    cardToken: string | undefined;
    numberOfInstallments: number | undefined;
    recurrence: string | undefined;
    signedTerms: number[] | undefined;
    complementaryProcedures: ScheduleComplementaryProcedureModel[] | undefined;
    paymentType: PaymentType;
    originPlatform: OriginPlatform;
    deviceData: DeviceData;
    billingAddress: Address;
}

export class ReScheduleAppointmentInput implements IReScheduleAppointmentInput {
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    updateAllRecurrences: boolean;
    rescheduleStatusBehaviour: RescheduleStatusBehaviour;
    askBehaviourOnReschedule: boolean | undefined;
    id: string;

    constructor(data?: IReScheduleAppointmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.updateAllRecurrences = _data["updateAllRecurrences"];
            this.rescheduleStatusBehaviour = _data["rescheduleStatusBehaviour"];
            this.askBehaviourOnReschedule = _data["askBehaviourOnReschedule"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReScheduleAppointmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReScheduleAppointmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updateAllRecurrences"] = this.updateAllRecurrences;
        data["rescheduleStatusBehaviour"] = this.rescheduleStatusBehaviour;
        data["askBehaviourOnReschedule"] = this.askBehaviourOnReschedule;
        data["id"] = this.id;
        return data; 
    }

    clone(): ReScheduleAppointmentInput {
        const json = this.toJSON();
        let result = new ReScheduleAppointmentInput();
        result.init(json);
        return result;
    }
}

export interface IReScheduleAppointmentInput {
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    updateAllRecurrences: boolean;
    rescheduleStatusBehaviour: RescheduleStatusBehaviour;
    askBehaviourOnReschedule: boolean | undefined;
    id: string;
}

export class UpdateScheduleAppointmentInput implements IUpdateScheduleAppointmentInput {
    id: string;
    professionalId: string | undefined;
    procedureId: number;
    price: number | undefined;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitId: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    remotely: boolean;
    comments: string | undefined;
    /** When via web, if the patient confirm the date */
    confirmed: boolean;
    parentRecurrenceId: string | undefined;
    recurrence: string | undefined;
    updateAllRecurrences: boolean;

    constructor(data?: IUpdateScheduleAppointmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionalId = _data["professionalId"];
            this.procedureId = _data["procedureId"];
            this.price = _data["price"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insurancePlanId = _data["insurancePlanId"];
            this.careUnitId = _data["careUnitId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.remotely = _data["remotely"];
            this.comments = _data["comments"];
            this.confirmed = _data["confirmed"];
            this.parentRecurrenceId = _data["parentRecurrenceId"];
            this.recurrence = _data["recurrence"];
            this.updateAllRecurrences = _data["updateAllRecurrences"];
        }
    }

    static fromJS(data: any): UpdateScheduleAppointmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleAppointmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionalId"] = this.professionalId;
        data["procedureId"] = this.procedureId;
        data["price"] = this.price;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insurancePlanId"] = this.insurancePlanId;
        data["careUnitId"] = this.careUnitId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["remotely"] = this.remotely;
        data["comments"] = this.comments;
        data["confirmed"] = this.confirmed;
        data["parentRecurrenceId"] = this.parentRecurrenceId;
        data["recurrence"] = this.recurrence;
        data["updateAllRecurrences"] = this.updateAllRecurrences;
        return data; 
    }

    clone(): UpdateScheduleAppointmentInput {
        const json = this.toJSON();
        let result = new UpdateScheduleAppointmentInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateScheduleAppointmentInput {
    id: string;
    professionalId: string | undefined;
    procedureId: number;
    price: number | undefined;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitId: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    remotely: boolean;
    comments: string | undefined;
    /** When via web, if the patient confirm the date */
    confirmed: boolean;
    parentRecurrenceId: string | undefined;
    recurrence: string | undefined;
    updateAllRecurrences: boolean;
}

export class WaitingMedicalAppointmentDto implements IWaitingMedicalAppointmentDto {
    id: string;
    comments: string | undefined;

    constructor(data?: IWaitingMedicalAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): WaitingMedicalAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaitingMedicalAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): WaitingMedicalAppointmentDto {
        const json = this.toJSON();
        let result = new WaitingMedicalAppointmentDto();
        result.init(json);
        return result;
    }
}

export interface IWaitingMedicalAppointmentDto {
    id: string;
    comments: string | undefined;
}

export class GetActiveMedicalAppointmentForPatientInput implements IGetActiveMedicalAppointmentForPatientInput {
    patientId: string;

    constructor(data?: IGetActiveMedicalAppointmentForPatientInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): GetActiveMedicalAppointmentForPatientInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveMedicalAppointmentForPatientInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        return data; 
    }

    clone(): GetActiveMedicalAppointmentForPatientInput {
        const json = this.toJSON();
        let result = new GetActiveMedicalAppointmentForPatientInput();
        result.init(json);
        return result;
    }
}

export interface IGetActiveMedicalAppointmentForPatientInput {
    patientId: string;
}

export class GetAvailabilityWindowRequest implements IGetAvailabilityWindowRequest {
    doctor: string | undefined;
    procedureId: number;
    careUnitId: number | undefined;
    patientId: string;
    appointmentId: string | undefined;
    insuranceCompany: number | undefined;
    insurancePlanId: number | undefined;

    constructor(data?: IGetAvailabilityWindowRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctor = _data["doctor"];
            this.procedureId = _data["procedureId"];
            this.careUnitId = _data["careUnitId"];
            this.patientId = _data["patientId"];
            this.appointmentId = _data["appointmentId"];
            this.insuranceCompany = _data["insuranceCompany"];
            this.insurancePlanId = _data["insurancePlanId"];
        }
    }

    static fromJS(data: any): GetAvailabilityWindowRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailabilityWindowRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctor"] = this.doctor;
        data["procedureId"] = this.procedureId;
        data["careUnitId"] = this.careUnitId;
        data["patientId"] = this.patientId;
        data["appointmentId"] = this.appointmentId;
        data["insuranceCompany"] = this.insuranceCompany;
        data["insurancePlanId"] = this.insurancePlanId;
        return data; 
    }

    clone(): GetAvailabilityWindowRequest {
        const json = this.toJSON();
        let result = new GetAvailabilityWindowRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAvailabilityWindowRequest {
    doctor: string | undefined;
    procedureId: number;
    careUnitId: number | undefined;
    patientId: string;
    appointmentId: string | undefined;
    insuranceCompany: number | undefined;
    insurancePlanId: number | undefined;
}

export class HealthProfessionalAvailability implements IHealthProfessionalAvailability {
    time: moment.Moment;
    healthProfessional: SchedulingHealthProfessional;

    constructor(data?: IHealthProfessionalAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"] ? moment(_data["time"].toString()) : <any>undefined;
            this.healthProfessional = _data["healthProfessional"] ? SchedulingHealthProfessional.fromJS(_data["healthProfessional"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthProfessionalAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["healthProfessional"] = this.healthProfessional ? this.healthProfessional.toJSON() : <any>undefined;
        return data; 
    }

    clone(): HealthProfessionalAvailability {
        const json = this.toJSON();
        let result = new HealthProfessionalAvailability();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalAvailability {
    time: moment.Moment;
    healthProfessional: SchedulingHealthProfessional;
}

export class ScheduleDateAvailability implements IScheduleDateAvailability {
    date: moment.Moment;
    readonly availability: HealthProfessionalAvailability[] | undefined;

    constructor(data?: IScheduleDateAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["availability"])) {
                (<any>this).availability = [] as any;
                for (let item of _data["availability"])
                    (<any>this).availability.push(HealthProfessionalAvailability.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleDateAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDateAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.availability)) {
            data["availability"] = [];
            for (let item of this.availability)
                data["availability"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ScheduleDateAvailability {
        const json = this.toJSON();
        let result = new ScheduleDateAvailability();
        result.init(json);
        return result;
    }
}

export interface IScheduleDateAvailability {
    date: moment.Moment;
    availability: HealthProfessionalAvailability[] | undefined;
}

export class AddComplementaryProcedureCommand implements IAddComplementaryProcedureCommand {
    appointmentId: string;
    procedureId: number;

    constructor(data?: IAddComplementaryProcedureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.procedureId = _data["procedureId"];
        }
    }

    static fromJS(data: any): AddComplementaryProcedureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddComplementaryProcedureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["procedureId"] = this.procedureId;
        return data; 
    }

    clone(): AddComplementaryProcedureCommand {
        const json = this.toJSON();
        let result = new AddComplementaryProcedureCommand();
        result.init(json);
        return result;
    }
}

export interface IAddComplementaryProcedureCommand {
    appointmentId: string;
    procedureId: number;
}

export class RemoveComplementaryProcedureCommand implements IRemoveComplementaryProcedureCommand {
    appointmentId: string;
    procedureId: number;

    constructor(data?: IRemoveComplementaryProcedureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.procedureId = _data["procedureId"];
        }
    }

    static fromJS(data: any): RemoveComplementaryProcedureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveComplementaryProcedureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["procedureId"] = this.procedureId;
        return data; 
    }

    clone(): RemoveComplementaryProcedureCommand {
        const json = this.toJSON();
        let result = new RemoveComplementaryProcedureCommand();
        result.init(json);
        return result;
    }
}

export interface IRemoveComplementaryProcedureCommand {
    appointmentId: string;
    procedureId: number;
}

export class GetPossibleComplementaryProceduresModel implements IGetPossibleComplementaryProceduresModel {
    appointmentId: string | undefined;
    procedureId: number;
    professionalId: string | undefined;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitId: number | undefined;

    constructor(data?: IGetPossibleComplementaryProceduresModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.procedureId = _data["procedureId"];
            this.professionalId = _data["professionalId"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insurancePlanId = _data["insurancePlanId"];
            this.careUnitId = _data["careUnitId"];
        }
    }

    static fromJS(data: any): GetPossibleComplementaryProceduresModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPossibleComplementaryProceduresModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["procedureId"] = this.procedureId;
        data["professionalId"] = this.professionalId;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insurancePlanId"] = this.insurancePlanId;
        data["careUnitId"] = this.careUnitId;
        return data; 
    }

    clone(): GetPossibleComplementaryProceduresModel {
        const json = this.toJSON();
        let result = new GetPossibleComplementaryProceduresModel();
        result.init(json);
        return result;
    }
}

export interface IGetPossibleComplementaryProceduresModel {
    appointmentId: string | undefined;
    procedureId: number;
    professionalId: string | undefined;
    insuranceCompanyId: number | undefined;
    insurancePlanId: number | undefined;
    careUnitId: number | undefined;
}

export class SignAppointmentResponsibilityTermCommand implements ISignAppointmentResponsibilityTermCommand {
    appointmentId: string;
    term: number;

    constructor(data?: ISignAppointmentResponsibilityTermCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.term = _data["term"];
        }
    }

    static fromJS(data: any): SignAppointmentResponsibilityTermCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SignAppointmentResponsibilityTermCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["term"] = this.term;
        return data; 
    }

    clone(): SignAppointmentResponsibilityTermCommand {
        const json = this.toJSON();
        let result = new SignAppointmentResponsibilityTermCommand();
        result.init(json);
        return result;
    }
}

export interface ISignAppointmentResponsibilityTermCommand {
    appointmentId: string;
    term: number;
}

export enum BankAccountType {
    _1 = 1,
    _2 = 2,
}

export class BankAccountData implements IBankAccountData {
    bankName: string | undefined;
    bankCode: string | undefined;
    agencyCode: string | undefined;
    accountNumber: string | undefined;
    accountType: BankAccountType;

    constructor(data?: IBankAccountData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.agencyCode = _data["agencyCode"];
            this.accountNumber = _data["accountNumber"];
            this.accountType = _data["accountType"];
        }
    }

    static fromJS(data: any): BankAccountData {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["agencyCode"] = this.agencyCode;
        data["accountNumber"] = this.accountNumber;
        data["accountType"] = this.accountType;
        return data; 
    }

    clone(): BankAccountData {
        const json = this.toJSON();
        let result = new BankAccountData();
        result.init(json);
        return result;
    }
}

export interface IBankAccountData {
    bankName: string | undefined;
    bankCode: string | undefined;
    agencyCode: string | undefined;
    accountNumber: string | undefined;
    accountType: BankAccountType;
}

export class CreateMatrixSellerRequest implements ICreateMatrixSellerRequest {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    businessName: string | undefined;
    businessPhoneNumber: string | undefined;
    businessEmail: string | undefined;
    businessTaxPayerId: string | undefined;
    businessAddress: Address;
    bankAccountData: BankAccountData;
    password: string | undefined;
    revenue: number;

    constructor(data?: ICreateMatrixSellerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.businessName = _data["businessName"];
            this.businessPhoneNumber = _data["businessPhoneNumber"];
            this.businessEmail = _data["businessEmail"];
            this.businessTaxPayerId = _data["businessTaxPayerId"];
            this.businessAddress = _data["businessAddress"] ? Address.fromJS(_data["businessAddress"]) : <any>undefined;
            this.bankAccountData = _data["bankAccountData"] ? BankAccountData.fromJS(_data["bankAccountData"]) : <any>undefined;
            this.password = _data["password"];
            this.revenue = _data["revenue"];
        }
    }

    static fromJS(data: any): CreateMatrixSellerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatrixSellerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["businessName"] = this.businessName;
        data["businessPhoneNumber"] = this.businessPhoneNumber;
        data["businessEmail"] = this.businessEmail;
        data["businessTaxPayerId"] = this.businessTaxPayerId;
        data["businessAddress"] = this.businessAddress ? this.businessAddress.toJSON() : <any>undefined;
        data["bankAccountData"] = this.bankAccountData ? this.bankAccountData.toJSON() : <any>undefined;
        data["password"] = this.password;
        data["revenue"] = this.revenue;
        return data; 
    }

    clone(): CreateMatrixSellerRequest {
        const json = this.toJSON();
        let result = new CreateMatrixSellerRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateMatrixSellerRequest {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    businessName: string | undefined;
    businessPhoneNumber: string | undefined;
    businessEmail: string | undefined;
    businessTaxPayerId: string | undefined;
    businessAddress: Address;
    bankAccountData: BankAccountData;
    password: string | undefined;
    revenue: number;
}

export class BankAccount implements IBankAccount {
    type: BankAccountType;
    name: string | undefined;
    lastDigits: string | undefined;

    constructor(data?: IBankAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.lastDigits = _data["lastDigits"];
        }
    }

    static fromJS(data: any): BankAccount {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["lastDigits"] = this.lastDigits;
        return data; 
    }

    clone(): BankAccount {
        const json = this.toJSON();
        let result = new BankAccount();
        result.init(json);
        return result;
    }
}

export interface IBankAccount {
    type: BankAccountType;
    name: string | undefined;
    lastDigits: string | undefined;
}

export enum SellerAccountStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class MatrixSellerDto implements IMatrixSellerDto {
    businessName: string | undefined;
    businessPhoneNumber: string | undefined;
    businessEmail: string | undefined;
    businessTaxPayerId: string | undefined;
    businessAddress: Address;
    maxProcedureNumberOfInstallments: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    isActive: boolean;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMatrixSellerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.businessPhoneNumber = _data["businessPhoneNumber"];
            this.businessEmail = _data["businessEmail"];
            this.businessTaxPayerId = _data["businessTaxPayerId"];
            this.businessAddress = _data["businessAddress"] ? Address.fromJS(_data["businessAddress"]) : <any>undefined;
            this.maxProcedureNumberOfInstallments = _data["maxProcedureNumberOfInstallments"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.bankAccount = _data["bankAccount"] ? BankAccount.fromJS(_data["bankAccount"]) : <any>undefined;
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.revenue = _data["revenue"];
            this.softDescriptor = _data["softDescriptor"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MatrixSellerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixSellerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["businessPhoneNumber"] = this.businessPhoneNumber;
        data["businessEmail"] = this.businessEmail;
        data["businessTaxPayerId"] = this.businessTaxPayerId;
        data["businessAddress"] = this.businessAddress ? this.businessAddress.toJSON() : <any>undefined;
        data["maxProcedureNumberOfInstallments"] = this.maxProcedureNumberOfInstallments;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["revenue"] = this.revenue;
        data["softDescriptor"] = this.softDescriptor;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MatrixSellerDto {
        const json = this.toJSON();
        let result = new MatrixSellerDto();
        result.init(json);
        return result;
    }
}

export interface IMatrixSellerDto {
    businessName: string | undefined;
    businessPhoneNumber: string | undefined;
    businessEmail: string | undefined;
    businessTaxPayerId: string | undefined;
    businessAddress: Address;
    maxProcedureNumberOfInstallments: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    isActive: boolean;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateHealthProfessionalSellerRequest implements ICreateHealthProfessionalSellerRequest {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    healthProfessionalId: string | undefined;
    bankAccountData: BankAccountData;
    password: string | undefined;
    revenue: number;

    constructor(data?: ICreateHealthProfessionalSellerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.bankAccountData = _data["bankAccountData"] ? BankAccountData.fromJS(_data["bankAccountData"]) : <any>undefined;
            this.password = _data["password"];
            this.revenue = _data["revenue"];
        }
    }

    static fromJS(data: any): CreateHealthProfessionalSellerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthProfessionalSellerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["bankAccountData"] = this.bankAccountData ? this.bankAccountData.toJSON() : <any>undefined;
        data["password"] = this.password;
        data["revenue"] = this.revenue;
        return data; 
    }

    clone(): CreateHealthProfessionalSellerRequest {
        const json = this.toJSON();
        let result = new CreateHealthProfessionalSellerRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateHealthProfessionalSellerRequest {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    healthProfessionalId: string | undefined;
    bankAccountData: BankAccountData;
    password: string | undefined;
    revenue: number;
}

export class HealthProfessionalSellerDto implements IHealthProfessionalSellerDto {
    healthProfessionalId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    isActive: boolean;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IHealthProfessionalSellerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.bankAccount = _data["bankAccount"] ? BankAccount.fromJS(_data["bankAccount"]) : <any>undefined;
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.revenue = _data["revenue"];
            this.softDescriptor = _data["softDescriptor"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthProfessionalSellerDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalSellerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["revenue"] = this.revenue;
        data["softDescriptor"] = this.softDescriptor;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthProfessionalSellerDto {
        const json = this.toJSON();
        let result = new HealthProfessionalSellerDto();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalSellerDto {
    healthProfessionalId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    isActive: boolean;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class OrderItem implements IOrderItem {
    order: Order;
    orderId: number;
    procedureId: number;
    quantity: number;
    unitPrice: number;
    discount: number;
    readonly subtotal: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.procedureId = _data["procedureId"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            (<any>this).subtotal = _data["subtotal"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["procedureId"] = this.procedureId;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["subtotal"] = this.subtotal;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderItem {
        const json = this.toJSON();
        let result = new OrderItem();
        result.init(json);
        return result;
    }
}

export interface IOrderItem {
    order: Order;
    orderId: number;
    procedureId: number;
    quantity: number;
    unitPrice: number;
    discount: number;
    subtotal: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Seller implements ISeller {
    discriminator: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    externalId: string | undefined;
    isActive: boolean;
    orderReceivers: Receiver[] | undefined;
    ownedOrders: Order[] | undefined;
    tenantId: number;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    userId: string | undefined;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISeller) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.externalId = _data["externalId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["orderReceivers"])) {
                this.orderReceivers = [] as any;
                for (let item of _data["orderReceivers"])
                    this.orderReceivers.push(Receiver.fromJS(item));
            }
            if (Array.isArray(_data["ownedOrders"])) {
                this.ownedOrders = [] as any;
                for (let item of _data["ownedOrders"])
                    this.ownedOrders.push(Order.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.bankAccount = _data["bankAccount"] ? BankAccount.fromJS(_data["bankAccount"]) : <any>undefined;
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.revenue = _data["revenue"];
            this.softDescriptor = _data["softDescriptor"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Seller {
        data = typeof data === 'object' ? data : {};
        let result = new Seller();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["externalId"] = this.externalId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.orderReceivers)) {
            data["orderReceivers"] = [];
            for (let item of this.orderReceivers)
                data["orderReceivers"].push(item.toJSON());
        }
        if (Array.isArray(this.ownedOrders)) {
            data["ownedOrders"] = [];
            for (let item of this.ownedOrders)
                data["ownedOrders"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["revenue"] = this.revenue;
        data["softDescriptor"] = this.softDescriptor;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Seller {
        const json = this.toJSON();
        let result = new Seller();
        result.init(json);
        return result;
    }
}

export interface ISeller {
    discriminator: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    externalId: string | undefined;
    isActive: boolean;
    orderReceivers: Receiver[] | undefined;
    ownedOrders: Order[] | undefined;
    tenantId: number;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    userId: string | undefined;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class BuyerCard implements IBuyerCard {
    buyer: Buyer;
    buyerId: number;
    cardId: string | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBuyerCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buyer = _data["buyer"] ? Buyer.fromJS(_data["buyer"]) : <any>undefined;
            this.buyerId = _data["buyerId"];
            this.cardId = _data["cardId"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BuyerCard {
        data = typeof data === 'object' ? data : {};
        let result = new BuyerCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>undefined;
        data["buyerId"] = this.buyerId;
        data["cardId"] = this.cardId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): BuyerCard {
        const json = this.toJSON();
        let result = new BuyerCard();
        result.init(json);
        return result;
    }
}

export interface IBuyerCard {
    buyer: Buyer;
    buyerId: number;
    cardId: string | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Buyer implements IBuyer {
    patientId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    externalId: string | undefined;
    cards: BuyerCard[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBuyer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards.push(BuyerCard.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Buyer {
        data = typeof data === 'object' ? data : {};
        let result = new Buyer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Buyer {
        const json = this.toJSON();
        let result = new Buyer();
        result.init(json);
        return result;
    }
}

export interface IBuyer {
    patientId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    externalId: string | undefined;
    cards: BuyerCard[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum OrderState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class Pix implements IPix {
    code: string | undefined;
    expirationDate: moment.Moment;

    constructor(data?: IPix) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Pix {
        data = typeof data === 'object' ? data : {};
        let result = new Pix();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): Pix {
        const json = this.toJSON();
        let result = new Pix();
        result.init(json);
        return result;
    }
}

export interface IPix {
    code: string | undefined;
    expirationDate: moment.Moment;
}

export class PaymentTransaction implements IPaymentTransaction {
    order: Order;
    orderId: number;
    currency: string | undefined;
    paymentType: PaymentType;
    numberOfInstallments: number;
    transactionId: string | undefined;
    receiptId: string | undefined;
    tenantId: number;
    pix: Pix;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPaymentTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.currency = _data["currency"];
            this.paymentType = _data["paymentType"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.transactionId = _data["transactionId"];
            this.receiptId = _data["receiptId"];
            this.tenantId = _data["tenantId"];
            this.pix = _data["pix"] ? Pix.fromJS(_data["pix"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PaymentTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["currency"] = this.currency;
        data["paymentType"] = this.paymentType;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["transactionId"] = this.transactionId;
        data["receiptId"] = this.receiptId;
        data["tenantId"] = this.tenantId;
        data["pix"] = this.pix ? this.pix.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PaymentTransaction {
        const json = this.toJSON();
        let result = new PaymentTransaction();
        result.init(json);
        return result;
    }
}

export interface IPaymentTransaction {
    order: Order;
    orderId: number;
    currency: string | undefined;
    paymentType: PaymentType;
    numberOfInstallments: number;
    transactionId: string | undefined;
    receiptId: string | undefined;
    tenantId: number;
    pix: Pix;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Order implements IOrder {
    items: OrderItem[] | undefined;
    discount: number;
    total: number;
    seller: Seller;
    sellerId: number;
    receivers: Receiver[] | undefined;
    buyer: Buyer;
    buyerId: number;
    state: OrderState;
    transactions: PaymentTransaction[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderItem.fromJS(item));
            }
            this.discount = _data["discount"];
            this.total = _data["total"];
            this.seller = _data["seller"] ? Seller.fromJS(_data["seller"]) : <any>undefined;
            this.sellerId = _data["sellerId"];
            if (Array.isArray(_data["receivers"])) {
                this.receivers = [] as any;
                for (let item of _data["receivers"])
                    this.receivers.push(Receiver.fromJS(item));
            }
            this.buyer = _data["buyer"] ? Buyer.fromJS(_data["buyer"]) : <any>undefined;
            this.buyerId = _data["buyerId"];
            this.state = _data["state"];
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(PaymentTransaction.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["discount"] = this.discount;
        data["total"] = this.total;
        data["seller"] = this.seller ? this.seller.toJSON() : <any>undefined;
        data["sellerId"] = this.sellerId;
        if (Array.isArray(this.receivers)) {
            data["receivers"] = [];
            for (let item of this.receivers)
                data["receivers"].push(item.toJSON());
        }
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>undefined;
        data["buyerId"] = this.buyerId;
        data["state"] = this.state;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder {
    items: OrderItem[] | undefined;
    discount: number;
    total: number;
    seller: Seller;
    sellerId: number;
    receivers: Receiver[] | undefined;
    buyer: Buyer;
    buyerId: number;
    state: OrderState;
    transactions: PaymentTransaction[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Receiver implements IReceiver {
    order: Order;
    orderId: number;
    seller: Seller;
    sellerId: number;
    percentage: number | undefined;
    amount: number | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IReceiver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.seller = _data["seller"] ? Seller.fromJS(_data["seller"]) : <any>undefined;
            this.sellerId = _data["sellerId"];
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Receiver {
        data = typeof data === 'object' ? data : {};
        let result = new Receiver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["seller"] = this.seller ? this.seller.toJSON() : <any>undefined;
        data["sellerId"] = this.sellerId;
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Receiver {
        const json = this.toJSON();
        let result = new Receiver();
        result.init(json);
        return result;
    }
}

export interface IReceiver {
    order: Order;
    orderId: number;
    seller: Seller;
    sellerId: number;
    percentage: number | undefined;
    amount: number | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MatrixSeller implements IMatrixSeller {
    businessName: string | undefined;
    businessPhoneNumber: string | undefined;
    businessEmail: string | undefined;
    businessTaxPayerId: string | undefined;
    businessAddress: Address;
    maxProcedureNumberOfInstallments: number;
    discriminator: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    externalId: string | undefined;
    isActive: boolean;
    orderReceivers: Receiver[] | undefined;
    ownedOrders: Order[] | undefined;
    tenantId: number;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    userId: string | undefined;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMatrixSeller) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.businessPhoneNumber = _data["businessPhoneNumber"];
            this.businessEmail = _data["businessEmail"];
            this.businessTaxPayerId = _data["businessTaxPayerId"];
            this.businessAddress = _data["businessAddress"] ? Address.fromJS(_data["businessAddress"]) : <any>undefined;
            this.maxProcedureNumberOfInstallments = _data["maxProcedureNumberOfInstallments"];
            this.discriminator = _data["discriminator"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.externalId = _data["externalId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["orderReceivers"])) {
                this.orderReceivers = [] as any;
                for (let item of _data["orderReceivers"])
                    this.orderReceivers.push(Receiver.fromJS(item));
            }
            if (Array.isArray(_data["ownedOrders"])) {
                this.ownedOrders = [] as any;
                for (let item of _data["ownedOrders"])
                    this.ownedOrders.push(Order.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.bankAccount = _data["bankAccount"] ? BankAccount.fromJS(_data["bankAccount"]) : <any>undefined;
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.revenue = _data["revenue"];
            this.softDescriptor = _data["softDescriptor"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MatrixSeller {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixSeller();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["businessPhoneNumber"] = this.businessPhoneNumber;
        data["businessEmail"] = this.businessEmail;
        data["businessTaxPayerId"] = this.businessTaxPayerId;
        data["businessAddress"] = this.businessAddress ? this.businessAddress.toJSON() : <any>undefined;
        data["maxProcedureNumberOfInstallments"] = this.maxProcedureNumberOfInstallments;
        data["discriminator"] = this.discriminator;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["externalId"] = this.externalId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.orderReceivers)) {
            data["orderReceivers"] = [];
            for (let item of this.orderReceivers)
                data["orderReceivers"].push(item.toJSON());
        }
        if (Array.isArray(this.ownedOrders)) {
            data["ownedOrders"] = [];
            for (let item of this.ownedOrders)
                data["ownedOrders"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["revenue"] = this.revenue;
        data["softDescriptor"] = this.softDescriptor;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MatrixSeller {
        const json = this.toJSON();
        let result = new MatrixSeller();
        result.init(json);
        return result;
    }
}

export interface IMatrixSeller {
    businessName: string | undefined;
    businessPhoneNumber: string | undefined;
    businessEmail: string | undefined;
    businessTaxPayerId: string | undefined;
    businessAddress: Address;
    maxProcedureNumberOfInstallments: number;
    discriminator: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    externalId: string | undefined;
    isActive: boolean;
    orderReceivers: Receiver[] | undefined;
    ownedOrders: Order[] | undefined;
    tenantId: number;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    userId: string | undefined;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class HealthProfessionalSeller implements IHealthProfessionalSeller {
    healthProfessionalId: string;
    discriminator: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    externalId: string | undefined;
    isActive: boolean;
    orderReceivers: Receiver[] | undefined;
    ownedOrders: Order[] | undefined;
    tenantId: number;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    userId: string | undefined;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IHealthProfessionalSeller) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.discriminator = _data["discriminator"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.externalId = _data["externalId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["orderReceivers"])) {
                this.orderReceivers = [] as any;
                for (let item of _data["orderReceivers"])
                    this.orderReceivers.push(Receiver.fromJS(item));
            }
            if (Array.isArray(_data["ownedOrders"])) {
                this.ownedOrders = [] as any;
                for (let item of _data["ownedOrders"])
                    this.ownedOrders.push(Order.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.bankAccount = _data["bankAccount"] ? BankAccount.fromJS(_data["bankAccount"]) : <any>undefined;
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.revenue = _data["revenue"];
            this.softDescriptor = _data["softDescriptor"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthProfessionalSeller {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalSeller();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["discriminator"] = this.discriminator;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["externalId"] = this.externalId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.orderReceivers)) {
            data["orderReceivers"] = [];
            for (let item of this.orderReceivers)
                data["orderReceivers"].push(item.toJSON());
        }
        if (Array.isArray(this.ownedOrders)) {
            data["ownedOrders"] = [];
            for (let item of this.ownedOrders)
                data["ownedOrders"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["revenue"] = this.revenue;
        data["softDescriptor"] = this.softDescriptor;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthProfessionalSeller {
        const json = this.toJSON();
        let result = new HealthProfessionalSeller();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalSeller {
    healthProfessionalId: string;
    discriminator: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    externalId: string | undefined;
    isActive: boolean;
    orderReceivers: Receiver[] | undefined;
    ownedOrders: Order[] | undefined;
    tenantId: number;
    bankAccount: BankAccount;
    status: SellerAccountStatus;
    userId: string | undefined;
    revenue: number;
    softDescriptor: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class SellerRegistrationModel implements ISellerRegistrationModel {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    businessName: string | undefined;
    businessPhoneNumber: string | undefined;
    businessEmail: string | undefined;
    businessTaxPayerId: string | undefined;
    businessAddress: Address;
    isMatrix: boolean;

    constructor(data?: ISellerRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.activityCode = _data["activityCode"];
            this.businessName = _data["businessName"];
            this.businessPhoneNumber = _data["businessPhoneNumber"];
            this.businessEmail = _data["businessEmail"];
            this.businessTaxPayerId = _data["businessTaxPayerId"];
            this.businessAddress = _data["businessAddress"] ? Address.fromJS(_data["businessAddress"]) : <any>undefined;
            this.isMatrix = _data["isMatrix"];
        }
    }

    static fromJS(data: any): SellerRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SellerRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["activityCode"] = this.activityCode;
        data["businessName"] = this.businessName;
        data["businessPhoneNumber"] = this.businessPhoneNumber;
        data["businessEmail"] = this.businessEmail;
        data["businessTaxPayerId"] = this.businessTaxPayerId;
        data["businessAddress"] = this.businessAddress ? this.businessAddress.toJSON() : <any>undefined;
        data["isMatrix"] = this.isMatrix;
        return data; 
    }

    clone(): SellerRegistrationModel {
        const json = this.toJSON();
        let result = new SellerRegistrationModel();
        result.init(json);
        return result;
    }
}

export interface ISellerRegistrationModel {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    taxPayerId: string | undefined;
    address: Address;
    birthday: moment.Moment;
    activityCode: string | undefined;
    businessName: string | undefined;
    businessPhoneNumber: string | undefined;
    businessEmail: string | undefined;
    businessTaxPayerId: string | undefined;
    businessAddress: Address;
    isMatrix: boolean;
}

export class IsAllowedToAcceptPaymentsQuery implements IIsAllowedToAcceptPaymentsQuery {
    tenantId: number | undefined;

    constructor(data?: IIsAllowedToAcceptPaymentsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsAllowedToAcceptPaymentsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new IsAllowedToAcceptPaymentsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): IsAllowedToAcceptPaymentsQuery {
        const json = this.toJSON();
        let result = new IsAllowedToAcceptPaymentsQuery();
        result.init(json);
        return result;
    }
}

export interface IIsAllowedToAcceptPaymentsQuery {
    tenantId: number | undefined;
}

export class IsAllowedToAcceptPaymentsResult implements IIsAllowedToAcceptPaymentsResult {
    allowed: boolean;
    maxProcedureNumberOfInstallments: number;

    constructor(data?: IIsAllowedToAcceptPaymentsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowed = _data["allowed"];
            this.maxProcedureNumberOfInstallments = _data["maxProcedureNumberOfInstallments"];
        }
    }

    static fromJS(data: any): IsAllowedToAcceptPaymentsResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsAllowedToAcceptPaymentsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowed"] = this.allowed;
        data["maxProcedureNumberOfInstallments"] = this.maxProcedureNumberOfInstallments;
        return data; 
    }

    clone(): IsAllowedToAcceptPaymentsResult {
        const json = this.toJSON();
        let result = new IsAllowedToAcceptPaymentsResult();
        result.init(json);
        return result;
    }
}

export interface IIsAllowedToAcceptPaymentsResult {
    allowed: boolean;
    maxProcedureNumberOfInstallments: number;
}

export class UpdateSellerMaxProcedureNumberOfInstallmentsCommand implements IUpdateSellerMaxProcedureNumberOfInstallmentsCommand {
    maxNumberOfInstallments: number;

    constructor(data?: IUpdateSellerMaxProcedureNumberOfInstallmentsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
        }
    }

    static fromJS(data: any): UpdateSellerMaxProcedureNumberOfInstallmentsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSellerMaxProcedureNumberOfInstallmentsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        return data; 
    }

    clone(): UpdateSellerMaxProcedureNumberOfInstallmentsCommand {
        const json = this.toJSON();
        let result = new UpdateSellerMaxProcedureNumberOfInstallmentsCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateSellerMaxProcedureNumberOfInstallmentsCommand {
    maxNumberOfInstallments: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = this.features[key];
            }
        }
        return data; 
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    gender: number | undefined;
    birthday: moment.Moment;
    personalIdentifier: string | undefined;
    phoneNumber: string | undefined;
    avatar: string | undefined;
    roleNames: string[] | undefined;
    hasActiveInvitation: boolean;
    firstActiveInvitation: string;
    userHash: string | undefined;
    creationTime: moment.Moment;
    creationTimeEpoch: number;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.gender = _data["gender"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.personalIdentifier = _data["personalIdentifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.avatar = _data["avatar"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.hasActiveInvitation = _data["hasActiveInvitation"];
            this.firstActiveInvitation = _data["firstActiveInvitation"];
            this.userHash = _data["userHash"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creationTimeEpoch = _data["creationTimeEpoch"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["personalIdentifier"] = this.personalIdentifier;
        data["phoneNumber"] = this.phoneNumber;
        data["avatar"] = this.avatar;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["hasActiveInvitation"] = this.hasActiveInvitation;
        data["firstActiveInvitation"] = this.firstActiveInvitation;
        data["userHash"] = this.userHash;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creationTimeEpoch"] = this.creationTimeEpoch;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    gender: number | undefined;
    birthday: moment.Moment;
    personalIdentifier: string | undefined;
    phoneNumber: string | undefined;
    avatar: string | undefined;
    roleNames: string[] | undefined;
    hasActiveInvitation: boolean;
    firstActiveInvitation: string;
    userHash: string | undefined;
    creationTime: moment.Moment;
    creationTimeEpoch: number;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionId: number;
    hasMobileApplication: boolean;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionId = _data["editionId"];
            this.hasMobileApplication = _data["hasMobileApplication"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionId"] = this.editionId;
        data["hasMobileApplication"] = this.hasMobileApplication;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionId: number;
    hasMobileApplication: boolean;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    otherTenants: TenantLoginInfoDto[] | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            if (Array.isArray(_data["otherTenants"])) {
                this.otherTenants = [] as any;
                for (let item of _data["otherTenants"])
                    this.otherTenants.push(TenantLoginInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        if (Array.isArray(this.otherTenants)) {
            data["otherTenants"] = [];
            for (let item of this.otherTenants)
                data["otherTenants"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    otherTenants: TenantLoginInfoDto[] | undefined;
}

export class Profession implements IProfession {
    code: number | undefined;
    specialty: number | undefined;
    specialtyRegistry: string | undefined;
    details: string | undefined;
    readonly isValid: boolean;

    constructor(data?: IProfession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.specialty = _data["specialty"];
            this.specialtyRegistry = _data["specialtyRegistry"];
            this.details = _data["details"];
            (<any>this).isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): Profession {
        data = typeof data === 'object' ? data : {};
        let result = new Profession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["specialty"] = this.specialty;
        data["specialtyRegistry"] = this.specialtyRegistry;
        data["details"] = this.details;
        data["isValid"] = this.isValid;
        return data; 
    }

    clone(): Profession {
        const json = this.toJSON();
        let result = new Profession();
        result.init(json);
        return result;
    }
}

export interface IProfession {
    code: number | undefined;
    specialty: number | undefined;
    specialtyRegistry: string | undefined;
    details: string | undefined;
    isValid: boolean;
}

export class MedicalProcedureCoveredByInsurancePlan implements IMedicalProcedureCoveredByInsurancePlan {
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    insurancePlan: InsurancePlan;
    insurancePlanId: number;
    price: number | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IMedicalProcedureCoveredByInsurancePlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedure.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.insurancePlan = _data["insurancePlan"] ? InsurancePlan.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.insurancePlanId = _data["insurancePlanId"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByInsurancePlan {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByInsurancePlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["insurancePlanId"] = this.insurancePlanId;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByInsurancePlan {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByInsurancePlan();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByInsurancePlan {
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    insurancePlan: InsurancePlan;
    insurancePlanId: number;
    price: number | undefined;
    tenantId: number;
    id: number;
}

export class Examination implements IExamination {
    doctor: Doctor;
    patient: Patient;
    patientId: string;
    examinationDescription: string | undefined;
    description: string | undefined;
    doctorId: string;
    tenantId: number;
    externalId: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IExamination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctor = _data["doctor"] ? Doctor.fromJS(_data["doctor"]) : <any>undefined;
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.patientId = _data["patientId"];
            this.examinationDescription = _data["examinationDescription"];
            this.description = _data["description"];
            this.doctorId = _data["doctorId"];
            this.tenantId = _data["tenantId"];
            this.externalId = _data["externalId"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): Examination {
        data = typeof data === 'object' ? data : {};
        let result = new Examination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["patientId"] = this.patientId;
        data["examinationDescription"] = this.examinationDescription;
        data["description"] = this.description;
        data["doctorId"] = this.doctorId;
        data["tenantId"] = this.tenantId;
        data["externalId"] = this.externalId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): Examination {
        const json = this.toJSON();
        let result = new Examination();
        result.init(json);
        return result;
    }
}

export interface IExamination {
    doctor: Doctor;
    patient: Patient;
    patientId: string;
    examinationDescription: string | undefined;
    description: string | undefined;
    doctorId: string;
    tenantId: number;
    externalId: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class MedicalAppointmentLock implements IMedicalAppointmentLock {
    healthProfessional: HealthProfessional;
    patient: Patient;
    patientId: string;
    healthProfessionalId: string | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalAppointmentLock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthProfessional = _data["healthProfessional"] ? HealthProfessional.fromJS(_data["healthProfessional"]) : <any>undefined;
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.patientId = _data["patientId"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalAppointmentLock {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentLock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthProfessional"] = this.healthProfessional ? this.healthProfessional.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["patientId"] = this.patientId;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalAppointmentLock {
        const json = this.toJSON();
        let result = new MedicalAppointmentLock();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentLock {
    healthProfessional: HealthProfessional;
    patient: Patient;
    patientId: string;
    healthProfessionalId: string | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Person implements IPerson {
    name: string | undefined;
    phoneNumber: string | undefined;
    birthday: number | undefined;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.birthday = _data["birthday"];
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["birthday"] = this.birthday;
        return data; 
    }

    clone(): Person {
        const json = this.toJSON();
        let result = new Person();
        result.init(json);
        return result;
    }
}

export interface IPerson {
    name: string | undefined;
    phoneNumber: string | undefined;
    birthday: number | undefined;
}

export enum MaritalStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class PatientProfessionalRelationship implements IPatientProfessionalRelationship {
    professional: HealthProfessional;
    patientId: string;
    patient: Patient;
    healthProfessionalId: string;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPatientProfessionalRelationship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professional = _data["professional"] ? HealthProfessional.fromJS(_data["professional"]) : <any>undefined;
            this.patientId = _data["patientId"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PatientProfessionalRelationship {
        data = typeof data === 'object' ? data : {};
        let result = new PatientProfessionalRelationship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        data["patientId"] = this.patientId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PatientProfessionalRelationship {
        const json = this.toJSON();
        let result = new PatientProfessionalRelationship();
        result.init(json);
        return result;
    }
}

export interface IPatientProfessionalRelationship {
    professional: HealthProfessional;
    patientId: string;
    patient: Patient;
    healthProfessionalId: string;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Patient implements IPatient {
    tenantId: number;
    user: User;
    userId: number | undefined;
    bloodType: string | undefined;
    weight: number | undefined;
    height: number | undefined;
    exams: Examination[] | undefined;
    personalIdentifier: string | undefined;
    name: string | undefined;
    gender: number;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    phone: string | undefined;
    fixedPhone: string | undefined;
    address: Address;
    externalId: string | undefined;
    dni: string | undefined;
    comments: string | undefined;
    locks: MedicalAppointmentLock[] | undefined;
    insurance: PatientInsurance;
    partner: Person;
    mother: Person;
    father: Person;
    sponsor: Person;
    tags: number;
    maritalStatus: MaritalStatus;
    profession: string | undefined;
    knownChannel: string | undefined;
    status: PatientStatus;
    professionals: PatientProfessionalRelationship[] | undefined;
    sequentialNumber: number;
    photo: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.bloodType = _data["bloodType"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            if (Array.isArray(_data["exams"])) {
                this.exams = [] as any;
                for (let item of _data["exams"])
                    this.exams.push(Examination.fromJS(item));
            }
            this.personalIdentifier = _data["personalIdentifier"];
            this.name = _data["name"];
            this.gender = _data["gender"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.fixedPhone = _data["fixedPhone"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.externalId = _data["externalId"];
            this.dni = _data["dni"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["locks"])) {
                this.locks = [] as any;
                for (let item of _data["locks"])
                    this.locks.push(MedicalAppointmentLock.fromJS(item));
            }
            this.insurance = _data["insurance"] ? PatientInsurance.fromJS(_data["insurance"]) : <any>undefined;
            this.partner = _data["partner"] ? Person.fromJS(_data["partner"]) : <any>undefined;
            this.mother = _data["mother"] ? Person.fromJS(_data["mother"]) : <any>undefined;
            this.father = _data["father"] ? Person.fromJS(_data["father"]) : <any>undefined;
            this.sponsor = _data["sponsor"] ? Person.fromJS(_data["sponsor"]) : <any>undefined;
            this.tags = _data["tags"];
            this.maritalStatus = _data["maritalStatus"];
            this.profession = _data["profession"];
            this.knownChannel = _data["knownChannel"];
            this.status = _data["status"];
            if (Array.isArray(_data["professionals"])) {
                this.professionals = [] as any;
                for (let item of _data["professionals"])
                    this.professionals.push(PatientProfessionalRelationship.fromJS(item));
            }
            this.sequentialNumber = _data["sequentialNumber"];
            this.photo = _data["photo"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): Patient {
        data = typeof data === 'object' ? data : {};
        let result = new Patient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["bloodType"] = this.bloodType;
        data["weight"] = this.weight;
        data["height"] = this.height;
        if (Array.isArray(this.exams)) {
            data["exams"] = [];
            for (let item of this.exams)
                data["exams"].push(item.toJSON());
        }
        data["personalIdentifier"] = this.personalIdentifier;
        data["name"] = this.name;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["fixedPhone"] = this.fixedPhone;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["externalId"] = this.externalId;
        data["dni"] = this.dni;
        data["comments"] = this.comments;
        if (Array.isArray(this.locks)) {
            data["locks"] = [];
            for (let item of this.locks)
                data["locks"].push(item.toJSON());
        }
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>undefined;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        data["mother"] = this.mother ? this.mother.toJSON() : <any>undefined;
        data["father"] = this.father ? this.father.toJSON() : <any>undefined;
        data["sponsor"] = this.sponsor ? this.sponsor.toJSON() : <any>undefined;
        data["tags"] = this.tags;
        data["maritalStatus"] = this.maritalStatus;
        data["profession"] = this.profession;
        data["knownChannel"] = this.knownChannel;
        data["status"] = this.status;
        if (Array.isArray(this.professionals)) {
            data["professionals"] = [];
            for (let item of this.professionals)
                data["professionals"].push(item.toJSON());
        }
        data["sequentialNumber"] = this.sequentialNumber;
        data["photo"] = this.photo;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): Patient {
        const json = this.toJSON();
        let result = new Patient();
        result.init(json);
        return result;
    }
}

export interface IPatient {
    tenantId: number;
    user: User;
    userId: number | undefined;
    bloodType: string | undefined;
    weight: number | undefined;
    height: number | undefined;
    exams: Examination[] | undefined;
    personalIdentifier: string | undefined;
    name: string | undefined;
    gender: number;
    birthday: moment.Moment | undefined;
    email: string | undefined;
    phone: string | undefined;
    fixedPhone: string | undefined;
    address: Address;
    externalId: string | undefined;
    dni: string | undefined;
    comments: string | undefined;
    locks: MedicalAppointmentLock[] | undefined;
    insurance: PatientInsurance;
    partner: Person;
    mother: Person;
    father: Person;
    sponsor: Person;
    tags: number;
    maritalStatus: MaritalStatus;
    profession: string | undefined;
    knownChannel: string | undefined;
    status: PatientStatus;
    professionals: PatientProfessionalRelationship[] | undefined;
    sequentialNumber: number;
    photo: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class MedicalAgreement implements IMedicalAgreement {
    name: string | undefined;
    doctor: Doctor;
    doctorId: string;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IMedicalAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.doctor = _data["doctor"] ? Doctor.fromJS(_data["doctor"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): MedicalAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): MedicalAgreement {
        const json = this.toJSON();
        let result = new MedicalAgreement();
        result.init(json);
        return result;
    }
}

export interface IMedicalAgreement {
    name: string | undefined;
    doctor: Doctor;
    doctorId: string;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class HealthPlan implements IHealthPlan {
    medicalAgreement: MedicalAgreement;
    name: string | undefined;
    doctor: Doctor;
    doctorId: string;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IHealthPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalAgreement = _data["medicalAgreement"] ? MedicalAgreement.fromJS(_data["medicalAgreement"]) : <any>undefined;
            this.name = _data["name"];
            this.doctor = _data["doctor"] ? Doctor.fromJS(_data["doctor"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): HealthPlan {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalAgreement"] = this.medicalAgreement ? this.medicalAgreement.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): HealthPlan {
        const json = this.toJSON();
        let result = new HealthPlan();
        result.init(json);
        return result;
    }
}

export interface IHealthPlan {
    medicalAgreement: MedicalAgreement;
    name: string | undefined;
    doctor: Doctor;
    doctorId: string;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class HealthCareUnitContactEmail implements IHealthCareUnitContactEmail {
    healthCareUnit: HealthCareUnit;
    healthCareUnitId: number;
    discriminator: ContactEmailDiscriminator;
    email: string | undefined;
    id: number;

    constructor(data?: IHealthCareUnitContactEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthCareUnit = _data["healthCareUnit"] ? HealthCareUnit.fromJS(_data["healthCareUnit"]) : <any>undefined;
            this.healthCareUnitId = _data["healthCareUnitId"];
            this.discriminator = _data["discriminator"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthCareUnitContactEmail {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCareUnitContactEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthCareUnit"] = this.healthCareUnit ? this.healthCareUnit.toJSON() : <any>undefined;
        data["healthCareUnitId"] = this.healthCareUnitId;
        data["discriminator"] = this.discriminator;
        data["email"] = this.email;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthCareUnitContactEmail {
        const json = this.toJSON();
        let result = new HealthCareUnitContactEmail();
        result.init(json);
        return result;
    }
}

export interface IHealthCareUnitContactEmail {
    healthCareUnit: HealthCareUnit;
    healthCareUnitId: number;
    discriminator: ContactEmailDiscriminator;
    email: string | undefined;
    id: number;
}

export class HealthCareUnitPhone implements IHealthCareUnitPhone {
    healthCareUnit: HealthCareUnit;
    healthCareUnitId: number;
    discriminator: PhoneNumberDiscriminator;
    number: string | undefined;
    isLandline: boolean;
    isWhatsApp: boolean;
    id: number;

    constructor(data?: IHealthCareUnitPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthCareUnit = _data["healthCareUnit"] ? HealthCareUnit.fromJS(_data["healthCareUnit"]) : <any>undefined;
            this.healthCareUnitId = _data["healthCareUnitId"];
            this.discriminator = _data["discriminator"];
            this.number = _data["number"];
            this.isLandline = _data["isLandline"];
            this.isWhatsApp = _data["isWhatsApp"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthCareUnitPhone {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCareUnitPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthCareUnit"] = this.healthCareUnit ? this.healthCareUnit.toJSON() : <any>undefined;
        data["healthCareUnitId"] = this.healthCareUnitId;
        data["discriminator"] = this.discriminator;
        data["number"] = this.number;
        data["isLandline"] = this.isLandline;
        data["isWhatsApp"] = this.isWhatsApp;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthCareUnitPhone {
        const json = this.toJSON();
        let result = new HealthCareUnitPhone();
        result.init(json);
        return result;
    }
}

export interface IHealthCareUnitPhone {
    healthCareUnit: HealthCareUnit;
    healthCareUnitId: number;
    discriminator: PhoneNumberDiscriminator;
    number: string | undefined;
    isLandline: boolean;
    isWhatsApp: boolean;
    id: number;
}

export class MedicalProcedureCoveredInHealthCareUnit implements IMedicalProcedureCoveredInHealthCareUnit {
    healthCareUnit: HealthCareUnit;
    healthCareUnitId: number;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    isActive: boolean;
    workJourney: string | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IMedicalProcedureCoveredInHealthCareUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthCareUnit = _data["healthCareUnit"] ? HealthCareUnit.fromJS(_data["healthCareUnit"]) : <any>undefined;
            this.healthCareUnitId = _data["healthCareUnitId"];
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedure.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.isActive = _data["isActive"];
            this.workJourney = _data["workJourney"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredInHealthCareUnit {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredInHealthCareUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthCareUnit"] = this.healthCareUnit ? this.healthCareUnit.toJSON() : <any>undefined;
        data["healthCareUnitId"] = this.healthCareUnitId;
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["isActive"] = this.isActive;
        data["workJourney"] = this.workJourney;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredInHealthCareUnit {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredInHealthCareUnit();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredInHealthCareUnit {
    healthCareUnit: HealthCareUnit;
    healthCareUnitId: number;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    isActive: boolean;
    workJourney: string | undefined;
    tenantId: number;
    id: number;
}

export class HealthProfessionalCareUnitMedicalProcedure implements IHealthProfessionalCareUnitMedicalProcedure {
    professional: HealthProfessional;
    professionalId: string;
    careUnit: HealthCareUnit;
    careUnitId: number;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    workJourney: string | undefined;
    isActive: boolean;
    tenantId: number;
    id: number;

    constructor(data?: IHealthProfessionalCareUnitMedicalProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professional = _data["professional"] ? HealthProfessional.fromJS(_data["professional"]) : <any>undefined;
            this.professionalId = _data["professionalId"];
            this.careUnit = _data["careUnit"] ? HealthCareUnit.fromJS(_data["careUnit"]) : <any>undefined;
            this.careUnitId = _data["careUnitId"];
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedure.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.workJourney = _data["workJourney"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthProfessionalCareUnitMedicalProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalCareUnitMedicalProcedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        data["professionalId"] = this.professionalId;
        data["careUnit"] = this.careUnit ? this.careUnit.toJSON() : <any>undefined;
        data["careUnitId"] = this.careUnitId;
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["workJourney"] = this.workJourney;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthProfessionalCareUnitMedicalProcedure {
        const json = this.toJSON();
        let result = new HealthProfessionalCareUnitMedicalProcedure();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalCareUnitMedicalProcedure {
    professional: HealthProfessional;
    professionalId: string;
    careUnit: HealthCareUnit;
    careUnitId: number;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    workJourney: string | undefined;
    isActive: boolean;
    tenantId: number;
    id: number;
}

export class HealthCareUnit implements IHealthCareUnit {
    name: string | undefined;
    address: LocalizedAddress;
    contactEmails: HealthCareUnitContactEmail[] | undefined;
    social: Social;
    phoneNumbers: HealthCareUnitPhone[] | undefined;
    coveredProcedures: MedicalProcedureCoveredInHealthCareUnit[] | undefined;
    workJourney: string | undefined;
    professionals: HealthProfessionalCareUnitMedicalProcedure[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IHealthCareUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? LocalizedAddress.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["contactEmails"])) {
                this.contactEmails = [] as any;
                for (let item of _data["contactEmails"])
                    this.contactEmails.push(HealthCareUnitContactEmail.fromJS(item));
            }
            this.social = _data["social"] ? Social.fromJS(_data["social"]) : <any>undefined;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(HealthCareUnitPhone.fromJS(item));
            }
            if (Array.isArray(_data["coveredProcedures"])) {
                this.coveredProcedures = [] as any;
                for (let item of _data["coveredProcedures"])
                    this.coveredProcedures.push(MedicalProcedureCoveredInHealthCareUnit.fromJS(item));
            }
            this.workJourney = _data["workJourney"];
            if (Array.isArray(_data["professionals"])) {
                this.professionals = [] as any;
                for (let item of _data["professionals"])
                    this.professionals.push(HealthProfessionalCareUnitMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments.push(MedicalAppointment.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthCareUnit {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCareUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.contactEmails)) {
            data["contactEmails"] = [];
            for (let item of this.contactEmails)
                data["contactEmails"].push(item.toJSON());
        }
        data["social"] = this.social ? this.social.toJSON() : <any>undefined;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredProcedures)) {
            data["coveredProcedures"] = [];
            for (let item of this.coveredProcedures)
                data["coveredProcedures"].push(item.toJSON());
        }
        data["workJourney"] = this.workJourney;
        if (Array.isArray(this.professionals)) {
            data["professionals"] = [];
            for (let item of this.professionals)
                data["professionals"].push(item.toJSON());
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthCareUnit {
        const json = this.toJSON();
        let result = new HealthCareUnit();
        result.init(json);
        return result;
    }
}

export interface IHealthCareUnit {
    name: string | undefined;
    address: LocalizedAddress;
    contactEmails: HealthCareUnitContactEmail[] | undefined;
    social: Social;
    phoneNumbers: HealthCareUnitPhone[] | undefined;
    coveredProcedures: MedicalProcedureCoveredInHealthCareUnit[] | undefined;
    workJourney: string | undefined;
    professionals: HealthProfessionalCareUnitMedicalProcedure[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MedicalProcedureResponsibilityTerm implements IMedicalProcedureResponsibilityTerm {
    procedureId: number;
    procedure: MedicalProcedure;
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    signatures: MedicalProcedureResponsibilityTermSignature[] | undefined;
    healthProfessionalId: string | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalProcedureResponsibilityTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procedureId = _data["procedureId"];
            this.procedure = _data["procedure"] ? MedicalProcedure.fromJS(_data["procedure"]) : <any>undefined;
            this.title = _data["title"];
            this.documentUrl = _data["documentUrl"];
            this.signatureRequiredOnlyOnce = _data["signatureRequiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures.push(MedicalProcedureResponsibilityTermSignature.fromJS(item));
            }
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureResponsibilityTerm {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureResponsibilityTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["procedureId"] = this.procedureId;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["documentUrl"] = this.documentUrl;
        data["signatureRequiredOnlyOnce"] = this.signatureRequiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item.toJSON());
        }
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureResponsibilityTerm {
        const json = this.toJSON();
        let result = new MedicalProcedureResponsibilityTerm();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureResponsibilityTerm {
    procedureId: number;
    procedure: MedicalProcedure;
    title: string | undefined;
    documentUrl: string | undefined;
    signatureRequiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    signatures: MedicalProcedureResponsibilityTermSignature[] | undefined;
    healthProfessionalId: string | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MedicalProcedureResponsibilityTermSignature implements IMedicalProcedureResponsibilityTermSignature {
    patientId: string;
    patient: Patient;
    medicalProcedureResponsibilityTermId: number;
    medicalProcedureResponsibilityTerm: MedicalProcedureResponsibilityTerm;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IMedicalProcedureResponsibilityTermSignature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.medicalProcedureResponsibilityTermId = _data["medicalProcedureResponsibilityTermId"];
            this.medicalProcedureResponsibilityTerm = _data["medicalProcedureResponsibilityTerm"] ? MedicalProcedureResponsibilityTerm.fromJS(_data["medicalProcedureResponsibilityTerm"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureResponsibilityTermSignature {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureResponsibilityTermSignature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["medicalProcedureResponsibilityTermId"] = this.medicalProcedureResponsibilityTermId;
        data["medicalProcedureResponsibilityTerm"] = this.medicalProcedureResponsibilityTerm ? this.medicalProcedureResponsibilityTerm.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureResponsibilityTermSignature {
        const json = this.toJSON();
        let result = new MedicalProcedureResponsibilityTermSignature();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureResponsibilityTermSignature {
    patientId: string;
    patient: Patient;
    medicalProcedureResponsibilityTermId: number;
    medicalProcedureResponsibilityTerm: MedicalProcedureResponsibilityTerm;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class MedicalAppointmentResponsibilityTermSignature implements IMedicalAppointmentResponsibilityTermSignature {
    appointmentId: string;
    appointment: MedicalAppointment;
    signatureId: string;
    signature: MedicalProcedureResponsibilityTermSignature;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalAppointmentResponsibilityTermSignature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.appointment = _data["appointment"] ? MedicalAppointment.fromJS(_data["appointment"]) : <any>undefined;
            this.signatureId = _data["signatureId"];
            this.signature = _data["signature"] ? MedicalProcedureResponsibilityTermSignature.fromJS(_data["signature"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalAppointmentResponsibilityTermSignature {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentResponsibilityTermSignature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["appointment"] = this.appointment ? this.appointment.toJSON() : <any>undefined;
        data["signatureId"] = this.signatureId;
        data["signature"] = this.signature ? this.signature.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalAppointmentResponsibilityTermSignature {
        const json = this.toJSON();
        let result = new MedicalAppointmentResponsibilityTermSignature();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentResponsibilityTermSignature {
    appointmentId: string;
    appointment: MedicalAppointment;
    signatureId: string;
    signature: MedicalProcedureResponsibilityTermSignature;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MedicalAppointmentComplementaryProcedure implements IMedicalAppointmentComplementaryProcedure {
    appointmentId: string;
    procedure: MedicalProcedure;
    procedureId: number;
    duration: number;
    price: number;
    splitPercentage: number | undefined;
    healthProfessionalId: string | undefined;
    insuranceCompany: InsuranceCompany;
    insuranceCompanyId: number | undefined;
    insurancePlan: InsurancePlan;
    insurancePlanId: number | undefined;
    insuranceNumber: string | undefined;
    careUnit: HealthCareUnit;
    careUnitId: number | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IMedicalAppointmentComplementaryProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.procedure = _data["procedure"] ? MedicalProcedure.fromJS(_data["procedure"]) : <any>undefined;
            this.procedureId = _data["procedureId"];
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.splitPercentage = _data["splitPercentage"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insurancePlan = _data["insurancePlan"] ? InsurancePlan.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.insurancePlanId = _data["insurancePlanId"];
            this.insuranceNumber = _data["insuranceNumber"];
            this.careUnit = _data["careUnit"] ? HealthCareUnit.fromJS(_data["careUnit"]) : <any>undefined;
            this.careUnitId = _data["careUnitId"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): MedicalAppointmentComplementaryProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointmentComplementaryProcedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data["procedureId"] = this.procedureId;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["splitPercentage"] = this.splitPercentage;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["insurancePlanId"] = this.insurancePlanId;
        data["insuranceNumber"] = this.insuranceNumber;
        data["careUnit"] = this.careUnit ? this.careUnit.toJSON() : <any>undefined;
        data["careUnitId"] = this.careUnitId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): MedicalAppointmentComplementaryProcedure {
        const json = this.toJSON();
        let result = new MedicalAppointmentComplementaryProcedure();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointmentComplementaryProcedure {
    appointmentId: string;
    procedure: MedicalProcedure;
    procedureId: number;
    duration: number;
    price: number;
    splitPercentage: number | undefined;
    healthProfessionalId: string | undefined;
    insuranceCompany: InsuranceCompany;
    insuranceCompanyId: number | undefined;
    insurancePlan: InsurancePlan;
    insurancePlanId: number | undefined;
    insuranceNumber: string | undefined;
    careUnit: HealthCareUnit;
    careUnitId: number | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class AppointmentStatusChange implements IAppointmentStatusChange {
    appointment: string;
    status: AppointmentStatus;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IAppointmentStatusChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointment = _data["appointment"];
            this.status = _data["status"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): AppointmentStatusChange {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentStatusChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointment"] = this.appointment;
        data["status"] = this.status;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): AppointmentStatusChange {
        const json = this.toJSON();
        let result = new AppointmentStatusChange();
        result.init(json);
        return result;
    }
}

export interface IAppointmentStatusChange {
    appointment: string;
    status: AppointmentStatus;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class AppointmentRatingItem implements IAppointmentRatingItem {
    appointmentRating: AppointmentRating;
    item: string | undefined;
    value: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IAppointmentRatingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentRating = _data["appointmentRating"] ? AppointmentRating.fromJS(_data["appointmentRating"]) : <any>undefined;
            this.item = _data["item"];
            this.value = _data["value"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): AppointmentRatingItem {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentRatingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentRating"] = this.appointmentRating ? this.appointmentRating.toJSON() : <any>undefined;
        data["item"] = this.item;
        data["value"] = this.value;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): AppointmentRatingItem {
        const json = this.toJSON();
        let result = new AppointmentRatingItem();
        result.init(json);
        return result;
    }
}

export interface IAppointmentRatingItem {
    appointmentRating: AppointmentRating;
    item: string | undefined;
    value: string | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class AppointmentRating implements IAppointmentRating {
    appointment: string;
    ratingForm: string;
    items: AppointmentRatingItem[] | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IAppointmentRating) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointment = _data["appointment"];
            this.ratingForm = _data["ratingForm"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppointmentRatingItem.fromJS(item));
            }
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): AppointmentRating {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentRating();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointment"] = this.appointment;
        data["ratingForm"] = this.ratingForm;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): AppointmentRating {
        const json = this.toJSON();
        let result = new AppointmentRating();
        result.init(json);
        return result;
    }
}

export interface IAppointmentRating {
    appointment: string;
    ratingForm: string;
    items: AppointmentRatingItem[] | undefined;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class PreProcedureForm implements IPreProcedureForm {
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    allowResponseEdition: boolean;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    version: number;
    healthProfessionalId: string | undefined;
    tenantId: number;
    medicalProcedureId: number;
    medicalProcedure: MedicalProcedure;
    responses: AppointmentPreProcedureFormResponse[] | undefined;
    parentId: number | undefined;
    parent: PreProcedureForm;
    versions: PreProcedureForm[] | undefined;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPreProcedureForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.definition = _data["definition"];
            this.allowResponseEdition = _data["allowResponseEdition"];
            this.requiredOnlyOnce = _data["requiredOnlyOnce"];
            this.requiredOnScheduling = _data["requiredOnScheduling"];
            this.version = _data["version"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.tenantId = _data["tenantId"];
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedure.fromJS(_data["medicalProcedure"]) : <any>undefined;
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses.push(AppointmentPreProcedureFormResponse.fromJS(item));
            }
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? PreProcedureForm.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions.push(PreProcedureForm.fromJS(item));
            }
            this.sendResponseNotification = _data["sendResponseNotification"];
            this.showOnMedicalRecords = _data["showOnMedicalRecords"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PreProcedureForm {
        data = typeof data === 'object' ? data : {};
        let result = new PreProcedureForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["definition"] = this.definition;
        data["allowResponseEdition"] = this.allowResponseEdition;
        data["requiredOnlyOnce"] = this.requiredOnlyOnce;
        data["requiredOnScheduling"] = this.requiredOnScheduling;
        data["version"] = this.version;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["tenantId"] = this.tenantId;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        data["sendResponseNotification"] = this.sendResponseNotification;
        data["showOnMedicalRecords"] = this.showOnMedicalRecords;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PreProcedureForm {
        const json = this.toJSON();
        let result = new PreProcedureForm();
        result.init(json);
        return result;
    }
}

export interface IPreProcedureForm {
    title: string | undefined;
    description: string | undefined;
    definition: string | undefined;
    allowResponseEdition: boolean;
    requiredOnlyOnce: boolean;
    requiredOnScheduling: boolean;
    version: number;
    healthProfessionalId: string | undefined;
    tenantId: number;
    medicalProcedureId: number;
    medicalProcedure: MedicalProcedure;
    responses: AppointmentPreProcedureFormResponse[] | undefined;
    parentId: number | undefined;
    parent: PreProcedureForm;
    versions: PreProcedureForm[] | undefined;
    sendResponseNotification: boolean;
    showOnMedicalRecords: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AppointmentPreProcedureFormAnswer implements IAppointmentPreProcedureFormAnswer {
    entryId: number;
    response: AppointmentPreProcedureFormResponse;
    formId: number;
    fieldId: string | undefined;
    answer: string | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAppointmentPreProcedureFormAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryId = _data["entryId"];
            this.response = _data["response"] ? AppointmentPreProcedureFormResponse.fromJS(_data["response"]) : <any>undefined;
            this.formId = _data["formId"];
            this.fieldId = _data["fieldId"];
            this.answer = _data["answer"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppointmentPreProcedureFormAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentPreProcedureFormAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryId"] = this.entryId;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["formId"] = this.formId;
        data["fieldId"] = this.fieldId;
        data["answer"] = this.answer;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): AppointmentPreProcedureFormAnswer {
        const json = this.toJSON();
        let result = new AppointmentPreProcedureFormAnswer();
        result.init(json);
        return result;
    }
}

export interface IAppointmentPreProcedureFormAnswer {
    entryId: number;
    response: AppointmentPreProcedureFormResponse;
    formId: number;
    fieldId: string | undefined;
    answer: string | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AppointmentPreProcedureFormResponse implements IAppointmentPreProcedureFormResponse {
    formId: number;
    form: PreProcedureForm;
    patientId: string;
    answerEntries: AppointmentPreProcedureFormAnswer[] | undefined;
    healthProfessionalId: string | undefined;
    tenantId: number;
    appointmentId: string;
    appointment: MedicalAppointment;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAppointmentPreProcedureFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.form = _data["form"] ? PreProcedureForm.fromJS(_data["form"]) : <any>undefined;
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["answerEntries"])) {
                this.answerEntries = [] as any;
                for (let item of _data["answerEntries"])
                    this.answerEntries.push(AppointmentPreProcedureFormAnswer.fromJS(item));
            }
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.tenantId = _data["tenantId"];
            this.appointmentId = _data["appointmentId"];
            this.appointment = _data["appointment"] ? MedicalAppointment.fromJS(_data["appointment"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppointmentPreProcedureFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentPreProcedureFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        data["patientId"] = this.patientId;
        if (Array.isArray(this.answerEntries)) {
            data["answerEntries"] = [];
            for (let item of this.answerEntries)
                data["answerEntries"].push(item.toJSON());
        }
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["tenantId"] = this.tenantId;
        data["appointmentId"] = this.appointmentId;
        data["appointment"] = this.appointment ? this.appointment.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): AppointmentPreProcedureFormResponse {
        const json = this.toJSON();
        let result = new AppointmentPreProcedureFormResponse();
        result.init(json);
        return result;
    }
}

export interface IAppointmentPreProcedureFormResponse {
    formId: number;
    form: PreProcedureForm;
    patientId: string;
    answerEntries: AppointmentPreProcedureFormAnswer[] | undefined;
    healthProfessionalId: string | undefined;
    tenantId: number;
    appointmentId: string;
    appointment: MedicalAppointment;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MedicalAppointment implements IMedicalAppointment {
    healthProfessional: HealthProfessional;
    hostUserId: number | undefined;
    patient: Patient;
    patientId: string;
    medicalSpecialty: number;
    procedure: MedicalProcedure;
    procedureId: number | undefined;
    medicalAgreement: MedicalAgreement;
    medicalAgreementId: string | undefined;
    healthPlan: HealthPlan;
    insuranceCompany: InsuranceCompany;
    insuranceCompanyId: number | undefined;
    insurancePlan: InsurancePlan;
    insurancePlanId: number | undefined;
    insuranceNumber: string | undefined;
    careUnit: HealthCareUnit;
    careUnitId: number | undefined;
    parent: MedicalAppointment;
    parentId: string | undefined;
    comments: string | undefined;
    title: string | undefined;
    price: number;
    splitPercentage: number | undefined;
    numberOfInstallments: number;
    paymentId: number;
    externalTransactionId: number | undefined;
    externalId: string | undefined;
    termSignatures: MedicalAppointmentResponsibilityTermSignature[] | undefined;
    readonly hasHostDefined: boolean;
    ownerIdentifier: UserIdentifier;
    medicalAppointmentComplementaryProcedures: MedicalAppointmentComplementaryProcedure[] | undefined;
    duration: number;
    healthProfessionalId: string | undefined;
    tenantId: number;
    recurringEventId: string | undefined;
    readonly isRecurringEvent: boolean;
    date: moment.Moment;
    startTime: moment.Moment | undefined;
    startWithoutPaymentConfirmation: boolean | undefined;
    endTime: moment.Moment | undefined;
    status: AppointmentStatus;
    statusChanges: AppointmentStatusChange[] | undefined;
    ratings: AppointmentRating[] | undefined;
    remotely: boolean;
    preProcedureFormResponses: AppointmentPreProcedureFormResponse[] | undefined;
    patientConfirmation: PatientConfirmation;
    originPlatform: OriginPlatform;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IMedicalAppointment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthProfessional = _data["healthProfessional"] ? HealthProfessional.fromJS(_data["healthProfessional"]) : <any>undefined;
            this.hostUserId = _data["hostUserId"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.patientId = _data["patientId"];
            this.medicalSpecialty = _data["medicalSpecialty"];
            this.procedure = _data["procedure"] ? MedicalProcedure.fromJS(_data["procedure"]) : <any>undefined;
            this.procedureId = _data["procedureId"];
            this.medicalAgreement = _data["medicalAgreement"] ? MedicalAgreement.fromJS(_data["medicalAgreement"]) : <any>undefined;
            this.medicalAgreementId = _data["medicalAgreementId"];
            this.healthPlan = _data["healthPlan"] ? HealthPlan.fromJS(_data["healthPlan"]) : <any>undefined;
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.insurancePlan = _data["insurancePlan"] ? InsurancePlan.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.insurancePlanId = _data["insurancePlanId"];
            this.insuranceNumber = _data["insuranceNumber"];
            this.careUnit = _data["careUnit"] ? HealthCareUnit.fromJS(_data["careUnit"]) : <any>undefined;
            this.careUnitId = _data["careUnitId"];
            this.parent = _data["parent"] ? MedicalAppointment.fromJS(_data["parent"]) : <any>undefined;
            this.parentId = _data["parentId"];
            this.comments = _data["comments"];
            this.title = _data["title"];
            this.price = _data["price"];
            this.splitPercentage = _data["splitPercentage"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.paymentId = _data["paymentId"];
            this.externalTransactionId = _data["externalTransactionId"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["termSignatures"])) {
                this.termSignatures = [] as any;
                for (let item of _data["termSignatures"])
                    this.termSignatures.push(MedicalAppointmentResponsibilityTermSignature.fromJS(item));
            }
            (<any>this).hasHostDefined = _data["hasHostDefined"];
            this.ownerIdentifier = _data["ownerIdentifier"] ? UserIdentifier.fromJS(_data["ownerIdentifier"]) : <any>undefined;
            if (Array.isArray(_data["medicalAppointmentComplementaryProcedures"])) {
                this.medicalAppointmentComplementaryProcedures = [] as any;
                for (let item of _data["medicalAppointmentComplementaryProcedures"])
                    this.medicalAppointmentComplementaryProcedures.push(MedicalAppointmentComplementaryProcedure.fromJS(item));
            }
            this.duration = _data["duration"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            this.tenantId = _data["tenantId"];
            this.recurringEventId = _data["recurringEventId"];
            (<any>this).isRecurringEvent = _data["isRecurringEvent"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.startWithoutPaymentConfirmation = _data["startWithoutPaymentConfirmation"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["statusChanges"])) {
                this.statusChanges = [] as any;
                for (let item of _data["statusChanges"])
                    this.statusChanges.push(AppointmentStatusChange.fromJS(item));
            }
            if (Array.isArray(_data["ratings"])) {
                this.ratings = [] as any;
                for (let item of _data["ratings"])
                    this.ratings.push(AppointmentRating.fromJS(item));
            }
            this.remotely = _data["remotely"];
            if (Array.isArray(_data["preProcedureFormResponses"])) {
                this.preProcedureFormResponses = [] as any;
                for (let item of _data["preProcedureFormResponses"])
                    this.preProcedureFormResponses.push(AppointmentPreProcedureFormResponse.fromJS(item));
            }
            this.patientConfirmation = _data["patientConfirmation"] ? PatientConfirmation.fromJS(_data["patientConfirmation"]) : <any>undefined;
            this.originPlatform = _data["originPlatform"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): MedicalAppointment {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalAppointment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthProfessional"] = this.healthProfessional ? this.healthProfessional.toJSON() : <any>undefined;
        data["hostUserId"] = this.hostUserId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["patientId"] = this.patientId;
        data["medicalSpecialty"] = this.medicalSpecialty;
        data["procedure"] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data["procedureId"] = this.procedureId;
        data["medicalAgreement"] = this.medicalAgreement ? this.medicalAgreement.toJSON() : <any>undefined;
        data["medicalAgreementId"] = this.medicalAgreementId;
        data["healthPlan"] = this.healthPlan ? this.healthPlan.toJSON() : <any>undefined;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["insurancePlanId"] = this.insurancePlanId;
        data["insuranceNumber"] = this.insuranceNumber;
        data["careUnit"] = this.careUnit ? this.careUnit.toJSON() : <any>undefined;
        data["careUnitId"] = this.careUnitId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["comments"] = this.comments;
        data["title"] = this.title;
        data["price"] = this.price;
        data["splitPercentage"] = this.splitPercentage;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["paymentId"] = this.paymentId;
        data["externalTransactionId"] = this.externalTransactionId;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.termSignatures)) {
            data["termSignatures"] = [];
            for (let item of this.termSignatures)
                data["termSignatures"].push(item.toJSON());
        }
        data["hasHostDefined"] = this.hasHostDefined;
        data["ownerIdentifier"] = this.ownerIdentifier ? this.ownerIdentifier.toJSON() : <any>undefined;
        if (Array.isArray(this.medicalAppointmentComplementaryProcedures)) {
            data["medicalAppointmentComplementaryProcedures"] = [];
            for (let item of this.medicalAppointmentComplementaryProcedures)
                data["medicalAppointmentComplementaryProcedures"].push(item.toJSON());
        }
        data["duration"] = this.duration;
        data["healthProfessionalId"] = this.healthProfessionalId;
        data["tenantId"] = this.tenantId;
        data["recurringEventId"] = this.recurringEventId;
        data["isRecurringEvent"] = this.isRecurringEvent;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["startWithoutPaymentConfirmation"] = this.startWithoutPaymentConfirmation;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.statusChanges)) {
            data["statusChanges"] = [];
            for (let item of this.statusChanges)
                data["statusChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.ratings)) {
            data["ratings"] = [];
            for (let item of this.ratings)
                data["ratings"].push(item.toJSON());
        }
        data["remotely"] = this.remotely;
        if (Array.isArray(this.preProcedureFormResponses)) {
            data["preProcedureFormResponses"] = [];
            for (let item of this.preProcedureFormResponses)
                data["preProcedureFormResponses"].push(item.toJSON());
        }
        data["patientConfirmation"] = this.patientConfirmation ? this.patientConfirmation.toJSON() : <any>undefined;
        data["originPlatform"] = this.originPlatform;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): MedicalAppointment {
        const json = this.toJSON();
        let result = new MedicalAppointment();
        result.init(json);
        return result;
    }
}

export interface IMedicalAppointment {
    healthProfessional: HealthProfessional;
    hostUserId: number | undefined;
    patient: Patient;
    patientId: string;
    medicalSpecialty: number;
    procedure: MedicalProcedure;
    procedureId: number | undefined;
    medicalAgreement: MedicalAgreement;
    medicalAgreementId: string | undefined;
    healthPlan: HealthPlan;
    insuranceCompany: InsuranceCompany;
    insuranceCompanyId: number | undefined;
    insurancePlan: InsurancePlan;
    insurancePlanId: number | undefined;
    insuranceNumber: string | undefined;
    careUnit: HealthCareUnit;
    careUnitId: number | undefined;
    parent: MedicalAppointment;
    parentId: string | undefined;
    comments: string | undefined;
    title: string | undefined;
    price: number;
    splitPercentage: number | undefined;
    numberOfInstallments: number;
    paymentId: number;
    externalTransactionId: number | undefined;
    externalId: string | undefined;
    termSignatures: MedicalAppointmentResponsibilityTermSignature[] | undefined;
    hasHostDefined: boolean;
    ownerIdentifier: UserIdentifier;
    medicalAppointmentComplementaryProcedures: MedicalAppointmentComplementaryProcedure[] | undefined;
    duration: number;
    healthProfessionalId: string | undefined;
    tenantId: number;
    recurringEventId: string | undefined;
    isRecurringEvent: boolean;
    date: moment.Moment;
    startTime: moment.Moment | undefined;
    startWithoutPaymentConfirmation: boolean | undefined;
    endTime: moment.Moment | undefined;
    status: AppointmentStatus;
    statusChanges: AppointmentStatusChange[] | undefined;
    ratings: AppointmentRating[] | undefined;
    remotely: boolean;
    preProcedureFormResponses: AppointmentPreProcedureFormResponse[] | undefined;
    patientConfirmation: PatientConfirmation;
    originPlatform: OriginPlatform;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class InsurancePlan implements IInsurancePlan {
    company: InsuranceCompany;
    companyId: number;
    name: string | undefined;
    returnDaysLimit: number | undefined;
    price: number | undefined;
    status: InsurancePlanStatus;
    coveredProcedures: MedicalProcedureCoveredByInsurancePlan[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IInsurancePlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? InsuranceCompany.fromJS(_data["company"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.returnDaysLimit = _data["returnDaysLimit"];
            this.price = _data["price"];
            this.status = _data["status"];
            if (Array.isArray(_data["coveredProcedures"])) {
                this.coveredProcedures = [] as any;
                for (let item of _data["coveredProcedures"])
                    this.coveredProcedures.push(MedicalProcedureCoveredByInsurancePlan.fromJS(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments.push(MedicalAppointment.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsurancePlan {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["returnDaysLimit"] = this.returnDaysLimit;
        data["price"] = this.price;
        data["status"] = this.status;
        if (Array.isArray(this.coveredProcedures)) {
            data["coveredProcedures"] = [];
            for (let item of this.coveredProcedures)
                data["coveredProcedures"].push(item.toJSON());
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): InsurancePlan {
        const json = this.toJSON();
        let result = new InsurancePlan();
        result.init(json);
        return result;
    }
}

export interface IInsurancePlan {
    company: InsuranceCompany;
    companyId: number;
    name: string | undefined;
    returnDaysLimit: number | undefined;
    price: number | undefined;
    status: InsurancePlanStatus;
    coveredProcedures: MedicalProcedureCoveredByInsurancePlan[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class InsuranceCompany implements IInsuranceCompany {
    name: string | undefined;
    code: string | undefined;
    dailyLimit: number | undefined;
    returnDaysLimit: number | undefined;
    locked: boolean;
    insurancePlans: InsurancePlan[] | undefined;
    coveredProcedures: MedicalProcedureCoveredByInsuranceCompany[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IInsuranceCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.dailyLimit = _data["dailyLimit"];
            this.returnDaysLimit = _data["returnDaysLimit"];
            this.locked = _data["locked"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans.push(InsurancePlan.fromJS(item));
            }
            if (Array.isArray(_data["coveredProcedures"])) {
                this.coveredProcedures = [] as any;
                for (let item of _data["coveredProcedures"])
                    this.coveredProcedures.push(MedicalProcedureCoveredByInsuranceCompany.fromJS(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments.push(MedicalAppointment.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InsuranceCompany {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["dailyLimit"] = this.dailyLimit;
        data["returnDaysLimit"] = this.returnDaysLimit;
        data["locked"] = this.locked;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredProcedures)) {
            data["coveredProcedures"] = [];
            for (let item of this.coveredProcedures)
                data["coveredProcedures"].push(item.toJSON());
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): InsuranceCompany {
        const json = this.toJSON();
        let result = new InsuranceCompany();
        result.init(json);
        return result;
    }
}

export interface IInsuranceCompany {
    name: string | undefined;
    code: string | undefined;
    dailyLimit: number | undefined;
    returnDaysLimit: number | undefined;
    locked: boolean;
    insurancePlans: InsurancePlan[] | undefined;
    coveredProcedures: MedicalProcedureCoveredByInsuranceCompany[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class MedicalProcedureCoveredByInsuranceCompany implements IMedicalProcedureCoveredByInsuranceCompany {
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    insuranceCompany: InsuranceCompany;
    insuranceCompanyId: number;
    price: number | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IMedicalProcedureCoveredByInsuranceCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedure.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureCoveredByInsuranceCompany {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureCoveredByInsuranceCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureCoveredByInsuranceCompany {
        const json = this.toJSON();
        let result = new MedicalProcedureCoveredByInsuranceCompany();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureCoveredByInsuranceCompany {
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    insuranceCompany: InsuranceCompany;
    insuranceCompanyId: number;
    price: number | undefined;
    tenantId: number;
    id: number;
}

export class MedicalProcedureServiceLocation implements IMedicalProcedureServiceLocation {
    name: string | undefined;
    description: string | undefined;
    healthCareUnit: HealthCareUnit;
    healthCareUnitId: number | undefined;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalProcedureServiceLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.healthCareUnit = _data["healthCareUnit"] ? HealthCareUnit.fromJS(_data["healthCareUnit"]) : <any>undefined;
            this.healthCareUnitId = _data["healthCareUnitId"];
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedure.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedureServiceLocation {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedureServiceLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["healthCareUnit"] = this.healthCareUnit ? this.healthCareUnit.toJSON() : <any>undefined;
        data["healthCareUnitId"] = this.healthCareUnitId;
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedureServiceLocation {
        const json = this.toJSON();
        let result = new MedicalProcedureServiceLocation();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedureServiceLocation {
    name: string | undefined;
    description: string | undefined;
    healthCareUnit: HealthCareUnit;
    healthCareUnitId: number | undefined;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class HealthProfessionalMedicalProcedure implements IHealthProfessionalMedicalProcedure {
    professional: HealthProfessional;
    professionalId: string;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    duration: number | undefined;
    readonly minutesDuration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    isActive: boolean;
    comments: string | undefined;
    allowOnlineSchedule: boolean;
    splitPercentage: number | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IHealthProfessionalMedicalProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professional = _data["professional"] ? HealthProfessional.fromJS(_data["professional"]) : <any>undefined;
            this.professionalId = _data["professionalId"];
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedure.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.duration = _data["duration"];
            (<any>this).minutesDuration = _data["minutesDuration"];
            this.periodUnit = _data["periodUnit"];
            this.isActive = _data["isActive"];
            this.comments = _data["comments"];
            this.allowOnlineSchedule = _data["allowOnlineSchedule"];
            this.splitPercentage = _data["splitPercentage"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthProfessionalMedicalProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalMedicalProcedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        data["professionalId"] = this.professionalId;
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["duration"] = this.duration;
        data["minutesDuration"] = this.minutesDuration;
        data["periodUnit"] = this.periodUnit;
        data["isActive"] = this.isActive;
        data["comments"] = this.comments;
        data["allowOnlineSchedule"] = this.allowOnlineSchedule;
        data["splitPercentage"] = this.splitPercentage;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthProfessionalMedicalProcedure {
        const json = this.toJSON();
        let result = new HealthProfessionalMedicalProcedure();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalMedicalProcedure {
    professional: HealthProfessional;
    professionalId: string;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    duration: number | undefined;
    minutesDuration: number | undefined;
    periodUnit: ProcedurePeriodUnit;
    isActive: boolean;
    comments: string | undefined;
    allowOnlineSchedule: boolean;
    splitPercentage: number | undefined;
    tenantId: number;
    id: number;
}

export class MedicalProcedure implements IMedicalProcedure {
    name: string | undefined;
    description: string | undefined;
    publicDescription: string | undefined;
    duration: number;
    periodUnit: ProcedurePeriodUnit;
    readonly minutesDuration: number;
    price: number;
    scheduleColor: string | undefined;
    coveredInsuranceCompanies: MedicalProcedureCoveredByInsuranceCompany[] | undefined;
    coveredInsurancePlans: MedicalProcedureCoveredByInsurancePlan[] | undefined;
    coveredCareUnits: MedicalProcedureCoveredInHealthCareUnit[] | undefined;
    coveredProfessionalCareUnits: HealthProfessionalCareUnitMedicalProcedure[] | undefined;
    coveredServiceLocations: MedicalProcedureServiceLocation[] | undefined;
    coveredByProfessionals: HealthProfessionalMedicalProcedure[] | undefined;
    derivedProcedures: MedicalProcedure[] | undefined;
    parent: MedicalProcedure;
    parentId: number | undefined;
    appointments: MedicalAppointment[] | undefined;
    allowOnlineSchedule: boolean;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    remotely: boolean;
    isReturn: boolean;
    returnParentId: string | undefined;
    isProfessionalRequired: boolean;
    externalId: string | undefined;
    splitPercentage: number | undefined;
    responsibilityTerms: MedicalProcedureResponsibilityTerm[] | undefined;
    maxNumberOfInstallments: number;
    tenantId: number;
    preProcedureForms: PreProcedureForm[] | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IMedicalProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.publicDescription = _data["publicDescription"];
            this.duration = _data["duration"];
            this.periodUnit = _data["periodUnit"];
            (<any>this).minutesDuration = _data["minutesDuration"];
            this.price = _data["price"];
            this.scheduleColor = _data["scheduleColor"];
            if (Array.isArray(_data["coveredInsuranceCompanies"])) {
                this.coveredInsuranceCompanies = [] as any;
                for (let item of _data["coveredInsuranceCompanies"])
                    this.coveredInsuranceCompanies.push(MedicalProcedureCoveredByInsuranceCompany.fromJS(item));
            }
            if (Array.isArray(_data["coveredInsurancePlans"])) {
                this.coveredInsurancePlans = [] as any;
                for (let item of _data["coveredInsurancePlans"])
                    this.coveredInsurancePlans.push(MedicalProcedureCoveredByInsurancePlan.fromJS(item));
            }
            if (Array.isArray(_data["coveredCareUnits"])) {
                this.coveredCareUnits = [] as any;
                for (let item of _data["coveredCareUnits"])
                    this.coveredCareUnits.push(MedicalProcedureCoveredInHealthCareUnit.fromJS(item));
            }
            if (Array.isArray(_data["coveredProfessionalCareUnits"])) {
                this.coveredProfessionalCareUnits = [] as any;
                for (let item of _data["coveredProfessionalCareUnits"])
                    this.coveredProfessionalCareUnits.push(HealthProfessionalCareUnitMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["coveredServiceLocations"])) {
                this.coveredServiceLocations = [] as any;
                for (let item of _data["coveredServiceLocations"])
                    this.coveredServiceLocations.push(MedicalProcedureServiceLocation.fromJS(item));
            }
            if (Array.isArray(_data["coveredByProfessionals"])) {
                this.coveredByProfessionals = [] as any;
                for (let item of _data["coveredByProfessionals"])
                    this.coveredByProfessionals.push(HealthProfessionalMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["derivedProcedures"])) {
                this.derivedProcedures = [] as any;
                for (let item of _data["derivedProcedures"])
                    this.derivedProcedures.push(MedicalProcedure.fromJS(item));
            }
            this.parent = _data["parent"] ? MedicalProcedure.fromJS(_data["parent"]) : <any>undefined;
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments.push(MedicalAppointment.fromJS(item));
            }
            this.allowOnlineSchedule = _data["allowOnlineSchedule"];
            this.onlinePaymentType = _data["onlinePaymentType"];
            this.remotely = _data["remotely"];
            this.isReturn = _data["isReturn"];
            this.returnParentId = _data["returnParentId"];
            this.isProfessionalRequired = _data["isProfessionalRequired"];
            this.externalId = _data["externalId"];
            this.splitPercentage = _data["splitPercentage"];
            if (Array.isArray(_data["responsibilityTerms"])) {
                this.responsibilityTerms = [] as any;
                for (let item of _data["responsibilityTerms"])
                    this.responsibilityTerms.push(MedicalProcedureResponsibilityTerm.fromJS(item));
            }
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["preProcedureForms"])) {
                this.preProcedureForms = [] as any;
                for (let item of _data["preProcedureForms"])
                    this.preProcedureForms.push(PreProcedureForm.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicalProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProcedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["publicDescription"] = this.publicDescription;
        data["duration"] = this.duration;
        data["periodUnit"] = this.periodUnit;
        data["minutesDuration"] = this.minutesDuration;
        data["price"] = this.price;
        data["scheduleColor"] = this.scheduleColor;
        if (Array.isArray(this.coveredInsuranceCompanies)) {
            data["coveredInsuranceCompanies"] = [];
            for (let item of this.coveredInsuranceCompanies)
                data["coveredInsuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredInsurancePlans)) {
            data["coveredInsurancePlans"] = [];
            for (let item of this.coveredInsurancePlans)
                data["coveredInsurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredCareUnits)) {
            data["coveredCareUnits"] = [];
            for (let item of this.coveredCareUnits)
                data["coveredCareUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredProfessionalCareUnits)) {
            data["coveredProfessionalCareUnits"] = [];
            for (let item of this.coveredProfessionalCareUnits)
                data["coveredProfessionalCareUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredServiceLocations)) {
            data["coveredServiceLocations"] = [];
            for (let item of this.coveredServiceLocations)
                data["coveredServiceLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.coveredByProfessionals)) {
            data["coveredByProfessionals"] = [];
            for (let item of this.coveredByProfessionals)
                data["coveredByProfessionals"].push(item.toJSON());
        }
        if (Array.isArray(this.derivedProcedures)) {
            data["derivedProcedures"] = [];
            for (let item of this.derivedProcedures)
                data["derivedProcedures"].push(item.toJSON());
        }
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        data["allowOnlineSchedule"] = this.allowOnlineSchedule;
        data["onlinePaymentType"] = this.onlinePaymentType;
        data["remotely"] = this.remotely;
        data["isReturn"] = this.isReturn;
        data["returnParentId"] = this.returnParentId;
        data["isProfessionalRequired"] = this.isProfessionalRequired;
        data["externalId"] = this.externalId;
        data["splitPercentage"] = this.splitPercentage;
        if (Array.isArray(this.responsibilityTerms)) {
            data["responsibilityTerms"] = [];
            for (let item of this.responsibilityTerms)
                data["responsibilityTerms"].push(item.toJSON());
        }
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.preProcedureForms)) {
            data["preProcedureForms"] = [];
            for (let item of this.preProcedureForms)
                data["preProcedureForms"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): MedicalProcedure {
        const json = this.toJSON();
        let result = new MedicalProcedure();
        result.init(json);
        return result;
    }
}

export interface IMedicalProcedure {
    name: string | undefined;
    description: string | undefined;
    publicDescription: string | undefined;
    duration: number;
    periodUnit: ProcedurePeriodUnit;
    minutesDuration: number;
    price: number;
    scheduleColor: string | undefined;
    coveredInsuranceCompanies: MedicalProcedureCoveredByInsuranceCompany[] | undefined;
    coveredInsurancePlans: MedicalProcedureCoveredByInsurancePlan[] | undefined;
    coveredCareUnits: MedicalProcedureCoveredInHealthCareUnit[] | undefined;
    coveredProfessionalCareUnits: HealthProfessionalCareUnitMedicalProcedure[] | undefined;
    coveredServiceLocations: MedicalProcedureServiceLocation[] | undefined;
    coveredByProfessionals: HealthProfessionalMedicalProcedure[] | undefined;
    derivedProcedures: MedicalProcedure[] | undefined;
    parent: MedicalProcedure;
    parentId: number | undefined;
    appointments: MedicalAppointment[] | undefined;
    allowOnlineSchedule: boolean;
    onlinePaymentType: MedicalProcedureOnlinePaymentType;
    remotely: boolean;
    isReturn: boolean;
    returnParentId: string | undefined;
    isProfessionalRequired: boolean;
    externalId: string | undefined;
    splitPercentage: number | undefined;
    responsibilityTerms: MedicalProcedureResponsibilityTerm[] | undefined;
    maxNumberOfInstallments: number;
    tenantId: number;
    preProcedureForms: PreProcedureForm[] | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class HealthProfessionalInsurancePlanMedicalProcedure implements IHealthProfessionalInsurancePlanMedicalProcedure {
    professional: HealthProfessional;
    professionalId: string;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    insurancePlan: InsurancePlan;
    insurancePlanId: number;
    price: number | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IHealthProfessionalInsurancePlanMedicalProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professional = _data["professional"] ? HealthProfessional.fromJS(_data["professional"]) : <any>undefined;
            this.professionalId = _data["professionalId"];
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedure.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.insurancePlan = _data["insurancePlan"] ? InsurancePlan.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.insurancePlanId = _data["insurancePlanId"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthProfessionalInsurancePlanMedicalProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalInsurancePlanMedicalProcedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        data["professionalId"] = this.professionalId;
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["insurancePlanId"] = this.insurancePlanId;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthProfessionalInsurancePlanMedicalProcedure {
        const json = this.toJSON();
        let result = new HealthProfessionalInsurancePlanMedicalProcedure();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalInsurancePlanMedicalProcedure {
    professional: HealthProfessional;
    professionalId: string;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    insurancePlan: InsurancePlan;
    insurancePlanId: number;
    price: number | undefined;
    tenantId: number;
    id: number;
}

export class HealthProfessional implements IHealthProfessional {
    name: string | undefined;
    address: Address;
    discriminator: string | undefined;
    user: User;
    userId: number | undefined;
    medicalProceduresCoveredByInsuranceCompanies: HealthProfessionalInsuranceCompanyMedicalProcedure[] | undefined;
    medicalProceduresCoveredByInsurancePlans: HealthProfessionalInsurancePlanMedicalProcedure[] | undefined;
    proceduresDuration: HealthProfessionalMedicalProcedure[] | undefined;
    careUnits: HealthProfessionalCareUnitMedicalProcedure[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    workJourney: string | undefined;
    externalId: string | undefined;
    locks: MedicalAppointmentLock[] | undefined;
    patients: PatientProfessionalRelationship[] | undefined;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IHealthProfessional) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.discriminator = _data["discriminator"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            if (Array.isArray(_data["medicalProceduresCoveredByInsuranceCompanies"])) {
                this.medicalProceduresCoveredByInsuranceCompanies = [] as any;
                for (let item of _data["medicalProceduresCoveredByInsuranceCompanies"])
                    this.medicalProceduresCoveredByInsuranceCompanies.push(HealthProfessionalInsuranceCompanyMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["medicalProceduresCoveredByInsurancePlans"])) {
                this.medicalProceduresCoveredByInsurancePlans = [] as any;
                for (let item of _data["medicalProceduresCoveredByInsurancePlans"])
                    this.medicalProceduresCoveredByInsurancePlans.push(HealthProfessionalInsurancePlanMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["proceduresDuration"])) {
                this.proceduresDuration = [] as any;
                for (let item of _data["proceduresDuration"])
                    this.proceduresDuration.push(HealthProfessionalMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["careUnits"])) {
                this.careUnits = [] as any;
                for (let item of _data["careUnits"])
                    this.careUnits.push(HealthProfessionalCareUnitMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments.push(MedicalAppointment.fromJS(item));
            }
            this.workJourney = _data["workJourney"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["locks"])) {
                this.locks = [] as any;
                for (let item of _data["locks"])
                    this.locks.push(MedicalAppointmentLock.fromJS(item));
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients.push(PatientProfessionalRelationship.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): HealthProfessional {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessional();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["discriminator"] = this.discriminator;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        if (Array.isArray(this.medicalProceduresCoveredByInsuranceCompanies)) {
            data["medicalProceduresCoveredByInsuranceCompanies"] = [];
            for (let item of this.medicalProceduresCoveredByInsuranceCompanies)
                data["medicalProceduresCoveredByInsuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.medicalProceduresCoveredByInsurancePlans)) {
            data["medicalProceduresCoveredByInsurancePlans"] = [];
            for (let item of this.medicalProceduresCoveredByInsurancePlans)
                data["medicalProceduresCoveredByInsurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.proceduresDuration)) {
            data["proceduresDuration"] = [];
            for (let item of this.proceduresDuration)
                data["proceduresDuration"].push(item.toJSON());
        }
        if (Array.isArray(this.careUnits)) {
            data["careUnits"] = [];
            for (let item of this.careUnits)
                data["careUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        data["workJourney"] = this.workJourney;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.locks)) {
            data["locks"] = [];
            for (let item of this.locks)
                data["locks"].push(item.toJSON());
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): HealthProfessional {
        const json = this.toJSON();
        let result = new HealthProfessional();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessional {
    name: string | undefined;
    address: Address;
    discriminator: string | undefined;
    user: User;
    userId: number | undefined;
    medicalProceduresCoveredByInsuranceCompanies: HealthProfessionalInsuranceCompanyMedicalProcedure[] | undefined;
    medicalProceduresCoveredByInsurancePlans: HealthProfessionalInsurancePlanMedicalProcedure[] | undefined;
    proceduresDuration: HealthProfessionalMedicalProcedure[] | undefined;
    careUnits: HealthProfessionalCareUnitMedicalProcedure[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    workJourney: string | undefined;
    externalId: string | undefined;
    locks: MedicalAppointmentLock[] | undefined;
    patients: PatientProfessionalRelationship[] | undefined;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class HealthProfessionalInsuranceCompanyMedicalProcedure implements IHealthProfessionalInsuranceCompanyMedicalProcedure {
    professional: HealthProfessional;
    professionalId: string;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    insuranceCompany: InsuranceCompany;
    insuranceCompanyId: number;
    price: number | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IHealthProfessionalInsuranceCompanyMedicalProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professional = _data["professional"] ? HealthProfessional.fromJS(_data["professional"]) : <any>undefined;
            this.professionalId = _data["professionalId"];
            this.medicalProcedure = _data["medicalProcedure"] ? MedicalProcedure.fromJS(_data["medicalProcedure"]) : <any>undefined;
            this.medicalProcedureId = _data["medicalProcedureId"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthProfessionalInsuranceCompanyMedicalProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new HealthProfessionalInsuranceCompanyMedicalProcedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        data["professionalId"] = this.professionalId;
        data["medicalProcedure"] = this.medicalProcedure ? this.medicalProcedure.toJSON() : <any>undefined;
        data["medicalProcedureId"] = this.medicalProcedureId;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): HealthProfessionalInsuranceCompanyMedicalProcedure {
        const json = this.toJSON();
        let result = new HealthProfessionalInsuranceCompanyMedicalProcedure();
        result.init(json);
        return result;
    }
}

export interface IHealthProfessionalInsuranceCompanyMedicalProcedure {
    professional: HealthProfessional;
    professionalId: string;
    medicalProcedure: MedicalProcedure;
    medicalProcedureId: number;
    insuranceCompany: InsuranceCompany;
    insuranceCompanyId: number;
    price: number | undefined;
    tenantId: number;
    id: number;
}

export class Doctor implements IDoctor {
    licenceNumber: LicenceNumber;
    commercialPhone: string | undefined;
    profession: Profession;
    name: string | undefined;
    address: Address;
    discriminator: string | undefined;
    user: User;
    userId: number | undefined;
    medicalProceduresCoveredByInsuranceCompanies: HealthProfessionalInsuranceCompanyMedicalProcedure[] | undefined;
    medicalProceduresCoveredByInsurancePlans: HealthProfessionalInsurancePlanMedicalProcedure[] | undefined;
    proceduresDuration: HealthProfessionalMedicalProcedure[] | undefined;
    careUnits: HealthProfessionalCareUnitMedicalProcedure[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    workJourney: string | undefined;
    externalId: string | undefined;
    locks: MedicalAppointmentLock[] | undefined;
    patients: PatientProfessionalRelationship[] | undefined;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: IDoctor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceNumber = _data["licenceNumber"] ? LicenceNumber.fromJS(_data["licenceNumber"]) : <any>undefined;
            this.commercialPhone = _data["commercialPhone"];
            this.profession = _data["profession"] ? Profession.fromJS(_data["profession"]) : <any>undefined;
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.discriminator = _data["discriminator"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            if (Array.isArray(_data["medicalProceduresCoveredByInsuranceCompanies"])) {
                this.medicalProceduresCoveredByInsuranceCompanies = [] as any;
                for (let item of _data["medicalProceduresCoveredByInsuranceCompanies"])
                    this.medicalProceduresCoveredByInsuranceCompanies.push(HealthProfessionalInsuranceCompanyMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["medicalProceduresCoveredByInsurancePlans"])) {
                this.medicalProceduresCoveredByInsurancePlans = [] as any;
                for (let item of _data["medicalProceduresCoveredByInsurancePlans"])
                    this.medicalProceduresCoveredByInsurancePlans.push(HealthProfessionalInsurancePlanMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["proceduresDuration"])) {
                this.proceduresDuration = [] as any;
                for (let item of _data["proceduresDuration"])
                    this.proceduresDuration.push(HealthProfessionalMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["careUnits"])) {
                this.careUnits = [] as any;
                for (let item of _data["careUnits"])
                    this.careUnits.push(HealthProfessionalCareUnitMedicalProcedure.fromJS(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments.push(MedicalAppointment.fromJS(item));
            }
            this.workJourney = _data["workJourney"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["locks"])) {
                this.locks = [] as any;
                for (let item of _data["locks"])
                    this.locks.push(MedicalAppointmentLock.fromJS(item));
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients.push(PatientProfessionalRelationship.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): Doctor {
        data = typeof data === 'object' ? data : {};
        let result = new Doctor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceNumber"] = this.licenceNumber ? this.licenceNumber.toJSON() : <any>undefined;
        data["commercialPhone"] = this.commercialPhone;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["discriminator"] = this.discriminator;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        if (Array.isArray(this.medicalProceduresCoveredByInsuranceCompanies)) {
            data["medicalProceduresCoveredByInsuranceCompanies"] = [];
            for (let item of this.medicalProceduresCoveredByInsuranceCompanies)
                data["medicalProceduresCoveredByInsuranceCompanies"].push(item.toJSON());
        }
        if (Array.isArray(this.medicalProceduresCoveredByInsurancePlans)) {
            data["medicalProceduresCoveredByInsurancePlans"] = [];
            for (let item of this.medicalProceduresCoveredByInsurancePlans)
                data["medicalProceduresCoveredByInsurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.proceduresDuration)) {
            data["proceduresDuration"] = [];
            for (let item of this.proceduresDuration)
                data["proceduresDuration"].push(item.toJSON());
        }
        if (Array.isArray(this.careUnits)) {
            data["careUnits"] = [];
            for (let item of this.careUnits)
                data["careUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        data["workJourney"] = this.workJourney;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.locks)) {
            data["locks"] = [];
            for (let item of this.locks)
                data["locks"].push(item.toJSON());
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): Doctor {
        const json = this.toJSON();
        let result = new Doctor();
        result.init(json);
        return result;
    }
}

export interface IDoctor {
    licenceNumber: LicenceNumber;
    commercialPhone: string | undefined;
    profession: Profession;
    name: string | undefined;
    address: Address;
    discriminator: string | undefined;
    user: User;
    userId: number | undefined;
    medicalProceduresCoveredByInsuranceCompanies: HealthProfessionalInsuranceCompanyMedicalProcedure[] | undefined;
    medicalProceduresCoveredByInsurancePlans: HealthProfessionalInsurancePlanMedicalProcedure[] | undefined;
    proceduresDuration: HealthProfessionalMedicalProcedure[] | undefined;
    careUnits: HealthProfessionalCareUnitMedicalProcedure[] | undefined;
    appointments: MedicalAppointment[] | undefined;
    workJourney: string | undefined;
    externalId: string | undefined;
    locks: MedicalAppointmentLock[] | undefined;
    patients: PatientProfessionalRelationship[] | undefined;
    tenantId: number;
    id: string;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
}

export class DoctorEntityUpdatedEventData implements IDoctorEntityUpdatedEventData {
    entity: Doctor;
    eventTime: moment.Moment;
    eventSource: any | undefined;

    constructor(data?: IDoctorEntityUpdatedEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"] ? Doctor.fromJS(_data["entity"]) : <any>undefined;
            this.eventTime = _data["eventTime"] ? moment(_data["eventTime"].toString()) : <any>undefined;
            this.eventSource = _data["eventSource"];
        }
    }

    static fromJS(data: any): DoctorEntityUpdatedEventData {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorEntityUpdatedEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data; 
    }

    clone(): DoctorEntityUpdatedEventData {
        const json = this.toJSON();
        let result = new DoctorEntityUpdatedEventData();
        result.init(json);
        return result;
    }
}

export interface IDoctorEntityUpdatedEventData {
    entity: Doctor;
    eventTime: moment.Moment;
    eventSource: any | undefined;
}

export class Stream implements IStream {
    readonly canRead: boolean;
    readonly canWrite: boolean;
    readonly canSeek: boolean;
    readonly canTimeout: boolean;
    readonly length: number;
    position: number;
    readTimeout: number;
    writeTimeout: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canWrite = _data["canWrite"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canTimeout = _data["canTimeout"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data; 
    }

    clone(): Stream {
        const json = this.toJSON();
        let result = new Stream();
        result.init(json);
        return result;
    }
}

export interface IStream {
    canRead: boolean;
    canWrite: boolean;
    canSeek: boolean;
    canTimeout: boolean;
    length: number;
    position: number;
    readTimeout: number;
    writeTimeout: number;
}

export class InternalDomainSettings implements IInternalDomainSettings {
    enabled: boolean;
    domain: string | undefined;
    subdomain: string | undefined;

    constructor(data?: IInternalDomainSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.domain = _data["domain"];
            this.subdomain = _data["subdomain"];
        }
    }

    static fromJS(data: any): InternalDomainSettings {
        data = typeof data === 'object' ? data : {};
        let result = new InternalDomainSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["domain"] = this.domain;
        data["subdomain"] = this.subdomain;
        return data; 
    }

    clone(): InternalDomainSettings {
        const json = this.toJSON();
        let result = new InternalDomainSettings();
        result.init(json);
        return result;
    }
}

export interface IInternalDomainSettings {
    enabled: boolean;
    domain: string | undefined;
    subdomain: string | undefined;
}

export class CnameRecord implements ICnameRecord {
    prefix: string | undefined;
    value: string | undefined;

    constructor(data?: ICnameRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CnameRecord {
        data = typeof data === 'object' ? data : {};
        let result = new CnameRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["value"] = this.value;
        return data; 
    }

    clone(): CnameRecord {
        const json = this.toJSON();
        let result = new CnameRecord();
        result.init(json);
        return result;
    }
}

export interface ICnameRecord {
    prefix: string | undefined;
    value: string | undefined;
}

export class ExternalDomainDnsConfig implements IExternalDomainDnsConfig {
    recordA: CnameRecord;
    recordTxt: CnameRecord;
    recordCname: CnameRecord;

    constructor(data?: IExternalDomainDnsConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordA = _data["recordA"] ? CnameRecord.fromJS(_data["recordA"]) : <any>undefined;
            this.recordTxt = _data["recordTxt"] ? CnameRecord.fromJS(_data["recordTxt"]) : <any>undefined;
            this.recordCname = _data["recordCname"] ? CnameRecord.fromJS(_data["recordCname"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalDomainDnsConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalDomainDnsConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordA"] = this.recordA ? this.recordA.toJSON() : <any>undefined;
        data["recordTxt"] = this.recordTxt ? this.recordTxt.toJSON() : <any>undefined;
        data["recordCname"] = this.recordCname ? this.recordCname.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ExternalDomainDnsConfig {
        const json = this.toJSON();
        let result = new ExternalDomainDnsConfig();
        result.init(json);
        return result;
    }
}

export interface IExternalDomainDnsConfig {
    recordA: CnameRecord;
    recordTxt: CnameRecord;
    recordCname: CnameRecord;
}

export class ExternalDomainSettings implements IExternalDomainSettings {
    enabled: boolean;
    dns: ExternalDomainDnsConfig;
    domain: string | undefined;

    constructor(data?: IExternalDomainSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.dns = _data["dns"] ? ExternalDomainDnsConfig.fromJS(_data["dns"]) : <any>undefined;
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): ExternalDomainSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalDomainSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["dns"] = this.dns ? this.dns.toJSON() : <any>undefined;
        data["domain"] = this.domain;
        return data; 
    }

    clone(): ExternalDomainSettings {
        const json = this.toJSON();
        let result = new ExternalDomainSettings();
        result.init(json);
        return result;
    }
}

export interface IExternalDomainSettings {
    enabled: boolean;
    dns: ExternalDomainDnsConfig;
    domain: string | undefined;
}

export class DomainSettingsDto implements IDomainSettingsDto {
    internal: InternalDomainSettings;
    external: ExternalDomainSettings;

    constructor(data?: IDomainSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internal = _data["internal"] ? InternalDomainSettings.fromJS(_data["internal"]) : <any>undefined;
            this.external = _data["external"] ? ExternalDomainSettings.fromJS(_data["external"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DomainSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DomainSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internal"] = this.internal ? this.internal.toJSON() : <any>undefined;
        data["external"] = this.external ? this.external.toJSON() : <any>undefined;
        return data; 
    }

    clone(): DomainSettingsDto {
        const json = this.toJSON();
        let result = new DomainSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IDomainSettingsDto {
    internal: InternalDomainSettings;
    external: ExternalDomainSettings;
}

export class UpdateInternalDomainCommand implements IUpdateInternalDomainCommand {
    tenantId: number | undefined;
    subdomain: string | undefined;

    constructor(data?: IUpdateInternalDomainCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.subdomain = _data["subdomain"];
        }
    }

    static fromJS(data: any): UpdateInternalDomainCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInternalDomainCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["subdomain"] = this.subdomain;
        return data; 
    }

    clone(): UpdateInternalDomainCommand {
        const json = this.toJSON();
        let result = new UpdateInternalDomainCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateInternalDomainCommand {
    tenantId: number | undefined;
    subdomain: string | undefined;
}

export class UpdateExternalDomainCommand implements IUpdateExternalDomainCommand {
    tenantId: number | undefined;
    domain: string | undefined;

    constructor(data?: IUpdateExternalDomainCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): UpdateExternalDomainCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExternalDomainCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["domain"] = this.domain;
        return data; 
    }

    clone(): UpdateExternalDomainCommand {
        const json = this.toJSON();
        let result = new UpdateExternalDomainCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateExternalDomainCommand {
    tenantId: number | undefined;
    domain: string | undefined;
}

export class DeleteExternalDomainCommand implements IDeleteExternalDomainCommand {
    domain: string | undefined;

    constructor(data?: IDeleteExternalDomainCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): DeleteExternalDomainCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteExternalDomainCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        return data; 
    }

    clone(): DeleteExternalDomainCommand {
        const json = this.toJSON();
        let result = new DeleteExternalDomainCommand();
        result.init(json);
        return result;
    }
}

export interface IDeleteExternalDomainCommand {
    domain: string | undefined;
}

export class AddCustomDomainToRedirectAppServiceCommand implements IAddCustomDomainToRedirectAppServiceCommand {
    domain: string | undefined;

    constructor(data?: IAddCustomDomainToRedirectAppServiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): AddCustomDomainToRedirectAppServiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomDomainToRedirectAppServiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        return data; 
    }

    clone(): AddCustomDomainToRedirectAppServiceCommand {
        const json = this.toJSON();
        let result = new AddCustomDomainToRedirectAppServiceCommand();
        result.init(json);
        return result;
    }
}

export interface IAddCustomDomainToRedirectAppServiceCommand {
    domain: string | undefined;
}

export class SiteTemplatePage implements ISiteTemplatePage {
    order: number;
    template: SiteTemplate;
    templateId: number;
    name: string | undefined;
    definition: string | undefined;
    friendlyUrl: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISiteTemplatePage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.template = _data["template"] ? SiteTemplate.fromJS(_data["template"]) : <any>undefined;
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.definition = _data["definition"];
            this.friendlyUrl = _data["friendlyUrl"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SiteTemplatePage {
        data = typeof data === 'object' ? data : {};
        let result = new SiteTemplatePage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["definition"] = this.definition;
        data["friendlyUrl"] = this.friendlyUrl;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): SiteTemplatePage {
        const json = this.toJSON();
        let result = new SiteTemplatePage();
        result.init(json);
        return result;
    }
}

export interface ISiteTemplatePage {
    order: number;
    template: SiteTemplate;
    templateId: number;
    name: string | undefined;
    definition: string | undefined;
    friendlyUrl: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class SiteTemplate implements ISiteTemplate {
    name: string | undefined;
    title: string | undefined;
    faviconUrl: string | undefined;
    definition: string | undefined;
    isActive: boolean;
    pages: SiteTemplatePage[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISiteTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            this.faviconUrl = _data["faviconUrl"];
            this.definition = _data["definition"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages.push(SiteTemplatePage.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SiteTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new SiteTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        data["faviconUrl"] = this.faviconUrl;
        data["definition"] = this.definition;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): SiteTemplate {
        const json = this.toJSON();
        let result = new SiteTemplate();
        result.init(json);
        return result;
    }
}

export interface ISiteTemplate {
    name: string | undefined;
    title: string | undefined;
    faviconUrl: string | undefined;
    definition: string | undefined;
    isActive: boolean;
    pages: SiteTemplatePage[] | undefined;
    tenantId: number;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class SiteTemplatePageDto implements ISiteTemplatePageDto {
    order: number;
    name: string | undefined;
    definition: string | undefined;
    friendlyUrl: string | undefined;
    isActive: boolean;

    constructor(data?: ISiteTemplatePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.definition = _data["definition"];
            this.friendlyUrl = _data["friendlyUrl"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SiteTemplatePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteTemplatePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["definition"] = this.definition;
        data["friendlyUrl"] = this.friendlyUrl;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): SiteTemplatePageDto {
        const json = this.toJSON();
        let result = new SiteTemplatePageDto();
        result.init(json);
        return result;
    }
}

export interface ISiteTemplatePageDto {
    order: number;
    name: string | undefined;
    definition: string | undefined;
    friendlyUrl: string | undefined;
    isActive: boolean;
}

export class SiteTemplateDto implements ISiteTemplateDto {
    name: string | undefined;
    title: string | undefined;
    faviconUrl: string | undefined;
    definition: string | undefined;
    isActive: boolean;
    pages: SiteTemplatePageDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISiteTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            this.faviconUrl = _data["faviconUrl"];
            this.definition = _data["definition"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages.push(SiteTemplatePageDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SiteTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        data["faviconUrl"] = this.faviconUrl;
        data["definition"] = this.definition;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): SiteTemplateDto {
        const json = this.toJSON();
        let result = new SiteTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ISiteTemplateDto {
    name: string | undefined;
    title: string | undefined;
    faviconUrl: string | undefined;
    definition: string | undefined;
    isActive: boolean;
    pages: SiteTemplatePageDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UploadTemporalFileResponse implements IUploadTemporalFileResponse {
    url: string | undefined;

    constructor(data?: IUploadTemporalFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UploadTemporalFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadTemporalFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data; 
    }

    clone(): UploadTemporalFileResponse {
        const json = this.toJSON();
        let result = new UploadTemporalFileResponse();
        result.init(json);
        return result;
    }
}

export interface IUploadTemporalFileResponse {
    url: string | undefined;
}

export class UploadTemporalFileResult implements IUploadTemporalFileResult {
    name: string | undefined;
    url: string | undefined;

    constructor(data?: IUploadTemporalFileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UploadTemporalFileResult {
        data = typeof data === 'object' ? data : {};
        let result = new UploadTemporalFileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        return data; 
    }

    clone(): UploadTemporalFileResult {
        const json = this.toJSON();
        let result = new UploadTemporalFileResult();
        result.init(json);
        return result;
    }
}

export interface IUploadTemporalFileResult {
    name: string | undefined;
    url: string | undefined;
}

export class TenantDetails implements ITenantDetails {
    apiKey: string | undefined;
    isFinancialFeatureEnabled: boolean;
    tenancyName: string;
    name: string;
    isActive: boolean;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: FiscalInfo;
    paymentInfo: PaymentInfo;
    billingCycle: BillingCycle;
    /** External Id, Vindi external customer id */
    externalId: number;
    activePaymentProfile: number;
    activeSubscription: number;
    pickedPlan: boolean;
    /** Date when the payment was made */
    activationTime: moment.Moment | undefined;
    /** Domain for the template site, for now: xxxx.vsaude.com.br */
    domain: string | undefined;
    mobileProject: MobileProjectDto;
    id: number;

    constructor(data?: ITenantDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.isFinancialFeatureEnabled = _data["isFinancialFeatureEnabled"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.fixedPhone = _data["fixedPhone"];
            this.email = _data["email"];
            this.businessType = _data["businessType"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.fiscalInfo = _data["fiscalInfo"] ? FiscalInfo.fromJS(_data["fiscalInfo"]) : <any>undefined;
            this.paymentInfo = _data["paymentInfo"] ? PaymentInfo.fromJS(_data["paymentInfo"]) : <any>undefined;
            this.billingCycle = _data["billingCycle"];
            this.externalId = _data["externalId"];
            this.activePaymentProfile = _data["activePaymentProfile"];
            this.activeSubscription = _data["activeSubscription"];
            this.pickedPlan = _data["pickedPlan"];
            this.activationTime = _data["activationTime"] ? moment(_data["activationTime"].toString()) : <any>undefined;
            this.domain = _data["domain"];
            this.mobileProject = _data["mobileProject"] ? MobileProjectDto.fromJS(_data["mobileProject"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["isFinancialFeatureEnabled"] = this.isFinancialFeatureEnabled;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["phoneNumber"] = this.phoneNumber;
        data["fixedPhone"] = this.fixedPhone;
        data["email"] = this.email;
        data["businessType"] = this.businessType;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fiscalInfo"] = this.fiscalInfo ? this.fiscalInfo.toJSON() : <any>undefined;
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        data["billingCycle"] = this.billingCycle;
        data["externalId"] = this.externalId;
        data["activePaymentProfile"] = this.activePaymentProfile;
        data["activeSubscription"] = this.activeSubscription;
        data["pickedPlan"] = this.pickedPlan;
        data["activationTime"] = this.activationTime ? this.activationTime.toISOString() : <any>undefined;
        data["domain"] = this.domain;
        data["mobileProject"] = this.mobileProject ? this.mobileProject.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantDetails {
        const json = this.toJSON();
        let result = new TenantDetails();
        result.init(json);
        return result;
    }
}

export interface ITenantDetails {
    apiKey: string | undefined;
    isFinancialFeatureEnabled: boolean;
    tenancyName: string;
    name: string;
    isActive: boolean;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: FiscalInfo;
    paymentInfo: PaymentInfo;
    billingCycle: BillingCycle;
    /** External Id, Vindi external customer id */
    externalId: number;
    activePaymentProfile: number;
    activeSubscription: number;
    pickedPlan: boolean;
    /** Date when the payment was made */
    activationTime: moment.Moment | undefined;
    /** Domain for the template site, for now: xxxx.vsaude.com.br */
    domain: string | undefined;
    mobileProject: MobileProjectDto;
    id: number;
}

export class TenantDetailsPagedResultDto implements ITenantDetailsPagedResultDto {
    totalCount: number;
    items: TenantDetails[] | undefined;

    constructor(data?: ITenantDetailsPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDetailsPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDetailsPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TenantDetailsPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDetailsPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDetailsPagedResultDto {
    totalCount: number;
    items: TenantDetails[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    readonly tenancyName: string | undefined;
    businessType: BusinessType;
    editionId: number | undefined;
    editionName: string | undefined;
    possibleEditions: EditionDto[] | undefined;
    edition: EditionDto;
    name: string | undefined;
    commercialIdentifier: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    gatewayPaymentToken: string | undefined;
    pickedPlan: boolean;
    fiscalInfo: FiscalInfo;
    externalId: number;
    utm_source: string | undefined;
    utm_medium: string | undefined;
    utm_campaign: string | undefined;
    utm_content: string | undefined;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).tenancyName = _data["tenancyName"];
            this.businessType = _data["businessType"];
            this.editionId = _data["editionId"];
            this.editionName = _data["editionName"];
            if (Array.isArray(_data["possibleEditions"])) {
                this.possibleEditions = [] as any;
                for (let item of _data["possibleEditions"])
                    this.possibleEditions.push(EditionDto.fromJS(item));
            }
            this.edition = _data["edition"] ? EditionDto.fromJS(_data["edition"]) : <any>undefined;
            this.name = _data["name"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.gatewayPaymentToken = _data["gatewayPaymentToken"];
            this.pickedPlan = _data["pickedPlan"];
            this.fiscalInfo = _data["fiscalInfo"] ? FiscalInfo.fromJS(_data["fiscalInfo"]) : <any>undefined;
            this.externalId = _data["externalId"];
            this.utm_source = _data["utm_source"];
            this.utm_medium = _data["utm_medium"];
            this.utm_campaign = _data["utm_campaign"];
            this.utm_content = _data["utm_content"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["businessType"] = this.businessType;
        data["editionId"] = this.editionId;
        data["editionName"] = this.editionName;
        if (Array.isArray(this.possibleEditions)) {
            data["possibleEditions"] = [];
            for (let item of this.possibleEditions)
                data["possibleEditions"].push(item.toJSON());
        }
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["gatewayPaymentToken"] = this.gatewayPaymentToken;
        data["pickedPlan"] = this.pickedPlan;
        data["fiscalInfo"] = this.fiscalInfo ? this.fiscalInfo.toJSON() : <any>undefined;
        data["externalId"] = this.externalId;
        data["utm_source"] = this.utm_source;
        data["utm_medium"] = this.utm_medium;
        data["utm_campaign"] = this.utm_campaign;
        data["utm_content"] = this.utm_content;
        return data; 
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string | undefined;
    businessType: BusinessType;
    editionId: number | undefined;
    editionName: string | undefined;
    possibleEditions: EditionDto[] | undefined;
    edition: EditionDto;
    name: string | undefined;
    commercialIdentifier: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    gatewayPaymentToken: string | undefined;
    pickedPlan: boolean;
    fiscalInfo: FiscalInfo;
    externalId: number;
    utm_source: string | undefined;
    utm_medium: string | undefined;
    utm_campaign: string | undefined;
    utm_content: string | undefined;
}

export class WorkJourneyItemRange implements IWorkJourneyItemRange {
    start: string;
    end: string;

    constructor(data?: IWorkJourneyItemRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any): WorkJourneyItemRange {
        data = typeof data === 'object' ? data : {};
        let result = new WorkJourneyItemRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start;
        data["end"] = this.end;
        return data; 
    }

    clone(): WorkJourneyItemRange {
        const json = this.toJSON();
        let result = new WorkJourneyItemRange();
        result.init(json);
        return result;
    }
}

export interface IWorkJourneyItemRange {
    start: string;
    end: string;
}

export class WorkJourneyItem implements IWorkJourneyItem {
    dayOfWeek: DayOfWeek;
    low: WorkJourneyItemRange;
    high: WorkJourneyItemRange;

    constructor(data?: IWorkJourneyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.low = _data["low"] ? WorkJourneyItemRange.fromJS(_data["low"]) : <any>undefined;
            this.high = _data["high"] ? WorkJourneyItemRange.fromJS(_data["high"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkJourneyItem {
        data = typeof data === 'object' ? data : {};
        let result = new WorkJourneyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["low"] = this.low ? this.low.toJSON() : <any>undefined;
        data["high"] = this.high ? this.high.toJSON() : <any>undefined;
        return data; 
    }

    clone(): WorkJourneyItem {
        const json = this.toJSON();
        let result = new WorkJourneyItem();
        result.init(json);
        return result;
    }
}

export interface IWorkJourneyItem {
    dayOfWeek: DayOfWeek;
    low: WorkJourneyItemRange;
    high: WorkJourneyItemRange;
}

export class WorkJourney implements IWorkJourney {
    days: WorkJourneyItem[] | undefined;

    constructor(data?: IWorkJourney) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days.push(WorkJourneyItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkJourney {
        data = typeof data === 'object' ? data : {};
        let result = new WorkJourney();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        return data; 
    }

    clone(): WorkJourney {
        const json = this.toJSON();
        let result = new WorkJourney();
        result.init(json);
        return result;
    }
}

export interface IWorkJourney {
    days: WorkJourneyItem[] | undefined;
}

export class WorkJourneyDto implements IWorkJourneyDto {
    workJourney: WorkJourney;
    doctor: DoctorDto;

    constructor(data?: IWorkJourneyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workJourney = _data["workJourney"] ? WorkJourney.fromJS(_data["workJourney"]) : <any>undefined;
            this.doctor = _data["doctor"] ? DoctorDto.fromJS(_data["doctor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkJourneyDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkJourneyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workJourney"] = this.workJourney ? this.workJourney.toJSON() : <any>undefined;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        return data; 
    }

    clone(): WorkJourneyDto {
        const json = this.toJSON();
        let result = new WorkJourneyDto();
        result.init(json);
        return result;
    }
}

export interface IWorkJourneyDto {
    workJourney: WorkJourney;
    doctor: DoctorDto;
}

export class DoctorFilterDto implements IDoctorFilterDto {
    id: string;
    userId: number;
    fullName: string | undefined;
    readonly isDeleted: boolean;

    constructor(data?: IDoctorFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            (<any>this).isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DoctorFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }

    clone(): DoctorFilterDto {
        const json = this.toJSON();
        let result = new DoctorFilterDto();
        result.init(json);
        return result;
    }
}

export interface IDoctorFilterDto {
    id: string;
    userId: number;
    fullName: string | undefined;
    isDeleted: boolean;
}

export class DoctorCalendarSettings implements IDoctorCalendarSettings {
    doctors: DoctorFilterDto[] | undefined;
    hasConfigured: boolean;

    constructor(data?: IDoctorCalendarSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["doctors"])) {
                this.doctors = [] as any;
                for (let item of _data["doctors"])
                    this.doctors.push(DoctorFilterDto.fromJS(item));
            }
            this.hasConfigured = _data["hasConfigured"];
        }
    }

    static fromJS(data: any): DoctorCalendarSettings {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorCalendarSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.doctors)) {
            data["doctors"] = [];
            for (let item of this.doctors)
                data["doctors"].push(item.toJSON());
        }
        data["hasConfigured"] = this.hasConfigured;
        return data; 
    }

    clone(): DoctorCalendarSettings {
        const json = this.toJSON();
        let result = new DoctorCalendarSettings();
        result.init(json);
        return result;
    }
}

export interface IDoctorCalendarSettings {
    doctors: DoctorFilterDto[] | undefined;
    hasConfigured: boolean;
}

export class UnlockTenantCommand implements IUnlockTenantCommand {
    id: number;
    externalId: number;
    activeSubscription: number;

    constructor(data?: IUnlockTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.activeSubscription = _data["activeSubscription"];
        }
    }

    static fromJS(data: any): UnlockTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnlockTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["activeSubscription"] = this.activeSubscription;
        return data; 
    }

    clone(): UnlockTenantCommand {
        const json = this.toJSON();
        let result = new UnlockTenantCommand();
        result.init(json);
        return result;
    }
}

export interface IUnlockTenantCommand {
    id: number;
    externalId: number;
    activeSubscription: number;
}

export class ChangeTenantEmailCommand implements IChangeTenantEmailCommand {
    id: number;
    email: string | undefined;

    constructor(data?: IChangeTenantEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ChangeTenantEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTenantEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data; 
    }

    clone(): ChangeTenantEmailCommand {
        const json = this.toJSON();
        let result = new ChangeTenantEmailCommand();
        result.init(json);
        return result;
    }
}

export interface IChangeTenantEmailCommand {
    id: number;
    email: string | undefined;
}

export class SetTenantDefaultPatientEmailCommand implements ISetTenantDefaultPatientEmailCommand {
    id: number;
    email: string | undefined;
    password: string | undefined;

    constructor(data?: ISetTenantDefaultPatientEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SetTenantDefaultPatientEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetTenantDefaultPatientEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["password"] = this.password;
        return data; 
    }

    clone(): SetTenantDefaultPatientEmailCommand {
        const json = this.toJSON();
        let result = new SetTenantDefaultPatientEmailCommand();
        result.init(json);
        return result;
    }
}

export interface ISetTenantDefaultPatientEmailCommand {
    id: number;
    email: string | undefined;
    password: string | undefined;
}

export class SetApiKeyCommand implements ISetApiKeyCommand {
    id: number;

    constructor(data?: ISetApiKeyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SetApiKeyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetApiKeyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): SetApiKeyCommand {
        const json = this.toJSON();
        let result = new SetApiKeyCommand();
        result.init(json);
        return result;
    }
}

export interface ISetApiKeyCommand {
    id: number;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: FiscalInfo;
    paymentInfo: PaymentInfo;
    billingCycle: BillingCycle;
    /** External Id, Vindi external customer id */
    externalId: number;
    activePaymentProfile: number;
    activeSubscription: number;
    pickedPlan: boolean;
    /** Date when the payment was made */
    activationTime: moment.Moment | undefined;
    /** Domain for the template site, for now: xxxx.vsaude.com.br */
    domain: string | undefined;
    mobileProject: MobileProjectDto;
    id: number;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.commercialIdentifier = _data["commercialIdentifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.fixedPhone = _data["fixedPhone"];
            this.email = _data["email"];
            this.businessType = _data["businessType"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.fiscalInfo = _data["fiscalInfo"] ? FiscalInfo.fromJS(_data["fiscalInfo"]) : <any>undefined;
            this.paymentInfo = _data["paymentInfo"] ? PaymentInfo.fromJS(_data["paymentInfo"]) : <any>undefined;
            this.billingCycle = _data["billingCycle"];
            this.externalId = _data["externalId"];
            this.activePaymentProfile = _data["activePaymentProfile"];
            this.activeSubscription = _data["activeSubscription"];
            this.pickedPlan = _data["pickedPlan"];
            this.activationTime = _data["activationTime"] ? moment(_data["activationTime"].toString()) : <any>undefined;
            this.domain = _data["domain"];
            this.mobileProject = _data["mobileProject"] ? MobileProjectDto.fromJS(_data["mobileProject"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["commercialIdentifier"] = this.commercialIdentifier;
        data["phoneNumber"] = this.phoneNumber;
        data["fixedPhone"] = this.fixedPhone;
        data["email"] = this.email;
        data["businessType"] = this.businessType;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fiscalInfo"] = this.fiscalInfo ? this.fiscalInfo.toJSON() : <any>undefined;
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        data["billingCycle"] = this.billingCycle;
        data["externalId"] = this.externalId;
        data["activePaymentProfile"] = this.activePaymentProfile;
        data["activeSubscription"] = this.activeSubscription;
        data["pickedPlan"] = this.pickedPlan;
        data["activationTime"] = this.activationTime ? this.activationTime.toISOString() : <any>undefined;
        data["domain"] = this.domain;
        data["mobileProject"] = this.mobileProject ? this.mobileProject.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    commercialIdentifier: string | undefined;
    phoneNumber: string | undefined;
    fixedPhone: string | undefined;
    email: string | undefined;
    businessType: BusinessType;
    address: Address;
    fiscalInfo: FiscalInfo;
    paymentInfo: PaymentInfo;
    billingCycle: BillingCycle;
    /** External Id, Vindi external customer id */
    externalId: number;
    activePaymentProfile: number;
    activeSubscription: number;
    pickedPlan: boolean;
    /** Date when the payment was made */
    activationTime: moment.Moment | undefined;
    /** Domain for the template site, for now: xxxx.vsaude.com.br */
    domain: string | undefined;
    mobileProject: MobileProjectDto;
    id: number;
}

export class DataImportCompletedCommand implements IDataImportCompletedCommand {
    tenantId: number;

    constructor(data?: IDataImportCompletedCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): DataImportCompletedCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DataImportCompletedCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): DataImportCompletedCommand {
        const json = this.toJSON();
        let result = new DataImportCompletedCommand();
        result.init(json);
        return result;
    }
}

export interface IDataImportCompletedCommand {
    tenantId: number;
}

export class GeneratePatientProfessionalRelationshipRequest implements IGeneratePatientProfessionalRelationshipRequest {
    tenantId: number;
    healthProfessionalId: string;
    patients: string[] | undefined;

    constructor(data?: IGeneratePatientProfessionalRelationshipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.healthProfessionalId = _data["healthProfessionalId"];
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients.push(item);
            }
        }
    }

    static fromJS(data: any): GeneratePatientProfessionalRelationshipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePatientProfessionalRelationshipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["healthProfessionalId"] = this.healthProfessionalId;
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item);
        }
        return data; 
    }

    clone(): GeneratePatientProfessionalRelationshipRequest {
        const json = this.toJSON();
        let result = new GeneratePatientProfessionalRelationshipRequest();
        result.init(json);
        return result;
    }
}

export interface IGeneratePatientProfessionalRelationshipRequest {
    tenantId: number;
    healthProfessionalId: string;
    patients: string[] | undefined;
}

export class ProcessDataImportCommand implements IProcessDataImportCommand {
    tenantId: number;

    constructor(data?: IProcessDataImportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ProcessDataImportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDataImportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): ProcessDataImportCommand {
        const json = this.toJSON();
        let result = new ProcessDataImportCommand();
        result.init(json);
        return result;
    }
}

export interface IProcessDataImportCommand {
    tenantId: number;
}

export class PendingTermsOfService implements IPendingTermsOfService {
    id: number;
    title: string | undefined;
    descriptionLink: string | undefined;
    contentLink: string | undefined;
    required: boolean;

    constructor(data?: IPendingTermsOfService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.descriptionLink = _data["descriptionLink"];
            this.contentLink = _data["contentLink"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): PendingTermsOfService {
        data = typeof data === 'object' ? data : {};
        let result = new PendingTermsOfService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["descriptionLink"] = this.descriptionLink;
        data["contentLink"] = this.contentLink;
        data["required"] = this.required;
        return data; 
    }

    clone(): PendingTermsOfService {
        const json = this.toJSON();
        let result = new PendingTermsOfService();
        result.init(json);
        return result;
    }
}

export interface IPendingTermsOfService {
    id: number;
    title: string | undefined;
    descriptionLink: string | undefined;
    contentLink: string | undefined;
    required: boolean;
}

export class ColorTheme implements IColorTheme {
    tag: string | undefined;
    title: string | undefined;
    colorScheme: ColorScheme;
    background: string | undefined;

    constructor(data?: IColorTheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
            this.title = _data["title"];
            this.colorScheme = _data["colorScheme"] ? ColorScheme.fromJS(_data["colorScheme"]) : <any>undefined;
            this.background = _data["background"];
        }
    }

    static fromJS(data: any): ColorTheme {
        data = typeof data === 'object' ? data : {};
        let result = new ColorTheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["title"] = this.title;
        data["colorScheme"] = this.colorScheme ? this.colorScheme.toJSON() : <any>undefined;
        data["background"] = this.background;
        return data; 
    }

    clone(): ColorTheme {
        const json = this.toJSON();
        let result = new ColorTheme();
        result.init(json);
        return result;
    }
}

export interface IColorTheme {
    tag: string | undefined;
    title: string | undefined;
    colorScheme: ColorScheme;
    background: string | undefined;
}

export class ColorThemeCategory implements IColorThemeCategory {
    title: string | undefined;
    description: string | undefined;
    color: string | undefined;
    colorThemes: ColorTheme[] | undefined;

    constructor(data?: IColorThemeCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.color = _data["color"];
            if (Array.isArray(_data["colorThemes"])) {
                this.colorThemes = [] as any;
                for (let item of _data["colorThemes"])
                    this.colorThemes.push(ColorTheme.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ColorThemeCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ColorThemeCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["color"] = this.color;
        if (Array.isArray(this.colorThemes)) {
            data["colorThemes"] = [];
            for (let item of this.colorThemes)
                data["colorThemes"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ColorThemeCategory {
        const json = this.toJSON();
        let result = new ColorThemeCategory();
        result.init(json);
        return result;
    }
}

export interface IColorThemeCategory {
    title: string | undefined;
    description: string | undefined;
    color: string | undefined;
    colorThemes: ColorTheme[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data; 
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateMobileUserModel implements IAuthenticateMobileUserModel {
    userNameOrEmailAddress: string;
    password: string;
    mobileProjectId: string | undefined;
    tenant: number | undefined;

    constructor(data?: IAuthenticateMobileUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.mobileProjectId = _data["mobileProjectId"];
            this.tenant = _data["tenant"];
        }
    }

    static fromJS(data: any): AuthenticateMobileUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateMobileUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["mobileProjectId"] = this.mobileProjectId;
        data["tenant"] = this.tenant;
        return data; 
    }

    clone(): AuthenticateMobileUserModel {
        const json = this.toJSON();
        let result = new AuthenticateMobileUserModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateMobileUserModel {
    userNameOrEmailAddress: string;
    password: string;
    mobileProjectId: string | undefined;
    tenant: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data; 
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class TransactionPaymentMethod implements ITransactionPaymentMethod {
    resource: string | undefined;
    cardBrand: string | undefined;
    cardFirst4Digits: string | undefined;
    cardLast4Digits: string | undefined;
    cardExpirationMonth: string | undefined;
    cardExpirationYear: string | undefined;
    cardHolderName: string | undefined;

    constructor(data?: ITransactionPaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resource = _data["resource"];
            this.cardBrand = _data["cardBrand"];
            this.cardFirst4Digits = _data["cardFirst4Digits"];
            this.cardLast4Digits = _data["cardLast4Digits"];
            this.cardExpirationMonth = _data["cardExpirationMonth"];
            this.cardExpirationYear = _data["cardExpirationYear"];
            this.cardHolderName = _data["cardHolderName"];
        }
    }

    static fromJS(data: any): TransactionPaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionPaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resource"] = this.resource;
        data["cardBrand"] = this.cardBrand;
        data["cardFirst4Digits"] = this.cardFirst4Digits;
        data["cardLast4Digits"] = this.cardLast4Digits;
        data["cardExpirationMonth"] = this.cardExpirationMonth;
        data["cardExpirationYear"] = this.cardExpirationYear;
        data["cardHolderName"] = this.cardHolderName;
        return data; 
    }

    clone(): TransactionPaymentMethod {
        const json = this.toJSON();
        let result = new TransactionPaymentMethod();
        result.init(json);
        return result;
    }
}

export interface ITransactionPaymentMethod {
    resource: string | undefined;
    cardBrand: string | undefined;
    cardFirst4Digits: string | undefined;
    cardLast4Digits: string | undefined;
    cardExpirationMonth: string | undefined;
    cardExpirationYear: string | undefined;
    cardHolderName: string | undefined;
}

export class TransactionDetails implements ITransactionDetails {
    status: string | undefined;
    amount: string | undefined;
    currency: string | undefined;
    paymentType: string | undefined;
    transactionPaymentMethod: TransactionPaymentMethod;
    createdAt: moment.Moment;

    constructor(data?: ITransactionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.paymentType = _data["paymentType"];
            this.transactionPaymentMethod = _data["transactionPaymentMethod"] ? TransactionPaymentMethod.fromJS(_data["transactionPaymentMethod"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["paymentType"] = this.paymentType;
        data["transactionPaymentMethod"] = this.transactionPaymentMethod ? this.transactionPaymentMethod.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data; 
    }

    clone(): TransactionDetails {
        const json = this.toJSON();
        let result = new TransactionDetails();
        result.init(json);
        return result;
    }
}

export interface ITransactionDetails {
    status: string | undefined;
    amount: string | undefined;
    currency: string | undefined;
    paymentType: string | undefined;
    transactionPaymentMethod: TransactionPaymentMethod;
    createdAt: moment.Moment;
}

export class CardDetails implements ICardDetails {
    brand: string | undefined;
    firstDigits: string | undefined;
    lastDigits: string | undefined;

    constructor(data?: ICardDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brand = _data["brand"];
            this.firstDigits = _data["firstDigits"];
            this.lastDigits = _data["lastDigits"];
        }
    }

    static fromJS(data: any): CardDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CardDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand;
        data["firstDigits"] = this.firstDigits;
        data["lastDigits"] = this.lastDigits;
        return data; 
    }

    clone(): CardDetails {
        const json = this.toJSON();
        let result = new CardDetails();
        result.init(json);
        return result;
    }
}

export interface ICardDetails {
    brand: string | undefined;
    firstDigits: string | undefined;
    lastDigits: string | undefined;
}

export class ReceiptDetails implements IReceiptDetails {
    status: string | undefined;
    amount: string | undefined;
    paymentType: string | undefined;
    businessName: string | undefined;
    seller: string | undefined;
    createdAt: moment.Moment;
    cardDetails: CardDetails;

    constructor(data?: IReceiptDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.amount = _data["amount"];
            this.paymentType = _data["paymentType"];
            this.businessName = _data["businessName"];
            this.seller = _data["seller"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.cardDetails = _data["cardDetails"] ? CardDetails.fromJS(_data["cardDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReceiptDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["paymentType"] = this.paymentType;
        data["businessName"] = this.businessName;
        data["seller"] = this.seller;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["cardDetails"] = this.cardDetails ? this.cardDetails.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ReceiptDetails {
        const json = this.toJSON();
        let result = new ReceiptDetails();
        result.init(json);
        return result;
    }
}

export interface IReceiptDetails {
    status: string | undefined;
    amount: string | undefined;
    paymentType: string | undefined;
    businessName: string | undefined;
    seller: string | undefined;
    createdAt: moment.Moment;
    cardDetails: CardDetails;
}

export class DeletedUserDto implements IDeletedUserDto {
    id: number;
    name: string | undefined;
    surName: string | undefined;
    userName: string | undefined;
    deletionTime: moment.Moment;
    deletionUserName: string | undefined;

    constructor(data?: IDeletedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surName = _data["surName"];
            this.userName = _data["userName"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.deletionUserName = _data["deletionUserName"];
        }
    }

    static fromJS(data: any): DeletedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeletedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surName"] = this.surName;
        data["userName"] = this.userName;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["deletionUserName"] = this.deletionUserName;
        return data; 
    }

    clone(): DeletedUserDto {
        const json = this.toJSON();
        let result = new DeletedUserDto();
        result.init(json);
        return result;
    }
}

export interface IDeletedUserDto {
    id: number;
    name: string | undefined;
    surName: string | undefined;
    userName: string | undefined;
    deletionTime: moment.Moment;
    deletionUserName: string | undefined;
}

export class GetDeletedUsersQueryResult implements IGetDeletedUsersQueryResult {
    totalCount: number;
    items: DeletedUserDto[] | undefined;

    constructor(data?: IGetDeletedUsersQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DeletedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeletedUsersQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeletedUsersQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetDeletedUsersQueryResult {
        const json = this.toJSON();
        let result = new GetDeletedUsersQueryResult();
        result.init(json);
        return result;
    }
}

export interface IGetDeletedUsersQueryResult {
    totalCount: number;
    items: DeletedUserDto[] | undefined;
}

export class UploadResponse implements IUploadResponse {
    url: string | undefined;

    constructor(data?: IUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data; 
    }

    clone(): UploadResponse {
        const json = this.toJSON();
        let result = new UploadResponse();
        result.init(json);
        return result;
    }
}

export interface IUploadResponse {
    url: string | undefined;
}

export class AvailableTenant implements IAvailableTenant {
    name: string | undefined;
    text: string | undefined;

    constructor(data?: IAvailableTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AvailableTenant {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["text"] = this.text;
        return data; 
    }

    clone(): AvailableTenant {
        const json = this.toJSON();
        let result = new AvailableTenant();
        result.init(json);
        return result;
    }
}

export interface IAvailableTenant {
    name: string | undefined;
    text: string | undefined;
}

export class UpdateUserPermissionsRequest implements IUpdateUserPermissionsRequest {
    userId: number;
    permissions: PermissionDto[] | undefined;

    constructor(data?: IUpdateUserPermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpdateUserPermissionsRequest {
        const json = this.toJSON();
        let result = new UpdateUserPermissionsRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserPermissionsRequest {
    userId: number;
    permissions: PermissionDto[] | undefined;
}

export class ResetUserPermissionsRequest implements IResetUserPermissionsRequest {
    userId: number;

    constructor(data?: IResetUserPermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ResetUserPermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetUserPermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data; 
    }

    clone(): ResetUserPermissionsRequest {
        const json = this.toJSON();
        let result = new ResetUserPermissionsRequest();
        result.init(json);
        return result;
    }
}

export interface IResetUserPermissionsRequest {
    userId: number;
}

export class CreateMobileUserDto implements ICreateMobileUserDto {
    mobileProjectId: string;
    tenantId: number | undefined;
    fullName: string;
    emailAddress: string;
    isEmailConfirmed: boolean;
    password: string | undefined;
    phone: string | undefined;
    isPhoneConfirmed: boolean;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    address: Address;
    birthday: moment.Moment | undefined;

    constructor(data?: ICreateMobileUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileProjectId = _data["mobileProjectId"];
            this.tenantId = _data["tenantId"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.password = _data["password"];
            this.phone = _data["phone"];
            this.isPhoneConfirmed = _data["isPhoneConfirmed"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.dni = _data["dni"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMobileUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMobileUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileProjectId"] = this.mobileProjectId;
        data["tenantId"] = this.tenantId;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["password"] = this.password;
        data["phone"] = this.phone;
        data["isPhoneConfirmed"] = this.isPhoneConfirmed;
        data["personalIdentifier"] = this.personalIdentifier;
        data["dni"] = this.dni;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        return data; 
    }

    clone(): CreateMobileUserDto {
        const json = this.toJSON();
        let result = new CreateMobileUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMobileUserDto {
    mobileProjectId: string;
    tenantId: number | undefined;
    fullName: string;
    emailAddress: string;
    isEmailConfirmed: boolean;
    password: string | undefined;
    phone: string | undefined;
    isPhoneConfirmed: boolean;
    personalIdentifier: string | undefined;
    dni: string | undefined;
    address: Address;
    birthday: moment.Moment | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
    name: string;
    surname: string;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    birthday: moment.Moment;
    gender: number | undefined;
    id: number;

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalIdentifier = _data["personalIdentifier"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["personalIdentifier"] = this.personalIdentifier;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateUserDto {
        const json = this.toJSON();
        let result = new UpdateUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDto {
    name: string;
    surname: string;
    phoneNumber: string | undefined;
    personalIdentifier: string | undefined;
    birthday: moment.Moment;
    gender: number | undefined;
    id: number;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class UserChat implements IUserChat {
    id: string | undefined;
    name: string | undefined;
    avatar: string | undefined;
    status: string | undefined;
    mood: string | undefined;
    unread: number | undefined;

    constructor(data?: IUserChat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.mood = _data["mood"];
            this.unread = _data["unread"];
        }
    }

    static fromJS(data: any): UserChat {
        data = typeof data === 'object' ? data : {};
        let result = new UserChat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["mood"] = this.mood;
        data["unread"] = this.unread;
        return data; 
    }

    clone(): UserChat {
        const json = this.toJSON();
        let result = new UserChat();
        result.init(json);
        return result;
    }
}

export interface IUserChat {
    id: string | undefined;
    name: string | undefined;
    avatar: string | undefined;
    status: string | undefined;
    mood: string | undefined;
    unread: number | undefined;
}

export class ChatConnectionInfo implements IChatConnectionInfo {
    domain: string | undefined;
    service: string | undefined;
    user: string | undefined;
    password: string | undefined;

    constructor(data?: IChatConnectionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
            this.service = _data["service"];
            this.user = _data["user"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ChatConnectionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ChatConnectionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["service"] = this.service;
        data["user"] = this.user;
        data["password"] = this.password;
        return data; 
    }

    clone(): ChatConnectionInfo {
        const json = this.toJSON();
        let result = new ChatConnectionInfo();
        result.init(json);
        return result;
    }
}

export interface IChatConnectionInfo {
    domain: string | undefined;
    service: string | undefined;
    user: string | undefined;
    password: string | undefined;
}

export class UserInfo implements IUserInfo {
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    isEmailConfirmed: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    avatar: string | undefined;
    id: number;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.avatar = _data["avatar"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["avatar"] = this.avatar;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserInfo {
        const json = this.toJSON();
        let result = new UserInfo();
        result.init(json);
        return result;
    }
}

export interface IUserInfo {
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    isEmailConfirmed: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    avatar: string | undefined;
    id: number;
}

export class UpdateUserInfoRequest implements IUpdateUserInfoRequest {
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    isEmailConfirmation: boolean;
    isPhoneNumberConfirmation: boolean;
    isMobile: boolean;

    constructor(data?: IUpdateUserInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isEmailConfirmation = _data["isEmailConfirmation"];
            this.isPhoneNumberConfirmation = _data["isPhoneNumberConfirmation"];
            this.isMobile = _data["isMobile"];
        }
    }

    static fromJS(data: any): UpdateUserInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isEmailConfirmation"] = this.isEmailConfirmation;
        data["isPhoneNumberConfirmation"] = this.isPhoneNumberConfirmation;
        data["isMobile"] = this.isMobile;
        return data; 
    }

    clone(): UpdateUserInfoRequest {
        const json = this.toJSON();
        let result = new UpdateUserInfoRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserInfoRequest {
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    isEmailConfirmation: boolean;
    isPhoneNumberConfirmation: boolean;
    isMobile: boolean;
}

export class UpdateUserInfoResponse implements IUpdateUserInfoResponse {
    confirmed: boolean;
    userInfo: UserInfo;
    confirmationCode: string | undefined;

    constructor(data?: IUpdateUserInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmed = _data["confirmed"];
            this.userInfo = _data["userInfo"] ? UserInfo.fromJS(_data["userInfo"]) : <any>undefined;
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): UpdateUserInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmed"] = this.confirmed;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        data["confirmationCode"] = this.confirmationCode;
        return data; 
    }

    clone(): UpdateUserInfoResponse {
        const json = this.toJSON();
        let result = new UpdateUserInfoResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserInfoResponse {
    confirmed: boolean;
    userInfo: UserInfo;
    confirmationCode: string | undefined;
}

export class StartResetPasswordRequest implements IStartResetPasswordRequest {
    mobileProjectId: string;
    email: string | undefined;

    constructor(data?: IStartResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileProjectId = _data["mobileProjectId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): StartResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileProjectId"] = this.mobileProjectId;
        data["email"] = this.email;
        return data; 
    }

    clone(): StartResetPasswordRequest {
        const json = this.toJSON();
        let result = new StartResetPasswordRequest();
        result.init(json);
        return result;
    }
}

export interface IStartResetPasswordRequest {
    mobileProjectId: string;
    email: string | undefined;
}

export class ResetPasswordResponse implements IResetPasswordResponse {
    token: string | undefined;

    constructor(data?: IResetPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ResetPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data; 
    }

    clone(): ResetPasswordResponse {
        const json = this.toJSON();
        let result = new ResetPasswordResponse();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResponse {
    token: string | undefined;
}

export class ValidateResetPasswordCodeInput implements IValidateResetPasswordCodeInput {
    email: string | undefined;
    code: string | undefined;

    constructor(data?: IValidateResetPasswordCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ValidateResetPasswordCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResetPasswordCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["code"] = this.code;
        return data; 
    }

    clone(): ValidateResetPasswordCodeInput {
        const json = this.toJSON();
        let result = new ValidateResetPasswordCodeInput();
        result.init(json);
        return result;
    }
}

export interface IValidateResetPasswordCodeInput {
    email: string | undefined;
    code: string | undefined;
}

export class CompleteResetPasswordRequest implements ICompleteResetPasswordRequest {
    mobileProjectId: string;
    email: string | undefined;
    token: string | undefined;
    password: string | undefined;

    constructor(data?: ICompleteResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileProjectId = _data["mobileProjectId"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CompleteResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileProjectId"] = this.mobileProjectId;
        data["email"] = this.email;
        data["token"] = this.token;
        data["password"] = this.password;
        return data; 
    }

    clone(): CompleteResetPasswordRequest {
        const json = this.toJSON();
        let result = new CompleteResetPasswordRequest();
        result.init(json);
        return result;
    }
}

export interface ICompleteResetPasswordRequest {
    mobileProjectId: string;
    email: string | undefined;
    token: string | undefined;
    password: string | undefined;
}

export class ForgotPasswordConfirm implements IForgotPasswordConfirm {
    email: string | undefined;

    constructor(data?: IForgotPasswordConfirm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordConfirm {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordConfirm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data; 
    }

    clone(): ForgotPasswordConfirm {
        const json = this.toJSON();
        let result = new ForgotPasswordConfirm();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordConfirm {
    email: string | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    password: string | undefined;
    userId: number | undefined;
    newPassword: string | undefined;
    isMobile: boolean;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
            this.isMobile = _data["isMobile"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        data["isMobile"] = this.isMobile;
        return data; 
    }

    clone(): ChangePasswordRequest {
        const json = this.toJSON();
        let result = new ChangePasswordRequest();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordRequest {
    password: string | undefined;
    userId: number | undefined;
    newPassword: string | undefined;
    isMobile: boolean;
}

export class ChangeEmailRequest implements IChangeEmailRequest {
    emailAddress: string | undefined;
    userId: number;

    constructor(data?: IChangeEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ChangeEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): ChangeEmailRequest {
        const json = this.toJSON();
        let result = new ChangeEmailRequest();
        result.init(json);
        return result;
    }
}

export interface IChangeEmailRequest {
    emailAddress: string | undefined;
    userId: number;
}

export class IsUserIdAvailableQuery implements IIsUserIdAvailableQuery {
    tenantId: number | undefined;
    mobileProjectId: string | undefined;
    id: string | undefined;

    constructor(data?: IIsUserIdAvailableQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.mobileProjectId = _data["mobileProjectId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IsUserIdAvailableQuery {
        data = typeof data === 'object' ? data : {};
        let result = new IsUserIdAvailableQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["mobileProjectId"] = this.mobileProjectId;
        data["id"] = this.id;
        return data; 
    }

    clone(): IsUserIdAvailableQuery {
        const json = this.toJSON();
        let result = new IsUserIdAvailableQuery();
        result.init(json);
        return result;
    }
}

export interface IIsUserIdAvailableQuery {
    tenantId: number | undefined;
    mobileProjectId: string | undefined;
    id: string | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;
}

export class UpdateUserAvatarResponse implements IUpdateUserAvatarResponse {
    url: string | undefined;

    constructor(data?: IUpdateUserAvatarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UpdateUserAvatarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserAvatarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data; 
    }

    clone(): UpdateUserAvatarResponse {
        const json = this.toJSON();
        let result = new UpdateUserAvatarResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserAvatarResponse {
    url: string | undefined;
}

export class GetSessionInfoResponse implements IGetSessionInfoResponse {
    personalIdentifier: string | undefined;
    authorizationTokenLifetime: moment.Moment | undefined;
    isAuthorizationTokenValid: boolean;

    constructor(data?: IGetSessionInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalIdentifier = _data["personalIdentifier"];
            this.authorizationTokenLifetime = _data["authorizationTokenLifetime"] ? moment(_data["authorizationTokenLifetime"].toString()) : <any>undefined;
            this.isAuthorizationTokenValid = _data["isAuthorizationTokenValid"];
        }
    }

    static fromJS(data: any): GetSessionInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSessionInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalIdentifier"] = this.personalIdentifier;
        data["authorizationTokenLifetime"] = this.authorizationTokenLifetime ? this.authorizationTokenLifetime.toISOString() : <any>undefined;
        data["isAuthorizationTokenValid"] = this.isAuthorizationTokenValid;
        return data; 
    }

    clone(): GetSessionInfoResponse {
        const json = this.toJSON();
        let result = new GetSessionInfoResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSessionInfoResponse {
    personalIdentifier: string | undefined;
    authorizationTokenLifetime: moment.Moment | undefined;
    isAuthorizationTokenValid: boolean;
}

export class Border implements IBorder {
    topLeft: number;
    topRight: number;
    bottomRight: number;
    bottomLeft: number;
    color: string | undefined;
    width: number;

    constructor(data?: IBorder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topLeft = _data["topLeft"];
            this.topRight = _data["topRight"];
            this.bottomRight = _data["bottomRight"];
            this.bottomLeft = _data["bottomLeft"];
            this.color = _data["color"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): Border {
        data = typeof data === 'object' ? data : {};
        let result = new Border();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topLeft"] = this.topLeft;
        data["topRight"] = this.topRight;
        data["bottomRight"] = this.bottomRight;
        data["bottomLeft"] = this.bottomLeft;
        data["color"] = this.color;
        data["width"] = this.width;
        return data; 
    }

    clone(): Border {
        const json = this.toJSON();
        let result = new Border();
        result.init(json);
        return result;
    }
}

export interface IBorder {
    topLeft: number;
    topRight: number;
    bottomRight: number;
    bottomLeft: number;
    color: string | undefined;
    width: number;
}

export class Shadow implements IShadow {
    color: string | undefined;
    elevation: number;

    constructor(data?: IShadow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
            this.elevation = _data["elevation"];
        }
    }

    static fromJS(data: any): Shadow {
        data = typeof data === 'object' ? data : {};
        let result = new Shadow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["elevation"] = this.elevation;
        return data; 
    }

    clone(): Shadow {
        const json = this.toJSON();
        let result = new Shadow();
        result.init(json);
        return result;
    }
}

export interface IShadow {
    color: string | undefined;
    elevation: number;
}

export class Padding implements IPadding {
    left: number;
    right: number;
    top: number;
    bottom: number;

    constructor(data?: IPadding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.left = _data["left"];
            this.right = _data["right"];
            this.top = _data["top"];
            this.bottom = _data["bottom"];
        }
    }

    static fromJS(data: any): Padding {
        data = typeof data === 'object' ? data : {};
        let result = new Padding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["left"] = this.left;
        data["right"] = this.right;
        data["top"] = this.top;
        data["bottom"] = this.bottom;
        return data; 
    }

    clone(): Padding {
        const json = this.toJSON();
        let result = new Padding();
        result.init(json);
        return result;
    }
}

export interface IPadding {
    left: number;
    right: number;
    top: number;
    bottom: number;
}

export class Control implements IControl {
    border: Border;
    shadow: Shadow;
    margin: Padding;
    padding: Padding;
    color: ColorScheme;

    constructor(data?: IControl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.border = _data["border"] ? Border.fromJS(_data["border"]) : <any>undefined;
            this.shadow = _data["shadow"] ? Shadow.fromJS(_data["shadow"]) : <any>undefined;
            this.margin = _data["margin"] ? Padding.fromJS(_data["margin"]) : <any>undefined;
            this.padding = _data["padding"] ? Padding.fromJS(_data["padding"]) : <any>undefined;
            this.color = _data["color"] ? ColorScheme.fromJS(_data["color"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Control {
        data = typeof data === 'object' ? data : {};
        let result = new Control();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["border"] = this.border ? this.border.toJSON() : <any>undefined;
        data["shadow"] = this.shadow ? this.shadow.toJSON() : <any>undefined;
        data["margin"] = this.margin ? this.margin.toJSON() : <any>undefined;
        data["padding"] = this.padding ? this.padding.toJSON() : <any>undefined;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        return data; 
    }

    clone(): Control {
        const json = this.toJSON();
        let result = new Control();
        result.init(json);
        return result;
    }
}

export interface IControl {
    border: Border;
    shadow: Shadow;
    margin: Padding;
    padding: Padding;
    color: ColorScheme;
}

export class AppModule implements IAppModule {
    name: string | undefined;
    layout: string | undefined;
    icon: string | undefined;
    title: string | undefined;
    isStatusBarDark: boolean;
    border: Border;
    shadow: Shadow;
    margin: Padding;
    padding: Padding;
    color: ColorScheme;

    constructor(data?: IAppModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.layout = _data["layout"];
            this.icon = _data["icon"];
            this.title = _data["title"];
            this.isStatusBarDark = _data["isStatusBarDark"];
            this.border = _data["border"] ? Border.fromJS(_data["border"]) : <any>undefined;
            this.shadow = _data["shadow"] ? Shadow.fromJS(_data["shadow"]) : <any>undefined;
            this.margin = _data["margin"] ? Padding.fromJS(_data["margin"]) : <any>undefined;
            this.padding = _data["padding"] ? Padding.fromJS(_data["padding"]) : <any>undefined;
            this.color = _data["color"] ? ColorScheme.fromJS(_data["color"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppModule {
        data = typeof data === 'object' ? data : {};
        let result = new AppModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["layout"] = this.layout;
        data["icon"] = this.icon;
        data["title"] = this.title;
        data["isStatusBarDark"] = this.isStatusBarDark;
        data["border"] = this.border ? this.border.toJSON() : <any>undefined;
        data["shadow"] = this.shadow ? this.shadow.toJSON() : <any>undefined;
        data["margin"] = this.margin ? this.margin.toJSON() : <any>undefined;
        data["padding"] = this.padding ? this.padding.toJSON() : <any>undefined;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AppModule {
        const json = this.toJSON();
        let result = new AppModule();
        result.init(json);
        return result;
    }
}

export interface IAppModule {
    name: string | undefined;
    layout: string | undefined;
    icon: string | undefined;
    title: string | undefined;
    isStatusBarDark: boolean;
    border: Border;
    shadow: Shadow;
    margin: Padding;
    padding: Padding;
    color: ColorScheme;
}

export class MobileProjectStructureDto implements IMobileProjectStructureDto {
    patientRegistrationSettings: PatientRegistrationSettings;
    id: string;
    layoutType: string | undefined;
    layout: string | undefined;
    color: ColorScheme;
    control: Control;
    modules: AppModule[] | undefined;
    logo: string | undefined;
    name: string | undefined;
    owner: number;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;
    colorTheme: ColorScheme;

    constructor(data?: IMobileProjectStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientRegistrationSettings = _data["patientRegistrationSettings"] ? PatientRegistrationSettings.fromJS(_data["patientRegistrationSettings"]) : <any>undefined;
            this.id = _data["id"];
            this.layoutType = _data["layoutType"];
            this.layout = _data["layout"];
            this.color = _data["color"] ? ColorScheme.fromJS(_data["color"]) : <any>undefined;
            this.control = _data["control"] ? Control.fromJS(_data["control"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules.push(AppModule.fromJS(item));
            }
            this.logo = _data["logo"];
            this.name = _data["name"];
            this.owner = _data["owner"];
            this.appStoreLink = _data["appStoreLink"];
            this.googlePlayLink = _data["googlePlayLink"];
            this.colorTheme = _data["colorTheme"] ? ColorScheme.fromJS(_data["colorTheme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MobileProjectStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobileProjectStructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientRegistrationSettings"] = this.patientRegistrationSettings ? this.patientRegistrationSettings.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["layoutType"] = this.layoutType;
        data["layout"] = this.layout;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["control"] = this.control ? this.control.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["logo"] = this.logo;
        data["name"] = this.name;
        data["owner"] = this.owner;
        data["appStoreLink"] = this.appStoreLink;
        data["googlePlayLink"] = this.googlePlayLink;
        data["colorTheme"] = this.colorTheme ? this.colorTheme.toJSON() : <any>undefined;
        return data; 
    }

    clone(): MobileProjectStructureDto {
        const json = this.toJSON();
        let result = new MobileProjectStructureDto();
        result.init(json);
        return result;
    }
}

export interface IMobileProjectStructureDto {
    patientRegistrationSettings: PatientRegistrationSettings;
    id: string;
    layoutType: string | undefined;
    layout: string | undefined;
    color: ColorScheme;
    control: Control;
    modules: AppModule[] | undefined;
    logo: string | undefined;
    name: string | undefined;
    owner: number;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;
    colorTheme: ColorScheme;
}

export class GetMobileProjectStructureResult implements IGetMobileProjectStructureResult {
    tenantId: number;
    id: string;
    layout: string | undefined;
    color: ColorScheme;
    control: Control;
    modules: AppModule[] | undefined;
    isStatusBarDark: boolean;
    logo: string | undefined;
    icon: string | undefined;
    name: string | undefined;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;
    pwaLink: string | undefined;
    timezoneOffset: number | undefined;

    constructor(data?: IGetMobileProjectStructureResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.layout = _data["layout"];
            this.color = _data["color"] ? ColorScheme.fromJS(_data["color"]) : <any>undefined;
            this.control = _data["control"] ? Control.fromJS(_data["control"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules.push(AppModule.fromJS(item));
            }
            this.isStatusBarDark = _data["isStatusBarDark"];
            this.logo = _data["logo"];
            this.icon = _data["icon"];
            this.name = _data["name"];
            this.appStoreLink = _data["appStoreLink"];
            this.googlePlayLink = _data["googlePlayLink"];
            this.pwaLink = _data["pwaLink"];
            this.timezoneOffset = _data["timezoneOffset"];
        }
    }

    static fromJS(data: any): GetMobileProjectStructureResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMobileProjectStructureResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["layout"] = this.layout;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["control"] = this.control ? this.control.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["isStatusBarDark"] = this.isStatusBarDark;
        data["logo"] = this.logo;
        data["icon"] = this.icon;
        data["name"] = this.name;
        data["appStoreLink"] = this.appStoreLink;
        data["googlePlayLink"] = this.googlePlayLink;
        data["pwaLink"] = this.pwaLink;
        data["timezoneOffset"] = this.timezoneOffset;
        return data; 
    }

    clone(): GetMobileProjectStructureResult {
        const json = this.toJSON();
        let result = new GetMobileProjectStructureResult();
        result.init(json);
        return result;
    }
}

export interface IGetMobileProjectStructureResult {
    tenantId: number;
    id: string;
    layout: string | undefined;
    color: ColorScheme;
    control: Control;
    modules: AppModule[] | undefined;
    isStatusBarDark: boolean;
    logo: string | undefined;
    icon: string | undefined;
    name: string | undefined;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;
    pwaLink: string | undefined;
    timezoneOffset: number | undefined;
}

export class UpdateMobileProjectStructureCommand implements IUpdateMobileProjectStructureCommand {
    id: string;
    layout: string | undefined;
    color: ColorScheme;
    control: Control;
    modules: AppModule[] | undefined;
    timezoneOffset: number | undefined;

    constructor(data?: IUpdateMobileProjectStructureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layout = _data["layout"];
            this.color = _data["color"] ? ColorScheme.fromJS(_data["color"]) : <any>undefined;
            this.control = _data["control"] ? Control.fromJS(_data["control"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules.push(AppModule.fromJS(item));
            }
            this.timezoneOffset = _data["timezoneOffset"];
        }
    }

    static fromJS(data: any): UpdateMobileProjectStructureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMobileProjectStructureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layout"] = this.layout;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["control"] = this.control ? this.control.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["timezoneOffset"] = this.timezoneOffset;
        return data; 
    }

    clone(): UpdateMobileProjectStructureCommand {
        const json = this.toJSON();
        let result = new UpdateMobileProjectStructureCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateMobileProjectStructureCommand {
    id: string;
    layout: string | undefined;
    color: ColorScheme;
    control: Control;
    modules: AppModule[] | undefined;
    timezoneOffset: number | undefined;
}

export class AccountRegistrationSettings implements IAccountRegistrationSettings {
    agreementTitle: string | undefined;
    agreementDocumentUrl: string | undefined;
    standardAgreementTitle: string | undefined;
    standardAgreementDocumentUrl: string | undefined;
    readonly configured: boolean;
    readonly standardConfigured: boolean;
    patientProfessionalRelationshipRuleEnabled: boolean;

    constructor(data?: IAccountRegistrationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreementTitle = _data["agreementTitle"];
            this.agreementDocumentUrl = _data["agreementDocumentUrl"];
            this.standardAgreementTitle = _data["standardAgreementTitle"];
            this.standardAgreementDocumentUrl = _data["standardAgreementDocumentUrl"];
            (<any>this).configured = _data["configured"];
            (<any>this).standardConfigured = _data["standardConfigured"];
            this.patientProfessionalRelationshipRuleEnabled = _data["patientProfessionalRelationshipRuleEnabled"];
        }
    }

    static fromJS(data: any): AccountRegistrationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new AccountRegistrationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementTitle"] = this.agreementTitle;
        data["agreementDocumentUrl"] = this.agreementDocumentUrl;
        data["standardAgreementTitle"] = this.standardAgreementTitle;
        data["standardAgreementDocumentUrl"] = this.standardAgreementDocumentUrl;
        data["configured"] = this.configured;
        data["standardConfigured"] = this.standardConfigured;
        data["patientProfessionalRelationshipRuleEnabled"] = this.patientProfessionalRelationshipRuleEnabled;
        return data; 
    }

    clone(): AccountRegistrationSettings {
        const json = this.toJSON();
        let result = new AccountRegistrationSettings();
        result.init(json);
        return result;
    }
}

export interface IAccountRegistrationSettings {
    agreementTitle: string | undefined;
    agreementDocumentUrl: string | undefined;
    standardAgreementTitle: string | undefined;
    standardAgreementDocumentUrl: string | undefined;
    configured: boolean;
    standardConfigured: boolean;
    patientProfessionalRelationshipRuleEnabled: boolean;
}

export class AccountAppModule implements IAccountAppModule {
    registrationSettings: AccountRegistrationSettings;
    allowAccountCreation: boolean;
    itemInnerCard: Control;
    itemOuterCard: Control;
    itemDetailsCard: Control;
    steps: string[] | undefined;
    name: string | undefined;
    layout: string | undefined;
    icon: string | undefined;
    title: string | undefined;
    isStatusBarDark: boolean;
    border: Border;
    shadow: Shadow;
    margin: Padding;
    padding: Padding;
    color: ColorScheme;

    constructor(data?: IAccountAppModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationSettings = _data["registrationSettings"] ? AccountRegistrationSettings.fromJS(_data["registrationSettings"]) : <any>undefined;
            this.allowAccountCreation = _data["allowAccountCreation"];
            this.itemInnerCard = _data["itemInnerCard"] ? Control.fromJS(_data["itemInnerCard"]) : <any>undefined;
            this.itemOuterCard = _data["itemOuterCard"] ? Control.fromJS(_data["itemOuterCard"]) : <any>undefined;
            this.itemDetailsCard = _data["itemDetailsCard"] ? Control.fromJS(_data["itemDetailsCard"]) : <any>undefined;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps.push(item);
            }
            this.name = _data["name"];
            this.layout = _data["layout"];
            this.icon = _data["icon"];
            this.title = _data["title"];
            this.isStatusBarDark = _data["isStatusBarDark"];
            this.border = _data["border"] ? Border.fromJS(_data["border"]) : <any>undefined;
            this.shadow = _data["shadow"] ? Shadow.fromJS(_data["shadow"]) : <any>undefined;
            this.margin = _data["margin"] ? Padding.fromJS(_data["margin"]) : <any>undefined;
            this.padding = _data["padding"] ? Padding.fromJS(_data["padding"]) : <any>undefined;
            this.color = _data["color"] ? ColorScheme.fromJS(_data["color"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountAppModule {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAppModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationSettings"] = this.registrationSettings ? this.registrationSettings.toJSON() : <any>undefined;
        data["allowAccountCreation"] = this.allowAccountCreation;
        data["itemInnerCard"] = this.itemInnerCard ? this.itemInnerCard.toJSON() : <any>undefined;
        data["itemOuterCard"] = this.itemOuterCard ? this.itemOuterCard.toJSON() : <any>undefined;
        data["itemDetailsCard"] = this.itemDetailsCard ? this.itemDetailsCard.toJSON() : <any>undefined;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item);
        }
        data["name"] = this.name;
        data["layout"] = this.layout;
        data["icon"] = this.icon;
        data["title"] = this.title;
        data["isStatusBarDark"] = this.isStatusBarDark;
        data["border"] = this.border ? this.border.toJSON() : <any>undefined;
        data["shadow"] = this.shadow ? this.shadow.toJSON() : <any>undefined;
        data["margin"] = this.margin ? this.margin.toJSON() : <any>undefined;
        data["padding"] = this.padding ? this.padding.toJSON() : <any>undefined;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AccountAppModule {
        const json = this.toJSON();
        let result = new AccountAppModule();
        result.init(json);
        return result;
    }
}

export interface IAccountAppModule {
    registrationSettings: AccountRegistrationSettings;
    allowAccountCreation: boolean;
    itemInnerCard: Control;
    itemOuterCard: Control;
    itemDetailsCard: Control;
    steps: string[] | undefined;
    name: string | undefined;
    layout: string | undefined;
    icon: string | undefined;
    title: string | undefined;
    isStatusBarDark: boolean;
    border: Border;
    shadow: Shadow;
    margin: Padding;
    padding: Padding;
    color: ColorScheme;
}

export class UpdateAccountModuleCommand implements IUpdateAccountModuleCommand {
    tenantId: number;
    registrationSettings: AccountRegistrationSettings;
    allowAccountCreation: boolean;
    steps: string[] | undefined;

    constructor(data?: IUpdateAccountModuleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.registrationSettings = _data["registrationSettings"] ? AccountRegistrationSettings.fromJS(_data["registrationSettings"]) : <any>undefined;
            this.allowAccountCreation = _data["allowAccountCreation"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAccountModuleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountModuleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["registrationSettings"] = this.registrationSettings ? this.registrationSettings.toJSON() : <any>undefined;
        data["allowAccountCreation"] = this.allowAccountCreation;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item);
        }
        return data; 
    }

    clone(): UpdateAccountModuleCommand {
        const json = this.toJSON();
        let result = new UpdateAccountModuleCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateAccountModuleCommand {
    tenantId: number;
    registrationSettings: AccountRegistrationSettings;
    allowAccountCreation: boolean;
    steps: string[] | undefined;
}

export class PwaDefinition implements IPwaDefinition {
    mobileId: string;
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
    brandImage: string | undefined;
    favicon: string | undefined;

    constructor(data?: IPwaDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileId = _data["mobileId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.brandImage = _data["brandImage"];
            this.favicon = _data["favicon"];
        }
    }

    static fromJS(data: any): PwaDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new PwaDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileId"] = this.mobileId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["brandImage"] = this.brandImage;
        data["favicon"] = this.favicon;
        return data; 
    }

    clone(): PwaDefinition {
        const json = this.toJSON();
        let result = new PwaDefinition();
        result.init(json);
        return result;
    }
}

export interface IPwaDefinition {
    mobileId: string;
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
    brandImage: string | undefined;
    favicon: string | undefined;
}

export class MobileProjectStructure implements IMobileProjectStructure {
    id: string;
    layoutType: string | undefined;
    colorTheme: ColorTheme;
    control: Control;
    isStatusBarDark: boolean;
    modules: AppModule[] | undefined;
    logo: string | undefined;
    name: string | undefined;
    owner: number;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;
    timezoneOffset: number | undefined;

    constructor(data?: IMobileProjectStructure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layoutType = _data["layoutType"];
            this.colorTheme = _data["colorTheme"] ? ColorTheme.fromJS(_data["colorTheme"]) : <any>undefined;
            this.control = _data["control"] ? Control.fromJS(_data["control"]) : <any>undefined;
            this.isStatusBarDark = _data["isStatusBarDark"];
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules.push(AppModule.fromJS(item));
            }
            this.logo = _data["logo"];
            this.name = _data["name"];
            this.owner = _data["owner"];
            this.appStoreLink = _data["appStoreLink"];
            this.googlePlayLink = _data["googlePlayLink"];
            this.timezoneOffset = _data["timezoneOffset"];
        }
    }

    static fromJS(data: any): MobileProjectStructure {
        data = typeof data === 'object' ? data : {};
        let result = new MobileProjectStructure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layoutType"] = this.layoutType;
        data["colorTheme"] = this.colorTheme ? this.colorTheme.toJSON() : <any>undefined;
        data["control"] = this.control ? this.control.toJSON() : <any>undefined;
        data["isStatusBarDark"] = this.isStatusBarDark;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["logo"] = this.logo;
        data["name"] = this.name;
        data["owner"] = this.owner;
        data["appStoreLink"] = this.appStoreLink;
        data["googlePlayLink"] = this.googlePlayLink;
        data["timezoneOffset"] = this.timezoneOffset;
        return data; 
    }

    clone(): MobileProjectStructure {
        const json = this.toJSON();
        let result = new MobileProjectStructure();
        result.init(json);
        return result;
    }
}

export interface IMobileProjectStructure {
    id: string;
    layoutType: string | undefined;
    colorTheme: ColorTheme;
    control: Control;
    isStatusBarDark: boolean;
    modules: AppModule[] | undefined;
    logo: string | undefined;
    name: string | undefined;
    owner: number;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;
    timezoneOffset: number | undefined;
}

export class StoreInfo implements IStoreInfo {
    appName: string | undefined;
    whatsNewInThisVersion: string | undefined;
    officialWebsite: string | undefined;
    copyright: string | undefined;
    appType: string | undefined;
    googlePlayAppCategory: string | undefined;
    appIconName: string | undefined;
    ios: boolean;
    android: boolean;
    appSmallDescription: string | undefined;
    appSubtitle: string | undefined;
    supportUrl: string | undefined;
    marketingUrl: string | undefined;
    appCategory: string | undefined;
    appSecondaryCategory: string | undefined;
    appKeywords: string | undefined;
    appDescription: string | undefined;
    defaultLanguage: string | undefined;
    contactEmail: string | undefined;
    phoneNumber: string | undefined;
    cartoonOrFantasyViolence: string | undefined;
    prolongedGraphicOrSadisticRealisticViolence: string | undefined;
    profanityOrCrudeHumor: string | undefined;
    realisticViolence: string | undefined;
    matureSuggestiveThemes: string | undefined;
    horrorFearThemes: string | undefined;
    medicalTreatmentInformation: string | undefined;
    alcoholTobaccoDrugUseReference: string | undefined;
    simulatedGambling: string | undefined;
    sexualContentNudity: string | undefined;
    graphicSexualContentNudity: string | undefined;
    gamblingAndContests: string | undefined;
    unrestrictedWebAccess: string | undefined;
    appPrice: number;
    appSplashImage: string | undefined;
    tabletSplashImage: string | undefined;
    iphoneXSplashImage: string | undefined;
    appIconImage: string | undefined;
    showcaseIphoneImage1: string | undefined;
    showcaseIphoneImage2: string | undefined;
    showcaseIphoneImage3: string | undefined;
    showcaseIphoneImage4: string | undefined;
    showcaseIphoneImage5: string | undefined;
    showcaseAndroidPhoneImage1: string | undefined;
    showcaseAndroidPhoneImage2: string | undefined;
    showcaseAndroidPhoneImage3: string | undefined;
    showcaseAndroidPhoneImage4: string | undefined;
    showcaseAndroidPhoneImage5: string | undefined;
    showcaseAndroidPhoneImage6: string | undefined;
    showcaseAndroidPhoneImage7: string | undefined;
    showcaseAndroidPhoneImage8: string | undefined;
    googlePlayResourcesImage: string | undefined;

    constructor(data?: IStoreInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appName = _data["appName"];
            this.whatsNewInThisVersion = _data["whatsNewInThisVersion"];
            this.officialWebsite = _data["officialWebsite"];
            this.copyright = _data["copyright"];
            this.appType = _data["appType"];
            this.googlePlayAppCategory = _data["googlePlayAppCategory"];
            this.appIconName = _data["appIconName"];
            this.ios = _data["ios"];
            this.android = _data["android"];
            this.appSmallDescription = _data["appSmallDescription"];
            this.appSubtitle = _data["appSubtitle"];
            this.supportUrl = _data["supportUrl"];
            this.marketingUrl = _data["marketingUrl"];
            this.appCategory = _data["appCategory"];
            this.appSecondaryCategory = _data["appSecondaryCategory"];
            this.appKeywords = _data["appKeywords"];
            this.appDescription = _data["appDescription"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.contactEmail = _data["contactEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.cartoonOrFantasyViolence = _data["cartoonOrFantasyViolence"];
            this.prolongedGraphicOrSadisticRealisticViolence = _data["prolongedGraphicOrSadisticRealisticViolence"];
            this.profanityOrCrudeHumor = _data["profanityOrCrudeHumor"];
            this.realisticViolence = _data["realisticViolence"];
            this.matureSuggestiveThemes = _data["matureSuggestiveThemes"];
            this.horrorFearThemes = _data["horrorFearThemes"];
            this.medicalTreatmentInformation = _data["medicalTreatmentInformation"];
            this.alcoholTobaccoDrugUseReference = _data["alcoholTobaccoDrugUseReference"];
            this.simulatedGambling = _data["simulatedGambling"];
            this.sexualContentNudity = _data["sexualContentNudity"];
            this.graphicSexualContentNudity = _data["graphicSexualContentNudity"];
            this.gamblingAndContests = _data["gamblingAndContests"];
            this.unrestrictedWebAccess = _data["unrestrictedWebAccess"];
            this.appPrice = _data["appPrice"];
            this.appSplashImage = _data["appSplashImage"];
            this.tabletSplashImage = _data["tabletSplashImage"];
            this.iphoneXSplashImage = _data["iphoneXSplashImage"];
            this.appIconImage = _data["appIconImage"];
            this.showcaseIphoneImage1 = _data["showcaseIphoneImage1"];
            this.showcaseIphoneImage2 = _data["showcaseIphoneImage2"];
            this.showcaseIphoneImage3 = _data["showcaseIphoneImage3"];
            this.showcaseIphoneImage4 = _data["showcaseIphoneImage4"];
            this.showcaseIphoneImage5 = _data["showcaseIphoneImage5"];
            this.showcaseAndroidPhoneImage1 = _data["showcaseAndroidPhoneImage1"];
            this.showcaseAndroidPhoneImage2 = _data["showcaseAndroidPhoneImage2"];
            this.showcaseAndroidPhoneImage3 = _data["showcaseAndroidPhoneImage3"];
            this.showcaseAndroidPhoneImage4 = _data["showcaseAndroidPhoneImage4"];
            this.showcaseAndroidPhoneImage5 = _data["showcaseAndroidPhoneImage5"];
            this.showcaseAndroidPhoneImage6 = _data["showcaseAndroidPhoneImage6"];
            this.showcaseAndroidPhoneImage7 = _data["showcaseAndroidPhoneImage7"];
            this.showcaseAndroidPhoneImage8 = _data["showcaseAndroidPhoneImage8"];
            this.googlePlayResourcesImage = _data["googlePlayResourcesImage"];
        }
    }

    static fromJS(data: any): StoreInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StoreInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appName"] = this.appName;
        data["whatsNewInThisVersion"] = this.whatsNewInThisVersion;
        data["officialWebsite"] = this.officialWebsite;
        data["copyright"] = this.copyright;
        data["appType"] = this.appType;
        data["googlePlayAppCategory"] = this.googlePlayAppCategory;
        data["appIconName"] = this.appIconName;
        data["ios"] = this.ios;
        data["android"] = this.android;
        data["appSmallDescription"] = this.appSmallDescription;
        data["appSubtitle"] = this.appSubtitle;
        data["supportUrl"] = this.supportUrl;
        data["marketingUrl"] = this.marketingUrl;
        data["appCategory"] = this.appCategory;
        data["appSecondaryCategory"] = this.appSecondaryCategory;
        data["appKeywords"] = this.appKeywords;
        data["appDescription"] = this.appDescription;
        data["defaultLanguage"] = this.defaultLanguage;
        data["contactEmail"] = this.contactEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["cartoonOrFantasyViolence"] = this.cartoonOrFantasyViolence;
        data["prolongedGraphicOrSadisticRealisticViolence"] = this.prolongedGraphicOrSadisticRealisticViolence;
        data["profanityOrCrudeHumor"] = this.profanityOrCrudeHumor;
        data["realisticViolence"] = this.realisticViolence;
        data["matureSuggestiveThemes"] = this.matureSuggestiveThemes;
        data["horrorFearThemes"] = this.horrorFearThemes;
        data["medicalTreatmentInformation"] = this.medicalTreatmentInformation;
        data["alcoholTobaccoDrugUseReference"] = this.alcoholTobaccoDrugUseReference;
        data["simulatedGambling"] = this.simulatedGambling;
        data["sexualContentNudity"] = this.sexualContentNudity;
        data["graphicSexualContentNudity"] = this.graphicSexualContentNudity;
        data["gamblingAndContests"] = this.gamblingAndContests;
        data["unrestrictedWebAccess"] = this.unrestrictedWebAccess;
        data["appPrice"] = this.appPrice;
        data["appSplashImage"] = this.appSplashImage;
        data["tabletSplashImage"] = this.tabletSplashImage;
        data["iphoneXSplashImage"] = this.iphoneXSplashImage;
        data["appIconImage"] = this.appIconImage;
        data["showcaseIphoneImage1"] = this.showcaseIphoneImage1;
        data["showcaseIphoneImage2"] = this.showcaseIphoneImage2;
        data["showcaseIphoneImage3"] = this.showcaseIphoneImage3;
        data["showcaseIphoneImage4"] = this.showcaseIphoneImage4;
        data["showcaseIphoneImage5"] = this.showcaseIphoneImage5;
        data["showcaseAndroidPhoneImage1"] = this.showcaseAndroidPhoneImage1;
        data["showcaseAndroidPhoneImage2"] = this.showcaseAndroidPhoneImage2;
        data["showcaseAndroidPhoneImage3"] = this.showcaseAndroidPhoneImage3;
        data["showcaseAndroidPhoneImage4"] = this.showcaseAndroidPhoneImage4;
        data["showcaseAndroidPhoneImage5"] = this.showcaseAndroidPhoneImage5;
        data["showcaseAndroidPhoneImage6"] = this.showcaseAndroidPhoneImage6;
        data["showcaseAndroidPhoneImage7"] = this.showcaseAndroidPhoneImage7;
        data["showcaseAndroidPhoneImage8"] = this.showcaseAndroidPhoneImage8;
        data["googlePlayResourcesImage"] = this.googlePlayResourcesImage;
        return data; 
    }

    clone(): StoreInfo {
        const json = this.toJSON();
        let result = new StoreInfo();
        result.init(json);
        return result;
    }
}

export interface IStoreInfo {
    appName: string | undefined;
    whatsNewInThisVersion: string | undefined;
    officialWebsite: string | undefined;
    copyright: string | undefined;
    appType: string | undefined;
    googlePlayAppCategory: string | undefined;
    appIconName: string | undefined;
    ios: boolean;
    android: boolean;
    appSmallDescription: string | undefined;
    appSubtitle: string | undefined;
    supportUrl: string | undefined;
    marketingUrl: string | undefined;
    appCategory: string | undefined;
    appSecondaryCategory: string | undefined;
    appKeywords: string | undefined;
    appDescription: string | undefined;
    defaultLanguage: string | undefined;
    contactEmail: string | undefined;
    phoneNumber: string | undefined;
    cartoonOrFantasyViolence: string | undefined;
    prolongedGraphicOrSadisticRealisticViolence: string | undefined;
    profanityOrCrudeHumor: string | undefined;
    realisticViolence: string | undefined;
    matureSuggestiveThemes: string | undefined;
    horrorFearThemes: string | undefined;
    medicalTreatmentInformation: string | undefined;
    alcoholTobaccoDrugUseReference: string | undefined;
    simulatedGambling: string | undefined;
    sexualContentNudity: string | undefined;
    graphicSexualContentNudity: string | undefined;
    gamblingAndContests: string | undefined;
    unrestrictedWebAccess: string | undefined;
    appPrice: number;
    appSplashImage: string | undefined;
    tabletSplashImage: string | undefined;
    iphoneXSplashImage: string | undefined;
    appIconImage: string | undefined;
    showcaseIphoneImage1: string | undefined;
    showcaseIphoneImage2: string | undefined;
    showcaseIphoneImage3: string | undefined;
    showcaseIphoneImage4: string | undefined;
    showcaseIphoneImage5: string | undefined;
    showcaseAndroidPhoneImage1: string | undefined;
    showcaseAndroidPhoneImage2: string | undefined;
    showcaseAndroidPhoneImage3: string | undefined;
    showcaseAndroidPhoneImage4: string | undefined;
    showcaseAndroidPhoneImage5: string | undefined;
    showcaseAndroidPhoneImage6: string | undefined;
    showcaseAndroidPhoneImage7: string | undefined;
    showcaseAndroidPhoneImage8: string | undefined;
    googlePlayResourcesImage: string | undefined;
}

export class HomeScreenMenuItemTranslationDto implements IHomeScreenMenuItemTranslationDto {
    title: string | undefined;
    subtitle: string | undefined;
    html: string | undefined;
    language: string | undefined;

    constructor(data?: IHomeScreenMenuItemTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.html = _data["html"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): HomeScreenMenuItemTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeScreenMenuItemTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["html"] = this.html;
        data["language"] = this.language;
        return data; 
    }

    clone(): HomeScreenMenuItemTranslationDto {
        const json = this.toJSON();
        let result = new HomeScreenMenuItemTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IHomeScreenMenuItemTranslationDto {
    title: string | undefined;
    subtitle: string | undefined;
    html: string | undefined;
    language: string | undefined;
}

export class HomeScreenMenuItemDto implements IHomeScreenMenuItemDto {
    id: string | undefined;
    icon: string | undefined;
    translations: HomeScreenMenuItemTranslationDto[] | undefined;

    constructor(data?: IHomeScreenMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations.push(HomeScreenMenuItemTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HomeScreenMenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeScreenMenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["icon"] = this.icon;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): HomeScreenMenuItemDto {
        const json = this.toJSON();
        let result = new HomeScreenMenuItemDto();
        result.init(json);
        return result;
    }
}

export interface IHomeScreenMenuItemDto {
    id: string | undefined;
    icon: string | undefined;
    translations: HomeScreenMenuItemTranslationDto[] | undefined;
}

export class HomeScreenTranslationDto implements IHomeScreenTranslationDto {
    title: string | undefined;
    subtitle: string | undefined;
    language: string | undefined;
    id: number;

    constructor(data?: IHomeScreenTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.language = _data["language"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HomeScreenTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeScreenTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["language"] = this.language;
        data["id"] = this.id;
        return data; 
    }

    clone(): HomeScreenTranslationDto {
        const json = this.toJSON();
        let result = new HomeScreenTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IHomeScreenTranslationDto {
    title: string | undefined;
    subtitle: string | undefined;
    language: string | undefined;
    id: number;
}

export class HomeScreenDto implements IHomeScreenDto {
    mobileProject: MobileProjectDto;
    headerImage: string | undefined;
    items: HomeScreenMenuItemDto[] | undefined;
    translations: HomeScreenTranslationDto[] | undefined;
    id: string;

    constructor(data?: IHomeScreenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileProject = _data["mobileProject"] ? MobileProjectDto.fromJS(_data["mobileProject"]) : <any>undefined;
            this.headerImage = _data["headerImage"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HomeScreenMenuItemDto.fromJS(item));
            }
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations.push(HomeScreenTranslationDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HomeScreenDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeScreenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileProject"] = this.mobileProject ? this.mobileProject.toJSON() : <any>undefined;
        data["headerImage"] = this.headerImage;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): HomeScreenDto {
        const json = this.toJSON();
        let result = new HomeScreenDto();
        result.init(json);
        return result;
    }
}

export interface IHomeScreenDto {
    mobileProject: MobileProjectDto;
    headerImage: string | undefined;
    items: HomeScreenMenuItemDto[] | undefined;
    translations: HomeScreenTranslationDto[] | undefined;
    id: string;
}

export class SelectItem implements ISelectItem {
    value: string | undefined;
    text: string | undefined;

    constructor(data?: ISelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        return data; 
    }

    clone(): SelectItem {
        const json = this.toJSON();
        let result = new SelectItem();
        result.init(json);
        return result;
    }
}

export interface ISelectItem {
    value: string | undefined;
    text: string | undefined;
}

export class AppleStoreRatingItem implements IAppleStoreRatingItem {
    value: string | undefined;
    text: string | undefined;
    name: string | undefined;

    constructor(data?: IAppleStoreRatingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppleStoreRatingItem {
        data = typeof data === 'object' ? data : {};
        let result = new AppleStoreRatingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        data["name"] = this.name;
        return data; 
    }

    clone(): AppleStoreRatingItem {
        const json = this.toJSON();
        let result = new AppleStoreRatingItem();
        result.init(json);
        return result;
    }
}

export interface IAppleStoreRatingItem {
    value: string | undefined;
    text: string | undefined;
    name: string | undefined;
}

export class StoreInfoNomenclators implements IStoreInfoNomenclators {
    readonly languages: SelectItem[] | undefined;
    readonly businessTypes: SelectItem[] | undefined;
    readonly industryTypes: SelectItem[] | undefined;
    readonly appCategories: SelectItem[] | undefined;
    readonly appleStoreRatingItems: AppleStoreRatingItem[] | undefined;
    readonly otherStoreOptionItems: AppleStoreRatingItem[] | undefined;
    readonly appTypes: SelectItem[] | undefined;
    readonly googlePlayAppCategories: SelectItem[] | undefined;

    constructor(data?: IStoreInfoNomenclators) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["languages"])) {
                (<any>this).languages = [] as any;
                for (let item of _data["languages"])
                    (<any>this).languages.push(SelectItem.fromJS(item));
            }
            if (Array.isArray(_data["businessTypes"])) {
                (<any>this).businessTypes = [] as any;
                for (let item of _data["businessTypes"])
                    (<any>this).businessTypes.push(SelectItem.fromJS(item));
            }
            if (Array.isArray(_data["industryTypes"])) {
                (<any>this).industryTypes = [] as any;
                for (let item of _data["industryTypes"])
                    (<any>this).industryTypes.push(SelectItem.fromJS(item));
            }
            if (Array.isArray(_data["appCategories"])) {
                (<any>this).appCategories = [] as any;
                for (let item of _data["appCategories"])
                    (<any>this).appCategories.push(SelectItem.fromJS(item));
            }
            if (Array.isArray(_data["appleStoreRatingItems"])) {
                (<any>this).appleStoreRatingItems = [] as any;
                for (let item of _data["appleStoreRatingItems"])
                    (<any>this).appleStoreRatingItems.push(AppleStoreRatingItem.fromJS(item));
            }
            if (Array.isArray(_data["otherStoreOptionItems"])) {
                (<any>this).otherStoreOptionItems = [] as any;
                for (let item of _data["otherStoreOptionItems"])
                    (<any>this).otherStoreOptionItems.push(AppleStoreRatingItem.fromJS(item));
            }
            if (Array.isArray(_data["appTypes"])) {
                (<any>this).appTypes = [] as any;
                for (let item of _data["appTypes"])
                    (<any>this).appTypes.push(SelectItem.fromJS(item));
            }
            if (Array.isArray(_data["googlePlayAppCategories"])) {
                (<any>this).googlePlayAppCategories = [] as any;
                for (let item of _data["googlePlayAppCategories"])
                    (<any>this).googlePlayAppCategories.push(SelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreInfoNomenclators {
        data = typeof data === 'object' ? data : {};
        let result = new StoreInfoNomenclators();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        if (Array.isArray(this.businessTypes)) {
            data["businessTypes"] = [];
            for (let item of this.businessTypes)
                data["businessTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.industryTypes)) {
            data["industryTypes"] = [];
            for (let item of this.industryTypes)
                data["industryTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.appCategories)) {
            data["appCategories"] = [];
            for (let item of this.appCategories)
                data["appCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.appleStoreRatingItems)) {
            data["appleStoreRatingItems"] = [];
            for (let item of this.appleStoreRatingItems)
                data["appleStoreRatingItems"].push(item.toJSON());
        }
        if (Array.isArray(this.otherStoreOptionItems)) {
            data["otherStoreOptionItems"] = [];
            for (let item of this.otherStoreOptionItems)
                data["otherStoreOptionItems"].push(item.toJSON());
        }
        if (Array.isArray(this.appTypes)) {
            data["appTypes"] = [];
            for (let item of this.appTypes)
                data["appTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.googlePlayAppCategories)) {
            data["googlePlayAppCategories"] = [];
            for (let item of this.googlePlayAppCategories)
                data["googlePlayAppCategories"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StoreInfoNomenclators {
        const json = this.toJSON();
        let result = new StoreInfoNomenclators();
        result.init(json);
        return result;
    }
}

export interface IStoreInfoNomenclators {
    languages: SelectItem[] | undefined;
    businessTypes: SelectItem[] | undefined;
    industryTypes: SelectItem[] | undefined;
    appCategories: SelectItem[] | undefined;
    appleStoreRatingItems: AppleStoreRatingItem[] | undefined;
    otherStoreOptionItems: AppleStoreRatingItem[] | undefined;
    appTypes: SelectItem[] | undefined;
    googlePlayAppCategories: SelectItem[] | undefined;
}

export class WizardDto implements IWizardDto {
    id: string | undefined;
    name: string | undefined;
    brandImage: string | undefined;
    iconImage: string | undefined;
    definition: MobileProjectStructure;
    contact: Contact;
    storeInfo: StoreInfo;
    homeScreen: HomeScreenDto;
    storeInfoNomenclators: StoreInfoNomenclators;
    completed: boolean;
    testToken: string | undefined;
    pwaLink: string | undefined;

    constructor(data?: IWizardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.brandImage = _data["brandImage"];
            this.iconImage = _data["iconImage"];
            this.definition = _data["definition"] ? MobileProjectStructure.fromJS(_data["definition"]) : <any>undefined;
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.storeInfo = _data["storeInfo"] ? StoreInfo.fromJS(_data["storeInfo"]) : <any>undefined;
            this.homeScreen = _data["homeScreen"] ? HomeScreenDto.fromJS(_data["homeScreen"]) : <any>undefined;
            this.storeInfoNomenclators = _data["storeInfoNomenclators"] ? StoreInfoNomenclators.fromJS(_data["storeInfoNomenclators"]) : <any>undefined;
            this.completed = _data["completed"];
            this.testToken = _data["testToken"];
            this.pwaLink = _data["pwaLink"];
        }
    }

    static fromJS(data: any): WizardDto {
        data = typeof data === 'object' ? data : {};
        let result = new WizardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["brandImage"] = this.brandImage;
        data["iconImage"] = this.iconImage;
        data["definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["storeInfo"] = this.storeInfo ? this.storeInfo.toJSON() : <any>undefined;
        data["homeScreen"] = this.homeScreen ? this.homeScreen.toJSON() : <any>undefined;
        data["storeInfoNomenclators"] = this.storeInfoNomenclators ? this.storeInfoNomenclators.toJSON() : <any>undefined;
        data["completed"] = this.completed;
        data["testToken"] = this.testToken;
        data["pwaLink"] = this.pwaLink;
        return data; 
    }

    clone(): WizardDto {
        const json = this.toJSON();
        let result = new WizardDto();
        result.init(json);
        return result;
    }
}

export interface IWizardDto {
    id: string | undefined;
    name: string | undefined;
    brandImage: string | undefined;
    iconImage: string | undefined;
    definition: MobileProjectStructure;
    contact: Contact;
    storeInfo: StoreInfo;
    homeScreen: HomeScreenDto;
    storeInfoNomenclators: StoreInfoNomenclators;
    completed: boolean;
    testToken: string | undefined;
    pwaLink: string | undefined;
}

export class CacheMobileAppInfo implements ICacheMobileAppInfo {
    id: string;
    tenantId: number;
    name: string | undefined;
    brandImage: string | undefined;
    iconImage: string | undefined;
    definition: string | undefined;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;

    constructor(data?: ICacheMobileAppInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.brandImage = _data["brandImage"];
            this.iconImage = _data["iconImage"];
            this.definition = _data["definition"];
            this.appStoreLink = _data["appStoreLink"];
            this.googlePlayLink = _data["googlePlayLink"];
        }
    }

    static fromJS(data: any): CacheMobileAppInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CacheMobileAppInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["brandImage"] = this.brandImage;
        data["iconImage"] = this.iconImage;
        data["definition"] = this.definition;
        data["appStoreLink"] = this.appStoreLink;
        data["googlePlayLink"] = this.googlePlayLink;
        return data; 
    }

    clone(): CacheMobileAppInfo {
        const json = this.toJSON();
        let result = new CacheMobileAppInfo();
        result.init(json);
        return result;
    }
}

export interface ICacheMobileAppInfo {
    id: string;
    tenantId: number;
    name: string | undefined;
    brandImage: string | undefined;
    iconImage: string | undefined;
    definition: string | undefined;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;
}

export class UpdateStoreLinkCommand implements IUpdateStoreLinkCommand {
    tenantId: number;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;

    constructor(data?: IUpdateStoreLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.appStoreLink = _data["appStoreLink"];
            this.googlePlayLink = _data["googlePlayLink"];
        }
    }

    static fromJS(data: any): UpdateStoreLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStoreLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["appStoreLink"] = this.appStoreLink;
        data["googlePlayLink"] = this.googlePlayLink;
        return data; 
    }

    clone(): UpdateStoreLinkCommand {
        const json = this.toJSON();
        let result = new UpdateStoreLinkCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateStoreLinkCommand {
    tenantId: number;
    appStoreLink: string | undefined;
    googlePlayLink: string | undefined;
}

export class GenerateQrCodeLinkCommand implements IGenerateQrCodeLinkCommand {
    tenantId: number;

    constructor(data?: IGenerateQrCodeLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): GenerateQrCodeLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateQrCodeLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): GenerateQrCodeLinkCommand {
        const json = this.toJSON();
        let result = new GenerateQrCodeLinkCommand();
        result.init(json);
        return result;
    }
}

export interface IGenerateQrCodeLinkCommand {
    tenantId: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}